import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: string; output: string; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
  /** Represents untyped JSON */
  JSON: { input: object; output: object; }
};

export type AccreteMessage = {
  __typename?: 'AccreteMessage';
  accreteMessageResults: Array<AccreteMessageResult>;
  /** SMS本文 */
  content: Scalars['String']['output'];
  /** メッセージ作成時間 */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** SMS本文に埋め込むリンク */
  link: Scalars['String']['output'];
  /** 結果メッセージ */
  message?: Maybe<Scalars['String']['output']>;
  /** SMS配信先の携帯電話番号 */
  phoneNumber: Scalars['String']['output'];
  /** 送信者 */
  practitioner?: Maybe<Practitioner>;
  /** SMS送信受付時間 */
  registerTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 結果コード */
  resultCode?: Maybe<Scalars['String']['output']>;
  /** 利用者リファレンス */
  userRef: Scalars['String']['output'];
};

export type AccreteMessagePage = {
  __typename?: 'AccreteMessagePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<AccreteMessage>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type AccreteMessageResult = {
  __typename?: 'AccreteMessageResult';
  id: Scalars['ID']['output'];
  /** 結果メッセージ */
  message?: Maybe<Scalars['String']['output']>;
  /** 配信先携帯電話事業者 */
  operator?: Maybe<Scalars['String']['output']>;
  /** 配信結果ステータス */
  result?: Maybe<Scalars['String']['output']>;
  /** 携帯電話事業者に配信した通数 */
  totalmsgnum?: Maybe<Scalars['String']['output']>;
  /** 利用者リファレンス */
  userRef?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ActivateAnnouncement */
export type ActivateAnnouncementInput = {
  announcementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateAnnouncementPayload = {
  __typename?: 'ActivateAnnouncementPayload';
  announcement: Announcement;
};

/** Autogenerated input type of ActivateOtpSecret */
export type ActivateOtpSecretInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  onetimeCode: Scalars['String']['input'];
  practitionerOtpSecretId: Scalars['ID']['input'];
};

export type ActivateOtpSecretPayload = {
  __typename?: 'ActivateOtpSecretPayload';
  practitionerOtpSecret: PractitionerOtpSecret;
};

/** Autogenerated input type of AddCompanyAddress */
export type AddCompanyAddressInput = {
  city: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  line: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
};

export type AddCompanyAddressPayload = {
  __typename?: 'AddCompanyAddressPayload';
  companyAddress: CompanyAddress;
};

/** Autogenerated input type of AddCompanyContactPoint */
export type AddCompanyContactPointInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  system: ContactPointSystem;
  value: Scalars['String']['input'];
};

export type AddCompanyContactPointPayload = {
  __typename?: 'AddCompanyContactPointPayload';
  companyContactPoint: CompanyContactPoint;
};

/** Autogenerated input type of AddCompanyPractitioner */
export type AddCompanyPractitionerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyPractitionerEmail: Scalars['String']['input'];
  companyPractitionerTel: Scalars['String']['input'];
  practitionerId: Scalars['ID']['input'];
};

export type AddCompanyPractitionerPayload = {
  __typename?: 'AddCompanyPractitionerPayload';
  /** 窓口担当としての認証 */
  companyPractitionerConfirmation: CompanyPractitionerConfirmation;
  practitioner: Practitioner;
};

/** Autogenerated input type of AddContractPlan */
export type AddContractPlanInput = {
  agreementExtensionCodes?: InputMaybe<Array<ExtensionCode>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  end?: InputMaybe<Scalars['ISO8601Date']['input']>;
  planId: Scalars['ID']['input'];
  start: Scalars['ISO8601Date']['input'];
};

export type AddContractPlanPayload = {
  __typename?: 'AddContractPlanPayload';
  contractPlan: ContractPlan;
};

/** Autogenerated input type of AddIncentiveTargetCompany */
export type AddIncentiveTargetCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

export type AddIncentiveTargetCompanyPayload = {
  __typename?: 'AddIncentiveTargetCompanyPayload';
  company: Company;
};

/** Autogenerated input type of AddInvitationCode */
export type AddInvitationCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type AddInvitationCodePayload = {
  __typename?: 'AddInvitationCodePayload';
  invitationCode: InvitationCode;
};

/** Autogenerated input type of AddOrganizationAddress */
export type AddOrganizationAddressInput = {
  city: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  line: Scalars['String']['input'];
  longitude: Scalars['Float']['input'];
  organizationId: Scalars['ID']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
};

export type AddOrganizationAddressPayload = {
  __typename?: 'AddOrganizationAddressPayload';
  organizationAddress: OrganizationAddress;
};

/** Autogenerated input type of AddOrganizationContactPoint */
export type AddOrganizationContactPointInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  system: ContactPointSystem;
  value: Scalars['String']['input'];
};

export type AddOrganizationContactPointPayload = {
  __typename?: 'AddOrganizationContactPointPayload';
  organizationContactPoint: OrganizationContactPoint;
};

/** Autogenerated input type of AddPatientAttachment */
export type AddPatientAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['String']['input'];
  name: Scalars['String']['input'];
  patientId: Scalars['ID']['input'];
};

export type AddPatientAttachmentPayload = {
  __typename?: 'AddPatientAttachmentPayload';
  patientAttachment: PatientAttachment;
};

/** Autogenerated input type of AddUberSignatureDraftExtraText */
export type AddUberSignatureDraftExtraTextInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  extraText: Scalars['String']['input'];
};

export type AddUberSignatureDraftExtraTextPayload = {
  __typename?: 'AddUberSignatureDraftExtraTextPayload';
  uberSignatureDraft: UberSignatureDraft;
};

export type Address = Node & {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  line: Scalars['String']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  postalCode: Scalars['String']['output'];
  prefecture: Scalars['String']['output'];
  type: AddressType;
  use: AddressUse;
};

/** 住所の種別を表す。See https://www.hl7.org/fhir/valueset-address-type.html */
export const AddressType = {
  /** 物理的な郵送先住所？？ An address that is both physical and postal. */
  Both: 'both',
  /** アクセス可能な物理的住所？？ A physical address that can be visited. */
  Physical: 'physical',
  /** 郵送先住所 */
  Postal: 'postal'
} as const;

export type AddressType = typeof AddressType[keyof typeof AddressType];
/** 住所の用途を表す。See https://www.hl7.org/fhir/valueset-address-use.html */
export const AddressUse = {
  /** 自宅 */
  Home: 'home',
  /** 利用されていない住所 */
  Old: 'old',
  /** 一時的な住所 */
  Temp: 'temp',
  /** オフィス */
  Work: 'work'
} as const;

export type AddressUse = typeof AddressUse[keyof typeof AddressUse];
export type Agent = Node & {
  __typename?: 'Agent';
  /** エージェントの実行に必要なファイル一式 */
  artifact?: Maybe<Blob>;
  /** 接続状態を返す（AWS IoT Device Shadow にアクセスして状態を取得するため一覧では呼び出さないこと） */
  connected: Scalars['Boolean']['output'];
  /** 店舗用メモ */
  description: Scalars['String']['output'];
  /** エージェントの環境構築が完了しているか */
  hasSetUp: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** 各機能の設定 */
  setting: AgentSetting;
};

/** GOARCHを表す */
export const AgentReleaseFileArch = {
  Amd64: 'amd64',
  I386: 'i386'
} as const;

export type AgentReleaseFileArch = typeof AgentReleaseFileArch[keyof typeof AgentReleaseFileArch];
export type AgentSetting = {
  __typename?: 'AgentSetting';
  id: Scalars['ID']['output'];
  printPrescription: PrintPrescriptionSetting;
};

export type AgreementExtension = Node & {
  __typename?: 'AgreementExtension';
  /** 同意スタッフ */
  activatePractitioner: Practitioner;
  active: Scalars['Boolean']['output'];
  /** 同意解除スタッフ */
  deactivatePractitioner?: Maybe<Practitioner>;
  /** 同意解除日時 */
  endAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  extension: Extension;
  id: Scalars['ID']['output'];
  /** 同意日時 */
  startAt: Scalars['ISO8601DateTime']['output'];
  /** Uberの署名 */
  uberSignatures?: Maybe<Array<UberSignature>>;
};

export type AgreementExtensionPage = {
  __typename?: 'AgreementExtensionPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<AgreementExtension>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type AllPatient = CheckinEntry | DirectVisitor | Patient | WebVisitor;

export type AllPatientOrder = {
  direction: OrderDirection;
  field: AllPatientOrderField;
};

/** 患者のソートで指定できるフィールド */
export const AllPatientOrderField = {
  /** メッセージ最終作成日時 */
  LatestMessageCreatedAt: 'latest_message_created_at'
} as const;

export type AllPatientOrderField = typeof AllPatientOrderField[keyof typeof AllPatientOrderField];
export type AllPatientPage = {
  __typename?: 'AllPatientPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<AllPatient>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type AllowList = Node & {
  __typename?: 'AllowList';
  id: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
};

/** Autogenerated input type of AllowOperatorAccessPermission */
export type AllowOperatorAccessPermissionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expiresAt: Scalars['ISO8601DateTime']['input'];
};

export type AllowOperatorAccessPermissionPayload = {
  __typename?: 'AllowOperatorAccessPermissionPayload';
  operatorAccessPermission: OperatorAccessPermission;
};

/** 薬局向けのお知らせ */
export type Announcement = Node & {
  __typename?: 'Announcement';
  active: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  emergency: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  subject: Scalars['String']['output'];
  type: AnnouncementType;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Announcement. */
export type AnnouncementConnection = {
  __typename?: 'AnnouncementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AnnouncementEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Announcement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AnnouncementEdge = {
  __typename?: 'AnnouncementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Announcement>;
};

export type AnnouncementPage = {
  __typename?: 'AnnouncementPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<Announcement>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

/** 薬局向けのお知らせ種別 */
export const AnnouncementType = {
  /** 重要 */
  Important: 'important',
  /** お知らせ */
  Information: 'information'
} as const;

export type AnnouncementType = typeof AnnouncementType[keyof typeof AnnouncementType];
/** Autogenerated input type of AppendIdToFeatureTargetGroup */
export type AppendIdToFeatureTargetGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureTargetGroupId: Scalars['ID']['input'];
  featureTargetIds: Array<Scalars['ID']['input']>;
};

export type AppendIdToFeatureTargetGroupPayload = {
  __typename?: 'AppendIdToFeatureTargetGroupPayload';
  featureTargetGroup: FeatureTargetGroup;
};

/** Autogenerated input type of AppendToFeatureTargetGroup */
export type AppendToFeatureTargetGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureTargetGroupId: Scalars['ID']['input'];
  featureTargetIds: Array<Scalars['ID']['input']>;
};

export type AppendToFeatureTargetGroupPayload = {
  __typename?: 'AppendToFeatureTargetGroupPayload';
  featureTargetGroup: FeatureTargetGroup;
};

export type Appointment = Node & {
  __typename?: 'Appointment';
  /** アプリ決済可能か */
  appPayment: Scalars['Boolean']['output'];
  /** 指導待ちステータスになった日時 */
  bookedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cancellationReason?: Maybe<AppointmentCancellationReason>;
  /** 支払い */
  charge?: Maybe<Charge>;
  congestionNotificationSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** 配達方法 */
  deliveryMethod: AppointmentDeliveryMethod;
  /** 店舗用予約メモ */
  description: Scalars['String']['output'];
  /** 仮予約 */
  draftAppointment?: Maybe<DraftAppointment>;
  /** 診察 */
  encounter?: Maybe<Encounter>;
  /** 希望の終了時間 */
  end?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 完了ステータスになった日時 */
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** お薬手帳開示許可 */
  hiccupAppointmentPermission?: Maybe<HiccupAppointmentPermission>;
  id: Scalars['ID']['output'];
  /** true=即時予約 */
  immediate: Scalars['Boolean']['output'];
  /** MEDIXS側受付情報 */
  medixsReception?: Maybe<MedixsReception>;
  organization: Organization;
  patient?: Maybe<Patient>;
  /** 店舗から患者への連絡メモ */
  patientInstruction: Scalars['String']['output'];
  /** 未受付から指導待ちにするときのAcceptDispensingRequestに失敗したらtrueになる */
  pfDispensingRequestAcceptFailed: Scalars['Boolean']['output'];
  /** 送信された処方箋個数 */
  pfDispensingRequestCount: Scalars['Int']['output'];
  pfDispensingRequestUploadType?: Maybe<AppointmentPfDispensingRequestUploadType>;
  /** 処方箋 */
  pfDispensingRequests: Array<Maybe<PfDispensingRequest>>;
  /** 非会員導線経由の処方箋 */
  prescriptions?: Maybe<Array<Blob>>;
  /** 資格確認方法 */
  qualificationConfirmationMethod: AppointmentQualificationConfirmationMethod;
  /** 問診 */
  questionnaires: Array<QuestionnaireSheetAnswer>;
  /** 患者と薬局の距離による当日配達見積もり */
  quote: Quote;
  /** 当日配達利用料が必要か */
  requiredUberDeliveryFee?: Maybe<Scalars['Boolean']['output']>;
  /** 希望の開始時間 */
  start?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: AppointmentStatus;
  /** true=遠隔服薬指導 */
  telemedicine: Scalars['Boolean']['output'];
  /** 当日配達 */
  uberDelivery?: Maybe<UberDelivery>;
  /** 当日配達見積もり */
  uberQuote?: Maybe<UberQuote>;
  /** 未読通知 */
  unreadOrganizationNotifications: Array<OrganizationNotification>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** 未会計ステータスになった日時 */
  waitingForChargeAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  webVisitor?: Maybe<WebVisitor>;
};

/** http://hl7.org/fhir/valueset-appointment-cancellation-reason.html */
export const AppointmentCancellationReason = {
  /** Other: Error */
  OthErr: 'oth_err',
  /** Other */
  Other: 'other',
  /** Patient */
  Pat: 'pat',
  /** Patient: Canceled via Patient Portal */
  PatCpp: 'pat_cpp',
  /** Provider */
  Prov: 'prov'
} as const;

export type AppointmentCancellationReason = typeof AppointmentCancellationReason[keyof typeof AppointmentCancellationReason];
/** The connection type for Appointment. */
export type AppointmentConnection = {
  __typename?: 'AppointmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AppointmentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Appointment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** 薬の配達方法 */
export const AppointmentDeliveryMethod = {
  /** B2クラウド_着払い */
  B2cloudCashOnDelivery: 'b2cloud_cash_on_delivery',
  /** B2クラウド_コレクト */
  B2cloudCollect: 'b2cloud_collect',
  /** B2クラウド_宅急便コンパクト */
  B2cloudCompact: 'b2cloud_compact',
  /** B2クラウド_宅急便コンパクトコレクト */
  B2cloudCompactCollect: 'b2cloud_compact_collect',
  /** B2クラウド_ＤＭ便 */
  B2cloudDm: 'b2cloud_dm',
  /** B2クラウド_ネコポス */
  B2cloudNekopos: 'b2cloud_nekopos',
  /** B2クラウド_発払い */
  B2cloudPrepayment: 'b2cloud_prepayment',
  /** B2クラウド_タイム */
  B2cloudTime: 'b2cloud_time',
  /** 薬局にてお渡し */
  Hand: 'hand',
  /** その他 */
  Other: 'other',
  /** その他宅配便 */
  Parcel: 'parcel',
  /** 当日受取配達 */
  SameDayDelivery: 'same_day_delivery'
} as const;

export type AppointmentDeliveryMethod = typeof AppointmentDeliveryMethod[keyof typeof AppointmentDeliveryMethod];
/** An edge in a connection. */
export type AppointmentEdge = {
  __typename?: 'AppointmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Appointment>;
};

export type AppointmentOrder = {
  direction: OrderDirection;
  field: AppointmentOrderField;
};

/** 予約のソートで指定できるフィールド */
export const AppointmentOrderField = {
  /** 予約作成日時 */
  CreatedAt: 'created_at',
  /** 希望の開始時間 */
  Start: 'start'
} as const;

export type AppointmentOrderField = typeof AppointmentOrderField[keyof typeof AppointmentOrderField];
export type AppointmentPage = {
  __typename?: 'AppointmentPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<Appointment>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export const AppointmentPfDispensingRequestUploadType = {
  /** CLINICSアプリからの処方箋アップロード */
  App: 'app',
  /** 医療機関からの処方箋アップロード */
  MedicalInstitution: 'medical_institution'
} as const;

export type AppointmentPfDispensingRequestUploadType = typeof AppointmentPfDispensingRequestUploadType[keyof typeof AppointmentPfDispensingRequestUploadType];
export const AppointmentQualificationConfirmationMethod = {
  /** マイナンバーカード */
  IndividualNumberCard: 'individual_number_card',
  /** 紙の保険証 */
  InsuranceCard: 'insurance_card'
} as const;

export type AppointmentQualificationConfirmationMethod = typeof AppointmentQualificationConfirmationMethod[keyof typeof AppointmentQualificationConfirmationMethod];
/**
 * @startuml
 * title 処方箋ネット受付予約(telemedicineがfalse)のステータス遷移
 * pending : 未受付
 * pending : ConfirmBookingDispensingRequest実行済み
 * booked : 指導待ち
 * booked : AcceptDispensingRequest実行済み
 * waiting_for_charge : 未会計
 * cancelled : キャンセル
 * cancelled : CancelBookingDispensingRequest実行済み
 * finished : 完了
 * finished : FulfillDispensingRequest実行済み
 *
 * [*] --> pending : アプリから予約
 * pending --> booked : 受付画面で受付ボタンを押した
 * pending --> cancelled : 受付画面でキャンセルボタンを押した
 * pending --> pending : AcceptDispensingRequestに失敗した
 * booked --> cancelled : 受付画面でキャンセルボタンを押した
 * booked --> waiting_for_charge : 受付画面で準備完了の連絡ボタン
 *  または、会計ボタンを押した
 * waiting_for_charge --> finished : 受付画面で会計ボタンを押した
 * finished --> [*]
 * @enduml
 *
 * @startuml
 * title オンライン服薬指導予約(telemedicineがtrue)のステータス遷移
 * pending : 未受付
 * pending : ConfirmBookingDispensingRequest実行済み
 * booked : 指導待ち
 * booked : AcceptDispensingRequest実行済み
 * waiting_for_charge : 未会計
 * charged : 会計済(配送待ち)
 * charged : FulfillDispensingRequest実行済み
 * cancelled : キャンセル
 * cancelled : CancelBookingDispensingRequest実行済み
 * finished : 完了
 *
 * [*] --> pending : アプリから予約
 * pending --> booked : 受付画面で受付ボタンを押した
 * pending --> cancelled : 受付画面でキャンセルボタンを押した
 * pending --> pending : AcceptDispensingRequestに失敗した
 * booked --> waiting_for_charge : オンライン服薬指導画面で終了ボタンを押した
 * booked --> cancelled : 受付画面でキャンセルボタンを押した
 * waiting_for_charge --> charged : 受付画面で会計ボタンを押した
 * charged --> finished : 受付画面で完了ボタンを押した
 * finished --> [*]
 * @enduml
 */
export const AppointmentStatus = {
  /** 指導待ち */
  Booked: 'booked',
  /** キャンセル */
  Cancelled: 'cancelled',
  /** 会計済(配送待ち) */
  Charged: 'charged',
  /** 完了 */
  Finished: 'finished',
  /** キャンセル(患者が来なかった) */
  Noshow: 'noshow',
  /** 未受付 */
  Pending: 'pending',
  /** 未会計 */
  WaitingForCharge: 'waiting_for_charge'
} as const;

export type AppointmentStatus = typeof AppointmentStatus[keyof typeof AppointmentStatus];
/** Autogenerated input type of ApproveUberSignature */
export type ApproveUberSignatureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  uberSignatureId: Scalars['ID']['input'];
};

export type ApproveUberSignaturePayload = {
  __typename?: 'ApproveUberSignaturePayload';
  uberSignature: UberSignature;
};

export type AuthToken = {
  __typename?: 'AuthToken';
  token: Scalars['String']['output'];
};

/** https://bmypage.kuronekoyamato.co.jp/bmypage/pdf/new_exchange1.pdf */
export const B2cloudInvoiceType = {
  /** 着払い */
  CashOnDelivery: 'cash_on_delivery',
  /** コレクト */
  Collect: 'collect',
  /** 宅急便コンパクト */
  Compact: 'compact',
  /** 宅急便コンパクトコレクト */
  CompactCollect: 'compact_collect',
  /** ＤＭ便 */
  Dm: 'dm',
  /** ネコポス */
  Nekopos: 'nekopos',
  /** 発払い */
  Prepayment: 'prepayment',
  /** タイム */
  Time: 'time'
} as const;

export type B2cloudInvoiceType = typeof B2cloudInvoiceType[keyof typeof B2cloudInvoiceType];
export type B2cloudSetting = Node & {
  __typename?: 'B2cloudSetting';
  data: B2cloudSettingData;
  id: Scalars['ID']['output'];
  organization: Organization;
};

export type B2cloudSettingData = {
  __typename?: 'B2cloudSettingData';
  /** 請求先顧客コード(半角数字12文字) */
  customerCode: Scalars['String']['output'];
  /** 会計時にデフォルトで表示する送り状種別 */
  defaultInvoiceType: B2cloudInvoiceType;
  enable: Scalars['Boolean']['output'];
  /** 品名１(全角/半角 25文字/50文字) */
  goodsName1: Scalars['String']['output'];
  /** ご依頼主 */
  sender: B2cloudSettingSenderData;
  /** 運賃管理番号(半角数字2文字) */
  shippingFeeCode: Scalars['String']['output'];
};

export type B2cloudSettingSenderData = {
  __typename?: 'B2cloudSettingSenderData';
  /** ご依頼主都道府県、ご依頼主市区郡町村とご依頼主町・番地を結合した文字列 */
  address: Scalars['String']['output'];
  /** ご依頼主アパートマンション(全角/半角 16文字/32文字) */
  building?: Maybe<Scalars['String']['output']>;
  /** ご依頼主市区郡町村(12文字) */
  city?: Maybe<Scalars['String']['output']>;
  /** ご依頼主町・番地(16文字) */
  line?: Maybe<Scalars['String']['output']>;
  /** ご依頼主名前(全角/半角 16文字/32文字) */
  name?: Maybe<Scalars['String']['output']>;
  /** ご依頼主電話番号(半角数字15文字ハイフン含む) */
  phone?: Maybe<Scalars['String']['output']>;
  /** ご依頼主電話番号枝番(半角数字2文字) */
  phoneBranchNumber?: Maybe<Scalars['String']['output']>;
  /** ご依頼主郵便番号(半角数字8文字ハイフンなし半角7文字も可) */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** ご依頼主都道府県(4文字) */
  prefecture?: Maybe<Scalars['String']['output']>;
};

export type Bank = {
  __typename?: 'Bank';
  /** 支店コード */
  branchCodes: Array<Scalars['String']['output']>;
  /** ひらがな支店名の最初一文字 */
  branchFirstHira: Array<Scalars['String']['output']>;
  /** ローマ字支店名の最初一文字 */
  branchFirstRoma: Array<Scalars['String']['output']>;
  branches: BranchPage;
  code: Scalars['ID']['output'];
  hira: Scalars['String']['output'];
  kana: Scalars['String']['output'];
  name: Scalars['String']['output'];
  roma: Scalars['String']['output'];
};


export type BankBranchesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type BankAccount = Node & {
  __typename?: 'BankAccount';
  /** 口座名義 */
  accountHolderName: Scalars['String']['output'];
  /** 口座番号 */
  accountNumber: Scalars['String']['output'];
  /** 口座種別(普通・当座) */
  accountType: BankAccountAccount;
  /** 全銀コード */
  bankCode: Scalars['String']['output'];
  /** 銀行名 */
  bankName: Scalars['String']['output'];
  /** 支店コード */
  branchCode: Scalars['String']['output'];
  /** 支店名 */
  branchName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
};

/** 口座種別 */
export const BankAccountAccount = {
  /** 普通 */
  Futsu: 'futsu',
  /** 当座 */
  Toza: 'toza'
} as const;

export type BankAccountAccount = typeof BankAccountAccount[keyof typeof BankAccountAccount];
export type BankBranch = {
  __typename?: 'BankBranch';
  bank: Bank;
  code: Scalars['ID']['output'];
  hira: Scalars['String']['output'];
  kana: Scalars['String']['output'];
  name: Scalars['String']['output'];
  roma: Scalars['String']['output'];
};

export type BankPage = {
  __typename?: 'BankPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<Bank>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type Blob = {
  __typename?: 'Blob';
  contentType: Scalars['String']['output'];
  signedId: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

/** Autogenerated input type of BookAppointment */
export type BookAppointmentInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type BookAppointmentPayload = {
  __typename?: 'BookAppointmentPayload';
  encounter: Encounter;
};

export type Bookmark = Node & {
  __typename?: 'Bookmark';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type BookmarkedPatientCount = {
  __typename?: 'BookmarkedPatientCount';
  /** お気に入り登録者の予約合計数 */
  appointmentCount: Scalars['Int']['output'];
  /** 月間お気に入り登録者数 */
  monthlyPatientsCount?: Maybe<Scalars['Int']['output']>;
  organization: Organization;
  /** 薬局毎のお気に入り累計登録者総数 */
  totalPatientsCount: Scalars['Int']['output'];
};

export type BookmarkedPatientCountPage = {
  __typename?: 'BookmarkedPatientCountPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<BookmarkedPatientCount>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type Branch = {
  __typename?: 'Branch';
  bank: Bank;
  code: Scalars['ID']['output'];
  hira: Scalars['String']['output'];
  kana: Scalars['String']['output'];
  name: Scalars['String']['output'];
  roma: Scalars['String']['output'];
};

export type BranchPage = {
  __typename?: 'BranchPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<Branch>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

/** Autogenerated input type of BulkDuplicateMedicationFollowupMessageTemplates */
export type BulkDuplicateMedicationFollowupMessageTemplatesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 参照元のメッセージテンプレートIDの配列 */
  medicationFollowupMessageTemplateIds: Array<Scalars['ID']['input']>;
  /** アップロード済みのテンプレート反映用店舗一覧CSVファイルのSigned ID */
  signedId?: InputMaybe<Scalars['String']['input']>;
  /** 参照元の店舗ID */
  sourceOrganizationId: Scalars['ID']['input'];
};

export type BulkDuplicateMedicationFollowupMessageTemplatesPayload = {
  __typename?: 'BulkDuplicateMedicationFollowupMessageTemplatesPayload';
  messageTemplateJobInformation: MedicationFollowupMessageTemplateJobInformation;
};

export type BusinessHourTime = {
  __typename?: 'BusinessHourTime';
  /** 終了時間 */
  end: Scalars['ISO8601DateTime']['output'];
  /** 開始時間 */
  start: Scalars['ISO8601DateTime']['output'];
};

export type BusinessHourTimeInput = {
  end: Scalars['ISO8601DateTime']['input'];
  start: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated input type of CancelAppointment */
export type CancelAppointmentInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reason: CancelAppointmentReason;
};

export type CancelAppointmentPayload = {
  __typename?: 'CancelAppointmentPayload';
  appointment: Appointment;
};

export const CancelAppointmentReason = {
  /** 患者が来ない */
  Noshow: 'noshow',
  /** その他起因 */
  Other: 'other',
  /** 患者起因 */
  Pat: 'pat',
  /** 患者起因(アプリ経由) */
  PatCpp: 'pat_cpp',
  /** 薬局起因 */
  Prov: 'prov'
} as const;

export type CancelAppointmentReason = typeof CancelAppointmentReason[keyof typeof CancelAppointmentReason];
/** Autogenerated input type of CancelAppointmentViaWeb */
export type CancelAppointmentViaWebInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CancelAppointmentViaWebPayload = {
  __typename?: 'CancelAppointmentViaWebPayload';
  appointment: PublicAppointment;
};

/** Autogenerated input type of CancelAppointmentWithWebVisitor */
export type CancelAppointmentWithWebVisitorInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reason: CancelAppointmentReason;
};

export type CancelAppointmentWithWebVisitorPayload = {
  __typename?: 'CancelAppointmentWithWebVisitorPayload';
  appointment: Appointment;
};

/** Autogenerated input type of CancelDraftAppointment */
export type CancelDraftAppointmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  draftAppointmentId: Scalars['ID']['input'];
  reason: DraftAppointmentCancellationReason;
};

export type CancelDraftAppointmentPayload = {
  __typename?: 'CancelDraftAppointmentPayload';
  draftAppointment: DraftAppointment;
};

/** Autogenerated input type of CancelOperatorAccessPermission */
export type CancelOperatorAccessPermissionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CancelOperatorAccessPermissionPayload = {
  __typename?: 'CancelOperatorAccessPermissionPayload';
  operatorAccessPermission?: Maybe<OperatorAccessPermission>;
};

/** 受け渡し方法を変更する時に変更可能なステータス */
export const ChangeDeliveryMethod = {
  /** 対面受取 */
  Hand: 'hand',
  /** 通常配達受取 */
  Parcel: 'parcel',
  /** 当日配達受取 */
  SameDayDelivery: 'same_day_delivery'
} as const;

export type ChangeDeliveryMethod = typeof ChangeDeliveryMethod[keyof typeof ChangeDeliveryMethod];
/** Autogenerated input type of ChangeDeliveryMethod */
export type ChangeDeliveryMethodInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod: ChangeDeliveryMethod;
};

export type ChangeDeliveryMethodPayload = {
  __typename?: 'ChangeDeliveryMethodPayload';
  appointment: Appointment;
};

/** Autogenerated input type of ChangeOutpatientQuestionnaireSettingQuestionnaireInUse */
export type ChangeOutpatientQuestionnaireSettingQuestionnaireInUseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  outpatientQuestionnaireSettingQuestionnaireId: Scalars['ID']['input'];
};

export type ChangeOutpatientQuestionnaireSettingQuestionnaireInUsePayload = {
  __typename?: 'ChangeOutpatientQuestionnaireSettingQuestionnaireInUsePayload';
  outpatientQuestionnaireSettingQuestionnaire: OutpatientQuestionnaireSettingQuestionnaire;
};

export type Charge = Node & {
  __typename?: 'Charge';
  amount: Scalars['String']['output'];
  appointment: Appointment;
  chargeHistories: ChargeHistoryPage;
  id: Scalars['ID']['output'];
  paymentMethod: PaymentMethod;
  pfPaymentHistoryId?: Maybe<Scalars['String']['output']>;
  pfPaymentId?: Maybe<Scalars['String']['output']>;
  practitioner: Practitioner;
  /** 返金可能かどうか */
  refundable: Scalars['Boolean']['output'];
  /** 返金済かどうか */
  refunded: Scalars['Boolean']['output'];
};


export type ChargeChargeHistoriesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type ChargeHistory = Node & {
  __typename?: 'ChargeHistory';
  /** 決済金額 */
  amount: Scalars['Int']['output'];
  amountDetails?: Maybe<Array<ChargeHistoryAmountDetail>>;
  charge: Charge;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** 税抜き利用料金(1円未満は切り捨て) */
  fee: Scalars['Int']['output'];
  /** 税込み利用料金(1円未満は切り捨て) */
  feeWithTax: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  invoice?: Maybe<Invoice>;
  /** 純利益 */
  net: Scalars['Int']['output'];
  organization: Organization;
  /** 返金済かどうか */
  refunded: Scalars['Boolean']['output'];
  statement: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ChargeHistoryAmountDetail = {
  __typename?: 'ChargeHistoryAmountDetail';
  /** 決済金額 */
  amount: Scalars['Int']['output'];
  code: LineItemCode;
};

export type ChargeHistoryPage = {
  __typename?: 'ChargeHistoryPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<ChargeHistory>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export const ChargeItemType = {
  /** 金額 */
  Money: 'money',
  /** 点数 */
  Point: 'point'
} as const;

export type ChargeItemType = typeof ChargeItemType[keyof typeof ChargeItemType];
export type ChargeWithApp2ChargeItemInput = {
  /** 金額もしくは点数 */
  amount: Scalars['Int']['input'];
  /** 識別コード */
  code?: InputMaybe<Scalars['String']['input']>;
  /** 名称 */
  subject: Scalars['String']['input'];
  /** 種別 */
  type?: InputMaybe<ChargeItemType>;
};

/** Autogenerated input type of ChargeWithApp2 */
export type ChargeWithApp2Input = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<ChargeWithApp2LineItemInput>;
};

export type ChargeWithApp2LineItemInput = {
  /** 金額 */
  amount: Scalars['Int']['input'];
  /** 詳細情報 */
  chargeItems?: InputMaybe<Array<ChargeWithApp2ChargeItemInput>>;
  /** 識別コード */
  code: LineItemCode;
  /** 名称 */
  subject: Scalars['String']['input'];
};

export type ChargeWithApp2Payload = {
  __typename?: 'ChargeWithApp2Payload';
  charge: Charge;
};

/** Autogenerated input type of ChargeWithApp */
export type ChargeWithAppInput = {
  amount: Scalars['Int']['input'];
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargeWithAppPayload = {
  __typename?: 'ChargeWithAppPayload';
  charge: Charge;
};

/** Autogenerated input type of ChargeWithCash2 */
export type ChargeWithCash2Input = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<ChargeWithApp2LineItemInput>;
};

export type ChargeWithCash2Payload = {
  __typename?: 'ChargeWithCash2Payload';
  charge: Charge;
};

/** Autogenerated input type of ChargeWithCash */
export type ChargeWithCashInput = {
  amount: Scalars['Int']['input'];
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargeWithCashPayload = {
  __typename?: 'ChargeWithCashPayload';
  charge: Charge;
};

export type CheckinEntry = Node & {
  __typename?: 'CheckinEntry';
  checkinOrganization: CheckinOrganization;
  description: Scalars['String']['output'];
  enteredAt: Scalars['ISO8601DateTime']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  notificationsCount: Scalars['Int']['output'];
  notifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  organization: Organization;
  /** SMS配信先の携帯電話番号 */
  phoneNumber: Scalars['String']['output'];
  phoneticFamilyName: Scalars['String']['output'];
  phoneticGivenName: Scalars['String']['output'];
  status: CheckinEntryStatus;
  /** 未読通知 */
  unreadOrganizationNotifications: Array<OrganizationNotification>;
};

export type CheckinEntryPage = {
  __typename?: 'CheckinEntryPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<CheckinEntry>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

/** チェックインステータス */
export const CheckinEntryStatus = {
  /** 未通知 */
  Entered: 'entered',
  /** 完了済み */
  Finished: 'finished',
  /** 通知済み */
  Notified: 'notified'
} as const;

export type CheckinEntryStatus = typeof CheckinEntryStatus[keyof typeof CheckinEntryStatus];
export type CheckinOrganization = Node & {
  __typename?: 'CheckinOrganization';
  active?: Maybe<Scalars['Boolean']['output']>;
  appDownloadUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** 店舗名 */
  name: Scalars['String']['output'];
};

export type CheckinSetting = {
  __typename?: 'CheckinSetting';
  active: Scalars['Boolean']['output'];
  checkinOrganization: CheckinOrganization;
  id: Scalars['ID']['output'];
  organization: Organization;
};

export type City = {
  __typename?: 'City';
  /** 市区町村名 */
  city: Scalars['String']['output'];
  /** 市区町村コード */
  jisCode: Scalars['String']['output'];
};

export type ClientAuthentication = Node & {
  __typename?: 'ClientAuthentication';
  /** クライアント認証が有効、かつ開始日以降か */
  available: Scalars['Boolean']['output'];
  company: Company;
  enable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  startAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ClientCert = Node & {
  __typename?: 'ClientCert';
  certId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  downloadStatus: ClientCertDownloadStatus;
  /** ダウンロードページのURL */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issuerRdn?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notAfter?: Maybe<Scalars['ISO8601DateTime']['output']>;
  notBefore?: Maybe<Scalars['ISO8601DateTime']['output']>;
  operator?: Maybe<Operator>;
  organization: Organization;
  password?: Maybe<Scalars['String']['output']>;
  practitioner?: Maybe<PrivilegeOrganizationPractitioner>;
  /** 要更新（有効期限が現在日から30日以内）か否か */
  renewable: Scalars['Boolean']['output'];
  revokedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status: ClientCertStatus;
  /** 証明書を使ってアクセスしたかどうか */
  used: Scalars['Boolean']['output'];
};

/** クライアント証明書のダウンロード状況 */
export const ClientCertDownloadStatus = {
  /** ダウンロード不可 */
  Cancelled: 'cancelled',
  /** ダウンロード済み */
  Done: 'done',
  /** ダウンロード可能 */
  Waiting: 'waiting'
} as const;

export type ClientCertDownloadStatus = typeof ClientCertDownloadStatus[keyof typeof ClientCertDownloadStatus];
export type ClientCertJobInformation = Node & {
  __typename?: 'ClientCertJobInformation';
  errorMessages?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  status: JobInformationStatus;
  url?: Maybe<Scalars['String']['output']>;
};

export type ClientCertPage = {
  __typename?: 'ClientCertPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<ClientCert>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export const ClientCertStatus = {
  /** 失効 */
  Revoked: 'revoked',
  /** 有効 */
  Valid: 'valid'
} as const;

export type ClientCertStatus = typeof ClientCertStatus[keyof typeof ClientCertStatus];
export const ClientCertStatusFilter = {
  /** ダウンロード済み */
  Downloaded: 'downloaded',
  /** 失効済み */
  Revoked: 'revoked',
  /** 有効 */
  Valid: 'valid',
  /** ダウンロード待ち */
  Waiting: 'waiting'
} as const;

export type ClientCertStatusFilter = typeof ClientCertStatusFilter[keyof typeof ClientCertStatusFilter];
export type ClientCertSummary = {
  __typename?: 'ClientCertSummary';
  /** 有効且つ、ダウンロード済、未使用の証明書数 */
  downloadedCount: Scalars['Int']['output'];
  organization: Organization;
  /** 要更新の証明書数 */
  renewCount: Scalars['Int']['output'];
  /** 失効済の証明書数 */
  revokedCount: Scalars['Int']['output'];
  /** 有効且つ、ダウンロード済、使用済みの証明書数 */
  validCount: Scalars['Int']['output'];
  /** ダウンロード待ちの証明書数 */
  waitingCount: Scalars['Int']['output'];
};

export type ClientCertSummaryPage = {
  __typename?: 'ClientCertSummaryPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<ClientCertSummary>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type ClientCertVerification = {
  __typename?: 'ClientCertVerification';
  clientCert?: Maybe<ClientCert>;
  status: ClientCertVerificationStatus;
  /** リダイレクト先URL */
  url?: Maybe<Scalars['String']['output']>;
};

export const ClientCertVerificationStatus = {
  /** 無効な証明書 */
  Ng: 'ng',
  /** 検証結果なし */
  None: 'none',
  /** 有効な証明書 */
  Ok: 'ok',
  /** 通常ドメインへのリダイレクト指示 */
  RedirectToApp: 'redirect_to_app',
  /** sドメインへのリダイレクト指示 */
  RedirectToS: 'redirect_to_s'
} as const;

export type ClientCertVerificationStatus = typeof ClientCertVerificationStatus[keyof typeof ClientCertVerificationStatus];
export type Company = Node & {
  __typename?: 'Company';
  active: Scalars['Boolean']['output'];
  /** 利用可能な拡張機能コード一覧 */
  activeExtensionCodes: Array<ExtensionCode>;
  /** 法人の無効化で影響を受ける店舗一覧 */
  affectedOrganizationsByDeactivation?: Maybe<OrganizationPage>;
  /** 連携ソフト設定 */
  agentSetting?: Maybe<CompanyAgentSetting>;
  agreementExtensions: AgreementExtensionPage;
  bookmarkedPatientCounts: BookmarkedPatientCountPage;
  /** 窓口担当候補 */
  candidateCompanyPractitioners?: Maybe<Array<Practitioner>>;
  checkinEntries: CheckinEntryPage;
  clientAuthentication?: Maybe<ClientAuthentication>;
  clientCertSummaries: ClientCertSummaryPage;
  companyAddresses: Array<CompanyAddress>;
  companyContactPoints: Array<CompanyContactPoint>;
  /** 有効な窓口担当 */
  companyPractitioner?: Maybe<CompanyPractitioner>;
  /** 認証待ちの認証 */
  companyPractitionerConfirmation?: Maybe<CompanyPractitionerConfirmation>;
  contract?: Maybe<Contract>;
  /** ライトプラン契約=true */
  contractLightPlan: Scalars['Boolean']['output'];
  /** 指定した年月内の契約プランで、特定の機能が有効なものがあったか */
  existPlanFeature: Scalars['Boolean']['output'];
  /** 処方箋ネット受付を受け付けている店舗数 */
  facetofaceOrganizationCount: Scalars['Int']['output'];
  /** 利用可能なFeatureFlagの名前 */
  featureNames: Array<Scalars['String']['output']>;
  /** 利用実績 */
  featureUsages: FeatureUsagePage;
  feeSettings: CompanyFeeSettingPage;
  id: Scalars['ID']['output'];
  /** 最新のメッセージテンプレート一括反映ジョブ情報 */
  latestSucceededTemplateJobInformation?: Maybe<MedicationFollowupMessageTemplateJobInformation>;
  /** 最新のUber署名 */
  latestUberSignature?: Maybe<UberSignature>;
  medicationFollowupUsages: MedicationFollowupUsagePage;
  /** 指定月の売上 */
  monthlySales?: Maybe<CompanyMonthlySales>;
  name: Scalars['String']['output'];
  organizationImportJobInformations: OrganizationImportJobInformationConnection;
  organizations: OrganizationPage;
  /** 利用明細が発行された年一覧(降順) */
  payoutYears: Array<Scalars['Int']['output']>;
  payouts: PayoutPage;
  practitioners: PractitionerPage;
  /** 本部店舗 */
  privilegeOrganization: PrivilegeOrganization;
  /** 予約公開している店舗数 */
  publishedOrganizationCount: Scalars['Int']['output'];
  receptionUsages: ReceptionUsagePage;
  receptions?: Maybe<ReceptionPage>;
  /** 指定年の売上がある月一覧(降順) */
  salesMonths: Array<Scalars['Int']['output']>;
  /** 売上がある年一覧(降順) */
  salesYears: Array<Scalars['Int']['output']>;
  sessionSetting?: Maybe<CompanySessionSetting>;
  slug: Scalars['String']['output'];
  /** オンライン服薬指導を受け付けている店舗数 */
  telemedicineOrganizationCount: Scalars['Int']['output'];
  tracingReportUsages: TracingReportUsagePage;
  uberSignatureDraft?: Maybe<UberSignatureDraft>;
  /** Uber署名の一覧 */
  uberSignatures?: Maybe<Array<UberSignature>>;
  webBookingsLimitSettings: Array<CompanyWebBookingsLimitSetting>;
};


export type CompanyAffectedOrganizationsByDeactivationArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAgreementExtensionsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  extensionCode: ExtensionCode;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyBookmarkedPatientCountsArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyCheckinEntriesArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderDirection>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<CheckinEntryStatus>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyClientCertSummariesArgs = {
  notIssued?: InputMaybe<Scalars['Boolean']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  renewable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyExistPlanFeatureArgs = {
  featureCode: Scalars['String']['input'];
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyFeatureUsagesArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<FeatureUsageType>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyFeeSettingsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyMedicationFollowupUsagesArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyMonthlySalesArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type CompanyOrganizationImportJobInformationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyOrganizationsArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  includeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyPayoutsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyPractitionersArgs = {
  includeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderDirection>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyReceptionUsagesArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyReceptionsArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderDirection>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<OrganizationAppointmentStatus>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanySalesMonthsArgs = {
  year: Scalars['Int']['input'];
};


export type CompanyTracingReportUsagesArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyAddress = Node & {
  __typename?: 'CompanyAddress';
  address: Address;
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
};

export type CompanyAgentSetting = {
  __typename?: 'CompanyAgentSetting';
  id: Scalars['ID']['output'];
  /** プロキシサーバーのIPアドレス/ドメイン名 */
  proxyHost?: Maybe<Scalars['String']['output']>;
  /** プロキシサーバーのポート番号 */
  proxyPort?: Maybe<Scalars['String']['output']>;
};

export type CompanyCommonSetting = Node & {
  __typename?: 'CompanyCommonSetting';
  createdAt: Scalars['ISO8601DateTime']['output'];
  fee: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  webBookingsLimit: Scalars['Boolean']['output'];
};

export type CompanyContactPoint = Node & {
  __typename?: 'CompanyContactPoint';
  contactPoint: ContactPoint;
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
};

export type CompanyFeeSetting = Node & {
  __typename?: 'CompanyFeeSetting';
  active: Scalars['Boolean']['output'];
  code: LineItemCode;
  company: Company;
  defaultAmount?: Maybe<Scalars['Int']['output']>;
  defaultField: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  fixed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  subject: Scalars['String']['output'];
};

export type CompanyFeeSettingPage = {
  __typename?: 'CompanyFeeSettingPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<CompanyFeeSetting>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type CompanyMonthlySales = {
  __typename?: 'CompanyMonthlySales';
  /** 日付 x 店舗毎の売上一覧(日付降順 x 店舗position昇順) */
  organizationDailySales: OrganizationDailySalesPage;
  /** 当月の売上金額合計 */
  totalAmount: Scalars['Int']['output'];
};


export type CompanyMonthlySalesOrganizationDailySalesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyPractitioner = Node & {
  __typename?: 'CompanyPractitioner';
  active: Scalars['Boolean']['output'];
  company: Company;
  companyPractitionerContactPoints: Array<CompanyPractitionerContactPoint>;
  id: Scalars['ID']['output'];
  practitioner: Practitioner;
  /** 送信履歴 */
  sendgridEventActivities?: Maybe<Array<SendgridEventActivity>>;
};

export type CompanyPractitionerConfirmation = Node & {
  __typename?: 'CompanyPractitionerConfirmation';
  company: Company;
  confirmationType: CompanyPractitionerConfirmationType;
  /** 認証済みかどうか */
  confirmed: Scalars['Boolean']['output'];
  data: CompanyPractitionerConfirmationData;
  /** 期限切れかどうか */
  expired: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  practitioner: Practitioner;
  /** 送信履歴 */
  sendgridEventActivities?: Maybe<Array<SendgridEventActivity>>;
};

export type CompanyPractitionerConfirmationData = {
  __typename?: 'CompanyPractitionerConfirmationData';
  /** 認証待ちメールアドレス */
  practitionerEmail: Scalars['String']['output'];
  practitionerTel?: Maybe<Scalars['String']['output']>;
};

export const CompanyPractitionerConfirmationType = {
  /** 窓口担当の新規作成 */
  Creation: 'creation',
  /** 連絡先の更新 */
  Update: 'update'
} as const;

export type CompanyPractitionerConfirmationType = typeof CompanyPractitionerConfirmationType[keyof typeof CompanyPractitionerConfirmationType];
export type CompanyPractitionerContactPoint = Node & {
  __typename?: 'CompanyPractitionerContactPoint';
  contactPoint: ContactPoint;
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
};

export type CompanySessionSetting = Node & {
  __typename?: 'CompanySessionSetting';
  /** セッション有効時間 */
  duration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type CompanySetupDocument = Node & {
  __typename?: 'CompanySetupDocument';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  data: Scalars['JSON']['output'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** 送信履歴 */
  sendgridEventActivities?: Maybe<Array<SendgridEventActivity>>;
  token: Scalars['String']['output'];
};

export type CompanyWebBookingsLimitSetting = Node & {
  __typename?: 'CompanyWebBookingsLimitSetting';
  code: WebBookingsLimitCode;
  company: Company;
  id: Scalars['ID']['output'];
  limit: Scalars['Int']['output'];
};

export type ContactPoint = Node & {
  __typename?: 'ContactPoint';
  formattedValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  system: ContactPointSystem;
  use: ContactPointUse;
  value: Scalars['String']['output'];
};

/** 連絡先との通信方式を表す。See http://hl7.org/fhir/valueset-contact-point-system.html */
export const ContactPointSystem = {
  /** メールアドレス */
  Email: 'email',
  /** FAX番号 */
  Fax: 'fax',
  /** その他 */
  Other: 'other',
  /** ポケベル番号 */
  Pager: 'pager',
  /** 音声通話用の電話番号 */
  Phone: 'phone',
  /** SMS送信用の番号 */
  Sms: 'sms',
  /** URL */
  Url: 'url'
} as const;

export type ContactPointSystem = typeof ContactPointSystem[keyof typeof ContactPointSystem];
/** 連絡先の用途を表す。See https://www.hl7.org/fhir/valueset-contact-point-use.html */
export const ContactPointUse = {
  /** 自宅 */
  Home: 'home',
  /** 携帯端末 */
  Mobile: 'mobile',
  /** 利用されていない連絡先 */
  Old: 'old',
  /** 一時的な連絡先 */
  Temp: 'temp',
  /** オフィス */
  Work: 'work'
} as const;

export type ContactPointUse = typeof ContactPointUse[keyof typeof ContactPointUse];
export type Contract = Node & {
  __typename?: 'Contract';
  contractCount: Scalars['Int']['output'];
  contractPlans: Array<ContractPlan>;
  id: Scalars['ID']['output'];
};


export type ContractContractPlansArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractPlan = Node & {
  __typename?: 'ContractPlan';
  contract: Contract;
  end?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  plan: Plan;
  start: Scalars['ISO8601Date']['output'];
};

export type CreateAdminPractitionerInput = {
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  phoneticFamilyName?: InputMaybe<Scalars['String']['input']>;
  phoneticGivenName?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<PractitionerRole>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateAllowList */
export type CreateAllowListInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type CreateAllowListPayload = {
  __typename?: 'CreateAllowListPayload';
  allowList: AllowList;
};

/** Autogenerated input type of CreateAnnouncement */
export type CreateAnnouncementInput = {
  active: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  emergency?: InputMaybe<Scalars['Boolean']['input']>;
  subject: Scalars['String']['input'];
  type: AnnouncementType;
};

export type CreateAnnouncementPayload = {
  __typename?: 'CreateAnnouncementPayload';
  announcement: Announcement;
};

/** Autogenerated input type of CreateAppointmentViaWeb */
export type CreateAppointmentViaWebInput = {
  answers: Array<QuestionnaireSheetAnswerInput>;
  birthDate: Scalars['ISO8601Date']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 希望終了時間 */
  endAt: Scalars['ISO8601DateTime']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  mobilePhone: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  phoneticFamilyName: Scalars['String']['input'];
  phoneticGivenName: Scalars['String']['input'];
  sex: Sex;
  /** アップロード済み処方箋画像のSigned ID */
  signedIds: Array<Scalars['String']['input']>;
  /** 希望開始時間 */
  startAt: Scalars['ISO8601DateTime']['input'];
};

export type CreateAppointmentViaWebPayload = {
  __typename?: 'CreateAppointmentViaWebPayload';
  appointment: PublicAppointment;
};

/** Autogenerated input type of CreateAuthTokenByProxy */
export type CreateAuthTokenByProxyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  practitionerId: Scalars['ID']['input'];
};

export type CreateAuthTokenByProxyPayload = {
  __typename?: 'CreateAuthTokenByProxyPayload';
  authToken: AuthToken;
};

/** Autogenerated input type of CreateCheckinEntry */
export type CreateCheckinEntryInput = {
  checkinOrganizationId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  phoneticFamilyName: Scalars['String']['input'];
  phoneticGivenName: Scalars['String']['input'];
  /** recaptchaのレスポンスデータ */
  response: Scalars['String']['input'];
};

export type CreateCheckinEntryPayload = {
  __typename?: 'CreateCheckinEntryPayload';
  publicCheckinEntry: PublicCheckinEntry;
};

/** Autogenerated input type of CreateClientCert */
export type CreateClientCertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CreateClientCertPayload = {
  __typename?: 'CreateClientCertPayload';
  clientCert: ClientCert;
};

/** Autogenerated input type of CreateCompanyFeeSetting */
export type CreateCompanyFeeSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: LineItemCode;
  companyId: Scalars['ID']['input'];
  defaultAmount?: InputMaybe<Scalars['Int']['input']>;
  defaultField?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  subject: Scalars['String']['input'];
};

export type CreateCompanyFeeSettingPayload = {
  __typename?: 'CreateCompanyFeeSettingPayload';
  companyFeeSetting: CompanyFeeSetting;
};

/** Autogenerated input type of CreateCompanySetupDocument */
export type CreateCompanySetupDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyAddressCity?: InputMaybe<Scalars['String']['input']>;
  companyAddressLine?: InputMaybe<Scalars['String']['input']>;
  companyAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  companyAddressPrefecture?: InputMaybe<Scalars['String']['input']>;
  companyFax?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  companyTel?: InputMaybe<Scalars['String']['input']>;
  contractCount: Scalars['Int']['input'];
  contractPlanId: Scalars['ID']['input'];
  contractStartDate: Scalars['ISO8601Date']['input'];
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  organizationAddressCity?: InputMaybe<Scalars['String']['input']>;
  organizationAddressLine?: InputMaybe<Scalars['String']['input']>;
  organizationAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  organizationAddressPrefecture?: InputMaybe<Scalars['String']['input']>;
  organizationFax?: InputMaybe<Scalars['String']['input']>;
  organizationName: Scalars['String']['input'];
  organizationTel?: InputMaybe<Scalars['String']['input']>;
  practitionerEmail: Scalars['String']['input'];
  practitionerFamilyName: Scalars['String']['input'];
  practitionerGivenName: Scalars['String']['input'];
  practitionerPhoneticFamilyName: Scalars['String']['input'];
  practitionerPhoneticGivenName: Scalars['String']['input'];
  practitionerTel: Scalars['String']['input'];
};

export type CreateCompanySetupDocumentPayload = {
  __typename?: 'CreateCompanySetupDocumentPayload';
  companySetupDocument: CompanySetupDocument;
};

/** Autogenerated input type of CreateDirectVisitor */
export type CreateDirectVisitorInput = {
  birthDate: Scalars['ISO8601Date']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  mobilePhone: Scalars['String']['input'];
  phoneticFamilyName: Scalars['String']['input'];
  phoneticGivenName: Scalars['String']['input'];
  sex: Sex;
};

export type CreateDirectVisitorPayload = {
  __typename?: 'CreateDirectVisitorPayload';
  directVisitor: DirectVisitor;
};

/** Autogenerated input type of CreateFeature */
export type CreateFeatureInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  name: Scalars['String']['input'];
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type CreateFeaturePayload = {
  __typename?: 'CreateFeaturePayload';
  feature: Feature;
};

/** Autogenerated input type of CreateFeatureTargetGroupFromTarget */
export type CreateFeatureTargetGroupFromTargetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  featureId: Scalars['ID']['input'];
  featureTargetId: Scalars['ID']['input'];
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type CreateFeatureTargetGroupFromTargetPayload = {
  __typename?: 'CreateFeatureTargetGroupFromTargetPayload';
  featureTargetGroup: FeatureTargetGroup;
};

/** Autogenerated input type of CreateFeatureTargetGroup */
export type CreateFeatureTargetGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  featureId: Scalars['ID']['input'];
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  type: FeatureTargetGroupType;
};

export type CreateFeatureTargetGroupPayload = {
  __typename?: 'CreateFeatureTargetGroupPayload';
  featureTargetGroup: FeatureTargetGroup;
};

/** Autogenerated input type of CreateGendaSetting */
export type CreateGendaSettingInput = {
  active: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  gendaApiKeyId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CreateGendaSettingPayload = {
  __typename?: 'CreateGendaSettingPayload';
  gendaSetting: GendaSetting;
};

/** Autogenerated input type of CreateGuestPatientFollowupComment */
export type CreateGuestPatientFollowupCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  guestPatientId: Scalars['ID']['input'];
  medicationFollowupStatus?: InputMaybe<PatientMedicationFollowupStatus>;
  practitionerId: Scalars['ID']['input'];
};

export type CreateGuestPatientFollowupCommentPayload = {
  __typename?: 'CreateGuestPatientFollowupCommentPayload';
  guestPatientMedicationFollowupComment: GuestPatientMedicationFollowupComment;
};

/** Autogenerated input type of CreateMedicalInstitutionSetting */
export type CreateMedicalInstitutionSettingInput = {
  attendingPhysicians: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clinicalDepartments: Array<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  medicalInstitutionName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateMedicalInstitutionSettingPayload = {
  __typename?: 'CreateMedicalInstitutionSettingPayload';
  medicalInstitutionSetting: MedicalInstitutionSetting;
};

/** Autogenerated input type of CreateMedicationFollowupMessage2 */
export type CreateMedicationFollowupMessage2Input = {
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
  autoReplyMessage?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  csClinicId?: InputMaybe<Scalars['String']['input']>;
  /** Medixs薬歴のイベントID */
  eventId?: InputMaybe<Scalars['Int']['input']>;
  guestPatientId?: InputMaybe<Scalars['ID']['input']>;
  medicationFollowupQuestionnaireRevisionId?: InputMaybe<Scalars['ID']['input']>;
  message: Scalars['String']['input'];
  patientId?: InputMaybe<Scalars['ID']['input']>;
  sendAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  withAutoReplyQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateMedicationFollowupMessage2Payload = {
  __typename?: 'CreateMedicationFollowupMessage2Payload';
  medicationFollowupMessage: MedicationFollowupMessage;
};

/** Autogenerated input type of CreateMedicationFollowupMessageTemplate */
export type CreateMedicationFollowupMessageTemplateInput = {
  autoReplyMessage?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** CLNICSクリニックID */
  csClinicId?: InputMaybe<Scalars['String']['input']>;
  /** 質問票ID */
  medicationFollowupQuestionnaireId?: InputMaybe<Scalars['ID']['input']>;
  message: Scalars['String']['input'];
  /** 未使用のため不要 */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  sendTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  sendTiming?: InputMaybe<Scalars['Int']['input']>;
  subject: Scalars['String']['input'];
  withAutoReplyQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
  /** 病院・診療所の紹介あり=true */
  withRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateMedicationFollowupMessageTemplatePayload = {
  __typename?: 'CreateMedicationFollowupMessageTemplatePayload';
  medicationFollowupMessageTemplate: MedicationFollowupMessageTemplate;
};

/** Autogenerated input type of CreateMedicationFollowupQuestionnaire */
export type CreateMedicationFollowupQuestionnaireInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formData: MedicationFollowupQuestionnaireFormDataInput;
  subject: Scalars['String']['input'];
};

export type CreateMedicationFollowupQuestionnairePayload = {
  __typename?: 'CreateMedicationFollowupQuestionnairePayload';
  medicationFollowupQuestionnaire: MedicationFollowupQuestionnaire;
};

export type CreateMedicationFollowupQuestionnaireSheetAnswerInput = {
  /** 質問 */
  title: Scalars['String']['input'];
  /** 回答 */
  value: Array<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateMedicationFollowupQuestionnaireSheet */
export type CreateMedicationFollowupQuestionnaireSheetInput = {
  answers: Array<CreateMedicationFollowupQuestionnaireSheetAnswerInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  publicMedicationFollowupMessageId: Scalars['ID']['input'];
};

export type CreateMedicationFollowupQuestionnaireSheetPayload = {
  __typename?: 'CreateMedicationFollowupQuestionnaireSheetPayload';
  publicMedicationFollowupMessage: PublicMedicationFollowupMessage;
  publicMedicationFollowupQuestionnaireSheet: PublicMedicationFollowupQuestionnaireSheet;
};

/** Autogenerated input type of CreateMedixsSetting */
export type CreateMedixsSettingInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  pharmacyId: Scalars['String']['input'];
};

export type CreateMedixsSettingPayload = {
  __typename?: 'CreateMedixsSettingPayload';
  medixsSetting: MedixsSetting;
};

/** Autogenerated input type of CreateMessageForWebVisitor */
export type CreateMessageForWebVisitorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  webVisitorId: Scalars['ID']['input'];
};

export type CreateMessageForWebVisitorPayload = {
  __typename?: 'CreateMessageForWebVisitorPayload';
  messageDeliver: MessageDeliver;
};

/** Autogenerated input type of CreateOperatorAuthority */
export type CreateOperatorAuthorityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  operatorId: Scalars['ID']['input'];
  operatorRoleId: Scalars['ID']['input'];
};

export type CreateOperatorAuthorityPayload = {
  __typename?: 'CreateOperatorAuthorityPayload';
  operator: Operator;
};

/** Autogenerated input type of CreateOperatorRole */
export type CreateOperatorRoleInput = {
  abilities: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOperatorRolePayload = {
  __typename?: 'CreateOperatorRolePayload';
  operatorRole: OperatorRole;
};

/** Autogenerated input type of CreateOrganizationCompanyFeeSetting */
export type CreateOrganizationCompanyFeeSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyFeeSettingId: Scalars['ID']['input'];
  defaultAmount?: InputMaybe<Scalars['Int']['input']>;
  defaultField: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};

export type CreateOrganizationCompanyFeeSettingPayload = {
  __typename?: 'CreateOrganizationCompanyFeeSettingPayload';
  organizationCompanyFeeSetting: OrganizationCompanyFeeSetting;
};

/** Autogenerated input type of CreateOrganizationFeeSetting */
export type CreateOrganizationFeeSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: LineItemCode;
  defaultAmount?: InputMaybe<Scalars['Int']['input']>;
  defaultField?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  subject: Scalars['String']['input'];
};

export type CreateOrganizationFeeSettingPayload = {
  __typename?: 'CreateOrganizationFeeSettingPayload';
  organizationFeeSetting: OrganizationFeeSetting;
};

/** Autogenerated input type of CreateOrganization */
export type CreateOrganizationInput = {
  adminPractitioner?: InputMaybe<CreateAdminPractitionerInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationPayload = {
  __typename?: 'CreateOrganizationPayload';
  adminPractitioner?: Maybe<Practitioner>;
  organization: Organization;
  practitionerCode?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateOtpSecret */
export type CreateOtpSecretInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOtpSecretPayload = {
  __typename?: 'CreateOtpSecretPayload';
  practitionerOtpSecret: PractitionerOtpSecret;
};

export type CreateOutpatientQuestionnaireEntryAddressInput = {
  city: Scalars['String']['input'];
  line: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
};

export type CreateOutpatientQuestionnaireEntryAnswerInput = {
  /** 質問 */
  outpatientQuestionnaireQuestionId: Scalars['ID']['input'];
  /** 回答 */
  values: Array<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateOutpatientQuestionnaireEntry */
export type CreateOutpatientQuestionnaireEntryInput = {
  address: CreateOutpatientQuestionnaireEntryAddressInput;
  /** 回答内容 */
  answers: Array<CreateOutpatientQuestionnaireEntryAnswerInput>;
  birthDate: Scalars['ISO8601Date']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enableNotification: Scalars['Boolean']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  outpatientQuestionnaireId: Scalars['ID']['input'];
  outpatientQuestionnaireOrganizationId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
  phoneticFamilyName: Scalars['String']['input'];
  phoneticGivenName: Scalars['String']['input'];
  /** recaptchaのレスポンスデータ */
  response: Scalars['String']['input'];
  sex: Sex;
};

export type CreateOutpatientQuestionnaireEntryPayload = {
  __typename?: 'CreateOutpatientQuestionnaireEntryPayload';
  outpatientQuestionnaireEntry: PublicOutpatientQuestionnaireEntry;
};

/** Autogenerated input type of CreateOutpatientQuestionnaireSettingQuestionnaire */
export type CreateOutpatientQuestionnaireSettingQuestionnaireInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 質問 */
  questions: Array<OutpatientQuestionnaireQuestionInput>;
  /** Web問診票のタイトル */
  title: Scalars['String']['input'];
};

export type CreateOutpatientQuestionnaireSettingQuestionnairePayload = {
  __typename?: 'CreateOutpatientQuestionnaireSettingQuestionnairePayload';
  outpatientQuestionnaireSettingQuestionnaire: OutpatientQuestionnaireSettingQuestionnaire;
};

/** Autogenerated input type of CreatePatientFollowupComment */
export type CreatePatientFollowupCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  medicationFollowupStatus?: InputMaybe<PatientMedicationFollowupStatus>;
  patientId: Scalars['ID']['input'];
  practitionerId: Scalars['ID']['input'];
};

export type CreatePatientFollowupCommentPayload = {
  __typename?: 'CreatePatientFollowupCommentPayload';
  patientMedicationFollowupComment: PatientMedicationFollowupComment;
};

/** Autogenerated input type of CreatePlan */
export type CreatePlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreatePlanPayload = {
  __typename?: 'CreatePlanPayload';
  plan: Plan;
};

/** Autogenerated input type of CreatePractitioner */
export type CreatePractitionerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  phoneticFamilyName: Scalars['String']['input'];
  phoneticGivenName: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreatePractitionerPayload = {
  __typename?: 'CreatePractitionerPayload';
  practitioner: Practitioner;
  practitionerCode: Scalars['String']['output'];
};

/** Autogenerated input type of CreateTracingReport */
export type CreateTracingReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clinicName: Scalars['String']['input'];
  clinicalDepartment: Scalars['String']['input'];
  dispensingDate: Scalars['ISO8601Date']['input'];
  doctorName: Scalars['String']['input'];
  guestPatientId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  pharmacistName: Scalars['String']['input'];
  prescriptionDrug: Scalars['String']['input'];
  prescriptionIssueDate: Scalars['ISO8601Date']['input'];
  report: Scalars['String']['input'];
  suggestion: Scalars['String']['input'];
};

export type CreateTracingReportPayload = {
  __typename?: 'CreateTracingReportPayload';
  tracingReport: TracingReport;
};

/** Autogenerated input type of CreateUberAgreementExtension */
export type CreateUberAgreementExtensionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  inputData: UberSignatureDataInput;
};

export type CreateUberAgreementExtensionPayload = {
  __typename?: 'CreateUberAgreementExtensionPayload';
  agreementExtension: AgreementExtension;
  uberSignature: UberSignature;
};

/** Autogenerated input type of CreateUberDelivery */
export type CreateUberDeliveryInput = {
  appointmentId: Scalars['ID']['input'];
  /** オートモード実行 */
  autoMode?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 配達物 */
  quantities: Array<Scalars['Int']['input']>;
  /** 配達見積もりID */
  quoteId: Scalars['String']['input'];
  /** キャンセル理由 */
  undeliverableReason?: InputMaybe<UberUndeliverableReasonStatus>;
};

export type CreateUberDeliveryPayload = {
  __typename?: 'CreateUberDeliveryPayload';
  uberDelivery: UberDelivery;
};

export type CsCity = {
  __typename?: 'CsCity';
  /** 地域コード */
  code: Scalars['String']['output'];
  /** 市区町村名 */
  name: Scalars['String']['output'];
};

export type CsClinic = {
  __typename?: 'CsClinic';
  /** 住所 */
  address: Scalars['String']['output'];
  /** クリニックID */
  id: Scalars['ID']['output'];
  /** ロゴ画像のURL */
  logoImageUrl: Scalars['String']['output'];
  /** クリニック名 */
  name: Scalars['String']['output'];
  subCategories: Array<CsClinicSubCategory>;
  /** 電話番号 */
  tel?: Maybe<Scalars['String']['output']>;
};

export type CsClinicCategory = {
  __typename?: 'CsClinicCategory';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CsClinicPage = {
  __typename?: 'CsClinicPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<CsClinic>;
  pagesCount: Scalars['Int']['output'];
};

export type CsClinicSubCategory = {
  __typename?: 'CsClinicSubCategory';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Autogenerated input type of DeactivateAnnouncement */
export type DeactivateAnnouncementInput = {
  announcementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeactivateAnnouncementPayload = {
  __typename?: 'DeactivateAnnouncementPayload';
  announcement: Announcement;
};

/** Autogenerated input type of DeactivateCompanyFeeSetting */
export type DeactivateCompanyFeeSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyFeeSettingId: Scalars['ID']['input'];
};

export type DeactivateCompanyFeeSettingPayload = {
  __typename?: 'DeactivateCompanyFeeSettingPayload';
  companyFeeSetting: CompanyFeeSetting;
};

/** Autogenerated input type of DeactivateCompany */
export type DeactivateCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

export type DeactivateCompanyPayload = {
  __typename?: 'DeactivateCompanyPayload';
  company: Company;
};

/** Autogenerated input type of DeactivateMedicationFollowupMessage */
export type DeactivateMedicationFollowupMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  medicationFollowupMessageId: Scalars['ID']['input'];
};

export type DeactivateMedicationFollowupMessagePayload = {
  __typename?: 'DeactivateMedicationFollowupMessagePayload';
  medicationFollowupMessage: MedicationFollowupMessage;
};

/** Autogenerated input type of DeactivateMedicationFollowupMessageTemplate */
export type DeactivateMedicationFollowupMessageTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  medicationFollowupMessageTemplateId: Scalars['ID']['input'];
};

export type DeactivateMedicationFollowupMessageTemplatePayload = {
  __typename?: 'DeactivateMedicationFollowupMessageTemplatePayload';
  medicationFollowupMessageTemplate: MedicationFollowupMessageTemplate;
};

/** Autogenerated input type of DeactivateMedicationFollowupQuestionnaire */
export type DeactivateMedicationFollowupQuestionnaireInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  medicationFollowupQuestionnaireId: Scalars['ID']['input'];
};

export type DeactivateMedicationFollowupQuestionnairePayload = {
  __typename?: 'DeactivateMedicationFollowupQuestionnairePayload';
  medicationFollowupQuestionnaire: MedicationFollowupQuestionnaire;
};

/** Autogenerated input type of DeactivateOperator */
export type DeactivateOperatorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  operatorId: Scalars['ID']['input'];
};

export type DeactivateOperatorPayload = {
  __typename?: 'DeactivateOperatorPayload';
  operator: Operator;
};

/** Autogenerated input type of DeactivateOrganizationFeeSetting */
export type DeactivateOrganizationFeeSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationFeeSettingId: Scalars['ID']['input'];
};

export type DeactivateOrganizationFeeSettingPayload = {
  __typename?: 'DeactivateOrganizationFeeSettingPayload';
  organizationFeeSetting: OrganizationFeeSetting;
};

/** Autogenerated input type of DeactivateOtpSecrets */
export type DeactivateOtpSecretsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeactivateOtpSecretsPayload = {
  __typename?: 'DeactivateOtpSecretsPayload';
  practitioner: Practitioner;
};

/** Autogenerated input type of DeactivatePractitioner */
export type DeactivatePractitionerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  practitionerId: Scalars['ID']['input'];
};

export type DeactivatePractitionerPayload = {
  __typename?: 'DeactivatePractitionerPayload';
  practitioner: Practitioner;
};

/** Autogenerated input type of DeleteAllowList */
export type DeleteAllowListInput = {
  allowListId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAllowListPayload = {
  __typename?: 'DeleteAllowListPayload';
  allowList: AllowList;
};

/** Autogenerated input type of DeleteFeature */
export type DeleteFeatureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureId: Scalars['ID']['input'];
};

export type DeleteFeaturePayload = {
  __typename?: 'DeleteFeaturePayload';
  feature: Feature;
};

/** Autogenerated input type of DeleteFeatureTargetGroup */
export type DeleteFeatureTargetGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureTargetGroupId: Scalars['ID']['input'];
};

export type DeleteFeatureTargetGroupPayload = {
  __typename?: 'DeleteFeatureTargetGroupPayload';
  featureTargetGroup: FeatureTargetGroup;
};

/** Autogenerated input type of DeleteFromFeatureTargetGroup */
export type DeleteFromFeatureTargetGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureTargetGroupId: Scalars['ID']['input'];
  featureTargetIds: Array<Scalars['ID']['input']>;
};

export type DeleteFromFeatureTargetGroupPayload = {
  __typename?: 'DeleteFromFeatureTargetGroupPayload';
  featureTargetGroup: FeatureTargetGroup;
};

/** Autogenerated input type of DeleteGuestPatientMedicationFollowupComment */
export type DeleteGuestPatientMedicationFollowupCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  guestPatientMedicationFollowupCommentId: Scalars['ID']['input'];
};

export type DeleteGuestPatientMedicationFollowupCommentPayload = {
  __typename?: 'DeleteGuestPatientMedicationFollowupCommentPayload';
  guestPatientMedicationFollowupComment: GuestPatientMedicationFollowupComment;
};

/** Autogenerated input type of DeleteIdFromFeatureTargetGroup */
export type DeleteIdFromFeatureTargetGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureTargetGroupId: Scalars['ID']['input'];
  featureTargetIds: Array<Scalars['ID']['input']>;
};

export type DeleteIdFromFeatureTargetGroupPayload = {
  __typename?: 'DeleteIdFromFeatureTargetGroupPayload';
  featureTargetGroup: FeatureTargetGroup;
};

/** Autogenerated input type of DeleteMedicationFollowupDraftMessage */
export type DeleteMedicationFollowupDraftMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  guestPatientId?: InputMaybe<Scalars['ID']['input']>;
  medicationFollowupDraftMessageId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteMedicationFollowupDraftMessagePayload = {
  __typename?: 'DeleteMedicationFollowupDraftMessagePayload';
  medicationFollowupDraftMessage?: Maybe<MedicationFollowupDraftMessage>;
};

/** Autogenerated input type of DeleteOperatorAuthority */
export type DeleteOperatorAuthorityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  operatorId: Scalars['ID']['input'];
  operatorRoleId: Scalars['ID']['input'];
};

export type DeleteOperatorAuthorityPayload = {
  __typename?: 'DeleteOperatorAuthorityPayload';
  operator: Operator;
};

/** Autogenerated input type of DeleteOperatorRole */
export type DeleteOperatorRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  operatorRoleId: Scalars['ID']['input'];
};

export type DeleteOperatorRolePayload = {
  __typename?: 'DeleteOperatorRolePayload';
  operatorRole: OperatorRole;
};

/** Autogenerated input type of DeleteOrganization */
export type DeleteOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type DeleteOrganizationPayload = {
  __typename?: 'DeleteOrganizationPayload';
  organization: Organization;
};

/** Autogenerated input type of DeleteOutpatientQuestionnaireSettingQuestionnaire */
export type DeleteOutpatientQuestionnaireSettingQuestionnaireInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  outpatientQuestionnaireSettingQuestionnaireId: Scalars['ID']['input'];
};

export type DeleteOutpatientQuestionnaireSettingQuestionnairePayload = {
  __typename?: 'DeleteOutpatientQuestionnaireSettingQuestionnairePayload';
  outpatientQuestionnaireSettingQuestionnaire: OutpatientQuestionnaireSettingQuestionnaire;
};

/** Autogenerated input type of DeletePatientAttachment */
export type DeletePatientAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  patientAttachmentId: Scalars['ID']['input'];
};

export type DeletePatientAttachmentPayload = {
  __typename?: 'DeletePatientAttachmentPayload';
  patientAttachment: PatientAttachment;
};

/** Autogenerated input type of DeletePatientMedicationFollowupComment */
export type DeletePatientMedicationFollowupCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  patientMedicationFollowupCommentId: Scalars['ID']['input'];
};

export type DeletePatientMedicationFollowupCommentPayload = {
  __typename?: 'DeletePatientMedicationFollowupCommentPayload';
  patientMedicationFollowupComment: PatientMedicationFollowupComment;
};

/** Autogenerated input type of DeleteTracingReportDraft */
export type DeleteTracingReportDraftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  guestPatientId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  tracingReportDraftId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteTracingReportDraftPayload = {
  __typename?: 'DeleteTracingReportDraftPayload';
  tracingReportDraft?: Maybe<TracingReportDraft>;
};

export type DescriptionCode = {
  __typename?: 'DescriptionCode';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type DirectVisitor = Node & {
  __typename?: 'DirectVisitor';
  active: Scalars['Boolean']['output'];
  birthDate: Scalars['ISO8601Date']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  medicationFollowupComments: GuestPatientMedicationFollowupCommentPage;
  medicationFollowupDraftMessages: MedicationFollowupDraftMessagePage;
  medicationFollowupMessages: MedicationFollowupMessagePage;
  medicationFollowupStatus?: Maybe<PatientMedicationFollowupStatus>;
  medixsPatient?: Maybe<MedixsPatient>;
  messageDeliverResults: MessageDeliverResultPage;
  mobilePhone: Scalars['String']['output'];
  /** Web問診 */
  outpatientQuestionnaireEntry?: Maybe<OutpatientQuestionnaireEntry>;
  phoneticFamilyName: Scalars['String']['output'];
  phoneticGivenName: Scalars['String']['output'];
  samePatient?: Maybe<Patient>;
  sex: Sex;
  tracingReportDrafts: TracingReportDraftPage;
  /** 発行済みのトレーシングレポート一覧 */
  tracingReports: TracingReportPage;
};


export type DirectVisitorMedicationFollowupCommentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type DirectVisitorMedicationFollowupDraftMessagesArgs = {
  onlyByCurrentPractitioner?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type DirectVisitorMedicationFollowupMessagesArgs = {
  onlyScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type DirectVisitorMessageDeliverResultsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type DirectVisitorTracingReportDraftsArgs = {
  onlyByCurrentPractitioner?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type DirectVisitorTracingReportsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type DirectVisitorCandidate = CheckinEntry | DirectVisitor;

export type DirectVisitorCandidatePage = {
  __typename?: 'DirectVisitorCandidatePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<DirectVisitorCandidate>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type DirectVisitorPage = {
  __typename?: 'DirectVisitorPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<DirectVisitor>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type DisclosedMedicineNote = HiccupOnetimeApiCache | HiccupTemporaryPermission;

export type DisclosedMedicineNotePage = {
  __typename?: 'DisclosedMedicineNotePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<DisclosedMedicineNote>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export const Dow = {
  Fri: 'fri',
  Mon: 'mon',
  Sat: 'sat',
  Sun: 'sun',
  Thu: 'thu',
  Tue: 'tue',
  Wed: 'wed'
} as const;

export type Dow = typeof Dow[keyof typeof Dow];
/** Autogenerated input type of DownloadClientCert */
export type DownloadClientCertInput = {
  clientCertId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadClientCertPayload = {
  __typename?: 'DownloadClientCertPayload';
  /** クライアント証明書データ（pfx形式） */
  certData: Scalars['String']['output'];
};

export type DraftAppointment = Node & {
  __typename?: 'DraftAppointment';
  appointment?: Maybe<Appointment>;
  cancellationReason?: Maybe<DraftAppointmentCancellationReason>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** 配達方法 */
  deliveryMethod: DraftAppointmentDeliveryMethod;
  /** 店舗用予約メモ */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  patient: Patient;
  /** 処方箋 */
  pfDispensingRequest?: Maybe<PfDispensingRequest>;
  previousStatus?: Maybe<DraftAppointmentStatus>;
  /** 問診 */
  questionnaires: Array<QuestionnaireSheetAnswer>;
  status: DraftAppointmentStatus;
  /** true=遠隔服薬指導 */
  telemedicine: Scalars['Boolean']['output'];
  /** 未読通知 */
  unreadOrganizationNotifications: Array<OrganizationNotification>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** http://hl7.org/fhir/valueset-appointment-cancellation-reason.html */
export const DraftAppointmentCancellationReason = {
  /** Other: Prep/Med/Results Unavailable */
  OthMu: 'oth_mu',
  /** Other */
  Other: 'other',
  /** Patient */
  Pat: 'pat',
  /** Patient: Canceled via Patient Portal */
  PatCpp: 'pat_cpp',
  /** Provider */
  Prov: 'prov'
} as const;

export type DraftAppointmentCancellationReason = typeof DraftAppointmentCancellationReason[keyof typeof DraftAppointmentCancellationReason];
/** 薬の配達方法 */
export const DraftAppointmentDeliveryMethod = {
  /** 薬局にてお渡し */
  Hand: 'hand',
  /** その他 */
  Other: 'other',
  /** その他宅配便 */
  Parcel: 'parcel',
  /** 当日受取配達 */
  SameDayDelivery: 'same_day_delivery'
} as const;

export type DraftAppointmentDeliveryMethod = typeof DraftAppointmentDeliveryMethod[keyof typeof DraftAppointmentDeliveryMethod];
export type DraftAppointmentPage = {
  __typename?: 'DraftAppointmentPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<DraftAppointment>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

/**
 * @startuml
 * title 医科調剤同時予約時の仮予約のステータス遷移
 * draft : 処方未確定
 * available : 処方箋待ち
 * wait_for_booking : 時間指定待ち
 * booked : 予約済み
 * cancelled : キャンセル
 * not_prescribed : 処方なし
 * finished: 完了
 *
 * [*] --> draft : アプリから仮予約
 * draft --> available : 医科で処方ありが選択された
 * available --> wait_for_booking : （FAXの場合）FAX受信後にPharmsから患者アプリへ時間指定依頼
 * available --> wait_for_booking : （アップロードの場合）医科で処方箋がアップロードされた
 * wait_for_booking --> booked : 患者がアプリから時間指定予約を確定した
 * draft --> not_prescribed : 医科で処方なしが選択された
 * available --> not_prescribed : 医科で処方なしに変更された
 * not_prescribed --> available : 医科で処方ありに変更された
 * draft --> cancelled : 薬局からキャンセルした
 * available --> cancelled : 薬局からキャンセルした
 * wait_for_booking --> cancelled : （アップロードの場合）患者がアプリからキャンセルした
 * wait_for_booking --> cancelled : （FAXの場合）薬局からキャンセルした
 * booked --> [*]: ASISの予約フローへ
 * available --> finished : 薬局から完了した
 * wait_for_booking --> finished : 薬局から完了した
 * @enduml
 */
export const DraftAppointmentStatus = {
  /** 処方箋共有待ち */
  Available: 'available',
  /** 予約済み */
  Booked: 'booked',
  /** キャンセル */
  Cancelled: 'cancelled',
  /** 処方未確定 */
  Draft: 'draft',
  /** 完了 */
  Finished: 'finished',
  /** 処方なし */
  NotPrescribed: 'not_prescribed',
  /** 時間指定待ち */
  WaitForBooking: 'wait_for_booking'
} as const;

export type DraftAppointmentStatus = typeof DraftAppointmentStatus[keyof typeof DraftAppointmentStatus];
/** Autogenerated input type of DumpOrganizations */
export type DumpOrganizationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

export type DumpOrganizationsPayload = {
  __typename?: 'DumpOrganizationsPayload';
  organizationImportJobInformation: OrganizationImportJobInformation;
};

/** Autogenerated input type of EditDirectVisitor */
export type EditDirectVisitorInput = {
  birthDate: Scalars['ISO8601Date']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  directVisitorId: Scalars['ID']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  mobilePhone: Scalars['String']['input'];
  phoneticFamilyName: Scalars['String']['input'];
  phoneticGivenName: Scalars['String']['input'];
  sex: Sex;
};

export type EditDirectVisitorPayload = {
  __typename?: 'EditDirectVisitorPayload';
  directVisitor: DirectVisitor;
};

export type Encounter = Node & {
  __typename?: 'Encounter';
  appointment: Appointment;
  id: Scalars['ID']['output'];
  /** 最後に通知を送った日時 */
  notifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  rawId: Scalars['ID']['output'];
  status: EncounterStatus;
};

/** http://hl7.org/fhir/valueset-encounter-status.html */
export const EncounterStatus = {
  /** キャンセル */
  Cancelled: 'cancelled',
  /** 診察完了 */
  Finished: 'finished',
  /** 診察中 */
  InProgress: 'in_progress'
} as const;

export type EncounterStatus = typeof EncounterStatus[keyof typeof EncounterStatus];
export type Event = GuestPatientMedicationFollowupComment | MedicationFollowupMessage | MedicationFollowupQuestionnaireSheet | PatientMedicationFollowupComment | TracingReport;

export type EventPage = {
  __typename?: 'EventPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<Event>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

/** Autogenerated input type of ExtendCompanySetupDocument */
export type ExtendCompanySetupDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companySetupDocumentId: Scalars['ID']['input'];
  expiresAt: Scalars['ISO8601DateTime']['input'];
};

export type ExtendCompanySetupDocumentPayload = {
  __typename?: 'ExtendCompanySetupDocumentPayload';
  companySetupDocument: CompanySetupDocument;
};

export type Extension = Node & {
  __typename?: 'Extension';
  code: ExtensionCode;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** 拡張機能識別コード */
export const ExtensionCode = {
  /** FAX送信 */
  SendFax: 'send_fax',
  /** Uber配達 */
  UberDirect: 'uber_direct'
} as const;

export type ExtensionCode = typeof ExtensionCode[keyof typeof ExtensionCode];
export type FaximoSendFax = Node & {
  __typename?: 'FaximoSendFax';
  createdAt: Scalars['ISO8601DateTime']['output'];
  faxNumber: Scalars['String']['output'];
  file?: Maybe<Blob>;
  id: Scalars['ID']['output'];
  organization: Organization;
  practitioner: Practitioner;
  status: FaximoSendFaxStatus;
  tracingReport?: Maybe<TracingReport>;
};

export type FaximoSendFaxPage = {
  __typename?: 'FaximoSendFaxPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<FaximoSendFax>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export const FaximoSendFaxStatus = {
  /** 送信失敗 */
  Failed: 'failed',
  /** 送信依頼中 */
  Processing: 'processing',
  /** 送信中 */
  Sending: 'sending',
  /** 送信成功 */
  Successed: 'successed'
} as const;

export type FaximoSendFaxStatus = typeof FaximoSendFaxStatus[keyof typeof FaximoSendFaxStatus];
export type Feature = Node & {
  __typename?: 'Feature';
  active: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  /** nilの場合は無限遠 */
  end?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** nilの場合は無限遠 */
  start?: Maybe<Scalars['ISO8601DateTime']['output']>;
  targetGroups: Array<FeatureTargetGroup>;
};

export type FeatureTarget = Company | Organization | Patient | Practitioner;

export type FeatureTargetGroup = Node & {
  __typename?: 'FeatureTargetGroup';
  end?: Maybe<Scalars['ISO8601DateTime']['output']>;
  feature: Feature;
  id: Scalars['ID']['output'];
  ids: Array<Scalars['ID']['output']>;
  start?: Maybe<Scalars['ISO8601DateTime']['output']>;
  type: FeatureTargetGroupType;
};

export const FeatureTargetGroupType = {
  Company: 'company',
  Organization: 'organization',
  Patient: 'patient',
  Practitioner: 'practitioner'
} as const;

export type FeatureTargetGroupType = typeof FeatureTargetGroupType[keyof typeof FeatureTargetGroupType];
export type FeatureUsage = Node & {
  __typename?: 'FeatureUsage';
  count: Scalars['Int']['output'];
  featureCode: PlanFeatureCode;
  id: Scalars['ID']['output'];
  kind: FeatureUsageKind;
  month: Scalars['Int']['output'];
  organization: Organization;
  year: Scalars['Int']['output'];
};

/** 従量課金利用実績の集計種別 */
export const FeatureUsageKind = {
  /** キャンセル */
  Cancel: 'cancel',
  /** FAX */
  Fax: 'fax',
  /** 機能コードと同じ */
  None: 'none',
  /** SMS */
  Sms: 'sms'
} as const;

export type FeatureUsageKind = typeof FeatureUsageKind[keyof typeof FeatureUsageKind];
export type FeatureUsagePage = {
  __typename?: 'FeatureUsagePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<FeatureUsage>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

/** 利用実績の種類 */
export const FeatureUsageType = {
  /** FAX送信実績 */
  Fax: 'fax',
  /** 受付実績 */
  Reception: 'reception',
  /** SMS送信実績 */
  Sms: 'sms'
} as const;

export type FeatureUsageType = typeof FeatureUsageType[keyof typeof FeatureUsageType];
export type FeeSetting = CompanyFeeSetting | OrganizationCompanyFeeSetting | OrganizationFeeSetting;

export type FeeSettingPage = {
  __typename?: 'FeeSettingPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<FeeSetting>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

/** Autogenerated input type of FetchMedixsReception */
export type FetchMedixsReceptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['String']['input']>;
};

export type FetchMedixsReceptionPayload = {
  __typename?: 'FetchMedixsReceptionPayload';
  medixsReceptions: Array<MedixsReception>;
};

/** Autogenerated input type of FinalizeDeliveryOutput */
export type FinalizeDeliveryOutputInput = {
  appointmentIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ステータスを完了に変更する */
  willFinished: Scalars['Boolean']['input'];
};

export type FinalizeDeliveryOutputPayload = {
  __typename?: 'FinalizeDeliveryOutputPayload';
  appointments: Array<Appointment>;
};

/** Autogenerated input type of FinishAppointment */
export type FinishAppointmentInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type FinishAppointmentPayload = {
  __typename?: 'FinishAppointmentPayload';
  appointment: Appointment;
};

/** Autogenerated input type of FinishCheckinEntry */
export type FinishCheckinEntryInput = {
  checkinEntryId?: InputMaybe<Scalars['ID']['input']>;
  checkinEntryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type FinishCheckinEntryPayload = {
  __typename?: 'FinishCheckinEntryPayload';
  checkinEntries?: Maybe<Array<CheckinEntry>>;
  checkinEntry?: Maybe<CheckinEntry>;
};

/** Autogenerated input type of FinishDraftAppointment */
export type FinishDraftAppointmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  draftAppointmentId: Scalars['ID']['input'];
};

export type FinishDraftAppointmentPayload = {
  __typename?: 'FinishDraftAppointmentPayload';
  draftAppointment: DraftAppointment;
};

/** Autogenerated input type of FinishEncounter */
export type FinishEncounterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  encounterId: Scalars['ID']['input'];
};

export type FinishEncounterPayload = {
  __typename?: 'FinishEncounterPayload';
  encounter: Encounter;
};

/** Autogenerated input type of FinishOutpatientQuestionnaireEntry */
export type FinishOutpatientQuestionnaireEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  outpatientQuestionnaireEntryId: Scalars['ID']['input'];
};

export type FinishOutpatientQuestionnaireEntryPayload = {
  __typename?: 'FinishOutpatientQuestionnaireEntryPayload';
  outpatientQuestionnaireEntry: OutpatientQuestionnaireEntry;
};

/** Autogenerated input type of FulfillAppointment */
export type FulfillAppointmentInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type FulfillAppointmentPayload = {
  __typename?: 'FulfillAppointmentPayload';
  encounter: Encounter;
};

export type GendaApiKey = Node & {
  __typename?: 'GendaApiKey';
  active: Scalars['Boolean']['output'];
  apiKey: Scalars['String']['output'];
  data: GendaApiKeyData;
  gendaSettings: GendaSettingPage;
  id: Scalars['ID']['output'];
};


export type GendaApiKeyGendaSettingsArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type GendaApiKeyData = {
  __typename?: 'GendaApiKeyData';
  /** 連携先 */
  partnerName?: Maybe<Scalars['String']['output']>;
};

export type GendaSetting = Node & {
  __typename?: 'GendaSetting';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  gendaApiKey: GendaApiKey;
  id: Scalars['ID']['output'];
  organization: Organization;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GendaSettingPage = {
  __typename?: 'GendaSettingPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<GendaSetting>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

/** Autogenerated input type of GenerateAgentArtifact */
export type GenerateAgentArtifactInput = {
  arch: AgentReleaseFileArch;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateAgentArtifactPayload = {
  __typename?: 'GenerateAgentArtifactPayload';
  agent: Agent;
};

/** Autogenerated input type of GenerateBookmarkedPatientsCountCsv */
export type GenerateBookmarkedPatientsCountCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type GenerateBookmarkedPatientsCountCsvPayload = {
  __typename?: 'GenerateBookmarkedPatientsCountCsvPayload';
  url: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateClientCertCsv */
export type GenerateClientCertCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

export type GenerateClientCertCsvPayload = {
  __typename?: 'GenerateClientCertCsvPayload';
  clientCertJobInformation: ClientCertJobInformation;
};

/** Autogenerated input type of GenerateCompanyMedicationFollowupMessageUsagesCsv */
export type GenerateCompanyMedicationFollowupMessageUsagesCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type GenerateCompanyMedicationFollowupMessageUsagesCsvPayload = {
  __typename?: 'GenerateCompanyMedicationFollowupMessageUsagesCsvPayload';
  url: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateCompanyOrganizationsAppDownloadUrlsCsv */
export type GenerateCompanyOrganizationsAppDownloadUrlsCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

export type GenerateCompanyOrganizationsAppDownloadUrlsCsvPayload = {
  __typename?: 'GenerateCompanyOrganizationsAppDownloadUrlsCsvPayload';
  url: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateCompanyReceptionUsagesCsv */
export type GenerateCompanyReceptionUsagesCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type GenerateCompanyReceptionUsagesCsvPayload = {
  __typename?: 'GenerateCompanyReceptionUsagesCsvPayload';
  url: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateCompanyReceptionsCsv */
export type GenerateCompanyReceptionsCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type GenerateCompanyReceptionsCsvPayload = {
  __typename?: 'GenerateCompanyReceptionsCsvPayload';
  url: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateCompanySalesDetailsCsv */
export type GenerateCompanySalesDetailsCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type GenerateCompanySalesDetailsCsvPayload = {
  __typename?: 'GenerateCompanySalesDetailsCsvPayload';
  url: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateCompanyTracingReportUsagesCsv */
export type GenerateCompanyTracingReportUsagesCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type GenerateCompanyTracingReportUsagesCsvPayload = {
  __typename?: 'GenerateCompanyTracingReportUsagesCsvPayload';
  url: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateCsvForClientCertsImport */
export type GenerateCsvForClientCertsImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

export type GenerateCsvForClientCertsImportPayload = {
  __typename?: 'GenerateCsvForClientCertsImportPayload';
  clientCertJobInformation: ClientCertJobInformation;
};

/** Autogenerated input type of GenerateCsvForMessageTemplatesBulkDuplicate */
export type GenerateCsvForMessageTemplatesBulkDuplicateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** CSV出力時に除外する店舗ID */
  sourceOrganizationId: Scalars['ID']['input'];
};

export type GenerateCsvForMessageTemplatesBulkDuplicatePayload = {
  __typename?: 'GenerateCsvForMessageTemplatesBulkDuplicatePayload';
  url: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateCsvForUberOrganizationSettingsUpsert */
export type GenerateCsvForUberOrganizationSettingsUpsertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

export type GenerateCsvForUberOrganizationSettingsUpsertPayload = {
  __typename?: 'GenerateCsvForUberOrganizationSettingsUpsertPayload';
  uberOrganizationSettingJobInformation: UberOrganizationSettingJobInformation;
};

/** Autogenerated input type of GenerateDeliveryCsv */
export type GenerateDeliveryCsvInput = {
  appointmentIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ステータスを完了に変更する */
  willFinished: Scalars['Boolean']['input'];
};

export type GenerateDeliveryCsvPayload = {
  __typename?: 'GenerateDeliveryCsvPayload';
  appointments: Array<Appointment>;
  url: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateIncentivePayoutNotification */
export type GenerateIncentivePayoutNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type GenerateIncentivePayoutNotificationPayload = {
  __typename?: 'GenerateIncentivePayoutNotificationPayload';
  url: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateOrganizationAuditEventCsv */
export type GenerateOrganizationAuditEventCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  month: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type GenerateOrganizationAuditEventCsvPayload = {
  __typename?: 'GenerateOrganizationAuditEventCsvPayload';
  url: Scalars['String']['output'];
};

/** Autogenerated input type of GeneratePayoutOrganizationsWithBankAccountCsv */
export type GeneratePayoutOrganizationsWithBankAccountCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  payoutId: Scalars['ID']['input'];
};

export type GeneratePayoutOrganizationsWithBankAccountCsvPayload = {
  __typename?: 'GeneratePayoutOrganizationsWithBankAccountCsvPayload';
  url: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateUberSignaturePreviewFormData */
export type GenerateUberSignaturePreviewFormDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inputData: UberSignatureDataInput;
};

export type GenerateUberSignaturePreviewFormDataPayload = {
  __typename?: 'GenerateUberSignaturePreviewFormDataPayload';
  /** 署名URL */
  url: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateUberSignaturePreview */
export type GenerateUberSignaturePreviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated input type of GenerateUberSignaturePreviewOnlyExtraText */
export type GenerateUberSignaturePreviewOnlyExtraTextInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateUberSignaturePreviewOnlyExtraTextPayload = {
  __typename?: 'GenerateUberSignaturePreviewOnlyExtraTextPayload';
  /** 署名URL */
  url: Scalars['String']['output'];
};

export type GenerateUberSignaturePreviewPayload = {
  __typename?: 'GenerateUberSignaturePreviewPayload';
  /** 署名URL */
  url: Scalars['String']['output'];
};

export type GuestPatient = DirectVisitor | WebVisitor;

export type GuestPatientMedicationFollowupComment = Node & {
  __typename?: 'GuestPatientMedicationFollowupComment';
  /** フォローアップコメント */
  comment: Scalars['String']['output'];
  /** コメント作成時間 */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** 送信者 */
  practitioner: Practitioner;
  /** コメント更新時間 */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GuestPatientMedicationFollowupCommentPage = {
  __typename?: 'GuestPatientMedicationFollowupCommentPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<GuestPatientMedicationFollowupComment>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type HiccupAppointmentPermission = Node & {
  __typename?: 'HiccupAppointmentPermission';
  /** 有効期限内であればtrue */
  active: Scalars['Boolean']['output'];
  appointment: Appointment;
  id: Scalars['ID']['output'];
};

export type HiccupOnetimeApiCache = Node & {
  __typename?: 'HiccupOnetimeApiCache';
  /** 有効期限内であればtrue */
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  expiresAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** ワンタイムコード */
  onetimeCode: Scalars['String']['output'];
  organization: Organization;
  patientProfile: HiccupOnetimeApiCachePatientProfile;
};

export type HiccupOnetimeApiCachePatientProfile = {
  __typename?: 'HiccupOnetimeApiCachePatientProfile';
  /** 氏名カナ */
  kana?: Maybe<Scalars['String']['output']>;
  /** 氏名 */
  name?: Maybe<Scalars['String']['output']>;
};

export type HiccupTemporaryPermission = Node & {
  __typename?: 'HiccupTemporaryPermission';
  /** 有効期限内であればtrue */
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  expiresAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** 既読であればtrue */
  isRead: Scalars['Boolean']['output'];
  organization: Organization;
  /** nullになることは無いはず */
  patient?: Maybe<Patient>;
};

export type HiccupTemporaryPermissionPage = {
  __typename?: 'HiccupTemporaryPermissionPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<HiccupTemporaryPermission>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type Holiday = {
  __typename?: 'Holiday';
  date: Scalars['ISO8601Date']['output'];
  name: Scalars['String']['output'];
};

/** Autogenerated input type of IdentifyMedixsPatient */
export type IdentifyMedixsPatientInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  medixsPatientId: Scalars['ID']['input'];
  medixsReceptionId: Scalars['ID']['input'];
  patientId: Scalars['ID']['input'];
};

export type IdentifyMedixsPatientPayload = {
  __typename?: 'IdentifyMedixsPatientPayload';
  medixsPatient: MedixsPatient;
  medixsReception: MedixsReception;
};

/** Autogenerated input type of IdentifyMedixsReception */
export type IdentifyMedixsReceptionInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  medixsReceptionId?: InputMaybe<Scalars['ID']['input']>;
};

export type IdentifyMedixsReceptionPayload = {
  __typename?: 'IdentifyMedixsReceptionPayload';
  medixsReception: MedixsReception;
};

/** Autogenerated input type of ImportClientCerts */
export type ImportClientCertsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  signedId: Scalars['ID']['input'];
};

export type ImportClientCertsPayload = {
  __typename?: 'ImportClientCertsPayload';
  clientCertJobInformation: ClientCertJobInformation;
};

/** Autogenerated input type of ImportOrganizations */
export type ImportOrganizationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  signedId: Scalars['ID']['input'];
};

export type ImportOrganizationsPayload = {
  __typename?: 'ImportOrganizationsPayload';
  organizationImportJobInformation: OrganizationImportJobInformation;
};

/** Autogenerated input type of ImportUberOrganizationsCsv */
export type ImportUberOrganizationsCsvInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** アップロード済みUber配達エリア反映CSVのSigned ID */
  signedId: Scalars['String']['input'];
};

export type ImportUberOrganizationsCsvPayload = {
  __typename?: 'ImportUberOrganizationsCsvPayload';
  uberOrganizationImportJobInformation: UberOrganizationImportJobInformation;
};

export type InvitationCode = Node & {
  __typename?: 'InvitationCode';
  accreteMessage?: Maybe<AccreteMessage>;
  appointment?: Maybe<Appointment>;
  /** 招待コード */
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** メモ */
  memo?: Maybe<Scalars['String']['output']>;
  /** 店舗ID */
  organizationId: Scalars['ID']['output'];
};

export type InvitationCodePage = {
  __typename?: 'InvitationCodePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<InvitationCode>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type Invoice = Node & {
  __typename?: 'Invoice';
  id: Scalars['ID']['output'];
  lineItems: Array<LineItem>;
  status: InvoiceStatus;
};

export const InvoiceStatus = {
  /** 会計済 */
  Balanced: 'balanced',
  /** キャンセル(返金済) */
  Cancelled: 'cancelled',
  /** 発行前 */
  Draft: 'draft',
  /** 発行済 */
  Issued: 'issued'
} as const;

export type InvoiceStatus = typeof InvoiceStatus[keyof typeof InvoiceStatus];
/** Autogenerated input type of IssueGendaApiKey */
export type IssueGendaApiKeyInput = {
  active: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 連携先の名前 */
  partnerName: Scalars['String']['input'];
};

export type IssueGendaApiKeyPayload = {
  __typename?: 'IssueGendaApiKeyPayload';
  gendaApiKey: GendaApiKey;
};

export const JobInformationStatus = {
  /** 失敗 */
  Failed: 'failed',
  /** 実行待ち */
  Pending: 'pending',
  /** 実行中 */
  Processing: 'processing',
  /** 成功 */
  Succeeded: 'succeeded'
} as const;

export type JobInformationStatus = typeof JobInformationStatus[keyof typeof JobInformationStatus];
export type LineItem = {
  __typename?: 'LineItem';
  /** 金額 */
  amount: Scalars['Int']['output'];
  /** 詳細 */
  chargeItems: Array<LineItemType>;
  /** 識別コード */
  code: LineItemCode;
  /** 連番 */
  sequence: Scalars['Int']['output'];
  /** 名称 */
  subject: Scalars['String']['output'];
};

export const LineItemCode = {
  /** 薬剤費 */
  BillingAmount: 'billing_amount',
  /** 配送料 */
  ShippingFee: 'shipping_fee',
  /** 当日配達利用料 */
  UberDeliveryFee: 'uber_delivery_fee'
} as const;

export type LineItemCode = typeof LineItemCode[keyof typeof LineItemCode];
export type LineItemType = {
  __typename?: 'LineItemType';
  /** 金額 */
  amount: Scalars['Int']['output'];
  /** 識別コード */
  code: LineItemCode;
  /** 連番 */
  sequence: Scalars['Int']['output'];
  /** 名称 */
  subject: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LoginUser = Operator | Practitioner;

/** Autogenerated input type of MarkAnnouncement */
export type MarkAnnouncementInput = {
  announcementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type MarkAnnouncementPayload = {
  __typename?: 'MarkAnnouncementPayload';
  announcement: Announcement;
};

/** Autogenerated input type of MarkHiccupTemporaryPermission */
export type MarkHiccupTemporaryPermissionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hiccupTemporaryPermissionId: Scalars['String']['input'];
};

export type MarkHiccupTemporaryPermissionPayload = {
  __typename?: 'MarkHiccupTemporaryPermissionPayload';
  hiccupTemporaryPermission: HiccupTemporaryPermission;
};

/** Autogenerated input type of MarkOrganizationNotificationByAppointment */
export type MarkOrganizationNotificationByAppointmentInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type MarkOrganizationNotificationByAppointmentPayload = {
  __typename?: 'MarkOrganizationNotificationByAppointmentPayload';
  organizationNotifications: Array<OrganizationNotification>;
};

/** Autogenerated input type of MarkOrganizationNotification */
export type MarkOrganizationNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationNotificationId: Scalars['ID']['input'];
};

export type MarkOrganizationNotificationPayload = {
  __typename?: 'MarkOrganizationNotificationPayload';
  organizationNotification: OrganizationNotification;
};

export type MedicalInstitutionSetting = Node & {
  __typename?: 'MedicalInstitutionSetting';
  attendingPhysicians: Array<Scalars['String']['output']>;
  clinicalDepartments: Array<Scalars['String']['output']>;
  contactPoint?: Maybe<ContactPoint>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  medicalInstitutionName: Scalars['String']['output'];
  organization: Organization;
  position: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MedicalInstitutionSettingPage = {
  __typename?: 'MedicalInstitutionSettingPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<MedicalInstitutionSetting>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type MedicationFollowupAutoReplySetting = Node & {
  __typename?: 'MedicationFollowupAutoReplySetting';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  questionnaireRevision?: Maybe<MedicationFollowupQuestionnaireRevision>;
};

export type MedicationFollowupAutoReplySettingTemplate = Node & {
  __typename?: 'MedicationFollowupAutoReplySettingTemplate';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  questionnaireRevision?: Maybe<MedicationFollowupQuestionnaireRevision>;
};

export type MedicationFollowupComment = GuestPatientMedicationFollowupComment | PatientMedicationFollowupComment;

export type MedicationFollowupCommentPage = {
  __typename?: 'MedicationFollowupCommentPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<MedicationFollowupComment>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type MedicationFollowupDraftMessage = Node & {
  __typename?: 'MedicationFollowupDraftMessage';
  data: MedicationFollowupDraftMessageData;
  guestPatient?: Maybe<GuestPatient>;
  id: Scalars['ID']['output'];
  patient?: Maybe<Patient>;
  practitioner: Practitioner;
};

export type MedicationFollowupDraftMessageData = {
  __typename?: 'MedicationFollowupDraftMessageData';
  /** 自動返信設定のメッセージ */
  autoReplySettingMessage?: Maybe<Scalars['String']['output']>;
  /** 自動返信設定の有無 */
  checkboxAutoReplySetting: Scalars['Boolean']['output'];
  /** 自動返信設定の質問票有無 */
  checkboxAutoReplySettingQuestionnaire: Scalars['Boolean']['output'];
  /** 受診勧奨設定の有無 */
  checkboxRecommendation: Scalars['Boolean']['output'];
  csClinic?: Maybe<CsClinic>;
  /** 日時指定ON/OFF */
  fixedDate: Scalars['Boolean']['output'];
  medicationFollowupQuestionnaire?: Maybe<MedicationFollowupQuestionnaire>;
  message?: Maybe<Scalars['String']['output']>;
  sendDate?: Maybe<Scalars['ISO8601Date']['output']>;
  sendTime?: Maybe<Scalars['String']['output']>;
};

export type MedicationFollowupDraftMessageDataInput = {
  /** 自動返信設定のメッセージ */
  autoReplySettingMessage?: InputMaybe<Scalars['String']['input']>;
  /** 自動返信設定の有無 */
  checkboxAutoReplySetting: Scalars['Boolean']['input'];
  /** 自動返信設定の質問票有無 */
  checkboxAutoReplySettingQuestionnaire: Scalars['Boolean']['input'];
  /** 受診勧奨設定の有無 */
  checkboxRecommendation: Scalars['Boolean']['input'];
  csClinicId?: InputMaybe<Scalars['String']['input']>;
  /** 日時指定ON/OFF */
  fixedDate: Scalars['Boolean']['input'];
  medicationFollowupQuestionnaireId?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sendDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  sendTime?: InputMaybe<Scalars['String']['input']>;
};

export type MedicationFollowupDraftMessagePage = {
  __typename?: 'MedicationFollowupDraftMessagePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<MedicationFollowupDraftMessage>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type MedicationFollowupMessage = Node & {
  __typename?: 'MedicationFollowupMessage';
  appointment?: Maybe<Appointment>;
  autoReplySetting?: Maybe<MedicationFollowupAutoReplySetting>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  csClinic?: Maybe<CsClinic>;
  directVisitor?: Maybe<DirectVisitor>;
  id: Scalars['ID']['output'];
  /** 自動返信のメッセージかどうか */
  isAutoReplyMessage: Scalars['Boolean']['output'];
  /** 回答を既読であればtrue */
  isRead: Scalars['Boolean']['output'];
  medicationFollowupQuestionnaireRevision?: Maybe<MedicationFollowupQuestionnaireRevision>;
  medicationFollowupQuestionnaireSheet?: Maybe<MedicationFollowupQuestionnaireSheet>;
  message: Scalars['String']['output'];
  messageDeliverResult?: Maybe<MessageDeliverResult>;
  patient?: Maybe<Patient>;
  practitioner: Practitioner;
  sendAt: Scalars['ISO8601DateTime']['output'];
  status: MedicationFollowupMessageStatus;
  webVisitor?: Maybe<WebVisitor>;
};

/** 添付項目 */
export const MedicationFollowupMessageAttachment = {
  /** 病院・診療所の紹介 */
  Clinic: 'clinic',
  /** 質問票 */
  QuestionnaireSheet: 'questionnaire_sheet'
} as const;

export type MedicationFollowupMessageAttachment = typeof MedicationFollowupMessageAttachment[keyof typeof MedicationFollowupMessageAttachment];
export type MedicationFollowupMessagePage = {
  __typename?: 'MedicationFollowupMessagePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<MedicationFollowupMessage>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export const MedicationFollowupMessageStatus = {
  /** 送信キャンセル */
  Cancelled: 'cancelled',
  /** 送信前 */
  Scheduled: 'scheduled',
  /** 送信済 */
  Sent: 'sent'
} as const;

export type MedicationFollowupMessageStatus = typeof MedicationFollowupMessageStatus[keyof typeof MedicationFollowupMessageStatus];
export type MedicationFollowupMessageTemplate = Node & {
  __typename?: 'MedicationFollowupMessageTemplate';
  active: Scalars['String']['output'];
  autoReplySettingTemplate?: Maybe<MedicationFollowupAutoReplySettingTemplate>;
  csClinic?: Maybe<CsClinic>;
  id: Scalars['ID']['output'];
  medicationFollowupQuestionnaire?: Maybe<MedicationFollowupQuestionnaire>;
  message: Scalars['String']['output'];
  organization: Organization;
  position: Scalars['Int']['output'];
  /** 時分のみが有効な値。その他の値（年月日と秒）は使用しないこと */
  sendTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 服薬指導終了何日後に送信 */
  sendTiming?: Maybe<Scalars['Int']['output']>;
  subject: Scalars['String']['output'];
  /** 病院・診療所の紹介あり=true */
  withRecommendation: Scalars['Boolean']['output'];
};

export type MedicationFollowupMessageTemplateJobInformation = Node & {
  __typename?: 'MedicationFollowupMessageTemplateJobInformation';
  /** 前回反映日 */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** エラーメッセージ */
  errorMessages: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 参照元店舗 */
  sourceOrganization: Organization;
  /** メッセージテンプレート一括反映ジョブのステータス */
  status: JobInformationStatus;
};

export type MedicationFollowupMessageTemplatePage = {
  __typename?: 'MedicationFollowupMessageTemplatePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<MedicationFollowupMessageTemplate>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type MedicationFollowupQuestionnaire = Node & {
  __typename?: 'MedicationFollowupQuestionnaire';
  active: Scalars['Boolean']['output'];
  /** デフォルト質問票判定フラグ */
  default: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  position: Scalars['Int']['output'];
  revision: MedicationFollowupQuestionnaireRevision;
};

export type MedicationFollowupQuestionnaireChoice = {
  __typename?: 'MedicationFollowupQuestionnaireChoice';
  goto?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  /** trueの場合は追加テキスト入力が必要 */
  text: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type MedicationFollowupQuestionnaireChoiceInput = {
  goto?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  /** trueの場合は追加テキスト入力が必要 */
  text: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
};

export type MedicationFollowupQuestionnaireCondition = {
  __typename?: 'MedicationFollowupQuestionnaireCondition';
  /** 質問のラベル */
  label: Scalars['String']['output'];
  /** 選択肢の値 */
  value: Scalars['String']['output'];
};

export type MedicationFollowupQuestionnaireConditionInput = {
  /** 質問のラベル */
  label: Scalars['String']['input'];
  /** 選択肢の値 */
  value: Scalars['String']['input'];
};

export type MedicationFollowupQuestionnaireFormData = {
  __typename?: 'MedicationFollowupQuestionnaireFormData';
  active: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  sections: Array<MedicationFollowupQuestionnaireSection>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MedicationFollowupQuestionnaireFormDataInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  sections: Array<MedicationFollowupQuestionnaireSectionInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MedicationFollowupQuestionnairePage = {
  __typename?: 'MedicationFollowupQuestionnairePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<MedicationFollowupQuestionnaire>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type MedicationFollowupQuestionnaireQuestion = {
  __typename?: 'MedicationFollowupQuestionnaireQuestion';
  choices?: Maybe<Array<MedicationFollowupQuestionnaireChoice>>;
  conditions?: Maybe<Array<MedicationFollowupQuestionnaireCondition>>;
  label?: Maybe<Scalars['String']['output']>;
  /** trueの場合はその他という選択肢を表示 */
  other: Scalars['Boolean']['output'];
  otherGoto: Scalars['Boolean']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  questionType: MedicationFollowupQuestionnaireQuestionType;
  required: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type MedicationFollowupQuestionnaireQuestionInput = {
  choices?: InputMaybe<Array<MedicationFollowupQuestionnaireChoiceInput>>;
  conditions?: InputMaybe<Array<MedicationFollowupQuestionnaireConditionInput>>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** trueの場合はその他という選択肢を表示 */
  other?: InputMaybe<Scalars['Boolean']['input']>;
  otherGoto?: InputMaybe<Scalars['Boolean']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  questionType: MedicationFollowupQuestionnaireQuestionType;
  required: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

/** 質問形式 */
export const MedicationFollowupQuestionnaireQuestionType = {
  /** チェックボックス */
  Check: 'check',
  /** ラジオボタン */
  Radio: 'radio',
  /** テキストボックス */
  Text: 'text'
} as const;

export type MedicationFollowupQuestionnaireQuestionType = typeof MedicationFollowupQuestionnaireQuestionType[keyof typeof MedicationFollowupQuestionnaireQuestionType];
export type MedicationFollowupQuestionnaireRevision = Node & {
  __typename?: 'MedicationFollowupQuestionnaireRevision';
  active: Scalars['Boolean']['output'];
  formData: MedicationFollowupQuestionnaireFormData;
  id: Scalars['ID']['output'];
  medicationFollowupQuestionnaire: MedicationFollowupQuestionnaire;
  subject: Scalars['String']['output'];
};

export type MedicationFollowupQuestionnaireSection = {
  __typename?: 'MedicationFollowupQuestionnaireSection';
  goto?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  questions: Array<MedicationFollowupQuestionnaireQuestion>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MedicationFollowupQuestionnaireSectionInput = {
  goto?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  questions: Array<MedicationFollowupQuestionnaireQuestionInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MedicationFollowupQuestionnaireSheet = Node & {
  __typename?: 'MedicationFollowupQuestionnaireSheet';
  /** 回答 */
  answers: Array<QuestionnaireSheetAnswer>;
  appointment?: Maybe<Appointment>;
  /** 回答日時 */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  medicationFollowupMessage: MedicationFollowupMessage;
};

export type MedicationFollowupQuestionnaireSheetPage = {
  __typename?: 'MedicationFollowupQuestionnaireSheetPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<MedicationFollowupQuestionnaireSheet>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type MedicationFollowupSetting = Node & {
  __typename?: 'MedicationFollowupSetting';
  id: Scalars['ID']['output'];
  organization: Organization;
  statusManagement: Scalars['Boolean']['output'];
};

export type MedicationFollowupUsage = {
  __typename?: 'MedicationFollowupUsage';
  /** 質問票への回答の件数 */
  answerCount: Scalars['Int']['output'];
  /** フォローアップメッセージの送信件数（アプリ） */
  appMessageCount: Scalars['Int']['output'];
  /** フォローアップメッセージの送信件数 */
  messageCount: Scalars['Int']['output'];
  organization: Organization;
  /** 質問票ありのフォローアップメッセージの件数 */
  questionnaireSheetCount: Scalars['Int']['output'];
  /** フォローアップメッセージの送信件数（SMS） */
  smsMessageCount: Scalars['Int']['output'];
  /** 質問票への回答の未読件数 */
  unreadCount: Scalars['Int']['output'];
};

export type MedicationFollowupUsagePage = {
  __typename?: 'MedicationFollowupUsagePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<MedicationFollowupUsage>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type Medicine = {
  __typename?: 'Medicine';
  /** 商品名 */
  productName: Scalars['String']['output'];
  /** YJコード */
  yjCode: Scalars['String']['output'];
};

/**
 * #### ドキュメント
 * JAHISお薬手帳データ
 */
export type MedicineNote = {
  __typename?: 'MedicineNote';
  /** @gotags: jahis:"record_group=4" */
  notebookMemo?: Maybe<MedicineNoteNotebookMemo>;
  /** @gotags: jahis:"record_group=3" */
  otcDrugDosage?: Maybe<MedicineNoteOtcDrugDosage>;
  /** @gotags: jahis:"record_group=1 2" */
  patient?: Maybe<MedicineNotePatient>;
  /** @gotags: jahis:"record_group=5 11 15 51 55 201 281 291 301 311 391 401 411 421 501 601" validate:"dive,required" */
  prescriptions?: Maybe<Array<MedicineNotePrescription>>;
  /** @gotags: jahis:"record_group=701" */
  primaryPharmacist?: Maybe<MedicineNotePrimaryPharmacist>;
  /** @gotags: jahis:"record_group=911" */
  splitControl?: Maybe<MedicineNoteSplitControl>;
  /** @gotags: jahis:"version_record_group" */
  version?: Maybe<MedicineNoteVersion>;
};

/** 処方-医療機関情報 */
export type MedicineNoteClinic = {
  __typename?: 'MedicineNoteClinic';
  /** @gotags: jahis:"record=51" */
  clinicRecord?: Maybe<MedicineNoteClinicRecord>;
};

/** 51. 処方-医療機関レコード */
export type MedicineNoteClinicRecord = {
  __typename?: 'MedicineNoteClinicRecord';
  /**
   * 医療機関コード X.7
   * バージョンレコードの出力区分が　1:医療機関=>患者 の場合は必須
   * @gotags: jahis:"field=4" validate:"omitempty,jahis_type_x,jahis_fixed_bytes=7"
   */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=5" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  /**
   * 医療機関名称 N.120
   * @gotags: jahis:"field=1" validate:"required,jahis_type_n,jahis_max_bytes=120"
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * 医療機関都道府県 X.2
   * バージョンレコードの出力区分が　1:医療機関=>患者 の場合は必須
   * @gotags: jahis:"field=2" validate:"omitempty,jahis_type_x,jahis_prefecture_code"
   */
  prefecture?: Maybe<Scalars['String']['output']>;
  /**
   * 医療機関点数表 X.1
   * * 1:医科
   * * 3:歯科
   * バージョンレコードの出力区分が　1:医療機関=>患者 の場合は必須
   * @gotags: jahis:"field=3" validate:"omitempty,jahis_type_x,oneof=1 3"
   */
  tensu?: Maybe<Scalars['String']['output']>;
};

/** 5. 調剤等年月日レコード */
export type MedicineNoteDispensingDateRecord = {
  __typename?: 'MedicineNoteDispensingDateRecord';
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=2" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  /**
   * 調剤等年月日 X.8
   * 薬局で調剤を行い出力する場合は「調剤年 月日」を記録し、医療機関で調剤を行い出力する場合は「処方年月日」を記録
   * 医薬品等の提供を行わずに、医療機関・薬局から患者等に情報を提供する場合には、情報提供を行った年月日を記録
   * @gotags: jahis:"field=1" validate:"required,jahis_type_x,jahis_date"
   */
  date?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** 調剤-医療機関情報 */
export type MedicineNoteDispensingPharmacy = {
  __typename?: 'MedicineNoteDispensingPharmacy';
  /** @gotags: jahis:"record=5" */
  dispensingDateRecord?: Maybe<MedicineNoteDispensingDateRecord>;
  /** @gotags: jahis:"record=15" */
  pharmacistRecord?: Maybe<MedicineNotePharmacistRecord>;
  /** @gotags: jahis:"record=11" */
  pharmacyRecord?: Maybe<MedicineNotePharmacyRecord>;
};

/** 処方-医師情報 */
export type MedicineNoteDoctor = {
  __typename?: 'MedicineNoteDoctor';
  /** @gotags: jahis:"record=55" */
  doctorRecord?: Maybe<MedicineNoteDoctorRecord>;
};

/** 55. 処方-医師レコード */
export type MedicineNoteDoctorRecord = {
  __typename?: 'MedicineNoteDoctorRecord';
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=3" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  /**
   * 診療科名 N.80
   * @gotags: jahis:"field=2" validate:"omitempty,jahis_type_n,jahis_max_bytes=80"
   */
  departmentName?: Maybe<Scalars['String']['output']>;
  /**
   * 医師氏名 N.40
   * 医師氏名(全角半角混在可)
   * 出来る限り姓と名の間に空白を1桁入れて、それ以外の空白は詰めて記録
   * 当レコード以降、次に処方-医師レコードが出現するまでの間の「RP内薬品情報グループ」「RP内用法情報グループ」は、当レコードに記録された医師により処方されたとみなす。
   * @gotags: jahis:"field=1" validate:"required,jahis_type_n,jahis_max_bytes=40"
   */
  name?: Maybe<Scalars['String']['output']>;
};

/** 用法情報 */
export type MedicineNoteDosage = {
  __typename?: 'MedicineNoteDosage';
  /** @gotags: jahis:"record=311" validate:"dive,required" */
  dosagePlusRecords?: Maybe<Array<MedicineNoteDosagePlusRecord>>;
  /** @gotags: jahis:"record=301" */
  dosageRecord?: Maybe<MedicineNoteDosageRecord>;
};

/** 処方服用注意情報 */
export type MedicineNoteDosageCaution = {
  __typename?: 'MedicineNoteDosageCaution';
  /** @gotags: jahis:"record=391" validate:"dive,required" */
  dosageCautionRecords?: Maybe<Array<MedicineNoteDosageCautionRecord>>;
};

/** 391. 処方服用注意レコード */
export type MedicineNoteDosageCautionRecord = {
  __typename?: 'MedicineNoteDosageCautionRecord';
  /**
   * 内容 N.400
   * @gotags: jahis:"field=2" validate:"required,jahis_type_n,jahis_max_bytes=400"
   */
  content?: Maybe<Scalars['String']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=3" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  /**
   * RP番号 9.3
   * @gotags: jahis:"field=1" validate:"required,min=1,max=999"
   */
  rpNumber?: Maybe<Scalars['Int']['output']>;
};

/** 311. 用法補足レコード */
export type MedicineNoteDosagePlusRecord = {
  __typename?: 'MedicineNoteDosagePlusRecord';
  /**
   * 用法補足情報 N.100
   * @gotags: jahis:"field=2" validate:"required,jahis_type_n,jahis_max_bytes=100"
   */
  content?: Maybe<Scalars['String']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=3" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  /**
   * RP番号 9.3
   * @gotags: jahis:"field=1" validate:"required,min=1,max=999"
   */
  rpNumber?: Maybe<Scalars['Int']['output']>;
};

/** 301. 用法レコード */
export type MedicineNoteDosageRecord = {
  __typename?: 'MedicineNoteDosageRecord';
  /**
   * 調剤数量 9.3
   * * 内服:投与日数
   * * 内滴:「1」固定
   * * 屯服:投 与回数
   * * 外用:「1」固定
   * * 注射「1」固定
   * * 浸煎薬:投与日数
   * * 湯薬:投与日数
   * * 材料:「1」 固定
   * * その他:「1」固定
   * ※浸煎薬・湯薬を屯服として調剤した場合は「投与回数」を記録する。
   * ※医療機関で浸煎薬・湯薬が判断できない場合は、内服または屯服として記録
   * ※医療機関で内服滴剤が判断できない場合は内服として記録
   * バージョンレコードの出力区分が　1:医療機関=>患者 の場合は必須
   * @gotags: jahis:"field=3,omitempty" validate:"omitempty,min=1,max=999"
   */
  amount?: Maybe<Scalars['Int']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=8" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  /**
   * 剤形コード X.2
   * 該当する剤形コード(別表4)を記録
   * * 1:内服
   * * 2:内滴
   * * 3:屯服
   * * 4:注射
   * * 5:外用
   * * 6:浸煎
   * * 7:湯
   * * 9:材料
   * * 10:その他
   * 非保険薬、保険外あるいは医療機関で剤形が判断できない場合は「10.その他」として記録
   * ※医療機関で浸煎薬・湯薬が判断できない場合は、内服または屯服として記録
   * ※医療機関で内服滴剤が判断できない場合は内服として記録
   * バージョンレコードの出力区分が　1:医療機関=>患者 の場合は必須
   * @gotags: jahis:"field=5" validate:"omitempty,jahis_type_x,jahis_form_code"
   */
  formCode?: Maybe<Scalars['String']['output']>;
  /**
   * 用法名称 N.100
   * ※薬局が出力する場合には、剤形コードが「材料」、「その他」の場合を除き必須出力とする。医療機関のシステムにおいて、出力が困難な場合は省略可とする。
   * @gotags: jahis:"field=2" validate:"omitempty,jahis_type_n,jahis_max_bytes=100"
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * RP番号 9.3
   * @gotags: jahis:"field=1" validate:"required,min=1,max=999"
   */
  rpNumber?: Maybe<Scalars['Int']['output']>;
  /**
   * 調剤単位 N.100
   * * 内服:日分
   * * 内滴:調剤
   * * 屯服:回分
   * * 注射: 調剤
   * * 外用:調剤
   * * 浸煎:日分
   * * 湯薬:日分
   * * 材料:調剤
   * * その他:調剤
   * ※浸煎薬・湯薬を屯服として調剤した場合は「回分」を記録する。
   * ※医療機関で浸煎薬・湯薬が判断できない場合は、内服または屯服として記録
   * ※医療機関で内服滴剤が判断できない場合は内服として記録
   * バージョンレコードの出力区分が　1:医療機関=>患者 の場合は必須
   * @gotags: jahis:"field=4" validate:"omitempty,jahis_type_n,jahis_max_bytes=100"
   */
  unit?: Maybe<Scalars['String']['output']>;
  /**
   * 用法コード X.16
   * バージョンレコードの出力区分が　1:医療機関=>患者 の場合は必須
   * 上記種別に対応した用法コード「用法コード種別」が「1.コードなし」の場合は省略する。
   * @gotags: jahis:"field=7" validate:"omitempty,jahis_type_x,jahis_max_bytes=16"
   */
  usageCode?: Maybe<Scalars['String']['output']>;
  /**
   * 用法コード種別 9.1
   * * 1:コードなし
   * * 2:JAMI用法コード
   * * 3~:将来統一コードを想定
   * ※「JAMI用法コード」とは日本医療情報学会標準である「処方・注射オーダ標準用法規格」にて定められたコード体系である。
   * バージョンレコードの出力区分が　1:医療機関=>患者 の場合は必須
   * @gotags: jahis:"field=6,omitempty" validate:"omitempty,min=1,max=9"
   */
  usageCodeType?: Maybe<Scalars['Int']['output']>;
};

/** 薬品情報 */
export type MedicineNoteMedicine = {
  __typename?: 'MedicineNoteMedicine';
  /** @gotags: jahis:"record=291" validate:"dive,required" */
  medicineCautionRecords?: Maybe<Array<MedicineNoteMedicineCautionRecord>>;
  /** @gotags: jahis:"record=281" validate:"dive,required" */
  medicinePlusRecords?: Maybe<Array<MedicineNoteMedicinePlusRecord>>;
  /** @gotags: jahis:"record=201" */
  medicineRecord?: Maybe<MedicineNoteMedicineRecord>;
};

/** 291. 薬品服用注意レコード */
export type MedicineNoteMedicineCautionRecord = {
  __typename?: 'MedicineNoteMedicineCautionRecord';
  /**
   * 内容 N.400
   * @gotags: jahis:"field=2" validate:"required,jahis_type_n,jahis_max_bytes=400"
   */
  content?: Maybe<Scalars['String']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=3" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  /**
   * RP番号 9.3
   * @gotags: jahis:"field=1" validate:"required,min=1,max=999"
   */
  rpNumber?: Maybe<Scalars['Int']['output']>;
};

/** 281. 薬品補足レコード */
export type MedicineNoteMedicinePlusRecord = {
  __typename?: 'MedicineNoteMedicinePlusRecord';
  /**
   * 内容 N.400
   * @gotags: jahis:"field=2" validate:"required,jahis_type_n,jahis_max_bytes=100"
   */
  content?: Maybe<Scalars['String']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=3" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  /**
   * RP番号 9.3
   * @gotags: jahis:"field=1" validate:"required,min=1,max=999"
   */
  rpNumber?: Maybe<Scalars['Int']['output']>;
};

/** 201. 薬品レコード */
export type MedicineNoteMedicineRecord = {
  __typename?: 'MedicineNoteMedicineRecord';
  /**
   * 用量 X.12
   * * 内服:1日量
   * * 内滴:全量
   * * 屯服:1回量
   * * 外用:全量
   * * 注射:全量
   * * 浸煎薬:1日量
   * * 湯薬:1日量
   * * 材料:全量
   * * その他:全量
   * ※浸煎薬・湯薬を屯服として調剤した場合 は「1 回量」を記録する。
   * ※医療機関で浸煎薬・湯薬が判断できない 場合は、内服または屯服として記録
   * ※医療機関で内服滴剤が判断できない場合 は内服として記録
   * 整数 6 桁+小数点+小数 5 桁
   * 整数の前 ZERO 及び小数の後 ZERO は省略、 小数 ZERO なら小数点も省略、整数 ZERO な らZEROを1桁残す
   * 最大桁数出力例:123456.78901
   * 整数のみ出力例:100
   * 小数のみ出力例:0.25
   * 混在出力例:1.5
   * @gotags: jahis:"field=3" validate:"required,jahis_type_x,jahis_decimal=11 5"
   */
  amount?: Maybe<Scalars['String']['output']>;
  /**
   * 薬品コード X.13
   * 上記種別に対応した薬品コード「薬品コード種別」が「1.コードなし」の場合は、省略する。
   * バージョンレコードの出力区分が　1:医療機関=>患者 の場合は必須
   * @gotags: jahis:"field=6" validate:"omitempty,jahis_type_x,jahis_max_bytes=13"
   */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=7" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  genericCode?: Maybe<Scalars['String']['output']>;
  genericCodeType?: Maybe<Scalars['Int']['output']>;
  genericName?: Maybe<Scalars['String']['output']>;
  /**
   * 薬品名称 N.120
   * @gotags: jahis:"field=2" validate:"required,jahis_type_n,jahis_max_bytes=120"
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * RP番号 9.3
   * @gotags: jahis:"field=1" validate:"required,min=1,max=999"
   */
  rpNumber?: Maybe<Scalars['Int']['output']>;
  /**
   * 薬品コード種別 9.1
   * * 1:コードなし
   * * 2:レセプト電算コード
   * * 3:厚労省コー ド
   * * 4:YJコード
   * * 6:HOTコード
   * バージョンレコードの出力区分が　1:医療機関=>患者 の場合は必須
   * @gotags: jahis:"field=5,omitempty" validate:"omitempty,oneof=1 2 3 4 6"
   */
  type?: Maybe<Scalars['Int']['output']>;
  /**
   * 単位名 N.12
   * @gotags: jahis:"field=4" validate:"required,jahis_type_n,jahis_max_bytes=12"
   */
  unitName?: Maybe<Scalars['String']['output']>;
};

/** お薬手帳メモ情報 */
export type MedicineNoteNotebookMemo = {
  __typename?: 'MedicineNoteNotebookMemo';
  /** @gotags: jahis:"record=4" validate:"dive,required" */
  notebookMemoRecords?: Maybe<Array<MedicineNoteNotebookMemoRecord>>;
};

/** 4. 手帳メモレコード */
export type MedicineNoteNotebookMemoRecord = {
  __typename?: 'MedicineNoteNotebookMemoRecord';
  /**
   * 手帳メモ情報 N.400
   * @gotags: jahis:"field=1" validate:"required,jahis_type_n,jahis_max_bytes=400"
   */
  content?: Maybe<Scalars['String']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=3" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  /**
   * メモ入力年月日 X.8
   * @gotags: jahis:"field=2" validate:"omitempty,jahis_type_x,jahis_date"
   */
  enteredAt?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** 一般用医薬品服用情報 */
export type MedicineNoteOtcDrugDosage = {
  __typename?: 'MedicineNoteOtcDrugDosage';
  /** @gotags: jahis:"record=3" validate:"dive,required" */
  otcDrugDosagesRecords?: Maybe<Array<MedicineNoteOtcDrugDosageRecord>>;
  otcDrugIngredientRecords?: Maybe<Array<MedicineNoteOtcDrugIngredientRecord>>;
};

/** 3. 一般用医薬品服用レコード */
export type MedicineNoteOtcDrugDosageRecord = {
  __typename?: 'MedicineNoteOtcDrugDosageRecord';
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=4" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  dosageRecordNumber?: Maybe<Scalars['Int']['output']>;
  /**
   * 服用終了年月日 X.8
   * @gotags: jahis:"field=3" validate:"omitempty,jahis_type_x,jahis_date"
   */
  end?: Maybe<Scalars['ISO8601Date']['output']>;
  janCode?: Maybe<Scalars['String']['output']>;
  /**
   * 薬品名称 N.120
   * @gotags: jahis:"field=1" validate:"required,jahis_type_n,jahis_max_bytes=120"
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * 服用開始年月日 X.8
   * @gotags: jahis:"field=2" validate:"omitempty,jahis_type_x,jahis_date"
   */
  start?: Maybe<Scalars['ISO8601Date']['output']>;
};

export type MedicineNoteOtcDrugIngredientRecord = {
  __typename?: 'MedicineNoteOtcDrugIngredientRecord';
  code?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<Scalars['Int']['output']>;
  dosageRecordNumber?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
};

/** 患者基本情報 */
export type MedicineNotePatient = {
  __typename?: 'MedicineNotePatient';
  /** @gotags: jahis:"record=1" */
  patientRecord?: Maybe<MedicineNotePatientRecord>;
  /** @gotags: jahis:"record=2" validate:"dive,required" */
  patientReportRecords?: Maybe<Array<MedicineNotePatientReportRecord>>;
};

/**
 * PF患者と基盤DBでマスタ管理された情報を返す
 *  - 手帳メモ
 *  - 患者特記
 *  - かかりつけ薬剤師
 */
export type MedicineNotePatientProfile = {
  __typename?: 'MedicineNotePatientProfile';
  /** 基盤DBでマスタ管理された手帳メモレコード */
  notebookMemoRecords: Array<MedicineNoteNotebookMemoRecord>;
  /** 基盤DBでマスタ管理された患者特記レコード */
  patientReportRecords: Array<MedicineNotePatientReportRecord>;
  pfPatient?: Maybe<PfPatient>;
  /** 基盤DBでマスタ管理されたかかりつけ薬剤師レコード */
  primaryPharmacistRecords: Array<MedicineNotePrimaryPharmacistRecord>;
};

/** 1. 患者情報レコード */
export type MedicineNotePatientRecord = {
  __typename?: 'MedicineNotePatientRecord';
  /**
   * 患者住所 N.800
   * @gotags: jahis:"field=5" validate:"omitempty,jahis_type_n,jahis_max_bytes=800"
   */
  address?: Maybe<Scalars['String']['output']>;
  /**
   * 患者生年月日 X.8
   * @gotags: jahis:"field=3" validate:"required,jahis_type_x,jahis_date"
   */
  birthDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * 血液型 N.20
   * @gotags: jahis:"field=8"  validate:"omitempty,jahis_type_n,jahis_max_bytes=20"
   */
  bloodType?: Maybe<Scalars['String']['output']>;
  /**
   * 患者緊急連絡先 N.800
   * @gotags: jahis:"field=7"  validate:"omitempty,jahis_type_n,jahis_max_bytes=800"
   */
  emergency?: Maybe<Scalars['String']['output']>;
  /**
   * 患者氏名カナ N.40
   * 全角、半角、ひらがな、カタカナの混在は不可。
   * 出来る限り姓と名の間に空白を1桁入れて、 それ以外の空白は詰めて記録
   * ※外国人の場合など姓と名の区別がない場合や、ミドルネームがある場合においては、この限りではなく、「空白なし」および「複数の空白」での記録も可とする。
   * @gotags: jahis:"field=10" validate:"omitempty,jahis_type_n,jahis_max_bytes=40,jahis_jahistc_patient_kana"
   */
  kana?: Maybe<Scalars['String']['output']>;
  /**
   * 患者氏名 N.40
   * 全角、半角の混在は不可
   * 出来る限り姓と名の間に空白を1桁入れて、それ以外の空白は詰めて記録
   * ※外国人の場合など姓と名の区別がない場合や、ミドルネームがある場合においては、この限りではなく、「空白なし」および「複数の空白」での記録も可とする。
   * ※患者氏名に外字が含まれる場合は、全てカナで記録する。
   * @gotags: jahis:"field=1" validate:"required,jahis_type_n,jahis_max_bytes=40,hankaku|zenkaku"
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * 患者郵便番号 X.8
   * @gotags: jahis:"field=4" validate:"omitempty,jahis_type_x,jahis_postal_code"
   */
  postalCode?: Maybe<Scalars['String']['output']>;
  /**
   * 患者性別 9.1
   * * 1:男
   * * 2:女
   * @gotags: jahis:"field=2" validate:"required,oneof=1 2"
   */
  sex?: Maybe<Scalars['Int']['output']>;
  /**
   * 患者電話番号 X.13
   * @gotags: jahis:"field=6" validate:"omitempty,jahis_type_x,jahis_max_bytes=13"
   */
  tel?: Maybe<Scalars['String']['output']>;
  /**
   * 体重 X.7
   * @gotags: jahis:"field=9" validate:"omitempty,jahis_type_x,jahis_decimal=6 3"
   */
  weight?: Maybe<Scalars['String']['output']>;
};

/** 2. 患者特記レコード */
export type MedicineNotePatientReportRecord = {
  __typename?: 'MedicineNotePatientReportRecord';
  /**
   * 患者特記内容 N.120
   * @gotags: jahis:"field=2" validate:"required,jahis_type_n,jahis_max_bytes=120"
   */
  content?: Maybe<Scalars['String']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=3" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  /**
   * 患者特記種別 9.1
   * * 1:アレルギー歴
   * * 2:副作用歴
   * * 3:既往歴
   * * 9:その他
   * @gotags: jahis:"field=1" validate:"required,oneof=1 2 3 9"
   */
  type?: Maybe<Scalars['Int']['output']>;
};

/** 15. 調剤-医師・薬剤師レコード */
export type MedicineNotePharmacistRecord = {
  __typename?: 'MedicineNotePharmacistRecord';
  /**
   * 医師・薬剤師連絡先 N.800
   * @gotags: jahis:"field=2" validate:"omitempty,jahis_type_n,jahis_max_bytes=800"
   */
  contact?: Maybe<Scalars['String']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=3" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  /**
   * 医師・薬剤師氏名 N.40
   * 医師・薬剤師氏名(全角半角混在可)
   * 出来る限り姓と名の間に空白を1桁入れて、それ以外の空白は詰めて記録
   * ※実際に調剤を行った薬剤師(診療所等で薬剤師が調剤を行っていない場合は医師)を記録する。
   * @gotags: jahis:"field=1" validate:"required,jahis_type_n,jahis_max_bytes=40"
   */
  name?: Maybe<Scalars['String']['output']>;
};

/** 11. 調剤-医療機関等レコード */
export type MedicineNotePharmacyRecord = {
  __typename?: 'MedicineNotePharmacyRecord';
  /**
   * 医療機関等住所 N.800
   * @gotags: jahis:"field=6" validate:"omitempty,jahis_type_n,jahis_max_bytes=800"
   */
  address?: Maybe<Scalars['String']['output']>;
  /**
   * 医療機関等コード X.7
   * バージョンレコードの出力区分が　1:医療機関=>患者 の場合は必須
   * @gotags: jahis:"field=4" validate:"omitempty,jahis_type_x,jahis_fixed_bytes=7"
   */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=8" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  /**
   * 医療機関等名称 N.120
   * @gotags: jahis:"field=1" validate:"required,jahis_type_n,jahis_max_bytes=120"
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * 医療機関等郵便番号 X.8
   * @gotags: jahis:"field=5" validate:"omitempty,jahis_type_x,jahis_postal_code"
   */
  postalCode?: Maybe<Scalars['String']['output']>;
  /**
   * 医療機関等都道府県 X.2
   * バージョンレコードの出力区分が　1:医療機関=>患者 の場合は必須
   * @gotags: jahis:"field=2" validate:"omitempty,jahis_type_x,jahis_prefecture_code"
   */
  prefecture?: Maybe<Scalars['String']['output']>;
  /**
   * 医療機関等電話番号 X.13
   * @gotags: jahis:"field=7" validate:"omitempty,jahis_type_x,jahis_max_bytes=13"
   */
  tel?: Maybe<Scalars['String']['output']>;
  /**
   * 医療機関等点数表 X.1
   * * 1:医科
   * * 3:歯科
   * * 4:調剤
   * バージョンレコードの出力区分が　1:医療機関=>患者 の場合は必須
   * @gotags: jahis:"field=3" validate:"omitempty,jahis_type_x,jahis_tensu_code"
   */
  tensu?: Maybe<Scalars['String']['output']>;
};

/** 服用注意情報 */
export type MedicineNotePrecaution = {
  __typename?: 'MedicineNotePrecaution';
  /** @gotags: jahis:"record=401" validate:"dive,required" */
  precautionRecords?: Maybe<Array<MedicineNotePrecautionRecord>>;
};

/** 401. 服用注意レコード */
export type MedicineNotePrecautionRecord = {
  __typename?: 'MedicineNotePrecautionRecord';
  /**
   * 内容 N.400
   * @gotags: jahis:"field=1" validate:"required,jahis_type_n,jahis_max_bytes=400"
   */
  content?: Maybe<Scalars['String']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=2" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
};

/** 調剤情報 */
export type MedicineNotePrescription = {
  __typename?: 'MedicineNotePrescription';
  /** @gotags: jahis:"record_group=51" */
  clinic?: Maybe<MedicineNoteClinic>;
  /** @gotags: jahis:"record_group=5 11 15" */
  dispensingPharmacy?: Maybe<MedicineNoteDispensingPharmacy>;
  /** @gotags: jahis:"record_group=401" */
  precaution?: Maybe<MedicineNotePrecaution>;
  /** @gotags: jahis:"record_group=601" */
  prescriptionMemo?: Maybe<MedicineNotePrescriptionMemo>;
  /** @gotags: jahis:"record_group=55 201 281 291 301 311 391" validate:"dive,required" */
  prescriptionRecipes?: Maybe<Array<MedicineNotePrescriptionRecipe>>;
  /** @gotags: jahis:"record_group=421" */
  remaining?: Maybe<MedicineNoteRemaining>;
  /** @gotags: jahis:"record_group=501" */
  remark?: Maybe<MedicineNoteRemark>;
  /** @gotags: jahis:"record_group=411" */
  warning?: Maybe<MedicineNoteWarning>;
};

/** 患者等記入情報 */
export type MedicineNotePrescriptionMemo = {
  __typename?: 'MedicineNotePrescriptionMemo';
  /** @gotags: jahis:"record=601" validate:"dive,required" */
  prescriptionMemoRecords?: Maybe<Array<MedicineNotePrescriptionMemoRecord>>;
};

/** 601. 患者等記入レコード */
export type MedicineNotePrescriptionMemoRecord = {
  __typename?: 'MedicineNotePrescriptionMemoRecord';
  /**
   * 患者等記入情報 N.400
   * 患者やその家族などから医師もしくは薬剤師に伝えたい内容を記録。(全角半角混在可)
   * @gotags: jahis:"field=1" validate:"required,jahis_type_n,jahis_max_bytes=400"
   */
  content?: Maybe<Scalars['String']['output']>;
  /**
   * 入力年月日 X.8
   * @gotags: jahis:"field=2" validate:"omitempty,jahis_type_x,jahis_date"
   */
  enteredAt?: Maybe<Scalars['ISO8601Date']['output']>;
};

/**
 * 医師情報とRP情報を保持する
 * パターン1：の場合は医師情報とRP情報の両データを保持する
 * パターン2：の場合はRP情報データのみを保持する
 */
export type MedicineNotePrescriptionRecipe = {
  __typename?: 'MedicineNotePrescriptionRecipe';
  /** @gotags: jahis:"record_group=55" */
  doctor?: Maybe<MedicineNoteDoctor>;
  /** @gotags: jahis:"record_group=201 281 291 301 311 391" validate:"dive,required" */
  recipeInformation?: Maybe<Array<MedicineNoteRecipeInformation>>;
};

/** かかりつけ薬剤師情報 */
export type MedicineNotePrimaryPharmacist = {
  __typename?: 'MedicineNotePrimaryPharmacist';
  /** @gotags: jahis:"record=701" validate:"dive,required" */
  primaryPharmacistRecords?: Maybe<Array<MedicineNotePrimaryPharmacistRecord>>;
};

/** 701. かかりつけ薬剤師レコード */
export type MedicineNotePrimaryPharmacistRecord = {
  __typename?: 'MedicineNotePrimaryPharmacistRecord';
  /**
   * 連絡先 N.800
   * @gotags: jahis:"field=3" validate:"required,jahis_type_n,jahis_max_bytes=800"
   */
  contact?: Maybe<Scalars['String']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=6" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  /**
   * 担当終了日 X.8
   * @gotags: jahis:"field=5" validate:"omitempty,jahis_type_x,jahis_date"
   */
  end?: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * かかりつけ薬剤師氏名 N.40
   * 患者が同意したかかりつけ薬剤師の氏名(全角半角混在可)
   * 出来る限り姓と名の間に空白を1桁入れて、それ以外の空白は詰めて記録
   * @gotags: jahis:"field=1" validate:"required,jahis_type_n,jahis_max_bytes=40"
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * 勤務先薬局名称 N.120
   * @gotags: jahis:"field=2" validate:"required,jahis_type_n,jahis_max_bytes=120"
   */
  pharmacyName?: Maybe<Scalars['String']['output']>;
  /**
   * 担当開始日 X.8
   * @gotags: jahis:"field=4" validate:"omitempty,jahis_type_x,jahis_date"
   */
  start?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** RP情報 */
export type MedicineNoteRecipeInformation = {
  __typename?: 'MedicineNoteRecipeInformation';
  /** @gotags: jahis:"record_group=301 311" */
  dosage?: Maybe<MedicineNoteDosage>;
  /** @gotags: jahis:"record_group=391" */
  dosageCaution?: Maybe<MedicineNoteDosageCaution>;
  /** @gotags: jahis:"record_group=201 281 291" validate:"dive,required" */
  medicines?: Maybe<Array<MedicineNoteMedicine>>;
};

/** 残薬確認情報 */
export type MedicineNoteRemaining = {
  __typename?: 'MedicineNoteRemaining';
  /** @gotags: jahis:"record=421" validate:"dive,required" */
  remainingRecords?: Maybe<Array<MedicineNoteRemainingRecord>>;
};

/** 421. 残薬確認レコード */
export type MedicineNoteRemainingRecord = {
  __typename?: 'MedicineNoteRemainingRecord';
  /**
   * 残薬内容 N.400
   * 医療機関・薬局が確認した患者の残薬の状況及び理由などを記録。(全角半角混在可)
   * @gotags: jahis:"field=1" validate:"required,jahis_type_n,jahis_max_bytes=400"
   */
  content?: Maybe<Scalars['String']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=2" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
};

/** 備考情報 */
export type MedicineNoteRemark = {
  __typename?: 'MedicineNoteRemark';
  /** @gotags: jahis:"record=501" validate:"dive,required" */
  remarkRecords?: Maybe<Array<MedicineNoteRemarkRecord>>;
};

/** 501. 備考レコード */
export type MedicineNoteRemarkRecord = {
  __typename?: 'MedicineNoteRemarkRecord';
  /**
   * 備考情報 N.400
   * @gotags: jahis:"field=1" validate:"required,jahis_type_n,jahis_max_bytes=400"
   */
  content?: Maybe<Scalars['String']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=2" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
};

/** 制御情報 */
export type MedicineNoteSplitControl = {
  __typename?: 'MedicineNoteSplitControl';
  /** @gotags: jahis:"record=911" */
  splitControlRecord?: Maybe<MedicineNoteSplitControlRecord>;
};

/** 911. 分割制御レコード */
export type MedicineNoteSplitControlRecord = {
  __typename?: 'MedicineNoteSplitControlRecord';
  /**
   * データ固有 ID 9.14
   * @gotags: jahis:"field=1" validate:"required,min=0,max=99999999999999"
   */
  id?: Maybe<Scalars['String']['output']>;
  /**
   * 分割数 9.3
   * @gotags: jahis:"field=2" validate:"required,min=1,max=999"
   */
  number?: Maybe<Scalars['Int']['output']>;
  /**
   * データ連番 9.3
   * @gotags: jahis:"field=3" validate:"required,min=1,ltefield=Number"
   */
  sequence?: Maybe<Scalars['Int']['output']>;
};

/**
 * #### 情報グループ
 * バージョン情報
 */
export type MedicineNoteVersion = {
  __typename?: 'MedicineNoteVersion';
  /** @gotags: jahis:"version_record" */
  versionRecord: MedicineNoteVersionRecord;
};

/**
 * #### Record
 * バージョンレコード
 */
export type MedicineNoteVersionRecord = {
  __typename?: 'MedicineNoteVersionRecord';
  /**
   * 出力区分
   * * 1:医療機関・薬局から患者等に情報を提供する場合
   * * 2:患者等から医療機関・薬局に情報を提供する場合
   * @gotags: jahis:"field=2" validate:"required,oneof=1 2"
   */
  destinationType?: Maybe<Scalars['Int']['output']>;
  /**
   * “JAHISTC”+(バージョン 半角数字)
   * @gotags: jahis:"field=1" validate:"required,jahis_jahistc_version"
   */
  version?: Maybe<Scalars['String']['output']>;
};

/** 医療機関等提供情報 */
export type MedicineNoteWarning = {
  __typename?: 'MedicineNoteWarning';
  /** @gotags: jahis:"record=411" validate:"dive,required" */
  warningRecords?: Maybe<Array<MedicineNoteWarningRecord>>;
};

/** 411. 医療機関等提供情報レコード */
export type MedicineNoteWarningRecord = {
  __typename?: 'MedicineNoteWarningRecord';
  /**
   * 内容 N.400
   * 医療機関・薬局から患者に提供する情報(全角半角混在可)
   * @gotags: jahis:"field=1" validate:"required,jahis_type_n,jahis_max_bytes=400"
   */
  content?: Maybe<Scalars['String']['output']>;
  /**
   * レコード作成者 9.1
   * @gotags: jahis:"field=3" validate:"required,jahis_record_creator"
   */
  creator?: Maybe<Scalars['Int']['output']>;
  /**
   * 提供情報種別 9.2
   * * 30:入院中に副作用が発現した薬剤に関する情報
   * * 31:退院後の療養を担う保険医療機関での投薬又は保険薬局での調剤に必要な服薬の状況及び投薬上の工夫に関する情報
   * * 99:その他
   * @gotags: jahis:"field=2" validate:"required,oneof=30 31 99"
   */
  type?: Maybe<Scalars['Int']['output']>;
};

export type MedicineNotesByOnetimeCode = {
  __typename?: 'MedicineNotesByOnetimeCode';
  /** 有効期限 */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** お薬手帳データ */
  medicineNotes?: Maybe<Array<MedicineNote>>;
  /** メッセージ */
  message: Scalars['String']['output'];
  /** 結果コード */
  resultCode: Scalars['String']['output'];
};

export type MedicineNotesByPatient = {
  __typename?: 'MedicineNotesByPatient';
  /** 有効期限 */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** お薬手帳データ */
  medicineNotes?: Maybe<Array<MedicineNote>>;
};

export type MedicinePage = {
  __typename?: 'MedicinePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<Medicine>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type MedixsDispensingRecord = {
  __typename?: 'MedixsDispensingRecord';
  /** 加算の合計 */
  additionSum: Scalars['Int']['output'];
  /** 基本加算 */
  basicAddition: Scalars['Int']['output'];
  /** 今回請求額 */
  claimAmount: Scalars['Int']['output'];
  /** 容器金額 */
  containerAmount: Scalars['Int']['output'];
  /** 一部負担金 */
  contributionsAmount: Scalars['Int']['output'];
  /** 調剤基本料 */
  dispensingBasic: Scalars['Int']['output'];
  /** 調剤料の合計 */
  dispensingSum: Scalars['Int']['output'];
  /** 薬歴 */
  history: Scalars['Int']['output'];
  /** 保険請求点数 */
  insuranceScore: Scalars['Float']['output'];
  /** 前回迄未入金 */
  lastUnpaidAmount: Scalars['Int']['output'];
  /** 指導管理料の合計 */
  managementSum: Scalars['Int']['output'];
  /** 特定保険医療材料料 */
  medicalMaterialsSum: Scalars['Int']['output'];
  /** 薬剤料の合計 */
  medicineSum: Scalars['Int']['output'];
  /** 加算等 */
  otherAddition: Scalars['Int']['output'];
  /** その他金額 */
  otherAmount: Scalars['Int']['output'];
  /** その他の指導料 */
  otherGuidance: Scalars['Int']['output'];
  /** 今回入金額 */
  paymentAmount: Scalars['Int']['output'];
  /** 合計点数 */
  scoreSumAmount: Scalars['Int']['output'];
  /** 合計請求額 */
  totalAmount: Scalars['Int']['output'];
  /** 未収金 */
  unpaidAmount: Scalars['Int']['output'];
};

export type MedixsEvent = {
  __typename?: 'MedixsEvent';
  /** Medixsイベント日 */
  eventDt: Scalars['ISO8601Date']['output'];
  /** MedixsイベントID */
  eventId: Scalars['Int']['output'];
  /** Medixsイベント名 */
  eventTitle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type MedixsEventPage = {
  __typename?: 'MedixsEventPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<MedixsEvent>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type MedixsPatient = Node & {
  __typename?: 'MedixsPatient';
  birthDate: Scalars['ISO8601Date']['output'];
  /** 服薬フォローアップメッセージ/質問票の回答情報の一覧を降順で返す */
  events: EventPage;
  gender: Sex;
  guestPatients: Array<GuestPatient>;
  id: Scalars['ID']['output'];
  /** 最新の予約 */
  latestAppointment?: Maybe<Appointment>;
  /** 最新の問診 */
  latestQuestionnaireSheet?: Maybe<MedixsPatientQuestionnaireSheet>;
  medicationFollowupComments: MedicationFollowupCommentPage;
  /** フォローアップメッセージの下書き */
  medicationFollowupDraftMessage?: Maybe<MedicationFollowupDraftMessage>;
  medicationFollowupStatus?: Maybe<PatientMedicationFollowupStatus>;
  /** Medixsのイベントの回答情報の一覧を降順で返す */
  medixsEvents: MedixsEventPage;
  mobilePhone: Scalars['String']['output'];
  patient?: Maybe<Patient>;
  patientCode: Scalars['String']['output'];
  patientName: Scalars['String']['output'];
  patientNameKana: Scalars['String']['output'];
  pharmacyId: Scalars['String']['output'];
  /** トレーシングレポートの下書き */
  tracingReportDraft?: Maybe<TracingReportDraft>;
  /** 最終来局日 */
  visitedDate: Scalars['ISO8601Date']['output'];
};


export type MedixsPatientEventsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type MedixsPatientMedicationFollowupCommentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type MedixsPatientMedixsEventsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type MedixsPatientPage = {
  __typename?: 'MedixsPatientPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<MedixsPatient>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type MedixsPatientQuestionnaireSheet = OutpatientQuestionnaireEntry | QuestionnaireSheet;

export type MedixsReception = Node & {
  __typename?: 'MedixsReception';
  id: Scalars['ID']['output'];
  importTime: Scalars['String']['output'];
  medicineNote?: Maybe<MedicineNote>;
  medixsDispensingRecord?: Maybe<MedixsDispensingRecord>;
  medixsPatient: MedixsPatient;
  patientCode: Scalars['String']['output'];
  pharmacyId: Scalars['String']['output'];
  prescriptions: Array<MedixsReceptionPrescription>;
  receptionId: Scalars['String']['output'];
  sendTime: Scalars['String']['output'];
};

export type MedixsReceptionPage = {
  __typename?: 'MedixsReceptionPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<MedixsReception>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type MedixsReceptionPrescription = {
  __typename?: 'MedixsReceptionPrescription';
  /** 医師名 */
  doctorName: Scalars['String']['output'];
  /** 処方箋交付年月日 */
  grantDate: Scalars['String']['output'];
  /** 診療科名 */
  hospitalDepartmentName: Scalars['String']['output'];
  /** 医療機関名 */
  hospitalName: Scalars['String']['output'];
  /** レセコン受付番号 */
  receptionNumber: Scalars['Int']['output'];
};

export type MedixsSetting = Node & {
  __typename?: 'MedixsSetting';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  medixsPatients: MedixsPatientPage;
  medixsReceptions: MedixsReceptionPage;
  organization: Organization;
  pharmacyId: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type MedixsSettingMedixsPatientsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  patientCode?: InputMaybe<Scalars['String']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type MedixsSettingMedixsReceptionsArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  patientId: Scalars['ID']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageDeliver = Node & {
  __typename?: 'MessageDeliver';
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  patient: Patient;
  practitioner: Practitioner;
};

export type MessageDeliverResult = Node & {
  __typename?: 'MessageDeliverResult';
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  guestPatient?: Maybe<GuestPatient>;
  id: Scalars['ID']['output'];
  organization: Organization;
  patient?: Maybe<Patient>;
  practitioner: Practitioner;
  status: MessageDeliverResultStatus;
  system: MessageDeliverSystem;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MessageDeliverResultPage = {
  __typename?: 'MessageDeliverResultPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<MessageDeliverResult>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export const MessageDeliverResultStatus = {
  /** 送信失敗 */
  Failed: 'failed',
  /** 処理中 */
  Processing: 'processing',
  /** 送信成功 */
  Successed: 'successed'
} as const;

export type MessageDeliverResultStatus = typeof MessageDeliverResultStatus[keyof typeof MessageDeliverResultStatus];
export const MessageDeliverSystem = {
  /** アプリ */
  App: 'app',
  /** SMS */
  Sms: 'sms'
} as const;

export type MessageDeliverSystem = typeof MessageDeliverSystem[keyof typeof MessageDeliverSystem];
export type MonthlyPayoutStatement = {
  __typename?: 'MonthlyPayoutStatement';
  /** 月単位で集計した決済額 */
  amount: Scalars['Int']['output'];
  /** 月単位で集計したサービス利用料（税込） */
  feeWithTax: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  /** 請求月単位で集計したサービス利用料（税込） */
  uberDeliveryFee: Scalars['Int']['output'];
  /** 配達年月単位で集計した患者に請求した当日配達利用料 */
  uberDeliveryInvoiceFees: UberDeliveryInvoiceFeePage;
  year: Scalars['Int']['output'];
};


export type MonthlyPayoutStatementUberDeliveryInvoiceFeesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type MonthlyPayoutStatementPage = {
  __typename?: 'MonthlyPayoutStatementPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<MonthlyPayoutStatement>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateAnnouncement?: Maybe<ActivateAnnouncementPayload>;
  activateOtpSecret?: Maybe<ActivateOtpSecretPayload>;
  addCompanyAddress?: Maybe<AddCompanyAddressPayload>;
  addCompanyContactPoint?: Maybe<AddCompanyContactPointPayload>;
  addCompanyPractitioner?: Maybe<AddCompanyPractitionerPayload>;
  addContractPlan?: Maybe<AddContractPlanPayload>;
  addIncentiveTargetCompany?: Maybe<AddIncentiveTargetCompanyPayload>;
  addInvitationCode?: Maybe<AddInvitationCodePayload>;
  addOrganizationAddress?: Maybe<AddOrganizationAddressPayload>;
  addOrganizationContactPoint?: Maybe<AddOrganizationContactPointPayload>;
  addPatientAttachment?: Maybe<AddPatientAttachmentPayload>;
  addUberSignatureDraftExtraText?: Maybe<AddUberSignatureDraftExtraTextPayload>;
  allowOperatorAccessPermission?: Maybe<AllowOperatorAccessPermissionPayload>;
  appendIdToFeatureTargetGroup?: Maybe<AppendIdToFeatureTargetGroupPayload>;
  appendToFeatureTargetGroup?: Maybe<AppendToFeatureTargetGroupPayload>;
  approveUberSignature?: Maybe<ApproveUberSignaturePayload>;
  bookAppointment?: Maybe<BookAppointmentPayload>;
  bulkDuplicateMedicationFollowupMessageTemplates?: Maybe<BulkDuplicateMedicationFollowupMessageTemplatesPayload>;
  cancelAppointment?: Maybe<CancelAppointmentPayload>;
  cancelAppointmentViaWeb?: Maybe<CancelAppointmentViaWebPayload>;
  cancelAppointmentWithWebVisitor?: Maybe<CancelAppointmentWithWebVisitorPayload>;
  cancelDraftAppointment?: Maybe<CancelDraftAppointmentPayload>;
  cancelOperatorAccessPermission?: Maybe<CancelOperatorAccessPermissionPayload>;
  changeDeliveryMethod?: Maybe<ChangeDeliveryMethodPayload>;
  changeOutpatientQuestionnaireSettingQuestionnaireInUse?: Maybe<ChangeOutpatientQuestionnaireSettingQuestionnaireInUsePayload>;
  /** @deprecated 代わりにchargeWithApp2を使って */
  chargeWithApp?: Maybe<ChargeWithAppPayload>;
  chargeWithApp2?: Maybe<ChargeWithApp2Payload>;
  chargeWithCash?: Maybe<ChargeWithCashPayload>;
  chargeWithCash2?: Maybe<ChargeWithCash2Payload>;
  createAllowList?: Maybe<CreateAllowListPayload>;
  createAnnouncement?: Maybe<CreateAnnouncementPayload>;
  createAppointmentViaWeb?: Maybe<CreateAppointmentViaWebPayload>;
  createAuthTokenByProxy?: Maybe<CreateAuthTokenByProxyPayload>;
  createCheckinEntry?: Maybe<CreateCheckinEntryPayload>;
  createClientCert?: Maybe<CreateClientCertPayload>;
  createCompanyFeeSetting?: Maybe<CreateCompanyFeeSettingPayload>;
  createCompanySetupDocument?: Maybe<CreateCompanySetupDocumentPayload>;
  createDirectVisitor?: Maybe<CreateDirectVisitorPayload>;
  createFeature?: Maybe<CreateFeaturePayload>;
  createFeatureTargetGroup?: Maybe<CreateFeatureTargetGroupPayload>;
  createFeatureTargetGroupFromTarget?: Maybe<CreateFeatureTargetGroupFromTargetPayload>;
  createGendaSetting?: Maybe<CreateGendaSettingPayload>;
  createGuestPatientFollowupComment?: Maybe<CreateGuestPatientFollowupCommentPayload>;
  createMedicalInstitutionSetting?: Maybe<CreateMedicalInstitutionSettingPayload>;
  createMedicationFollowupMessage2?: Maybe<CreateMedicationFollowupMessage2Payload>;
  createMedicationFollowupMessageTemplate?: Maybe<CreateMedicationFollowupMessageTemplatePayload>;
  createMedicationFollowupQuestionnaire?: Maybe<CreateMedicationFollowupQuestionnairePayload>;
  createMedicationFollowupQuestionnaireSheet?: Maybe<CreateMedicationFollowupQuestionnaireSheetPayload>;
  createMedixsSetting?: Maybe<CreateMedixsSettingPayload>;
  createMessageForWebVisitor?: Maybe<CreateMessageForWebVisitorPayload>;
  createOperatorAuthority?: Maybe<CreateOperatorAuthorityPayload>;
  createOperatorRole?: Maybe<CreateOperatorRolePayload>;
  createOrganization?: Maybe<CreateOrganizationPayload>;
  createOrganizationCompanyFeeSetting?: Maybe<CreateOrganizationCompanyFeeSettingPayload>;
  createOrganizationFeeSetting?: Maybe<CreateOrganizationFeeSettingPayload>;
  createOtpSecret?: Maybe<CreateOtpSecretPayload>;
  createOutpatientQuestionnaireEntry?: Maybe<CreateOutpatientQuestionnaireEntryPayload>;
  createOutpatientQuestionnaireSettingQuestionnaire?: Maybe<CreateOutpatientQuestionnaireSettingQuestionnairePayload>;
  createPatientFollowupComment?: Maybe<CreatePatientFollowupCommentPayload>;
  createPlan?: Maybe<CreatePlanPayload>;
  createPractitioner?: Maybe<CreatePractitionerPayload>;
  /**
   * 文字数について
   * 対象薬剤: 横39文字 × 縦2文字 = 78文字
   * 報告連絡: 横66文字 × 縦19文字 = 1254文字
   * 提案事項: 横66文字 × 縦5文字 = 330文字
   * ※上記文字数を超えた場合は文字が縮小されて収まるように設定している
   */
  createTracingReport?: Maybe<CreateTracingReportPayload>;
  createUberAgreementExtension?: Maybe<CreateUberAgreementExtensionPayload>;
  createUberDelivery?: Maybe<CreateUberDeliveryPayload>;
  deactivateAnnouncement?: Maybe<DeactivateAnnouncementPayload>;
  deactivateCompany?: Maybe<DeactivateCompanyPayload>;
  deactivateCompanyFeeSetting?: Maybe<DeactivateCompanyFeeSettingPayload>;
  deactivateMedicationFollowupMessage?: Maybe<DeactivateMedicationFollowupMessagePayload>;
  deactivateMedicationFollowupMessageTemplate?: Maybe<DeactivateMedicationFollowupMessageTemplatePayload>;
  deactivateMedicationFollowupQuestionnaire?: Maybe<DeactivateMedicationFollowupQuestionnairePayload>;
  deactivateOperator?: Maybe<DeactivateOperatorPayload>;
  deactivateOrganizationFeeSetting?: Maybe<DeactivateOrganizationFeeSettingPayload>;
  deactivateOtpSecrets?: Maybe<DeactivateOtpSecretsPayload>;
  deactivatePractitioner?: Maybe<DeactivatePractitionerPayload>;
  deleteAllowList?: Maybe<DeleteAllowListPayload>;
  deleteFeature?: Maybe<DeleteFeaturePayload>;
  deleteFeatureTargetGroup?: Maybe<DeleteFeatureTargetGroupPayload>;
  deleteFromFeatureTargetGroup?: Maybe<DeleteFromFeatureTargetGroupPayload>;
  deleteGuestPatientMedicationFollowupComment?: Maybe<DeleteGuestPatientMedicationFollowupCommentPayload>;
  deleteIdFromFeatureTargetGroup?: Maybe<DeleteIdFromFeatureTargetGroupPayload>;
  deleteMedicationFollowupDraftMessage?: Maybe<DeleteMedicationFollowupDraftMessagePayload>;
  deleteOperatorAuthority?: Maybe<DeleteOperatorAuthorityPayload>;
  deleteOperatorRole?: Maybe<DeleteOperatorRolePayload>;
  deleteOrganization?: Maybe<DeleteOrganizationPayload>;
  deleteOutpatientQuestionnaireSettingQuestionnaire?: Maybe<DeleteOutpatientQuestionnaireSettingQuestionnairePayload>;
  deletePatientAttachment?: Maybe<DeletePatientAttachmentPayload>;
  deletePatientMedicationFollowupComment?: Maybe<DeletePatientMedicationFollowupCommentPayload>;
  deleteTracingReportDraft?: Maybe<DeleteTracingReportDraftPayload>;
  downloadClientCert?: Maybe<DownloadClientCertPayload>;
  dumpOrganizations?: Maybe<DumpOrganizationsPayload>;
  editDirectVisitor?: Maybe<EditDirectVisitorPayload>;
  extendCompanySetupDocument?: Maybe<ExtendCompanySetupDocumentPayload>;
  fetchMedixsReception?: Maybe<FetchMedixsReceptionPayload>;
  finalizeDeliveryOutput?: Maybe<FinalizeDeliveryOutputPayload>;
  finishAppointment?: Maybe<FinishAppointmentPayload>;
  finishCheckinEntry?: Maybe<FinishCheckinEntryPayload>;
  finishDraftAppointment?: Maybe<FinishDraftAppointmentPayload>;
  finishEncounter?: Maybe<FinishEncounterPayload>;
  finishOutpatientQuestionnaireEntry?: Maybe<FinishOutpatientQuestionnaireEntryPayload>;
  fulfillAppointment?: Maybe<FulfillAppointmentPayload>;
  generateAgentArtifact?: Maybe<GenerateAgentArtifactPayload>;
  generateBookmarkedPatientsCountCsv?: Maybe<GenerateBookmarkedPatientsCountCsvPayload>;
  generateClientCertCsv?: Maybe<GenerateClientCertCsvPayload>;
  generateCompanyMedicationFollowupMessageUsagesCsv?: Maybe<GenerateCompanyMedicationFollowupMessageUsagesCsvPayload>;
  generateCompanyOrganizationsAppDownloadUrlsCsv?: Maybe<GenerateCompanyOrganizationsAppDownloadUrlsCsvPayload>;
  generateCompanyReceptionUsagesCsv?: Maybe<GenerateCompanyReceptionUsagesCsvPayload>;
  generateCompanyReceptionsCsv?: Maybe<GenerateCompanyReceptionsCsvPayload>;
  generateCompanySalesDetailsCsv?: Maybe<GenerateCompanySalesDetailsCsvPayload>;
  generateCompanyTracingReportUsagesCsv?: Maybe<GenerateCompanyTracingReportUsagesCsvPayload>;
  generateCsvForClientCertsImport?: Maybe<GenerateCsvForClientCertsImportPayload>;
  generateCsvForMessageTemplatesBulkDuplicate?: Maybe<GenerateCsvForMessageTemplatesBulkDuplicatePayload>;
  generateCsvForUberOrganizationSettingsUpsert?: Maybe<GenerateCsvForUberOrganizationSettingsUpsertPayload>;
  generateDeliveryCsv?: Maybe<GenerateDeliveryCsvPayload>;
  generateIncentivePayoutNotification?: Maybe<GenerateIncentivePayoutNotificationPayload>;
  generateOrganizationAuditEventCsv?: Maybe<GenerateOrganizationAuditEventCsvPayload>;
  generatePayoutOrganizationsWithBankAccountCsv?: Maybe<GeneratePayoutOrganizationsWithBankAccountCsvPayload>;
  generateUberSignaturePreview?: Maybe<GenerateUberSignaturePreviewPayload>;
  generateUberSignaturePreviewFormData?: Maybe<GenerateUberSignaturePreviewFormDataPayload>;
  generateUberSignaturePreviewOnlyExtraText?: Maybe<GenerateUberSignaturePreviewOnlyExtraTextPayload>;
  identifyMedixsPatient?: Maybe<IdentifyMedixsPatientPayload>;
  identifyMedixsReception?: Maybe<IdentifyMedixsReceptionPayload>;
  importClientCerts?: Maybe<ImportClientCertsPayload>;
  importOrganizations?: Maybe<ImportOrganizationsPayload>;
  importUberOrganizationsCsv?: Maybe<ImportUberOrganizationsCsvPayload>;
  issueGendaApiKey?: Maybe<IssueGendaApiKeyPayload>;
  markAnnouncement?: Maybe<MarkAnnouncementPayload>;
  markHiccupTemporaryPermission?: Maybe<MarkHiccupTemporaryPermissionPayload>;
  markOrganizationNotification?: Maybe<MarkOrganizationNotificationPayload>;
  markOrganizationNotificationByAppointment?: Maybe<MarkOrganizationNotificationByAppointmentPayload>;
  notifyCheckinEntry?: Maybe<NotifyCheckinEntryPayload>;
  notifyOutpatientQuestionnaireEntry?: Maybe<NotifyOutpatientQuestionnaireEntryPayload>;
  rechargeWithApp?: Maybe<RechargeWithAppPayload>;
  rechargeWithCash?: Maybe<RechargeWithCashPayload>;
  recreateTracingReport?: Maybe<RecreateTracingReportPayload>;
  remandUberSignature?: Maybe<RemandUberSignaturePayload>;
  removeCompanyAddress?: Maybe<RemoveCompanyAddressPayload>;
  removeCompanyContactPoint?: Maybe<RemoveCompanyContactPointPayload>;
  removeCompanySetupDocument?: Maybe<RemoveCompanySetupDocumentPayload>;
  removeMedicalInstitutionSetting?: Maybe<RemoveMedicalInstitutionSettingPayload>;
  removeOrganizationContactPoint?: Maybe<RemoveOrganizationContactPointPayload>;
  removeWebBookingsExceptionBusinessHour?: Maybe<RemoveWebBookingsExceptionBusinessHourPayload>;
  requestAppointment?: Maybe<RequestAppointmentPayload>;
  resendAuthenticationCode?: Maybe<ResendAuthenticationCodePayload>;
  restartAgent?: Maybe<RestartAgentPayload>;
  resumeWebBookings?: Maybe<ResumeWebBookingsPayload>;
  revokeClientCert?: Maybe<RevokeClientCertPayload>;
  sendAuthenticationCodeAndRegisterPatientEmail?: Maybe<SendAuthenticationCodeAndRegisterPatientEmailPayload>;
  sendCallNotification?: Maybe<SendCallNotificationPayload>;
  sendClientCertMail?: Maybe<SendClientCertMailPayload>;
  sendCongestionNotification?: Maybe<SendCongestionNotificationPayload>;
  sendCongestionNotificationForWebVisitor?: Maybe<SendCongestionNotificationForWebVisitorPayload>;
  sendDispensingPreparedNotification?: Maybe<SendDispensingPreparedNotificationPayload>;
  /**
   * 指定した携帯電話番号へSMSを送信する
   * SMS本文内にある `{{link}}` は、SMS本文に埋め込むリンクで置換される
   */
  sendInvitationSms?: Maybe<SendInvitationSmsPayload>;
  sendPractitionerCodeMail?: Maybe<SendPractitionerCodeMailPayload>;
  sendTracingReport?: Maybe<SendTracingReportPayload>;
  setPractitionerRole?: Maybe<SetPractitionerRolePayload>;
  signupCompany?: Maybe<SignupCompanyPayload>;
  signupPfPatientFromCheckinEntry?: Maybe<SignupPfPatientFromCheckinEntryPayload>;
  signupPfPatientFromOutpatientQuestionnaireEntry?: Maybe<SignupPfPatientFromOutpatientQuestionnaireEntryPayload>;
  skipEncounter?: Maybe<SkipEncounterPayload>;
  subscribeChannel?: Maybe<SubscribeChannelPayload>;
  suspendWebBookings?: Maybe<SuspendWebBookingsPayload>;
  unidentifyMedixsPatient?: Maybe<UnidentifyMedixsPatientPayload>;
  unidentifyMedixsReception?: Maybe<UnidentifyMedixsReceptionPayload>;
  unpublishOrganization?: Maybe<UnpublishOrganizationPayload>;
  unsubscribeChannel?: Maybe<UnsubscribeChannelPayload>;
  updateAgentDescription?: Maybe<UpdateAgentDescriptionPayload>;
  updateAgentPrintPrescriptionSetting?: Maybe<UpdatePrintPrescriptionSettingPayload>;
  updateAnnouncement?: Maybe<UpdateAnnouncementPayload>;
  updateAppointmentDeliveryMethod?: Maybe<UpdateAppointmentDeliveryMethodPayload>;
  updateAppointmentDescription?: Maybe<UpdateAppointmentDescriptionPayload>;
  updateB2cloudSetting?: Maybe<UpdateB2cloudSettingPayload>;
  updateBankAccount?: Maybe<UpdateBankAccountPayload>;
  updateCheckinDescription?: Maybe<UpdateCheckinDescriptionPayload>;
  updateCheckinSetting?: Maybe<UpdateCheckinSettingPayload>;
  updateCompany?: Maybe<UpdateCompanyPayload>;
  updateCompanyAddress?: Maybe<UpdateCompanyAddressPayload>;
  updateCompanyAgentSetting?: Maybe<UpdateCompanyAgentSettingPayload>;
  updateCompanyContactPoint?: Maybe<UpdateCompanyContactPointPayload>;
  updateCompanyFeeSetting?: Maybe<UpdateCompanyFeeSettingPayload>;
  updateCompanyPractitioner?: Maybe<UpdateCompanyPractitionerPayload>;
  updateCompanySessionSetting?: Maybe<UpdateCompanySessionSettingPayload>;
  updateContract?: Maybe<UpdateContractPayload>;
  updateContractPlan?: Maybe<UpdateContractPlanPayload>;
  updateDraftAppointmentDescription?: Maybe<UpdateDraftAppointmentDescriptionPayload>;
  updateFeature?: Maybe<UpdateFeaturePayload>;
  updateFeatureTargetGroup?: Maybe<UpdateFeatureTargetGroupPayload>;
  updateGendaApiKey?: Maybe<UpdateGendaApiKeyPayload>;
  updateGendaSetting?: Maybe<UpdateGendaSettingPayload>;
  updateGuestPatientFollowupComment?: Maybe<UpdateGuestPatientFollowupCommentPayload>;
  updateMedicalInstitutionSetting?: Maybe<UpdateMedicalInstitutionSettingPayload>;
  updateMedicationFollowupMessage2?: Maybe<UpdateMedicationFollowupMessage2Payload>;
  updateMedicationFollowupMessageTemplate?: Maybe<UpdateMedicationFollowupMessageTemplatePayload>;
  updateMedicationFollowupQuestionnaire?: Maybe<UpdateMedicationFollowupQuestionnairePayload>;
  updateMedicationFollowupQuestionnairePosition?: Maybe<UpdateMedicationFollowupQuestionnairePositionPayload>;
  updateMedixsSetting?: Maybe<UpdateMedixsSettingPayload>;
  updateNotificationSetting?: Maybe<UpdateNotificationSettingPayload>;
  updateOperatorRole?: Maybe<UpdateOperatorRolePayload>;
  updateOrganization?: Maybe<UpdateOrganizationPayload>;
  updateOrganizationAddress?: Maybe<UpdateOrganizationAddressPayload>;
  updateOrganizationCompanyFeeSetting?: Maybe<UpdateOrganizationCompanyFeeSettingPayload>;
  updateOrganizationContactPoint?: Maybe<UpdateOrganizationContactPointPayload>;
  updateOrganizationFeeSetting?: Maybe<UpdateOrganizationFeeSettingPayload>;
  updateOutpatientQuestionnaireDescription?: Maybe<UpdateOutpatientQuestionnaireDescriptionPayload>;
  updateOutpatientQuestionnaireSetting?: Maybe<UpdateOutpatientQuestionnaireSettingPayload>;
  updateOutpatientQuestionnaireSettingQuestionnaire?: Maybe<UpdateOutpatientQuestionnaireSettingQuestionnairePayload>;
  updatePatientFollowupComment?: Maybe<UpdatePatientFollowupCommentPayload>;
  updatePlan?: Maybe<UpdatePlanPayload>;
  updatePractitioner?: Maybe<UpdatePractitionerPayload>;
  updatePractitionerAuthentication?: Maybe<UpdatePractitionerAuthenticationPayload>;
  updatePractitionerCode?: Maybe<UpdatePractitionerCodePayload>;
  updatePractitionerCodeForCompanyPractitioner?: Maybe<UpdatePractitionerCodeForCompanyPractitionerPayload>;
  updateUberSignatureInputData?: Maybe<UpdateUberSignatureInputDataPayload>;
  updateWebBookingsBusinessHour2?: Maybe<UpdateWebBookingsBusinessHour2Payload>;
  updateWebBookingsExceptionBusinessHour?: Maybe<UpdateWebBookingsExceptionBusinessHourPayload>;
  updateWebBookingsHolidayBusinessHour?: Maybe<UpdateWebBookingsHolidayBusinessHourPayload>;
  updateWebBookingsSetting?: Maybe<UpdateWebBookingsSettingPayload>;
  upsertAgreementExtension?: Maybe<UpsertAgreementExtensionPayload>;
  upsertClientAuthentication?: Maybe<UpsertClientAuthenticationPayload>;
  upsertCompanyWebBookingsLimitSetting?: Maybe<UpsertCompanyWebBookingsLimitSettingPayload>;
  upsertGuestPatientMedicationFollowupStatus?: Maybe<UpsertGuestPatientMedicationFollowupStatusPayload>;
  upsertMedicationFollowupDraftMessage?: Maybe<UpsertMedicationFollowupDraftMessagePayload>;
  upsertMedicationFollowupStatusSetting?: Maybe<UpsertMedicationFollowupStatusSettingPayload>;
  upsertOrganization?: Maybe<UpsertOrganizationPayload>;
  upsertOrganizations?: Maybe<UpsertOrganizationsPayload>;
  upsertPatientMedicationFollowupStatus?: Maybe<UpsertPatientMedicationFollowupStatusPayload>;
  upsertTracingReportDraft?: Maybe<UpsertTracingReportDraftPayload>;
  upsertUberOrganizationSetting?: Maybe<UpsertUberOrganizationSettingPayload>;
  upsertUberOrganizationSettings?: Maybe<UpsertUberOrganizationSettingsPayload>;
  upsertUberSignatureDraft?: Maybe<UpsertUberSignatureDraftPayload>;
  upsertWebBookingsAllDayLimit?: Maybe<UpsertWebBookingsAllDayLimitPayload>;
  upsertWebBookingsLimit?: Maybe<UpsertWebBookingsLimitPayload>;
  viewedMedicationFollowupQuestionnaireSheet?: Maybe<ViewedMedicationFollowupQuestionnaireSheetPayload>;
};


export type MutationActivateAnnouncementArgs = {
  input: ActivateAnnouncementInput;
};


export type MutationActivateOtpSecretArgs = {
  input: ActivateOtpSecretInput;
};


export type MutationAddCompanyAddressArgs = {
  input: AddCompanyAddressInput;
};


export type MutationAddCompanyContactPointArgs = {
  input: AddCompanyContactPointInput;
};


export type MutationAddCompanyPractitionerArgs = {
  input: AddCompanyPractitionerInput;
};


export type MutationAddContractPlanArgs = {
  input: AddContractPlanInput;
};


export type MutationAddIncentiveTargetCompanyArgs = {
  input: AddIncentiveTargetCompanyInput;
};


export type MutationAddInvitationCodeArgs = {
  input: AddInvitationCodeInput;
};


export type MutationAddOrganizationAddressArgs = {
  input: AddOrganizationAddressInput;
};


export type MutationAddOrganizationContactPointArgs = {
  input: AddOrganizationContactPointInput;
};


export type MutationAddPatientAttachmentArgs = {
  input: AddPatientAttachmentInput;
};


export type MutationAddUberSignatureDraftExtraTextArgs = {
  input: AddUberSignatureDraftExtraTextInput;
};


export type MutationAllowOperatorAccessPermissionArgs = {
  input: AllowOperatorAccessPermissionInput;
};


export type MutationAppendIdToFeatureTargetGroupArgs = {
  input: AppendIdToFeatureTargetGroupInput;
};


export type MutationAppendToFeatureTargetGroupArgs = {
  input: AppendToFeatureTargetGroupInput;
};


export type MutationApproveUberSignatureArgs = {
  input: ApproveUberSignatureInput;
};


export type MutationBookAppointmentArgs = {
  input: BookAppointmentInput;
};


export type MutationBulkDuplicateMedicationFollowupMessageTemplatesArgs = {
  input: BulkDuplicateMedicationFollowupMessageTemplatesInput;
};


export type MutationCancelAppointmentArgs = {
  input: CancelAppointmentInput;
};


export type MutationCancelAppointmentViaWebArgs = {
  input: CancelAppointmentViaWebInput;
};


export type MutationCancelAppointmentWithWebVisitorArgs = {
  input: CancelAppointmentWithWebVisitorInput;
};


export type MutationCancelDraftAppointmentArgs = {
  input: CancelDraftAppointmentInput;
};


export type MutationCancelOperatorAccessPermissionArgs = {
  input: CancelOperatorAccessPermissionInput;
};


export type MutationChangeDeliveryMethodArgs = {
  input: ChangeDeliveryMethodInput;
};


export type MutationChangeOutpatientQuestionnaireSettingQuestionnaireInUseArgs = {
  input: ChangeOutpatientQuestionnaireSettingQuestionnaireInUseInput;
};


export type MutationChargeWithAppArgs = {
  input: ChargeWithAppInput;
};


export type MutationChargeWithApp2Args = {
  input: ChargeWithApp2Input;
};


export type MutationChargeWithCashArgs = {
  input: ChargeWithCashInput;
};


export type MutationChargeWithCash2Args = {
  input: ChargeWithCash2Input;
};


export type MutationCreateAllowListArgs = {
  input: CreateAllowListInput;
};


export type MutationCreateAnnouncementArgs = {
  input: CreateAnnouncementInput;
};


export type MutationCreateAppointmentViaWebArgs = {
  input: CreateAppointmentViaWebInput;
};


export type MutationCreateAuthTokenByProxyArgs = {
  input: CreateAuthTokenByProxyInput;
};


export type MutationCreateCheckinEntryArgs = {
  input: CreateCheckinEntryInput;
};


export type MutationCreateClientCertArgs = {
  input: CreateClientCertInput;
};


export type MutationCreateCompanyFeeSettingArgs = {
  input: CreateCompanyFeeSettingInput;
};


export type MutationCreateCompanySetupDocumentArgs = {
  input: CreateCompanySetupDocumentInput;
};


export type MutationCreateDirectVisitorArgs = {
  input: CreateDirectVisitorInput;
};


export type MutationCreateFeatureArgs = {
  input: CreateFeatureInput;
};


export type MutationCreateFeatureTargetGroupArgs = {
  input: CreateFeatureTargetGroupInput;
};


export type MutationCreateFeatureTargetGroupFromTargetArgs = {
  input: CreateFeatureTargetGroupFromTargetInput;
};


export type MutationCreateGendaSettingArgs = {
  input: CreateGendaSettingInput;
};


export type MutationCreateGuestPatientFollowupCommentArgs = {
  input: CreateGuestPatientFollowupCommentInput;
};


export type MutationCreateMedicalInstitutionSettingArgs = {
  input: CreateMedicalInstitutionSettingInput;
};


export type MutationCreateMedicationFollowupMessage2Args = {
  input: CreateMedicationFollowupMessage2Input;
};


export type MutationCreateMedicationFollowupMessageTemplateArgs = {
  input: CreateMedicationFollowupMessageTemplateInput;
};


export type MutationCreateMedicationFollowupQuestionnaireArgs = {
  input: CreateMedicationFollowupQuestionnaireInput;
};


export type MutationCreateMedicationFollowupQuestionnaireSheetArgs = {
  input: CreateMedicationFollowupQuestionnaireSheetInput;
};


export type MutationCreateMedixsSettingArgs = {
  input: CreateMedixsSettingInput;
};


export type MutationCreateMessageForWebVisitorArgs = {
  input: CreateMessageForWebVisitorInput;
};


export type MutationCreateOperatorAuthorityArgs = {
  input: CreateOperatorAuthorityInput;
};


export type MutationCreateOperatorRoleArgs = {
  input: CreateOperatorRoleInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationCompanyFeeSettingArgs = {
  input: CreateOrganizationCompanyFeeSettingInput;
};


export type MutationCreateOrganizationFeeSettingArgs = {
  input: CreateOrganizationFeeSettingInput;
};


export type MutationCreateOtpSecretArgs = {
  input: CreateOtpSecretInput;
};


export type MutationCreateOutpatientQuestionnaireEntryArgs = {
  input: CreateOutpatientQuestionnaireEntryInput;
};


export type MutationCreateOutpatientQuestionnaireSettingQuestionnaireArgs = {
  input: CreateOutpatientQuestionnaireSettingQuestionnaireInput;
};


export type MutationCreatePatientFollowupCommentArgs = {
  input: CreatePatientFollowupCommentInput;
};


export type MutationCreatePlanArgs = {
  input: CreatePlanInput;
};


export type MutationCreatePractitionerArgs = {
  input: CreatePractitionerInput;
};


export type MutationCreateTracingReportArgs = {
  input: CreateTracingReportInput;
};


export type MutationCreateUberAgreementExtensionArgs = {
  input: CreateUberAgreementExtensionInput;
};


export type MutationCreateUberDeliveryArgs = {
  input: CreateUberDeliveryInput;
};


export type MutationDeactivateAnnouncementArgs = {
  input: DeactivateAnnouncementInput;
};


export type MutationDeactivateCompanyArgs = {
  input: DeactivateCompanyInput;
};


export type MutationDeactivateCompanyFeeSettingArgs = {
  input: DeactivateCompanyFeeSettingInput;
};


export type MutationDeactivateMedicationFollowupMessageArgs = {
  input: DeactivateMedicationFollowupMessageInput;
};


export type MutationDeactivateMedicationFollowupMessageTemplateArgs = {
  input: DeactivateMedicationFollowupMessageTemplateInput;
};


export type MutationDeactivateMedicationFollowupQuestionnaireArgs = {
  input: DeactivateMedicationFollowupQuestionnaireInput;
};


export type MutationDeactivateOperatorArgs = {
  input: DeactivateOperatorInput;
};


export type MutationDeactivateOrganizationFeeSettingArgs = {
  input: DeactivateOrganizationFeeSettingInput;
};


export type MutationDeactivateOtpSecretsArgs = {
  input: DeactivateOtpSecretsInput;
};


export type MutationDeactivatePractitionerArgs = {
  input: DeactivatePractitionerInput;
};


export type MutationDeleteAllowListArgs = {
  input: DeleteAllowListInput;
};


export type MutationDeleteFeatureArgs = {
  input: DeleteFeatureInput;
};


export type MutationDeleteFeatureTargetGroupArgs = {
  input: DeleteFeatureTargetGroupInput;
};


export type MutationDeleteFromFeatureTargetGroupArgs = {
  input: DeleteFromFeatureTargetGroupInput;
};


export type MutationDeleteGuestPatientMedicationFollowupCommentArgs = {
  input: DeleteGuestPatientMedicationFollowupCommentInput;
};


export type MutationDeleteIdFromFeatureTargetGroupArgs = {
  input: DeleteIdFromFeatureTargetGroupInput;
};


export type MutationDeleteMedicationFollowupDraftMessageArgs = {
  input: DeleteMedicationFollowupDraftMessageInput;
};


export type MutationDeleteOperatorAuthorityArgs = {
  input: DeleteOperatorAuthorityInput;
};


export type MutationDeleteOperatorRoleArgs = {
  input: DeleteOperatorRoleInput;
};


export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};


export type MutationDeleteOutpatientQuestionnaireSettingQuestionnaireArgs = {
  input: DeleteOutpatientQuestionnaireSettingQuestionnaireInput;
};


export type MutationDeletePatientAttachmentArgs = {
  input: DeletePatientAttachmentInput;
};


export type MutationDeletePatientMedicationFollowupCommentArgs = {
  input: DeletePatientMedicationFollowupCommentInput;
};


export type MutationDeleteTracingReportDraftArgs = {
  input: DeleteTracingReportDraftInput;
};


export type MutationDownloadClientCertArgs = {
  input: DownloadClientCertInput;
};


export type MutationDumpOrganizationsArgs = {
  input: DumpOrganizationsInput;
};


export type MutationEditDirectVisitorArgs = {
  input: EditDirectVisitorInput;
};


export type MutationExtendCompanySetupDocumentArgs = {
  input: ExtendCompanySetupDocumentInput;
};


export type MutationFetchMedixsReceptionArgs = {
  input: FetchMedixsReceptionInput;
};


export type MutationFinalizeDeliveryOutputArgs = {
  input: FinalizeDeliveryOutputInput;
};


export type MutationFinishAppointmentArgs = {
  input: FinishAppointmentInput;
};


export type MutationFinishCheckinEntryArgs = {
  input: FinishCheckinEntryInput;
};


export type MutationFinishDraftAppointmentArgs = {
  input: FinishDraftAppointmentInput;
};


export type MutationFinishEncounterArgs = {
  input: FinishEncounterInput;
};


export type MutationFinishOutpatientQuestionnaireEntryArgs = {
  input: FinishOutpatientQuestionnaireEntryInput;
};


export type MutationFulfillAppointmentArgs = {
  input: FulfillAppointmentInput;
};


export type MutationGenerateAgentArtifactArgs = {
  input: GenerateAgentArtifactInput;
};


export type MutationGenerateBookmarkedPatientsCountCsvArgs = {
  input: GenerateBookmarkedPatientsCountCsvInput;
};


export type MutationGenerateClientCertCsvArgs = {
  input: GenerateClientCertCsvInput;
};


export type MutationGenerateCompanyMedicationFollowupMessageUsagesCsvArgs = {
  input: GenerateCompanyMedicationFollowupMessageUsagesCsvInput;
};


export type MutationGenerateCompanyOrganizationsAppDownloadUrlsCsvArgs = {
  input: GenerateCompanyOrganizationsAppDownloadUrlsCsvInput;
};


export type MutationGenerateCompanyReceptionUsagesCsvArgs = {
  input: GenerateCompanyReceptionUsagesCsvInput;
};


export type MutationGenerateCompanyReceptionsCsvArgs = {
  input: GenerateCompanyReceptionsCsvInput;
};


export type MutationGenerateCompanySalesDetailsCsvArgs = {
  input: GenerateCompanySalesDetailsCsvInput;
};


export type MutationGenerateCompanyTracingReportUsagesCsvArgs = {
  input: GenerateCompanyTracingReportUsagesCsvInput;
};


export type MutationGenerateCsvForClientCertsImportArgs = {
  input: GenerateCsvForClientCertsImportInput;
};


export type MutationGenerateCsvForMessageTemplatesBulkDuplicateArgs = {
  input: GenerateCsvForMessageTemplatesBulkDuplicateInput;
};


export type MutationGenerateCsvForUberOrganizationSettingsUpsertArgs = {
  input: GenerateCsvForUberOrganizationSettingsUpsertInput;
};


export type MutationGenerateDeliveryCsvArgs = {
  input: GenerateDeliveryCsvInput;
};


export type MutationGenerateIncentivePayoutNotificationArgs = {
  input: GenerateIncentivePayoutNotificationInput;
};


export type MutationGenerateOrganizationAuditEventCsvArgs = {
  input: GenerateOrganizationAuditEventCsvInput;
};


export type MutationGeneratePayoutOrganizationsWithBankAccountCsvArgs = {
  input: GeneratePayoutOrganizationsWithBankAccountCsvInput;
};


export type MutationGenerateUberSignaturePreviewArgs = {
  input: GenerateUberSignaturePreviewInput;
};


export type MutationGenerateUberSignaturePreviewFormDataArgs = {
  input: GenerateUberSignaturePreviewFormDataInput;
};


export type MutationGenerateUberSignaturePreviewOnlyExtraTextArgs = {
  input: GenerateUberSignaturePreviewOnlyExtraTextInput;
};


export type MutationIdentifyMedixsPatientArgs = {
  input: IdentifyMedixsPatientInput;
};


export type MutationIdentifyMedixsReceptionArgs = {
  input: IdentifyMedixsReceptionInput;
};


export type MutationImportClientCertsArgs = {
  input: ImportClientCertsInput;
};


export type MutationImportOrganizationsArgs = {
  input: ImportOrganizationsInput;
};


export type MutationImportUberOrganizationsCsvArgs = {
  input: ImportUberOrganizationsCsvInput;
};


export type MutationIssueGendaApiKeyArgs = {
  input: IssueGendaApiKeyInput;
};


export type MutationMarkAnnouncementArgs = {
  input: MarkAnnouncementInput;
};


export type MutationMarkHiccupTemporaryPermissionArgs = {
  input: MarkHiccupTemporaryPermissionInput;
};


export type MutationMarkOrganizationNotificationArgs = {
  input: MarkOrganizationNotificationInput;
};


export type MutationMarkOrganizationNotificationByAppointmentArgs = {
  input: MarkOrganizationNotificationByAppointmentInput;
};


export type MutationNotifyCheckinEntryArgs = {
  input: NotifyCheckinEntryInput;
};


export type MutationNotifyOutpatientQuestionnaireEntryArgs = {
  input: NotifyOutpatientQuestionnaireEntryInput;
};


export type MutationRechargeWithAppArgs = {
  input: RechargeWithAppInput;
};


export type MutationRechargeWithCashArgs = {
  input: RechargeWithCashInput;
};


export type MutationRecreateTracingReportArgs = {
  input: RecreateTracingReportInput;
};


export type MutationRemandUberSignatureArgs = {
  input: RemandUberSignatureInput;
};


export type MutationRemoveCompanyAddressArgs = {
  input: RemoveCompanyAddressInput;
};


export type MutationRemoveCompanyContactPointArgs = {
  input: RemoveCompanyContactPointInput;
};


export type MutationRemoveCompanySetupDocumentArgs = {
  input: RemoveCompanySetupDocumentInput;
};


export type MutationRemoveMedicalInstitutionSettingArgs = {
  input: RemoveMedicalInstitutionSettingInput;
};


export type MutationRemoveOrganizationContactPointArgs = {
  input: RemoveOrganizationContactPointInput;
};


export type MutationRemoveWebBookingsExceptionBusinessHourArgs = {
  input: RemoveWebBookingsExceptionBusinessHourInput;
};


export type MutationRequestAppointmentArgs = {
  input: RequestAppointmentInput;
};


export type MutationResendAuthenticationCodeArgs = {
  input: ResendAuthenticationCodeInput;
};


export type MutationRestartAgentArgs = {
  input: RestartAgentInput;
};


export type MutationResumeWebBookingsArgs = {
  input: ResumeWebBookingsInput;
};


export type MutationRevokeClientCertArgs = {
  input: RevokeClientCertInput;
};


export type MutationSendAuthenticationCodeAndRegisterPatientEmailArgs = {
  input: SendAuthenticationCodeAndRegisterPatientEmailInput;
};


export type MutationSendCallNotificationArgs = {
  input: SendCallNotificationInput;
};


export type MutationSendClientCertMailArgs = {
  input: SendClientCertMailInput;
};


export type MutationSendCongestionNotificationArgs = {
  input: SendCongestionNotificationInput;
};


export type MutationSendCongestionNotificationForWebVisitorArgs = {
  input: SendCongestionNotificationForWebVisitorInput;
};


export type MutationSendDispensingPreparedNotificationArgs = {
  input: SendDispensingPreparedNotificationInput;
};


export type MutationSendInvitationSmsArgs = {
  input: SendInvitationSmsInput;
};


export type MutationSendPractitionerCodeMailArgs = {
  input: SendPractitionerCodeMailInput;
};


export type MutationSendTracingReportArgs = {
  input: SendTracingReportInput;
};


export type MutationSetPractitionerRoleArgs = {
  input: SetPractitionerRoleInput;
};


export type MutationSignupCompanyArgs = {
  input: SignupCompanyInput;
};


export type MutationSignupPfPatientFromCheckinEntryArgs = {
  input: SignupPfPatientFromCheckinEntryInput;
};


export type MutationSignupPfPatientFromOutpatientQuestionnaireEntryArgs = {
  input: SignupPfPatientFromOutpatientQuestionnaireEntryInput;
};


export type MutationSkipEncounterArgs = {
  input: SkipEncounterInput;
};


export type MutationSubscribeChannelArgs = {
  input: SubscribeChannelInput;
};


export type MutationSuspendWebBookingsArgs = {
  input: SuspendWebBookingsInput;
};


export type MutationUnidentifyMedixsPatientArgs = {
  input: UnidentifyMedixsPatientInput;
};


export type MutationUnidentifyMedixsReceptionArgs = {
  input: UnidentifyMedixsReceptionInput;
};


export type MutationUnpublishOrganizationArgs = {
  input: UnpublishOrganizationInput;
};


export type MutationUnsubscribeChannelArgs = {
  input: UnsubscribeChannelInput;
};


export type MutationUpdateAgentDescriptionArgs = {
  input: UpdateAgentDescriptionInput;
};


export type MutationUpdateAgentPrintPrescriptionSettingArgs = {
  input: UpdatePrintPrescriptionSettingInput;
};


export type MutationUpdateAnnouncementArgs = {
  input: UpdateAnnouncementInput;
};


export type MutationUpdateAppointmentDeliveryMethodArgs = {
  input: UpdateAppointmentDeliveryMethodInput;
};


export type MutationUpdateAppointmentDescriptionArgs = {
  input: UpdateAppointmentDescriptionInput;
};


export type MutationUpdateB2cloudSettingArgs = {
  input: UpdateB2cloudSettingInput;
};


export type MutationUpdateBankAccountArgs = {
  input: UpdateBankAccountInput;
};


export type MutationUpdateCheckinDescriptionArgs = {
  input: UpdateCheckinDescriptionInput;
};


export type MutationUpdateCheckinSettingArgs = {
  input: UpdateCheckinSettingInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyAddressArgs = {
  input: UpdateCompanyAddressInput;
};


export type MutationUpdateCompanyAgentSettingArgs = {
  input: UpdateCompanyAgentSettingInput;
};


export type MutationUpdateCompanyContactPointArgs = {
  input: UpdateCompanyContactPointInput;
};


export type MutationUpdateCompanyFeeSettingArgs = {
  input: UpdateCompanyFeeSettingInput;
};


export type MutationUpdateCompanyPractitionerArgs = {
  input: UpdateCompanyPractitionerInput;
};


export type MutationUpdateCompanySessionSettingArgs = {
  input: UpdateCompanySessionSettingInput;
};


export type MutationUpdateContractArgs = {
  input: UpdateContractInput;
};


export type MutationUpdateContractPlanArgs = {
  input: UpdateContractPlanInput;
};


export type MutationUpdateDraftAppointmentDescriptionArgs = {
  input: UpdateDraftAppointmentDescriptionInput;
};


export type MutationUpdateFeatureArgs = {
  input: UpdateFeatureInput;
};


export type MutationUpdateFeatureTargetGroupArgs = {
  input: UpdateFeatureTargetGroupInput;
};


export type MutationUpdateGendaApiKeyArgs = {
  input: UpdateGendaApiKeyInput;
};


export type MutationUpdateGendaSettingArgs = {
  input: UpdateGendaSettingInput;
};


export type MutationUpdateGuestPatientFollowupCommentArgs = {
  input: UpdateGuestPatientFollowupCommentInput;
};


export type MutationUpdateMedicalInstitutionSettingArgs = {
  input: UpdateMedicalInstitutionSettingInput;
};


export type MutationUpdateMedicationFollowupMessage2Args = {
  input: UpdateMedicationFollowupMessage2Input;
};


export type MutationUpdateMedicationFollowupMessageTemplateArgs = {
  input: UpdateMedicationFollowupMessageTemplateInput;
};


export type MutationUpdateMedicationFollowupQuestionnaireArgs = {
  input: UpdateMedicationFollowupQuestionnaireInput;
};


export type MutationUpdateMedicationFollowupQuestionnairePositionArgs = {
  input: UpdateMedicationFollowupQuestionnairePositionInput;
};


export type MutationUpdateMedixsSettingArgs = {
  input: UpdateMedixsSettingInput;
};


export type MutationUpdateNotificationSettingArgs = {
  input: UpdateNotificationSettingInput;
};


export type MutationUpdateOperatorRoleArgs = {
  input: UpdateOperatorRoleInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationAddressArgs = {
  input: UpdateOrganizationAddressInput;
};


export type MutationUpdateOrganizationCompanyFeeSettingArgs = {
  input: UpdateOrganizationCompanyFeeSettingInput;
};


export type MutationUpdateOrganizationContactPointArgs = {
  input: UpdateOrganizationContactPointInput;
};


export type MutationUpdateOrganizationFeeSettingArgs = {
  input: UpdateOrganizationFeeSettingInput;
};


export type MutationUpdateOutpatientQuestionnaireDescriptionArgs = {
  input: UpdateOutpatientQuestionnaireDescriptionInput;
};


export type MutationUpdateOutpatientQuestionnaireSettingArgs = {
  input: UpdateOutpatientQuestionnaireSettingInput;
};


export type MutationUpdateOutpatientQuestionnaireSettingQuestionnaireArgs = {
  input: UpdateOutpatientQuestionnaireSettingQuestionnaireInput;
};


export type MutationUpdatePatientFollowupCommentArgs = {
  input: UpdatePatientFollowupCommentInput;
};


export type MutationUpdatePlanArgs = {
  input: UpdatePlanInput;
};


export type MutationUpdatePractitionerArgs = {
  input: UpdatePractitionerInput;
};


export type MutationUpdatePractitionerAuthenticationArgs = {
  input: UpdatePractitionerAuthenticationInput;
};


export type MutationUpdatePractitionerCodeArgs = {
  input: UpdatePractitionerCodeInput;
};


export type MutationUpdatePractitionerCodeForCompanyPractitionerArgs = {
  input: UpdatePractitionerCodeForCompanyPractitionerInput;
};


export type MutationUpdateUberSignatureInputDataArgs = {
  input: UpdateUberSignatureInputDataInput;
};


export type MutationUpdateWebBookingsBusinessHour2Args = {
  input: UpdateWebBookingsBusinessHour2Input;
};


export type MutationUpdateWebBookingsExceptionBusinessHourArgs = {
  input: UpdateWebBookingsExceptionBusinessHourInput;
};


export type MutationUpdateWebBookingsHolidayBusinessHourArgs = {
  input: UpdateWebBookingsHolidayBusinessHourInput;
};


export type MutationUpdateWebBookingsSettingArgs = {
  input: UpdateWebBookingsSettingInput;
};


export type MutationUpsertAgreementExtensionArgs = {
  input: UpsertAgreementExtensionInput;
};


export type MutationUpsertClientAuthenticationArgs = {
  input: UpsertClientAuthenticationInput;
};


export type MutationUpsertCompanyWebBookingsLimitSettingArgs = {
  input: UpsertCompanyWebBookingsLimitSettingInput;
};


export type MutationUpsertGuestPatientMedicationFollowupStatusArgs = {
  input: UpsertGuestPatientMedicationFollowupStatusInput;
};


export type MutationUpsertMedicationFollowupDraftMessageArgs = {
  input: UpsertMedicationFollowupDraftMessageInput;
};


export type MutationUpsertMedicationFollowupStatusSettingArgs = {
  input: UpsertMedicationFollowupStatusSettingInput;
};


export type MutationUpsertOrganizationArgs = {
  input: UpsertOrganizationInput;
};


export type MutationUpsertOrganizationsArgs = {
  input: UpsertOrganizationsInput;
};


export type MutationUpsertPatientMedicationFollowupStatusArgs = {
  input: UpsertPatientMedicationFollowupStatusInput;
};


export type MutationUpsertTracingReportDraftArgs = {
  input: UpsertTracingReportDraftInput;
};


export type MutationUpsertUberOrganizationSettingArgs = {
  input: UpsertUberOrganizationSettingInput;
};


export type MutationUpsertUberOrganizationSettingsArgs = {
  input: UpsertUberOrganizationSettingsInput;
};


export type MutationUpsertUberSignatureDraftArgs = {
  input: UpsertUberSignatureDraftInput;
};


export type MutationUpsertWebBookingsAllDayLimitArgs = {
  input: UpsertWebBookingsAllDayLimitInput;
};


export type MutationUpsertWebBookingsLimitArgs = {
  input: UpsertWebBookingsLimitInput;
};


export type MutationViewedMedicationFollowupQuestionnaireSheetArgs = {
  input: ViewedMedicationFollowupQuestionnaireSheetInput;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

export type NotificationSettingData = {
  __typename?: 'NotificationSettingData';
  /** 服薬フォローアップの通知設定 */
  medicationFollowupEnabled: Scalars['Boolean']['output'];
  /** オンライン服薬指導の通知設定 */
  onlineEnabled: Scalars['Boolean']['output'];
  /** サウンド設定 */
  sound: NotificationSettingSound;
  /** 電話通知設定 */
  tel: NotificationSettingTel;
};

export type NotificationSettingSound = {
  __typename?: 'NotificationSettingSound';
  enable: Scalars['Boolean']['output'];
  /** 未受付が残っている場合に [interval] 分間隔で音を鳴らす */
  interval?: Maybe<Scalars['Int']['output']>;
  /** サウンド名 */
  name: Scalars['String']['output'];
};

export type NotificationSettingTel = {
  __typename?: 'NotificationSettingTel';
  /** 申込があってから未受付が [delay] 分続いたら電話を鳴らす */
  delay: Scalars['Int']['output'];
  enable: Scalars['Boolean']['output'];
  formattedPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** 電話番号 */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of NotifyCheckinEntry */
export type NotifyCheckinEntryInput = {
  checkinEntryId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type NotifyCheckinEntryPayload = {
  __typename?: 'NotifyCheckinEntryPayload';
  checkinEntry: CheckinEntry;
};

/** Autogenerated input type of NotifyOutpatientQuestionnaireEntry */
export type NotifyOutpatientQuestionnaireEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  outpatientQuestionnaireEntryId: Scalars['ID']['input'];
};

export type NotifyOutpatientQuestionnaireEntryPayload = {
  __typename?: 'NotifyOutpatientQuestionnaireEntryPayload';
  outpatientQuestionnaireEntry: OutpatientQuestionnaireEntry;
};

export type Operator = Node & {
  __typename?: 'Operator';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  operatorRoles: Array<OperatorRole>;
};

export type OperatorAccessPermission = Node & {
  __typename?: 'OperatorAccessPermission';
  expiresAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
};

export type OperatorRole = Node & {
  __typename?: 'OperatorRole';
  abilities: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  operators: Array<Operator>;
};

/** 並び替える順序 */
export const OrderDirection = {
  /** 昇順 */
  Asc: 'asc',
  /** 降順 */
  Desc: 'desc'
} as const;

export type OrderDirection = typeof OrderDirection[keyof typeof OrderDirection];
export type Organization = Node & {
  __typename?: 'Organization';
  active: Scalars['Boolean']['output'];
  adminPractitioners: Array<Practitioner>;
  agent?: Maybe<Agent>;
  allPatients: AllPatientPage;
  appDownloadUrl: Scalars['String']['output'];
  appPromotionDownloadUrl: Scalars['String']['output'];
  appointmentCount: Scalars['Int']['output'];
  appointments: AppointmentPage;
  b2cloudSetting?: Maybe<B2cloudSetting>;
  bankAccount?: Maybe<BankAccount>;
  bookmarkedPatients: PatientPage;
  /** お気に入り登録しているアプリ患者の数 */
  bookmarkedPfPatientsCount: Scalars['Int']['output'];
  /** 取消金額の合計 */
  cancellationAmount: Scalars['Int']['output'];
  /** 決済金額の合計(取消は含まない) */
  chargeAmount: Scalars['Int']['output'];
  chargeHistories: ChargeHistoryPage;
  /** 決済から取消を引いた合計金額 */
  chargeTotals: Scalars['Int']['output'];
  checkinEntries: CheckinEntryPage;
  checkinSetting?: Maybe<CheckinSetting>;
  clientCerts: ClientCertPage;
  company: Company;
  /** 法人共通設定 */
  companyCommonSetting?: Maybe<CompanyCommonSetting>;
  /** 指定日の売上 */
  dailySalesDetail: OrganizationDailySalesDetail;
  descriptionCodes: Array<DescriptionCode>;
  directVisitorCandidates: DirectVisitorCandidatePage;
  directVisitors: DirectVisitorPage;
  /** 開示済のお薬手帳一覧を有効期限日時の降順で返す */
  disclosedMedicineNotes: DisclosedMedicineNotePage;
  /** 店舗で上書きした料金設定が存在するか */
  existCompanyOrganizationFeeSetting: Scalars['Boolean']['output'];
  /** 店舗で上書きした受付上限が存在するか */
  existWebBookingsLimit: Scalars['Boolean']['output'];
  faximoSendFaxes: FaximoSendFaxPage;
  /** 利用実績 */
  featureUsages: FeatureUsagePage;
  feeSettings: FeeSettingPage;
  /** お薬手帳閲覧許可を有効期限日時の降順で返す */
  hiccupTemporaryPermissions: HiccupTemporaryPermissionPage;
  id: Scalars['ID']['output'];
  /** 当日配達が進行中の予約数 */
  inDeliveryAppointmentCount: Scalars['Int']['output'];
  /** 未完了の予約数 */
  incompleteAppointmentCount?: Maybe<Scalars['Int']['output']>;
  /** 未完了のチェックイン数 */
  incompleteCheckinEntryCount: Scalars['Int']['output'];
  /** 未完了の仮予約数 */
  incompleteDraftAppointmentCount?: Maybe<Scalars['Int']['output']>;
  /** 送信前の服薬フォローアップメッセージ数 */
  incompleteMedicationFollowupMessageCount?: Maybe<Scalars['Int']['output']>;
  invitationCodes: InvitationCodePage;
  medicalInstitutionSetting?: Maybe<MedicalInstitutionSetting>;
  medicalInstitutionSettings: MedicalInstitutionSettingPage;
  medicationFollowupMessageTemplates: MedicationFollowupMessageTemplatePage;
  medicationFollowupMessages: MedicationFollowupMessagePage;
  /** 質問票を降順で返す */
  medicationFollowupQuestionnaireSheets: MedicationFollowupQuestionnaireSheetPage;
  medicationFollowupQuestionnaires: MedicationFollowupQuestionnairePage;
  medicationFollowupSetting?: Maybe<MedicationFollowupSetting>;
  medixsSetting?: Maybe<MedixsSetting>;
  name: Scalars['String']['output'];
  notificationSetting?: Maybe<OrganizationNotificationSetting>;
  organizationAddresses: Array<OrganizationAddress>;
  organizationContactPoints: Array<OrganizationContactPoint>;
  organizationNotifications: OrganizationNotificationPage;
  outpatientQuestionnaireSetting?: Maybe<OutpatientQuestionnaireSetting>;
  outpatientQuestionnaireSettingQuestionnaires: Array<OutpatientQuestionnaireSettingQuestionnaire>;
  patients: PatientConnection;
  payoutOrganizations: PayoutOrganizationPage;
  pharmacistPractitioners: Array<Practitioner>;
  position: Scalars['Int']['output'];
  practitionerAuthentications: Array<PractitionerAuthentication>;
  practitioners: PractitionerPage;
  privilege: Scalars['Boolean']['output'];
  receptions: ReceptionPage;
  slug: Scalars['String']['output'];
  uberOrganization?: Maybe<UberOrganization>;
  uberOrganizationSetting?: Maybe<UberOrganizationSetting>;
  unreadOrganizationNotifications: OrganizationNotificationPage;
  webBookingsSetting?: Maybe<WebBookingsSetting>;
};


export type OrganizationAllPatientsArgs = {
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  isFollowingUp?: InputMaybe<Scalars['Boolean']['input']>;
  latestMessageCreatedAt?: InputMaybe<Scalars['ISO8601Date']['input']>;
  orderBy?: InputMaybe<AllPatientOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  practitionerId?: InputMaybe<Scalars['ID']['input']>;
  searchWord?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationAppointmentCountArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']['input']>;
  statuses: Array<AppointmentStatus>;
  to?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type OrganizationAppointmentsArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  deliveryMethods?: InputMaybe<Array<AppointmentDeliveryMethod>>;
  orderBy?: InputMaybe<AppointmentOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<OrganizationAppointmentStatus>>;
};


export type OrganizationBookmarkedPatientsArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationBookmarkedPfPatientsCountArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationCancellationAmountArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']['input']>;
  paymentMethods?: InputMaybe<Array<PaymentMethod>>;
  to?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type OrganizationChargeAmountArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']['input']>;
  paymentMethods?: InputMaybe<Array<PaymentMethod>>;
  to?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type OrganizationChargeHistoriesArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']['input']>;
  order?: InputMaybe<OrderDirection>;
  page?: InputMaybe<Scalars['Int']['input']>;
  paymentMethods?: InputMaybe<Array<PaymentMethod>>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type OrganizationChargeTotalsArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']['input']>;
  paymentMethods?: InputMaybe<Array<PaymentMethod>>;
  to?: InputMaybe<Scalars['ISO8601Date']['input']>;
};


export type OrganizationCheckinEntriesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<CheckinEntryStatus>>;
};


export type OrganizationClientCertsArgs = {
  onlyRenewable?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  statusFilters?: InputMaybe<Array<ClientCertStatusFilter>>;
};


export type OrganizationDailySalesDetailArgs = {
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type OrganizationDirectVisitorCandidatesArgs = {
  includeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  searchWord?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationDirectVisitorsArgs = {
  includeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  searchWord?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationDisclosedMedicineNotesArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  onlyUnread?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationFaximoSendFaxesArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchWord?: InputMaybe<Scalars['String']['input']>;
};


export type OrganizationFeatureUsagesArgs = {
  month?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<FeatureUsageType>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationFeeSettingsArgs = {
  code?: InputMaybe<Array<LineItemCode>>;
  includeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationHiccupTemporaryPermissionsArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  onlyUnread?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationInvitationCodesArgs = {
  notApplied?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sendFailed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type OrganizationMedicalInstitutionSettingArgs = {
  medicalInstitutionName: Scalars['String']['input'];
};


export type OrganizationMedicalInstitutionSettingsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationMedicationFollowupMessageTemplatesArgs = {
  includeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationMedicationFollowupMessagesArgs = {
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  attachment?: InputMaybe<MedicationFollowupMessageAttachment>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  practitionerId?: InputMaybe<Scalars['ID']['input']>;
};


export type OrganizationMedicationFollowupQuestionnaireSheetsArgs = {
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  onlyUnread?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type OrganizationMedicationFollowupQuestionnairesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationOrganizationNotificationsArgs = {
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  onlyUncompleted?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<OrganizationNotificationType>>;
};


export type OrganizationPatientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationPayoutOrganizationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationPractitionersArgs = {
  includeNonActive?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationReceptionsArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  orderBy?: InputMaybe<AppointmentOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  patientName?: InputMaybe<Scalars['String']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<OrganizationAppointmentStatus>>;
};


export type OrganizationUnreadOrganizationNotificationsArgs = {
  from?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<OrganizationNotificationType>>;
};

export type OrganizationAddress = Node & {
  __typename?: 'OrganizationAddress';
  address: Address;
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
};

export const OrganizationAppointmentStatus = {
  /** 未受付 */
  Status1: 'status1',
  /** 指導待ち */
  Status2: 'status2',
  /** 未会計 */
  Status3: 'status3',
  /** 配達待ち */
  Status4: 'status4',
  /** 完了 */
  Status5: 'status5',
  /** キャンセル */
  Status6: 'status6',
  /** 集荷待ち */
  Status7: 'status7'
} as const;

export type OrganizationAppointmentStatus = typeof OrganizationAppointmentStatus[keyof typeof OrganizationAppointmentStatus];
export type OrganizationCompanyFeeSetting = Node & {
  __typename?: 'OrganizationCompanyFeeSetting';
  active: Scalars['Boolean']['output'];
  code: LineItemCode;
  defaultAmount?: Maybe<Scalars['Int']['output']>;
  defaultField: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  fixed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  subject: Scalars['String']['output'];
};

export type OrganizationContactPoint = Node & {
  __typename?: 'OrganizationContactPoint';
  contactPoint: ContactPoint;
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
};

export type OrganizationDailySales = {
  __typename?: 'OrganizationDailySales';
  /** 当日の返金有無 */
  isRefunded: Scalars['Boolean']['output'];
  /** 日付 */
  orderedAt: Scalars['ISO8601Date']['output'];
  organization: Organization;
  /** 当日の売上金額合計 */
  totalAmount: Scalars['Int']['output'];
  /** 当日のアプリ決済売上金額合計 */
  totalAppAmount: Scalars['Int']['output'];
  /** 当日の窓口決済売上金額合計 */
  totalCashAmount: Scalars['Int']['output'];
  /** 当日のサービス利用料 */
  totalFeeWithTax: Scalars['Int']['output'];
  /** 当日の支払金額 */
  totalPayout: Scalars['Int']['output'];
  /** 当日の当日配達利用料合計 */
  totalUberAmount: Scalars['Int']['output'];
};

export type OrganizationDailySalesDetail = {
  __typename?: 'OrganizationDailySalesDetail';
  /** 当日のアプリ決済の患者負担金内訳 */
  appBillingAmountDetail: Array<SubjectTotalAmount>;
  /** 当日のアプリ決済の配送料内訳 */
  appShippingFeeDetail: Array<SubjectTotalAmount>;
  /** 当日のアプリ決済の当日配達料内訳 */
  appUberDeliveryFeeDetail: Array<SubjectTotalAmount>;
  /** 当日の窓口決済の患者負担金内訳 */
  cashBillingAmountDetail: Array<SubjectTotalAmount>;
  /** 当日の窓口決済の配送料内訳 */
  cashShippingFeeDetail: Array<SubjectTotalAmount>;
  /** 指定日の店舗の売上 */
  organizationDailySales: OrganizationDailySales;
  /** 当日の返金履歴 */
  refundHistories?: Maybe<Array<RefundHistory>>;
};

export type OrganizationDailySalesPage = {
  __typename?: 'OrganizationDailySalesPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<OrganizationDailySales>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type OrganizationFeeSetting = Node & {
  __typename?: 'OrganizationFeeSetting';
  active: Scalars['Boolean']['output'];
  code: LineItemCode;
  defaultAmount?: Maybe<Scalars['Int']['output']>;
  defaultField: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  /** 削除不可 */
  fixed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  position: Scalars['Int']['output'];
  subject: Scalars['String']['output'];
};

export type OrganizationImportJobInformation = Node & {
  __typename?: 'OrganizationImportJobInformation';
  company?: Maybe<Company>;
  file?: Maybe<Blob>;
  id: Scalars['ID']['output'];
  /** エラーメッセージ */
  messages: Array<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  practitioner?: Maybe<Practitioner>;
  status: OrganizationImportJobInformationStatus;
  type: OrganizationImportJobInformationType;
  workerProgress: Scalars['Float']['output'];
};

/** The connection type for OrganizationImportJobInformation. */
export type OrganizationImportJobInformationConnection = {
  __typename?: 'OrganizationImportJobInformationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationImportJobInformationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OrganizationImportJobInformation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrganizationImportJobInformationEdge = {
  __typename?: 'OrganizationImportJobInformationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganizationImportJobInformation>;
};

export const OrganizationImportJobInformationStatus = {
  /** 失敗 */
  Failed: 'failed',
  /** 実行待ち */
  Pending: 'pending',
  /** 実行中 */
  Processing: 'processing',
  /** 成功 */
  Succeeded: 'succeeded'
} as const;

export type OrganizationImportJobInformationStatus = typeof OrganizationImportJobInformationStatus[keyof typeof OrganizationImportJobInformationStatus];
export const OrganizationImportJobInformationType = {
  /** 一括出力 */
  Export: 'export',
  /** 一括作成 */
  Import: 'import',
  /** 一括更新 */
  Upsert: 'upsert'
} as const;

export type OrganizationImportJobInformationType = typeof OrganizationImportJobInformationType[keyof typeof OrganizationImportJobInformationType];
export type OrganizationNotification = Node & {
  __typename?: 'OrganizationNotification';
  appointment?: Maybe<Appointment>;
  checkinEntry?: Maybe<CheckinEntry>;
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  draftAppointment?: Maybe<DraftAppointment>;
  faximoSendFax?: Maybe<FaximoSendFax>;
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  medicationFollowupMessage?: Maybe<MedicationFollowupMessage>;
  meta: Scalars['JSON']['output'];
  organization: Organization;
  outpatientQuestionnaireEntry?: Maybe<OutpatientQuestionnaireEntry>;
  subject: Scalars['String']['output'];
  type: OrganizationNotificationType;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type OrganizationNotificationPage = {
  __typename?: 'OrganizationNotificationPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<OrganizationNotification>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type OrganizationNotificationSetting = Node & {
  __typename?: 'OrganizationNotificationSetting';
  data: NotificationSettingData;
  id: Scalars['ID']['output'];
  organization: Organization;
};

export const OrganizationNotificationType = {
  /** エージェントとの接続が切断された */
  AgentDisconnected: 'agent_disconnected',
  /** 仮予約から本予約が作成された */
  AppointmentsBooked: 'appointments_booked',
  /** 予約がキャンセルされた */
  AppointmentsCancelled: 'appointments_cancelled',
  /** 予約が追加された */
  AppointmentsCreated: 'appointments_created',
  /** 当日配達で配達員が患者に荷物を届けられなかった */
  CanceledUberDelivery: 'canceled_uber_delivery',
  /** チェックインが追加された */
  CheckinEntriesCreated: 'checkin_entries_created',
  /** 当日配達で配達員が配達を完了した */
  DeliveredUberDelivery: 'delivered_uber_delivery',
  /** 仮予約が処方ありに変更された */
  DraftAppointmentsAvailable: 'draft_appointments_available',
  /** 仮予約がキャンセルされた */
  DraftAppointmentsCancelled: 'draft_appointments_cancelled',
  /** 仮予約の処方箋が変更された */
  DraftAppointmentsPrescriptionImagesUpdated: 'draft_appointments_prescription_images_updated',
  /** FAXの送信に失敗した */
  FaximoSendFaxesFailed: 'faximo_send_faxes_failed',
  /** 当日配達で配達員がマッチした */
  MatchedUberDelivery: 'matched_uber_delivery',
  /** 服薬フォローアップメッセージの送信に失敗した */
  MedicationFollowupMessagesFailed: 'medication_followup_messages_failed',
  /** Web問診が追加された */
  OutpatientQuestionnaireEntriesCreated: 'outpatient_questionnaire_entries_created',
  /** 当日配達で配達員が再度マッチした */
  ReassignedUberDelivery: 'reassigned_uber_delivery',
  /** 当日配達で配達員のマッチングに時間がかかっている */
  TimeElapsedUberDelivery: 'time_elapsed_uber_delivery',
  /** 当日配達でUberサポートによってキャンセルされた */
  UberSupportCanceledUberDelivery: 'uber_support_canceled_uber_delivery',
  /** 当日配達で配達員とマッチングせず自動でキャンセルされた */
  UnfulfilledUberDelivery: 'unfulfilled_uber_delivery'
} as const;

export type OrganizationNotificationType = typeof OrganizationNotificationType[keyof typeof OrganizationNotificationType];
export type OrganizationPage = {
  __typename?: 'OrganizationPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<Organization>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type OutpatientQuestionnaire = Node & {
  __typename?: 'OutpatientQuestionnaire';
  id: Scalars['ID']['output'];
  /** ラベル */
  label: Scalars['String']['output'];
  /** 質問 */
  questions: Array<OutpatientQuestionnaireQuestion>;
  /** タイトル */
  title: Scalars['String']['output'];
};

export type OutpatientQuestionnaireEntry = Node & {
  __typename?: 'OutpatientQuestionnaireEntry';
  address: Address;
  description: Scalars['String']['output'];
  directVisitor: DirectVisitor;
  enableNotification: Scalars['Boolean']['output'];
  enteredAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  /** 問診内容 */
  questionnaires: Array<OutpatientQuestionnaireSheetAnswer>;
  status: OutpatientQuestionnaireEntryStatus;
  /** 未読通知 */
  unreadOrganizationNotifications: Array<OrganizationNotification>;
};

/** Web問診テータス */
export const OutpatientQuestionnaireEntryStatus = {
  /** 未通知 */
  Entered: 'entered',
  /** 完了済み */
  Finished: 'finished',
  /** 通知済み */
  Notified: 'notified'
} as const;

export type OutpatientQuestionnaireEntryStatus = typeof OutpatientQuestionnaireEntryStatus[keyof typeof OutpatientQuestionnaireEntryStatus];
export type OutpatientQuestionnaireOrganization = Node & {
  __typename?: 'OutpatientQuestionnaireOrganization';
  active: Scalars['Boolean']['output'];
  appDownloadUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** 店舗名 */
  name: Scalars['String']['output'];
  /** 現在設定されている質問票 */
  outpatientQuestionnaire: OutpatientQuestionnaire;
};

export type OutpatientQuestionnaireQuestion = Node & {
  __typename?: 'OutpatientQuestionnaireQuestion';
  /** 選択肢 */
  choices: Array<Scalars['String']['output']>;
  /** 確認項目コード */
  descriptionCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** ラベル */
  label: Scalars['String']['output'];
  /** 表示順 */
  position: Scalars['Int']['output'];
  questionType: OutpatientQuestionnaireQuestionType;
  /** 必須項目かどうか */
  required: Scalars['Boolean']['output'];
  /** タイトル */
  title: Scalars['String']['output'];
};

export type OutpatientQuestionnaireQuestionInput = {
  /** 確認項目コード */
  descriptionCode?: InputMaybe<Scalars['String']['input']>;
  questionType: OutpatientQuestionnaireQuestionType;
  /** 必須項目かどうか */
  required: Scalars['Boolean']['input'];
  /** 質問名 */
  title: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

/** 質問形式 */
export const OutpatientQuestionnaireQuestionType = {
  /** チェックボックス */
  Check: 'check',
  /** ラジオボタン */
  Radio: 'radio',
  /** テキストボックス */
  Text: 'text'
} as const;

export type OutpatientQuestionnaireQuestionType = typeof OutpatientQuestionnaireQuestionType[keyof typeof OutpatientQuestionnaireQuestionType];
export type OutpatientQuestionnaireSetting = Node & {
  __typename?: 'OutpatientQuestionnaireSetting';
  /** 設定が有効かどうか */
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  outpatientQuestionnaireOrganization: OutpatientQuestionnaireOrganization;
};

export type OutpatientQuestionnaireSettingQuestionnaire = Node & {
  __typename?: 'OutpatientQuestionnaireSettingQuestionnaire';
  /** デフォルトのWeb問診表かどうか */
  default: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** 質問票 */
  outpatientQuestionnaire: OutpatientQuestionnaire;
  /** 表示順 */
  position: Scalars['Int']['output'];
  /** 使用中どうか */
  use: Scalars['Boolean']['output'];
};

export type OutpatientQuestionnaireSheetAnswer = {
  __typename?: 'OutpatientQuestionnaireSheetAnswer';
  /** 回答 */
  answers: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 質問 */
  title: Scalars['String']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Patient = Node & {
  __typename?: 'Patient';
  active: Scalars['Boolean']['output'];
  appointments: AppointmentPage;
  birthDate: Scalars['ISO8601Date']['output'];
  bookmark?: Maybe<Bookmark>;
  draftAppointments: DraftAppointmentPage;
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  medicationFollowupComments: PatientMedicationFollowupCommentPage;
  medicationFollowupDraftMessages: MedicationFollowupDraftMessagePage;
  medicationFollowupMessages: MedicationFollowupMessagePage;
  medicationFollowupStatus?: Maybe<PatientMedicationFollowupStatus>;
  /** 閲覧許可されていればPFからお薬手帳データを読み込んで返す */
  medicineNotes?: Maybe<Array<MedicineNote>>;
  medixsPatient?: Maybe<MedixsPatient>;
  messageDeliverResults: MessageDeliverResultPage;
  patientAttachments: PatientAttachmentPage;
  pfFirebaseUid?: Maybe<Scalars['String']['output']>;
  pfPatient?: Maybe<PfPatient>;
  phoneticFamilyName: Scalars['String']['output'];
  phoneticGivenName: Scalars['String']['output'];
  /** 問診 */
  questionnaireSheet?: Maybe<QuestionnaireSheet>;
  /** 問診 */
  questionnaires?: Maybe<Array<QuestionnaireSheetAnswer>>;
  sex: Sex;
  tracingReportDrafts: TracingReportDraftPage;
  /** 発行済みのトレーシングレポート一覧 */
  tracingReports: TracingReportPage;
};


export type PatientAppointmentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<OrganizationAppointmentStatus>>;
};


export type PatientDraftAppointmentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<DraftAppointmentStatus>>;
};


export type PatientMedicationFollowupCommentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientMedicationFollowupDraftMessagesArgs = {
  onlyByCurrentPractitioner?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientMedicationFollowupMessagesArgs = {
  onlyScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientMedicineNotesArgs = {
  from: Scalars['ISO8601Date']['input'];
  to: Scalars['ISO8601Date']['input'];
};


export type PatientMessageDeliverResultsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientPatientAttachmentsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  patientFrom?: InputMaybe<Scalars['Boolean']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientTracingReportDraftsArgs = {
  onlyByCurrentPractitioner?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type PatientTracingReportsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type PatientAttachment = Node & {
  __typename?: 'PatientAttachment';
  createdAt: Scalars['ISO8601DateTime']['output'];
  file: Blob;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  patientFrom: Scalars['Boolean']['output'];
};

export type PatientAttachmentPage = {
  __typename?: 'PatientAttachmentPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<PatientAttachment>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

/** The connection type for Patient. */
export type PatientConnection = {
  __typename?: 'PatientConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PatientEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Patient>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PatientEdge = {
  __typename?: 'PatientEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Patient>;
};

export type PatientMedicationFollowupComment = Node & {
  __typename?: 'PatientMedicationFollowupComment';
  /** フォローアップコメント */
  comment: Scalars['String']['output'];
  /** コメント作成時間 */
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** 送信者 */
  practitioner: Practitioner;
  /** コメント更新時間 */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PatientMedicationFollowupCommentPage = {
  __typename?: 'PatientMedicationFollowupCommentPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<PatientMedicationFollowupComment>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

/** 患者の服薬フォローアップステータス */
export const PatientMedicationFollowupStatus = {
  /** 完了 */
  Finished: 'finished',
  /** 対応中 */
  InProgress: 'in_progress'
} as const;

export type PatientMedicationFollowupStatus = typeof PatientMedicationFollowupStatus[keyof typeof PatientMedicationFollowupStatus];
export type PatientPage = {
  __typename?: 'PatientPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<Patient>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export const PaymentMethod = {
  App: 'app',
  Cash: 'cash'
} as const;

export type PaymentMethod = typeof PaymentMethod[keyof typeof PaymentMethod];
export type Payout = Node & {
  __typename?: 'Payout';
  company?: Maybe<Company>;
  /** 明細書作成時点の法人名 */
  companyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 月 */
  month: Scalars['Int']['output'];
  payoutOrganizations: PayoutOrganizationPage;
  /** インボイス対応前（2023年8月以前の支払い分）の場合、繰越がなければnullになる */
  qualifiedInvoice?: Maybe<QualifiedInvoice>;
  /** 支払金額合計 */
  totalPayment: Scalars['Int']['output'];
  /** 当日配達リリース前（2024年3月以前の支払い分）の場合、nullになる */
  uberInvoice?: Maybe<UberInvoice>;
  /** 年 */
  year: Scalars['Int']['output'];
};


export type PayoutPayoutOrganizationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type PayoutBankAccount = Node & {
  __typename?: 'PayoutBankAccount';
  /** 口座名義 */
  accountHolderName: Scalars['String']['output'];
  /** 口座番号 */
  accountNumber: Scalars['String']['output'];
  /** 口座種別(普通・当座) */
  accountType: PayoutBankAccountAccount;
  /** 全銀コード */
  bankCode: Scalars['String']['output'];
  /** 銀行名 */
  bankName: Scalars['String']['output'];
  /** 支店コード */
  branchCode: Scalars['String']['output'];
  /** 支店名 */
  branchName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payoutOrganization?: Maybe<PayoutOrganization>;
};

/** 口座種別 */
export const PayoutBankAccountAccount = {
  /** 普通 */
  Futsu: 'futsu',
  /** 当座 */
  Toza: 'toza'
} as const;

export type PayoutBankAccountAccount = typeof PayoutBankAccountAccount[keyof typeof PayoutBankAccountAccount];
export type PayoutOrganization = Node & {
  __typename?: 'PayoutOrganization';
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  /** 明細作成時点の店舗名 */
  organizationName?: Maybe<Scalars['String']['output']>;
  payout?: Maybe<Payout>;
  payoutBankAccount?: Maybe<PayoutBankAccount>;
  payoutSubjects: Array<PayoutSubject>;
};

export type PayoutOrganizationPage = {
  __typename?: 'PayoutOrganizationPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<PayoutOrganization>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type PayoutPage = {
  __typename?: 'PayoutPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<Payout>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type PayoutSubject = Node & {
  __typename?: 'PayoutSubject';
  /** 金額 */
  amount: Scalars['Int']['output'];
  code: PayoutSubjectCode;
  id: Scalars['ID']['output'];
  payoutOrganization?: Maybe<PayoutOrganization>;
};

/** 科目コード */
export const PayoutSubjectCode = {
  /** 決済総額 */
  Amount: 'amount',
  /** 決済総額の内訳(薬剤費) */
  BillingAmount: 'billing_amount',
  /** 取消総額 */
  CancellationAmount: 'cancellation_amount',
  /** 利用料 */
  Fee: 'fee',
  /** 税込み利用料 */
  FeeWithTax: 'fee_with_tax',
  /** 純利益 */
  Net: 'net',
  /** 当日配達利用料のrefunded分 */
  RefundedUberDeliveryFee: 'refunded_uber_delivery_fee',
  /** 決済総額の内訳(配送料) */
  ShippingFee: 'shipping_fee',
  /** 決済総額の内訳(当日配達利用料) */
  UberDeliveryFee: 'uber_delivery_fee'
} as const;

export type PayoutSubjectCode = typeof PayoutSubjectCode[keyof typeof PayoutSubjectCode];
/** https://www.hl7.org/fhir/datatypes.html#Address */
export type PfAddress = {
  __typename?: 'PfAddress';
  /** @gotags: validate:"max=100" */
  city: Scalars['String']['output'];
  /** @gotags: validate:"max=300" */
  line: Scalars['String']['output'];
  /** @gotags: validate:"omitempty,len=7,numeric" */
  postalCode: Scalars['String']['output'];
  /** @gotags: validate:"max=50" */
  prefecture: Scalars['String']['output'];
  /**
   * 1が最優先
   * @gotags: validate:"gt=0"
   */
  sequence: Scalars['Int']['output'];
  /** @gotags: validate:"ne=0" */
  type: PfAddressType;
  /** @gotags: validate:"ne=0" */
  use: PfAddressUse;
};

/**
 * 住所の種別を表す
 * http://hl7.org/fhir/ValueSet/address-type
 */
export const PfAddressType = {
  /** 実際の住所と郵便物の郵送先が同じである住所 */
  TypeBoth: 'TYPE_BOTH',
  /** 実際の住所 */
  TypePhysical: 'TYPE_PHYSICAL',
  /** 郵便物の郵送専用の住所（私書箱など？） */
  TypePostal: 'TYPE_POSTAL',
  TypeUnknown: 'TYPE_UNKNOWN'
} as const;

export type PfAddressType = typeof PfAddressType[keyof typeof PfAddressType];
/**
 * 住所の用途を表す
 * http://hl7.org/fhir/ValueSet/address-use
 */
export const PfAddressUse = {
  /** 請求書などの専用の送付先 */
  UseBilling: 'USE_BILLING',
  /** 自宅 */
  UseHome: 'USE_HOME',
  /** 現在利用されていない住所 */
  UseOld: 'USE_OLD',
  /** 一時的な住所 */
  UseTemp: 'USE_TEMP',
  UseUnknown: 'USE_UNKNOWN',
  /** オフィス */
  UseWork: 'USE_WORK'
} as const;

export type PfAddressUse = typeof PfAddressUse[keyof typeof PfAddressUse];
/**
 * Attachment
 * 患者アカウントのアップロードファイルを管理
 */
export type PfAttachment = {
  __typename?: 'PfAttachment';
  /** Content-Type */
  contentType: Scalars['String']['output'];
  /** RFC3339 */
  createdAt: Scalars['ISO8601Date']['output'];
  /** @gotags: validate:"required" */
  id: Scalars['ID']['output'];
  /** @gotags: validate:"required" */
  patientId: Scalars['ID']['output'];
  /** @gotags: validate:"min=0,max=100" */
  title: Scalars['String']['output'];
  /** RFC3339 */
  updatedAt: Scalars['ISO8601Date']['output'];
  /**
   * 有効期限付きの参照用URL
   * * 保険証画像の場合: 1day
   * * 処方箋画像の場合: 1day
   * * エクスポート用 JAHIS お薬手帳データ CSV の場合: 3min
   */
  url: Scalars['String']['output'];
};

/** https://www.hl7.org/fhir/datatypes.html#ContactPoint */
export type PfContactPoint = {
  __typename?: 'PfContactPoint';
  formattedValue?: Maybe<Scalars['String']['output']>;
  /**
   * 優先度。1 が最優先
   * @gotags: validate:"gt=0"
   */
  rank: Scalars['Int']['output'];
  /** @gotags: validate:"ne=0" */
  system: PfContactPointSystem;
  /** @gotags: validate:"ne=0" */
  use: PfContactPointUse;
  /**
   * 最大長はEMAILに合わせている
   * @gotags: validate:"max=254"
   */
  value: Scalars['String']['output'];
};

/**
 * 連絡先の通信方式を表す。
 * https://www.hl7.org/fhir/valueset-contact-point-system.html
 */
export const PfContactPointSystem = {
  /** メールアドレス */
  SystemEmail: 'SYSTEM_EMAIL',
  /** FAX 番号 */
  SystemFax: 'SYSTEM_FAX',
  /** その他 */
  SystemOther: 'SYSTEM_OTHER',
  /** pager/beeper/ポケベル */
  SystemPager: 'SYSTEM_PAGER',
  /** 電話番号 */
  SystemPhone: 'SYSTEM_PHONE',
  /** SMS 送信用の番号 */
  SystemSms: 'SYSTEM_SMS',
  SystemUnknown: 'SYSTEM_UNKNOWN',
  /** URL */
  SystemUrl: 'SYSTEM_URL'
} as const;

export type PfContactPointSystem = typeof PfContactPointSystem[keyof typeof PfContactPointSystem];
/**
 * 連絡先の用途を表す。
 * https://www.hl7.org/fhir/valueset-contact-point-use.html
 */
export const PfContactPointUse = {
  /** 自宅 */
  UseHome: 'USE_HOME',
  /** 携帯端末 */
  UseMobile: 'USE_MOBILE',
  /** 現在利用されていない連絡先 */
  UseOld: 'USE_OLD',
  /** 一時的な連絡先 */
  UseTemp: 'USE_TEMP',
  UseUnknown: 'USE_UNKNOWN',
  /** オフィス */
  UseWork: 'USE_WORK'
} as const;

export type PfContactPointUse = typeof PfContactPointUse[keyof typeof PfContactPointUse];
/**
 * DispensingRequest
 * 調剤の要求を表す。要求の作成元は医科システム、あるいは患者アプリを想定している。
 *
 * 作成元が医科システムの場合、一回の診察による処方につきこの要求が一つ作成される。
 * 要求に処方箋画像を含む場合、分割処方や薬剤が多いなどの理由により複数枚の画像が含まれる可能性がある。
 *
 * 作成元が患者アプリの場合、一回の調剤薬局予約につきこの要求が一つ作成される。
 * 複数の医療機関の処方箋を一度に受け付けてもらいたい場合など、この要求の中に複数の医療機関により発行された処方箋が含まれる場合がある。
 *
 * 要求を受け付けた調剤薬局システムは、予約完了時や全ての調剤が完了した時、あるいは分割調剤の一部の調剤が完了したときなど、
 * その進捗に応じてステータスフィールドや調剤薬局情報フィールドを更新する。
 */
export type PfDispensingRequest = Node & {
  __typename?: 'PfDispensingRequest';
  /** @gotags: validate:"required" */
  id: Scalars['ID']['output'];
  /**
   * この要求を作成した医科システムの情報。
   * 医科システム経由ではなく患者アプリから要求を作成した場合、値無しとなる。
   */
  medicalInstitution?: Maybe<PfDispensingRequestMedicalInstitution>;
  /** @gotags: validate:"required" */
  patientId: Scalars['ID']['output'];
  /**
   * この要求を受け付けた調剤薬局情報のリスト。
   * 通常、受け付けた調剤薬局がリストに１件登録される。
   * 分割調剤の場合、それぞれを受け付けた調剤薬局がリストに登録される。
   * @gotags: validate:"dive,required"
   */
  pharmacies: Array<PfDispensingRequestPharmacy>;
  /**
   * 処方箋画像。
   * @gotags: validate:"dive,required"
   */
  prescriptionImages: Array<Maybe<PfPrescriptionImage>>;
  /**
   * 処方箋画像の最終更新日時
   * RFC3339
   */
  prescriptionImagesUpdatedAt?: Maybe<Scalars['String']['output']>;
  /**
   * この要求を作成したサービスアカウント。
   * 患者アプリから要求を作成した場合、`SERVICE_ACCOUNT_APP` となる。
   * @gotags: validate:"ne=0"
   */
  requester: PfServiceAccount;
  sendMethod: PfDispensingRequestSendMethod;
  /**
   * 要求のステータス
   * @gotags: validate:"ne=0"
   */
  status: PfDispensingRequestStatus;
};

/**
 * 調剤要求を作成した医科システムにおける医療機関関連情報
 * NOTE: 基盤と医科システム間でコミュニケーションが必要な場合のトラッキング項目なので、調剤システムの業務画面でこれらの項目を表示するのは不適切な場合がある。
 * たとえば CLINICS では、システムの都合上、Physician に設定される名前は実際の処方箋に記載される処方医の名前とは異なる場合がある。
 */
export type PfDispensingRequestMedicalInstitution = {
  __typename?: 'PfDispensingRequestMedicalInstitution';
  /** @gotags: validate:"required" */
  consultation: PfDispensingRequestMedicalInstitutionConsultation;
  /** @gotags: validate:"required" */
  medicalInstitution: PfDispensingRequestMedicalInstitutionMedicalInstitution;
  /** @gotags: validate:"required" */
  physician: PfDispensingRequestMedicalInstitutionPhysician;
  /** @gotags: validate:"required" */
  prescription: PfDispensingRequestMedicalInstitutionPrescription;
};

/** 診察情報 */
export type PfDispensingRequestMedicalInstitutionConsultation = {
  __typename?: 'PfDispensingRequestMedicalInstitutionConsultation';
  /**
   * 診察日時 RFC3339
   * TODO validate rfc3339
   * @gotags: validate:"required"
   */
  consultedAt: Scalars['ISO8601DateTime']['output'];
  /**
   * 診療科名
   * @gotags: validate:"max=180"
   */
  departmentName: Scalars['String']['output'];
  /**
   * 医科システムにおける識別子
   * @gotags: validate:"required"
   */
  id: Scalars['ID']['output'];
};

/** 医療機関情報 */
export type PfDispensingRequestMedicalInstitutionMedicalInstitution = {
  __typename?: 'PfDispensingRequestMedicalInstitutionMedicalInstitution';
  /** @gotags: validate:"dive,required" */
  addresses: Array<PfAddress>;
  /**
   * 医科システムにおける識別子
   * @gotags: validate:"required"
   */
  id: Scalars['ID']['output'];
  /** @gotags: validate:"required,max=180" */
  name: Scalars['String']['output'];
  /** @gotags: validate:"dive,required" */
  telecoms: Array<PfContactPoint>;
};

/** 処方医の情報 */
export type PfDispensingRequestMedicalInstitutionPhysician = {
  __typename?: 'PfDispensingRequestMedicalInstitutionPhysician';
  /** @gotags: validate:"max=180" */
  familyName: Scalars['String']['output'];
  /** @gotags: validate:"max=180" */
  givenName: Scalars['String']['output'];
  /**
   * 医科システムにおける識別子
   * @gotags: validate:"required"
   */
  id: Scalars['ID']['output'];
  /** @gotags: validate:"max=180,katakana" */
  phoneticFamilyName: Scalars['String']['output'];
  /** @gotags: validate:"max=180,katakana" */
  phoneticGivenName: Scalars['String']['output'];
};

/** 処方箋情報 */
export type PfDispensingRequestMedicalInstitutionPrescription = {
  __typename?: 'PfDispensingRequestMedicalInstitutionPrescription';
  /**
   * 交付年月日
   * YYYY-MM-DD (RFC3339 date)
   * @gotags: validate:"required,date"
   */
  issuedDate: Scalars['ISO8601Date']['output'];
  /**
   * 有効期限の上書き。
   * 通常処方箋の有効期限は交付日より4日であるが、別の期限を設けたい場合ここに値を設定する。
   * YYYY-MM-DD (RFC3339 date)
   * @gotags: validate:"omitempty,date"
   */
  overrideExpirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

/**
 * 調剤要求を受け付ける調剤薬局関連情報
 * 医科システムと連係する場合、Pharmacy.name や Pharmacy.addresses などの情報をもとに処方箋原本を送付するため、
 * 正確な情報が設定される必要がある。
 */
export type PfDispensingRequestPharmacy = {
  __typename?: 'PfDispensingRequestPharmacy';
  dispensing?: Maybe<PfDispensingRequestPharmacyDispensing>;
  pharmacist?: Maybe<PfDispensingRequestPharmacyPharmacist>;
  /** @gotags: validate:"required" */
  pharmacy: PfDispensingRequestPharmacyPharmacy;
};

/** 調剤情報 */
export type PfDispensingRequestPharmacyDispensing = {
  __typename?: 'PfDispensingRequestPharmacyDispensing';
  /**
   * 調剤年月日
   * YYYY-MM-DD (RFC3339 date)
   * @gotags: validate:"required,date"
   */
  dispensedDate: Scalars['ISO8601Date']['output'];
};

/** 担当薬剤師の情報 */
export type PfDispensingRequestPharmacyPharmacist = {
  __typename?: 'PfDispensingRequestPharmacyPharmacist';
  /** @gotags: validate:"max=180" */
  familyName: Scalars['String']['output'];
  /** @gotags: validate:"max=180" */
  givenName: Scalars['String']['output'];
  /**
   * 調剤システムにおける識別子
   * @gotags: validate:"required"
   */
  id: Scalars['ID']['output'];
  /** @gotags: validate:"max=180,katakana" */
  phoneticFamilyName: Scalars['String']['output'];
  /** @gotags: validate:"max=180,katakana" */
  phoneticGivenName: Scalars['String']['output'];
};

/** 調剤薬局情報 */
export type PfDispensingRequestPharmacyPharmacy = {
  __typename?: 'PfDispensingRequestPharmacyPharmacy';
  /** @gotags: validate:"dive,required" */
  addresses: Array<PfAddress>;
  /**
   * 調剤システムにおける識別子
   * @gotags: validate:"required"
   */
  id: Scalars['ID']['output'];
  /** @gotags: validate:"required,max=180" */
  name: Scalars['String']['output'];
  /** @gotags: validate:"dive,required" */
  telecoms: Array<PfContactPoint>;
};

/** 処方箋データの送信方法 */
export const PfDispensingRequestSendMethod = {
  /** FAX */
  Fax: 'FAX',
  /** アップロード */
  Upload: 'UPLOAD'
} as const;

export type PfDispensingRequestSendMethod = typeof PfDispensingRequestSendMethod[keyof typeof PfDispensingRequestSendMethod];
/**
 * 調剤要求のステータス
 * * ステートマシン
 * * DRAFT --> <削除> (処方の取り消し)
 * * DRAFT --> AVAILABLE (調剤要求の準備が完了し予約可能になった)
 * * AVAILABLE --> <削除> (処方の取り消し)
 * * AVAILABLE --> BOOKED (薬局の予約完了)
 * * BOOKED --> AVAILABLE (予約キャンセル)
 * * BOOKED --> PENDING (疑義照会など処方情報の変更を依頼したいとき)
 * * BOOKED --> ACCEPTED（処方箋内容が確認され受理された）
 * * PENDING --> BOOKED (再度予約)
 * * PENDING --> AVAILABLE (予約キャンセル)
 * * ACCEPTED --> AVAILABLE （予約キャンセル)
 * * ACCEPTED --> FULFILLED （調剤完了）
 */
export const PfDispensingRequestStatus = {
  /**
   * 調剤薬局に内容が確認され受理された状態。
   * オンライン服薬指導の場合、この状態になれば医療機関は処方箋を送付してよしと判断する
   * * 処方箋情報の変更: 不可
   * * 調剤リクエスト削除: 不可
   */
  StatusAccepted: 'STATUS_ACCEPTED',
  /**
   * まだ予約も受付も行われていない状態、あるいはキャンセルされた状態
   * * 調剤リクエスト削除: 可能
   * * 処方箋情報の変更: 可能
   */
  StatusAvailable: 'STATUS_AVAILABLE',
  /**
   * 調剤薬局に予約が入った状態。まだその内容は調剤担当には確認されていない。
   * * 処方箋情報の変更: 不可
   * * 調剤リクエスト削除: 不可
   */
  StatusBooked: 'STATUS_BOOKED',
  StatusCanceled: 'STATUS_CANCELED',
  /**
   * 医科システム側で編集中などまだ準備中であることを示す。予約に用いることはできない
   * * 調剤リクエスト削除: 可能
   * * 処方箋情報の変更: 可能
   */
  StatusDraft: 'STATUS_DRAFT',
  /**
   * 一通りの調剤業務が完了した状態
   * * 処方箋情報の変更: 不可
   * * 調剤リクエスト削除: 不可
   */
  StatusFulfilled: 'STATUS_FULFILLED',
  StatusNotPrescribed: 'STATUS_NOT_PRESCRIBED',
  /**
   * 予約が行われたが、まだ予約確定に至っていない状態（処方箋画像の取り直しが必要など）
   * * 処方箋情報の変更: 可能
   * * 調剤リクエスト削除: 不可
   */
  StatusPending: 'STATUS_PENDING',
  StatusUnknown: 'STATUS_UNKNOWN',
  StatusWaitForBooking: 'STATUS_WAIT_FOR_BOOKING'
} as const;

export type PfDispensingRequestStatus = typeof PfDispensingRequestStatus[keyof typeof PfDispensingRequestStatus];
/**
 * InsuranceCard
 * 保険証画像
 */
export type PfInsuranceCard = {
  __typename?: 'PfInsuranceCard';
  /**
   * 紐づく Attachment
   * Content-Type は image/gif image/jpeg image/png application/pdf のみ許容
   * @gotags: validate:"required"
   */
  attachment: PfAttachment;
  /** RFC3339 */
  createdAt: Scalars['ISO8601Date']['output'];
  /** @gotags: validate:"required" */
  id: Scalars['ID']['output'];
  /** @gotags: validate:"required" */
  patientId: Scalars['ID']['output'];
  /** RFC3339 */
  updatedAt: Scalars['ISO8601Date']['output'];
  /** @gotags: validate:"required,rfc3339" */
  uploadedAt: Scalars['ISO8601Date']['output'];
};

export type PfInsuranceCards = {
  __typename?: 'PfInsuranceCards';
  insuranceCards: Array<PfInsuranceCard>;
  nextPageToken: Scalars['String']['output'];
};

/** https://www.hl7.org/fhir/patient.html#Patient */
export type PfPatient = Node & {
  __typename?: 'PfPatient';
  /**
   * 一旦最大5件まで登録可能にしている（特に理由なし）
   * @gotags: validate:"max=5,dive,required"
   */
  addresses: Array<PfAddress>;
  /**
   * YYYY-MM-DD (RFC3339 date)
   * @gotags: validate:"omitempty,date"
   */
  birthDate?: Maybe<Scalars['ISO8601Date']['output']>;
  children: Array<PfPatient>;
  family: Array<PfPatient>;
  /** @gotags: validate:"max=180" */
  familyName: Scalars['String']['output'];
  /** @gotags: validate:"max=180" */
  givenName: Scalars['String']['output'];
  /** @gotags: validate:"required" */
  id: Scalars['ID']['output'];
  insuranceCards?: Maybe<PfInsuranceCards>;
  parent?: Maybe<PfPatient>;
  /** @gotags: validate:"max=36" */
  parentId: Scalars['ID']['output'];
  /** @gotags: validate:"max=180,katakana" */
  phoneticFamilyName: Scalars['String']['output'];
  /** @gotags: validate:"max=180,katakana" */
  phoneticGivenName: Scalars['String']['output'];
  /** @gotags: validate:"oneof=0 1 2 9" */
  sex: PfSex;
  /**
   * アカウントの連絡先情報
   * 一旦最大5件まで登録可能（特に理由なし）
   * NOTE: 家族アカウントには親アカウントの連絡祭情報が引き継がれます
   * @gotags: validate:"max=5,dive,required"
   */
  telecoms: Array<PfContactPoint>;
};


/** https://www.hl7.org/fhir/patient.html#Patient */
export type PfPatientInsuranceCardsArgs = {
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * PrescriptionImage
 * 処方箋画像
 */
export type PfPrescriptionImage = Node & {
  __typename?: 'PfPrescriptionImage';
  /**
   * 紐づく Attachment
   * Content-Type は image/gif image/jpeg image/png application/pdf のみ許容
   * @gotags: validate:"required"
   */
  attachment: PfAttachment;
  /** @gotags: validate:"required" */
  id: Scalars['ID']['output'];
  /** @gotags: validate:"required" */
  patientId: Scalars['ID']['output'];
  /** @gotags: validate:"required,rfc3339" */
  uploadedAt: Scalars['ISO8601DateTime']['output'];
};

/**
 * サービスアカウント定義
 * See https://github.com/medley-inc/medical-platform/blob/develop/proto/def/model/datatype/service_account.proto
 */
export const PfServiceAccount = {
  ServiceAccountApp: 'SERVICE_ACCOUNT_APP',
  ServiceAccountClinics: 'SERVICE_ACCOUNT_CLINICS',
  ServiceAccountDentis: 'SERVICE_ACCOUNT_DENTIS',
  ServiceAccountPharms: 'SERVICE_ACCOUNT_PHARMS',
  ServiceAccountPlatform: 'SERVICE_ACCOUNT_PLATFORM',
  ServiceAccountUnknown: 'SERVICE_ACCOUNT_UNKNOWN'
} as const;

export type PfServiceAccount = typeof PfServiceAccount[keyof typeof PfServiceAccount];
/** https://ja.wikipedia.org/wiki/ISO_5218 */
export const PfSex = {
  Female: 'female',
  Male: 'male',
  Other: 'other',
  Unknown: 'unknown'
} as const;

export type PfSex = typeof PfSex[keyof typeof PfSex];
export type Plan = Node & {
  __typename?: 'Plan';
  extensions: Array<Extension>;
  features: Array<PlanFeature>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PlanFeature = Node & {
  __typename?: 'PlanFeature';
  /** 課金方法 */
  billingMethod: PlanFeatureBillingMethod;
  /** 機能識別コード */
  code: PlanFeatureCode;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** 提供機能の課金方法 */
export const PlanFeatureBillingMethod = {
  /** 定額 */
  Flat: 'flat',
  /** 従量 */
  Metered: 'metered'
} as const;

export type PlanFeatureBillingMethod = typeof PlanFeatureBillingMethod[keyof typeof PlanFeatureBillingMethod];
/** 機能識別コード */
export const PlanFeatureCode = {
  /** 店舗チェックイン */
  Checkin: 'checkin',
  /** 処方箋ネット受付 */
  Facetoface: 'facetoface',
  /** 服薬フォローアップ */
  Followup: 'followup',
  /** 電子お薬手帳 */
  MedicineNote: 'medicine_note',
  /** オンライン服薬指導 */
  Online: 'online',
  /** Web問診 */
  OutpatientQuestionnaire: 'outpatient_questionnaire',
  /** 処方箋自動印刷 */
  PrintPrescription: 'print_prescription',
  /** トレーシングレポート */
  TracingReport: 'tracing_report'
} as const;

export type PlanFeatureCode = typeof PlanFeatureCode[keyof typeof PlanFeatureCode];
export type PostalCode = {
  __typename?: 'PostalCode';
  /** 市区町村 */
  city: Scalars['String']['output'];
  /** 番地等(事業所郵便番号のみ) */
  line: Scalars['String']['output'];
  /** 郵便番号 */
  postalCode: Scalars['String']['output'];
  /** 都道府県 */
  prefecture: Scalars['String']['output'];
  /** 町域名 */
  town: Scalars['String']['output'];
};

export type PostalCodePage = {
  __typename?: 'PostalCodePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<PostalCode>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type Practitioner = Node & {
  __typename?: 'Practitioner';
  accreteMessages: AccreteMessagePage;
  active: Scalars['Boolean']['output'];
  authentication: PractitionerAuthentication;
  customToken?: Maybe<Scalars['String']['output']>;
  familyName: Scalars['String']['output'];
  featureNames: Array<Scalars['String']['output']>;
  givenName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  intercomUserHash?: Maybe<Scalars['String']['output']>;
  /** 代理ログイン中フラグ */
  isProxy: Scalars['Boolean']['output'];
  operatorAccessPermission?: Maybe<OperatorAccessPermission>;
  organization: Organization;
  otpSecret?: Maybe<PractitionerOtpSecret>;
  phoneticFamilyName: Scalars['String']['output'];
  phoneticGivenName: Scalars['String']['output'];
  planFeatureCodes: Array<PlanFeatureCode>;
  position: Scalars['Int']['output'];
  rawId: Scalars['ID']['output'];
  roles: Array<PractitionerRole>;
  signinHistory?: Maybe<PractitionerSigninHistory>;
};


export type PractitionerAccreteMessagesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type PractitionerAuthentication = {
  __typename?: 'PractitionerAuthentication';
  username: Scalars['String']['output'];
};

export const PractitionerCodeMailType = {
  /** アカウント登録 */
  Registration: 'registration',
  /** パスワード変更 */
  Reset: 'reset'
} as const;

export type PractitionerCodeMailType = typeof PractitionerCodeMailType[keyof typeof PractitionerCodeMailType];
export type PractitionerOtpSecret = Node & {
  __typename?: 'PractitionerOtpSecret';
  id: Scalars['ID']['output'];
  provisioningUri: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type PractitionerPage = {
  __typename?: 'PractitionerPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<Practitioner>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export const PractitionerRole = {
  /** 店舗管理者 */
  Admin: 'admin',
  /** 事務 */
  Clerk: 'clerk',
  /** 法人管理者 */
  CompanyAdmin: 'company_admin',
  /** 薬剤師 */
  Pharmacist: 'pharmacist'
} as const;

export type PractitionerRole = typeof PractitionerRole[keyof typeof PractitionerRole];
export type PractitionerSigninHistory = Node & {
  __typename?: 'PractitionerSigninHistory';
  id: Scalars['ID']['output'];
  practitioner: Practitioner;
  /** ログイン履歴 */
  signinHistories: Array<SigninHistory>;
};

export type PrintPrescriptionSetting = {
  __typename?: 'PrintPrescriptionSetting';
  /** 機能が有効かどうか */
  enable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** 印刷枚数 */
  printCount: Scalars['Int']['output'];
};

export type PrivilegeOrganization = Node & {
  __typename?: 'PrivilegeOrganization';
  /** 本部権限スタッフ一覧 */
  companyAdminPractitioners: Array<PrivilegeOrganizationPractitioner>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PrivilegeOrganizationPractitioner = Node & {
  __typename?: 'PrivilegeOrganizationPractitioner';
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type PublicAddress = Node & {
  __typename?: 'PublicAddress';
  city: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  line: Scalars['String']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  postalCode: Scalars['String']['output'];
  prefecture: Scalars['String']['output'];
  type: AddressType;
  use: AddressUse;
};

export type PublicAppointment = Node & {
  __typename?: 'PublicAppointment';
  cancellationReason?: Maybe<AppointmentCancellationReason>;
  id: Scalars['ID']['output'];
  organization: PublicOrganization;
  status: AppointmentStatus;
};

/** CheckinEntryからPIIを取り除いたオブジェクト */
export type PublicCheckinEntry = Node & {
  __typename?: 'PublicCheckinEntry';
  checkinOrganization: CheckinOrganization;
  enteredAt: Scalars['ISO8601DateTime']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  notifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** SMS配信先の携帯電話番号 */
  phoneNumber: Scalars['String']['output'];
  phoneticFamilyName: Scalars['String']['output'];
  phoneticGivenName: Scalars['String']['output'];
  status: CheckinEntryStatus;
};

export type PublicMedicationFollowupMessage = Node & {
  __typename?: 'PublicMedicationFollowupMessage';
  /** 回答可能=true */
  answerable: Scalars['Boolean']['output'];
  appDownloadUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  medicationFollowupQuestionnaireRevision?: Maybe<PublicMedicationFollowupQuestionnaireRevision>;
  medicationFollowupQuestionnaireSheet?: Maybe<PublicMedicationFollowupQuestionnaireSheet>;
  organizationName: Scalars['String']['output'];
};

export type PublicMedicationFollowupQuestionnaireRevision = Node & {
  __typename?: 'PublicMedicationFollowupQuestionnaireRevision';
  active: Scalars['Boolean']['output'];
  formData: MedicationFollowupQuestionnaireFormData;
  id: Scalars['ID']['output'];
  subject: Scalars['String']['output'];
};

export type PublicMedicationFollowupQuestionnaireSheet = Node & {
  __typename?: 'PublicMedicationFollowupQuestionnaireSheet';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
};

export type PublicOrganization = Node & {
  __typename?: 'PublicOrganization';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationAddresses: Array<PublicOrganizationAddress>;
  phoneNumber: Scalars['String']['output'];
  rawId: Scalars['String']['output'];
  webBookingsSetting: PublicWebBookingsSetting;
};

export type PublicOrganizationAddress = Node & {
  __typename?: 'PublicOrganizationAddress';
  address: PublicAddress;
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
};

export type PublicOrganizationPage = {
  __typename?: 'PublicOrganizationPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<PublicOrganization>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type PublicOutpatientQuestionnaireEntry = Node & {
  __typename?: 'PublicOutpatientQuestionnaireEntry';
  enableNotification: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organization: OutpatientQuestionnaireOrganization;
  signupPfPatientInformation?: Maybe<PublicSignupPfPatientInformation>;
};

/** SignupPfPatientInformationから患者側で必要になる値だけを持つオブジェクト */
export type PublicSignupPfPatientInformation = Node & {
  __typename?: 'PublicSignupPfPatientInformation';
  id: Scalars['ID']['output'];
  outpatientQuestionnaireEntry?: Maybe<PublicOutpatientQuestionnaireEntry>;
  signupPfPatientInformationOrganization: PublicSignupPfPatientInformationOrganization;
  tel?: Maybe<Scalars['String']['output']>;
};

export type PublicSignupPfPatientInformationOrganization = Node & {
  __typename?: 'PublicSignupPfPatientInformationOrganization';
  appDeeplink: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** 店舗名 */
  name: Scalars['String']['output'];
};

export type PublicSlot = Node & {
  __typename?: 'PublicSlot';
  date: Scalars['ISO8601Date']['output'];
  endAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  startAt: Scalars['ISO8601DateTime']['output'];
};

export type PublicWebBookingsSetting = Node & {
  __typename?: 'PublicWebBookingsSetting';
  /** 説明コメント */
  description: Scalars['String']['output'];
  /** 電子処方箋対応フラグ */
  electronicPrescription: Scalars['Boolean']['output'];
  /** 処方箋ネット受付フラグ */
  facetoface: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<Blob>;
  /** 予約公開フラグ */
  published: Scalars['Boolean']['output'];
  slots: Array<PublicSlot>;
};

export type QualifiedInvoice = {
  __typename?: 'QualifiedInvoice';
  id: Scalars['ID']['output'];
  monthlyPayoutStatements: MonthlyPayoutStatementPage;
  /** 各月のサービス利用料・事務取扱手数料に対して、月毎に消費税を計算し端数処理を施した上で合計した額 */
  tax: Scalars['Int']['output'];
  /** 事務取扱手数料（振込先口座数 * 手数料単価） */
  transferFee: Scalars['Int']['output'];
};


export type QualifiedInvoiceMonthlyPayoutStatementsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  __typename?: 'Query';
  announcements: AnnouncementPage;
  appointments: AppointmentConnection;
  bankBranch?: Maybe<BankBranch>;
  banks: BankPage;
  cities: Array<City>;
  /** クライアント証明書検証情報 */
  clientCertVerification?: Maybe<ClientCertVerification>;
  companySetupDocument?: Maybe<CompanySetupDocument>;
  /** CLINICSの医療機関検索で利用する市区町村一覧を返す */
  csCities: Array<CsCity>;
  /** CLINICSの医療機関検索で利用する診療科一覧を返す */
  csClinicCategories: Array<CsClinicCategory>;
  csClinics: CsClinicPage;
  /** 服薬フォローアップメッセージ/質問票の回答情報の一覧を降順で返す */
  events?: Maybe<EventPage>;
  holidays: Array<Holiday>;
  latestUberOrganizationImportJobInformation?: Maybe<UberOrganizationImportJobInformation>;
  me?: Maybe<LoginUser>;
  medicineNotePatientProfile?: Maybe<MedicineNotePatientProfile>;
  /** お薬手帳データを返す */
  medicineNotesByOnetimeCode?: Maybe<MedicineNotesByOnetimeCode>;
  /** お薬手帳データを返す */
  medicineNotesByPatient?: Maybe<MedicineNotesByPatient>;
  medicines: MedicinePage;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  organizations: OrganizationPage;
  patients: PatientConnection;
  postalCodes: PostalCodePage;
  practitioners: PractitionerPage;
  publicOrganizations: PublicOrganizationPage;
  unreadAnnouncements: AnnouncementConnection;
};


export type QueryAnnouncementsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAppointmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBankBranchArgs = {
  branchCode: Scalars['String']['input'];
  code: Scalars['String']['input'];
};


export type QueryBanksArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCitiesArgs = {
  prefectureCode: Scalars['String']['input'];
};


export type QueryCompanySetupDocumentArgs = {
  token: Scalars['String']['input'];
};


export type QueryCsCitiesArgs = {
  prefectureCode: Scalars['String']['input'];
};


export type QueryCsClinicsArgs = {
  categoryKey?: InputMaybe<Scalars['String']['input']>;
  cityCode?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  prefectureCode?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventsArgs = {
  guestPatientId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHolidaysArgs = {
  from: Scalars['ISO8601Date']['input'];
  to: Scalars['ISO8601Date']['input'];
};


export type QueryMedicineNotePatientProfileArgs = {
  patientId: Scalars['ID']['input'];
};


export type QueryMedicineNotesByOnetimeCodeArgs = {
  from: Scalars['ISO8601Date']['input'];
  onetimeCode: Scalars['String']['input'];
  to: Scalars['ISO8601Date']['input'];
};


export type QueryMedicineNotesByPatientArgs = {
  from?: InputMaybe<Scalars['ISO8601Date']['input']>;
  patientId: Scalars['ID']['input'];
  to: Scalars['ISO8601Date']['input'];
};


export type QueryMedicinesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPatientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryPostalCodesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  postalCode: Scalars['String']['input'];
};


export type QueryPractitionersArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPublicOrganizationsArgs = {
  cityCode?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryUnreadAnnouncementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionnaireSheet = {
  __typename?: 'QuestionnaireSheet';
  /** 回答 */
  answers: Array<QuestionnaireSheetAnswer>;
  /** 回答日時 */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type QuestionnaireSheetAnswer = {
  __typename?: 'QuestionnaireSheetAnswer';
  /** 質問 */
  title: Scalars['String']['output'];
  /** 回答 */
  value: Array<Scalars['String']['output']>;
};

export type QuestionnaireSheetAnswerInput = {
  /** 質問 */
  title: Scalars['String']['input'];
  /** 回答 */
  value: Array<Scalars['String']['input']>;
};

export type Quote = {
  __typename?: 'Quote';
  /** 配達可能かどうか */
  availableSameDayDelivery: Scalars['Boolean']['output'];
  /** 配達見込み料金 */
  fee: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type Reception = Appointment | CheckinEntry | DraftAppointment | OutpatientQuestionnaireEntry;

export type ReceptionPage = {
  __typename?: 'ReceptionPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<Reception>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type ReceptionUsage = {
  __typename?: 'ReceptionUsage';
  /** 実績（総回数） */
  allReceptionCount: Scalars['Int']['output'];
  /** キャンセル回数 */
  cancelledAppointmentCount: Scalars['Int']['output'];
  /** 処方箋ネット受付回数 */
  facetofaceAppointmentCount: Scalars['Int']['output'];
  /** 薬局 */
  organization: Organization;
  /** オンライン服薬指導回数 */
  telemedicineAppointmentCount: Scalars['Int']['output'];
};

export type ReceptionUsagePage = {
  __typename?: 'ReceptionUsagePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<ReceptionUsage>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

/** Autogenerated input type of RechargeWithApp */
export type RechargeWithAppInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<ChargeWithApp2LineItemInput>;
};

export type RechargeWithAppPayload = {
  __typename?: 'RechargeWithAppPayload';
  charge: Charge;
};

/** Autogenerated input type of RechargeWithCash */
export type RechargeWithCashInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  lineItems: Array<ChargeWithApp2LineItemInput>;
};

export type RechargeWithCashPayload = {
  __typename?: 'RechargeWithCashPayload';
  charge: Charge;
};

/** Autogenerated input type of RecreateTracingReport */
export type RecreateTracingReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tracingReportId: Scalars['ID']['input'];
};

export type RecreateTracingReportPayload = {
  __typename?: 'RecreateTracingReportPayload';
  tracingReport: TracingReport;
};

export type RefundHistory = Node & {
  __typename?: 'RefundHistory';
  afterChargeHistory: ChargeHistory;
  beforeChargeHistory: ChargeHistory;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  patient: Patient;
  refundedChargeHistory: ChargeHistory;
};

/** Autogenerated input type of RemandUberSignature */
export type RemandUberSignatureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  extraText?: InputMaybe<Scalars['String']['input']>;
  uberSignatureId: Scalars['ID']['input'];
};

export type RemandUberSignaturePayload = {
  __typename?: 'RemandUberSignaturePayload';
  uberSignature: UberSignature;
};

/** Autogenerated input type of RemoveCompanyAddress */
export type RemoveCompanyAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyAddressId: Scalars['ID']['input'];
};

export type RemoveCompanyAddressPayload = {
  __typename?: 'RemoveCompanyAddressPayload';
  companyAddress: CompanyAddress;
};

/** Autogenerated input type of RemoveCompanyContactPoint */
export type RemoveCompanyContactPointInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyContactPointId: Scalars['ID']['input'];
};

export type RemoveCompanyContactPointPayload = {
  __typename?: 'RemoveCompanyContactPointPayload';
  companyContactPoint: CompanyContactPoint;
};

/** Autogenerated input type of RemoveCompanySetupDocument */
export type RemoveCompanySetupDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companySetupDocumentId: Scalars['ID']['input'];
};

export type RemoveCompanySetupDocumentPayload = {
  __typename?: 'RemoveCompanySetupDocumentPayload';
  companySetupDocument: CompanySetupDocument;
};

/** Autogenerated input type of RemoveMedicalInstitutionSetting */
export type RemoveMedicalInstitutionSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  medicalInstitutionSettingId: Scalars['ID']['input'];
};

export type RemoveMedicalInstitutionSettingPayload = {
  __typename?: 'RemoveMedicalInstitutionSettingPayload';
  medicalInstitutionSetting: MedicalInstitutionSetting;
};

/** Autogenerated input type of RemoveOrganizationContactPoint */
export type RemoveOrganizationContactPointInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationContactPointId: Scalars['ID']['input'];
};

export type RemoveOrganizationContactPointPayload = {
  __typename?: 'RemoveOrganizationContactPointPayload';
  organizationContactPoint: OrganizationContactPoint;
};

/** Autogenerated input type of RemoveWebBookingsExceptionBusinessHour */
export type RemoveWebBookingsExceptionBusinessHourInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exceptionDate: Scalars['ISO8601Date']['input'];
  webBookingsSettingId: Scalars['ID']['input'];
};

export type RemoveWebBookingsExceptionBusinessHourPayload = {
  __typename?: 'RemoveWebBookingsExceptionBusinessHourPayload';
  webBookingsSetting: WebBookingsSetting;
};

/** Autogenerated input type of RequestAppointment */
export type RequestAppointmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  draftAppointmentId: Scalars['ID']['input'];
};

export type RequestAppointmentPayload = {
  __typename?: 'RequestAppointmentPayload';
  draftAppointment: DraftAppointment;
};

/** Autogenerated input type of ResendAuthenticationCode */
export type ResendAuthenticationCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  publicSignupPfPatientInformationId: Scalars['ID']['input'];
};

export type ResendAuthenticationCodePayload = {
  __typename?: 'ResendAuthenticationCodePayload';
  publicSignupPfPatientInformation: PublicSignupPfPatientInformation;
};

/** Autogenerated input type of RestartAgent */
export type RestartAgentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type RestartAgentPayload = {
  __typename?: 'RestartAgentPayload';
  agent: Agent;
};

/** Autogenerated input type of ResumeWebBookings */
export type ResumeWebBookingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  webBookingsSettingId: Scalars['ID']['input'];
};

export type ResumeWebBookingsPayload = {
  __typename?: 'ResumeWebBookingsPayload';
  webBookingsSuspend: WebBookingsSuspend;
};

/** Autogenerated input type of RevokeClientCert */
export type RevokeClientCertInput = {
  clientCertId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type RevokeClientCertPayload = {
  __typename?: 'RevokeClientCertPayload';
  clientCert: ClientCert;
};

/** Autogenerated input type of SendAuthenticationCodeAndRegisterPatientEmail */
export type SendAuthenticationCodeAndRegisterPatientEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SMSに送られた認証コード */
  pfAuthenticationCode: Scalars['String']['input'];
  publicSignupPfPatientInformationId: Scalars['ID']['input'];
};

export type SendAuthenticationCodeAndRegisterPatientEmailPayload = {
  __typename?: 'SendAuthenticationCodeAndRegisterPatientEmailPayload';
  publicSignupPfPatientInformation: PublicSignupPfPatientInformation;
};

/** Autogenerated input type of SendCallNotification */
export type SendCallNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  encounterId: Scalars['ID']['input'];
};

export type SendCallNotificationPayload = {
  __typename?: 'SendCallNotificationPayload';
  encounter: Encounter;
};

/** Autogenerated input type of SendClientCertMail */
export type SendClientCertMailInput = {
  clientCertId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** クライアント証明書の送信先メールアドレス */
  email: Scalars['String']['input'];
};

export type SendClientCertMailPayload = {
  __typename?: 'SendClientCertMailPayload';
  clientCert: ClientCert;
};

/** Autogenerated input type of SendCongestionNotificationForWebVisitor */
export type SendCongestionNotificationForWebVisitorInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  webVisitorId: Scalars['ID']['input'];
};

export type SendCongestionNotificationForWebVisitorPayload = {
  __typename?: 'SendCongestionNotificationForWebVisitorPayload';
  messageDeliver: MessageDeliver;
};

/** Autogenerated input type of SendCongestionNotification */
export type SendCongestionNotificationInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type SendCongestionNotificationPayload = {
  __typename?: 'SendCongestionNotificationPayload';
  appointment: Appointment;
};

/** Autogenerated input type of SendDispensingPreparedNotification */
export type SendDispensingPreparedNotificationInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type SendDispensingPreparedNotificationPayload = {
  __typename?: 'SendDispensingPreparedNotificationPayload';
  appointment: Appointment;
};

/** Autogenerated input type of SendInvitationSms */
export type SendInvitationSmsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** SMS本文 */
  content: Scalars['String']['input'];
  invitationCodeId: Scalars['ID']['input'];
  /** メモ */
  memo?: InputMaybe<Scalars['String']['input']>;
  /** SMS配信先の携帯電話番号 */
  phoneNumber: Scalars['String']['input'];
};

export type SendInvitationSmsPayload = {
  __typename?: 'SendInvitationSmsPayload';
  accreteMessage: AccreteMessage;
};

/** Autogenerated input type of SendPractitionerCodeMail */
export type SendPractitionerCodeMailInput = {
  clientCertId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  /** 送信メールの種類 */
  mailType: PractitionerCodeMailType;
  practitionerCode: Scalars['String']['input'];
  practitionerId: Scalars['ID']['input'];
};

export type SendPractitionerCodeMailPayload = {
  __typename?: 'SendPractitionerCodeMailPayload';
  practitioner: Practitioner;
};

/** Autogenerated input type of SendTracingReport */
export type SendTracingReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** FAX番号 */
  faxNumber: Scalars['String']['input'];
  tracingReportId: Scalars['ID']['input'];
};

export type SendTracingReportPayload = {
  __typename?: 'SendTracingReportPayload';
  faximoSendFax: FaximoSendFax;
};

export type SendgridEventActivity = Node & {
  __typename?: 'SendgridEventActivity';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** メール種類(Mailerのメソッド名) */
  mailKind: Scalars['String']['output'];
  status: SendgridEventActivityStatus;
};

export const SendgridEventActivityStatus = {
  /** 送信失敗 */
  Failed: 'failed',
  /** 送信準備中 */
  Pending: 'pending',
  /** 送信中 */
  Processing: 'processing',
  /** 送信成功 */
  Successed: 'successed'
} as const;

export type SendgridEventActivityStatus = typeof SendgridEventActivityStatus[keyof typeof SendgridEventActivityStatus];
/** Autogenerated input type of SetPractitionerRole */
export type SetPractitionerRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  practitionerId: Scalars['ID']['input'];
  roles: Array<PractitionerRole>;
};

export type SetPractitionerRolePayload = {
  __typename?: 'SetPractitionerRolePayload';
  practitioner: Practitioner;
};

export const Sex = {
  Female: 'female',
  Male: 'male',
  Other: 'other',
  Unknown: 'unknown'
} as const;

export type Sex = typeof Sex[keyof typeof Sex];
export type SigninHistory = {
  __typename?: 'SigninHistory';
  /** アクセス元のIPアドレス */
  ipAddress: Scalars['String']['output'];
  /** ログイン日時 */
  signinAt: Scalars['ISO8601DateTime']['output'];
  /** アクセス元のユーザーエージェント */
  userAgent: Scalars['String']['output'];
};

/** Autogenerated input type of SignupCompany */
export type SignupCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyAddressCity?: InputMaybe<Scalars['String']['input']>;
  companyAddressLine?: InputMaybe<Scalars['String']['input']>;
  companyAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  companyAddressPrefecture?: InputMaybe<Scalars['String']['input']>;
  companyFax?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyTel?: InputMaybe<Scalars['String']['input']>;
  organizationAddressCity?: InputMaybe<Scalars['String']['input']>;
  organizationAddressLine?: InputMaybe<Scalars['String']['input']>;
  organizationAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  organizationAddressPrefecture?: InputMaybe<Scalars['String']['input']>;
  organizationFax?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationTel?: InputMaybe<Scalars['String']['input']>;
  practitionerFamilyName?: InputMaybe<Scalars['String']['input']>;
  practitionerGivenName?: InputMaybe<Scalars['String']['input']>;
  practitionerPassword: Scalars['String']['input'];
  practitionerPhoneticFamilyName?: InputMaybe<Scalars['String']['input']>;
  practitionerPhoneticGivenName?: InputMaybe<Scalars['String']['input']>;
  practitionerUsername: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type SignupCompanyPayload = {
  __typename?: 'SignupCompanyPayload';
  company: Company;
  organization: Organization;
  practitioner: Practitioner;
};

/** Autogenerated input type of SignupPfPatientFromCheckinEntry */
export type SignupPfPatientFromCheckinEntryInput = {
  birthDate: Scalars['ISO8601Date']['input'];
  checkinEntryId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneticFamilyName: Scalars['String']['input'];
  phoneticGivenName: Scalars['String']['input'];
  sex: Scalars['Int']['input'];
  tel: Scalars['String']['input'];
};

export type SignupPfPatientFromCheckinEntryPayload = {
  __typename?: 'SignupPfPatientFromCheckinEntryPayload';
  publicSignupPfPatientInformation: PublicSignupPfPatientInformation;
};

export type SignupPfPatientFromOutpatientQuestionnaireEntryAddressInput = {
  city: Scalars['String']['input'];
  line: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
};

/** Autogenerated input type of SignupPfPatientFromOutpatientQuestionnaireEntry */
export type SignupPfPatientFromOutpatientQuestionnaireEntryInput = {
  address: SignupPfPatientFromOutpatientQuestionnaireEntryAddressInput;
  birthDate: Scalars['ISO8601Date']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  outpatientQuestionnaireEntryId: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  phoneticFamilyName: Scalars['String']['input'];
  phoneticGivenName: Scalars['String']['input'];
  sex: Scalars['Int']['input'];
  tel: Scalars['String']['input'];
};

export type SignupPfPatientFromOutpatientQuestionnaireEntryPayload = {
  __typename?: 'SignupPfPatientFromOutpatientQuestionnaireEntryPayload';
  publicSignupPfPatientInformation: PublicSignupPfPatientInformation;
};

/** Autogenerated input type of SkipEncounter */
export type SkipEncounterInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type SkipEncounterPayload = {
  __typename?: 'SkipEncounterPayload';
  appointment: Appointment;
};

export type SubjectTotalAmount = {
  __typename?: 'SubjectTotalAmount';
  /** 区分ラベル */
  label: Scalars['String']['output'];
  /** 区分金額合計 */
  totalAmount: Scalars['Int']['output'];
};

/** Autogenerated input type of SubscribeChannel */
export type SubscribeChannelInput = {
  channelId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type SubscribeChannelPayload = {
  __typename?: 'SubscribeChannelPayload';
  channelId: Scalars['String']['output'];
};

/** Autogenerated input type of SuspendWebBookings */
export type SuspendWebBookingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  untilAt: Scalars['ISO8601DateTime']['input'];
  webBookingsSettingId: Scalars['ID']['input'];
};

export type SuspendWebBookingsPayload = {
  __typename?: 'SuspendWebBookingsPayload';
  webBookingsSuspend: WebBookingsSuspend;
};

export type TracingReport = Node & {
  __typename?: 'TracingReport';
  createdAt: Scalars['ISO8601DateTime']['output'];
  data: TracingReportData;
  file?: Maybe<Blob>;
  id: Scalars['ID']['output'];
  latestSentFax?: Maybe<FaximoSendFax>;
  latestSentFaxByEvent?: Maybe<FaximoSendFax>;
  organization: Organization;
  status: JobInformationStatus;
  type: Scalars['String']['output'];
};

export type TracingReportData = {
  __typename?: 'TracingReportData';
  clinicName: Scalars['String']['output'];
  medicalInstitutionSetting?: Maybe<MedicalInstitutionSetting>;
  patientFamilyName?: Maybe<Scalars['String']['output']>;
  patientGivenName?: Maybe<Scalars['String']['output']>;
  pharmacistName: Scalars['String']['output'];
};

export type TracingReportDraft = Node & {
  __typename?: 'TracingReportDraft';
  data: TracingReportDraftData;
  guestPatient?: Maybe<GuestPatient>;
  id: Scalars['ID']['output'];
  patient?: Maybe<Patient>;
};

export type TracingReportDraftData = {
  __typename?: 'TracingReportDraftData';
  /** 医療機関名 */
  clinicName?: Maybe<Scalars['String']['output']>;
  /** 診療科 */
  clinicalDepartment?: Maybe<Scalars['String']['output']>;
  /** 調剤日 */
  dispensingDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** 担当医師名 */
  doctorName?: Maybe<Scalars['String']['output']>;
  /** 担当薬剤師 */
  pharmacistName?: Maybe<Scalars['String']['output']>;
  /** 対象薬剤 */
  prescriptionDrugs?: Maybe<Array<TracingReportDraftPrescriptionDrug>>;
  /** 処方箋発行日 */
  prescriptionIssueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** 報告事項 */
  report?: Maybe<Scalars['String']['output']>;
  /** 提案事項 */
  suggestion?: Maybe<Scalars['String']['output']>;
};

export type TracingReportDraftDataInput = {
  /** 医療機関名 */
  clinicName?: InputMaybe<Scalars['String']['input']>;
  /** 診療科 */
  clinicalDepartment?: InputMaybe<Scalars['String']['input']>;
  /** 調剤日 */
  dispensingDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** 担当医師名 */
  doctorName?: InputMaybe<Scalars['String']['input']>;
  /** 担当薬剤師 */
  pharmacistName?: InputMaybe<Scalars['String']['input']>;
  /** 対象薬剤 */
  prescriptionDrugs?: InputMaybe<Array<TracingReportDraftPrescriptionDrugInput>>;
  /** 処方箋発行日 */
  prescriptionIssueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** 報告事項 */
  report?: InputMaybe<Scalars['String']['input']>;
  /** 提案事項 */
  suggestion?: InputMaybe<Scalars['String']['input']>;
};

export type TracingReportDraftPage = {
  __typename?: 'TracingReportDraftPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<TracingReportDraft>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type TracingReportDraftPrescriptionDrug = {
  __typename?: 'TracingReportDraftPrescriptionDrug';
  drugName?: Maybe<Scalars['String']['output']>;
};

export type TracingReportDraftPrescriptionDrugInput = {
  /** 対象薬剤 */
  drugName?: InputMaybe<Scalars['String']['input']>;
};

export type TracingReportPage = {
  __typename?: 'TracingReportPage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<TracingReport>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export type TracingReportUsage = {
  __typename?: 'TracingReportUsage';
  /** 作成回数 */
  createdCount: Scalars['Int']['output'];
  /** 薬局 */
  organization: Organization;
  /** Fax送信回数 */
  sendCount: Scalars['Int']['output'];
};

export type TracingReportUsagePage = {
  __typename?: 'TracingReportUsagePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<TracingReportUsage>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

/** 当日配達可能エリア内かどうかの判定結果 */
export const UberAreaStatus = {
  /** 当日配達可能エリア内かどうか確認中 */
  Confirming: 'confirming',
  /** 当日配達可能エリア外 */
  Outside: 'outside',
  /** 当日配達可能エリア内 */
  Within: 'within'
} as const;

export type UberAreaStatus = typeof UberAreaStatus[keyof typeof UberAreaStatus];
export type UberCourier = {
  __typename?: 'UberCourier';
  id: Scalars['ID']['output'];
  /** Uberの配達員名 */
  name: Scalars['String']['output'];
  /** Uberの配達員の電話番号 */
  phoneNumber: Scalars['String']['output'];
  /** Uber配達員が薬局に到着する予定時間 */
  pickupScheduledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type UberDelivery = Node & {
  __typename?: 'UberDelivery';
  appointment: Appointment;
  /** 配達員情報 */
  courier?: Maybe<UberCourier>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** 配達完了時間 */
  deliveredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Uberの配達ID */
  deliveryId: Scalars['String']['output'];
  /** 配達料金 */
  fee: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** 無料キャンペーンに行われた配達かどうか */
  isFreePromotion: Scalars['Boolean']['output'];
  isTimeElapsedNotification: Scalars['Boolean']['output'];
  /** 請求額が正しいかどうか */
  isValidFee: Scalars['Boolean']['output'];
  /** Uberの配達受け取りID */
  orderNumber: Scalars['String']['output'];
  practitioner: Practitioner;
  /** 配達ステータス */
  status: UberDeliveryStatus;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type UberDeliveryInvoiceFee = {
  __typename?: 'UberDeliveryInvoiceFee';
  /** 当日配達を行った月 */
  deliveredMonth: Scalars['Int']['output'];
  /** 当日配達を行った年 */
  deliveredYear: Scalars['Int']['output'];
  totalUberDeliveryFee: Scalars['Int']['output'];
};

export type UberDeliveryInvoiceFeePage = {
  __typename?: 'UberDeliveryInvoiceFeePage';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  nodes: Array<UberDeliveryInvoiceFee>;
  nodesCount: Scalars['Int']['output'];
  pagesCount: Scalars['Int']['output'];
};

export const UberDeliveryStatus = {
  /** キャンセル(配達員に渡す前) */
  BeforeDropoffCanceled: 'before_dropoff_canceled',
  /** キャンセル(患者不在) */
  Canceled: 'canceled',
  /** 配達完了 */
  Delivered: 'delivered',
  /** 配達中 */
  Dropoff: 'dropoff',
  /** 集荷待ち */
  Pending: 'pending',
  /** 集荷済み */
  Pickup: 'pickup',
  /** キャンセル */
  Suspended: 'suspended',
  /** キャンセル(Uberサポートのキャンセル) */
  UberSupportCanceled: 'uber_support_canceled',
  /** キャンセル(自動キャンセル) */
  Unfulfilled: 'unfulfilled'
} as const;

export type UberDeliveryStatus = typeof UberDeliveryStatus[keyof typeof UberDeliveryStatus];
export type UberInvoice = {
  __typename?: 'UberInvoice';
  id: Scalars['ID']['output'];
  /** 各月の当日配達利用料合計に対して消費税を計算し端数処理を施した額 */
  tax: Scalars['Int']['output'];
  /** 法人単位の月次の当日配達利用料 */
  totalAmount: Scalars['Int']['output'];
};

export type UberOrganization = Node & {
  __typename?: 'UberOrganization';
  id: Scalars['ID']['output'];
  uberAreaStatus: UberAreaStatus;
};

export type UberOrganizationImportJobInformation = Node & {
  __typename?: 'UberOrganizationImportJobInformation';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  /** 当日配達設定一括更新ジョブの状況 */
  status: UberOrganizationImportJobInformationStatus;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** 店舗の当日配達エリアを一括更新する際のジョブ状況 */
export const UberOrganizationImportJobInformationStatus = {
  /** 失敗 */
  Failed: 'failed',
  /** 実行待ち */
  Pending: 'pending',
  /** 成功 */
  Succeeded: 'succeeded'
} as const;

export type UberOrganizationImportJobInformationStatus = typeof UberOrganizationImportJobInformationStatus[keyof typeof UberOrganizationImportJobInformationStatus];
export type UberOrganizationSetting = Node & {
  __typename?: 'UberOrganizationSetting';
  enable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type UberOrganizationSettingJobInformation = Node & {
  __typename?: 'UberOrganizationSettingJobInformation';
  /** ファイルのURL */
  file?: Maybe<Blob>;
  id: Scalars['ID']['output'];
  /** エラーメッセージ */
  messages: Array<Scalars['String']['output']>;
  /** 当日配達設定一括更新ジョブの状況 */
  status: UberOrganizationSettingJobInformationStatus;
};

/** 店舗の当日配達設定を一括更新、または一括出力する際のジョブ状況 */
export const UberOrganizationSettingJobInformationStatus = {
  /** 失敗 */
  Failed: 'failed',
  /** 実行待ち */
  Pending: 'pending',
  /** 実行中 */
  Processing: 'processing',
  /** 成功 */
  Succeeded: 'succeeded'
} as const;

export type UberOrganizationSettingJobInformationStatus = typeof UberOrganizationSettingJobInformationStatus[keyof typeof UberOrganizationSettingJobInformationStatus];
export type UberQuote = {
  __typename?: 'UberQuote';
  /** Uberへのリクエスト時のエラーコード */
  errorCode?: Maybe<UberQuoteErrorCode>;
  /** 配達見積もり時の料金 */
  fee?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** 配達見積もりID */
  quoteId?: Maybe<Scalars['String']['output']>;
};

/** UberQuoteで返却されるエラーコード */
export const UberQuoteErrorCode = {
  /** 配達エリア圏外である */
  AddressUndeliverable: 'address_undeliverable',
  /** 配達員が見つからず、集荷依頼できない */
  AddressUndeliverableLimitedCouriers: 'address_undeliverable_limited_couriers',
  /** その他のエラー */
  Other: 'other'
} as const;

export type UberQuoteErrorCode = typeof UberQuoteErrorCode[keyof typeof UberQuoteErrorCode];
export type UberSignature = Node & {
  __typename?: 'UberSignature';
  company: Company;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** 特別条件 */
  extraText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputData: UberSignatureData;
  /** 署名PDFのURL */
  pdf: Blob;
  signedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: UberSignatureStatus;
};

export type UberSignatureData = {
  __typename?: 'UberSignatureData';
  /** 会社登録住所 */
  companyAddress: Scalars['String']['output'];
  /** 会社電子メール */
  companyEmail: Scalars['String']['output'];
  /** 会社名 */
  companyName: Scalars['String']['output'];
  /** 会社連絡先電話番号 */
  companyPhoneNumber: Scalars['String']['output'];
  /** 会社法人等番号 */
  corporateNumber: Scalars['String']['output'];
  /** 個人事業主かどうか */
  isSelfEmployed?: Maybe<Scalars['Boolean']['output']>;
  /** 主たる連絡先電子メール */
  primaryContactEmail: Scalars['String']['output'];
  /** 主たる連絡先氏名（苗字） */
  primaryContactFamilyName: Scalars['String']['output'];
  /** 主たる連絡先氏名（名前） */
  primaryContactGivenName: Scalars['String']['output'];
  /** 主たる連絡先電話番号 */
  primaryContactPhone: Scalars['String']['output'];
  /** 責任者電子メール */
  responsiblePersonEmail: Scalars['String']['output'];
  /** 責任者氏名（苗字） */
  responsiblePersonFamilyName: Scalars['String']['output'];
  /** 責任者氏名（名前） */
  responsiblePersonGivenName: Scalars['String']['output'];
  /** 責任者電話番号 */
  responsiblePersonPhone: Scalars['String']['output'];
  /** 責任者肩書き */
  responsiblePersonTitle: Scalars['String']['output'];
  /** 署名 */
  signature: Scalars['String']['output'];
  /** 署名（苗字） */
  signatureFamilyName: Scalars['String']['output'];
  /** 署名（名前） */
  signatureGivenName: Scalars['String']['output'];
  /** 署名者肩書き */
  signatureTitle: Scalars['String']['output'];
};

export type UberSignatureDataInput = {
  /** 会社登録住所 */
  companyAddress: Scalars['String']['input'];
  /** 会社電子メール */
  companyEmail: Scalars['String']['input'];
  /** 会社名 */
  companyName: Scalars['String']['input'];
  /** 会社連絡先電話番号 */
  companyPhoneNumber: Scalars['String']['input'];
  /** 会社法人等番号 */
  corporateNumber?: InputMaybe<Scalars['String']['input']>;
  /** 個人事業主かどうか */
  isSelfEmployed: Scalars['Boolean']['input'];
  /** 主たる連絡先電子メール */
  primaryContactEmail: Scalars['String']['input'];
  /** 主たる連絡先氏名（苗字） */
  primaryContactFamilyName: Scalars['String']['input'];
  /** 主たる連絡先氏名（名前） */
  primaryContactGivenName: Scalars['String']['input'];
  /** 主たる連絡先電話番号 */
  primaryContactPhone: Scalars['String']['input'];
  /** 責任者電子メール */
  responsiblePersonEmail: Scalars['String']['input'];
  /** 責任者氏名（苗字） */
  responsiblePersonFamilyName: Scalars['String']['input'];
  /** 責任者氏名（名前） */
  responsiblePersonGivenName: Scalars['String']['input'];
  /** 責任者電話番号 */
  responsiblePersonPhone: Scalars['String']['input'];
  /** 責任者肩書き */
  responsiblePersonTitle: Scalars['String']['input'];
  /** 署名 */
  signature: Scalars['String']['input'];
  /** 署名（苗字） */
  signatureFamilyName: Scalars['String']['input'];
  /** 署名（名前） */
  signatureGivenName: Scalars['String']['input'];
  /** 署名者肩書き */
  signatureTitle: Scalars['String']['input'];
};

export type UberSignatureDraft = Node & {
  __typename?: 'UberSignatureDraft';
  company: Company;
  extraText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputData?: Maybe<UberSignatureDraftData>;
};

export type UberSignatureDraftData = {
  __typename?: 'UberSignatureDraftData';
  /** 会社登録住所 */
  companyAddress?: Maybe<Scalars['String']['output']>;
  /** 会社電子メール */
  companyEmail?: Maybe<Scalars['String']['output']>;
  /** 会社名 */
  companyName?: Maybe<Scalars['String']['output']>;
  /** 会社連絡先電話番号 */
  companyPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** 会社法人等番号 */
  corporateNumber?: Maybe<Scalars['String']['output']>;
  /** 個人事業主かどうか */
  isSelfEmployed?: Maybe<Scalars['Boolean']['output']>;
  /** 主たる連絡先電子メール */
  primaryContactEmail?: Maybe<Scalars['String']['output']>;
  /** 主たる連絡先氏名（苗字） */
  primaryContactFamilyName?: Maybe<Scalars['String']['output']>;
  /** 主たる連絡先氏名（名前） */
  primaryContactGivenName?: Maybe<Scalars['String']['output']>;
  /** 主たる連絡先電話番号 */
  primaryContactPhone?: Maybe<Scalars['String']['output']>;
  /** 責任者電子メール */
  responsiblePersonEmail?: Maybe<Scalars['String']['output']>;
  /** 責任者氏名（苗字） */
  responsiblePersonFamilyName?: Maybe<Scalars['String']['output']>;
  /** 責任者氏名（名前） */
  responsiblePersonGivenName?: Maybe<Scalars['String']['output']>;
  /** 責任者電話番号 */
  responsiblePersonPhone?: Maybe<Scalars['String']['output']>;
  /** 責任者肩書き */
  responsiblePersonTitle?: Maybe<Scalars['String']['output']>;
  /** 署名 */
  signature?: Maybe<Scalars['String']['output']>;
  /** 署名（苗字） */
  signatureFamilyName?: Maybe<Scalars['String']['output']>;
  /** 署名（名前） */
  signatureGivenName?: Maybe<Scalars['String']['output']>;
  /** 署名者肩書き */
  signatureTitle?: Maybe<Scalars['String']['output']>;
};

export type UberSignatureDraftDataInput = {
  /** 会社登録住所 */
  companyAddress?: InputMaybe<Scalars['String']['input']>;
  /** 会社電子メール */
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  /** 会社名 */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** 会社連絡先電話番号 */
  companyPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** 会社法人等番号 */
  corporateNumber?: InputMaybe<Scalars['String']['input']>;
  /** 個人事業主かどうか */
  isSelfEmployed?: InputMaybe<Scalars['Boolean']['input']>;
  /** 主たる連絡先電子メール */
  primaryContactEmail?: InputMaybe<Scalars['String']['input']>;
  /** 主たる連絡先氏名（苗字） */
  primaryContactFamilyName?: InputMaybe<Scalars['String']['input']>;
  /** 主たる連絡先氏名（名前） */
  primaryContactGivenName?: InputMaybe<Scalars['String']['input']>;
  /** 主たる連絡先電話番号 */
  primaryContactPhone?: InputMaybe<Scalars['String']['input']>;
  /** 責任者電子メール */
  responsiblePersonEmail?: InputMaybe<Scalars['String']['input']>;
  /** 責任者氏名（苗字） */
  responsiblePersonFamilyName?: InputMaybe<Scalars['String']['input']>;
  /** 責任者氏名（名前） */
  responsiblePersonGivenName?: InputMaybe<Scalars['String']['input']>;
  /** 責任者電話番号 */
  responsiblePersonPhone?: InputMaybe<Scalars['String']['input']>;
  /** 責任者肩書き */
  responsiblePersonTitle?: InputMaybe<Scalars['String']['input']>;
  /** 署名 */
  signature?: InputMaybe<Scalars['String']['input']>;
  /** 署名（苗字） */
  signatureFamilyName?: InputMaybe<Scalars['String']['input']>;
  /** 署名（名前） */
  signatureGivenName?: InputMaybe<Scalars['String']['input']>;
  /** 署名者肩書き */
  signatureTitle?: InputMaybe<Scalars['String']['input']>;
};

export const UberSignatureStatus = {
  /** 承認済み */
  Approved: 'approved',
  /** 差し戻し */
  Remanded: 'remanded',
  /** 承認待ち */
  WaitingForApproval: 'waiting_for_approval'
} as const;

export type UberSignatureStatus = typeof UberSignatureStatus[keyof typeof UberSignatureStatus];
/** Uber配達のキャンセル理由 */
export const UberUndeliverableReasonStatus = {
  /** 未受付 */
  CannotAccessCustomerLocation: 'cannot_access_customer_location',
  /** 住所不明 */
  CannotFindCustomerAddress: 'cannot_find_customer_address',
  /** 薬局起因でキャンセルした */
  CustomerRejectedOrder: 'customer_rejected_order',
  /** 利用ができない */
  CustomerUnavailable: 'customer_unavailable'
} as const;

export type UberUndeliverableReasonStatus = typeof UberUndeliverableReasonStatus[keyof typeof UberUndeliverableReasonStatus];
/** Autogenerated input type of UnidentifyMedixsPatient */
export type UnidentifyMedixsPatientInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  medixsPatientId: Scalars['ID']['input'];
};

export type UnidentifyMedixsPatientPayload = {
  __typename?: 'UnidentifyMedixsPatientPayload';
  medixsPatient: MedixsPatient;
};

/** Autogenerated input type of UnidentifyMedixsReception */
export type UnidentifyMedixsReceptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  medixsReceptionId: Scalars['ID']['input'];
};

export type UnidentifyMedixsReceptionPayload = {
  __typename?: 'UnidentifyMedixsReceptionPayload';
  medixsReception: MedixsReception;
};

/** Autogenerated input type of UnpublishOrganization */
export type UnpublishOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type UnpublishOrganizationPayload = {
  __typename?: 'UnpublishOrganizationPayload';
  organization: Organization;
};

/** Autogenerated input type of UnsubscribeChannel */
export type UnsubscribeChannelInput = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type UnsubscribeChannelPayload = {
  __typename?: 'UnsubscribeChannelPayload';
  channelId?: Maybe<Scalars['String']['output']>;
};

export type UpdateAdminPractitionerInput = {
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneticFamilyName?: InputMaybe<Scalars['String']['input']>;
  phoneticGivenName?: InputMaybe<Scalars['String']['input']>;
  practitionerId?: InputMaybe<Scalars['ID']['input']>;
  roles?: InputMaybe<Array<PractitionerRole>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateAgentDescription */
export type UpdateAgentDescriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
};

export type UpdateAgentDescriptionPayload = {
  __typename?: 'UpdateAgentDescriptionPayload';
  agent: Agent;
};

/** Autogenerated input type of UpdateAnnouncement */
export type UpdateAnnouncementInput = {
  active: Scalars['Boolean']['input'];
  announcementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  emergency?: InputMaybe<Scalars['Boolean']['input']>;
  subject: Scalars['String']['input'];
  type: AnnouncementType;
};

export type UpdateAnnouncementPayload = {
  __typename?: 'UpdateAnnouncementPayload';
  announcement: Announcement;
};

/** Autogenerated input type of UpdateAppointmentDeliveryMethod */
export type UpdateAppointmentDeliveryMethodInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod: AppointmentDeliveryMethod;
};

export type UpdateAppointmentDeliveryMethodPayload = {
  __typename?: 'UpdateAppointmentDeliveryMethodPayload';
  appointment: Appointment;
};

/** Autogenerated input type of UpdateAppointmentDescription */
export type UpdateAppointmentDescriptionInput = {
  appointmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
};

export type UpdateAppointmentDescriptionPayload = {
  __typename?: 'UpdateAppointmentDescriptionPayload';
  appointment: Appointment;
};

export type UpdateB2cloudSettingDataInput = {
  /** 請求先顧客コード(半角数字12文字) */
  customerCode?: InputMaybe<Scalars['String']['input']>;
  /** 会計時にデフォルトで表示する送り状種別 */
  defaultInvoiceType?: InputMaybe<B2cloudInvoiceType>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 品名１(全角/半角 25文字/50文字) */
  goodsName1?: InputMaybe<Scalars['String']['input']>;
  /** ご依頼主 */
  sender?: InputMaybe<UpdateB2cloudSettingSenderDataInput>;
  /** 運賃管理番号(半角数字2文字) */
  shippingFeeCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateB2cloudSetting */
export type UpdateB2cloudSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: UpdateB2cloudSettingDataInput;
  organizationId: Scalars['ID']['input'];
};

export type UpdateB2cloudSettingPayload = {
  __typename?: 'UpdateB2cloudSettingPayload';
  b2cloudSetting: B2cloudSetting;
};

export type UpdateB2cloudSettingSenderDataInput = {
  /** ご依頼主アパートマンション(全角/半角 16文字/32文字) */
  building?: InputMaybe<Scalars['String']['input']>;
  /** ご依頼主市区郡町村(12文字) */
  city?: InputMaybe<Scalars['String']['input']>;
  /** ご依頼主町・番地(16文字) */
  line?: InputMaybe<Scalars['String']['input']>;
  /** ご依頼主名前(全角/半角 16文字/32文字) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ご依頼主電話番号(半角数字15文字ハイフン含む) */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** ご依頼主電話番号枝番(半角数字2文字) */
  phoneBranchNumber?: InputMaybe<Scalars['String']['input']>;
  /** ご依頼主郵便番号(半角数字8文字ハイフンなし半角7文字も可) */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** ご依頼主都道府県(4文字) */
  prefecture?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateBankAccount */
export type UpdateBankAccountInput = {
  /** 口座名義 */
  accountHolderName: Scalars['String']['input'];
  /** 口座番号 */
  accountNumber: Scalars['String']['input'];
  /** 口座種別(普通・当座) */
  accountType: BankAccountAccount;
  /** 全銀コード */
  bankCode: Scalars['String']['input'];
  /** 銀行名 */
  bankName: Scalars['String']['input'];
  /** 支店コード */
  branchCode: Scalars['String']['input'];
  /** 支店名 */
  branchName: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type UpdateBankAccountPayload = {
  __typename?: 'UpdateBankAccountPayload';
  bankAccount: BankAccount;
};

/** Autogenerated input type of UpdateCheckinDescription */
export type UpdateCheckinDescriptionInput = {
  checkinEntryId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
};

export type UpdateCheckinDescriptionPayload = {
  __typename?: 'UpdateCheckinDescriptionPayload';
  checkinEntry: CheckinEntry;
};

/** Autogenerated input type of UpdateCheckinSetting */
export type UpdateCheckinSettingInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCheckinSettingPayload = {
  __typename?: 'UpdateCheckinSettingPayload';
  checkinSetting: CheckinSetting;
};

export type UpdateCompanyAddressAddressInput = {
  city: Scalars['String']['input'];
  line: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
};

/** Autogenerated input type of UpdateCompanyAddress */
export type UpdateCompanyAddressInput = {
  address: UpdateCompanyAddressAddressInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyAddressId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type UpdateCompanyAddressPayload = {
  __typename?: 'UpdateCompanyAddressPayload';
  companyAddress: CompanyAddress;
};

/** Autogenerated input type of UpdateCompanyAgentSetting */
export type UpdateCompanyAgentSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  proxyHost?: InputMaybe<Scalars['String']['input']>;
  proxyPort?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyAgentSettingPayload = {
  __typename?: 'UpdateCompanyAgentSettingPayload';
  agentSetting: CompanyAgentSetting;
};

export type UpdateCompanyContactPointContactPointInput = {
  system: ContactPointSystem;
  value: Scalars['String']['input'];
};

/** Autogenerated input type of UpdateCompanyContactPoint */
export type UpdateCompanyContactPointInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyContactPointId: Scalars['ID']['input'];
  contactPoint: UpdateCompanyContactPointContactPointInput;
  position: Scalars['Int']['input'];
};

export type UpdateCompanyContactPointPayload = {
  __typename?: 'UpdateCompanyContactPointPayload';
  companyContactPoint: CompanyContactPoint;
};

/** Autogenerated input type of UpdateCompanyFeeSetting */
export type UpdateCompanyFeeSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: LineItemCode;
  companyFeeSettingId: Scalars['ID']['input'];
  defaultAmount?: InputMaybe<Scalars['Int']['input']>;
  defaultField: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  subject: Scalars['String']['input'];
};

export type UpdateCompanyFeeSettingPayload = {
  __typename?: 'UpdateCompanyFeeSettingPayload';
  companyFeeSetting: CompanyFeeSetting;
};

/** Autogenerated input type of UpdateCompany */
export type UpdateCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyPayload = {
  __typename?: 'UpdateCompanyPayload';
  company: Company;
};

/** Autogenerated input type of UpdateCompanyPractitioner */
export type UpdateCompanyPractitionerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyPractitionerEmail: Scalars['String']['input'];
  companyPractitionerId: Scalars['ID']['input'];
  companyPractitionerTel: Scalars['String']['input'];
};

export type UpdateCompanyPractitionerPayload = {
  __typename?: 'UpdateCompanyPractitionerPayload';
  companyPractitioner: CompanyPractitioner;
  /** 窓口担当としての認証 */
  companyPractitionerConfirmation?: Maybe<CompanyPractitionerConfirmation>;
};

/** Autogenerated input type of UpdateCompanySessionSetting */
export type UpdateCompanySessionSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
};

export type UpdateCompanySessionSettingPayload = {
  __typename?: 'UpdateCompanySessionSettingPayload';
  companySessionSetting: CompanySessionSetting;
};

/** Autogenerated input type of UpdateContract */
export type UpdateContractInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  contractCount: Scalars['Int']['input'];
};

export type UpdateContractPayload = {
  __typename?: 'UpdateContractPayload';
  contract: Contract;
};

/** Autogenerated input type of UpdateContractPlan */
export type UpdateContractPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractPlanId: Scalars['ID']['input'];
  end?: InputMaybe<Scalars['ISO8601Date']['input']>;
  planId: Scalars['ID']['input'];
  start: Scalars['ISO8601Date']['input'];
};

export type UpdateContractPlanPayload = {
  __typename?: 'UpdateContractPlanPayload';
  contractPlan: ContractPlan;
};

/** Autogenerated input type of UpdateDraftAppointmentDescription */
export type UpdateDraftAppointmentDescriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  draftAppointmentId: Scalars['ID']['input'];
};

export type UpdateDraftAppointmentDescriptionPayload = {
  __typename?: 'UpdateDraftAppointmentDescriptionPayload';
  draftAppointment: DraftAppointment;
};

/** Autogenerated input type of UpdateFeature */
export type UpdateFeatureInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  featureId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type UpdateFeaturePayload = {
  __typename?: 'UpdateFeaturePayload';
  feature: Feature;
};

/** Autogenerated input type of UpdateFeatureTargetGroup */
export type UpdateFeatureTargetGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  featureTargetGroupId: Scalars['ID']['input'];
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  start?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  type?: InputMaybe<FeatureTargetGroupType>;
};

export type UpdateFeatureTargetGroupPayload = {
  __typename?: 'UpdateFeatureTargetGroupPayload';
  featureTargetGroup: FeatureTargetGroup;
};

/** Autogenerated input type of UpdateGendaApiKey */
export type UpdateGendaApiKeyInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  gendaApiKeyId: Scalars['ID']['input'];
  /** 連携先の名前 */
  partnerName: Scalars['String']['input'];
};

export type UpdateGendaApiKeyPayload = {
  __typename?: 'UpdateGendaApiKeyPayload';
  gendaApiKey: GendaApiKey;
};

/** Autogenerated input type of UpdateGendaSetting */
export type UpdateGendaSettingInput = {
  active: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  gendaSettingId: Scalars['ID']['input'];
};

export type UpdateGendaSettingPayload = {
  __typename?: 'UpdateGendaSettingPayload';
  gendaSetting: GendaSetting;
};

/** Autogenerated input type of UpdateGuestPatientFollowupComment */
export type UpdateGuestPatientFollowupCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  guestPatientMedicationFollowupCommentId: Scalars['ID']['input'];
  medicationFollowupStatus?: InputMaybe<PatientMedicationFollowupStatus>;
};

export type UpdateGuestPatientFollowupCommentPayload = {
  __typename?: 'UpdateGuestPatientFollowupCommentPayload';
  guestPatientMedicationFollowupComment: GuestPatientMedicationFollowupComment;
};

/** Autogenerated input type of UpdateMedicalInstitutionSetting */
export type UpdateMedicalInstitutionSettingInput = {
  attendingPhysicians: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clinicalDepartments: Array<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  medicalInstitutionName: Scalars['String']['input'];
  medicalInstitutionSettingId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMedicalInstitutionSettingPayload = {
  __typename?: 'UpdateMedicalInstitutionSettingPayload';
  medicalInstitutionSetting: MedicalInstitutionSetting;
};

/** Autogenerated input type of UpdateMedicationFollowupMessage2 */
export type UpdateMedicationFollowupMessage2Input = {
  autoReplyMessage?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  csClinicId?: InputMaybe<Scalars['String']['input']>;
  /** Medixs薬歴のイベントID */
  eventId?: InputMaybe<Scalars['Int']['input']>;
  medicationFollowupMessageId: Scalars['ID']['input'];
  medicationFollowupQuestionnaireRevisionId?: InputMaybe<Scalars['ID']['input']>;
  message: Scalars['String']['input'];
  sendAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  withAutoReplyQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMedicationFollowupMessage2Payload = {
  __typename?: 'UpdateMedicationFollowupMessage2Payload';
  medicationFollowupMessage: MedicationFollowupMessage;
};

/** Autogenerated input type of UpdateMedicationFollowupMessageTemplate */
export type UpdateMedicationFollowupMessageTemplateInput = {
  autoReplyMessage?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** CLNICSクリニックID */
  csClinicId?: InputMaybe<Scalars['String']['input']>;
  medicationFollowupMessageTemplateId: Scalars['ID']['input'];
  /** 質問票ID */
  medicationFollowupQuestionnaireId?: InputMaybe<Scalars['ID']['input']>;
  message: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  sendTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  sendTiming?: InputMaybe<Scalars['Int']['input']>;
  subject: Scalars['String']['input'];
  withAutoReplyQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
  /** 病院・診療所の紹介あり=true */
  withRecommendation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMedicationFollowupMessageTemplatePayload = {
  __typename?: 'UpdateMedicationFollowupMessageTemplatePayload';
  medicationFollowupMessageTemplate: MedicationFollowupMessageTemplate;
};

/** Autogenerated input type of UpdateMedicationFollowupQuestionnaire */
export type UpdateMedicationFollowupQuestionnaireInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  formData: MedicationFollowupQuestionnaireFormDataInput;
  medicationFollowupQuestionnaireId: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
};

export type UpdateMedicationFollowupQuestionnairePayload = {
  __typename?: 'UpdateMedicationFollowupQuestionnairePayload';
  medicationFollowupQuestionnaire: MedicationFollowupQuestionnaire;
};

/** Autogenerated input type of UpdateMedicationFollowupQuestionnairePosition */
export type UpdateMedicationFollowupQuestionnairePositionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  medicationFollowupQuestionnaireId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type UpdateMedicationFollowupQuestionnairePositionPayload = {
  __typename?: 'UpdateMedicationFollowupQuestionnairePositionPayload';
  medicationFollowupQuestionnaire: MedicationFollowupQuestionnaire;
};

/** Autogenerated input type of UpdateMedixsSetting */
export type UpdateMedixsSettingInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  pharmacyId: Scalars['String']['input'];
};

export type UpdateMedixsSettingPayload = {
  __typename?: 'UpdateMedixsSettingPayload';
  medixsSetting: MedixsSetting;
};

export type UpdateNotificationSettingDataInput = {
  /** 服薬フォローアップの通知設定 */
  medicationFollowupEnabled: Scalars['Boolean']['input'];
  /** オンライン服薬指導の通知設定 */
  onlineEnabled: Scalars['Boolean']['input'];
  /** サウンド設定 */
  sound: UpdateNotificationSettingSoundInput;
  /** 電話通知設定 */
  tel: UpdateNotificationSettingTelInput;
};

/** Autogenerated input type of UpdateNotificationSetting */
export type UpdateNotificationSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: UpdateNotificationSettingDataInput;
  organizationId: Scalars['ID']['input'];
};

export type UpdateNotificationSettingPayload = {
  __typename?: 'UpdateNotificationSettingPayload';
  organizationNotificationSetting: OrganizationNotificationSetting;
};

export type UpdateNotificationSettingSoundInput = {
  enable: Scalars['Boolean']['input'];
  /** 未受付が残っている場合に [interval] 分間隔で音を鳴らす */
  interval?: InputMaybe<Scalars['Int']['input']>;
  /** サウンド名 */
  name: Scalars['String']['input'];
};

export type UpdateNotificationSettingTelInput = {
  /** 申込があってから未受付が [delay] 分続いたら電話を鳴らす */
  delay: Scalars['Int']['input'];
  enable: Scalars['Boolean']['input'];
  /** 電話番号 */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateOperatorRole */
export type UpdateOperatorRoleInput = {
  abilities: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  operatorRoleId: Scalars['ID']['input'];
};

export type UpdateOperatorRolePayload = {
  __typename?: 'UpdateOperatorRolePayload';
  operatorRole: OperatorRole;
};

export type UpdateOrganizationAddressAddressInput = {
  city: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  line: Scalars['String']['input'];
  longitude: Scalars['Float']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
};

/** Autogenerated input type of UpdateOrganizationAddress */
export type UpdateOrganizationAddressInput = {
  address: UpdateOrganizationAddressAddressInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationAddressId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type UpdateOrganizationAddressPayload = {
  __typename?: 'UpdateOrganizationAddressPayload';
  organizationAddress: OrganizationAddress;
};

/** Autogenerated input type of UpdateOrganizationCompanyFeeSetting */
export type UpdateOrganizationCompanyFeeSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  defaultAmount?: InputMaybe<Scalars['Int']['input']>;
  defaultField: Scalars['Boolean']['input'];
  organizationCompanyFeeSettingId: Scalars['ID']['input'];
};

export type UpdateOrganizationCompanyFeeSettingPayload = {
  __typename?: 'UpdateOrganizationCompanyFeeSettingPayload';
  organizationCompanyFeeSetting: OrganizationCompanyFeeSetting;
};

export type UpdateOrganizationContactPointContactPointInput = {
  system: ContactPointSystem;
  value: Scalars['String']['input'];
};

/** Autogenerated input type of UpdateOrganizationContactPoint */
export type UpdateOrganizationContactPointInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactPoint: UpdateOrganizationContactPointContactPointInput;
  organizationContactPointId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

export type UpdateOrganizationContactPointPayload = {
  __typename?: 'UpdateOrganizationContactPointPayload';
  organizationContactPoint: OrganizationContactPoint;
};

/** Autogenerated input type of UpdateOrganizationFeeSetting */
export type UpdateOrganizationFeeSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: LineItemCode;
  defaultAmount?: InputMaybe<Scalars['Int']['input']>;
  defaultField: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  organizationFeeSettingId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  subject: Scalars['String']['input'];
};

export type UpdateOrganizationFeeSettingPayload = {
  __typename?: 'UpdateOrganizationFeeSettingPayload';
  organizationFeeSetting: OrganizationFeeSetting;
};

/** Autogenerated input type of UpdateOrganization */
export type UpdateOrganizationInput = {
  adminPractitioner?: InputMaybe<UpdateAdminPractitionerInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

export type UpdateOrganizationPayload = {
  __typename?: 'UpdateOrganizationPayload';
  adminPractitioner?: Maybe<Practitioner>;
  organization: Organization;
  practitionerCode?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateOutpatientQuestionnaireDescription */
export type UpdateOutpatientQuestionnaireDescriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  outpatientQuestionnaireEntryId: Scalars['ID']['input'];
};

export type UpdateOutpatientQuestionnaireDescriptionPayload = {
  __typename?: 'UpdateOutpatientQuestionnaireDescriptionPayload';
  outpatientQuestionnaireEntry: OutpatientQuestionnaireEntry;
};

/** Autogenerated input type of UpdateOutpatientQuestionnaireSetting */
export type UpdateOutpatientQuestionnaireSettingInput = {
  active: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOutpatientQuestionnaireSettingPayload = {
  __typename?: 'UpdateOutpatientQuestionnaireSettingPayload';
  outpatientQuestionnaireSetting: OutpatientQuestionnaireSetting;
};

/** Autogenerated input type of UpdateOutpatientQuestionnaireSettingQuestionnaire */
export type UpdateOutpatientQuestionnaireSettingQuestionnaireInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  outpatientQuestionnaireSettingQuestionnaireId: Scalars['ID']['input'];
  /** 質問 */
  questions: Array<OutpatientQuestionnaireQuestionInput>;
  /** Web問診票のタイトル */
  title: Scalars['String']['input'];
};

export type UpdateOutpatientQuestionnaireSettingQuestionnairePayload = {
  __typename?: 'UpdateOutpatientQuestionnaireSettingQuestionnairePayload';
  outpatientQuestionnaireSettingQuestionnaire: OutpatientQuestionnaireSettingQuestionnaire;
};

/** Autogenerated input type of UpdatePatientFollowupComment */
export type UpdatePatientFollowupCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  medicationFollowupStatus?: InputMaybe<PatientMedicationFollowupStatus>;
  patientMedicationFollowupCommentId: Scalars['ID']['input'];
};

export type UpdatePatientFollowupCommentPayload = {
  __typename?: 'UpdatePatientFollowupCommentPayload';
  patientMedicationFollowupComment: PatientMedicationFollowupComment;
};

/** Autogenerated input type of UpdatePlan */
export type UpdatePlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  featureIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  planId: Scalars['ID']['input'];
};

export type UpdatePlanPayload = {
  __typename?: 'UpdatePlanPayload';
  plan: Plan;
};

/** Autogenerated input type of UpdatePractitionerAuthentication */
export type UpdatePractitionerAuthenticationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  practitionerId: Scalars['ID']['input'];
  username: Scalars['String']['input'];
};

export type UpdatePractitionerAuthenticationPayload = {
  __typename?: 'UpdatePractitionerAuthenticationPayload';
  authentication: PractitionerAuthentication;
};

/** Autogenerated input type of UpdatePractitionerCodeForCompanyPractitioner */
export type UpdatePractitionerCodeForCompanyPractitionerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyPractitionerId: Scalars['ID']['input'];
};

export type UpdatePractitionerCodeForCompanyPractitionerPayload = {
  __typename?: 'UpdatePractitionerCodeForCompanyPractitionerPayload';
  companyPractitioner: CompanyPractitioner;
};

/** Autogenerated input type of UpdatePractitionerCode */
export type UpdatePractitionerCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  practitionerId: Scalars['ID']['input'];
};

export type UpdatePractitionerCodePayload = {
  __typename?: 'UpdatePractitionerCodePayload';
  practitioner: Practitioner;
  practitionerCode: Scalars['String']['output'];
};

/** Autogenerated input type of UpdatePractitioner */
export type UpdatePractitionerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  phoneticFamilyName: Scalars['String']['input'];
  phoneticGivenName: Scalars['String']['input'];
  practitionerId: Scalars['ID']['input'];
};

export type UpdatePractitionerPayload = {
  __typename?: 'UpdatePractitionerPayload';
  practitioner: Practitioner;
};

/** Autogenerated input type of UpdatePrintPrescriptionSetting */
export type UpdatePrintPrescriptionSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enable: Scalars['Boolean']['input'];
  printCount?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePrintPrescriptionSettingPayload = {
  __typename?: 'UpdatePrintPrescriptionSettingPayload';
  agent: Agent;
};

/** Autogenerated input type of UpdateUberSignatureInputData */
export type UpdateUberSignatureInputDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inputData: UberSignatureDraftDataInput;
  uberSignatureId: Scalars['ID']['input'];
};

export type UpdateUberSignatureInputDataPayload = {
  __typename?: 'UpdateUberSignatureInputDataPayload';
  uberSignature: UberSignature;
};

/** Autogenerated input type of UpdateWebBookingsBusinessHour2 */
export type UpdateWebBookingsBusinessHour2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dow: Dow;
  times: Array<BusinessHourTimeInput>;
  webBookingsSettingId: Scalars['ID']['input'];
};

export type UpdateWebBookingsBusinessHour2Payload = {
  __typename?: 'UpdateWebBookingsBusinessHour2Payload';
  webBookingsSetting: WebBookingsSetting;
};

/** Autogenerated input type of UpdateWebBookingsExceptionBusinessHour */
export type UpdateWebBookingsExceptionBusinessHourInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exceptionDate: Scalars['ISO8601Date']['input'];
  times: Array<BusinessHourTimeInput>;
  webBookingsSettingId: Scalars['ID']['input'];
};

export type UpdateWebBookingsExceptionBusinessHourPayload = {
  __typename?: 'UpdateWebBookingsExceptionBusinessHourPayload';
  webBookingsSetting: WebBookingsSetting;
};

/** Autogenerated input type of UpdateWebBookingsHolidayBusinessHour */
export type UpdateWebBookingsHolidayBusinessHourInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  times: Array<BusinessHourTimeInput>;
  webBookingsSettingId: Scalars['ID']['input'];
};

export type UpdateWebBookingsHolidayBusinessHourPayload = {
  __typename?: 'UpdateWebBookingsHolidayBusinessHourPayload';
  webBookingsSetting: WebBookingsSetting;
};

/** Autogenerated input type of UpdateWebBookingsSetting */
export type UpdateWebBookingsSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  electronicPrescription: Scalars['Boolean']['input'];
  facetoface: Scalars['Boolean']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  maxAppointmentCount: Scalars['Int']['input'];
  onlineQualificationConfirmation: Scalars['Boolean']['input'];
  onlineQualificationConfirmationUrl?: InputMaybe<Scalars['String']['input']>;
  openingHours: Scalars['String']['input'];
  published: Scalars['Boolean']['input'];
  telemedicine: Scalars['Boolean']['input'];
  useHoliday: Scalars['Boolean']['input'];
  webBookingsSettingId: Scalars['ID']['input'];
  website: Scalars['String']['input'];
};

export type UpdateWebBookingsSettingPayload = {
  __typename?: 'UpdateWebBookingsSettingPayload';
  webBookingsSetting: WebBookingsSetting;
};

/** Autogenerated input type of UpsertAgreementExtension */
export type UpsertAgreementExtensionInput = {
  active: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  /** 拡張機能コード */
  extensionCode: ExtensionCode;
};

export type UpsertAgreementExtensionPayload = {
  __typename?: 'UpsertAgreementExtensionPayload';
  agreementExtension: AgreementExtension;
};

/** Autogenerated input type of UpsertClientAuthentication */
export type UpsertClientAuthenticationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  enable: Scalars['Boolean']['input'];
  /** 開始日 */
  startAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type UpsertClientAuthenticationPayload = {
  __typename?: 'UpsertClientAuthenticationPayload';
  clientAuthentication: ClientAuthentication;
};

/** Autogenerated input type of UpsertCompanyWebBookingsLimitSetting */
export type UpsertCompanyWebBookingsLimitSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: WebBookingsLimitCode;
  companyId: Scalars['ID']['input'];
  companyWebBookingsLimitSettingId?: InputMaybe<Scalars['ID']['input']>;
  limit: Scalars['Int']['input'];
};

export type UpsertCompanyWebBookingsLimitSettingPayload = {
  __typename?: 'UpsertCompanyWebBookingsLimitSettingPayload';
  companyWebBookingsLimitSetting: CompanyWebBookingsLimitSetting;
};

/** Autogenerated input type of UpsertGuestPatientMedicationFollowupStatus */
export type UpsertGuestPatientMedicationFollowupStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  guestPatientId: Scalars['ID']['input'];
  /** 患者の服薬フォローアップステータス */
  medicationFollowupStatus: PatientMedicationFollowupStatus;
};

export type UpsertGuestPatientMedicationFollowupStatusPayload = {
  __typename?: 'UpsertGuestPatientMedicationFollowupStatusPayload';
  /** 服薬フォローアップステータス */
  guestPatientMedicationFollowupStatus: PatientMedicationFollowupStatus;
};

/** Autogenerated input type of UpsertMedicationFollowupDraftMessage */
export type UpsertMedicationFollowupDraftMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: MedicationFollowupDraftMessageDataInput;
  guestPatientId?: InputMaybe<Scalars['ID']['input']>;
  medicationFollowupDraftMessageId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertMedicationFollowupDraftMessagePayload = {
  __typename?: 'UpsertMedicationFollowupDraftMessagePayload';
  medicationFollowupDraftMessage: MedicationFollowupDraftMessage;
};

/** Autogenerated input type of UpsertMedicationFollowupStatusSetting */
export type UpsertMedicationFollowupStatusSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  statusManagement: Scalars['Boolean']['input'];
};

export type UpsertMedicationFollowupStatusSettingPayload = {
  __typename?: 'UpsertMedicationFollowupStatusSettingPayload';
  medicationFollowupSetting: MedicationFollowupSetting;
};

export type UpsertOrganizationAddressInput = {
  city: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  line: Scalars['String']['input'];
  longitude: Scalars['Float']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
};

export type UpsertOrganizationAdminPractitionerInput = {
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneticFamilyName?: InputMaybe<Scalars['String']['input']>;
  phoneticGivenName?: InputMaybe<Scalars['String']['input']>;
  practitionerId?: InputMaybe<Scalars['ID']['input']>;
  roles?: InputMaybe<Array<PractitionerRole>>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertOrganizationBankAccountInput = {
  /** 口座名義 */
  accountHolderName: Scalars['String']['input'];
  /** 口座番号 */
  accountNumber: Scalars['String']['input'];
  /** 口座種別(普通・当座) */
  accountType: BankAccountAccount;
  /** 全銀コード */
  bankCode: Scalars['String']['input'];
  /** 銀行名 */
  bankName: Scalars['String']['input'];
  /** 支店コード */
  branchCode: Scalars['String']['input'];
  /** 支店名 */
  branchName: Scalars['String']['input'];
};

/** Autogenerated input type of UpsertOrganization */
export type UpsertOrganizationInput = {
  address: UpsertOrganizationAddressInput;
  adminPractitioner: UpsertOrganizationAdminPractitionerInput;
  bankAccount: UpsertOrganizationBankAccountInput;
  businessHours: UpsertOrganizationWebBookingsBusinessHourInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  enableCompanyFeeSetting: Scalars['Boolean']['input'];
  enableCompanyWebBookingsLimitSetting: Scalars['Boolean']['input'];
  /** FAX番号 */
  faxNumber: Scalars['String']['input'];
  holidayBusinessHours: Array<BusinessHourTimeInput>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** 電話番号 */
  phoneNumber: Scalars['String']['input'];
  webBookingsSetting: UpsertOrganizationWebBookingsSettingInput;
};

export type UpsertOrganizationPayload = {
  __typename?: 'UpsertOrganizationPayload';
  adminPractitioner?: Maybe<Practitioner>;
  clientCert?: Maybe<ClientCert>;
  organization: Organization;
  practitionerCode?: Maybe<Scalars['String']['output']>;
};

export type UpsertOrganizationWebBookingsBusinessHourInput = {
  fri: Array<BusinessHourTimeInput>;
  mon: Array<BusinessHourTimeInput>;
  sat: Array<BusinessHourTimeInput>;
  sun: Array<BusinessHourTimeInput>;
  thu: Array<BusinessHourTimeInput>;
  tue: Array<BusinessHourTimeInput>;
  wed: Array<BusinessHourTimeInput>;
};

export type UpsertOrganizationWebBookingsSettingInput = {
  description: Scalars['String']['input'];
  electronicPrescription: Scalars['Boolean']['input'];
  facetoface: Scalars['Boolean']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  onlineQualificationConfirmation: Scalars['Boolean']['input'];
  onlineQualificationConfirmationUrl?: InputMaybe<Scalars['String']['input']>;
  openingHours: Scalars['String']['input'];
  published: Scalars['Boolean']['input'];
  telemedicine: Scalars['Boolean']['input'];
  useHoliday: Scalars['Boolean']['input'];
  website: Scalars['String']['input'];
};

/** Autogenerated input type of UpsertOrganizations */
export type UpsertOrganizationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  signedId: Scalars['ID']['input'];
};

export type UpsertOrganizationsPayload = {
  __typename?: 'UpsertOrganizationsPayload';
  organizationImportJobInformation: OrganizationImportJobInformation;
};

/** Autogenerated input type of UpsertPatientMedicationFollowupStatus */
export type UpsertPatientMedicationFollowupStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** 患者の服薬フォローアップステータス */
  medicationFollowupStatus: PatientMedicationFollowupStatus;
  patientId: Scalars['ID']['input'];
};

export type UpsertPatientMedicationFollowupStatusPayload = {
  __typename?: 'UpsertPatientMedicationFollowupStatusPayload';
  /** 服薬フォローアップステータス */
  patientMedicationFollowupStatus: PatientMedicationFollowupStatus;
};

/** Autogenerated input type of UpsertTracingReportDraft */
export type UpsertTracingReportDraftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: TracingReportDraftDataInput;
  guestPatientId?: InputMaybe<Scalars['ID']['input']>;
  patientId?: InputMaybe<Scalars['ID']['input']>;
  tracingReportDraftId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertTracingReportDraftPayload = {
  __typename?: 'UpsertTracingReportDraftPayload';
  tracingReportDraft: TracingReportDraft;
};

/** Autogenerated input type of UpsertUberOrganizationSetting */
export type UpsertUberOrganizationSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enable: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
};

export type UpsertUberOrganizationSettingPayload = {
  __typename?: 'UpsertUberOrganizationSettingPayload';
  uberOrganizationSetting: UberOrganizationSetting;
};

/** Autogenerated input type of UpsertUberOrganizationSettings */
export type UpsertUberOrganizationSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  signedId: Scalars['ID']['input'];
};

export type UpsertUberOrganizationSettingsPayload = {
  __typename?: 'UpsertUberOrganizationSettingsPayload';
  /** 店舗の当日配達設定一括アップサートのジョブ情報 */
  uberOrganizationSettingJobInformation: UberOrganizationSettingJobInformation;
};

/** Autogenerated input type of UpsertUberSignatureDraft */
export type UpsertUberSignatureDraftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  inputData: UberSignatureDraftDataInput;
};

export type UpsertUberSignatureDraftPayload = {
  __typename?: 'UpsertUberSignatureDraftPayload';
  uberSignatureDraft: UberSignatureDraft;
};

/** Autogenerated input type of UpsertWebBookingsAllDayLimit */
export type UpsertWebBookingsAllDayLimitInput = {
  allDayFacetofaceLimit?: InputMaybe<Scalars['Int']['input']>;
  allDayTelemedicineLimit?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  webBookingsBusinessHourId: Scalars['ID']['input'];
};

export type UpsertWebBookingsAllDayLimitPayload = {
  __typename?: 'UpsertWebBookingsAllDayLimitPayload';
  webBookingsLimit: WebBookingsLimit;
};

/** Autogenerated input type of UpsertWebBookingsLimit */
export type UpsertWebBookingsLimitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  limits: Array<UpsertWebBookingsLimitLimitInput>;
  webBookingsBusinessHourId: Scalars['ID']['input'];
};

export type UpsertWebBookingsLimitLimitInput = {
  endAt: Scalars['ISO8601DateTime']['input'];
  facetofaceLimit?: InputMaybe<Scalars['Int']['input']>;
  startAt: Scalars['ISO8601DateTime']['input'];
  telemedicineLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertWebBookingsLimitPayload = {
  __typename?: 'UpsertWebBookingsLimitPayload';
  webBookingsLimit: WebBookingsLimit;
};

/** Autogenerated input type of ViewedMedicationFollowupQuestionnaireSheet */
export type ViewedMedicationFollowupQuestionnaireSheetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  medicationFollowupQuestionnaireSheetId?: InputMaybe<Scalars['ID']['input']>;
  medicationFollowupQuestionnaireSheetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ViewedMedicationFollowupQuestionnaireSheetPayload = {
  __typename?: 'ViewedMedicationFollowupQuestionnaireSheetPayload';
  medicationFollowupQuestionnaireSheet?: Maybe<MedicationFollowupQuestionnaireSheet>;
  medicationFollowupQuestionnaireSheets?: Maybe<Array<MedicationFollowupQuestionnaireSheet>>;
};

export type WebBookingsBusinessHour = Node & {
  __typename?: 'WebBookingsBusinessHour';
  dow: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  times: Array<BusinessHourTime>;
  webBookingsLimit?: Maybe<WebBookingsLimit>;
};

export type WebBookingsExceptionBusinessHour = Node & {
  __typename?: 'WebBookingsExceptionBusinessHour';
  exceptionDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  times: Array<BusinessHourTime>;
};

export type WebBookingsExceptionDate = Node & {
  __typename?: 'WebBookingsExceptionDate';
  exceptionDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
};

export type WebBookingsHolidayBusinessHour = Node & {
  __typename?: 'WebBookingsHolidayBusinessHour';
  id: Scalars['ID']['output'];
  times: Array<BusinessHourTime>;
};

export type WebBookingsLimit = Node & {
  __typename?: 'WebBookingsLimit';
  allDayFacetofaceLimit?: Maybe<Scalars['Int']['output']>;
  allDayTelemedicineLimit?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  limits: Array<WebBookingsLimitLimit>;
};

export const WebBookingsLimitCode = {
  /** 処方箋ネット受付 */
  Facetoface: 'facetoface',
  /** オンライン服薬指導 */
  Telemedicine: 'telemedicine'
} as const;

export type WebBookingsLimitCode = typeof WebBookingsLimitCode[keyof typeof WebBookingsLimitCode];
export type WebBookingsLimitLimit = {
  __typename?: 'WebBookingsLimitLimit';
  /** 終了時間 */
  endAt: Scalars['ISO8601DateTime']['output'];
  /** 処方箋ネット受付の受付上限 */
  facetofaceLimit?: Maybe<Scalars['Int']['output']>;
  /** 開始時間 */
  startAt: Scalars['ISO8601DateTime']['output'];
  /** オンライン服薬指導の受付上限 */
  telemedicineLimit?: Maybe<Scalars['Int']['output']>;
};

export type WebBookingsSetting = Node & {
  __typename?: 'WebBookingsSetting';
  /** 説明コメント */
  description: Scalars['String']['output'];
  /** 電子処方箋対応フラグ */
  electronicPrescription: Scalars['Boolean']['output'];
  /** 処方箋ネット受付フラグ */
  facetoface: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<Blob>;
  /** 1日の最大予約受け入れ数 */
  maxAppointmentCount: Scalars['Int']['output'];
  /** オンライン資格確認対応（オンライン服薬指導） */
  onlineQualificationConfirmation: Scalars['Boolean']['output'];
  /** マイナ在宅Web URL */
  onlineQualificationConfirmationUrl?: Maybe<Scalars['String']['output']>;
  /** 営業時間 */
  openingHours: Scalars['String']['output'];
  /** 予約公開フラグ */
  published: Scalars['Boolean']['output'];
  /** 遠隔服薬指導フラグ */
  telemedicine: Scalars['Boolean']['output'];
  /** 祝日を休みとする */
  useHoliday: Scalars['Boolean']['output'];
  webBookingsBusinessHours: Array<WebBookingsBusinessHour>;
  webBookingsExceptionBusinessHours: Array<WebBookingsExceptionBusinessHour>;
  webBookingsExceptionDates: Array<WebBookingsExceptionDate>;
  webBookingsHolidayBusinessHour?: Maybe<WebBookingsHolidayBusinessHour>;
  webBookingsSuspend?: Maybe<WebBookingsSuspend>;
  /** ウェブサイトURL */
  website: Scalars['String']['output'];
};


export type WebBookingsSettingWebBookingsExceptionBusinessHoursArgs = {
  includePast?: InputMaybe<Scalars['Boolean']['input']>;
};


export type WebBookingsSettingWebBookingsExceptionDatesArgs = {
  includePast?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WebBookingsSuspend = Node & {
  __typename?: 'WebBookingsSuspend';
  id: Scalars['ID']['output'];
  untilAt: Scalars['ISO8601DateTime']['output'];
};

export type WebVisitor = Node & {
  __typename?: 'WebVisitor';
  active: Scalars['Boolean']['output'];
  appointment: Appointment;
  birthDate: Scalars['ISO8601Date']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  medicationFollowupComments: GuestPatientMedicationFollowupCommentPage;
  medicationFollowupDraftMessages: MedicationFollowupDraftMessagePage;
  medicationFollowupMessages: MedicationFollowupMessagePage;
  medicationFollowupStatus?: Maybe<PatientMedicationFollowupStatus>;
  medixsPatient?: Maybe<MedixsPatient>;
  messageDeliverResults: MessageDeliverResultPage;
  mobilePhone: Scalars['String']['output'];
  phoneticFamilyName: Scalars['String']['output'];
  phoneticGivenName: Scalars['String']['output'];
  /** 問診 */
  questionnaireSheet: QuestionnaireSheet;
  samePatient?: Maybe<Patient>;
  sex: Sex;
  tracingReportDrafts: TracingReportDraftPage;
  /** 発行済みのトレーシングレポート一覧 */
  tracingReports: TracingReportPage;
};


export type WebVisitorMedicationFollowupCommentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type WebVisitorMedicationFollowupDraftMessagesArgs = {
  onlyByCurrentPractitioner?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type WebVisitorMedicationFollowupMessagesArgs = {
  onlyScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type WebVisitorMessageDeliverResultsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type WebVisitorTracingReportDraftsArgs = {
  onlyByCurrentPractitioner?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type WebVisitorTracingReportsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type GetCitiesQueryVariables = Exact<{
  prefectureCode: Scalars['String']['input'];
}>;


export type GetCitiesQuery = { __typename?: 'Query', cities: Array<{ __typename?: 'City', city: string, jisCode: string }> };

export type GetPublicOrganizationsQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  cityCode?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type GetPublicOrganizationsQuery = { __typename?: 'Query', publicOrganizations: { __typename?: 'PublicOrganizationPage', hasNextPage: boolean, hasPreviousPage: boolean, nodesCount: number, pagesCount: number, nodes: Array<{ __typename?: 'PublicOrganization', id: string, name: string, phoneNumber: string, organizationAddresses: Array<{ __typename?: 'PublicOrganizationAddress', id: string, address: { __typename?: 'PublicAddress', id: string, city: string, line: string, postalCode: string, prefecture: string, type: AddressType, use: AddressUse } }>, webBookingsSetting: { __typename?: 'PublicWebBookingsSetting', id: string, electronicPrescription: boolean, logo?: { __typename?: 'Blob', signedId: string, url: string } | null } }> } };

export type SlotFragment = { __typename?: 'PublicSlot', id: string, date: string, startAt: string, endAt: string };

export type GetPharmacyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPharmacyQuery = { __typename?: 'Query', node?: { __typename?: 'Address' } | { __typename?: 'Agent' } | { __typename?: 'AgreementExtension' } | { __typename?: 'AllowList' } | { __typename?: 'Announcement' } | { __typename?: 'Appointment' } | { __typename?: 'B2cloudSetting' } | { __typename?: 'BankAccount' } | { __typename?: 'Bookmark' } | { __typename?: 'Charge' } | { __typename?: 'ChargeHistory' } | { __typename?: 'CheckinEntry' } | { __typename?: 'CheckinOrganization' } | { __typename?: 'ClientAuthentication' } | { __typename?: 'ClientCert' } | { __typename?: 'ClientCertJobInformation' } | { __typename?: 'Company' } | { __typename?: 'CompanyAddress' } | { __typename?: 'CompanyCommonSetting' } | { __typename?: 'CompanyContactPoint' } | { __typename?: 'CompanyFeeSetting' } | { __typename?: 'CompanyPractitioner' } | { __typename?: 'CompanyPractitionerConfirmation' } | { __typename?: 'CompanyPractitionerContactPoint' } | { __typename?: 'CompanySessionSetting' } | { __typename?: 'CompanySetupDocument' } | { __typename?: 'CompanyWebBookingsLimitSetting' } | { __typename?: 'ContactPoint' } | { __typename?: 'Contract' } | { __typename?: 'ContractPlan' } | { __typename?: 'DirectVisitor' } | { __typename?: 'DraftAppointment' } | { __typename?: 'Encounter' } | { __typename?: 'Extension' } | { __typename?: 'FaximoSendFax' } | { __typename?: 'Feature' } | { __typename?: 'FeatureTargetGroup' } | { __typename?: 'FeatureUsage' } | { __typename?: 'GendaApiKey' } | { __typename?: 'GendaSetting' } | { __typename?: 'GuestPatientMedicationFollowupComment' } | { __typename?: 'HiccupAppointmentPermission' } | { __typename?: 'HiccupOnetimeApiCache' } | { __typename?: 'HiccupTemporaryPermission' } | { __typename?: 'InvitationCode' } | { __typename?: 'Invoice' } | { __typename?: 'MedicalInstitutionSetting' } | { __typename?: 'MedicationFollowupAutoReplySetting' } | { __typename?: 'MedicationFollowupAutoReplySettingTemplate' } | { __typename?: 'MedicationFollowupDraftMessage' } | { __typename?: 'MedicationFollowupMessage' } | { __typename?: 'MedicationFollowupMessageTemplate' } | { __typename?: 'MedicationFollowupMessageTemplateJobInformation' } | { __typename?: 'MedicationFollowupQuestionnaire' } | { __typename?: 'MedicationFollowupQuestionnaireRevision' } | { __typename?: 'MedicationFollowupQuestionnaireSheet' } | { __typename?: 'MedicationFollowupSetting' } | { __typename?: 'MedixsPatient' } | { __typename?: 'MedixsReception' } | { __typename?: 'MedixsSetting' } | { __typename?: 'MessageDeliver' } | { __typename?: 'MessageDeliverResult' } | { __typename?: 'Operator' } | { __typename?: 'OperatorAccessPermission' } | { __typename?: 'OperatorRole' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationAddress' } | { __typename?: 'OrganizationCompanyFeeSetting' } | { __typename?: 'OrganizationContactPoint' } | { __typename?: 'OrganizationFeeSetting' } | { __typename?: 'OrganizationImportJobInformation' } | { __typename?: 'OrganizationNotification' } | { __typename?: 'OrganizationNotificationSetting' } | { __typename?: 'OutpatientQuestionnaire' } | { __typename?: 'OutpatientQuestionnaireEntry' } | { __typename?: 'OutpatientQuestionnaireOrganization' } | { __typename?: 'OutpatientQuestionnaireQuestion' } | { __typename?: 'OutpatientQuestionnaireSetting' } | { __typename?: 'OutpatientQuestionnaireSettingQuestionnaire' } | { __typename?: 'Patient' } | { __typename?: 'PatientAttachment' } | { __typename?: 'PatientMedicationFollowupComment' } | { __typename?: 'Payout' } | { __typename?: 'PayoutBankAccount' } | { __typename?: 'PayoutOrganization' } | { __typename?: 'PayoutSubject' } | { __typename?: 'PfDispensingRequest' } | { __typename?: 'PfPatient' } | { __typename?: 'PfPrescriptionImage' } | { __typename?: 'Plan' } | { __typename?: 'PlanFeature' } | { __typename?: 'Practitioner' } | { __typename?: 'PractitionerOtpSecret' } | { __typename?: 'PractitionerSigninHistory' } | { __typename?: 'PrivilegeOrganization' } | { __typename?: 'PrivilegeOrganizationPractitioner' } | { __typename?: 'PublicAddress' } | { __typename?: 'PublicAppointment' } | { __typename?: 'PublicCheckinEntry' } | { __typename?: 'PublicMedicationFollowupMessage' } | { __typename?: 'PublicMedicationFollowupQuestionnaireRevision' } | { __typename?: 'PublicMedicationFollowupQuestionnaireSheet' } | { __typename?: 'PublicOrganization', id: string, rawId: string, active: boolean, name: string, phoneNumber: string, webBookingsSetting: { __typename?: 'PublicWebBookingsSetting', id: string, description: string, electronicPrescription: boolean, published: boolean, facetoface: boolean, slots: Array<{ __typename?: 'PublicSlot', id: string, date: string, startAt: string, endAt: string }>, logo?: { __typename?: 'Blob', signedId: string, url: string } | null }, organizationAddresses: Array<{ __typename?: 'PublicOrganizationAddress', id: string, address: { __typename?: 'PublicAddress', id: string, longitude?: number | null, latitude?: number | null, city: string, line: string, postalCode: string, prefecture: string, type: AddressType, use: AddressUse } }> } | { __typename?: 'PublicOrganizationAddress' } | { __typename?: 'PublicOutpatientQuestionnaireEntry' } | { __typename?: 'PublicSignupPfPatientInformation' } | { __typename?: 'PublicSignupPfPatientInformationOrganization' } | { __typename?: 'PublicSlot' } | { __typename?: 'PublicWebBookingsSetting' } | { __typename?: 'RefundHistory' } | { __typename?: 'SendgridEventActivity' } | { __typename?: 'TracingReport' } | { __typename?: 'TracingReportDraft' } | { __typename?: 'UberDelivery' } | { __typename?: 'UberOrganization' } | { __typename?: 'UberOrganizationImportJobInformation' } | { __typename?: 'UberOrganizationSetting' } | { __typename?: 'UberOrganizationSettingJobInformation' } | { __typename?: 'UberSignature' } | { __typename?: 'UberSignatureDraft' } | { __typename?: 'WebBookingsBusinessHour' } | { __typename?: 'WebBookingsExceptionBusinessHour' } | { __typename?: 'WebBookingsExceptionDate' } | { __typename?: 'WebBookingsHolidayBusinessHour' } | { __typename?: 'WebBookingsLimit' } | { __typename?: 'WebBookingsSetting' } | { __typename?: 'WebBookingsSuspend' } | { __typename?: 'WebVisitor' } | null };

export type CreateAppointmentViaWebMutationVariables = Exact<{
  input: CreateAppointmentViaWebInput;
}>;


export type CreateAppointmentViaWebMutation = { __typename?: 'Mutation', createAppointmentViaWeb?: { __typename?: 'CreateAppointmentViaWebPayload', appointment: { __typename?: 'PublicAppointment', id: string, organization: { __typename?: 'PublicOrganization', id: string } } } | null };

export type GetCancelledAppointmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCancelledAppointmentQuery = { __typename?: 'Query', node?: { __typename?: 'Address' } | { __typename?: 'Agent' } | { __typename?: 'AgreementExtension' } | { __typename?: 'AllowList' } | { __typename?: 'Announcement' } | { __typename?: 'Appointment' } | { __typename?: 'B2cloudSetting' } | { __typename?: 'BankAccount' } | { __typename?: 'Bookmark' } | { __typename?: 'Charge' } | { __typename?: 'ChargeHistory' } | { __typename?: 'CheckinEntry' } | { __typename?: 'CheckinOrganization' } | { __typename?: 'ClientAuthentication' } | { __typename?: 'ClientCert' } | { __typename?: 'ClientCertJobInformation' } | { __typename?: 'Company' } | { __typename?: 'CompanyAddress' } | { __typename?: 'CompanyCommonSetting' } | { __typename?: 'CompanyContactPoint' } | { __typename?: 'CompanyFeeSetting' } | { __typename?: 'CompanyPractitioner' } | { __typename?: 'CompanyPractitionerConfirmation' } | { __typename?: 'CompanyPractitionerContactPoint' } | { __typename?: 'CompanySessionSetting' } | { __typename?: 'CompanySetupDocument' } | { __typename?: 'CompanyWebBookingsLimitSetting' } | { __typename?: 'ContactPoint' } | { __typename?: 'Contract' } | { __typename?: 'ContractPlan' } | { __typename?: 'DirectVisitor' } | { __typename?: 'DraftAppointment' } | { __typename?: 'Encounter' } | { __typename?: 'Extension' } | { __typename?: 'FaximoSendFax' } | { __typename?: 'Feature' } | { __typename?: 'FeatureTargetGroup' } | { __typename?: 'FeatureUsage' } | { __typename?: 'GendaApiKey' } | { __typename?: 'GendaSetting' } | { __typename?: 'GuestPatientMedicationFollowupComment' } | { __typename?: 'HiccupAppointmentPermission' } | { __typename?: 'HiccupOnetimeApiCache' } | { __typename?: 'HiccupTemporaryPermission' } | { __typename?: 'InvitationCode' } | { __typename?: 'Invoice' } | { __typename?: 'MedicalInstitutionSetting' } | { __typename?: 'MedicationFollowupAutoReplySetting' } | { __typename?: 'MedicationFollowupAutoReplySettingTemplate' } | { __typename?: 'MedicationFollowupDraftMessage' } | { __typename?: 'MedicationFollowupMessage' } | { __typename?: 'MedicationFollowupMessageTemplate' } | { __typename?: 'MedicationFollowupMessageTemplateJobInformation' } | { __typename?: 'MedicationFollowupQuestionnaire' } | { __typename?: 'MedicationFollowupQuestionnaireRevision' } | { __typename?: 'MedicationFollowupQuestionnaireSheet' } | { __typename?: 'MedicationFollowupSetting' } | { __typename?: 'MedixsPatient' } | { __typename?: 'MedixsReception' } | { __typename?: 'MedixsSetting' } | { __typename?: 'MessageDeliver' } | { __typename?: 'MessageDeliverResult' } | { __typename?: 'Operator' } | { __typename?: 'OperatorAccessPermission' } | { __typename?: 'OperatorRole' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationAddress' } | { __typename?: 'OrganizationCompanyFeeSetting' } | { __typename?: 'OrganizationContactPoint' } | { __typename?: 'OrganizationFeeSetting' } | { __typename?: 'OrganizationImportJobInformation' } | { __typename?: 'OrganizationNotification' } | { __typename?: 'OrganizationNotificationSetting' } | { __typename?: 'OutpatientQuestionnaire' } | { __typename?: 'OutpatientQuestionnaireEntry' } | { __typename?: 'OutpatientQuestionnaireOrganization' } | { __typename?: 'OutpatientQuestionnaireQuestion' } | { __typename?: 'OutpatientQuestionnaireSetting' } | { __typename?: 'OutpatientQuestionnaireSettingQuestionnaire' } | { __typename?: 'Patient' } | { __typename?: 'PatientAttachment' } | { __typename?: 'PatientMedicationFollowupComment' } | { __typename?: 'Payout' } | { __typename?: 'PayoutBankAccount' } | { __typename?: 'PayoutOrganization' } | { __typename?: 'PayoutSubject' } | { __typename?: 'PfDispensingRequest' } | { __typename?: 'PfPatient' } | { __typename?: 'PfPrescriptionImage' } | { __typename?: 'Plan' } | { __typename?: 'PlanFeature' } | { __typename?: 'Practitioner' } | { __typename?: 'PractitionerOtpSecret' } | { __typename?: 'PractitionerSigninHistory' } | { __typename?: 'PrivilegeOrganization' } | { __typename?: 'PrivilegeOrganizationPractitioner' } | { __typename?: 'PublicAddress' } | { __typename?: 'PublicAppointment', id: string, cancellationReason?: AppointmentCancellationReason | null, status: AppointmentStatus, organization: { __typename?: 'PublicOrganization', id: string, name: string, phoneNumber: string, organizationAddresses: Array<{ __typename?: 'PublicOrganizationAddress', id: string, address: { __typename?: 'PublicAddress', id: string, city: string, line: string, postalCode: string, prefecture: string, type: AddressType, use: AddressUse } }>, webBookingsSetting: { __typename?: 'PublicWebBookingsSetting', id: string, electronicPrescription: boolean, logo?: { __typename?: 'Blob', signedId: string, url: string } | null } } } | { __typename?: 'PublicCheckinEntry' } | { __typename?: 'PublicMedicationFollowupMessage' } | { __typename?: 'PublicMedicationFollowupQuestionnaireRevision' } | { __typename?: 'PublicMedicationFollowupQuestionnaireSheet' } | { __typename?: 'PublicOrganization' } | { __typename?: 'PublicOrganizationAddress' } | { __typename?: 'PublicOutpatientQuestionnaireEntry' } | { __typename?: 'PublicSignupPfPatientInformation' } | { __typename?: 'PublicSignupPfPatientInformationOrganization' } | { __typename?: 'PublicSlot' } | { __typename?: 'PublicWebBookingsSetting' } | { __typename?: 'RefundHistory' } | { __typename?: 'SendgridEventActivity' } | { __typename?: 'TracingReport' } | { __typename?: 'TracingReportDraft' } | { __typename?: 'UberDelivery' } | { __typename?: 'UberOrganization' } | { __typename?: 'UberOrganizationImportJobInformation' } | { __typename?: 'UberOrganizationSetting' } | { __typename?: 'UberOrganizationSettingJobInformation' } | { __typename?: 'UberSignature' } | { __typename?: 'UberSignatureDraft' } | { __typename?: 'WebBookingsBusinessHour' } | { __typename?: 'WebBookingsExceptionBusinessHour' } | { __typename?: 'WebBookingsExceptionDate' } | { __typename?: 'WebBookingsHolidayBusinessHour' } | { __typename?: 'WebBookingsLimit' } | { __typename?: 'WebBookingsSetting' } | { __typename?: 'WebBookingsSuspend' } | { __typename?: 'WebVisitor' } | null };

export type GetAppointmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAppointmentQuery = { __typename?: 'Query', node?: { __typename?: 'Address' } | { __typename?: 'Agent' } | { __typename?: 'AgreementExtension' } | { __typename?: 'AllowList' } | { __typename?: 'Announcement' } | { __typename?: 'Appointment' } | { __typename?: 'B2cloudSetting' } | { __typename?: 'BankAccount' } | { __typename?: 'Bookmark' } | { __typename?: 'Charge' } | { __typename?: 'ChargeHistory' } | { __typename?: 'CheckinEntry' } | { __typename?: 'CheckinOrganization' } | { __typename?: 'ClientAuthentication' } | { __typename?: 'ClientCert' } | { __typename?: 'ClientCertJobInformation' } | { __typename?: 'Company' } | { __typename?: 'CompanyAddress' } | { __typename?: 'CompanyCommonSetting' } | { __typename?: 'CompanyContactPoint' } | { __typename?: 'CompanyFeeSetting' } | { __typename?: 'CompanyPractitioner' } | { __typename?: 'CompanyPractitionerConfirmation' } | { __typename?: 'CompanyPractitionerContactPoint' } | { __typename?: 'CompanySessionSetting' } | { __typename?: 'CompanySetupDocument' } | { __typename?: 'CompanyWebBookingsLimitSetting' } | { __typename?: 'ContactPoint' } | { __typename?: 'Contract' } | { __typename?: 'ContractPlan' } | { __typename?: 'DirectVisitor' } | { __typename?: 'DraftAppointment' } | { __typename?: 'Encounter' } | { __typename?: 'Extension' } | { __typename?: 'FaximoSendFax' } | { __typename?: 'Feature' } | { __typename?: 'FeatureTargetGroup' } | { __typename?: 'FeatureUsage' } | { __typename?: 'GendaApiKey' } | { __typename?: 'GendaSetting' } | { __typename?: 'GuestPatientMedicationFollowupComment' } | { __typename?: 'HiccupAppointmentPermission' } | { __typename?: 'HiccupOnetimeApiCache' } | { __typename?: 'HiccupTemporaryPermission' } | { __typename?: 'InvitationCode' } | { __typename?: 'Invoice' } | { __typename?: 'MedicalInstitutionSetting' } | { __typename?: 'MedicationFollowupAutoReplySetting' } | { __typename?: 'MedicationFollowupAutoReplySettingTemplate' } | { __typename?: 'MedicationFollowupDraftMessage' } | { __typename?: 'MedicationFollowupMessage' } | { __typename?: 'MedicationFollowupMessageTemplate' } | { __typename?: 'MedicationFollowupMessageTemplateJobInformation' } | { __typename?: 'MedicationFollowupQuestionnaire' } | { __typename?: 'MedicationFollowupQuestionnaireRevision' } | { __typename?: 'MedicationFollowupQuestionnaireSheet' } | { __typename?: 'MedicationFollowupSetting' } | { __typename?: 'MedixsPatient' } | { __typename?: 'MedixsReception' } | { __typename?: 'MedixsSetting' } | { __typename?: 'MessageDeliver' } | { __typename?: 'MessageDeliverResult' } | { __typename?: 'Operator' } | { __typename?: 'OperatorAccessPermission' } | { __typename?: 'OperatorRole' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationAddress' } | { __typename?: 'OrganizationCompanyFeeSetting' } | { __typename?: 'OrganizationContactPoint' } | { __typename?: 'OrganizationFeeSetting' } | { __typename?: 'OrganizationImportJobInformation' } | { __typename?: 'OrganizationNotification' } | { __typename?: 'OrganizationNotificationSetting' } | { __typename?: 'OutpatientQuestionnaire' } | { __typename?: 'OutpatientQuestionnaireEntry' } | { __typename?: 'OutpatientQuestionnaireOrganization' } | { __typename?: 'OutpatientQuestionnaireQuestion' } | { __typename?: 'OutpatientQuestionnaireSetting' } | { __typename?: 'OutpatientQuestionnaireSettingQuestionnaire' } | { __typename?: 'Patient' } | { __typename?: 'PatientAttachment' } | { __typename?: 'PatientMedicationFollowupComment' } | { __typename?: 'Payout' } | { __typename?: 'PayoutBankAccount' } | { __typename?: 'PayoutOrganization' } | { __typename?: 'PayoutSubject' } | { __typename?: 'PfDispensingRequest' } | { __typename?: 'PfPatient' } | { __typename?: 'PfPrescriptionImage' } | { __typename?: 'Plan' } | { __typename?: 'PlanFeature' } | { __typename?: 'Practitioner' } | { __typename?: 'PractitionerOtpSecret' } | { __typename?: 'PractitionerSigninHistory' } | { __typename?: 'PrivilegeOrganization' } | { __typename?: 'PrivilegeOrganizationPractitioner' } | { __typename?: 'PublicAddress' } | { __typename?: 'PublicAppointment', id: string, status: AppointmentStatus, organization: { __typename?: 'PublicOrganization', id: string, name: string, phoneNumber: string, organizationAddresses: Array<{ __typename?: 'PublicOrganizationAddress', id: string, address: { __typename?: 'PublicAddress', id: string, city: string, line: string, postalCode: string, prefecture: string, type: AddressType, use: AddressUse } }>, webBookingsSetting: { __typename?: 'PublicWebBookingsSetting', id: string, electronicPrescription: boolean, logo?: { __typename?: 'Blob', signedId: string, url: string } | null } } } | { __typename?: 'PublicCheckinEntry' } | { __typename?: 'PublicMedicationFollowupMessage' } | { __typename?: 'PublicMedicationFollowupQuestionnaireRevision' } | { __typename?: 'PublicMedicationFollowupQuestionnaireSheet' } | { __typename?: 'PublicOrganization' } | { __typename?: 'PublicOrganizationAddress' } | { __typename?: 'PublicOutpatientQuestionnaireEntry' } | { __typename?: 'PublicSignupPfPatientInformation' } | { __typename?: 'PublicSignupPfPatientInformationOrganization' } | { __typename?: 'PublicSlot' } | { __typename?: 'PublicWebBookingsSetting' } | { __typename?: 'RefundHistory' } | { __typename?: 'SendgridEventActivity' } | { __typename?: 'TracingReport' } | { __typename?: 'TracingReportDraft' } | { __typename?: 'UberDelivery' } | { __typename?: 'UberOrganization' } | { __typename?: 'UberOrganizationImportJobInformation' } | { __typename?: 'UberOrganizationSetting' } | { __typename?: 'UberOrganizationSettingJobInformation' } | { __typename?: 'UberSignature' } | { __typename?: 'UberSignatureDraft' } | { __typename?: 'WebBookingsBusinessHour' } | { __typename?: 'WebBookingsExceptionBusinessHour' } | { __typename?: 'WebBookingsExceptionDate' } | { __typename?: 'WebBookingsHolidayBusinessHour' } | { __typename?: 'WebBookingsLimit' } | { __typename?: 'WebBookingsSetting' } | { __typename?: 'WebBookingsSuspend' } | { __typename?: 'WebVisitor' } | null };

export type CancelAppointmentMutationVariables = Exact<{
  input: CancelAppointmentViaWebInput;
}>;


export type CancelAppointmentMutation = { __typename?: 'Mutation', cancelAppointmentViaWeb?: { __typename?: 'CancelAppointmentViaWebPayload', appointment: { __typename?: 'PublicAppointment', id: string, organization: { __typename?: 'PublicOrganization', id: string, name: string, phoneNumber: string, organizationAddresses: Array<{ __typename?: 'PublicOrganizationAddress', id: string, address: { __typename?: 'PublicAddress', id: string, city: string, line: string, postalCode: string, prefecture: string, type: AddressType, use: AddressUse } }>, webBookingsSetting: { __typename?: 'PublicWebBookingsSetting', id: string, electronicPrescription: boolean, logo?: { __typename?: 'Blob', signedId: string, url: string } | null } } } } | null };

export type PharmacyProfileFragment = { __typename?: 'PublicOrganization', id: string, name: string, phoneNumber: string, organizationAddresses: Array<{ __typename?: 'PublicOrganizationAddress', id: string, address: { __typename?: 'PublicAddress', id: string, city: string, line: string, postalCode: string, prefecture: string, type: AddressType, use: AddressUse } }>, webBookingsSetting: { __typename?: 'PublicWebBookingsSetting', id: string, electronicPrescription: boolean, logo?: { __typename?: 'Blob', signedId: string, url: string } | null } };

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = ResolversObject<{
  AllPatient: ( Omit<CheckinEntry, 'checkinOrganization' | 'organization' | 'unreadOrganizationNotifications'> & { checkinOrganization: _RefType['CheckinOrganization'], organization: _RefType['Organization'], unreadOrganizationNotifications: Array<_RefType['OrganizationNotification']> } ) | ( Omit<DirectVisitor, 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'outpatientQuestionnaireEntry' | 'samePatient' | 'tracingReportDrafts' | 'tracingReports'> & { medicationFollowupDraftMessages: _RefType['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: _RefType['MedicationFollowupMessagePage'], medixsPatient?: Maybe<_RefType['MedixsPatient']>, messageDeliverResults: _RefType['MessageDeliverResultPage'], outpatientQuestionnaireEntry?: Maybe<_RefType['OutpatientQuestionnaireEntry']>, samePatient?: Maybe<_RefType['Patient']>, tracingReportDrafts: _RefType['TracingReportDraftPage'], tracingReports: _RefType['TracingReportPage'] } ) | ( Omit<Patient, 'appointments' | 'bookmark' | 'draftAppointments' | 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'questionnaireSheet' | 'questionnaires' | 'tracingReportDrafts' | 'tracingReports'> & { appointments: _RefType['AppointmentPage'], bookmark?: Maybe<_RefType['Bookmark']>, draftAppointments: _RefType['DraftAppointmentPage'], medicationFollowupDraftMessages: _RefType['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: _RefType['MedicationFollowupMessagePage'], medixsPatient?: Maybe<_RefType['MedixsPatient']>, messageDeliverResults: _RefType['MessageDeliverResultPage'], questionnaireSheet?: Maybe<_RefType['QuestionnaireSheet']>, questionnaires?: Maybe<Array<_RefType['QuestionnaireSheetAnswer']>>, tracingReportDrafts: _RefType['TracingReportDraftPage'], tracingReports: _RefType['TracingReportPage'] } ) | ( Omit<WebVisitor, 'appointment' | 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'questionnaireSheet' | 'samePatient' | 'tracingReportDrafts' | 'tracingReports'> & { appointment: _RefType['Appointment'], medicationFollowupDraftMessages: _RefType['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: _RefType['MedicationFollowupMessagePage'], medixsPatient?: Maybe<_RefType['MedixsPatient']>, messageDeliverResults: _RefType['MessageDeliverResultPage'], questionnaireSheet: _RefType['QuestionnaireSheet'], samePatient?: Maybe<_RefType['Patient']>, tracingReportDrafts: _RefType['TracingReportDraftPage'], tracingReports: _RefType['TracingReportPage'] } );
  DirectVisitorCandidate: ( Omit<CheckinEntry, 'checkinOrganization' | 'organization' | 'unreadOrganizationNotifications'> & { checkinOrganization: _RefType['CheckinOrganization'], organization: _RefType['Organization'], unreadOrganizationNotifications: Array<_RefType['OrganizationNotification']> } ) | ( Omit<DirectVisitor, 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'outpatientQuestionnaireEntry' | 'samePatient' | 'tracingReportDrafts' | 'tracingReports'> & { medicationFollowupDraftMessages: _RefType['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: _RefType['MedicationFollowupMessagePage'], medixsPatient?: Maybe<_RefType['MedixsPatient']>, messageDeliverResults: _RefType['MessageDeliverResultPage'], outpatientQuestionnaireEntry?: Maybe<_RefType['OutpatientQuestionnaireEntry']>, samePatient?: Maybe<_RefType['Patient']>, tracingReportDrafts: _RefType['TracingReportDraftPage'], tracingReports: _RefType['TracingReportPage'] } );
  DisclosedMedicineNote: ( Omit<HiccupOnetimeApiCache, 'organization'> & { organization: _RefType['Organization'] } ) | ( Omit<HiccupTemporaryPermission, 'organization' | 'patient'> & { organization: _RefType['Organization'], patient?: Maybe<_RefType['Patient']> } );
  Event: ( Omit<GuestPatientMedicationFollowupComment, 'practitioner'> & { practitioner: _RefType['Practitioner'] } ) | ( Omit<MedicationFollowupMessage, 'appointment' | 'autoReplySetting' | 'directVisitor' | 'medicationFollowupQuestionnaireRevision' | 'medicationFollowupQuestionnaireSheet' | 'messageDeliverResult' | 'patient' | 'practitioner' | 'webVisitor'> & { appointment?: Maybe<_RefType['Appointment']>, autoReplySetting?: Maybe<_RefType['MedicationFollowupAutoReplySetting']>, directVisitor?: Maybe<_RefType['DirectVisitor']>, medicationFollowupQuestionnaireRevision?: Maybe<_RefType['MedicationFollowupQuestionnaireRevision']>, medicationFollowupQuestionnaireSheet?: Maybe<_RefType['MedicationFollowupQuestionnaireSheet']>, messageDeliverResult?: Maybe<_RefType['MessageDeliverResult']>, patient?: Maybe<_RefType['Patient']>, practitioner: _RefType['Practitioner'], webVisitor?: Maybe<_RefType['WebVisitor']> } ) | ( Omit<MedicationFollowupQuestionnaireSheet, 'answers' | 'appointment' | 'medicationFollowupMessage'> & { answers: Array<_RefType['QuestionnaireSheetAnswer']>, appointment?: Maybe<_RefType['Appointment']>, medicationFollowupMessage: _RefType['MedicationFollowupMessage'] } ) | ( Omit<PatientMedicationFollowupComment, 'practitioner'> & { practitioner: _RefType['Practitioner'] } ) | ( Omit<TracingReport, 'data' | 'latestSentFax' | 'latestSentFaxByEvent' | 'organization'> & { data: _RefType['TracingReportData'], latestSentFax?: Maybe<_RefType['FaximoSendFax']>, latestSentFaxByEvent?: Maybe<_RefType['FaximoSendFax']>, organization: _RefType['Organization'] } );
  FeatureTarget: ( Omit<Company, 'affectedOrganizationsByDeactivation' | 'agreementExtensions' | 'bookmarkedPatientCounts' | 'candidateCompanyPractitioners' | 'checkinEntries' | 'clientAuthentication' | 'clientCertSummaries' | 'companyAddresses' | 'companyContactPoints' | 'companyPractitioner' | 'companyPractitionerConfirmation' | 'contract' | 'featureUsages' | 'feeSettings' | 'latestSucceededTemplateJobInformation' | 'latestUberSignature' | 'medicationFollowupUsages' | 'monthlySales' | 'organizationImportJobInformations' | 'organizations' | 'payouts' | 'receptionUsages' | 'receptions' | 'tracingReportUsages' | 'uberSignatureDraft' | 'uberSignatures' | 'webBookingsLimitSettings'> & { affectedOrganizationsByDeactivation?: Maybe<_RefType['OrganizationPage']>, agreementExtensions: _RefType['AgreementExtensionPage'], bookmarkedPatientCounts: _RefType['BookmarkedPatientCountPage'], candidateCompanyPractitioners?: Maybe<Array<_RefType['Practitioner']>>, checkinEntries: _RefType['CheckinEntryPage'], clientAuthentication?: Maybe<_RefType['ClientAuthentication']>, clientCertSummaries: _RefType['ClientCertSummaryPage'], companyAddresses: Array<_RefType['CompanyAddress']>, companyContactPoints: Array<_RefType['CompanyContactPoint']>, companyPractitioner?: Maybe<_RefType['CompanyPractitioner']>, companyPractitionerConfirmation?: Maybe<_RefType['CompanyPractitionerConfirmation']>, contract?: Maybe<_RefType['Contract']>, featureUsages: _RefType['FeatureUsagePage'], feeSettings: _RefType['CompanyFeeSettingPage'], latestSucceededTemplateJobInformation?: Maybe<_RefType['MedicationFollowupMessageTemplateJobInformation']>, latestUberSignature?: Maybe<_RefType['UberSignature']>, medicationFollowupUsages: _RefType['MedicationFollowupUsagePage'], monthlySales?: Maybe<_RefType['CompanyMonthlySales']>, organizationImportJobInformations: _RefType['OrganizationImportJobInformationConnection'], organizations: _RefType['OrganizationPage'], payouts: _RefType['PayoutPage'], receptionUsages: _RefType['ReceptionUsagePage'], receptions?: Maybe<_RefType['ReceptionPage']>, tracingReportUsages: _RefType['TracingReportUsagePage'], uberSignatureDraft?: Maybe<_RefType['UberSignatureDraft']>, uberSignatures?: Maybe<Array<_RefType['UberSignature']>>, webBookingsLimitSettings: Array<_RefType['CompanyWebBookingsLimitSetting']> } ) | ( Omit<Organization, 'adminPractitioners' | 'allPatients' | 'appointments' | 'b2cloudSetting' | 'bankAccount' | 'bookmarkedPatients' | 'chargeHistories' | 'checkinEntries' | 'checkinSetting' | 'clientCerts' | 'company' | 'companyCommonSetting' | 'dailySalesDetail' | 'directVisitorCandidates' | 'directVisitors' | 'disclosedMedicineNotes' | 'faximoSendFaxes' | 'featureUsages' | 'feeSettings' | 'hiccupTemporaryPermissions' | 'invitationCodes' | 'medicalInstitutionSetting' | 'medicalInstitutionSettings' | 'medicationFollowupMessageTemplates' | 'medicationFollowupMessages' | 'medicationFollowupQuestionnaireSheets' | 'medicationFollowupQuestionnaires' | 'medicationFollowupSetting' | 'medixsSetting' | 'notificationSetting' | 'organizationAddresses' | 'organizationContactPoints' | 'organizationNotifications' | 'patients' | 'payoutOrganizations' | 'pharmacistPractitioners' | 'practitionerAuthentications' | 'receptions' | 'unreadOrganizationNotifications'> & { adminPractitioners: Array<_RefType['Practitioner']>, allPatients: _RefType['AllPatientPage'], appointments: _RefType['AppointmentPage'], b2cloudSetting?: Maybe<_RefType['B2cloudSetting']>, bankAccount?: Maybe<_RefType['BankAccount']>, bookmarkedPatients: _RefType['PatientPage'], chargeHistories: _RefType['ChargeHistoryPage'], checkinEntries: _RefType['CheckinEntryPage'], checkinSetting?: Maybe<_RefType['CheckinSetting']>, clientCerts: _RefType['ClientCertPage'], company: _RefType['Company'], companyCommonSetting?: Maybe<_RefType['CompanyCommonSetting']>, dailySalesDetail: _RefType['OrganizationDailySalesDetail'], directVisitorCandidates: _RefType['DirectVisitorCandidatePage'], directVisitors: _RefType['DirectVisitorPage'], disclosedMedicineNotes: _RefType['DisclosedMedicineNotePage'], faximoSendFaxes: _RefType['FaximoSendFaxPage'], featureUsages: _RefType['FeatureUsagePage'], feeSettings: _RefType['FeeSettingPage'], hiccupTemporaryPermissions: _RefType['HiccupTemporaryPermissionPage'], invitationCodes: _RefType['InvitationCodePage'], medicalInstitutionSetting?: Maybe<_RefType['MedicalInstitutionSetting']>, medicalInstitutionSettings: _RefType['MedicalInstitutionSettingPage'], medicationFollowupMessageTemplates: _RefType['MedicationFollowupMessageTemplatePage'], medicationFollowupMessages: _RefType['MedicationFollowupMessagePage'], medicationFollowupQuestionnaireSheets: _RefType['MedicationFollowupQuestionnaireSheetPage'], medicationFollowupQuestionnaires: _RefType['MedicationFollowupQuestionnairePage'], medicationFollowupSetting?: Maybe<_RefType['MedicationFollowupSetting']>, medixsSetting?: Maybe<_RefType['MedixsSetting']>, notificationSetting?: Maybe<_RefType['OrganizationNotificationSetting']>, organizationAddresses: Array<_RefType['OrganizationAddress']>, organizationContactPoints: Array<_RefType['OrganizationContactPoint']>, organizationNotifications: _RefType['OrganizationNotificationPage'], patients: _RefType['PatientConnection'], payoutOrganizations: _RefType['PayoutOrganizationPage'], pharmacistPractitioners: Array<_RefType['Practitioner']>, practitionerAuthentications: Array<_RefType['PractitionerAuthentication']>, receptions: _RefType['ReceptionPage'], unreadOrganizationNotifications: _RefType['OrganizationNotificationPage'] } ) | ( Omit<Patient, 'appointments' | 'bookmark' | 'draftAppointments' | 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'questionnaireSheet' | 'questionnaires' | 'tracingReportDrafts' | 'tracingReports'> & { appointments: _RefType['AppointmentPage'], bookmark?: Maybe<_RefType['Bookmark']>, draftAppointments: _RefType['DraftAppointmentPage'], medicationFollowupDraftMessages: _RefType['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: _RefType['MedicationFollowupMessagePage'], medixsPatient?: Maybe<_RefType['MedixsPatient']>, messageDeliverResults: _RefType['MessageDeliverResultPage'], questionnaireSheet?: Maybe<_RefType['QuestionnaireSheet']>, questionnaires?: Maybe<Array<_RefType['QuestionnaireSheetAnswer']>>, tracingReportDrafts: _RefType['TracingReportDraftPage'], tracingReports: _RefType['TracingReportPage'] } ) | ( Omit<Practitioner, 'authentication' | 'organization' | 'signinHistory'> & { authentication: _RefType['PractitionerAuthentication'], organization: _RefType['Organization'], signinHistory?: Maybe<_RefType['PractitionerSigninHistory']> } );
  FeeSetting: ( Omit<CompanyFeeSetting, 'company'> & { company: _RefType['Company'] } ) | ( OrganizationCompanyFeeSetting ) | ( Omit<OrganizationFeeSetting, 'organization'> & { organization: _RefType['Organization'] } );
  GuestPatient: ( Omit<DirectVisitor, 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'outpatientQuestionnaireEntry' | 'samePatient' | 'tracingReportDrafts' | 'tracingReports'> & { medicationFollowupDraftMessages: _RefType['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: _RefType['MedicationFollowupMessagePage'], medixsPatient?: Maybe<_RefType['MedixsPatient']>, messageDeliverResults: _RefType['MessageDeliverResultPage'], outpatientQuestionnaireEntry?: Maybe<_RefType['OutpatientQuestionnaireEntry']>, samePatient?: Maybe<_RefType['Patient']>, tracingReportDrafts: _RefType['TracingReportDraftPage'], tracingReports: _RefType['TracingReportPage'] } ) | ( Omit<WebVisitor, 'appointment' | 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'questionnaireSheet' | 'samePatient' | 'tracingReportDrafts' | 'tracingReports'> & { appointment: _RefType['Appointment'], medicationFollowupDraftMessages: _RefType['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: _RefType['MedicationFollowupMessagePage'], medixsPatient?: Maybe<_RefType['MedixsPatient']>, messageDeliverResults: _RefType['MessageDeliverResultPage'], questionnaireSheet: _RefType['QuestionnaireSheet'], samePatient?: Maybe<_RefType['Patient']>, tracingReportDrafts: _RefType['TracingReportDraftPage'], tracingReports: _RefType['TracingReportPage'] } );
  LoginUser: ( Operator ) | ( Omit<Practitioner, 'authentication' | 'organization' | 'signinHistory'> & { authentication: _RefType['PractitionerAuthentication'], organization: _RefType['Organization'], signinHistory?: Maybe<_RefType['PractitionerSigninHistory']> } );
  MedicationFollowupComment: ( Omit<GuestPatientMedicationFollowupComment, 'practitioner'> & { practitioner: _RefType['Practitioner'] } ) | ( Omit<PatientMedicationFollowupComment, 'practitioner'> & { practitioner: _RefType['Practitioner'] } );
  MedixsPatientQuestionnaireSheet: ( Omit<OutpatientQuestionnaireEntry, 'address' | 'directVisitor' | 'organization' | 'unreadOrganizationNotifications'> & { address: _RefType['Address'], directVisitor: _RefType['DirectVisitor'], organization: _RefType['Organization'], unreadOrganizationNotifications: Array<_RefType['OrganizationNotification']> } ) | ( Omit<QuestionnaireSheet, 'answers'> & { answers: Array<_RefType['QuestionnaireSheetAnswer']> } );
  Reception: ( Omit<Appointment, 'charge' | 'draftAppointment' | 'encounter' | 'hiccupAppointmentPermission' | 'medixsReception' | 'organization' | 'patient' | 'questionnaires' | 'uberDelivery' | 'unreadOrganizationNotifications' | 'webVisitor'> & { charge?: Maybe<_RefType['Charge']>, draftAppointment?: Maybe<_RefType['DraftAppointment']>, encounter?: Maybe<_RefType['Encounter']>, hiccupAppointmentPermission?: Maybe<_RefType['HiccupAppointmentPermission']>, medixsReception?: Maybe<_RefType['MedixsReception']>, organization: _RefType['Organization'], patient?: Maybe<_RefType['Patient']>, questionnaires: Array<_RefType['QuestionnaireSheetAnswer']>, uberDelivery?: Maybe<_RefType['UberDelivery']>, unreadOrganizationNotifications: Array<_RefType['OrganizationNotification']>, webVisitor?: Maybe<_RefType['WebVisitor']> } ) | ( Omit<CheckinEntry, 'checkinOrganization' | 'organization' | 'unreadOrganizationNotifications'> & { checkinOrganization: _RefType['CheckinOrganization'], organization: _RefType['Organization'], unreadOrganizationNotifications: Array<_RefType['OrganizationNotification']> } ) | ( Omit<DraftAppointment, 'appointment' | 'organization' | 'patient' | 'questionnaires' | 'unreadOrganizationNotifications'> & { appointment?: Maybe<_RefType['Appointment']>, organization: _RefType['Organization'], patient: _RefType['Patient'], questionnaires: Array<_RefType['QuestionnaireSheetAnswer']>, unreadOrganizationNotifications: Array<_RefType['OrganizationNotification']> } ) | ( Omit<OutpatientQuestionnaireEntry, 'address' | 'directVisitor' | 'organization' | 'unreadOrganizationNotifications'> & { address: _RefType['Address'], directVisitor: _RefType['DirectVisitor'], organization: _RefType['Organization'], unreadOrganizationNotifications: Array<_RefType['OrganizationNotification']> } );
}>;

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = ResolversObject<{
  Node: ( Address ) | ( Agent ) | ( Omit<AgreementExtension, 'activatePractitioner' | 'deactivatePractitioner' | 'extension' | 'uberSignatures'> & { activatePractitioner: _RefType['Practitioner'], deactivatePractitioner?: Maybe<_RefType['Practitioner']>, extension: _RefType['Extension'], uberSignatures?: Maybe<Array<_RefType['UberSignature']>> } ) | ( AllowList ) | ( Announcement ) | ( Omit<Appointment, 'charge' | 'draftAppointment' | 'encounter' | 'hiccupAppointmentPermission' | 'medixsReception' | 'organization' | 'patient' | 'questionnaires' | 'uberDelivery' | 'unreadOrganizationNotifications' | 'webVisitor'> & { charge?: Maybe<_RefType['Charge']>, draftAppointment?: Maybe<_RefType['DraftAppointment']>, encounter?: Maybe<_RefType['Encounter']>, hiccupAppointmentPermission?: Maybe<_RefType['HiccupAppointmentPermission']>, medixsReception?: Maybe<_RefType['MedixsReception']>, organization: _RefType['Organization'], patient?: Maybe<_RefType['Patient']>, questionnaires: Array<_RefType['QuestionnaireSheetAnswer']>, uberDelivery?: Maybe<_RefType['UberDelivery']>, unreadOrganizationNotifications: Array<_RefType['OrganizationNotification']>, webVisitor?: Maybe<_RefType['WebVisitor']> } ) | ( Omit<B2cloudSetting, 'organization'> & { organization: _RefType['Organization'] } ) | ( Omit<BankAccount, 'organization'> & { organization?: Maybe<_RefType['Organization']> } ) | ( Bookmark ) | ( Omit<Charge, 'appointment' | 'chargeHistories' | 'practitioner'> & { appointment: _RefType['Appointment'], chargeHistories: _RefType['ChargeHistoryPage'], practitioner: _RefType['Practitioner'] } ) | ( Omit<ChargeHistory, 'amountDetails' | 'charge' | 'organization'> & { amountDetails?: Maybe<Array<_RefType['ChargeHistoryAmountDetail']>>, charge: _RefType['Charge'], organization: _RefType['Organization'] } ) | ( Omit<CheckinEntry, 'checkinOrganization' | 'organization' | 'unreadOrganizationNotifications'> & { checkinOrganization: _RefType['CheckinOrganization'], organization: _RefType['Organization'], unreadOrganizationNotifications: Array<_RefType['OrganizationNotification']> } ) | ( CheckinOrganization ) | ( Omit<ClientAuthentication, 'company'> & { company: _RefType['Company'] } ) | ( Omit<ClientCert, 'organization'> & { organization: _RefType['Organization'] } ) | ( ClientCertJobInformation ) | ( Omit<Company, 'affectedOrganizationsByDeactivation' | 'agreementExtensions' | 'bookmarkedPatientCounts' | 'candidateCompanyPractitioners' | 'checkinEntries' | 'clientAuthentication' | 'clientCertSummaries' | 'companyAddresses' | 'companyContactPoints' | 'companyPractitioner' | 'companyPractitionerConfirmation' | 'contract' | 'featureUsages' | 'feeSettings' | 'latestSucceededTemplateJobInformation' | 'latestUberSignature' | 'medicationFollowupUsages' | 'monthlySales' | 'organizationImportJobInformations' | 'organizations' | 'payouts' | 'receptionUsages' | 'receptions' | 'tracingReportUsages' | 'uberSignatureDraft' | 'uberSignatures' | 'webBookingsLimitSettings'> & { affectedOrganizationsByDeactivation?: Maybe<_RefType['OrganizationPage']>, agreementExtensions: _RefType['AgreementExtensionPage'], bookmarkedPatientCounts: _RefType['BookmarkedPatientCountPage'], candidateCompanyPractitioners?: Maybe<Array<_RefType['Practitioner']>>, checkinEntries: _RefType['CheckinEntryPage'], clientAuthentication?: Maybe<_RefType['ClientAuthentication']>, clientCertSummaries: _RefType['ClientCertSummaryPage'], companyAddresses: Array<_RefType['CompanyAddress']>, companyContactPoints: Array<_RefType['CompanyContactPoint']>, companyPractitioner?: Maybe<_RefType['CompanyPractitioner']>, companyPractitionerConfirmation?: Maybe<_RefType['CompanyPractitionerConfirmation']>, contract?: Maybe<_RefType['Contract']>, featureUsages: _RefType['FeatureUsagePage'], feeSettings: _RefType['CompanyFeeSettingPage'], latestSucceededTemplateJobInformation?: Maybe<_RefType['MedicationFollowupMessageTemplateJobInformation']>, latestUberSignature?: Maybe<_RefType['UberSignature']>, medicationFollowupUsages: _RefType['MedicationFollowupUsagePage'], monthlySales?: Maybe<_RefType['CompanyMonthlySales']>, organizationImportJobInformations: _RefType['OrganizationImportJobInformationConnection'], organizations: _RefType['OrganizationPage'], payouts: _RefType['PayoutPage'], receptionUsages: _RefType['ReceptionUsagePage'], receptions?: Maybe<_RefType['ReceptionPage']>, tracingReportUsages: _RefType['TracingReportUsagePage'], uberSignatureDraft?: Maybe<_RefType['UberSignatureDraft']>, uberSignatures?: Maybe<Array<_RefType['UberSignature']>>, webBookingsLimitSettings: Array<_RefType['CompanyWebBookingsLimitSetting']> } ) | ( Omit<CompanyAddress, 'address'> & { address: _RefType['Address'] } ) | ( Omit<CompanyCommonSetting, 'organization'> & { organization?: Maybe<_RefType['Organization']> } ) | ( Omit<CompanyContactPoint, 'contactPoint'> & { contactPoint: _RefType['ContactPoint'] } ) | ( Omit<CompanyFeeSetting, 'company'> & { company: _RefType['Company'] } ) | ( Omit<CompanyPractitioner, 'company' | 'companyPractitionerContactPoints' | 'practitioner'> & { company: _RefType['Company'], companyPractitionerContactPoints: Array<_RefType['CompanyPractitionerContactPoint']>, practitioner: _RefType['Practitioner'] } ) | ( Omit<CompanyPractitionerConfirmation, 'company' | 'practitioner'> & { company: _RefType['Company'], practitioner: _RefType['Practitioner'] } ) | ( Omit<CompanyPractitionerContactPoint, 'contactPoint'> & { contactPoint: _RefType['ContactPoint'] } ) | ( CompanySessionSetting ) | ( CompanySetupDocument ) | ( Omit<CompanyWebBookingsLimitSetting, 'company'> & { company: _RefType['Company'] } ) | ( ContactPoint ) | ( Omit<Contract, 'contractPlans'> & { contractPlans: Array<_RefType['ContractPlan']> } ) | ( Omit<ContractPlan, 'contract' | 'plan'> & { contract: _RefType['Contract'], plan: _RefType['Plan'] } ) | ( Omit<DirectVisitor, 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'outpatientQuestionnaireEntry' | 'samePatient' | 'tracingReportDrafts' | 'tracingReports'> & { medicationFollowupDraftMessages: _RefType['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: _RefType['MedicationFollowupMessagePage'], medixsPatient?: Maybe<_RefType['MedixsPatient']>, messageDeliverResults: _RefType['MessageDeliverResultPage'], outpatientQuestionnaireEntry?: Maybe<_RefType['OutpatientQuestionnaireEntry']>, samePatient?: Maybe<_RefType['Patient']>, tracingReportDrafts: _RefType['TracingReportDraftPage'], tracingReports: _RefType['TracingReportPage'] } ) | ( Omit<DraftAppointment, 'appointment' | 'organization' | 'patient' | 'questionnaires' | 'unreadOrganizationNotifications'> & { appointment?: Maybe<_RefType['Appointment']>, organization: _RefType['Organization'], patient: _RefType['Patient'], questionnaires: Array<_RefType['QuestionnaireSheetAnswer']>, unreadOrganizationNotifications: Array<_RefType['OrganizationNotification']> } ) | ( Omit<Encounter, 'appointment'> & { appointment: _RefType['Appointment'] } ) | ( Extension ) | ( Omit<FaximoSendFax, 'organization' | 'practitioner' | 'tracingReport'> & { organization: _RefType['Organization'], practitioner: _RefType['Practitioner'], tracingReport?: Maybe<_RefType['TracingReport']> } ) | ( Feature ) | ( FeatureTargetGroup ) | ( Omit<FeatureUsage, 'organization'> & { organization: _RefType['Organization'] } ) | ( GendaApiKey ) | ( Omit<GendaSetting, 'organization'> & { organization: _RefType['Organization'] } ) | ( Omit<GuestPatientMedicationFollowupComment, 'practitioner'> & { practitioner: _RefType['Practitioner'] } ) | ( Omit<HiccupAppointmentPermission, 'appointment'> & { appointment: _RefType['Appointment'] } ) | ( Omit<HiccupOnetimeApiCache, 'organization'> & { organization: _RefType['Organization'] } ) | ( Omit<HiccupTemporaryPermission, 'organization' | 'patient'> & { organization: _RefType['Organization'], patient?: Maybe<_RefType['Patient']> } ) | ( Omit<InvitationCode, 'appointment'> & { appointment?: Maybe<_RefType['Appointment']> } ) | ( Invoice ) | ( Omit<MedicalInstitutionSetting, 'contactPoint' | 'organization'> & { contactPoint?: Maybe<_RefType['ContactPoint']>, organization: _RefType['Organization'] } ) | ( Omit<MedicationFollowupAutoReplySetting, 'questionnaireRevision'> & { questionnaireRevision?: Maybe<_RefType['MedicationFollowupQuestionnaireRevision']> } ) | ( Omit<MedicationFollowupAutoReplySettingTemplate, 'questionnaireRevision'> & { questionnaireRevision?: Maybe<_RefType['MedicationFollowupQuestionnaireRevision']> } ) | ( Omit<MedicationFollowupDraftMessage, 'data' | 'guestPatient' | 'patient' | 'practitioner'> & { data: _RefType['MedicationFollowupDraftMessageData'], guestPatient?: Maybe<_RefType['GuestPatient']>, patient?: Maybe<_RefType['Patient']>, practitioner: _RefType['Practitioner'] } ) | ( Omit<MedicationFollowupMessage, 'appointment' | 'autoReplySetting' | 'directVisitor' | 'medicationFollowupQuestionnaireRevision' | 'medicationFollowupQuestionnaireSheet' | 'messageDeliverResult' | 'patient' | 'practitioner' | 'webVisitor'> & { appointment?: Maybe<_RefType['Appointment']>, autoReplySetting?: Maybe<_RefType['MedicationFollowupAutoReplySetting']>, directVisitor?: Maybe<_RefType['DirectVisitor']>, medicationFollowupQuestionnaireRevision?: Maybe<_RefType['MedicationFollowupQuestionnaireRevision']>, medicationFollowupQuestionnaireSheet?: Maybe<_RefType['MedicationFollowupQuestionnaireSheet']>, messageDeliverResult?: Maybe<_RefType['MessageDeliverResult']>, patient?: Maybe<_RefType['Patient']>, practitioner: _RefType['Practitioner'], webVisitor?: Maybe<_RefType['WebVisitor']> } ) | ( Omit<MedicationFollowupMessageTemplate, 'autoReplySettingTemplate' | 'medicationFollowupQuestionnaire' | 'organization'> & { autoReplySettingTemplate?: Maybe<_RefType['MedicationFollowupAutoReplySettingTemplate']>, medicationFollowupQuestionnaire?: Maybe<_RefType['MedicationFollowupQuestionnaire']>, organization: _RefType['Organization'] } ) | ( Omit<MedicationFollowupMessageTemplateJobInformation, 'sourceOrganization'> & { sourceOrganization: _RefType['Organization'] } ) | ( Omit<MedicationFollowupQuestionnaire, 'organization' | 'revision'> & { organization: _RefType['Organization'], revision: _RefType['MedicationFollowupQuestionnaireRevision'] } ) | ( Omit<MedicationFollowupQuestionnaireRevision, 'medicationFollowupQuestionnaire'> & { medicationFollowupQuestionnaire: _RefType['MedicationFollowupQuestionnaire'] } ) | ( Omit<MedicationFollowupQuestionnaireSheet, 'answers' | 'appointment' | 'medicationFollowupMessage'> & { answers: Array<_RefType['QuestionnaireSheetAnswer']>, appointment?: Maybe<_RefType['Appointment']>, medicationFollowupMessage: _RefType['MedicationFollowupMessage'] } ) | ( Omit<MedicationFollowupSetting, 'organization'> & { organization: _RefType['Organization'] } ) | ( Omit<MedixsPatient, 'events' | 'guestPatients' | 'latestAppointment' | 'latestQuestionnaireSheet' | 'medicationFollowupComments' | 'medicationFollowupDraftMessage' | 'patient' | 'tracingReportDraft'> & { events: _RefType['EventPage'], guestPatients: Array<_RefType['GuestPatient']>, latestAppointment?: Maybe<_RefType['Appointment']>, latestQuestionnaireSheet?: Maybe<_RefType['MedixsPatientQuestionnaireSheet']>, medicationFollowupComments: _RefType['MedicationFollowupCommentPage'], medicationFollowupDraftMessage?: Maybe<_RefType['MedicationFollowupDraftMessage']>, patient?: Maybe<_RefType['Patient']>, tracingReportDraft?: Maybe<_RefType['TracingReportDraft']> } ) | ( Omit<MedixsReception, 'medixsDispensingRecord' | 'medixsPatient'> & { medixsDispensingRecord?: Maybe<_RefType['MedixsDispensingRecord']>, medixsPatient: _RefType['MedixsPatient'] } ) | ( Omit<MedixsSetting, 'medixsPatients' | 'medixsReceptions' | 'organization'> & { medixsPatients: _RefType['MedixsPatientPage'], medixsReceptions: _RefType['MedixsReceptionPage'], organization: _RefType['Organization'] } ) | ( Omit<MessageDeliver, 'patient' | 'practitioner'> & { patient: _RefType['Patient'], practitioner: _RefType['Practitioner'] } ) | ( Omit<MessageDeliverResult, 'guestPatient' | 'organization' | 'patient' | 'practitioner'> & { guestPatient?: Maybe<_RefType['GuestPatient']>, organization: _RefType['Organization'], patient?: Maybe<_RefType['Patient']>, practitioner: _RefType['Practitioner'] } ) | ( Operator ) | ( OperatorAccessPermission ) | ( OperatorRole ) | ( Omit<Organization, 'adminPractitioners' | 'allPatients' | 'appointments' | 'b2cloudSetting' | 'bankAccount' | 'bookmarkedPatients' | 'chargeHistories' | 'checkinEntries' | 'checkinSetting' | 'clientCerts' | 'company' | 'companyCommonSetting' | 'dailySalesDetail' | 'directVisitorCandidates' | 'directVisitors' | 'disclosedMedicineNotes' | 'faximoSendFaxes' | 'featureUsages' | 'feeSettings' | 'hiccupTemporaryPermissions' | 'invitationCodes' | 'medicalInstitutionSetting' | 'medicalInstitutionSettings' | 'medicationFollowupMessageTemplates' | 'medicationFollowupMessages' | 'medicationFollowupQuestionnaireSheets' | 'medicationFollowupQuestionnaires' | 'medicationFollowupSetting' | 'medixsSetting' | 'notificationSetting' | 'organizationAddresses' | 'organizationContactPoints' | 'organizationNotifications' | 'patients' | 'payoutOrganizations' | 'pharmacistPractitioners' | 'practitionerAuthentications' | 'receptions' | 'unreadOrganizationNotifications'> & { adminPractitioners: Array<_RefType['Practitioner']>, allPatients: _RefType['AllPatientPage'], appointments: _RefType['AppointmentPage'], b2cloudSetting?: Maybe<_RefType['B2cloudSetting']>, bankAccount?: Maybe<_RefType['BankAccount']>, bookmarkedPatients: _RefType['PatientPage'], chargeHistories: _RefType['ChargeHistoryPage'], checkinEntries: _RefType['CheckinEntryPage'], checkinSetting?: Maybe<_RefType['CheckinSetting']>, clientCerts: _RefType['ClientCertPage'], company: _RefType['Company'], companyCommonSetting?: Maybe<_RefType['CompanyCommonSetting']>, dailySalesDetail: _RefType['OrganizationDailySalesDetail'], directVisitorCandidates: _RefType['DirectVisitorCandidatePage'], directVisitors: _RefType['DirectVisitorPage'], disclosedMedicineNotes: _RefType['DisclosedMedicineNotePage'], faximoSendFaxes: _RefType['FaximoSendFaxPage'], featureUsages: _RefType['FeatureUsagePage'], feeSettings: _RefType['FeeSettingPage'], hiccupTemporaryPermissions: _RefType['HiccupTemporaryPermissionPage'], invitationCodes: _RefType['InvitationCodePage'], medicalInstitutionSetting?: Maybe<_RefType['MedicalInstitutionSetting']>, medicalInstitutionSettings: _RefType['MedicalInstitutionSettingPage'], medicationFollowupMessageTemplates: _RefType['MedicationFollowupMessageTemplatePage'], medicationFollowupMessages: _RefType['MedicationFollowupMessagePage'], medicationFollowupQuestionnaireSheets: _RefType['MedicationFollowupQuestionnaireSheetPage'], medicationFollowupQuestionnaires: _RefType['MedicationFollowupQuestionnairePage'], medicationFollowupSetting?: Maybe<_RefType['MedicationFollowupSetting']>, medixsSetting?: Maybe<_RefType['MedixsSetting']>, notificationSetting?: Maybe<_RefType['OrganizationNotificationSetting']>, organizationAddresses: Array<_RefType['OrganizationAddress']>, organizationContactPoints: Array<_RefType['OrganizationContactPoint']>, organizationNotifications: _RefType['OrganizationNotificationPage'], patients: _RefType['PatientConnection'], payoutOrganizations: _RefType['PayoutOrganizationPage'], pharmacistPractitioners: Array<_RefType['Practitioner']>, practitionerAuthentications: Array<_RefType['PractitionerAuthentication']>, receptions: _RefType['ReceptionPage'], unreadOrganizationNotifications: _RefType['OrganizationNotificationPage'] } ) | ( Omit<OrganizationAddress, 'address'> & { address: _RefType['Address'] } ) | ( OrganizationCompanyFeeSetting ) | ( Omit<OrganizationContactPoint, 'contactPoint'> & { contactPoint: _RefType['ContactPoint'] } ) | ( Omit<OrganizationFeeSetting, 'organization'> & { organization: _RefType['Organization'] } ) | ( Omit<OrganizationImportJobInformation, 'company' | 'practitioner'> & { company?: Maybe<_RefType['Company']>, practitioner?: Maybe<_RefType['Practitioner']> } ) | ( Omit<OrganizationNotification, 'appointment' | 'checkinEntry' | 'draftAppointment' | 'faximoSendFax' | 'medicationFollowupMessage' | 'organization' | 'outpatientQuestionnaireEntry'> & { appointment?: Maybe<_RefType['Appointment']>, checkinEntry?: Maybe<_RefType['CheckinEntry']>, draftAppointment?: Maybe<_RefType['DraftAppointment']>, faximoSendFax?: Maybe<_RefType['FaximoSendFax']>, medicationFollowupMessage?: Maybe<_RefType['MedicationFollowupMessage']>, organization: _RefType['Organization'], outpatientQuestionnaireEntry?: Maybe<_RefType['OutpatientQuestionnaireEntry']> } ) | ( Omit<OrganizationNotificationSetting, 'organization'> & { organization: _RefType['Organization'] } ) | ( OutpatientQuestionnaire ) | ( Omit<OutpatientQuestionnaireEntry, 'address' | 'directVisitor' | 'organization' | 'unreadOrganizationNotifications'> & { address: _RefType['Address'], directVisitor: _RefType['DirectVisitor'], organization: _RefType['Organization'], unreadOrganizationNotifications: Array<_RefType['OrganizationNotification']> } ) | ( OutpatientQuestionnaireOrganization ) | ( OutpatientQuestionnaireQuestion ) | ( OutpatientQuestionnaireSetting ) | ( OutpatientQuestionnaireSettingQuestionnaire ) | ( Omit<Patient, 'appointments' | 'bookmark' | 'draftAppointments' | 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'questionnaireSheet' | 'questionnaires' | 'tracingReportDrafts' | 'tracingReports'> & { appointments: _RefType['AppointmentPage'], bookmark?: Maybe<_RefType['Bookmark']>, draftAppointments: _RefType['DraftAppointmentPage'], medicationFollowupDraftMessages: _RefType['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: _RefType['MedicationFollowupMessagePage'], medixsPatient?: Maybe<_RefType['MedixsPatient']>, messageDeliverResults: _RefType['MessageDeliverResultPage'], questionnaireSheet?: Maybe<_RefType['QuestionnaireSheet']>, questionnaires?: Maybe<Array<_RefType['QuestionnaireSheetAnswer']>>, tracingReportDrafts: _RefType['TracingReportDraftPage'], tracingReports: _RefType['TracingReportPage'] } ) | ( PatientAttachment ) | ( Omit<PatientMedicationFollowupComment, 'practitioner'> & { practitioner: _RefType['Practitioner'] } ) | ( Omit<Payout, 'company' | 'payoutOrganizations'> & { company?: Maybe<_RefType['Company']>, payoutOrganizations: _RefType['PayoutOrganizationPage'] } ) | ( Omit<PayoutBankAccount, 'payoutOrganization'> & { payoutOrganization?: Maybe<_RefType['PayoutOrganization']> } ) | ( Omit<PayoutOrganization, 'organization' | 'payout' | 'payoutBankAccount' | 'payoutSubjects'> & { organization?: Maybe<_RefType['Organization']>, payout?: Maybe<_RefType['Payout']>, payoutBankAccount?: Maybe<_RefType['PayoutBankAccount']>, payoutSubjects: Array<_RefType['PayoutSubject']> } ) | ( Omit<PayoutSubject, 'payoutOrganization'> & { payoutOrganization?: Maybe<_RefType['PayoutOrganization']> } ) | ( PfDispensingRequest ) | ( PfPatient ) | ( PfPrescriptionImage ) | ( Omit<Plan, 'extensions'> & { extensions: Array<_RefType['Extension']> } ) | ( PlanFeature ) | ( Omit<Practitioner, 'authentication' | 'organization' | 'signinHistory'> & { authentication: _RefType['PractitionerAuthentication'], organization: _RefType['Organization'], signinHistory?: Maybe<_RefType['PractitionerSigninHistory']> } ) | ( PractitionerOtpSecret ) | ( Omit<PractitionerSigninHistory, 'practitioner'> & { practitioner: _RefType['Practitioner'] } ) | ( PrivilegeOrganization ) | ( PrivilegeOrganizationPractitioner ) | ( PublicAddress ) | ( PublicAppointment ) | ( Omit<PublicCheckinEntry, 'checkinOrganization'> & { checkinOrganization: _RefType['CheckinOrganization'] } ) | ( PublicMedicationFollowupMessage ) | ( PublicMedicationFollowupQuestionnaireRevision ) | ( PublicMedicationFollowupQuestionnaireSheet ) | ( PublicOrganization ) | ( PublicOrganizationAddress ) | ( PublicOutpatientQuestionnaireEntry ) | ( PublicSignupPfPatientInformation ) | ( PublicSignupPfPatientInformationOrganization ) | ( PublicSlot ) | ( PublicWebBookingsSetting ) | ( Omit<RefundHistory, 'afterChargeHistory' | 'beforeChargeHistory' | 'patient' | 'refundedChargeHistory'> & { afterChargeHistory: _RefType['ChargeHistory'], beforeChargeHistory: _RefType['ChargeHistory'], patient: _RefType['Patient'], refundedChargeHistory: _RefType['ChargeHistory'] } ) | ( SendgridEventActivity ) | ( Omit<TracingReport, 'data' | 'latestSentFax' | 'latestSentFaxByEvent' | 'organization'> & { data: _RefType['TracingReportData'], latestSentFax?: Maybe<_RefType['FaximoSendFax']>, latestSentFaxByEvent?: Maybe<_RefType['FaximoSendFax']>, organization: _RefType['Organization'] } ) | ( Omit<TracingReportDraft, 'guestPatient' | 'patient'> & { guestPatient?: Maybe<_RefType['GuestPatient']>, patient?: Maybe<_RefType['Patient']> } ) | ( Omit<UberDelivery, 'appointment' | 'practitioner'> & { appointment: _RefType['Appointment'], practitioner: _RefType['Practitioner'] } ) | ( UberOrganization ) | ( UberOrganizationImportJobInformation ) | ( UberOrganizationSetting ) | ( UberOrganizationSettingJobInformation ) | ( Omit<UberSignature, 'company'> & { company: _RefType['Company'] } ) | ( Omit<UberSignatureDraft, 'company'> & { company: _RefType['Company'] } ) | ( WebBookingsBusinessHour ) | ( WebBookingsExceptionBusinessHour ) | ( WebBookingsExceptionDate ) | ( WebBookingsHolidayBusinessHour ) | ( WebBookingsLimit ) | ( WebBookingsSetting ) | ( WebBookingsSuspend ) | ( Omit<WebVisitor, 'appointment' | 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'questionnaireSheet' | 'samePatient' | 'tracingReportDrafts' | 'tracingReports'> & { appointment: _RefType['Appointment'], medicationFollowupDraftMessages: _RefType['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: _RefType['MedicationFollowupMessagePage'], medixsPatient?: Maybe<_RefType['MedixsPatient']>, messageDeliverResults: _RefType['MessageDeliverResultPage'], questionnaireSheet: _RefType['QuestionnaireSheet'], samePatient?: Maybe<_RefType['Patient']>, tracingReportDrafts: _RefType['TracingReportDraftPage'], tracingReports: _RefType['TracingReportPage'] } );
}>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  AccreteMessage: ResolverTypeWrapper<Omit<AccreteMessage, 'practitioner'> & { practitioner?: Maybe<ResolversTypes['Practitioner']> }>;
  AccreteMessagePage: ResolverTypeWrapper<AccreteMessagePage>;
  AccreteMessageResult: ResolverTypeWrapper<AccreteMessageResult>;
  ActivateAnnouncementInput: ActivateAnnouncementInput;
  ActivateAnnouncementPayload: ResolverTypeWrapper<ActivateAnnouncementPayload>;
  ActivateOtpSecretInput: ActivateOtpSecretInput;
  ActivateOtpSecretPayload: ResolverTypeWrapper<ActivateOtpSecretPayload>;
  AddCompanyAddressInput: AddCompanyAddressInput;
  AddCompanyAddressPayload: ResolverTypeWrapper<Omit<AddCompanyAddressPayload, 'companyAddress'> & { companyAddress: ResolversTypes['CompanyAddress'] }>;
  AddCompanyContactPointInput: AddCompanyContactPointInput;
  AddCompanyContactPointPayload: ResolverTypeWrapper<Omit<AddCompanyContactPointPayload, 'companyContactPoint'> & { companyContactPoint: ResolversTypes['CompanyContactPoint'] }>;
  AddCompanyPractitionerInput: AddCompanyPractitionerInput;
  AddCompanyPractitionerPayload: ResolverTypeWrapper<Omit<AddCompanyPractitionerPayload, 'companyPractitionerConfirmation' | 'practitioner'> & { companyPractitionerConfirmation: ResolversTypes['CompanyPractitionerConfirmation'], practitioner: ResolversTypes['Practitioner'] }>;
  AddContractPlanInput: AddContractPlanInput;
  AddContractPlanPayload: ResolverTypeWrapper<Omit<AddContractPlanPayload, 'contractPlan'> & { contractPlan: ResolversTypes['ContractPlan'] }>;
  AddIncentiveTargetCompanyInput: AddIncentiveTargetCompanyInput;
  AddIncentiveTargetCompanyPayload: ResolverTypeWrapper<Omit<AddIncentiveTargetCompanyPayload, 'company'> & { company: ResolversTypes['Company'] }>;
  AddInvitationCodeInput: AddInvitationCodeInput;
  AddInvitationCodePayload: ResolverTypeWrapper<Omit<AddInvitationCodePayload, 'invitationCode'> & { invitationCode: ResolversTypes['InvitationCode'] }>;
  AddOrganizationAddressInput: AddOrganizationAddressInput;
  AddOrganizationAddressPayload: ResolverTypeWrapper<Omit<AddOrganizationAddressPayload, 'organizationAddress'> & { organizationAddress: ResolversTypes['OrganizationAddress'] }>;
  AddOrganizationContactPointInput: AddOrganizationContactPointInput;
  AddOrganizationContactPointPayload: ResolverTypeWrapper<Omit<AddOrganizationContactPointPayload, 'organizationContactPoint'> & { organizationContactPoint: ResolversTypes['OrganizationContactPoint'] }>;
  AddPatientAttachmentInput: AddPatientAttachmentInput;
  AddPatientAttachmentPayload: ResolverTypeWrapper<AddPatientAttachmentPayload>;
  AddUberSignatureDraftExtraTextInput: AddUberSignatureDraftExtraTextInput;
  AddUberSignatureDraftExtraTextPayload: ResolverTypeWrapper<Omit<AddUberSignatureDraftExtraTextPayload, 'uberSignatureDraft'> & { uberSignatureDraft: ResolversTypes['UberSignatureDraft'] }>;
  Address: ResolverTypeWrapper<Address>;
  AddressType: AddressType;
  AddressUse: AddressUse;
  Agent: ResolverTypeWrapper<Agent>;
  AgentReleaseFileArch: AgentReleaseFileArch;
  AgentSetting: ResolverTypeWrapper<AgentSetting>;
  AgreementExtension: ResolverTypeWrapper<Omit<AgreementExtension, 'activatePractitioner' | 'deactivatePractitioner' | 'extension' | 'uberSignatures'> & { activatePractitioner: ResolversTypes['Practitioner'], deactivatePractitioner?: Maybe<ResolversTypes['Practitioner']>, extension: ResolversTypes['Extension'], uberSignatures?: Maybe<Array<ResolversTypes['UberSignature']>> }>;
  AgreementExtensionPage: ResolverTypeWrapper<Omit<AgreementExtensionPage, 'nodes'> & { nodes: Array<ResolversTypes['AgreementExtension']> }>;
  AllPatient: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AllPatient']>;
  AllPatientOrder: AllPatientOrder;
  AllPatientOrderField: AllPatientOrderField;
  AllPatientPage: ResolverTypeWrapper<Omit<AllPatientPage, 'nodes'> & { nodes: Array<ResolversTypes['AllPatient']> }>;
  AllowList: ResolverTypeWrapper<AllowList>;
  AllowOperatorAccessPermissionInput: AllowOperatorAccessPermissionInput;
  AllowOperatorAccessPermissionPayload: ResolverTypeWrapper<AllowOperatorAccessPermissionPayload>;
  Announcement: ResolverTypeWrapper<Announcement>;
  AnnouncementConnection: ResolverTypeWrapper<AnnouncementConnection>;
  AnnouncementEdge: ResolverTypeWrapper<AnnouncementEdge>;
  AnnouncementPage: ResolverTypeWrapper<AnnouncementPage>;
  AnnouncementType: AnnouncementType;
  AppendIdToFeatureTargetGroupInput: AppendIdToFeatureTargetGroupInput;
  AppendIdToFeatureTargetGroupPayload: ResolverTypeWrapper<AppendIdToFeatureTargetGroupPayload>;
  AppendToFeatureTargetGroupInput: AppendToFeatureTargetGroupInput;
  AppendToFeatureTargetGroupPayload: ResolverTypeWrapper<AppendToFeatureTargetGroupPayload>;
  Appointment: ResolverTypeWrapper<Omit<Appointment, 'charge' | 'draftAppointment' | 'encounter' | 'hiccupAppointmentPermission' | 'medixsReception' | 'organization' | 'patient' | 'questionnaires' | 'uberDelivery' | 'unreadOrganizationNotifications' | 'webVisitor'> & { charge?: Maybe<ResolversTypes['Charge']>, draftAppointment?: Maybe<ResolversTypes['DraftAppointment']>, encounter?: Maybe<ResolversTypes['Encounter']>, hiccupAppointmentPermission?: Maybe<ResolversTypes['HiccupAppointmentPermission']>, medixsReception?: Maybe<ResolversTypes['MedixsReception']>, organization: ResolversTypes['Organization'], patient?: Maybe<ResolversTypes['Patient']>, questionnaires: Array<ResolversTypes['QuestionnaireSheetAnswer']>, uberDelivery?: Maybe<ResolversTypes['UberDelivery']>, unreadOrganizationNotifications: Array<ResolversTypes['OrganizationNotification']>, webVisitor?: Maybe<ResolversTypes['WebVisitor']> }>;
  AppointmentCancellationReason: AppointmentCancellationReason;
  AppointmentConnection: ResolverTypeWrapper<Omit<AppointmentConnection, 'edges' | 'nodes'> & { edges?: Maybe<Array<Maybe<ResolversTypes['AppointmentEdge']>>>, nodes?: Maybe<Array<Maybe<ResolversTypes['Appointment']>>> }>;
  AppointmentDeliveryMethod: AppointmentDeliveryMethod;
  AppointmentEdge: ResolverTypeWrapper<Omit<AppointmentEdge, 'node'> & { node?: Maybe<ResolversTypes['Appointment']> }>;
  AppointmentOrder: AppointmentOrder;
  AppointmentOrderField: AppointmentOrderField;
  AppointmentPage: ResolverTypeWrapper<Omit<AppointmentPage, 'nodes'> & { nodes: Array<ResolversTypes['Appointment']> }>;
  AppointmentPfDispensingRequestUploadType: AppointmentPfDispensingRequestUploadType;
  AppointmentQualificationConfirmationMethod: AppointmentQualificationConfirmationMethod;
  AppointmentStatus: AppointmentStatus;
  ApproveUberSignatureInput: ApproveUberSignatureInput;
  ApproveUberSignaturePayload: ResolverTypeWrapper<Omit<ApproveUberSignaturePayload, 'uberSignature'> & { uberSignature: ResolversTypes['UberSignature'] }>;
  AuthToken: ResolverTypeWrapper<AuthToken>;
  B2cloudInvoiceType: B2cloudInvoiceType;
  B2cloudSetting: ResolverTypeWrapper<Omit<B2cloudSetting, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  B2cloudSettingData: ResolverTypeWrapper<B2cloudSettingData>;
  B2cloudSettingSenderData: ResolverTypeWrapper<B2cloudSettingSenderData>;
  Bank: ResolverTypeWrapper<Bank>;
  BankAccount: ResolverTypeWrapper<Omit<BankAccount, 'organization'> & { organization?: Maybe<ResolversTypes['Organization']> }>;
  BankAccountAccount: BankAccountAccount;
  BankBranch: ResolverTypeWrapper<BankBranch>;
  BankPage: ResolverTypeWrapper<BankPage>;
  Blob: ResolverTypeWrapper<Blob>;
  BookAppointmentInput: BookAppointmentInput;
  BookAppointmentPayload: ResolverTypeWrapper<Omit<BookAppointmentPayload, 'encounter'> & { encounter: ResolversTypes['Encounter'] }>;
  Bookmark: ResolverTypeWrapper<Bookmark>;
  BookmarkedPatientCount: ResolverTypeWrapper<Omit<BookmarkedPatientCount, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  BookmarkedPatientCountPage: ResolverTypeWrapper<Omit<BookmarkedPatientCountPage, 'nodes'> & { nodes: Array<ResolversTypes['BookmarkedPatientCount']> }>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Branch: ResolverTypeWrapper<Branch>;
  BranchPage: ResolverTypeWrapper<BranchPage>;
  BulkDuplicateMedicationFollowupMessageTemplatesInput: BulkDuplicateMedicationFollowupMessageTemplatesInput;
  BulkDuplicateMedicationFollowupMessageTemplatesPayload: ResolverTypeWrapper<Omit<BulkDuplicateMedicationFollowupMessageTemplatesPayload, 'messageTemplateJobInformation'> & { messageTemplateJobInformation: ResolversTypes['MedicationFollowupMessageTemplateJobInformation'] }>;
  BusinessHourTime: ResolverTypeWrapper<BusinessHourTime>;
  BusinessHourTimeInput: BusinessHourTimeInput;
  CancelAppointmentInput: CancelAppointmentInput;
  CancelAppointmentPayload: ResolverTypeWrapper<Omit<CancelAppointmentPayload, 'appointment'> & { appointment: ResolversTypes['Appointment'] }>;
  CancelAppointmentReason: CancelAppointmentReason;
  CancelAppointmentViaWebInput: CancelAppointmentViaWebInput;
  CancelAppointmentViaWebPayload: ResolverTypeWrapper<CancelAppointmentViaWebPayload>;
  CancelAppointmentWithWebVisitorInput: CancelAppointmentWithWebVisitorInput;
  CancelAppointmentWithWebVisitorPayload: ResolverTypeWrapper<Omit<CancelAppointmentWithWebVisitorPayload, 'appointment'> & { appointment: ResolversTypes['Appointment'] }>;
  CancelDraftAppointmentInput: CancelDraftAppointmentInput;
  CancelDraftAppointmentPayload: ResolverTypeWrapper<Omit<CancelDraftAppointmentPayload, 'draftAppointment'> & { draftAppointment: ResolversTypes['DraftAppointment'] }>;
  CancelOperatorAccessPermissionInput: CancelOperatorAccessPermissionInput;
  CancelOperatorAccessPermissionPayload: ResolverTypeWrapper<CancelOperatorAccessPermissionPayload>;
  ChangeDeliveryMethod: ChangeDeliveryMethod;
  ChangeDeliveryMethodInput: ChangeDeliveryMethodInput;
  ChangeDeliveryMethodPayload: ResolverTypeWrapper<Omit<ChangeDeliveryMethodPayload, 'appointment'> & { appointment: ResolversTypes['Appointment'] }>;
  ChangeOutpatientQuestionnaireSettingQuestionnaireInUseInput: ChangeOutpatientQuestionnaireSettingQuestionnaireInUseInput;
  ChangeOutpatientQuestionnaireSettingQuestionnaireInUsePayload: ResolverTypeWrapper<ChangeOutpatientQuestionnaireSettingQuestionnaireInUsePayload>;
  Charge: ResolverTypeWrapper<Omit<Charge, 'appointment' | 'chargeHistories' | 'practitioner'> & { appointment: ResolversTypes['Appointment'], chargeHistories: ResolversTypes['ChargeHistoryPage'], practitioner: ResolversTypes['Practitioner'] }>;
  ChargeHistory: ResolverTypeWrapper<Omit<ChargeHistory, 'amountDetails' | 'charge' | 'organization'> & { amountDetails?: Maybe<Array<ResolversTypes['ChargeHistoryAmountDetail']>>, charge: ResolversTypes['Charge'], organization: ResolversTypes['Organization'] }>;
  ChargeHistoryAmountDetail: ResolverTypeWrapper<ChargeHistoryAmountDetail>;
  ChargeHistoryPage: ResolverTypeWrapper<Omit<ChargeHistoryPage, 'nodes'> & { nodes: Array<ResolversTypes['ChargeHistory']> }>;
  ChargeItemType: ChargeItemType;
  ChargeWithApp2ChargeItemInput: ChargeWithApp2ChargeItemInput;
  ChargeWithApp2Input: ChargeWithApp2Input;
  ChargeWithApp2LineItemInput: ChargeWithApp2LineItemInput;
  ChargeWithApp2Payload: ResolverTypeWrapper<Omit<ChargeWithApp2Payload, 'charge'> & { charge: ResolversTypes['Charge'] }>;
  ChargeWithAppInput: ChargeWithAppInput;
  ChargeWithAppPayload: ResolverTypeWrapper<Omit<ChargeWithAppPayload, 'charge'> & { charge: ResolversTypes['Charge'] }>;
  ChargeWithCash2Input: ChargeWithCash2Input;
  ChargeWithCash2Payload: ResolverTypeWrapper<Omit<ChargeWithCash2Payload, 'charge'> & { charge: ResolversTypes['Charge'] }>;
  ChargeWithCashInput: ChargeWithCashInput;
  ChargeWithCashPayload: ResolverTypeWrapper<Omit<ChargeWithCashPayload, 'charge'> & { charge: ResolversTypes['Charge'] }>;
  CheckinEntry: ResolverTypeWrapper<Omit<CheckinEntry, 'checkinOrganization' | 'organization' | 'unreadOrganizationNotifications'> & { checkinOrganization: ResolversTypes['CheckinOrganization'], organization: ResolversTypes['Organization'], unreadOrganizationNotifications: Array<ResolversTypes['OrganizationNotification']> }>;
  CheckinEntryPage: ResolverTypeWrapper<Omit<CheckinEntryPage, 'nodes'> & { nodes: Array<ResolversTypes['CheckinEntry']> }>;
  CheckinEntryStatus: CheckinEntryStatus;
  CheckinOrganization: ResolverTypeWrapper<CheckinOrganization>;
  CheckinSetting: ResolverTypeWrapper<Omit<CheckinSetting, 'checkinOrganization' | 'organization'> & { checkinOrganization: ResolversTypes['CheckinOrganization'], organization: ResolversTypes['Organization'] }>;
  City: ResolverTypeWrapper<City>;
  ClientAuthentication: ResolverTypeWrapper<Omit<ClientAuthentication, 'company'> & { company: ResolversTypes['Company'] }>;
  ClientCert: ResolverTypeWrapper<Omit<ClientCert, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  ClientCertDownloadStatus: ClientCertDownloadStatus;
  ClientCertJobInformation: ResolverTypeWrapper<ClientCertJobInformation>;
  ClientCertPage: ResolverTypeWrapper<Omit<ClientCertPage, 'nodes'> & { nodes: Array<ResolversTypes['ClientCert']> }>;
  ClientCertStatus: ClientCertStatus;
  ClientCertStatusFilter: ClientCertStatusFilter;
  ClientCertSummary: ResolverTypeWrapper<Omit<ClientCertSummary, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  ClientCertSummaryPage: ResolverTypeWrapper<Omit<ClientCertSummaryPage, 'nodes'> & { nodes: Array<ResolversTypes['ClientCertSummary']> }>;
  ClientCertVerification: ResolverTypeWrapper<Omit<ClientCertVerification, 'clientCert'> & { clientCert?: Maybe<ResolversTypes['ClientCert']> }>;
  ClientCertVerificationStatus: ClientCertVerificationStatus;
  Company: ResolverTypeWrapper<Omit<Company, 'affectedOrganizationsByDeactivation' | 'agreementExtensions' | 'bookmarkedPatientCounts' | 'candidateCompanyPractitioners' | 'checkinEntries' | 'clientAuthentication' | 'clientCertSummaries' | 'companyAddresses' | 'companyContactPoints' | 'companyPractitioner' | 'companyPractitionerConfirmation' | 'contract' | 'featureUsages' | 'feeSettings' | 'latestSucceededTemplateJobInformation' | 'latestUberSignature' | 'medicationFollowupUsages' | 'monthlySales' | 'organizationImportJobInformations' | 'organizations' | 'payouts' | 'receptionUsages' | 'receptions' | 'tracingReportUsages' | 'uberSignatureDraft' | 'uberSignatures' | 'webBookingsLimitSettings'> & { affectedOrganizationsByDeactivation?: Maybe<ResolversTypes['OrganizationPage']>, agreementExtensions: ResolversTypes['AgreementExtensionPage'], bookmarkedPatientCounts: ResolversTypes['BookmarkedPatientCountPage'], candidateCompanyPractitioners?: Maybe<Array<ResolversTypes['Practitioner']>>, checkinEntries: ResolversTypes['CheckinEntryPage'], clientAuthentication?: Maybe<ResolversTypes['ClientAuthentication']>, clientCertSummaries: ResolversTypes['ClientCertSummaryPage'], companyAddresses: Array<ResolversTypes['CompanyAddress']>, companyContactPoints: Array<ResolversTypes['CompanyContactPoint']>, companyPractitioner?: Maybe<ResolversTypes['CompanyPractitioner']>, companyPractitionerConfirmation?: Maybe<ResolversTypes['CompanyPractitionerConfirmation']>, contract?: Maybe<ResolversTypes['Contract']>, featureUsages: ResolversTypes['FeatureUsagePage'], feeSettings: ResolversTypes['CompanyFeeSettingPage'], latestSucceededTemplateJobInformation?: Maybe<ResolversTypes['MedicationFollowupMessageTemplateJobInformation']>, latestUberSignature?: Maybe<ResolversTypes['UberSignature']>, medicationFollowupUsages: ResolversTypes['MedicationFollowupUsagePage'], monthlySales?: Maybe<ResolversTypes['CompanyMonthlySales']>, organizationImportJobInformations: ResolversTypes['OrganizationImportJobInformationConnection'], organizations: ResolversTypes['OrganizationPage'], payouts: ResolversTypes['PayoutPage'], receptionUsages: ResolversTypes['ReceptionUsagePage'], receptions?: Maybe<ResolversTypes['ReceptionPage']>, tracingReportUsages: ResolversTypes['TracingReportUsagePage'], uberSignatureDraft?: Maybe<ResolversTypes['UberSignatureDraft']>, uberSignatures?: Maybe<Array<ResolversTypes['UberSignature']>>, webBookingsLimitSettings: Array<ResolversTypes['CompanyWebBookingsLimitSetting']> }>;
  CompanyAddress: ResolverTypeWrapper<Omit<CompanyAddress, 'address'> & { address: ResolversTypes['Address'] }>;
  CompanyAgentSetting: ResolverTypeWrapper<CompanyAgentSetting>;
  CompanyCommonSetting: ResolverTypeWrapper<Omit<CompanyCommonSetting, 'organization'> & { organization?: Maybe<ResolversTypes['Organization']> }>;
  CompanyContactPoint: ResolverTypeWrapper<Omit<CompanyContactPoint, 'contactPoint'> & { contactPoint: ResolversTypes['ContactPoint'] }>;
  CompanyFeeSetting: ResolverTypeWrapper<Omit<CompanyFeeSetting, 'company'> & { company: ResolversTypes['Company'] }>;
  CompanyFeeSettingPage: ResolverTypeWrapper<Omit<CompanyFeeSettingPage, 'nodes'> & { nodes: Array<ResolversTypes['CompanyFeeSetting']> }>;
  CompanyMonthlySales: ResolverTypeWrapper<Omit<CompanyMonthlySales, 'organizationDailySales'> & { organizationDailySales: ResolversTypes['OrganizationDailySalesPage'] }>;
  CompanyPractitioner: ResolverTypeWrapper<Omit<CompanyPractitioner, 'company' | 'companyPractitionerContactPoints' | 'practitioner'> & { company: ResolversTypes['Company'], companyPractitionerContactPoints: Array<ResolversTypes['CompanyPractitionerContactPoint']>, practitioner: ResolversTypes['Practitioner'] }>;
  CompanyPractitionerConfirmation: ResolverTypeWrapper<Omit<CompanyPractitionerConfirmation, 'company' | 'practitioner'> & { company: ResolversTypes['Company'], practitioner: ResolversTypes['Practitioner'] }>;
  CompanyPractitionerConfirmationData: ResolverTypeWrapper<CompanyPractitionerConfirmationData>;
  CompanyPractitionerConfirmationType: CompanyPractitionerConfirmationType;
  CompanyPractitionerContactPoint: ResolverTypeWrapper<Omit<CompanyPractitionerContactPoint, 'contactPoint'> & { contactPoint: ResolversTypes['ContactPoint'] }>;
  CompanySessionSetting: ResolverTypeWrapper<CompanySessionSetting>;
  CompanySetupDocument: ResolverTypeWrapper<CompanySetupDocument>;
  CompanyWebBookingsLimitSetting: ResolverTypeWrapper<Omit<CompanyWebBookingsLimitSetting, 'company'> & { company: ResolversTypes['Company'] }>;
  ContactPoint: ResolverTypeWrapper<ContactPoint>;
  ContactPointSystem: ContactPointSystem;
  ContactPointUse: ContactPointUse;
  Contract: ResolverTypeWrapper<Omit<Contract, 'contractPlans'> & { contractPlans: Array<ResolversTypes['ContractPlan']> }>;
  ContractPlan: ResolverTypeWrapper<Omit<ContractPlan, 'contract' | 'plan'> & { contract: ResolversTypes['Contract'], plan: ResolversTypes['Plan'] }>;
  CreateAdminPractitionerInput: CreateAdminPractitionerInput;
  CreateAllowListInput: CreateAllowListInput;
  CreateAllowListPayload: ResolverTypeWrapper<CreateAllowListPayload>;
  CreateAnnouncementInput: CreateAnnouncementInput;
  CreateAnnouncementPayload: ResolverTypeWrapper<CreateAnnouncementPayload>;
  CreateAppointmentViaWebInput: CreateAppointmentViaWebInput;
  CreateAppointmentViaWebPayload: ResolverTypeWrapper<CreateAppointmentViaWebPayload>;
  CreateAuthTokenByProxyInput: CreateAuthTokenByProxyInput;
  CreateAuthTokenByProxyPayload: ResolverTypeWrapper<CreateAuthTokenByProxyPayload>;
  CreateCheckinEntryInput: CreateCheckinEntryInput;
  CreateCheckinEntryPayload: ResolverTypeWrapper<Omit<CreateCheckinEntryPayload, 'publicCheckinEntry'> & { publicCheckinEntry: ResolversTypes['PublicCheckinEntry'] }>;
  CreateClientCertInput: CreateClientCertInput;
  CreateClientCertPayload: ResolverTypeWrapper<Omit<CreateClientCertPayload, 'clientCert'> & { clientCert: ResolversTypes['ClientCert'] }>;
  CreateCompanyFeeSettingInput: CreateCompanyFeeSettingInput;
  CreateCompanyFeeSettingPayload: ResolverTypeWrapper<Omit<CreateCompanyFeeSettingPayload, 'companyFeeSetting'> & { companyFeeSetting: ResolversTypes['CompanyFeeSetting'] }>;
  CreateCompanySetupDocumentInput: CreateCompanySetupDocumentInput;
  CreateCompanySetupDocumentPayload: ResolverTypeWrapper<CreateCompanySetupDocumentPayload>;
  CreateDirectVisitorInput: CreateDirectVisitorInput;
  CreateDirectVisitorPayload: ResolverTypeWrapper<Omit<CreateDirectVisitorPayload, 'directVisitor'> & { directVisitor: ResolversTypes['DirectVisitor'] }>;
  CreateFeatureInput: CreateFeatureInput;
  CreateFeaturePayload: ResolverTypeWrapper<CreateFeaturePayload>;
  CreateFeatureTargetGroupFromTargetInput: CreateFeatureTargetGroupFromTargetInput;
  CreateFeatureTargetGroupFromTargetPayload: ResolverTypeWrapper<CreateFeatureTargetGroupFromTargetPayload>;
  CreateFeatureTargetGroupInput: CreateFeatureTargetGroupInput;
  CreateFeatureTargetGroupPayload: ResolverTypeWrapper<CreateFeatureTargetGroupPayload>;
  CreateGendaSettingInput: CreateGendaSettingInput;
  CreateGendaSettingPayload: ResolverTypeWrapper<Omit<CreateGendaSettingPayload, 'gendaSetting'> & { gendaSetting: ResolversTypes['GendaSetting'] }>;
  CreateGuestPatientFollowupCommentInput: CreateGuestPatientFollowupCommentInput;
  CreateGuestPatientFollowupCommentPayload: ResolverTypeWrapper<CreateGuestPatientFollowupCommentPayload>;
  CreateMedicalInstitutionSettingInput: CreateMedicalInstitutionSettingInput;
  CreateMedicalInstitutionSettingPayload: ResolverTypeWrapper<Omit<CreateMedicalInstitutionSettingPayload, 'medicalInstitutionSetting'> & { medicalInstitutionSetting: ResolversTypes['MedicalInstitutionSetting'] }>;
  CreateMedicationFollowupMessage2Input: CreateMedicationFollowupMessage2Input;
  CreateMedicationFollowupMessage2Payload: ResolverTypeWrapper<Omit<CreateMedicationFollowupMessage2Payload, 'medicationFollowupMessage'> & { medicationFollowupMessage: ResolversTypes['MedicationFollowupMessage'] }>;
  CreateMedicationFollowupMessageTemplateInput: CreateMedicationFollowupMessageTemplateInput;
  CreateMedicationFollowupMessageTemplatePayload: ResolverTypeWrapper<Omit<CreateMedicationFollowupMessageTemplatePayload, 'medicationFollowupMessageTemplate'> & { medicationFollowupMessageTemplate: ResolversTypes['MedicationFollowupMessageTemplate'] }>;
  CreateMedicationFollowupQuestionnaireInput: CreateMedicationFollowupQuestionnaireInput;
  CreateMedicationFollowupQuestionnairePayload: ResolverTypeWrapper<Omit<CreateMedicationFollowupQuestionnairePayload, 'medicationFollowupQuestionnaire'> & { medicationFollowupQuestionnaire: ResolversTypes['MedicationFollowupQuestionnaire'] }>;
  CreateMedicationFollowupQuestionnaireSheetAnswerInput: CreateMedicationFollowupQuestionnaireSheetAnswerInput;
  CreateMedicationFollowupQuestionnaireSheetInput: CreateMedicationFollowupQuestionnaireSheetInput;
  CreateMedicationFollowupQuestionnaireSheetPayload: ResolverTypeWrapper<CreateMedicationFollowupQuestionnaireSheetPayload>;
  CreateMedixsSettingInput: CreateMedixsSettingInput;
  CreateMedixsSettingPayload: ResolverTypeWrapper<Omit<CreateMedixsSettingPayload, 'medixsSetting'> & { medixsSetting: ResolversTypes['MedixsSetting'] }>;
  CreateMessageForWebVisitorInput: CreateMessageForWebVisitorInput;
  CreateMessageForWebVisitorPayload: ResolverTypeWrapper<Omit<CreateMessageForWebVisitorPayload, 'messageDeliver'> & { messageDeliver: ResolversTypes['MessageDeliver'] }>;
  CreateOperatorAuthorityInput: CreateOperatorAuthorityInput;
  CreateOperatorAuthorityPayload: ResolverTypeWrapper<CreateOperatorAuthorityPayload>;
  CreateOperatorRoleInput: CreateOperatorRoleInput;
  CreateOperatorRolePayload: ResolverTypeWrapper<CreateOperatorRolePayload>;
  CreateOrganizationCompanyFeeSettingInput: CreateOrganizationCompanyFeeSettingInput;
  CreateOrganizationCompanyFeeSettingPayload: ResolverTypeWrapper<CreateOrganizationCompanyFeeSettingPayload>;
  CreateOrganizationFeeSettingInput: CreateOrganizationFeeSettingInput;
  CreateOrganizationFeeSettingPayload: ResolverTypeWrapper<Omit<CreateOrganizationFeeSettingPayload, 'organizationFeeSetting'> & { organizationFeeSetting: ResolversTypes['OrganizationFeeSetting'] }>;
  CreateOrganizationInput: CreateOrganizationInput;
  CreateOrganizationPayload: ResolverTypeWrapper<Omit<CreateOrganizationPayload, 'adminPractitioner' | 'organization'> & { adminPractitioner?: Maybe<ResolversTypes['Practitioner']>, organization: ResolversTypes['Organization'] }>;
  CreateOtpSecretInput: CreateOtpSecretInput;
  CreateOtpSecretPayload: ResolverTypeWrapper<CreateOtpSecretPayload>;
  CreateOutpatientQuestionnaireEntryAddressInput: CreateOutpatientQuestionnaireEntryAddressInput;
  CreateOutpatientQuestionnaireEntryAnswerInput: CreateOutpatientQuestionnaireEntryAnswerInput;
  CreateOutpatientQuestionnaireEntryInput: CreateOutpatientQuestionnaireEntryInput;
  CreateOutpatientQuestionnaireEntryPayload: ResolverTypeWrapper<CreateOutpatientQuestionnaireEntryPayload>;
  CreateOutpatientQuestionnaireSettingQuestionnaireInput: CreateOutpatientQuestionnaireSettingQuestionnaireInput;
  CreateOutpatientQuestionnaireSettingQuestionnairePayload: ResolverTypeWrapper<CreateOutpatientQuestionnaireSettingQuestionnairePayload>;
  CreatePatientFollowupCommentInput: CreatePatientFollowupCommentInput;
  CreatePatientFollowupCommentPayload: ResolverTypeWrapper<CreatePatientFollowupCommentPayload>;
  CreatePlanInput: CreatePlanInput;
  CreatePlanPayload: ResolverTypeWrapper<Omit<CreatePlanPayload, 'plan'> & { plan: ResolversTypes['Plan'] }>;
  CreatePractitionerInput: CreatePractitionerInput;
  CreatePractitionerPayload: ResolverTypeWrapper<Omit<CreatePractitionerPayload, 'practitioner'> & { practitioner: ResolversTypes['Practitioner'] }>;
  CreateTracingReportInput: CreateTracingReportInput;
  CreateTracingReportPayload: ResolverTypeWrapper<Omit<CreateTracingReportPayload, 'tracingReport'> & { tracingReport: ResolversTypes['TracingReport'] }>;
  CreateUberAgreementExtensionInput: CreateUberAgreementExtensionInput;
  CreateUberAgreementExtensionPayload: ResolverTypeWrapper<Omit<CreateUberAgreementExtensionPayload, 'agreementExtension' | 'uberSignature'> & { agreementExtension: ResolversTypes['AgreementExtension'], uberSignature: ResolversTypes['UberSignature'] }>;
  CreateUberDeliveryInput: CreateUberDeliveryInput;
  CreateUberDeliveryPayload: ResolverTypeWrapper<Omit<CreateUberDeliveryPayload, 'uberDelivery'> & { uberDelivery: ResolversTypes['UberDelivery'] }>;
  CsCity: ResolverTypeWrapper<CsCity>;
  CsClinic: ResolverTypeWrapper<CsClinic>;
  CsClinicCategory: ResolverTypeWrapper<CsClinicCategory>;
  CsClinicPage: ResolverTypeWrapper<CsClinicPage>;
  CsClinicSubCategory: ResolverTypeWrapper<CsClinicSubCategory>;
  DeactivateAnnouncementInput: DeactivateAnnouncementInput;
  DeactivateAnnouncementPayload: ResolverTypeWrapper<DeactivateAnnouncementPayload>;
  DeactivateCompanyFeeSettingInput: DeactivateCompanyFeeSettingInput;
  DeactivateCompanyFeeSettingPayload: ResolverTypeWrapper<Omit<DeactivateCompanyFeeSettingPayload, 'companyFeeSetting'> & { companyFeeSetting: ResolversTypes['CompanyFeeSetting'] }>;
  DeactivateCompanyInput: DeactivateCompanyInput;
  DeactivateCompanyPayload: ResolverTypeWrapper<Omit<DeactivateCompanyPayload, 'company'> & { company: ResolversTypes['Company'] }>;
  DeactivateMedicationFollowupMessageInput: DeactivateMedicationFollowupMessageInput;
  DeactivateMedicationFollowupMessagePayload: ResolverTypeWrapper<Omit<DeactivateMedicationFollowupMessagePayload, 'medicationFollowupMessage'> & { medicationFollowupMessage: ResolversTypes['MedicationFollowupMessage'] }>;
  DeactivateMedicationFollowupMessageTemplateInput: DeactivateMedicationFollowupMessageTemplateInput;
  DeactivateMedicationFollowupMessageTemplatePayload: ResolverTypeWrapper<Omit<DeactivateMedicationFollowupMessageTemplatePayload, 'medicationFollowupMessageTemplate'> & { medicationFollowupMessageTemplate: ResolversTypes['MedicationFollowupMessageTemplate'] }>;
  DeactivateMedicationFollowupQuestionnaireInput: DeactivateMedicationFollowupQuestionnaireInput;
  DeactivateMedicationFollowupQuestionnairePayload: ResolverTypeWrapper<Omit<DeactivateMedicationFollowupQuestionnairePayload, 'medicationFollowupQuestionnaire'> & { medicationFollowupQuestionnaire: ResolversTypes['MedicationFollowupQuestionnaire'] }>;
  DeactivateOperatorInput: DeactivateOperatorInput;
  DeactivateOperatorPayload: ResolverTypeWrapper<DeactivateOperatorPayload>;
  DeactivateOrganizationFeeSettingInput: DeactivateOrganizationFeeSettingInput;
  DeactivateOrganizationFeeSettingPayload: ResolverTypeWrapper<Omit<DeactivateOrganizationFeeSettingPayload, 'organizationFeeSetting'> & { organizationFeeSetting: ResolversTypes['OrganizationFeeSetting'] }>;
  DeactivateOtpSecretsInput: DeactivateOtpSecretsInput;
  DeactivateOtpSecretsPayload: ResolverTypeWrapper<Omit<DeactivateOtpSecretsPayload, 'practitioner'> & { practitioner: ResolversTypes['Practitioner'] }>;
  DeactivatePractitionerInput: DeactivatePractitionerInput;
  DeactivatePractitionerPayload: ResolverTypeWrapper<Omit<DeactivatePractitionerPayload, 'practitioner'> & { practitioner: ResolversTypes['Practitioner'] }>;
  DeleteAllowListInput: DeleteAllowListInput;
  DeleteAllowListPayload: ResolverTypeWrapper<DeleteAllowListPayload>;
  DeleteFeatureInput: DeleteFeatureInput;
  DeleteFeaturePayload: ResolverTypeWrapper<DeleteFeaturePayload>;
  DeleteFeatureTargetGroupInput: DeleteFeatureTargetGroupInput;
  DeleteFeatureTargetGroupPayload: ResolverTypeWrapper<DeleteFeatureTargetGroupPayload>;
  DeleteFromFeatureTargetGroupInput: DeleteFromFeatureTargetGroupInput;
  DeleteFromFeatureTargetGroupPayload: ResolverTypeWrapper<DeleteFromFeatureTargetGroupPayload>;
  DeleteGuestPatientMedicationFollowupCommentInput: DeleteGuestPatientMedicationFollowupCommentInput;
  DeleteGuestPatientMedicationFollowupCommentPayload: ResolverTypeWrapper<DeleteGuestPatientMedicationFollowupCommentPayload>;
  DeleteIdFromFeatureTargetGroupInput: DeleteIdFromFeatureTargetGroupInput;
  DeleteIdFromFeatureTargetGroupPayload: ResolverTypeWrapper<DeleteIdFromFeatureTargetGroupPayload>;
  DeleteMedicationFollowupDraftMessageInput: DeleteMedicationFollowupDraftMessageInput;
  DeleteMedicationFollowupDraftMessagePayload: ResolverTypeWrapper<Omit<DeleteMedicationFollowupDraftMessagePayload, 'medicationFollowupDraftMessage'> & { medicationFollowupDraftMessage?: Maybe<ResolversTypes['MedicationFollowupDraftMessage']> }>;
  DeleteOperatorAuthorityInput: DeleteOperatorAuthorityInput;
  DeleteOperatorAuthorityPayload: ResolverTypeWrapper<DeleteOperatorAuthorityPayload>;
  DeleteOperatorRoleInput: DeleteOperatorRoleInput;
  DeleteOperatorRolePayload: ResolverTypeWrapper<DeleteOperatorRolePayload>;
  DeleteOrganizationInput: DeleteOrganizationInput;
  DeleteOrganizationPayload: ResolverTypeWrapper<Omit<DeleteOrganizationPayload, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  DeleteOutpatientQuestionnaireSettingQuestionnaireInput: DeleteOutpatientQuestionnaireSettingQuestionnaireInput;
  DeleteOutpatientQuestionnaireSettingQuestionnairePayload: ResolverTypeWrapper<DeleteOutpatientQuestionnaireSettingQuestionnairePayload>;
  DeletePatientAttachmentInput: DeletePatientAttachmentInput;
  DeletePatientAttachmentPayload: ResolverTypeWrapper<DeletePatientAttachmentPayload>;
  DeletePatientMedicationFollowupCommentInput: DeletePatientMedicationFollowupCommentInput;
  DeletePatientMedicationFollowupCommentPayload: ResolverTypeWrapper<DeletePatientMedicationFollowupCommentPayload>;
  DeleteTracingReportDraftInput: DeleteTracingReportDraftInput;
  DeleteTracingReportDraftPayload: ResolverTypeWrapper<Omit<DeleteTracingReportDraftPayload, 'tracingReportDraft'> & { tracingReportDraft?: Maybe<ResolversTypes['TracingReportDraft']> }>;
  DescriptionCode: ResolverTypeWrapper<DescriptionCode>;
  DirectVisitor: ResolverTypeWrapper<Omit<DirectVisitor, 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'outpatientQuestionnaireEntry' | 'samePatient' | 'tracingReportDrafts' | 'tracingReports'> & { medicationFollowupDraftMessages: ResolversTypes['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: ResolversTypes['MedicationFollowupMessagePage'], medixsPatient?: Maybe<ResolversTypes['MedixsPatient']>, messageDeliverResults: ResolversTypes['MessageDeliverResultPage'], outpatientQuestionnaireEntry?: Maybe<ResolversTypes['OutpatientQuestionnaireEntry']>, samePatient?: Maybe<ResolversTypes['Patient']>, tracingReportDrafts: ResolversTypes['TracingReportDraftPage'], tracingReports: ResolversTypes['TracingReportPage'] }>;
  DirectVisitorCandidate: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['DirectVisitorCandidate']>;
  DirectVisitorCandidatePage: ResolverTypeWrapper<Omit<DirectVisitorCandidatePage, 'nodes'> & { nodes: Array<ResolversTypes['DirectVisitorCandidate']> }>;
  DirectVisitorPage: ResolverTypeWrapper<Omit<DirectVisitorPage, 'nodes'> & { nodes: Array<ResolversTypes['DirectVisitor']> }>;
  DisclosedMedicineNote: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['DisclosedMedicineNote']>;
  DisclosedMedicineNotePage: ResolverTypeWrapper<Omit<DisclosedMedicineNotePage, 'nodes'> & { nodes: Array<ResolversTypes['DisclosedMedicineNote']> }>;
  Dow: Dow;
  DownloadClientCertInput: DownloadClientCertInput;
  DownloadClientCertPayload: ResolverTypeWrapper<DownloadClientCertPayload>;
  DraftAppointment: ResolverTypeWrapper<Omit<DraftAppointment, 'appointment' | 'organization' | 'patient' | 'questionnaires' | 'unreadOrganizationNotifications'> & { appointment?: Maybe<ResolversTypes['Appointment']>, organization: ResolversTypes['Organization'], patient: ResolversTypes['Patient'], questionnaires: Array<ResolversTypes['QuestionnaireSheetAnswer']>, unreadOrganizationNotifications: Array<ResolversTypes['OrganizationNotification']> }>;
  DraftAppointmentCancellationReason: DraftAppointmentCancellationReason;
  DraftAppointmentDeliveryMethod: DraftAppointmentDeliveryMethod;
  DraftAppointmentPage: ResolverTypeWrapper<Omit<DraftAppointmentPage, 'nodes'> & { nodes: Array<ResolversTypes['DraftAppointment']> }>;
  DraftAppointmentStatus: DraftAppointmentStatus;
  DumpOrganizationsInput: DumpOrganizationsInput;
  DumpOrganizationsPayload: ResolverTypeWrapper<Omit<DumpOrganizationsPayload, 'organizationImportJobInformation'> & { organizationImportJobInformation: ResolversTypes['OrganizationImportJobInformation'] }>;
  EditDirectVisitorInput: EditDirectVisitorInput;
  EditDirectVisitorPayload: ResolverTypeWrapper<Omit<EditDirectVisitorPayload, 'directVisitor'> & { directVisitor: ResolversTypes['DirectVisitor'] }>;
  Encounter: ResolverTypeWrapper<Omit<Encounter, 'appointment'> & { appointment: ResolversTypes['Appointment'] }>;
  EncounterStatus: EncounterStatus;
  Event: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Event']>;
  EventPage: ResolverTypeWrapper<Omit<EventPage, 'nodes'> & { nodes: Array<ResolversTypes['Event']> }>;
  ExtendCompanySetupDocumentInput: ExtendCompanySetupDocumentInput;
  ExtendCompanySetupDocumentPayload: ResolverTypeWrapper<ExtendCompanySetupDocumentPayload>;
  Extension: ResolverTypeWrapper<Extension>;
  ExtensionCode: ExtensionCode;
  FaximoSendFax: ResolverTypeWrapper<Omit<FaximoSendFax, 'organization' | 'practitioner' | 'tracingReport'> & { organization: ResolversTypes['Organization'], practitioner: ResolversTypes['Practitioner'], tracingReport?: Maybe<ResolversTypes['TracingReport']> }>;
  FaximoSendFaxPage: ResolverTypeWrapper<Omit<FaximoSendFaxPage, 'nodes'> & { nodes: Array<ResolversTypes['FaximoSendFax']> }>;
  FaximoSendFaxStatus: FaximoSendFaxStatus;
  Feature: ResolverTypeWrapper<Feature>;
  FeatureTarget: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['FeatureTarget']>;
  FeatureTargetGroup: ResolverTypeWrapper<FeatureTargetGroup>;
  FeatureTargetGroupType: FeatureTargetGroupType;
  FeatureUsage: ResolverTypeWrapper<Omit<FeatureUsage, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  FeatureUsageKind: FeatureUsageKind;
  FeatureUsagePage: ResolverTypeWrapper<Omit<FeatureUsagePage, 'nodes'> & { nodes: Array<ResolversTypes['FeatureUsage']> }>;
  FeatureUsageType: FeatureUsageType;
  FeeSetting: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['FeeSetting']>;
  FeeSettingPage: ResolverTypeWrapper<Omit<FeeSettingPage, 'nodes'> & { nodes: Array<ResolversTypes['FeeSetting']> }>;
  FetchMedixsReceptionInput: FetchMedixsReceptionInput;
  FetchMedixsReceptionPayload: ResolverTypeWrapper<Omit<FetchMedixsReceptionPayload, 'medixsReceptions'> & { medixsReceptions: Array<ResolversTypes['MedixsReception']> }>;
  FinalizeDeliveryOutputInput: FinalizeDeliveryOutputInput;
  FinalizeDeliveryOutputPayload: ResolverTypeWrapper<Omit<FinalizeDeliveryOutputPayload, 'appointments'> & { appointments: Array<ResolversTypes['Appointment']> }>;
  FinishAppointmentInput: FinishAppointmentInput;
  FinishAppointmentPayload: ResolverTypeWrapper<Omit<FinishAppointmentPayload, 'appointment'> & { appointment: ResolversTypes['Appointment'] }>;
  FinishCheckinEntryInput: FinishCheckinEntryInput;
  FinishCheckinEntryPayload: ResolverTypeWrapper<Omit<FinishCheckinEntryPayload, 'checkinEntries' | 'checkinEntry'> & { checkinEntries?: Maybe<Array<ResolversTypes['CheckinEntry']>>, checkinEntry?: Maybe<ResolversTypes['CheckinEntry']> }>;
  FinishDraftAppointmentInput: FinishDraftAppointmentInput;
  FinishDraftAppointmentPayload: ResolverTypeWrapper<Omit<FinishDraftAppointmentPayload, 'draftAppointment'> & { draftAppointment: ResolversTypes['DraftAppointment'] }>;
  FinishEncounterInput: FinishEncounterInput;
  FinishEncounterPayload: ResolverTypeWrapper<Omit<FinishEncounterPayload, 'encounter'> & { encounter: ResolversTypes['Encounter'] }>;
  FinishOutpatientQuestionnaireEntryInput: FinishOutpatientQuestionnaireEntryInput;
  FinishOutpatientQuestionnaireEntryPayload: ResolverTypeWrapper<Omit<FinishOutpatientQuestionnaireEntryPayload, 'outpatientQuestionnaireEntry'> & { outpatientQuestionnaireEntry: ResolversTypes['OutpatientQuestionnaireEntry'] }>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FulfillAppointmentInput: FulfillAppointmentInput;
  FulfillAppointmentPayload: ResolverTypeWrapper<Omit<FulfillAppointmentPayload, 'encounter'> & { encounter: ResolversTypes['Encounter'] }>;
  GendaApiKey: ResolverTypeWrapper<GendaApiKey>;
  GendaApiKeyData: ResolverTypeWrapper<GendaApiKeyData>;
  GendaSetting: ResolverTypeWrapper<Omit<GendaSetting, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  GendaSettingPage: ResolverTypeWrapper<Omit<GendaSettingPage, 'nodes'> & { nodes: Array<ResolversTypes['GendaSetting']> }>;
  GenerateAgentArtifactInput: GenerateAgentArtifactInput;
  GenerateAgentArtifactPayload: ResolverTypeWrapper<GenerateAgentArtifactPayload>;
  GenerateBookmarkedPatientsCountCsvInput: GenerateBookmarkedPatientsCountCsvInput;
  GenerateBookmarkedPatientsCountCsvPayload: ResolverTypeWrapper<GenerateBookmarkedPatientsCountCsvPayload>;
  GenerateClientCertCsvInput: GenerateClientCertCsvInput;
  GenerateClientCertCsvPayload: ResolverTypeWrapper<GenerateClientCertCsvPayload>;
  GenerateCompanyMedicationFollowupMessageUsagesCsvInput: GenerateCompanyMedicationFollowupMessageUsagesCsvInput;
  GenerateCompanyMedicationFollowupMessageUsagesCsvPayload: ResolverTypeWrapper<GenerateCompanyMedicationFollowupMessageUsagesCsvPayload>;
  GenerateCompanyOrganizationsAppDownloadUrlsCsvInput: GenerateCompanyOrganizationsAppDownloadUrlsCsvInput;
  GenerateCompanyOrganizationsAppDownloadUrlsCsvPayload: ResolverTypeWrapper<GenerateCompanyOrganizationsAppDownloadUrlsCsvPayload>;
  GenerateCompanyReceptionUsagesCsvInput: GenerateCompanyReceptionUsagesCsvInput;
  GenerateCompanyReceptionUsagesCsvPayload: ResolverTypeWrapper<GenerateCompanyReceptionUsagesCsvPayload>;
  GenerateCompanyReceptionsCsvInput: GenerateCompanyReceptionsCsvInput;
  GenerateCompanyReceptionsCsvPayload: ResolverTypeWrapper<GenerateCompanyReceptionsCsvPayload>;
  GenerateCompanySalesDetailsCsvInput: GenerateCompanySalesDetailsCsvInput;
  GenerateCompanySalesDetailsCsvPayload: ResolverTypeWrapper<GenerateCompanySalesDetailsCsvPayload>;
  GenerateCompanyTracingReportUsagesCsvInput: GenerateCompanyTracingReportUsagesCsvInput;
  GenerateCompanyTracingReportUsagesCsvPayload: ResolverTypeWrapper<GenerateCompanyTracingReportUsagesCsvPayload>;
  GenerateCsvForClientCertsImportInput: GenerateCsvForClientCertsImportInput;
  GenerateCsvForClientCertsImportPayload: ResolverTypeWrapper<GenerateCsvForClientCertsImportPayload>;
  GenerateCsvForMessageTemplatesBulkDuplicateInput: GenerateCsvForMessageTemplatesBulkDuplicateInput;
  GenerateCsvForMessageTemplatesBulkDuplicatePayload: ResolverTypeWrapper<GenerateCsvForMessageTemplatesBulkDuplicatePayload>;
  GenerateCsvForUberOrganizationSettingsUpsertInput: GenerateCsvForUberOrganizationSettingsUpsertInput;
  GenerateCsvForUberOrganizationSettingsUpsertPayload: ResolverTypeWrapper<GenerateCsvForUberOrganizationSettingsUpsertPayload>;
  GenerateDeliveryCsvInput: GenerateDeliveryCsvInput;
  GenerateDeliveryCsvPayload: ResolverTypeWrapper<Omit<GenerateDeliveryCsvPayload, 'appointments'> & { appointments: Array<ResolversTypes['Appointment']> }>;
  GenerateIncentivePayoutNotificationInput: GenerateIncentivePayoutNotificationInput;
  GenerateIncentivePayoutNotificationPayload: ResolverTypeWrapper<GenerateIncentivePayoutNotificationPayload>;
  GenerateOrganizationAuditEventCsvInput: GenerateOrganizationAuditEventCsvInput;
  GenerateOrganizationAuditEventCsvPayload: ResolverTypeWrapper<GenerateOrganizationAuditEventCsvPayload>;
  GeneratePayoutOrganizationsWithBankAccountCsvInput: GeneratePayoutOrganizationsWithBankAccountCsvInput;
  GeneratePayoutOrganizationsWithBankAccountCsvPayload: ResolverTypeWrapper<GeneratePayoutOrganizationsWithBankAccountCsvPayload>;
  GenerateUberSignaturePreviewFormDataInput: GenerateUberSignaturePreviewFormDataInput;
  GenerateUberSignaturePreviewFormDataPayload: ResolverTypeWrapper<GenerateUberSignaturePreviewFormDataPayload>;
  GenerateUberSignaturePreviewInput: GenerateUberSignaturePreviewInput;
  GenerateUberSignaturePreviewOnlyExtraTextInput: GenerateUberSignaturePreviewOnlyExtraTextInput;
  GenerateUberSignaturePreviewOnlyExtraTextPayload: ResolverTypeWrapper<GenerateUberSignaturePreviewOnlyExtraTextPayload>;
  GenerateUberSignaturePreviewPayload: ResolverTypeWrapper<GenerateUberSignaturePreviewPayload>;
  GuestPatient: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['GuestPatient']>;
  GuestPatientMedicationFollowupComment: ResolverTypeWrapper<Omit<GuestPatientMedicationFollowupComment, 'practitioner'> & { practitioner: ResolversTypes['Practitioner'] }>;
  GuestPatientMedicationFollowupCommentPage: ResolverTypeWrapper<GuestPatientMedicationFollowupCommentPage>;
  HiccupAppointmentPermission: ResolverTypeWrapper<Omit<HiccupAppointmentPermission, 'appointment'> & { appointment: ResolversTypes['Appointment'] }>;
  HiccupOnetimeApiCache: ResolverTypeWrapper<Omit<HiccupOnetimeApiCache, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  HiccupOnetimeApiCachePatientProfile: ResolverTypeWrapper<HiccupOnetimeApiCachePatientProfile>;
  HiccupTemporaryPermission: ResolverTypeWrapper<Omit<HiccupTemporaryPermission, 'organization' | 'patient'> & { organization: ResolversTypes['Organization'], patient?: Maybe<ResolversTypes['Patient']> }>;
  HiccupTemporaryPermissionPage: ResolverTypeWrapper<Omit<HiccupTemporaryPermissionPage, 'nodes'> & { nodes: Array<ResolversTypes['HiccupTemporaryPermission']> }>;
  Holiday: ResolverTypeWrapper<Holiday>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  ISO8601Date: ResolverTypeWrapper<Scalars['ISO8601Date']['output']>;
  ISO8601DateTime: ResolverTypeWrapper<Scalars['ISO8601DateTime']['output']>;
  IdentifyMedixsPatientInput: IdentifyMedixsPatientInput;
  IdentifyMedixsPatientPayload: ResolverTypeWrapper<Omit<IdentifyMedixsPatientPayload, 'medixsPatient' | 'medixsReception'> & { medixsPatient: ResolversTypes['MedixsPatient'], medixsReception: ResolversTypes['MedixsReception'] }>;
  IdentifyMedixsReceptionInput: IdentifyMedixsReceptionInput;
  IdentifyMedixsReceptionPayload: ResolverTypeWrapper<Omit<IdentifyMedixsReceptionPayload, 'medixsReception'> & { medixsReception: ResolversTypes['MedixsReception'] }>;
  ImportClientCertsInput: ImportClientCertsInput;
  ImportClientCertsPayload: ResolverTypeWrapper<ImportClientCertsPayload>;
  ImportOrganizationsInput: ImportOrganizationsInput;
  ImportOrganizationsPayload: ResolverTypeWrapper<Omit<ImportOrganizationsPayload, 'organizationImportJobInformation'> & { organizationImportJobInformation: ResolversTypes['OrganizationImportJobInformation'] }>;
  ImportUberOrganizationsCsvInput: ImportUberOrganizationsCsvInput;
  ImportUberOrganizationsCsvPayload: ResolverTypeWrapper<ImportUberOrganizationsCsvPayload>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  InvitationCode: ResolverTypeWrapper<Omit<InvitationCode, 'appointment'> & { appointment?: Maybe<ResolversTypes['Appointment']> }>;
  InvitationCodePage: ResolverTypeWrapper<Omit<InvitationCodePage, 'nodes'> & { nodes: Array<ResolversTypes['InvitationCode']> }>;
  Invoice: ResolverTypeWrapper<Invoice>;
  InvoiceStatus: InvoiceStatus;
  IssueGendaApiKeyInput: IssueGendaApiKeyInput;
  IssueGendaApiKeyPayload: ResolverTypeWrapper<IssueGendaApiKeyPayload>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  JobInformationStatus: JobInformationStatus;
  LineItem: ResolverTypeWrapper<LineItem>;
  LineItemCode: LineItemCode;
  LineItemType: ResolverTypeWrapper<LineItemType>;
  LoginUser: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['LoginUser']>;
  MarkAnnouncementInput: MarkAnnouncementInput;
  MarkAnnouncementPayload: ResolverTypeWrapper<MarkAnnouncementPayload>;
  MarkHiccupTemporaryPermissionInput: MarkHiccupTemporaryPermissionInput;
  MarkHiccupTemporaryPermissionPayload: ResolverTypeWrapper<Omit<MarkHiccupTemporaryPermissionPayload, 'hiccupTemporaryPermission'> & { hiccupTemporaryPermission: ResolversTypes['HiccupTemporaryPermission'] }>;
  MarkOrganizationNotificationByAppointmentInput: MarkOrganizationNotificationByAppointmentInput;
  MarkOrganizationNotificationByAppointmentPayload: ResolverTypeWrapper<Omit<MarkOrganizationNotificationByAppointmentPayload, 'organizationNotifications'> & { organizationNotifications: Array<ResolversTypes['OrganizationNotification']> }>;
  MarkOrganizationNotificationInput: MarkOrganizationNotificationInput;
  MarkOrganizationNotificationPayload: ResolverTypeWrapper<Omit<MarkOrganizationNotificationPayload, 'organizationNotification'> & { organizationNotification: ResolversTypes['OrganizationNotification'] }>;
  MedicalInstitutionSetting: ResolverTypeWrapper<Omit<MedicalInstitutionSetting, 'contactPoint' | 'organization'> & { contactPoint?: Maybe<ResolversTypes['ContactPoint']>, organization: ResolversTypes['Organization'] }>;
  MedicalInstitutionSettingPage: ResolverTypeWrapper<Omit<MedicalInstitutionSettingPage, 'nodes'> & { nodes: Array<ResolversTypes['MedicalInstitutionSetting']> }>;
  MedicationFollowupAutoReplySetting: ResolverTypeWrapper<Omit<MedicationFollowupAutoReplySetting, 'questionnaireRevision'> & { questionnaireRevision?: Maybe<ResolversTypes['MedicationFollowupQuestionnaireRevision']> }>;
  MedicationFollowupAutoReplySettingTemplate: ResolverTypeWrapper<Omit<MedicationFollowupAutoReplySettingTemplate, 'questionnaireRevision'> & { questionnaireRevision?: Maybe<ResolversTypes['MedicationFollowupQuestionnaireRevision']> }>;
  MedicationFollowupComment: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['MedicationFollowupComment']>;
  MedicationFollowupCommentPage: ResolverTypeWrapper<Omit<MedicationFollowupCommentPage, 'nodes'> & { nodes: Array<ResolversTypes['MedicationFollowupComment']> }>;
  MedicationFollowupDraftMessage: ResolverTypeWrapper<Omit<MedicationFollowupDraftMessage, 'data' | 'guestPatient' | 'patient' | 'practitioner'> & { data: ResolversTypes['MedicationFollowupDraftMessageData'], guestPatient?: Maybe<ResolversTypes['GuestPatient']>, patient?: Maybe<ResolversTypes['Patient']>, practitioner: ResolversTypes['Practitioner'] }>;
  MedicationFollowupDraftMessageData: ResolverTypeWrapper<Omit<MedicationFollowupDraftMessageData, 'medicationFollowupQuestionnaire'> & { medicationFollowupQuestionnaire?: Maybe<ResolversTypes['MedicationFollowupQuestionnaire']> }>;
  MedicationFollowupDraftMessageDataInput: MedicationFollowupDraftMessageDataInput;
  MedicationFollowupDraftMessagePage: ResolverTypeWrapper<Omit<MedicationFollowupDraftMessagePage, 'nodes'> & { nodes: Array<ResolversTypes['MedicationFollowupDraftMessage']> }>;
  MedicationFollowupMessage: ResolverTypeWrapper<Omit<MedicationFollowupMessage, 'appointment' | 'autoReplySetting' | 'directVisitor' | 'medicationFollowupQuestionnaireRevision' | 'medicationFollowupQuestionnaireSheet' | 'messageDeliverResult' | 'patient' | 'practitioner' | 'webVisitor'> & { appointment?: Maybe<ResolversTypes['Appointment']>, autoReplySetting?: Maybe<ResolversTypes['MedicationFollowupAutoReplySetting']>, directVisitor?: Maybe<ResolversTypes['DirectVisitor']>, medicationFollowupQuestionnaireRevision?: Maybe<ResolversTypes['MedicationFollowupQuestionnaireRevision']>, medicationFollowupQuestionnaireSheet?: Maybe<ResolversTypes['MedicationFollowupQuestionnaireSheet']>, messageDeliverResult?: Maybe<ResolversTypes['MessageDeliverResult']>, patient?: Maybe<ResolversTypes['Patient']>, practitioner: ResolversTypes['Practitioner'], webVisitor?: Maybe<ResolversTypes['WebVisitor']> }>;
  MedicationFollowupMessageAttachment: MedicationFollowupMessageAttachment;
  MedicationFollowupMessagePage: ResolverTypeWrapper<Omit<MedicationFollowupMessagePage, 'nodes'> & { nodes: Array<ResolversTypes['MedicationFollowupMessage']> }>;
  MedicationFollowupMessageStatus: MedicationFollowupMessageStatus;
  MedicationFollowupMessageTemplate: ResolverTypeWrapper<Omit<MedicationFollowupMessageTemplate, 'autoReplySettingTemplate' | 'medicationFollowupQuestionnaire' | 'organization'> & { autoReplySettingTemplate?: Maybe<ResolversTypes['MedicationFollowupAutoReplySettingTemplate']>, medicationFollowupQuestionnaire?: Maybe<ResolversTypes['MedicationFollowupQuestionnaire']>, organization: ResolversTypes['Organization'] }>;
  MedicationFollowupMessageTemplateJobInformation: ResolverTypeWrapper<Omit<MedicationFollowupMessageTemplateJobInformation, 'sourceOrganization'> & { sourceOrganization: ResolversTypes['Organization'] }>;
  MedicationFollowupMessageTemplatePage: ResolverTypeWrapper<Omit<MedicationFollowupMessageTemplatePage, 'nodes'> & { nodes: Array<ResolversTypes['MedicationFollowupMessageTemplate']> }>;
  MedicationFollowupQuestionnaire: ResolverTypeWrapper<Omit<MedicationFollowupQuestionnaire, 'organization' | 'revision'> & { organization: ResolversTypes['Organization'], revision: ResolversTypes['MedicationFollowupQuestionnaireRevision'] }>;
  MedicationFollowupQuestionnaireChoice: ResolverTypeWrapper<MedicationFollowupQuestionnaireChoice>;
  MedicationFollowupQuestionnaireChoiceInput: MedicationFollowupQuestionnaireChoiceInput;
  MedicationFollowupQuestionnaireCondition: ResolverTypeWrapper<MedicationFollowupQuestionnaireCondition>;
  MedicationFollowupQuestionnaireConditionInput: MedicationFollowupQuestionnaireConditionInput;
  MedicationFollowupQuestionnaireFormData: ResolverTypeWrapper<MedicationFollowupQuestionnaireFormData>;
  MedicationFollowupQuestionnaireFormDataInput: MedicationFollowupQuestionnaireFormDataInput;
  MedicationFollowupQuestionnairePage: ResolverTypeWrapper<Omit<MedicationFollowupQuestionnairePage, 'nodes'> & { nodes: Array<ResolversTypes['MedicationFollowupQuestionnaire']> }>;
  MedicationFollowupQuestionnaireQuestion: ResolverTypeWrapper<MedicationFollowupQuestionnaireQuestion>;
  MedicationFollowupQuestionnaireQuestionInput: MedicationFollowupQuestionnaireQuestionInput;
  MedicationFollowupQuestionnaireQuestionType: MedicationFollowupQuestionnaireQuestionType;
  MedicationFollowupQuestionnaireRevision: ResolverTypeWrapper<Omit<MedicationFollowupQuestionnaireRevision, 'medicationFollowupQuestionnaire'> & { medicationFollowupQuestionnaire: ResolversTypes['MedicationFollowupQuestionnaire'] }>;
  MedicationFollowupQuestionnaireSection: ResolverTypeWrapper<MedicationFollowupQuestionnaireSection>;
  MedicationFollowupQuestionnaireSectionInput: MedicationFollowupQuestionnaireSectionInput;
  MedicationFollowupQuestionnaireSheet: ResolverTypeWrapper<Omit<MedicationFollowupQuestionnaireSheet, 'answers' | 'appointment' | 'medicationFollowupMessage'> & { answers: Array<ResolversTypes['QuestionnaireSheetAnswer']>, appointment?: Maybe<ResolversTypes['Appointment']>, medicationFollowupMessage: ResolversTypes['MedicationFollowupMessage'] }>;
  MedicationFollowupQuestionnaireSheetPage: ResolverTypeWrapper<Omit<MedicationFollowupQuestionnaireSheetPage, 'nodes'> & { nodes: Array<ResolversTypes['MedicationFollowupQuestionnaireSheet']> }>;
  MedicationFollowupSetting: ResolverTypeWrapper<Omit<MedicationFollowupSetting, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  MedicationFollowupUsage: ResolverTypeWrapper<Omit<MedicationFollowupUsage, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  MedicationFollowupUsagePage: ResolverTypeWrapper<Omit<MedicationFollowupUsagePage, 'nodes'> & { nodes: Array<ResolversTypes['MedicationFollowupUsage']> }>;
  Medicine: ResolverTypeWrapper<Medicine>;
  MedicineNote: ResolverTypeWrapper<MedicineNote>;
  MedicineNoteClinic: ResolverTypeWrapper<MedicineNoteClinic>;
  MedicineNoteClinicRecord: ResolverTypeWrapper<MedicineNoteClinicRecord>;
  MedicineNoteDispensingDateRecord: ResolverTypeWrapper<MedicineNoteDispensingDateRecord>;
  MedicineNoteDispensingPharmacy: ResolverTypeWrapper<MedicineNoteDispensingPharmacy>;
  MedicineNoteDoctor: ResolverTypeWrapper<MedicineNoteDoctor>;
  MedicineNoteDoctorRecord: ResolverTypeWrapper<MedicineNoteDoctorRecord>;
  MedicineNoteDosage: ResolverTypeWrapper<MedicineNoteDosage>;
  MedicineNoteDosageCaution: ResolverTypeWrapper<MedicineNoteDosageCaution>;
  MedicineNoteDosageCautionRecord: ResolverTypeWrapper<MedicineNoteDosageCautionRecord>;
  MedicineNoteDosagePlusRecord: ResolverTypeWrapper<MedicineNoteDosagePlusRecord>;
  MedicineNoteDosageRecord: ResolverTypeWrapper<MedicineNoteDosageRecord>;
  MedicineNoteMedicine: ResolverTypeWrapper<MedicineNoteMedicine>;
  MedicineNoteMedicineCautionRecord: ResolverTypeWrapper<MedicineNoteMedicineCautionRecord>;
  MedicineNoteMedicinePlusRecord: ResolverTypeWrapper<MedicineNoteMedicinePlusRecord>;
  MedicineNoteMedicineRecord: ResolverTypeWrapper<MedicineNoteMedicineRecord>;
  MedicineNoteNotebookMemo: ResolverTypeWrapper<MedicineNoteNotebookMemo>;
  MedicineNoteNotebookMemoRecord: ResolverTypeWrapper<MedicineNoteNotebookMemoRecord>;
  MedicineNoteOtcDrugDosage: ResolverTypeWrapper<MedicineNoteOtcDrugDosage>;
  MedicineNoteOtcDrugDosageRecord: ResolverTypeWrapper<MedicineNoteOtcDrugDosageRecord>;
  MedicineNoteOtcDrugIngredientRecord: ResolverTypeWrapper<MedicineNoteOtcDrugIngredientRecord>;
  MedicineNotePatient: ResolverTypeWrapper<MedicineNotePatient>;
  MedicineNotePatientProfile: ResolverTypeWrapper<MedicineNotePatientProfile>;
  MedicineNotePatientRecord: ResolverTypeWrapper<MedicineNotePatientRecord>;
  MedicineNotePatientReportRecord: ResolverTypeWrapper<MedicineNotePatientReportRecord>;
  MedicineNotePharmacistRecord: ResolverTypeWrapper<MedicineNotePharmacistRecord>;
  MedicineNotePharmacyRecord: ResolverTypeWrapper<MedicineNotePharmacyRecord>;
  MedicineNotePrecaution: ResolverTypeWrapper<MedicineNotePrecaution>;
  MedicineNotePrecautionRecord: ResolverTypeWrapper<MedicineNotePrecautionRecord>;
  MedicineNotePrescription: ResolverTypeWrapper<MedicineNotePrescription>;
  MedicineNotePrescriptionMemo: ResolverTypeWrapper<MedicineNotePrescriptionMemo>;
  MedicineNotePrescriptionMemoRecord: ResolverTypeWrapper<MedicineNotePrescriptionMemoRecord>;
  MedicineNotePrescriptionRecipe: ResolverTypeWrapper<MedicineNotePrescriptionRecipe>;
  MedicineNotePrimaryPharmacist: ResolverTypeWrapper<MedicineNotePrimaryPharmacist>;
  MedicineNotePrimaryPharmacistRecord: ResolverTypeWrapper<MedicineNotePrimaryPharmacistRecord>;
  MedicineNoteRecipeInformation: ResolverTypeWrapper<MedicineNoteRecipeInformation>;
  MedicineNoteRemaining: ResolverTypeWrapper<MedicineNoteRemaining>;
  MedicineNoteRemainingRecord: ResolverTypeWrapper<MedicineNoteRemainingRecord>;
  MedicineNoteRemark: ResolverTypeWrapper<MedicineNoteRemark>;
  MedicineNoteRemarkRecord: ResolverTypeWrapper<MedicineNoteRemarkRecord>;
  MedicineNoteSplitControl: ResolverTypeWrapper<MedicineNoteSplitControl>;
  MedicineNoteSplitControlRecord: ResolverTypeWrapper<MedicineNoteSplitControlRecord>;
  MedicineNoteVersion: ResolverTypeWrapper<MedicineNoteVersion>;
  MedicineNoteVersionRecord: ResolverTypeWrapper<MedicineNoteVersionRecord>;
  MedicineNoteWarning: ResolverTypeWrapper<MedicineNoteWarning>;
  MedicineNoteWarningRecord: ResolverTypeWrapper<MedicineNoteWarningRecord>;
  MedicineNotesByOnetimeCode: ResolverTypeWrapper<MedicineNotesByOnetimeCode>;
  MedicineNotesByPatient: ResolverTypeWrapper<MedicineNotesByPatient>;
  MedicinePage: ResolverTypeWrapper<MedicinePage>;
  MedixsDispensingRecord: ResolverTypeWrapper<MedixsDispensingRecord>;
  MedixsEvent: ResolverTypeWrapper<MedixsEvent>;
  MedixsEventPage: ResolverTypeWrapper<MedixsEventPage>;
  MedixsPatient: ResolverTypeWrapper<Omit<MedixsPatient, 'events' | 'guestPatients' | 'latestAppointment' | 'latestQuestionnaireSheet' | 'medicationFollowupComments' | 'medicationFollowupDraftMessage' | 'patient' | 'tracingReportDraft'> & { events: ResolversTypes['EventPage'], guestPatients: Array<ResolversTypes['GuestPatient']>, latestAppointment?: Maybe<ResolversTypes['Appointment']>, latestQuestionnaireSheet?: Maybe<ResolversTypes['MedixsPatientQuestionnaireSheet']>, medicationFollowupComments: ResolversTypes['MedicationFollowupCommentPage'], medicationFollowupDraftMessage?: Maybe<ResolversTypes['MedicationFollowupDraftMessage']>, patient?: Maybe<ResolversTypes['Patient']>, tracingReportDraft?: Maybe<ResolversTypes['TracingReportDraft']> }>;
  MedixsPatientPage: ResolverTypeWrapper<Omit<MedixsPatientPage, 'nodes'> & { nodes: Array<ResolversTypes['MedixsPatient']> }>;
  MedixsPatientQuestionnaireSheet: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['MedixsPatientQuestionnaireSheet']>;
  MedixsReception: ResolverTypeWrapper<Omit<MedixsReception, 'medixsDispensingRecord' | 'medixsPatient'> & { medixsDispensingRecord?: Maybe<ResolversTypes['MedixsDispensingRecord']>, medixsPatient: ResolversTypes['MedixsPatient'] }>;
  MedixsReceptionPage: ResolverTypeWrapper<Omit<MedixsReceptionPage, 'nodes'> & { nodes: Array<ResolversTypes['MedixsReception']> }>;
  MedixsReceptionPrescription: ResolverTypeWrapper<MedixsReceptionPrescription>;
  MedixsSetting: ResolverTypeWrapper<Omit<MedixsSetting, 'medixsPatients' | 'medixsReceptions' | 'organization'> & { medixsPatients: ResolversTypes['MedixsPatientPage'], medixsReceptions: ResolversTypes['MedixsReceptionPage'], organization: ResolversTypes['Organization'] }>;
  MessageDeliver: ResolverTypeWrapper<Omit<MessageDeliver, 'patient' | 'practitioner'> & { patient: ResolversTypes['Patient'], practitioner: ResolversTypes['Practitioner'] }>;
  MessageDeliverResult: ResolverTypeWrapper<Omit<MessageDeliverResult, 'guestPatient' | 'organization' | 'patient' | 'practitioner'> & { guestPatient?: Maybe<ResolversTypes['GuestPatient']>, organization: ResolversTypes['Organization'], patient?: Maybe<ResolversTypes['Patient']>, practitioner: ResolversTypes['Practitioner'] }>;
  MessageDeliverResultPage: ResolverTypeWrapper<Omit<MessageDeliverResultPage, 'nodes'> & { nodes: Array<ResolversTypes['MessageDeliverResult']> }>;
  MessageDeliverResultStatus: MessageDeliverResultStatus;
  MessageDeliverSystem: MessageDeliverSystem;
  MonthlyPayoutStatement: ResolverTypeWrapper<MonthlyPayoutStatement>;
  MonthlyPayoutStatementPage: ResolverTypeWrapper<MonthlyPayoutStatementPage>;
  Mutation: ResolverTypeWrapper<{}>;
  Node: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Node']>;
  NotificationSettingData: ResolverTypeWrapper<NotificationSettingData>;
  NotificationSettingSound: ResolverTypeWrapper<NotificationSettingSound>;
  NotificationSettingTel: ResolverTypeWrapper<NotificationSettingTel>;
  NotifyCheckinEntryInput: NotifyCheckinEntryInput;
  NotifyCheckinEntryPayload: ResolverTypeWrapper<Omit<NotifyCheckinEntryPayload, 'checkinEntry'> & { checkinEntry: ResolversTypes['CheckinEntry'] }>;
  NotifyOutpatientQuestionnaireEntryInput: NotifyOutpatientQuestionnaireEntryInput;
  NotifyOutpatientQuestionnaireEntryPayload: ResolverTypeWrapper<Omit<NotifyOutpatientQuestionnaireEntryPayload, 'outpatientQuestionnaireEntry'> & { outpatientQuestionnaireEntry: ResolversTypes['OutpatientQuestionnaireEntry'] }>;
  Operator: ResolverTypeWrapper<Operator>;
  OperatorAccessPermission: ResolverTypeWrapper<OperatorAccessPermission>;
  OperatorRole: ResolverTypeWrapper<OperatorRole>;
  OrderDirection: OrderDirection;
  Organization: ResolverTypeWrapper<Omit<Organization, 'adminPractitioners' | 'allPatients' | 'appointments' | 'b2cloudSetting' | 'bankAccount' | 'bookmarkedPatients' | 'chargeHistories' | 'checkinEntries' | 'checkinSetting' | 'clientCerts' | 'company' | 'companyCommonSetting' | 'dailySalesDetail' | 'directVisitorCandidates' | 'directVisitors' | 'disclosedMedicineNotes' | 'faximoSendFaxes' | 'featureUsages' | 'feeSettings' | 'hiccupTemporaryPermissions' | 'invitationCodes' | 'medicalInstitutionSetting' | 'medicalInstitutionSettings' | 'medicationFollowupMessageTemplates' | 'medicationFollowupMessages' | 'medicationFollowupQuestionnaireSheets' | 'medicationFollowupQuestionnaires' | 'medicationFollowupSetting' | 'medixsSetting' | 'notificationSetting' | 'organizationAddresses' | 'organizationContactPoints' | 'organizationNotifications' | 'patients' | 'payoutOrganizations' | 'pharmacistPractitioners' | 'practitionerAuthentications' | 'receptions' | 'unreadOrganizationNotifications'> & { adminPractitioners: Array<ResolversTypes['Practitioner']>, allPatients: ResolversTypes['AllPatientPage'], appointments: ResolversTypes['AppointmentPage'], b2cloudSetting?: Maybe<ResolversTypes['B2cloudSetting']>, bankAccount?: Maybe<ResolversTypes['BankAccount']>, bookmarkedPatients: ResolversTypes['PatientPage'], chargeHistories: ResolversTypes['ChargeHistoryPage'], checkinEntries: ResolversTypes['CheckinEntryPage'], checkinSetting?: Maybe<ResolversTypes['CheckinSetting']>, clientCerts: ResolversTypes['ClientCertPage'], company: ResolversTypes['Company'], companyCommonSetting?: Maybe<ResolversTypes['CompanyCommonSetting']>, dailySalesDetail: ResolversTypes['OrganizationDailySalesDetail'], directVisitorCandidates: ResolversTypes['DirectVisitorCandidatePage'], directVisitors: ResolversTypes['DirectVisitorPage'], disclosedMedicineNotes: ResolversTypes['DisclosedMedicineNotePage'], faximoSendFaxes: ResolversTypes['FaximoSendFaxPage'], featureUsages: ResolversTypes['FeatureUsagePage'], feeSettings: ResolversTypes['FeeSettingPage'], hiccupTemporaryPermissions: ResolversTypes['HiccupTemporaryPermissionPage'], invitationCodes: ResolversTypes['InvitationCodePage'], medicalInstitutionSetting?: Maybe<ResolversTypes['MedicalInstitutionSetting']>, medicalInstitutionSettings: ResolversTypes['MedicalInstitutionSettingPage'], medicationFollowupMessageTemplates: ResolversTypes['MedicationFollowupMessageTemplatePage'], medicationFollowupMessages: ResolversTypes['MedicationFollowupMessagePage'], medicationFollowupQuestionnaireSheets: ResolversTypes['MedicationFollowupQuestionnaireSheetPage'], medicationFollowupQuestionnaires: ResolversTypes['MedicationFollowupQuestionnairePage'], medicationFollowupSetting?: Maybe<ResolversTypes['MedicationFollowupSetting']>, medixsSetting?: Maybe<ResolversTypes['MedixsSetting']>, notificationSetting?: Maybe<ResolversTypes['OrganizationNotificationSetting']>, organizationAddresses: Array<ResolversTypes['OrganizationAddress']>, organizationContactPoints: Array<ResolversTypes['OrganizationContactPoint']>, organizationNotifications: ResolversTypes['OrganizationNotificationPage'], patients: ResolversTypes['PatientConnection'], payoutOrganizations: ResolversTypes['PayoutOrganizationPage'], pharmacistPractitioners: Array<ResolversTypes['Practitioner']>, practitionerAuthentications: Array<ResolversTypes['PractitionerAuthentication']>, receptions: ResolversTypes['ReceptionPage'], unreadOrganizationNotifications: ResolversTypes['OrganizationNotificationPage'] }>;
  OrganizationAddress: ResolverTypeWrapper<Omit<OrganizationAddress, 'address'> & { address: ResolversTypes['Address'] }>;
  OrganizationAppointmentStatus: OrganizationAppointmentStatus;
  OrganizationCompanyFeeSetting: ResolverTypeWrapper<OrganizationCompanyFeeSetting>;
  OrganizationContactPoint: ResolverTypeWrapper<Omit<OrganizationContactPoint, 'contactPoint'> & { contactPoint: ResolversTypes['ContactPoint'] }>;
  OrganizationDailySales: ResolverTypeWrapper<Omit<OrganizationDailySales, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  OrganizationDailySalesDetail: ResolverTypeWrapper<Omit<OrganizationDailySalesDetail, 'appBillingAmountDetail' | 'appShippingFeeDetail' | 'appUberDeliveryFeeDetail' | 'cashBillingAmountDetail' | 'cashShippingFeeDetail' | 'organizationDailySales' | 'refundHistories'> & { appBillingAmountDetail: Array<ResolversTypes['SubjectTotalAmount']>, appShippingFeeDetail: Array<ResolversTypes['SubjectTotalAmount']>, appUberDeliveryFeeDetail: Array<ResolversTypes['SubjectTotalAmount']>, cashBillingAmountDetail: Array<ResolversTypes['SubjectTotalAmount']>, cashShippingFeeDetail: Array<ResolversTypes['SubjectTotalAmount']>, organizationDailySales: ResolversTypes['OrganizationDailySales'], refundHistories?: Maybe<Array<ResolversTypes['RefundHistory']>> }>;
  OrganizationDailySalesPage: ResolverTypeWrapper<Omit<OrganizationDailySalesPage, 'nodes'> & { nodes: Array<ResolversTypes['OrganizationDailySales']> }>;
  OrganizationFeeSetting: ResolverTypeWrapper<Omit<OrganizationFeeSetting, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  OrganizationImportJobInformation: ResolverTypeWrapper<Omit<OrganizationImportJobInformation, 'company' | 'practitioner'> & { company?: Maybe<ResolversTypes['Company']>, practitioner?: Maybe<ResolversTypes['Practitioner']> }>;
  OrganizationImportJobInformationConnection: ResolverTypeWrapper<Omit<OrganizationImportJobInformationConnection, 'edges' | 'nodes'> & { edges?: Maybe<Array<Maybe<ResolversTypes['OrganizationImportJobInformationEdge']>>>, nodes?: Maybe<Array<Maybe<ResolversTypes['OrganizationImportJobInformation']>>> }>;
  OrganizationImportJobInformationEdge: ResolverTypeWrapper<Omit<OrganizationImportJobInformationEdge, 'node'> & { node?: Maybe<ResolversTypes['OrganizationImportJobInformation']> }>;
  OrganizationImportJobInformationStatus: OrganizationImportJobInformationStatus;
  OrganizationImportJobInformationType: OrganizationImportJobInformationType;
  OrganizationNotification: ResolverTypeWrapper<Omit<OrganizationNotification, 'appointment' | 'checkinEntry' | 'draftAppointment' | 'faximoSendFax' | 'medicationFollowupMessage' | 'organization' | 'outpatientQuestionnaireEntry'> & { appointment?: Maybe<ResolversTypes['Appointment']>, checkinEntry?: Maybe<ResolversTypes['CheckinEntry']>, draftAppointment?: Maybe<ResolversTypes['DraftAppointment']>, faximoSendFax?: Maybe<ResolversTypes['FaximoSendFax']>, medicationFollowupMessage?: Maybe<ResolversTypes['MedicationFollowupMessage']>, organization: ResolversTypes['Organization'], outpatientQuestionnaireEntry?: Maybe<ResolversTypes['OutpatientQuestionnaireEntry']> }>;
  OrganizationNotificationPage: ResolverTypeWrapper<Omit<OrganizationNotificationPage, 'nodes'> & { nodes: Array<ResolversTypes['OrganizationNotification']> }>;
  OrganizationNotificationSetting: ResolverTypeWrapper<Omit<OrganizationNotificationSetting, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  OrganizationNotificationType: OrganizationNotificationType;
  OrganizationPage: ResolverTypeWrapper<Omit<OrganizationPage, 'nodes'> & { nodes: Array<ResolversTypes['Organization']> }>;
  OutpatientQuestionnaire: ResolverTypeWrapper<OutpatientQuestionnaire>;
  OutpatientQuestionnaireEntry: ResolverTypeWrapper<Omit<OutpatientQuestionnaireEntry, 'address' | 'directVisitor' | 'organization' | 'unreadOrganizationNotifications'> & { address: ResolversTypes['Address'], directVisitor: ResolversTypes['DirectVisitor'], organization: ResolversTypes['Organization'], unreadOrganizationNotifications: Array<ResolversTypes['OrganizationNotification']> }>;
  OutpatientQuestionnaireEntryStatus: OutpatientQuestionnaireEntryStatus;
  OutpatientQuestionnaireOrganization: ResolverTypeWrapper<OutpatientQuestionnaireOrganization>;
  OutpatientQuestionnaireQuestion: ResolverTypeWrapper<OutpatientQuestionnaireQuestion>;
  OutpatientQuestionnaireQuestionInput: OutpatientQuestionnaireQuestionInput;
  OutpatientQuestionnaireQuestionType: OutpatientQuestionnaireQuestionType;
  OutpatientQuestionnaireSetting: ResolverTypeWrapper<OutpatientQuestionnaireSetting>;
  OutpatientQuestionnaireSettingQuestionnaire: ResolverTypeWrapper<OutpatientQuestionnaireSettingQuestionnaire>;
  OutpatientQuestionnaireSheetAnswer: ResolverTypeWrapper<OutpatientQuestionnaireSheetAnswer>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  Patient: ResolverTypeWrapper<Omit<Patient, 'appointments' | 'bookmark' | 'draftAppointments' | 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'questionnaireSheet' | 'questionnaires' | 'tracingReportDrafts' | 'tracingReports'> & { appointments: ResolversTypes['AppointmentPage'], bookmark?: Maybe<ResolversTypes['Bookmark']>, draftAppointments: ResolversTypes['DraftAppointmentPage'], medicationFollowupDraftMessages: ResolversTypes['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: ResolversTypes['MedicationFollowupMessagePage'], medixsPatient?: Maybe<ResolversTypes['MedixsPatient']>, messageDeliverResults: ResolversTypes['MessageDeliverResultPage'], questionnaireSheet?: Maybe<ResolversTypes['QuestionnaireSheet']>, questionnaires?: Maybe<Array<ResolversTypes['QuestionnaireSheetAnswer']>>, tracingReportDrafts: ResolversTypes['TracingReportDraftPage'], tracingReports: ResolversTypes['TracingReportPage'] }>;
  PatientAttachment: ResolverTypeWrapper<PatientAttachment>;
  PatientAttachmentPage: ResolverTypeWrapper<PatientAttachmentPage>;
  PatientConnection: ResolverTypeWrapper<Omit<PatientConnection, 'edges' | 'nodes'> & { edges?: Maybe<Array<Maybe<ResolversTypes['PatientEdge']>>>, nodes?: Maybe<Array<Maybe<ResolversTypes['Patient']>>> }>;
  PatientEdge: ResolverTypeWrapper<Omit<PatientEdge, 'node'> & { node?: Maybe<ResolversTypes['Patient']> }>;
  PatientMedicationFollowupComment: ResolverTypeWrapper<Omit<PatientMedicationFollowupComment, 'practitioner'> & { practitioner: ResolversTypes['Practitioner'] }>;
  PatientMedicationFollowupCommentPage: ResolverTypeWrapper<PatientMedicationFollowupCommentPage>;
  PatientMedicationFollowupStatus: PatientMedicationFollowupStatus;
  PatientPage: ResolverTypeWrapper<Omit<PatientPage, 'nodes'> & { nodes: Array<ResolversTypes['Patient']> }>;
  PaymentMethod: PaymentMethod;
  Payout: ResolverTypeWrapper<Omit<Payout, 'company' | 'payoutOrganizations'> & { company?: Maybe<ResolversTypes['Company']>, payoutOrganizations: ResolversTypes['PayoutOrganizationPage'] }>;
  PayoutBankAccount: ResolverTypeWrapper<Omit<PayoutBankAccount, 'payoutOrganization'> & { payoutOrganization?: Maybe<ResolversTypes['PayoutOrganization']> }>;
  PayoutBankAccountAccount: PayoutBankAccountAccount;
  PayoutOrganization: ResolverTypeWrapper<Omit<PayoutOrganization, 'organization' | 'payout' | 'payoutBankAccount' | 'payoutSubjects'> & { organization?: Maybe<ResolversTypes['Organization']>, payout?: Maybe<ResolversTypes['Payout']>, payoutBankAccount?: Maybe<ResolversTypes['PayoutBankAccount']>, payoutSubjects: Array<ResolversTypes['PayoutSubject']> }>;
  PayoutOrganizationPage: ResolverTypeWrapper<Omit<PayoutOrganizationPage, 'nodes'> & { nodes: Array<ResolversTypes['PayoutOrganization']> }>;
  PayoutPage: ResolverTypeWrapper<Omit<PayoutPage, 'nodes'> & { nodes: Array<ResolversTypes['Payout']> }>;
  PayoutSubject: ResolverTypeWrapper<Omit<PayoutSubject, 'payoutOrganization'> & { payoutOrganization?: Maybe<ResolversTypes['PayoutOrganization']> }>;
  PayoutSubjectCode: PayoutSubjectCode;
  PfAddress: ResolverTypeWrapper<PfAddress>;
  PfAddressType: PfAddressType;
  PfAddressUse: PfAddressUse;
  PfAttachment: ResolverTypeWrapper<PfAttachment>;
  PfContactPoint: ResolverTypeWrapper<PfContactPoint>;
  PfContactPointSystem: PfContactPointSystem;
  PfContactPointUse: PfContactPointUse;
  PfDispensingRequest: ResolverTypeWrapper<PfDispensingRequest>;
  PfDispensingRequestMedicalInstitution: ResolverTypeWrapper<PfDispensingRequestMedicalInstitution>;
  PfDispensingRequestMedicalInstitutionConsultation: ResolverTypeWrapper<PfDispensingRequestMedicalInstitutionConsultation>;
  PfDispensingRequestMedicalInstitutionMedicalInstitution: ResolverTypeWrapper<PfDispensingRequestMedicalInstitutionMedicalInstitution>;
  PfDispensingRequestMedicalInstitutionPhysician: ResolverTypeWrapper<PfDispensingRequestMedicalInstitutionPhysician>;
  PfDispensingRequestMedicalInstitutionPrescription: ResolverTypeWrapper<PfDispensingRequestMedicalInstitutionPrescription>;
  PfDispensingRequestPharmacy: ResolverTypeWrapper<PfDispensingRequestPharmacy>;
  PfDispensingRequestPharmacyDispensing: ResolverTypeWrapper<PfDispensingRequestPharmacyDispensing>;
  PfDispensingRequestPharmacyPharmacist: ResolverTypeWrapper<PfDispensingRequestPharmacyPharmacist>;
  PfDispensingRequestPharmacyPharmacy: ResolverTypeWrapper<PfDispensingRequestPharmacyPharmacy>;
  PfDispensingRequestSendMethod: PfDispensingRequestSendMethod;
  PfDispensingRequestStatus: PfDispensingRequestStatus;
  PfInsuranceCard: ResolverTypeWrapper<PfInsuranceCard>;
  PfInsuranceCards: ResolverTypeWrapper<PfInsuranceCards>;
  PfPatient: ResolverTypeWrapper<PfPatient>;
  PfPrescriptionImage: ResolverTypeWrapper<PfPrescriptionImage>;
  PfServiceAccount: PfServiceAccount;
  PfSex: PfSex;
  Plan: ResolverTypeWrapper<Omit<Plan, 'extensions'> & { extensions: Array<ResolversTypes['Extension']> }>;
  PlanFeature: ResolverTypeWrapper<PlanFeature>;
  PlanFeatureBillingMethod: PlanFeatureBillingMethod;
  PlanFeatureCode: PlanFeatureCode;
  PostalCode: ResolverTypeWrapper<PostalCode>;
  PostalCodePage: ResolverTypeWrapper<PostalCodePage>;
  Practitioner: ResolverTypeWrapper<Omit<Practitioner, 'authentication' | 'organization' | 'signinHistory'> & { authentication: ResolversTypes['PractitionerAuthentication'], organization: ResolversTypes['Organization'], signinHistory?: Maybe<ResolversTypes['PractitionerSigninHistory']> }>;
  PractitionerAuthentication: ResolverTypeWrapper<PractitionerAuthentication>;
  PractitionerCodeMailType: PractitionerCodeMailType;
  PractitionerOtpSecret: ResolverTypeWrapper<PractitionerOtpSecret>;
  PractitionerPage: ResolverTypeWrapper<Omit<PractitionerPage, 'nodes'> & { nodes: Array<ResolversTypes['Practitioner']> }>;
  PractitionerRole: PractitionerRole;
  PractitionerSigninHistory: ResolverTypeWrapper<Omit<PractitionerSigninHistory, 'practitioner'> & { practitioner: ResolversTypes['Practitioner'] }>;
  PrintPrescriptionSetting: ResolverTypeWrapper<PrintPrescriptionSetting>;
  PrivilegeOrganization: ResolverTypeWrapper<PrivilegeOrganization>;
  PrivilegeOrganizationPractitioner: ResolverTypeWrapper<PrivilegeOrganizationPractitioner>;
  PublicAddress: ResolverTypeWrapper<PublicAddress>;
  PublicAppointment: ResolverTypeWrapper<PublicAppointment>;
  PublicCheckinEntry: ResolverTypeWrapper<Omit<PublicCheckinEntry, 'checkinOrganization'> & { checkinOrganization: ResolversTypes['CheckinOrganization'] }>;
  PublicMedicationFollowupMessage: ResolverTypeWrapper<PublicMedicationFollowupMessage>;
  PublicMedicationFollowupQuestionnaireRevision: ResolverTypeWrapper<PublicMedicationFollowupQuestionnaireRevision>;
  PublicMedicationFollowupQuestionnaireSheet: ResolverTypeWrapper<PublicMedicationFollowupQuestionnaireSheet>;
  PublicOrganization: ResolverTypeWrapper<PublicOrganization>;
  PublicOrganizationAddress: ResolverTypeWrapper<PublicOrganizationAddress>;
  PublicOrganizationPage: ResolverTypeWrapper<PublicOrganizationPage>;
  PublicOutpatientQuestionnaireEntry: ResolverTypeWrapper<PublicOutpatientQuestionnaireEntry>;
  PublicSignupPfPatientInformation: ResolverTypeWrapper<PublicSignupPfPatientInformation>;
  PublicSignupPfPatientInformationOrganization: ResolverTypeWrapper<PublicSignupPfPatientInformationOrganization>;
  PublicSlot: ResolverTypeWrapper<PublicSlot>;
  PublicWebBookingsSetting: ResolverTypeWrapper<PublicWebBookingsSetting>;
  QualifiedInvoice: ResolverTypeWrapper<QualifiedInvoice>;
  Query: ResolverTypeWrapper<{}>;
  QuestionnaireSheet: ResolverTypeWrapper<Omit<QuestionnaireSheet, 'answers'> & { answers: Array<ResolversTypes['QuestionnaireSheetAnswer']> }>;
  QuestionnaireSheetAnswer: ResolverTypeWrapper<QuestionnaireSheetAnswer>;
  QuestionnaireSheetAnswerInput: QuestionnaireSheetAnswerInput;
  Quote: ResolverTypeWrapper<Quote>;
  Reception: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Reception']>;
  ReceptionPage: ResolverTypeWrapper<Omit<ReceptionPage, 'nodes'> & { nodes: Array<ResolversTypes['Reception']> }>;
  ReceptionUsage: ResolverTypeWrapper<Omit<ReceptionUsage, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  ReceptionUsagePage: ResolverTypeWrapper<Omit<ReceptionUsagePage, 'nodes'> & { nodes: Array<ResolversTypes['ReceptionUsage']> }>;
  RechargeWithAppInput: RechargeWithAppInput;
  RechargeWithAppPayload: ResolverTypeWrapper<Omit<RechargeWithAppPayload, 'charge'> & { charge: ResolversTypes['Charge'] }>;
  RechargeWithCashInput: RechargeWithCashInput;
  RechargeWithCashPayload: ResolverTypeWrapper<Omit<RechargeWithCashPayload, 'charge'> & { charge: ResolversTypes['Charge'] }>;
  RecreateTracingReportInput: RecreateTracingReportInput;
  RecreateTracingReportPayload: ResolverTypeWrapper<Omit<RecreateTracingReportPayload, 'tracingReport'> & { tracingReport: ResolversTypes['TracingReport'] }>;
  RefundHistory: ResolverTypeWrapper<Omit<RefundHistory, 'afterChargeHistory' | 'beforeChargeHistory' | 'patient' | 'refundedChargeHistory'> & { afterChargeHistory: ResolversTypes['ChargeHistory'], beforeChargeHistory: ResolversTypes['ChargeHistory'], patient: ResolversTypes['Patient'], refundedChargeHistory: ResolversTypes['ChargeHistory'] }>;
  RemandUberSignatureInput: RemandUberSignatureInput;
  RemandUberSignaturePayload: ResolverTypeWrapper<Omit<RemandUberSignaturePayload, 'uberSignature'> & { uberSignature: ResolversTypes['UberSignature'] }>;
  RemoveCompanyAddressInput: RemoveCompanyAddressInput;
  RemoveCompanyAddressPayload: ResolverTypeWrapper<Omit<RemoveCompanyAddressPayload, 'companyAddress'> & { companyAddress: ResolversTypes['CompanyAddress'] }>;
  RemoveCompanyContactPointInput: RemoveCompanyContactPointInput;
  RemoveCompanyContactPointPayload: ResolverTypeWrapper<Omit<RemoveCompanyContactPointPayload, 'companyContactPoint'> & { companyContactPoint: ResolversTypes['CompanyContactPoint'] }>;
  RemoveCompanySetupDocumentInput: RemoveCompanySetupDocumentInput;
  RemoveCompanySetupDocumentPayload: ResolverTypeWrapper<RemoveCompanySetupDocumentPayload>;
  RemoveMedicalInstitutionSettingInput: RemoveMedicalInstitutionSettingInput;
  RemoveMedicalInstitutionSettingPayload: ResolverTypeWrapper<Omit<RemoveMedicalInstitutionSettingPayload, 'medicalInstitutionSetting'> & { medicalInstitutionSetting: ResolversTypes['MedicalInstitutionSetting'] }>;
  RemoveOrganizationContactPointInput: RemoveOrganizationContactPointInput;
  RemoveOrganizationContactPointPayload: ResolverTypeWrapper<Omit<RemoveOrganizationContactPointPayload, 'organizationContactPoint'> & { organizationContactPoint: ResolversTypes['OrganizationContactPoint'] }>;
  RemoveWebBookingsExceptionBusinessHourInput: RemoveWebBookingsExceptionBusinessHourInput;
  RemoveWebBookingsExceptionBusinessHourPayload: ResolverTypeWrapper<RemoveWebBookingsExceptionBusinessHourPayload>;
  RequestAppointmentInput: RequestAppointmentInput;
  RequestAppointmentPayload: ResolverTypeWrapper<Omit<RequestAppointmentPayload, 'draftAppointment'> & { draftAppointment: ResolversTypes['DraftAppointment'] }>;
  ResendAuthenticationCodeInput: ResendAuthenticationCodeInput;
  ResendAuthenticationCodePayload: ResolverTypeWrapper<ResendAuthenticationCodePayload>;
  RestartAgentInput: RestartAgentInput;
  RestartAgentPayload: ResolverTypeWrapper<RestartAgentPayload>;
  ResumeWebBookingsInput: ResumeWebBookingsInput;
  ResumeWebBookingsPayload: ResolverTypeWrapper<ResumeWebBookingsPayload>;
  RevokeClientCertInput: RevokeClientCertInput;
  RevokeClientCertPayload: ResolverTypeWrapper<Omit<RevokeClientCertPayload, 'clientCert'> & { clientCert: ResolversTypes['ClientCert'] }>;
  SendAuthenticationCodeAndRegisterPatientEmailInput: SendAuthenticationCodeAndRegisterPatientEmailInput;
  SendAuthenticationCodeAndRegisterPatientEmailPayload: ResolverTypeWrapper<SendAuthenticationCodeAndRegisterPatientEmailPayload>;
  SendCallNotificationInput: SendCallNotificationInput;
  SendCallNotificationPayload: ResolverTypeWrapper<Omit<SendCallNotificationPayload, 'encounter'> & { encounter: ResolversTypes['Encounter'] }>;
  SendClientCertMailInput: SendClientCertMailInput;
  SendClientCertMailPayload: ResolverTypeWrapper<Omit<SendClientCertMailPayload, 'clientCert'> & { clientCert: ResolversTypes['ClientCert'] }>;
  SendCongestionNotificationForWebVisitorInput: SendCongestionNotificationForWebVisitorInput;
  SendCongestionNotificationForWebVisitorPayload: ResolverTypeWrapper<Omit<SendCongestionNotificationForWebVisitorPayload, 'messageDeliver'> & { messageDeliver: ResolversTypes['MessageDeliver'] }>;
  SendCongestionNotificationInput: SendCongestionNotificationInput;
  SendCongestionNotificationPayload: ResolverTypeWrapper<Omit<SendCongestionNotificationPayload, 'appointment'> & { appointment: ResolversTypes['Appointment'] }>;
  SendDispensingPreparedNotificationInput: SendDispensingPreparedNotificationInput;
  SendDispensingPreparedNotificationPayload: ResolverTypeWrapper<Omit<SendDispensingPreparedNotificationPayload, 'appointment'> & { appointment: ResolversTypes['Appointment'] }>;
  SendInvitationSmsInput: SendInvitationSmsInput;
  SendInvitationSmsPayload: ResolverTypeWrapper<SendInvitationSmsPayload>;
  SendPractitionerCodeMailInput: SendPractitionerCodeMailInput;
  SendPractitionerCodeMailPayload: ResolverTypeWrapper<Omit<SendPractitionerCodeMailPayload, 'practitioner'> & { practitioner: ResolversTypes['Practitioner'] }>;
  SendTracingReportInput: SendTracingReportInput;
  SendTracingReportPayload: ResolverTypeWrapper<Omit<SendTracingReportPayload, 'faximoSendFax'> & { faximoSendFax: ResolversTypes['FaximoSendFax'] }>;
  SendgridEventActivity: ResolverTypeWrapper<SendgridEventActivity>;
  SendgridEventActivityStatus: SendgridEventActivityStatus;
  SetPractitionerRoleInput: SetPractitionerRoleInput;
  SetPractitionerRolePayload: ResolverTypeWrapper<Omit<SetPractitionerRolePayload, 'practitioner'> & { practitioner: ResolversTypes['Practitioner'] }>;
  Sex: Sex;
  SigninHistory: ResolverTypeWrapper<SigninHistory>;
  SignupCompanyInput: SignupCompanyInput;
  SignupCompanyPayload: ResolverTypeWrapper<Omit<SignupCompanyPayload, 'company' | 'organization' | 'practitioner'> & { company: ResolversTypes['Company'], organization: ResolversTypes['Organization'], practitioner: ResolversTypes['Practitioner'] }>;
  SignupPfPatientFromCheckinEntryInput: SignupPfPatientFromCheckinEntryInput;
  SignupPfPatientFromCheckinEntryPayload: ResolverTypeWrapper<SignupPfPatientFromCheckinEntryPayload>;
  SignupPfPatientFromOutpatientQuestionnaireEntryAddressInput: SignupPfPatientFromOutpatientQuestionnaireEntryAddressInput;
  SignupPfPatientFromOutpatientQuestionnaireEntryInput: SignupPfPatientFromOutpatientQuestionnaireEntryInput;
  SignupPfPatientFromOutpatientQuestionnaireEntryPayload: ResolverTypeWrapper<SignupPfPatientFromOutpatientQuestionnaireEntryPayload>;
  SkipEncounterInput: SkipEncounterInput;
  SkipEncounterPayload: ResolverTypeWrapper<Omit<SkipEncounterPayload, 'appointment'> & { appointment: ResolversTypes['Appointment'] }>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SubjectTotalAmount: ResolverTypeWrapper<SubjectTotalAmount>;
  SubscribeChannelInput: SubscribeChannelInput;
  SubscribeChannelPayload: ResolverTypeWrapper<SubscribeChannelPayload>;
  SuspendWebBookingsInput: SuspendWebBookingsInput;
  SuspendWebBookingsPayload: ResolverTypeWrapper<SuspendWebBookingsPayload>;
  TracingReport: ResolverTypeWrapper<Omit<TracingReport, 'data' | 'latestSentFax' | 'latestSentFaxByEvent' | 'organization'> & { data: ResolversTypes['TracingReportData'], latestSentFax?: Maybe<ResolversTypes['FaximoSendFax']>, latestSentFaxByEvent?: Maybe<ResolversTypes['FaximoSendFax']>, organization: ResolversTypes['Organization'] }>;
  TracingReportData: ResolverTypeWrapper<Omit<TracingReportData, 'medicalInstitutionSetting'> & { medicalInstitutionSetting?: Maybe<ResolversTypes['MedicalInstitutionSetting']> }>;
  TracingReportDraft: ResolverTypeWrapper<Omit<TracingReportDraft, 'guestPatient' | 'patient'> & { guestPatient?: Maybe<ResolversTypes['GuestPatient']>, patient?: Maybe<ResolversTypes['Patient']> }>;
  TracingReportDraftData: ResolverTypeWrapper<TracingReportDraftData>;
  TracingReportDraftDataInput: TracingReportDraftDataInput;
  TracingReportDraftPage: ResolverTypeWrapper<Omit<TracingReportDraftPage, 'nodes'> & { nodes: Array<ResolversTypes['TracingReportDraft']> }>;
  TracingReportDraftPrescriptionDrug: ResolverTypeWrapper<TracingReportDraftPrescriptionDrug>;
  TracingReportDraftPrescriptionDrugInput: TracingReportDraftPrescriptionDrugInput;
  TracingReportPage: ResolverTypeWrapper<Omit<TracingReportPage, 'nodes'> & { nodes: Array<ResolversTypes['TracingReport']> }>;
  TracingReportUsage: ResolverTypeWrapper<Omit<TracingReportUsage, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  TracingReportUsagePage: ResolverTypeWrapper<Omit<TracingReportUsagePage, 'nodes'> & { nodes: Array<ResolversTypes['TracingReportUsage']> }>;
  UberAreaStatus: UberAreaStatus;
  UberCourier: ResolverTypeWrapper<UberCourier>;
  UberDelivery: ResolverTypeWrapper<Omit<UberDelivery, 'appointment' | 'practitioner'> & { appointment: ResolversTypes['Appointment'], practitioner: ResolversTypes['Practitioner'] }>;
  UberDeliveryInvoiceFee: ResolverTypeWrapper<UberDeliveryInvoiceFee>;
  UberDeliveryInvoiceFeePage: ResolverTypeWrapper<UberDeliveryInvoiceFeePage>;
  UberDeliveryStatus: UberDeliveryStatus;
  UberInvoice: ResolverTypeWrapper<UberInvoice>;
  UberOrganization: ResolverTypeWrapper<UberOrganization>;
  UberOrganizationImportJobInformation: ResolverTypeWrapper<UberOrganizationImportJobInformation>;
  UberOrganizationImportJobInformationStatus: UberOrganizationImportJobInformationStatus;
  UberOrganizationSetting: ResolverTypeWrapper<UberOrganizationSetting>;
  UberOrganizationSettingJobInformation: ResolverTypeWrapper<UberOrganizationSettingJobInformation>;
  UberOrganizationSettingJobInformationStatus: UberOrganizationSettingJobInformationStatus;
  UberQuote: ResolverTypeWrapper<UberQuote>;
  UberQuoteErrorCode: UberQuoteErrorCode;
  UberSignature: ResolverTypeWrapper<Omit<UberSignature, 'company'> & { company: ResolversTypes['Company'] }>;
  UberSignatureData: ResolverTypeWrapper<UberSignatureData>;
  UberSignatureDataInput: UberSignatureDataInput;
  UberSignatureDraft: ResolverTypeWrapper<Omit<UberSignatureDraft, 'company'> & { company: ResolversTypes['Company'] }>;
  UberSignatureDraftData: ResolverTypeWrapper<UberSignatureDraftData>;
  UberSignatureDraftDataInput: UberSignatureDraftDataInput;
  UberSignatureStatus: UberSignatureStatus;
  UberUndeliverableReasonStatus: UberUndeliverableReasonStatus;
  UnidentifyMedixsPatientInput: UnidentifyMedixsPatientInput;
  UnidentifyMedixsPatientPayload: ResolverTypeWrapper<Omit<UnidentifyMedixsPatientPayload, 'medixsPatient'> & { medixsPatient: ResolversTypes['MedixsPatient'] }>;
  UnidentifyMedixsReceptionInput: UnidentifyMedixsReceptionInput;
  UnidentifyMedixsReceptionPayload: ResolverTypeWrapper<Omit<UnidentifyMedixsReceptionPayload, 'medixsReception'> & { medixsReception: ResolversTypes['MedixsReception'] }>;
  UnpublishOrganizationInput: UnpublishOrganizationInput;
  UnpublishOrganizationPayload: ResolverTypeWrapper<Omit<UnpublishOrganizationPayload, 'organization'> & { organization: ResolversTypes['Organization'] }>;
  UnsubscribeChannelInput: UnsubscribeChannelInput;
  UnsubscribeChannelPayload: ResolverTypeWrapper<UnsubscribeChannelPayload>;
  UpdateAdminPractitionerInput: UpdateAdminPractitionerInput;
  UpdateAgentDescriptionInput: UpdateAgentDescriptionInput;
  UpdateAgentDescriptionPayload: ResolverTypeWrapper<UpdateAgentDescriptionPayload>;
  UpdateAnnouncementInput: UpdateAnnouncementInput;
  UpdateAnnouncementPayload: ResolverTypeWrapper<UpdateAnnouncementPayload>;
  UpdateAppointmentDeliveryMethodInput: UpdateAppointmentDeliveryMethodInput;
  UpdateAppointmentDeliveryMethodPayload: ResolverTypeWrapper<Omit<UpdateAppointmentDeliveryMethodPayload, 'appointment'> & { appointment: ResolversTypes['Appointment'] }>;
  UpdateAppointmentDescriptionInput: UpdateAppointmentDescriptionInput;
  UpdateAppointmentDescriptionPayload: ResolverTypeWrapper<Omit<UpdateAppointmentDescriptionPayload, 'appointment'> & { appointment: ResolversTypes['Appointment'] }>;
  UpdateB2cloudSettingDataInput: UpdateB2cloudSettingDataInput;
  UpdateB2cloudSettingInput: UpdateB2cloudSettingInput;
  UpdateB2cloudSettingPayload: ResolverTypeWrapper<Omit<UpdateB2cloudSettingPayload, 'b2cloudSetting'> & { b2cloudSetting: ResolversTypes['B2cloudSetting'] }>;
  UpdateB2cloudSettingSenderDataInput: UpdateB2cloudSettingSenderDataInput;
  UpdateBankAccountInput: UpdateBankAccountInput;
  UpdateBankAccountPayload: ResolverTypeWrapper<Omit<UpdateBankAccountPayload, 'bankAccount'> & { bankAccount: ResolversTypes['BankAccount'] }>;
  UpdateCheckinDescriptionInput: UpdateCheckinDescriptionInput;
  UpdateCheckinDescriptionPayload: ResolverTypeWrapper<Omit<UpdateCheckinDescriptionPayload, 'checkinEntry'> & { checkinEntry: ResolversTypes['CheckinEntry'] }>;
  UpdateCheckinSettingInput: UpdateCheckinSettingInput;
  UpdateCheckinSettingPayload: ResolverTypeWrapper<Omit<UpdateCheckinSettingPayload, 'checkinSetting'> & { checkinSetting: ResolversTypes['CheckinSetting'] }>;
  UpdateCompanyAddressAddressInput: UpdateCompanyAddressAddressInput;
  UpdateCompanyAddressInput: UpdateCompanyAddressInput;
  UpdateCompanyAddressPayload: ResolverTypeWrapper<Omit<UpdateCompanyAddressPayload, 'companyAddress'> & { companyAddress: ResolversTypes['CompanyAddress'] }>;
  UpdateCompanyAgentSettingInput: UpdateCompanyAgentSettingInput;
  UpdateCompanyAgentSettingPayload: ResolverTypeWrapper<UpdateCompanyAgentSettingPayload>;
  UpdateCompanyContactPointContactPointInput: UpdateCompanyContactPointContactPointInput;
  UpdateCompanyContactPointInput: UpdateCompanyContactPointInput;
  UpdateCompanyContactPointPayload: ResolverTypeWrapper<Omit<UpdateCompanyContactPointPayload, 'companyContactPoint'> & { companyContactPoint: ResolversTypes['CompanyContactPoint'] }>;
  UpdateCompanyFeeSettingInput: UpdateCompanyFeeSettingInput;
  UpdateCompanyFeeSettingPayload: ResolverTypeWrapper<Omit<UpdateCompanyFeeSettingPayload, 'companyFeeSetting'> & { companyFeeSetting: ResolversTypes['CompanyFeeSetting'] }>;
  UpdateCompanyInput: UpdateCompanyInput;
  UpdateCompanyPayload: ResolverTypeWrapper<Omit<UpdateCompanyPayload, 'company'> & { company: ResolversTypes['Company'] }>;
  UpdateCompanyPractitionerInput: UpdateCompanyPractitionerInput;
  UpdateCompanyPractitionerPayload: ResolverTypeWrapper<Omit<UpdateCompanyPractitionerPayload, 'companyPractitioner' | 'companyPractitionerConfirmation'> & { companyPractitioner: ResolversTypes['CompanyPractitioner'], companyPractitionerConfirmation?: Maybe<ResolversTypes['CompanyPractitionerConfirmation']> }>;
  UpdateCompanySessionSettingInput: UpdateCompanySessionSettingInput;
  UpdateCompanySessionSettingPayload: ResolverTypeWrapper<UpdateCompanySessionSettingPayload>;
  UpdateContractInput: UpdateContractInput;
  UpdateContractPayload: ResolverTypeWrapper<Omit<UpdateContractPayload, 'contract'> & { contract: ResolversTypes['Contract'] }>;
  UpdateContractPlanInput: UpdateContractPlanInput;
  UpdateContractPlanPayload: ResolverTypeWrapper<Omit<UpdateContractPlanPayload, 'contractPlan'> & { contractPlan: ResolversTypes['ContractPlan'] }>;
  UpdateDraftAppointmentDescriptionInput: UpdateDraftAppointmentDescriptionInput;
  UpdateDraftAppointmentDescriptionPayload: ResolverTypeWrapper<Omit<UpdateDraftAppointmentDescriptionPayload, 'draftAppointment'> & { draftAppointment: ResolversTypes['DraftAppointment'] }>;
  UpdateFeatureInput: UpdateFeatureInput;
  UpdateFeaturePayload: ResolverTypeWrapper<UpdateFeaturePayload>;
  UpdateFeatureTargetGroupInput: UpdateFeatureTargetGroupInput;
  UpdateFeatureTargetGroupPayload: ResolverTypeWrapper<UpdateFeatureTargetGroupPayload>;
  UpdateGendaApiKeyInput: UpdateGendaApiKeyInput;
  UpdateGendaApiKeyPayload: ResolverTypeWrapper<UpdateGendaApiKeyPayload>;
  UpdateGendaSettingInput: UpdateGendaSettingInput;
  UpdateGendaSettingPayload: ResolverTypeWrapper<Omit<UpdateGendaSettingPayload, 'gendaSetting'> & { gendaSetting: ResolversTypes['GendaSetting'] }>;
  UpdateGuestPatientFollowupCommentInput: UpdateGuestPatientFollowupCommentInput;
  UpdateGuestPatientFollowupCommentPayload: ResolverTypeWrapper<UpdateGuestPatientFollowupCommentPayload>;
  UpdateMedicalInstitutionSettingInput: UpdateMedicalInstitutionSettingInput;
  UpdateMedicalInstitutionSettingPayload: ResolverTypeWrapper<Omit<UpdateMedicalInstitutionSettingPayload, 'medicalInstitutionSetting'> & { medicalInstitutionSetting: ResolversTypes['MedicalInstitutionSetting'] }>;
  UpdateMedicationFollowupMessage2Input: UpdateMedicationFollowupMessage2Input;
  UpdateMedicationFollowupMessage2Payload: ResolverTypeWrapper<Omit<UpdateMedicationFollowupMessage2Payload, 'medicationFollowupMessage'> & { medicationFollowupMessage: ResolversTypes['MedicationFollowupMessage'] }>;
  UpdateMedicationFollowupMessageTemplateInput: UpdateMedicationFollowupMessageTemplateInput;
  UpdateMedicationFollowupMessageTemplatePayload: ResolverTypeWrapper<Omit<UpdateMedicationFollowupMessageTemplatePayload, 'medicationFollowupMessageTemplate'> & { medicationFollowupMessageTemplate: ResolversTypes['MedicationFollowupMessageTemplate'] }>;
  UpdateMedicationFollowupQuestionnaireInput: UpdateMedicationFollowupQuestionnaireInput;
  UpdateMedicationFollowupQuestionnairePayload: ResolverTypeWrapper<Omit<UpdateMedicationFollowupQuestionnairePayload, 'medicationFollowupQuestionnaire'> & { medicationFollowupQuestionnaire: ResolversTypes['MedicationFollowupQuestionnaire'] }>;
  UpdateMedicationFollowupQuestionnairePositionInput: UpdateMedicationFollowupQuestionnairePositionInput;
  UpdateMedicationFollowupQuestionnairePositionPayload: ResolverTypeWrapper<Omit<UpdateMedicationFollowupQuestionnairePositionPayload, 'medicationFollowupQuestionnaire'> & { medicationFollowupQuestionnaire: ResolversTypes['MedicationFollowupQuestionnaire'] }>;
  UpdateMedixsSettingInput: UpdateMedixsSettingInput;
  UpdateMedixsSettingPayload: ResolverTypeWrapper<Omit<UpdateMedixsSettingPayload, 'medixsSetting'> & { medixsSetting: ResolversTypes['MedixsSetting'] }>;
  UpdateNotificationSettingDataInput: UpdateNotificationSettingDataInput;
  UpdateNotificationSettingInput: UpdateNotificationSettingInput;
  UpdateNotificationSettingPayload: ResolverTypeWrapper<Omit<UpdateNotificationSettingPayload, 'organizationNotificationSetting'> & { organizationNotificationSetting: ResolversTypes['OrganizationNotificationSetting'] }>;
  UpdateNotificationSettingSoundInput: UpdateNotificationSettingSoundInput;
  UpdateNotificationSettingTelInput: UpdateNotificationSettingTelInput;
  UpdateOperatorRoleInput: UpdateOperatorRoleInput;
  UpdateOperatorRolePayload: ResolverTypeWrapper<UpdateOperatorRolePayload>;
  UpdateOrganizationAddressAddressInput: UpdateOrganizationAddressAddressInput;
  UpdateOrganizationAddressInput: UpdateOrganizationAddressInput;
  UpdateOrganizationAddressPayload: ResolverTypeWrapper<Omit<UpdateOrganizationAddressPayload, 'organizationAddress'> & { organizationAddress: ResolversTypes['OrganizationAddress'] }>;
  UpdateOrganizationCompanyFeeSettingInput: UpdateOrganizationCompanyFeeSettingInput;
  UpdateOrganizationCompanyFeeSettingPayload: ResolverTypeWrapper<UpdateOrganizationCompanyFeeSettingPayload>;
  UpdateOrganizationContactPointContactPointInput: UpdateOrganizationContactPointContactPointInput;
  UpdateOrganizationContactPointInput: UpdateOrganizationContactPointInput;
  UpdateOrganizationContactPointPayload: ResolverTypeWrapper<Omit<UpdateOrganizationContactPointPayload, 'organizationContactPoint'> & { organizationContactPoint: ResolversTypes['OrganizationContactPoint'] }>;
  UpdateOrganizationFeeSettingInput: UpdateOrganizationFeeSettingInput;
  UpdateOrganizationFeeSettingPayload: ResolverTypeWrapper<Omit<UpdateOrganizationFeeSettingPayload, 'organizationFeeSetting'> & { organizationFeeSetting: ResolversTypes['OrganizationFeeSetting'] }>;
  UpdateOrganizationInput: UpdateOrganizationInput;
  UpdateOrganizationPayload: ResolverTypeWrapper<Omit<UpdateOrganizationPayload, 'adminPractitioner' | 'organization'> & { adminPractitioner?: Maybe<ResolversTypes['Practitioner']>, organization: ResolversTypes['Organization'] }>;
  UpdateOutpatientQuestionnaireDescriptionInput: UpdateOutpatientQuestionnaireDescriptionInput;
  UpdateOutpatientQuestionnaireDescriptionPayload: ResolverTypeWrapper<Omit<UpdateOutpatientQuestionnaireDescriptionPayload, 'outpatientQuestionnaireEntry'> & { outpatientQuestionnaireEntry: ResolversTypes['OutpatientQuestionnaireEntry'] }>;
  UpdateOutpatientQuestionnaireSettingInput: UpdateOutpatientQuestionnaireSettingInput;
  UpdateOutpatientQuestionnaireSettingPayload: ResolverTypeWrapper<UpdateOutpatientQuestionnaireSettingPayload>;
  UpdateOutpatientQuestionnaireSettingQuestionnaireInput: UpdateOutpatientQuestionnaireSettingQuestionnaireInput;
  UpdateOutpatientQuestionnaireSettingQuestionnairePayload: ResolverTypeWrapper<UpdateOutpatientQuestionnaireSettingQuestionnairePayload>;
  UpdatePatientFollowupCommentInput: UpdatePatientFollowupCommentInput;
  UpdatePatientFollowupCommentPayload: ResolverTypeWrapper<UpdatePatientFollowupCommentPayload>;
  UpdatePlanInput: UpdatePlanInput;
  UpdatePlanPayload: ResolverTypeWrapper<Omit<UpdatePlanPayload, 'plan'> & { plan: ResolversTypes['Plan'] }>;
  UpdatePractitionerAuthenticationInput: UpdatePractitionerAuthenticationInput;
  UpdatePractitionerAuthenticationPayload: ResolverTypeWrapper<Omit<UpdatePractitionerAuthenticationPayload, 'authentication'> & { authentication: ResolversTypes['PractitionerAuthentication'] }>;
  UpdatePractitionerCodeForCompanyPractitionerInput: UpdatePractitionerCodeForCompanyPractitionerInput;
  UpdatePractitionerCodeForCompanyPractitionerPayload: ResolverTypeWrapper<Omit<UpdatePractitionerCodeForCompanyPractitionerPayload, 'companyPractitioner'> & { companyPractitioner: ResolversTypes['CompanyPractitioner'] }>;
  UpdatePractitionerCodeInput: UpdatePractitionerCodeInput;
  UpdatePractitionerCodePayload: ResolverTypeWrapper<Omit<UpdatePractitionerCodePayload, 'practitioner'> & { practitioner: ResolversTypes['Practitioner'] }>;
  UpdatePractitionerInput: UpdatePractitionerInput;
  UpdatePractitionerPayload: ResolverTypeWrapper<Omit<UpdatePractitionerPayload, 'practitioner'> & { practitioner: ResolversTypes['Practitioner'] }>;
  UpdatePrintPrescriptionSettingInput: UpdatePrintPrescriptionSettingInput;
  UpdatePrintPrescriptionSettingPayload: ResolverTypeWrapper<UpdatePrintPrescriptionSettingPayload>;
  UpdateUberSignatureInputDataInput: UpdateUberSignatureInputDataInput;
  UpdateUberSignatureInputDataPayload: ResolverTypeWrapper<Omit<UpdateUberSignatureInputDataPayload, 'uberSignature'> & { uberSignature: ResolversTypes['UberSignature'] }>;
  UpdateWebBookingsBusinessHour2Input: UpdateWebBookingsBusinessHour2Input;
  UpdateWebBookingsBusinessHour2Payload: ResolverTypeWrapper<UpdateWebBookingsBusinessHour2Payload>;
  UpdateWebBookingsExceptionBusinessHourInput: UpdateWebBookingsExceptionBusinessHourInput;
  UpdateWebBookingsExceptionBusinessHourPayload: ResolverTypeWrapper<UpdateWebBookingsExceptionBusinessHourPayload>;
  UpdateWebBookingsHolidayBusinessHourInput: UpdateWebBookingsHolidayBusinessHourInput;
  UpdateWebBookingsHolidayBusinessHourPayload: ResolverTypeWrapper<UpdateWebBookingsHolidayBusinessHourPayload>;
  UpdateWebBookingsSettingInput: UpdateWebBookingsSettingInput;
  UpdateWebBookingsSettingPayload: ResolverTypeWrapper<UpdateWebBookingsSettingPayload>;
  UpsertAgreementExtensionInput: UpsertAgreementExtensionInput;
  UpsertAgreementExtensionPayload: ResolverTypeWrapper<Omit<UpsertAgreementExtensionPayload, 'agreementExtension'> & { agreementExtension: ResolversTypes['AgreementExtension'] }>;
  UpsertClientAuthenticationInput: UpsertClientAuthenticationInput;
  UpsertClientAuthenticationPayload: ResolverTypeWrapper<Omit<UpsertClientAuthenticationPayload, 'clientAuthentication'> & { clientAuthentication: ResolversTypes['ClientAuthentication'] }>;
  UpsertCompanyWebBookingsLimitSettingInput: UpsertCompanyWebBookingsLimitSettingInput;
  UpsertCompanyWebBookingsLimitSettingPayload: ResolverTypeWrapper<Omit<UpsertCompanyWebBookingsLimitSettingPayload, 'companyWebBookingsLimitSetting'> & { companyWebBookingsLimitSetting: ResolversTypes['CompanyWebBookingsLimitSetting'] }>;
  UpsertGuestPatientMedicationFollowupStatusInput: UpsertGuestPatientMedicationFollowupStatusInput;
  UpsertGuestPatientMedicationFollowupStatusPayload: ResolverTypeWrapper<UpsertGuestPatientMedicationFollowupStatusPayload>;
  UpsertMedicationFollowupDraftMessageInput: UpsertMedicationFollowupDraftMessageInput;
  UpsertMedicationFollowupDraftMessagePayload: ResolverTypeWrapper<Omit<UpsertMedicationFollowupDraftMessagePayload, 'medicationFollowupDraftMessage'> & { medicationFollowupDraftMessage: ResolversTypes['MedicationFollowupDraftMessage'] }>;
  UpsertMedicationFollowupStatusSettingInput: UpsertMedicationFollowupStatusSettingInput;
  UpsertMedicationFollowupStatusSettingPayload: ResolverTypeWrapper<Omit<UpsertMedicationFollowupStatusSettingPayload, 'medicationFollowupSetting'> & { medicationFollowupSetting: ResolversTypes['MedicationFollowupSetting'] }>;
  UpsertOrganizationAddressInput: UpsertOrganizationAddressInput;
  UpsertOrganizationAdminPractitionerInput: UpsertOrganizationAdminPractitionerInput;
  UpsertOrganizationBankAccountInput: UpsertOrganizationBankAccountInput;
  UpsertOrganizationInput: UpsertOrganizationInput;
  UpsertOrganizationPayload: ResolverTypeWrapper<Omit<UpsertOrganizationPayload, 'adminPractitioner' | 'clientCert' | 'organization'> & { adminPractitioner?: Maybe<ResolversTypes['Practitioner']>, clientCert?: Maybe<ResolversTypes['ClientCert']>, organization: ResolversTypes['Organization'] }>;
  UpsertOrganizationWebBookingsBusinessHourInput: UpsertOrganizationWebBookingsBusinessHourInput;
  UpsertOrganizationWebBookingsSettingInput: UpsertOrganizationWebBookingsSettingInput;
  UpsertOrganizationsInput: UpsertOrganizationsInput;
  UpsertOrganizationsPayload: ResolverTypeWrapper<Omit<UpsertOrganizationsPayload, 'organizationImportJobInformation'> & { organizationImportJobInformation: ResolversTypes['OrganizationImportJobInformation'] }>;
  UpsertPatientMedicationFollowupStatusInput: UpsertPatientMedicationFollowupStatusInput;
  UpsertPatientMedicationFollowupStatusPayload: ResolverTypeWrapper<UpsertPatientMedicationFollowupStatusPayload>;
  UpsertTracingReportDraftInput: UpsertTracingReportDraftInput;
  UpsertTracingReportDraftPayload: ResolverTypeWrapper<Omit<UpsertTracingReportDraftPayload, 'tracingReportDraft'> & { tracingReportDraft: ResolversTypes['TracingReportDraft'] }>;
  UpsertUberOrganizationSettingInput: UpsertUberOrganizationSettingInput;
  UpsertUberOrganizationSettingPayload: ResolverTypeWrapper<UpsertUberOrganizationSettingPayload>;
  UpsertUberOrganizationSettingsInput: UpsertUberOrganizationSettingsInput;
  UpsertUberOrganizationSettingsPayload: ResolverTypeWrapper<UpsertUberOrganizationSettingsPayload>;
  UpsertUberSignatureDraftInput: UpsertUberSignatureDraftInput;
  UpsertUberSignatureDraftPayload: ResolverTypeWrapper<Omit<UpsertUberSignatureDraftPayload, 'uberSignatureDraft'> & { uberSignatureDraft: ResolversTypes['UberSignatureDraft'] }>;
  UpsertWebBookingsAllDayLimitInput: UpsertWebBookingsAllDayLimitInput;
  UpsertWebBookingsAllDayLimitPayload: ResolverTypeWrapper<UpsertWebBookingsAllDayLimitPayload>;
  UpsertWebBookingsLimitInput: UpsertWebBookingsLimitInput;
  UpsertWebBookingsLimitLimitInput: UpsertWebBookingsLimitLimitInput;
  UpsertWebBookingsLimitPayload: ResolverTypeWrapper<UpsertWebBookingsLimitPayload>;
  ViewedMedicationFollowupQuestionnaireSheetInput: ViewedMedicationFollowupQuestionnaireSheetInput;
  ViewedMedicationFollowupQuestionnaireSheetPayload: ResolverTypeWrapper<Omit<ViewedMedicationFollowupQuestionnaireSheetPayload, 'medicationFollowupQuestionnaireSheet' | 'medicationFollowupQuestionnaireSheets'> & { medicationFollowupQuestionnaireSheet?: Maybe<ResolversTypes['MedicationFollowupQuestionnaireSheet']>, medicationFollowupQuestionnaireSheets?: Maybe<Array<ResolversTypes['MedicationFollowupQuestionnaireSheet']>> }>;
  WebBookingsBusinessHour: ResolverTypeWrapper<WebBookingsBusinessHour>;
  WebBookingsExceptionBusinessHour: ResolverTypeWrapper<WebBookingsExceptionBusinessHour>;
  WebBookingsExceptionDate: ResolverTypeWrapper<WebBookingsExceptionDate>;
  WebBookingsHolidayBusinessHour: ResolverTypeWrapper<WebBookingsHolidayBusinessHour>;
  WebBookingsLimit: ResolverTypeWrapper<WebBookingsLimit>;
  WebBookingsLimitCode: WebBookingsLimitCode;
  WebBookingsLimitLimit: ResolverTypeWrapper<WebBookingsLimitLimit>;
  WebBookingsSetting: ResolverTypeWrapper<WebBookingsSetting>;
  WebBookingsSuspend: ResolverTypeWrapper<WebBookingsSuspend>;
  WebVisitor: ResolverTypeWrapper<Omit<WebVisitor, 'appointment' | 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'questionnaireSheet' | 'samePatient' | 'tracingReportDrafts' | 'tracingReports'> & { appointment: ResolversTypes['Appointment'], medicationFollowupDraftMessages: ResolversTypes['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: ResolversTypes['MedicationFollowupMessagePage'], medixsPatient?: Maybe<ResolversTypes['MedixsPatient']>, messageDeliverResults: ResolversTypes['MessageDeliverResultPage'], questionnaireSheet: ResolversTypes['QuestionnaireSheet'], samePatient?: Maybe<ResolversTypes['Patient']>, tracingReportDrafts: ResolversTypes['TracingReportDraftPage'], tracingReports: ResolversTypes['TracingReportPage'] }>;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  AccreteMessage: Omit<AccreteMessage, 'practitioner'> & { practitioner?: Maybe<ResolversParentTypes['Practitioner']> };
  AccreteMessagePage: AccreteMessagePage;
  AccreteMessageResult: AccreteMessageResult;
  ActivateAnnouncementInput: ActivateAnnouncementInput;
  ActivateAnnouncementPayload: ActivateAnnouncementPayload;
  ActivateOtpSecretInput: ActivateOtpSecretInput;
  ActivateOtpSecretPayload: ActivateOtpSecretPayload;
  AddCompanyAddressInput: AddCompanyAddressInput;
  AddCompanyAddressPayload: Omit<AddCompanyAddressPayload, 'companyAddress'> & { companyAddress: ResolversParentTypes['CompanyAddress'] };
  AddCompanyContactPointInput: AddCompanyContactPointInput;
  AddCompanyContactPointPayload: Omit<AddCompanyContactPointPayload, 'companyContactPoint'> & { companyContactPoint: ResolversParentTypes['CompanyContactPoint'] };
  AddCompanyPractitionerInput: AddCompanyPractitionerInput;
  AddCompanyPractitionerPayload: Omit<AddCompanyPractitionerPayload, 'companyPractitionerConfirmation' | 'practitioner'> & { companyPractitionerConfirmation: ResolversParentTypes['CompanyPractitionerConfirmation'], practitioner: ResolversParentTypes['Practitioner'] };
  AddContractPlanInput: AddContractPlanInput;
  AddContractPlanPayload: Omit<AddContractPlanPayload, 'contractPlan'> & { contractPlan: ResolversParentTypes['ContractPlan'] };
  AddIncentiveTargetCompanyInput: AddIncentiveTargetCompanyInput;
  AddIncentiveTargetCompanyPayload: Omit<AddIncentiveTargetCompanyPayload, 'company'> & { company: ResolversParentTypes['Company'] };
  AddInvitationCodeInput: AddInvitationCodeInput;
  AddInvitationCodePayload: Omit<AddInvitationCodePayload, 'invitationCode'> & { invitationCode: ResolversParentTypes['InvitationCode'] };
  AddOrganizationAddressInput: AddOrganizationAddressInput;
  AddOrganizationAddressPayload: Omit<AddOrganizationAddressPayload, 'organizationAddress'> & { organizationAddress: ResolversParentTypes['OrganizationAddress'] };
  AddOrganizationContactPointInput: AddOrganizationContactPointInput;
  AddOrganizationContactPointPayload: Omit<AddOrganizationContactPointPayload, 'organizationContactPoint'> & { organizationContactPoint: ResolversParentTypes['OrganizationContactPoint'] };
  AddPatientAttachmentInput: AddPatientAttachmentInput;
  AddPatientAttachmentPayload: AddPatientAttachmentPayload;
  AddUberSignatureDraftExtraTextInput: AddUberSignatureDraftExtraTextInput;
  AddUberSignatureDraftExtraTextPayload: Omit<AddUberSignatureDraftExtraTextPayload, 'uberSignatureDraft'> & { uberSignatureDraft: ResolversParentTypes['UberSignatureDraft'] };
  Address: Address;
  Agent: Agent;
  AgentSetting: AgentSetting;
  AgreementExtension: Omit<AgreementExtension, 'activatePractitioner' | 'deactivatePractitioner' | 'extension' | 'uberSignatures'> & { activatePractitioner: ResolversParentTypes['Practitioner'], deactivatePractitioner?: Maybe<ResolversParentTypes['Practitioner']>, extension: ResolversParentTypes['Extension'], uberSignatures?: Maybe<Array<ResolversParentTypes['UberSignature']>> };
  AgreementExtensionPage: Omit<AgreementExtensionPage, 'nodes'> & { nodes: Array<ResolversParentTypes['AgreementExtension']> };
  AllPatient: ResolversUnionTypes<ResolversParentTypes>['AllPatient'];
  AllPatientOrder: AllPatientOrder;
  AllPatientPage: Omit<AllPatientPage, 'nodes'> & { nodes: Array<ResolversParentTypes['AllPatient']> };
  AllowList: AllowList;
  AllowOperatorAccessPermissionInput: AllowOperatorAccessPermissionInput;
  AllowOperatorAccessPermissionPayload: AllowOperatorAccessPermissionPayload;
  Announcement: Announcement;
  AnnouncementConnection: AnnouncementConnection;
  AnnouncementEdge: AnnouncementEdge;
  AnnouncementPage: AnnouncementPage;
  AppendIdToFeatureTargetGroupInput: AppendIdToFeatureTargetGroupInput;
  AppendIdToFeatureTargetGroupPayload: AppendIdToFeatureTargetGroupPayload;
  AppendToFeatureTargetGroupInput: AppendToFeatureTargetGroupInput;
  AppendToFeatureTargetGroupPayload: AppendToFeatureTargetGroupPayload;
  Appointment: Omit<Appointment, 'charge' | 'draftAppointment' | 'encounter' | 'hiccupAppointmentPermission' | 'medixsReception' | 'organization' | 'patient' | 'questionnaires' | 'uberDelivery' | 'unreadOrganizationNotifications' | 'webVisitor'> & { charge?: Maybe<ResolversParentTypes['Charge']>, draftAppointment?: Maybe<ResolversParentTypes['DraftAppointment']>, encounter?: Maybe<ResolversParentTypes['Encounter']>, hiccupAppointmentPermission?: Maybe<ResolversParentTypes['HiccupAppointmentPermission']>, medixsReception?: Maybe<ResolversParentTypes['MedixsReception']>, organization: ResolversParentTypes['Organization'], patient?: Maybe<ResolversParentTypes['Patient']>, questionnaires: Array<ResolversParentTypes['QuestionnaireSheetAnswer']>, uberDelivery?: Maybe<ResolversParentTypes['UberDelivery']>, unreadOrganizationNotifications: Array<ResolversParentTypes['OrganizationNotification']>, webVisitor?: Maybe<ResolversParentTypes['WebVisitor']> };
  AppointmentConnection: Omit<AppointmentConnection, 'edges' | 'nodes'> & { edges?: Maybe<Array<Maybe<ResolversParentTypes['AppointmentEdge']>>>, nodes?: Maybe<Array<Maybe<ResolversParentTypes['Appointment']>>> };
  AppointmentEdge: Omit<AppointmentEdge, 'node'> & { node?: Maybe<ResolversParentTypes['Appointment']> };
  AppointmentOrder: AppointmentOrder;
  AppointmentPage: Omit<AppointmentPage, 'nodes'> & { nodes: Array<ResolversParentTypes['Appointment']> };
  ApproveUberSignatureInput: ApproveUberSignatureInput;
  ApproveUberSignaturePayload: Omit<ApproveUberSignaturePayload, 'uberSignature'> & { uberSignature: ResolversParentTypes['UberSignature'] };
  AuthToken: AuthToken;
  B2cloudSetting: Omit<B2cloudSetting, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  B2cloudSettingData: B2cloudSettingData;
  B2cloudSettingSenderData: B2cloudSettingSenderData;
  Bank: Bank;
  BankAccount: Omit<BankAccount, 'organization'> & { organization?: Maybe<ResolversParentTypes['Organization']> };
  BankBranch: BankBranch;
  BankPage: BankPage;
  Blob: Blob;
  BookAppointmentInput: BookAppointmentInput;
  BookAppointmentPayload: Omit<BookAppointmentPayload, 'encounter'> & { encounter: ResolversParentTypes['Encounter'] };
  Bookmark: Bookmark;
  BookmarkedPatientCount: Omit<BookmarkedPatientCount, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  BookmarkedPatientCountPage: Omit<BookmarkedPatientCountPage, 'nodes'> & { nodes: Array<ResolversParentTypes['BookmarkedPatientCount']> };
  Boolean: Scalars['Boolean']['output'];
  Branch: Branch;
  BranchPage: BranchPage;
  BulkDuplicateMedicationFollowupMessageTemplatesInput: BulkDuplicateMedicationFollowupMessageTemplatesInput;
  BulkDuplicateMedicationFollowupMessageTemplatesPayload: Omit<BulkDuplicateMedicationFollowupMessageTemplatesPayload, 'messageTemplateJobInformation'> & { messageTemplateJobInformation: ResolversParentTypes['MedicationFollowupMessageTemplateJobInformation'] };
  BusinessHourTime: BusinessHourTime;
  BusinessHourTimeInput: BusinessHourTimeInput;
  CancelAppointmentInput: CancelAppointmentInput;
  CancelAppointmentPayload: Omit<CancelAppointmentPayload, 'appointment'> & { appointment: ResolversParentTypes['Appointment'] };
  CancelAppointmentViaWebInput: CancelAppointmentViaWebInput;
  CancelAppointmentViaWebPayload: CancelAppointmentViaWebPayload;
  CancelAppointmentWithWebVisitorInput: CancelAppointmentWithWebVisitorInput;
  CancelAppointmentWithWebVisitorPayload: Omit<CancelAppointmentWithWebVisitorPayload, 'appointment'> & { appointment: ResolversParentTypes['Appointment'] };
  CancelDraftAppointmentInput: CancelDraftAppointmentInput;
  CancelDraftAppointmentPayload: Omit<CancelDraftAppointmentPayload, 'draftAppointment'> & { draftAppointment: ResolversParentTypes['DraftAppointment'] };
  CancelOperatorAccessPermissionInput: CancelOperatorAccessPermissionInput;
  CancelOperatorAccessPermissionPayload: CancelOperatorAccessPermissionPayload;
  ChangeDeliveryMethodInput: ChangeDeliveryMethodInput;
  ChangeDeliveryMethodPayload: Omit<ChangeDeliveryMethodPayload, 'appointment'> & { appointment: ResolversParentTypes['Appointment'] };
  ChangeOutpatientQuestionnaireSettingQuestionnaireInUseInput: ChangeOutpatientQuestionnaireSettingQuestionnaireInUseInput;
  ChangeOutpatientQuestionnaireSettingQuestionnaireInUsePayload: ChangeOutpatientQuestionnaireSettingQuestionnaireInUsePayload;
  Charge: Omit<Charge, 'appointment' | 'chargeHistories' | 'practitioner'> & { appointment: ResolversParentTypes['Appointment'], chargeHistories: ResolversParentTypes['ChargeHistoryPage'], practitioner: ResolversParentTypes['Practitioner'] };
  ChargeHistory: Omit<ChargeHistory, 'amountDetails' | 'charge' | 'organization'> & { amountDetails?: Maybe<Array<ResolversParentTypes['ChargeHistoryAmountDetail']>>, charge: ResolversParentTypes['Charge'], organization: ResolversParentTypes['Organization'] };
  ChargeHistoryAmountDetail: ChargeHistoryAmountDetail;
  ChargeHistoryPage: Omit<ChargeHistoryPage, 'nodes'> & { nodes: Array<ResolversParentTypes['ChargeHistory']> };
  ChargeWithApp2ChargeItemInput: ChargeWithApp2ChargeItemInput;
  ChargeWithApp2Input: ChargeWithApp2Input;
  ChargeWithApp2LineItemInput: ChargeWithApp2LineItemInput;
  ChargeWithApp2Payload: Omit<ChargeWithApp2Payload, 'charge'> & { charge: ResolversParentTypes['Charge'] };
  ChargeWithAppInput: ChargeWithAppInput;
  ChargeWithAppPayload: Omit<ChargeWithAppPayload, 'charge'> & { charge: ResolversParentTypes['Charge'] };
  ChargeWithCash2Input: ChargeWithCash2Input;
  ChargeWithCash2Payload: Omit<ChargeWithCash2Payload, 'charge'> & { charge: ResolversParentTypes['Charge'] };
  ChargeWithCashInput: ChargeWithCashInput;
  ChargeWithCashPayload: Omit<ChargeWithCashPayload, 'charge'> & { charge: ResolversParentTypes['Charge'] };
  CheckinEntry: Omit<CheckinEntry, 'checkinOrganization' | 'organization' | 'unreadOrganizationNotifications'> & { checkinOrganization: ResolversParentTypes['CheckinOrganization'], organization: ResolversParentTypes['Organization'], unreadOrganizationNotifications: Array<ResolversParentTypes['OrganizationNotification']> };
  CheckinEntryPage: Omit<CheckinEntryPage, 'nodes'> & { nodes: Array<ResolversParentTypes['CheckinEntry']> };
  CheckinOrganization: CheckinOrganization;
  CheckinSetting: Omit<CheckinSetting, 'checkinOrganization' | 'organization'> & { checkinOrganization: ResolversParentTypes['CheckinOrganization'], organization: ResolversParentTypes['Organization'] };
  City: City;
  ClientAuthentication: Omit<ClientAuthentication, 'company'> & { company: ResolversParentTypes['Company'] };
  ClientCert: Omit<ClientCert, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  ClientCertJobInformation: ClientCertJobInformation;
  ClientCertPage: Omit<ClientCertPage, 'nodes'> & { nodes: Array<ResolversParentTypes['ClientCert']> };
  ClientCertSummary: Omit<ClientCertSummary, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  ClientCertSummaryPage: Omit<ClientCertSummaryPage, 'nodes'> & { nodes: Array<ResolversParentTypes['ClientCertSummary']> };
  ClientCertVerification: Omit<ClientCertVerification, 'clientCert'> & { clientCert?: Maybe<ResolversParentTypes['ClientCert']> };
  Company: Omit<Company, 'affectedOrganizationsByDeactivation' | 'agreementExtensions' | 'bookmarkedPatientCounts' | 'candidateCompanyPractitioners' | 'checkinEntries' | 'clientAuthentication' | 'clientCertSummaries' | 'companyAddresses' | 'companyContactPoints' | 'companyPractitioner' | 'companyPractitionerConfirmation' | 'contract' | 'featureUsages' | 'feeSettings' | 'latestSucceededTemplateJobInformation' | 'latestUberSignature' | 'medicationFollowupUsages' | 'monthlySales' | 'organizationImportJobInformations' | 'organizations' | 'payouts' | 'receptionUsages' | 'receptions' | 'tracingReportUsages' | 'uberSignatureDraft' | 'uberSignatures' | 'webBookingsLimitSettings'> & { affectedOrganizationsByDeactivation?: Maybe<ResolversParentTypes['OrganizationPage']>, agreementExtensions: ResolversParentTypes['AgreementExtensionPage'], bookmarkedPatientCounts: ResolversParentTypes['BookmarkedPatientCountPage'], candidateCompanyPractitioners?: Maybe<Array<ResolversParentTypes['Practitioner']>>, checkinEntries: ResolversParentTypes['CheckinEntryPage'], clientAuthentication?: Maybe<ResolversParentTypes['ClientAuthentication']>, clientCertSummaries: ResolversParentTypes['ClientCertSummaryPage'], companyAddresses: Array<ResolversParentTypes['CompanyAddress']>, companyContactPoints: Array<ResolversParentTypes['CompanyContactPoint']>, companyPractitioner?: Maybe<ResolversParentTypes['CompanyPractitioner']>, companyPractitionerConfirmation?: Maybe<ResolversParentTypes['CompanyPractitionerConfirmation']>, contract?: Maybe<ResolversParentTypes['Contract']>, featureUsages: ResolversParentTypes['FeatureUsagePage'], feeSettings: ResolversParentTypes['CompanyFeeSettingPage'], latestSucceededTemplateJobInformation?: Maybe<ResolversParentTypes['MedicationFollowupMessageTemplateJobInformation']>, latestUberSignature?: Maybe<ResolversParentTypes['UberSignature']>, medicationFollowupUsages: ResolversParentTypes['MedicationFollowupUsagePage'], monthlySales?: Maybe<ResolversParentTypes['CompanyMonthlySales']>, organizationImportJobInformations: ResolversParentTypes['OrganizationImportJobInformationConnection'], organizations: ResolversParentTypes['OrganizationPage'], payouts: ResolversParentTypes['PayoutPage'], receptionUsages: ResolversParentTypes['ReceptionUsagePage'], receptions?: Maybe<ResolversParentTypes['ReceptionPage']>, tracingReportUsages: ResolversParentTypes['TracingReportUsagePage'], uberSignatureDraft?: Maybe<ResolversParentTypes['UberSignatureDraft']>, uberSignatures?: Maybe<Array<ResolversParentTypes['UberSignature']>>, webBookingsLimitSettings: Array<ResolversParentTypes['CompanyWebBookingsLimitSetting']> };
  CompanyAddress: Omit<CompanyAddress, 'address'> & { address: ResolversParentTypes['Address'] };
  CompanyAgentSetting: CompanyAgentSetting;
  CompanyCommonSetting: Omit<CompanyCommonSetting, 'organization'> & { organization?: Maybe<ResolversParentTypes['Organization']> };
  CompanyContactPoint: Omit<CompanyContactPoint, 'contactPoint'> & { contactPoint: ResolversParentTypes['ContactPoint'] };
  CompanyFeeSetting: Omit<CompanyFeeSetting, 'company'> & { company: ResolversParentTypes['Company'] };
  CompanyFeeSettingPage: Omit<CompanyFeeSettingPage, 'nodes'> & { nodes: Array<ResolversParentTypes['CompanyFeeSetting']> };
  CompanyMonthlySales: Omit<CompanyMonthlySales, 'organizationDailySales'> & { organizationDailySales: ResolversParentTypes['OrganizationDailySalesPage'] };
  CompanyPractitioner: Omit<CompanyPractitioner, 'company' | 'companyPractitionerContactPoints' | 'practitioner'> & { company: ResolversParentTypes['Company'], companyPractitionerContactPoints: Array<ResolversParentTypes['CompanyPractitionerContactPoint']>, practitioner: ResolversParentTypes['Practitioner'] };
  CompanyPractitionerConfirmation: Omit<CompanyPractitionerConfirmation, 'company' | 'practitioner'> & { company: ResolversParentTypes['Company'], practitioner: ResolversParentTypes['Practitioner'] };
  CompanyPractitionerConfirmationData: CompanyPractitionerConfirmationData;
  CompanyPractitionerContactPoint: Omit<CompanyPractitionerContactPoint, 'contactPoint'> & { contactPoint: ResolversParentTypes['ContactPoint'] };
  CompanySessionSetting: CompanySessionSetting;
  CompanySetupDocument: CompanySetupDocument;
  CompanyWebBookingsLimitSetting: Omit<CompanyWebBookingsLimitSetting, 'company'> & { company: ResolversParentTypes['Company'] };
  ContactPoint: ContactPoint;
  Contract: Omit<Contract, 'contractPlans'> & { contractPlans: Array<ResolversParentTypes['ContractPlan']> };
  ContractPlan: Omit<ContractPlan, 'contract' | 'plan'> & { contract: ResolversParentTypes['Contract'], plan: ResolversParentTypes['Plan'] };
  CreateAdminPractitionerInput: CreateAdminPractitionerInput;
  CreateAllowListInput: CreateAllowListInput;
  CreateAllowListPayload: CreateAllowListPayload;
  CreateAnnouncementInput: CreateAnnouncementInput;
  CreateAnnouncementPayload: CreateAnnouncementPayload;
  CreateAppointmentViaWebInput: CreateAppointmentViaWebInput;
  CreateAppointmentViaWebPayload: CreateAppointmentViaWebPayload;
  CreateAuthTokenByProxyInput: CreateAuthTokenByProxyInput;
  CreateAuthTokenByProxyPayload: CreateAuthTokenByProxyPayload;
  CreateCheckinEntryInput: CreateCheckinEntryInput;
  CreateCheckinEntryPayload: Omit<CreateCheckinEntryPayload, 'publicCheckinEntry'> & { publicCheckinEntry: ResolversParentTypes['PublicCheckinEntry'] };
  CreateClientCertInput: CreateClientCertInput;
  CreateClientCertPayload: Omit<CreateClientCertPayload, 'clientCert'> & { clientCert: ResolversParentTypes['ClientCert'] };
  CreateCompanyFeeSettingInput: CreateCompanyFeeSettingInput;
  CreateCompanyFeeSettingPayload: Omit<CreateCompanyFeeSettingPayload, 'companyFeeSetting'> & { companyFeeSetting: ResolversParentTypes['CompanyFeeSetting'] };
  CreateCompanySetupDocumentInput: CreateCompanySetupDocumentInput;
  CreateCompanySetupDocumentPayload: CreateCompanySetupDocumentPayload;
  CreateDirectVisitorInput: CreateDirectVisitorInput;
  CreateDirectVisitorPayload: Omit<CreateDirectVisitorPayload, 'directVisitor'> & { directVisitor: ResolversParentTypes['DirectVisitor'] };
  CreateFeatureInput: CreateFeatureInput;
  CreateFeaturePayload: CreateFeaturePayload;
  CreateFeatureTargetGroupFromTargetInput: CreateFeatureTargetGroupFromTargetInput;
  CreateFeatureTargetGroupFromTargetPayload: CreateFeatureTargetGroupFromTargetPayload;
  CreateFeatureTargetGroupInput: CreateFeatureTargetGroupInput;
  CreateFeatureTargetGroupPayload: CreateFeatureTargetGroupPayload;
  CreateGendaSettingInput: CreateGendaSettingInput;
  CreateGendaSettingPayload: Omit<CreateGendaSettingPayload, 'gendaSetting'> & { gendaSetting: ResolversParentTypes['GendaSetting'] };
  CreateGuestPatientFollowupCommentInput: CreateGuestPatientFollowupCommentInput;
  CreateGuestPatientFollowupCommentPayload: CreateGuestPatientFollowupCommentPayload;
  CreateMedicalInstitutionSettingInput: CreateMedicalInstitutionSettingInput;
  CreateMedicalInstitutionSettingPayload: Omit<CreateMedicalInstitutionSettingPayload, 'medicalInstitutionSetting'> & { medicalInstitutionSetting: ResolversParentTypes['MedicalInstitutionSetting'] };
  CreateMedicationFollowupMessage2Input: CreateMedicationFollowupMessage2Input;
  CreateMedicationFollowupMessage2Payload: Omit<CreateMedicationFollowupMessage2Payload, 'medicationFollowupMessage'> & { medicationFollowupMessage: ResolversParentTypes['MedicationFollowupMessage'] };
  CreateMedicationFollowupMessageTemplateInput: CreateMedicationFollowupMessageTemplateInput;
  CreateMedicationFollowupMessageTemplatePayload: Omit<CreateMedicationFollowupMessageTemplatePayload, 'medicationFollowupMessageTemplate'> & { medicationFollowupMessageTemplate: ResolversParentTypes['MedicationFollowupMessageTemplate'] };
  CreateMedicationFollowupQuestionnaireInput: CreateMedicationFollowupQuestionnaireInput;
  CreateMedicationFollowupQuestionnairePayload: Omit<CreateMedicationFollowupQuestionnairePayload, 'medicationFollowupQuestionnaire'> & { medicationFollowupQuestionnaire: ResolversParentTypes['MedicationFollowupQuestionnaire'] };
  CreateMedicationFollowupQuestionnaireSheetAnswerInput: CreateMedicationFollowupQuestionnaireSheetAnswerInput;
  CreateMedicationFollowupQuestionnaireSheetInput: CreateMedicationFollowupQuestionnaireSheetInput;
  CreateMedicationFollowupQuestionnaireSheetPayload: CreateMedicationFollowupQuestionnaireSheetPayload;
  CreateMedixsSettingInput: CreateMedixsSettingInput;
  CreateMedixsSettingPayload: Omit<CreateMedixsSettingPayload, 'medixsSetting'> & { medixsSetting: ResolversParentTypes['MedixsSetting'] };
  CreateMessageForWebVisitorInput: CreateMessageForWebVisitorInput;
  CreateMessageForWebVisitorPayload: Omit<CreateMessageForWebVisitorPayload, 'messageDeliver'> & { messageDeliver: ResolversParentTypes['MessageDeliver'] };
  CreateOperatorAuthorityInput: CreateOperatorAuthorityInput;
  CreateOperatorAuthorityPayload: CreateOperatorAuthorityPayload;
  CreateOperatorRoleInput: CreateOperatorRoleInput;
  CreateOperatorRolePayload: CreateOperatorRolePayload;
  CreateOrganizationCompanyFeeSettingInput: CreateOrganizationCompanyFeeSettingInput;
  CreateOrganizationCompanyFeeSettingPayload: CreateOrganizationCompanyFeeSettingPayload;
  CreateOrganizationFeeSettingInput: CreateOrganizationFeeSettingInput;
  CreateOrganizationFeeSettingPayload: Omit<CreateOrganizationFeeSettingPayload, 'organizationFeeSetting'> & { organizationFeeSetting: ResolversParentTypes['OrganizationFeeSetting'] };
  CreateOrganizationInput: CreateOrganizationInput;
  CreateOrganizationPayload: Omit<CreateOrganizationPayload, 'adminPractitioner' | 'organization'> & { adminPractitioner?: Maybe<ResolversParentTypes['Practitioner']>, organization: ResolversParentTypes['Organization'] };
  CreateOtpSecretInput: CreateOtpSecretInput;
  CreateOtpSecretPayload: CreateOtpSecretPayload;
  CreateOutpatientQuestionnaireEntryAddressInput: CreateOutpatientQuestionnaireEntryAddressInput;
  CreateOutpatientQuestionnaireEntryAnswerInput: CreateOutpatientQuestionnaireEntryAnswerInput;
  CreateOutpatientQuestionnaireEntryInput: CreateOutpatientQuestionnaireEntryInput;
  CreateOutpatientQuestionnaireEntryPayload: CreateOutpatientQuestionnaireEntryPayload;
  CreateOutpatientQuestionnaireSettingQuestionnaireInput: CreateOutpatientQuestionnaireSettingQuestionnaireInput;
  CreateOutpatientQuestionnaireSettingQuestionnairePayload: CreateOutpatientQuestionnaireSettingQuestionnairePayload;
  CreatePatientFollowupCommentInput: CreatePatientFollowupCommentInput;
  CreatePatientFollowupCommentPayload: CreatePatientFollowupCommentPayload;
  CreatePlanInput: CreatePlanInput;
  CreatePlanPayload: Omit<CreatePlanPayload, 'plan'> & { plan: ResolversParentTypes['Plan'] };
  CreatePractitionerInput: CreatePractitionerInput;
  CreatePractitionerPayload: Omit<CreatePractitionerPayload, 'practitioner'> & { practitioner: ResolversParentTypes['Practitioner'] };
  CreateTracingReportInput: CreateTracingReportInput;
  CreateTracingReportPayload: Omit<CreateTracingReportPayload, 'tracingReport'> & { tracingReport: ResolversParentTypes['TracingReport'] };
  CreateUberAgreementExtensionInput: CreateUberAgreementExtensionInput;
  CreateUberAgreementExtensionPayload: Omit<CreateUberAgreementExtensionPayload, 'agreementExtension' | 'uberSignature'> & { agreementExtension: ResolversParentTypes['AgreementExtension'], uberSignature: ResolversParentTypes['UberSignature'] };
  CreateUberDeliveryInput: CreateUberDeliveryInput;
  CreateUberDeliveryPayload: Omit<CreateUberDeliveryPayload, 'uberDelivery'> & { uberDelivery: ResolversParentTypes['UberDelivery'] };
  CsCity: CsCity;
  CsClinic: CsClinic;
  CsClinicCategory: CsClinicCategory;
  CsClinicPage: CsClinicPage;
  CsClinicSubCategory: CsClinicSubCategory;
  DeactivateAnnouncementInput: DeactivateAnnouncementInput;
  DeactivateAnnouncementPayload: DeactivateAnnouncementPayload;
  DeactivateCompanyFeeSettingInput: DeactivateCompanyFeeSettingInput;
  DeactivateCompanyFeeSettingPayload: Omit<DeactivateCompanyFeeSettingPayload, 'companyFeeSetting'> & { companyFeeSetting: ResolversParentTypes['CompanyFeeSetting'] };
  DeactivateCompanyInput: DeactivateCompanyInput;
  DeactivateCompanyPayload: Omit<DeactivateCompanyPayload, 'company'> & { company: ResolversParentTypes['Company'] };
  DeactivateMedicationFollowupMessageInput: DeactivateMedicationFollowupMessageInput;
  DeactivateMedicationFollowupMessagePayload: Omit<DeactivateMedicationFollowupMessagePayload, 'medicationFollowupMessage'> & { medicationFollowupMessage: ResolversParentTypes['MedicationFollowupMessage'] };
  DeactivateMedicationFollowupMessageTemplateInput: DeactivateMedicationFollowupMessageTemplateInput;
  DeactivateMedicationFollowupMessageTemplatePayload: Omit<DeactivateMedicationFollowupMessageTemplatePayload, 'medicationFollowupMessageTemplate'> & { medicationFollowupMessageTemplate: ResolversParentTypes['MedicationFollowupMessageTemplate'] };
  DeactivateMedicationFollowupQuestionnaireInput: DeactivateMedicationFollowupQuestionnaireInput;
  DeactivateMedicationFollowupQuestionnairePayload: Omit<DeactivateMedicationFollowupQuestionnairePayload, 'medicationFollowupQuestionnaire'> & { medicationFollowupQuestionnaire: ResolversParentTypes['MedicationFollowupQuestionnaire'] };
  DeactivateOperatorInput: DeactivateOperatorInput;
  DeactivateOperatorPayload: DeactivateOperatorPayload;
  DeactivateOrganizationFeeSettingInput: DeactivateOrganizationFeeSettingInput;
  DeactivateOrganizationFeeSettingPayload: Omit<DeactivateOrganizationFeeSettingPayload, 'organizationFeeSetting'> & { organizationFeeSetting: ResolversParentTypes['OrganizationFeeSetting'] };
  DeactivateOtpSecretsInput: DeactivateOtpSecretsInput;
  DeactivateOtpSecretsPayload: Omit<DeactivateOtpSecretsPayload, 'practitioner'> & { practitioner: ResolversParentTypes['Practitioner'] };
  DeactivatePractitionerInput: DeactivatePractitionerInput;
  DeactivatePractitionerPayload: Omit<DeactivatePractitionerPayload, 'practitioner'> & { practitioner: ResolversParentTypes['Practitioner'] };
  DeleteAllowListInput: DeleteAllowListInput;
  DeleteAllowListPayload: DeleteAllowListPayload;
  DeleteFeatureInput: DeleteFeatureInput;
  DeleteFeaturePayload: DeleteFeaturePayload;
  DeleteFeatureTargetGroupInput: DeleteFeatureTargetGroupInput;
  DeleteFeatureTargetGroupPayload: DeleteFeatureTargetGroupPayload;
  DeleteFromFeatureTargetGroupInput: DeleteFromFeatureTargetGroupInput;
  DeleteFromFeatureTargetGroupPayload: DeleteFromFeatureTargetGroupPayload;
  DeleteGuestPatientMedicationFollowupCommentInput: DeleteGuestPatientMedicationFollowupCommentInput;
  DeleteGuestPatientMedicationFollowupCommentPayload: DeleteGuestPatientMedicationFollowupCommentPayload;
  DeleteIdFromFeatureTargetGroupInput: DeleteIdFromFeatureTargetGroupInput;
  DeleteIdFromFeatureTargetGroupPayload: DeleteIdFromFeatureTargetGroupPayload;
  DeleteMedicationFollowupDraftMessageInput: DeleteMedicationFollowupDraftMessageInput;
  DeleteMedicationFollowupDraftMessagePayload: Omit<DeleteMedicationFollowupDraftMessagePayload, 'medicationFollowupDraftMessage'> & { medicationFollowupDraftMessage?: Maybe<ResolversParentTypes['MedicationFollowupDraftMessage']> };
  DeleteOperatorAuthorityInput: DeleteOperatorAuthorityInput;
  DeleteOperatorAuthorityPayload: DeleteOperatorAuthorityPayload;
  DeleteOperatorRoleInput: DeleteOperatorRoleInput;
  DeleteOperatorRolePayload: DeleteOperatorRolePayload;
  DeleteOrganizationInput: DeleteOrganizationInput;
  DeleteOrganizationPayload: Omit<DeleteOrganizationPayload, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  DeleteOutpatientQuestionnaireSettingQuestionnaireInput: DeleteOutpatientQuestionnaireSettingQuestionnaireInput;
  DeleteOutpatientQuestionnaireSettingQuestionnairePayload: DeleteOutpatientQuestionnaireSettingQuestionnairePayload;
  DeletePatientAttachmentInput: DeletePatientAttachmentInput;
  DeletePatientAttachmentPayload: DeletePatientAttachmentPayload;
  DeletePatientMedicationFollowupCommentInput: DeletePatientMedicationFollowupCommentInput;
  DeletePatientMedicationFollowupCommentPayload: DeletePatientMedicationFollowupCommentPayload;
  DeleteTracingReportDraftInput: DeleteTracingReportDraftInput;
  DeleteTracingReportDraftPayload: Omit<DeleteTracingReportDraftPayload, 'tracingReportDraft'> & { tracingReportDraft?: Maybe<ResolversParentTypes['TracingReportDraft']> };
  DescriptionCode: DescriptionCode;
  DirectVisitor: Omit<DirectVisitor, 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'outpatientQuestionnaireEntry' | 'samePatient' | 'tracingReportDrafts' | 'tracingReports'> & { medicationFollowupDraftMessages: ResolversParentTypes['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: ResolversParentTypes['MedicationFollowupMessagePage'], medixsPatient?: Maybe<ResolversParentTypes['MedixsPatient']>, messageDeliverResults: ResolversParentTypes['MessageDeliverResultPage'], outpatientQuestionnaireEntry?: Maybe<ResolversParentTypes['OutpatientQuestionnaireEntry']>, samePatient?: Maybe<ResolversParentTypes['Patient']>, tracingReportDrafts: ResolversParentTypes['TracingReportDraftPage'], tracingReports: ResolversParentTypes['TracingReportPage'] };
  DirectVisitorCandidate: ResolversUnionTypes<ResolversParentTypes>['DirectVisitorCandidate'];
  DirectVisitorCandidatePage: Omit<DirectVisitorCandidatePage, 'nodes'> & { nodes: Array<ResolversParentTypes['DirectVisitorCandidate']> };
  DirectVisitorPage: Omit<DirectVisitorPage, 'nodes'> & { nodes: Array<ResolversParentTypes['DirectVisitor']> };
  DisclosedMedicineNote: ResolversUnionTypes<ResolversParentTypes>['DisclosedMedicineNote'];
  DisclosedMedicineNotePage: Omit<DisclosedMedicineNotePage, 'nodes'> & { nodes: Array<ResolversParentTypes['DisclosedMedicineNote']> };
  DownloadClientCertInput: DownloadClientCertInput;
  DownloadClientCertPayload: DownloadClientCertPayload;
  DraftAppointment: Omit<DraftAppointment, 'appointment' | 'organization' | 'patient' | 'questionnaires' | 'unreadOrganizationNotifications'> & { appointment?: Maybe<ResolversParentTypes['Appointment']>, organization: ResolversParentTypes['Organization'], patient: ResolversParentTypes['Patient'], questionnaires: Array<ResolversParentTypes['QuestionnaireSheetAnswer']>, unreadOrganizationNotifications: Array<ResolversParentTypes['OrganizationNotification']> };
  DraftAppointmentPage: Omit<DraftAppointmentPage, 'nodes'> & { nodes: Array<ResolversParentTypes['DraftAppointment']> };
  DumpOrganizationsInput: DumpOrganizationsInput;
  DumpOrganizationsPayload: Omit<DumpOrganizationsPayload, 'organizationImportJobInformation'> & { organizationImportJobInformation: ResolversParentTypes['OrganizationImportJobInformation'] };
  EditDirectVisitorInput: EditDirectVisitorInput;
  EditDirectVisitorPayload: Omit<EditDirectVisitorPayload, 'directVisitor'> & { directVisitor: ResolversParentTypes['DirectVisitor'] };
  Encounter: Omit<Encounter, 'appointment'> & { appointment: ResolversParentTypes['Appointment'] };
  Event: ResolversUnionTypes<ResolversParentTypes>['Event'];
  EventPage: Omit<EventPage, 'nodes'> & { nodes: Array<ResolversParentTypes['Event']> };
  ExtendCompanySetupDocumentInput: ExtendCompanySetupDocumentInput;
  ExtendCompanySetupDocumentPayload: ExtendCompanySetupDocumentPayload;
  Extension: Extension;
  FaximoSendFax: Omit<FaximoSendFax, 'organization' | 'practitioner' | 'tracingReport'> & { organization: ResolversParentTypes['Organization'], practitioner: ResolversParentTypes['Practitioner'], tracingReport?: Maybe<ResolversParentTypes['TracingReport']> };
  FaximoSendFaxPage: Omit<FaximoSendFaxPage, 'nodes'> & { nodes: Array<ResolversParentTypes['FaximoSendFax']> };
  Feature: Feature;
  FeatureTarget: ResolversUnionTypes<ResolversParentTypes>['FeatureTarget'];
  FeatureTargetGroup: FeatureTargetGroup;
  FeatureUsage: Omit<FeatureUsage, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  FeatureUsagePage: Omit<FeatureUsagePage, 'nodes'> & { nodes: Array<ResolversParentTypes['FeatureUsage']> };
  FeeSetting: ResolversUnionTypes<ResolversParentTypes>['FeeSetting'];
  FeeSettingPage: Omit<FeeSettingPage, 'nodes'> & { nodes: Array<ResolversParentTypes['FeeSetting']> };
  FetchMedixsReceptionInput: FetchMedixsReceptionInput;
  FetchMedixsReceptionPayload: Omit<FetchMedixsReceptionPayload, 'medixsReceptions'> & { medixsReceptions: Array<ResolversParentTypes['MedixsReception']> };
  FinalizeDeliveryOutputInput: FinalizeDeliveryOutputInput;
  FinalizeDeliveryOutputPayload: Omit<FinalizeDeliveryOutputPayload, 'appointments'> & { appointments: Array<ResolversParentTypes['Appointment']> };
  FinishAppointmentInput: FinishAppointmentInput;
  FinishAppointmentPayload: Omit<FinishAppointmentPayload, 'appointment'> & { appointment: ResolversParentTypes['Appointment'] };
  FinishCheckinEntryInput: FinishCheckinEntryInput;
  FinishCheckinEntryPayload: Omit<FinishCheckinEntryPayload, 'checkinEntries' | 'checkinEntry'> & { checkinEntries?: Maybe<Array<ResolversParentTypes['CheckinEntry']>>, checkinEntry?: Maybe<ResolversParentTypes['CheckinEntry']> };
  FinishDraftAppointmentInput: FinishDraftAppointmentInput;
  FinishDraftAppointmentPayload: Omit<FinishDraftAppointmentPayload, 'draftAppointment'> & { draftAppointment: ResolversParentTypes['DraftAppointment'] };
  FinishEncounterInput: FinishEncounterInput;
  FinishEncounterPayload: Omit<FinishEncounterPayload, 'encounter'> & { encounter: ResolversParentTypes['Encounter'] };
  FinishOutpatientQuestionnaireEntryInput: FinishOutpatientQuestionnaireEntryInput;
  FinishOutpatientQuestionnaireEntryPayload: Omit<FinishOutpatientQuestionnaireEntryPayload, 'outpatientQuestionnaireEntry'> & { outpatientQuestionnaireEntry: ResolversParentTypes['OutpatientQuestionnaireEntry'] };
  Float: Scalars['Float']['output'];
  FulfillAppointmentInput: FulfillAppointmentInput;
  FulfillAppointmentPayload: Omit<FulfillAppointmentPayload, 'encounter'> & { encounter: ResolversParentTypes['Encounter'] };
  GendaApiKey: GendaApiKey;
  GendaApiKeyData: GendaApiKeyData;
  GendaSetting: Omit<GendaSetting, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  GendaSettingPage: Omit<GendaSettingPage, 'nodes'> & { nodes: Array<ResolversParentTypes['GendaSetting']> };
  GenerateAgentArtifactInput: GenerateAgentArtifactInput;
  GenerateAgentArtifactPayload: GenerateAgentArtifactPayload;
  GenerateBookmarkedPatientsCountCsvInput: GenerateBookmarkedPatientsCountCsvInput;
  GenerateBookmarkedPatientsCountCsvPayload: GenerateBookmarkedPatientsCountCsvPayload;
  GenerateClientCertCsvInput: GenerateClientCertCsvInput;
  GenerateClientCertCsvPayload: GenerateClientCertCsvPayload;
  GenerateCompanyMedicationFollowupMessageUsagesCsvInput: GenerateCompanyMedicationFollowupMessageUsagesCsvInput;
  GenerateCompanyMedicationFollowupMessageUsagesCsvPayload: GenerateCompanyMedicationFollowupMessageUsagesCsvPayload;
  GenerateCompanyOrganizationsAppDownloadUrlsCsvInput: GenerateCompanyOrganizationsAppDownloadUrlsCsvInput;
  GenerateCompanyOrganizationsAppDownloadUrlsCsvPayload: GenerateCompanyOrganizationsAppDownloadUrlsCsvPayload;
  GenerateCompanyReceptionUsagesCsvInput: GenerateCompanyReceptionUsagesCsvInput;
  GenerateCompanyReceptionUsagesCsvPayload: GenerateCompanyReceptionUsagesCsvPayload;
  GenerateCompanyReceptionsCsvInput: GenerateCompanyReceptionsCsvInput;
  GenerateCompanyReceptionsCsvPayload: GenerateCompanyReceptionsCsvPayload;
  GenerateCompanySalesDetailsCsvInput: GenerateCompanySalesDetailsCsvInput;
  GenerateCompanySalesDetailsCsvPayload: GenerateCompanySalesDetailsCsvPayload;
  GenerateCompanyTracingReportUsagesCsvInput: GenerateCompanyTracingReportUsagesCsvInput;
  GenerateCompanyTracingReportUsagesCsvPayload: GenerateCompanyTracingReportUsagesCsvPayload;
  GenerateCsvForClientCertsImportInput: GenerateCsvForClientCertsImportInput;
  GenerateCsvForClientCertsImportPayload: GenerateCsvForClientCertsImportPayload;
  GenerateCsvForMessageTemplatesBulkDuplicateInput: GenerateCsvForMessageTemplatesBulkDuplicateInput;
  GenerateCsvForMessageTemplatesBulkDuplicatePayload: GenerateCsvForMessageTemplatesBulkDuplicatePayload;
  GenerateCsvForUberOrganizationSettingsUpsertInput: GenerateCsvForUberOrganizationSettingsUpsertInput;
  GenerateCsvForUberOrganizationSettingsUpsertPayload: GenerateCsvForUberOrganizationSettingsUpsertPayload;
  GenerateDeliveryCsvInput: GenerateDeliveryCsvInput;
  GenerateDeliveryCsvPayload: Omit<GenerateDeliveryCsvPayload, 'appointments'> & { appointments: Array<ResolversParentTypes['Appointment']> };
  GenerateIncentivePayoutNotificationInput: GenerateIncentivePayoutNotificationInput;
  GenerateIncentivePayoutNotificationPayload: GenerateIncentivePayoutNotificationPayload;
  GenerateOrganizationAuditEventCsvInput: GenerateOrganizationAuditEventCsvInput;
  GenerateOrganizationAuditEventCsvPayload: GenerateOrganizationAuditEventCsvPayload;
  GeneratePayoutOrganizationsWithBankAccountCsvInput: GeneratePayoutOrganizationsWithBankAccountCsvInput;
  GeneratePayoutOrganizationsWithBankAccountCsvPayload: GeneratePayoutOrganizationsWithBankAccountCsvPayload;
  GenerateUberSignaturePreviewFormDataInput: GenerateUberSignaturePreviewFormDataInput;
  GenerateUberSignaturePreviewFormDataPayload: GenerateUberSignaturePreviewFormDataPayload;
  GenerateUberSignaturePreviewInput: GenerateUberSignaturePreviewInput;
  GenerateUberSignaturePreviewOnlyExtraTextInput: GenerateUberSignaturePreviewOnlyExtraTextInput;
  GenerateUberSignaturePreviewOnlyExtraTextPayload: GenerateUberSignaturePreviewOnlyExtraTextPayload;
  GenerateUberSignaturePreviewPayload: GenerateUberSignaturePreviewPayload;
  GuestPatient: ResolversUnionTypes<ResolversParentTypes>['GuestPatient'];
  GuestPatientMedicationFollowupComment: Omit<GuestPatientMedicationFollowupComment, 'practitioner'> & { practitioner: ResolversParentTypes['Practitioner'] };
  GuestPatientMedicationFollowupCommentPage: GuestPatientMedicationFollowupCommentPage;
  HiccupAppointmentPermission: Omit<HiccupAppointmentPermission, 'appointment'> & { appointment: ResolversParentTypes['Appointment'] };
  HiccupOnetimeApiCache: Omit<HiccupOnetimeApiCache, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  HiccupOnetimeApiCachePatientProfile: HiccupOnetimeApiCachePatientProfile;
  HiccupTemporaryPermission: Omit<HiccupTemporaryPermission, 'organization' | 'patient'> & { organization: ResolversParentTypes['Organization'], patient?: Maybe<ResolversParentTypes['Patient']> };
  HiccupTemporaryPermissionPage: Omit<HiccupTemporaryPermissionPage, 'nodes'> & { nodes: Array<ResolversParentTypes['HiccupTemporaryPermission']> };
  Holiday: Holiday;
  ID: Scalars['ID']['output'];
  ISO8601Date: Scalars['ISO8601Date']['output'];
  ISO8601DateTime: Scalars['ISO8601DateTime']['output'];
  IdentifyMedixsPatientInput: IdentifyMedixsPatientInput;
  IdentifyMedixsPatientPayload: Omit<IdentifyMedixsPatientPayload, 'medixsPatient' | 'medixsReception'> & { medixsPatient: ResolversParentTypes['MedixsPatient'], medixsReception: ResolversParentTypes['MedixsReception'] };
  IdentifyMedixsReceptionInput: IdentifyMedixsReceptionInput;
  IdentifyMedixsReceptionPayload: Omit<IdentifyMedixsReceptionPayload, 'medixsReception'> & { medixsReception: ResolversParentTypes['MedixsReception'] };
  ImportClientCertsInput: ImportClientCertsInput;
  ImportClientCertsPayload: ImportClientCertsPayload;
  ImportOrganizationsInput: ImportOrganizationsInput;
  ImportOrganizationsPayload: Omit<ImportOrganizationsPayload, 'organizationImportJobInformation'> & { organizationImportJobInformation: ResolversParentTypes['OrganizationImportJobInformation'] };
  ImportUberOrganizationsCsvInput: ImportUberOrganizationsCsvInput;
  ImportUberOrganizationsCsvPayload: ImportUberOrganizationsCsvPayload;
  Int: Scalars['Int']['output'];
  InvitationCode: Omit<InvitationCode, 'appointment'> & { appointment?: Maybe<ResolversParentTypes['Appointment']> };
  InvitationCodePage: Omit<InvitationCodePage, 'nodes'> & { nodes: Array<ResolversParentTypes['InvitationCode']> };
  Invoice: Invoice;
  IssueGendaApiKeyInput: IssueGendaApiKeyInput;
  IssueGendaApiKeyPayload: IssueGendaApiKeyPayload;
  JSON: Scalars['JSON']['output'];
  LineItem: LineItem;
  LineItemType: LineItemType;
  LoginUser: ResolversUnionTypes<ResolversParentTypes>['LoginUser'];
  MarkAnnouncementInput: MarkAnnouncementInput;
  MarkAnnouncementPayload: MarkAnnouncementPayload;
  MarkHiccupTemporaryPermissionInput: MarkHiccupTemporaryPermissionInput;
  MarkHiccupTemporaryPermissionPayload: Omit<MarkHiccupTemporaryPermissionPayload, 'hiccupTemporaryPermission'> & { hiccupTemporaryPermission: ResolversParentTypes['HiccupTemporaryPermission'] };
  MarkOrganizationNotificationByAppointmentInput: MarkOrganizationNotificationByAppointmentInput;
  MarkOrganizationNotificationByAppointmentPayload: Omit<MarkOrganizationNotificationByAppointmentPayload, 'organizationNotifications'> & { organizationNotifications: Array<ResolversParentTypes['OrganizationNotification']> };
  MarkOrganizationNotificationInput: MarkOrganizationNotificationInput;
  MarkOrganizationNotificationPayload: Omit<MarkOrganizationNotificationPayload, 'organizationNotification'> & { organizationNotification: ResolversParentTypes['OrganizationNotification'] };
  MedicalInstitutionSetting: Omit<MedicalInstitutionSetting, 'contactPoint' | 'organization'> & { contactPoint?: Maybe<ResolversParentTypes['ContactPoint']>, organization: ResolversParentTypes['Organization'] };
  MedicalInstitutionSettingPage: Omit<MedicalInstitutionSettingPage, 'nodes'> & { nodes: Array<ResolversParentTypes['MedicalInstitutionSetting']> };
  MedicationFollowupAutoReplySetting: Omit<MedicationFollowupAutoReplySetting, 'questionnaireRevision'> & { questionnaireRevision?: Maybe<ResolversParentTypes['MedicationFollowupQuestionnaireRevision']> };
  MedicationFollowupAutoReplySettingTemplate: Omit<MedicationFollowupAutoReplySettingTemplate, 'questionnaireRevision'> & { questionnaireRevision?: Maybe<ResolversParentTypes['MedicationFollowupQuestionnaireRevision']> };
  MedicationFollowupComment: ResolversUnionTypes<ResolversParentTypes>['MedicationFollowupComment'];
  MedicationFollowupCommentPage: Omit<MedicationFollowupCommentPage, 'nodes'> & { nodes: Array<ResolversParentTypes['MedicationFollowupComment']> };
  MedicationFollowupDraftMessage: Omit<MedicationFollowupDraftMessage, 'data' | 'guestPatient' | 'patient' | 'practitioner'> & { data: ResolversParentTypes['MedicationFollowupDraftMessageData'], guestPatient?: Maybe<ResolversParentTypes['GuestPatient']>, patient?: Maybe<ResolversParentTypes['Patient']>, practitioner: ResolversParentTypes['Practitioner'] };
  MedicationFollowupDraftMessageData: Omit<MedicationFollowupDraftMessageData, 'medicationFollowupQuestionnaire'> & { medicationFollowupQuestionnaire?: Maybe<ResolversParentTypes['MedicationFollowupQuestionnaire']> };
  MedicationFollowupDraftMessageDataInput: MedicationFollowupDraftMessageDataInput;
  MedicationFollowupDraftMessagePage: Omit<MedicationFollowupDraftMessagePage, 'nodes'> & { nodes: Array<ResolversParentTypes['MedicationFollowupDraftMessage']> };
  MedicationFollowupMessage: Omit<MedicationFollowupMessage, 'appointment' | 'autoReplySetting' | 'directVisitor' | 'medicationFollowupQuestionnaireRevision' | 'medicationFollowupQuestionnaireSheet' | 'messageDeliverResult' | 'patient' | 'practitioner' | 'webVisitor'> & { appointment?: Maybe<ResolversParentTypes['Appointment']>, autoReplySetting?: Maybe<ResolversParentTypes['MedicationFollowupAutoReplySetting']>, directVisitor?: Maybe<ResolversParentTypes['DirectVisitor']>, medicationFollowupQuestionnaireRevision?: Maybe<ResolversParentTypes['MedicationFollowupQuestionnaireRevision']>, medicationFollowupQuestionnaireSheet?: Maybe<ResolversParentTypes['MedicationFollowupQuestionnaireSheet']>, messageDeliverResult?: Maybe<ResolversParentTypes['MessageDeliverResult']>, patient?: Maybe<ResolversParentTypes['Patient']>, practitioner: ResolversParentTypes['Practitioner'], webVisitor?: Maybe<ResolversParentTypes['WebVisitor']> };
  MedicationFollowupMessagePage: Omit<MedicationFollowupMessagePage, 'nodes'> & { nodes: Array<ResolversParentTypes['MedicationFollowupMessage']> };
  MedicationFollowupMessageTemplate: Omit<MedicationFollowupMessageTemplate, 'autoReplySettingTemplate' | 'medicationFollowupQuestionnaire' | 'organization'> & { autoReplySettingTemplate?: Maybe<ResolversParentTypes['MedicationFollowupAutoReplySettingTemplate']>, medicationFollowupQuestionnaire?: Maybe<ResolversParentTypes['MedicationFollowupQuestionnaire']>, organization: ResolversParentTypes['Organization'] };
  MedicationFollowupMessageTemplateJobInformation: Omit<MedicationFollowupMessageTemplateJobInformation, 'sourceOrganization'> & { sourceOrganization: ResolversParentTypes['Organization'] };
  MedicationFollowupMessageTemplatePage: Omit<MedicationFollowupMessageTemplatePage, 'nodes'> & { nodes: Array<ResolversParentTypes['MedicationFollowupMessageTemplate']> };
  MedicationFollowupQuestionnaire: Omit<MedicationFollowupQuestionnaire, 'organization' | 'revision'> & { organization: ResolversParentTypes['Organization'], revision: ResolversParentTypes['MedicationFollowupQuestionnaireRevision'] };
  MedicationFollowupQuestionnaireChoice: MedicationFollowupQuestionnaireChoice;
  MedicationFollowupQuestionnaireChoiceInput: MedicationFollowupQuestionnaireChoiceInput;
  MedicationFollowupQuestionnaireCondition: MedicationFollowupQuestionnaireCondition;
  MedicationFollowupQuestionnaireConditionInput: MedicationFollowupQuestionnaireConditionInput;
  MedicationFollowupQuestionnaireFormData: MedicationFollowupQuestionnaireFormData;
  MedicationFollowupQuestionnaireFormDataInput: MedicationFollowupQuestionnaireFormDataInput;
  MedicationFollowupQuestionnairePage: Omit<MedicationFollowupQuestionnairePage, 'nodes'> & { nodes: Array<ResolversParentTypes['MedicationFollowupQuestionnaire']> };
  MedicationFollowupQuestionnaireQuestion: MedicationFollowupQuestionnaireQuestion;
  MedicationFollowupQuestionnaireQuestionInput: MedicationFollowupQuestionnaireQuestionInput;
  MedicationFollowupQuestionnaireRevision: Omit<MedicationFollowupQuestionnaireRevision, 'medicationFollowupQuestionnaire'> & { medicationFollowupQuestionnaire: ResolversParentTypes['MedicationFollowupQuestionnaire'] };
  MedicationFollowupQuestionnaireSection: MedicationFollowupQuestionnaireSection;
  MedicationFollowupQuestionnaireSectionInput: MedicationFollowupQuestionnaireSectionInput;
  MedicationFollowupQuestionnaireSheet: Omit<MedicationFollowupQuestionnaireSheet, 'answers' | 'appointment' | 'medicationFollowupMessage'> & { answers: Array<ResolversParentTypes['QuestionnaireSheetAnswer']>, appointment?: Maybe<ResolversParentTypes['Appointment']>, medicationFollowupMessage: ResolversParentTypes['MedicationFollowupMessage'] };
  MedicationFollowupQuestionnaireSheetPage: Omit<MedicationFollowupQuestionnaireSheetPage, 'nodes'> & { nodes: Array<ResolversParentTypes['MedicationFollowupQuestionnaireSheet']> };
  MedicationFollowupSetting: Omit<MedicationFollowupSetting, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  MedicationFollowupUsage: Omit<MedicationFollowupUsage, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  MedicationFollowupUsagePage: Omit<MedicationFollowupUsagePage, 'nodes'> & { nodes: Array<ResolversParentTypes['MedicationFollowupUsage']> };
  Medicine: Medicine;
  MedicineNote: MedicineNote;
  MedicineNoteClinic: MedicineNoteClinic;
  MedicineNoteClinicRecord: MedicineNoteClinicRecord;
  MedicineNoteDispensingDateRecord: MedicineNoteDispensingDateRecord;
  MedicineNoteDispensingPharmacy: MedicineNoteDispensingPharmacy;
  MedicineNoteDoctor: MedicineNoteDoctor;
  MedicineNoteDoctorRecord: MedicineNoteDoctorRecord;
  MedicineNoteDosage: MedicineNoteDosage;
  MedicineNoteDosageCaution: MedicineNoteDosageCaution;
  MedicineNoteDosageCautionRecord: MedicineNoteDosageCautionRecord;
  MedicineNoteDosagePlusRecord: MedicineNoteDosagePlusRecord;
  MedicineNoteDosageRecord: MedicineNoteDosageRecord;
  MedicineNoteMedicine: MedicineNoteMedicine;
  MedicineNoteMedicineCautionRecord: MedicineNoteMedicineCautionRecord;
  MedicineNoteMedicinePlusRecord: MedicineNoteMedicinePlusRecord;
  MedicineNoteMedicineRecord: MedicineNoteMedicineRecord;
  MedicineNoteNotebookMemo: MedicineNoteNotebookMemo;
  MedicineNoteNotebookMemoRecord: MedicineNoteNotebookMemoRecord;
  MedicineNoteOtcDrugDosage: MedicineNoteOtcDrugDosage;
  MedicineNoteOtcDrugDosageRecord: MedicineNoteOtcDrugDosageRecord;
  MedicineNoteOtcDrugIngredientRecord: MedicineNoteOtcDrugIngredientRecord;
  MedicineNotePatient: MedicineNotePatient;
  MedicineNotePatientProfile: MedicineNotePatientProfile;
  MedicineNotePatientRecord: MedicineNotePatientRecord;
  MedicineNotePatientReportRecord: MedicineNotePatientReportRecord;
  MedicineNotePharmacistRecord: MedicineNotePharmacistRecord;
  MedicineNotePharmacyRecord: MedicineNotePharmacyRecord;
  MedicineNotePrecaution: MedicineNotePrecaution;
  MedicineNotePrecautionRecord: MedicineNotePrecautionRecord;
  MedicineNotePrescription: MedicineNotePrescription;
  MedicineNotePrescriptionMemo: MedicineNotePrescriptionMemo;
  MedicineNotePrescriptionMemoRecord: MedicineNotePrescriptionMemoRecord;
  MedicineNotePrescriptionRecipe: MedicineNotePrescriptionRecipe;
  MedicineNotePrimaryPharmacist: MedicineNotePrimaryPharmacist;
  MedicineNotePrimaryPharmacistRecord: MedicineNotePrimaryPharmacistRecord;
  MedicineNoteRecipeInformation: MedicineNoteRecipeInformation;
  MedicineNoteRemaining: MedicineNoteRemaining;
  MedicineNoteRemainingRecord: MedicineNoteRemainingRecord;
  MedicineNoteRemark: MedicineNoteRemark;
  MedicineNoteRemarkRecord: MedicineNoteRemarkRecord;
  MedicineNoteSplitControl: MedicineNoteSplitControl;
  MedicineNoteSplitControlRecord: MedicineNoteSplitControlRecord;
  MedicineNoteVersion: MedicineNoteVersion;
  MedicineNoteVersionRecord: MedicineNoteVersionRecord;
  MedicineNoteWarning: MedicineNoteWarning;
  MedicineNoteWarningRecord: MedicineNoteWarningRecord;
  MedicineNotesByOnetimeCode: MedicineNotesByOnetimeCode;
  MedicineNotesByPatient: MedicineNotesByPatient;
  MedicinePage: MedicinePage;
  MedixsDispensingRecord: MedixsDispensingRecord;
  MedixsEvent: MedixsEvent;
  MedixsEventPage: MedixsEventPage;
  MedixsPatient: Omit<MedixsPatient, 'events' | 'guestPatients' | 'latestAppointment' | 'latestQuestionnaireSheet' | 'medicationFollowupComments' | 'medicationFollowupDraftMessage' | 'patient' | 'tracingReportDraft'> & { events: ResolversParentTypes['EventPage'], guestPatients: Array<ResolversParentTypes['GuestPatient']>, latestAppointment?: Maybe<ResolversParentTypes['Appointment']>, latestQuestionnaireSheet?: Maybe<ResolversParentTypes['MedixsPatientQuestionnaireSheet']>, medicationFollowupComments: ResolversParentTypes['MedicationFollowupCommentPage'], medicationFollowupDraftMessage?: Maybe<ResolversParentTypes['MedicationFollowupDraftMessage']>, patient?: Maybe<ResolversParentTypes['Patient']>, tracingReportDraft?: Maybe<ResolversParentTypes['TracingReportDraft']> };
  MedixsPatientPage: Omit<MedixsPatientPage, 'nodes'> & { nodes: Array<ResolversParentTypes['MedixsPatient']> };
  MedixsPatientQuestionnaireSheet: ResolversUnionTypes<ResolversParentTypes>['MedixsPatientQuestionnaireSheet'];
  MedixsReception: Omit<MedixsReception, 'medixsDispensingRecord' | 'medixsPatient'> & { medixsDispensingRecord?: Maybe<ResolversParentTypes['MedixsDispensingRecord']>, medixsPatient: ResolversParentTypes['MedixsPatient'] };
  MedixsReceptionPage: Omit<MedixsReceptionPage, 'nodes'> & { nodes: Array<ResolversParentTypes['MedixsReception']> };
  MedixsReceptionPrescription: MedixsReceptionPrescription;
  MedixsSetting: Omit<MedixsSetting, 'medixsPatients' | 'medixsReceptions' | 'organization'> & { medixsPatients: ResolversParentTypes['MedixsPatientPage'], medixsReceptions: ResolversParentTypes['MedixsReceptionPage'], organization: ResolversParentTypes['Organization'] };
  MessageDeliver: Omit<MessageDeliver, 'patient' | 'practitioner'> & { patient: ResolversParentTypes['Patient'], practitioner: ResolversParentTypes['Practitioner'] };
  MessageDeliverResult: Omit<MessageDeliverResult, 'guestPatient' | 'organization' | 'patient' | 'practitioner'> & { guestPatient?: Maybe<ResolversParentTypes['GuestPatient']>, organization: ResolversParentTypes['Organization'], patient?: Maybe<ResolversParentTypes['Patient']>, practitioner: ResolversParentTypes['Practitioner'] };
  MessageDeliverResultPage: Omit<MessageDeliverResultPage, 'nodes'> & { nodes: Array<ResolversParentTypes['MessageDeliverResult']> };
  MonthlyPayoutStatement: MonthlyPayoutStatement;
  MonthlyPayoutStatementPage: MonthlyPayoutStatementPage;
  Mutation: {};
  Node: ResolversInterfaceTypes<ResolversParentTypes>['Node'];
  NotificationSettingData: NotificationSettingData;
  NotificationSettingSound: NotificationSettingSound;
  NotificationSettingTel: NotificationSettingTel;
  NotifyCheckinEntryInput: NotifyCheckinEntryInput;
  NotifyCheckinEntryPayload: Omit<NotifyCheckinEntryPayload, 'checkinEntry'> & { checkinEntry: ResolversParentTypes['CheckinEntry'] };
  NotifyOutpatientQuestionnaireEntryInput: NotifyOutpatientQuestionnaireEntryInput;
  NotifyOutpatientQuestionnaireEntryPayload: Omit<NotifyOutpatientQuestionnaireEntryPayload, 'outpatientQuestionnaireEntry'> & { outpatientQuestionnaireEntry: ResolversParentTypes['OutpatientQuestionnaireEntry'] };
  Operator: Operator;
  OperatorAccessPermission: OperatorAccessPermission;
  OperatorRole: OperatorRole;
  Organization: Omit<Organization, 'adminPractitioners' | 'allPatients' | 'appointments' | 'b2cloudSetting' | 'bankAccount' | 'bookmarkedPatients' | 'chargeHistories' | 'checkinEntries' | 'checkinSetting' | 'clientCerts' | 'company' | 'companyCommonSetting' | 'dailySalesDetail' | 'directVisitorCandidates' | 'directVisitors' | 'disclosedMedicineNotes' | 'faximoSendFaxes' | 'featureUsages' | 'feeSettings' | 'hiccupTemporaryPermissions' | 'invitationCodes' | 'medicalInstitutionSetting' | 'medicalInstitutionSettings' | 'medicationFollowupMessageTemplates' | 'medicationFollowupMessages' | 'medicationFollowupQuestionnaireSheets' | 'medicationFollowupQuestionnaires' | 'medicationFollowupSetting' | 'medixsSetting' | 'notificationSetting' | 'organizationAddresses' | 'organizationContactPoints' | 'organizationNotifications' | 'patients' | 'payoutOrganizations' | 'pharmacistPractitioners' | 'practitionerAuthentications' | 'receptions' | 'unreadOrganizationNotifications'> & { adminPractitioners: Array<ResolversParentTypes['Practitioner']>, allPatients: ResolversParentTypes['AllPatientPage'], appointments: ResolversParentTypes['AppointmentPage'], b2cloudSetting?: Maybe<ResolversParentTypes['B2cloudSetting']>, bankAccount?: Maybe<ResolversParentTypes['BankAccount']>, bookmarkedPatients: ResolversParentTypes['PatientPage'], chargeHistories: ResolversParentTypes['ChargeHistoryPage'], checkinEntries: ResolversParentTypes['CheckinEntryPage'], checkinSetting?: Maybe<ResolversParentTypes['CheckinSetting']>, clientCerts: ResolversParentTypes['ClientCertPage'], company: ResolversParentTypes['Company'], companyCommonSetting?: Maybe<ResolversParentTypes['CompanyCommonSetting']>, dailySalesDetail: ResolversParentTypes['OrganizationDailySalesDetail'], directVisitorCandidates: ResolversParentTypes['DirectVisitorCandidatePage'], directVisitors: ResolversParentTypes['DirectVisitorPage'], disclosedMedicineNotes: ResolversParentTypes['DisclosedMedicineNotePage'], faximoSendFaxes: ResolversParentTypes['FaximoSendFaxPage'], featureUsages: ResolversParentTypes['FeatureUsagePage'], feeSettings: ResolversParentTypes['FeeSettingPage'], hiccupTemporaryPermissions: ResolversParentTypes['HiccupTemporaryPermissionPage'], invitationCodes: ResolversParentTypes['InvitationCodePage'], medicalInstitutionSetting?: Maybe<ResolversParentTypes['MedicalInstitutionSetting']>, medicalInstitutionSettings: ResolversParentTypes['MedicalInstitutionSettingPage'], medicationFollowupMessageTemplates: ResolversParentTypes['MedicationFollowupMessageTemplatePage'], medicationFollowupMessages: ResolversParentTypes['MedicationFollowupMessagePage'], medicationFollowupQuestionnaireSheets: ResolversParentTypes['MedicationFollowupQuestionnaireSheetPage'], medicationFollowupQuestionnaires: ResolversParentTypes['MedicationFollowupQuestionnairePage'], medicationFollowupSetting?: Maybe<ResolversParentTypes['MedicationFollowupSetting']>, medixsSetting?: Maybe<ResolversParentTypes['MedixsSetting']>, notificationSetting?: Maybe<ResolversParentTypes['OrganizationNotificationSetting']>, organizationAddresses: Array<ResolversParentTypes['OrganizationAddress']>, organizationContactPoints: Array<ResolversParentTypes['OrganizationContactPoint']>, organizationNotifications: ResolversParentTypes['OrganizationNotificationPage'], patients: ResolversParentTypes['PatientConnection'], payoutOrganizations: ResolversParentTypes['PayoutOrganizationPage'], pharmacistPractitioners: Array<ResolversParentTypes['Practitioner']>, practitionerAuthentications: Array<ResolversParentTypes['PractitionerAuthentication']>, receptions: ResolversParentTypes['ReceptionPage'], unreadOrganizationNotifications: ResolversParentTypes['OrganizationNotificationPage'] };
  OrganizationAddress: Omit<OrganizationAddress, 'address'> & { address: ResolversParentTypes['Address'] };
  OrganizationCompanyFeeSetting: OrganizationCompanyFeeSetting;
  OrganizationContactPoint: Omit<OrganizationContactPoint, 'contactPoint'> & { contactPoint: ResolversParentTypes['ContactPoint'] };
  OrganizationDailySales: Omit<OrganizationDailySales, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  OrganizationDailySalesDetail: Omit<OrganizationDailySalesDetail, 'appBillingAmountDetail' | 'appShippingFeeDetail' | 'appUberDeliveryFeeDetail' | 'cashBillingAmountDetail' | 'cashShippingFeeDetail' | 'organizationDailySales' | 'refundHistories'> & { appBillingAmountDetail: Array<ResolversParentTypes['SubjectTotalAmount']>, appShippingFeeDetail: Array<ResolversParentTypes['SubjectTotalAmount']>, appUberDeliveryFeeDetail: Array<ResolversParentTypes['SubjectTotalAmount']>, cashBillingAmountDetail: Array<ResolversParentTypes['SubjectTotalAmount']>, cashShippingFeeDetail: Array<ResolversParentTypes['SubjectTotalAmount']>, organizationDailySales: ResolversParentTypes['OrganizationDailySales'], refundHistories?: Maybe<Array<ResolversParentTypes['RefundHistory']>> };
  OrganizationDailySalesPage: Omit<OrganizationDailySalesPage, 'nodes'> & { nodes: Array<ResolversParentTypes['OrganizationDailySales']> };
  OrganizationFeeSetting: Omit<OrganizationFeeSetting, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  OrganizationImportJobInformation: Omit<OrganizationImportJobInformation, 'company' | 'practitioner'> & { company?: Maybe<ResolversParentTypes['Company']>, practitioner?: Maybe<ResolversParentTypes['Practitioner']> };
  OrganizationImportJobInformationConnection: Omit<OrganizationImportJobInformationConnection, 'edges' | 'nodes'> & { edges?: Maybe<Array<Maybe<ResolversParentTypes['OrganizationImportJobInformationEdge']>>>, nodes?: Maybe<Array<Maybe<ResolversParentTypes['OrganizationImportJobInformation']>>> };
  OrganizationImportJobInformationEdge: Omit<OrganizationImportJobInformationEdge, 'node'> & { node?: Maybe<ResolversParentTypes['OrganizationImportJobInformation']> };
  OrganizationNotification: Omit<OrganizationNotification, 'appointment' | 'checkinEntry' | 'draftAppointment' | 'faximoSendFax' | 'medicationFollowupMessage' | 'organization' | 'outpatientQuestionnaireEntry'> & { appointment?: Maybe<ResolversParentTypes['Appointment']>, checkinEntry?: Maybe<ResolversParentTypes['CheckinEntry']>, draftAppointment?: Maybe<ResolversParentTypes['DraftAppointment']>, faximoSendFax?: Maybe<ResolversParentTypes['FaximoSendFax']>, medicationFollowupMessage?: Maybe<ResolversParentTypes['MedicationFollowupMessage']>, organization: ResolversParentTypes['Organization'], outpatientQuestionnaireEntry?: Maybe<ResolversParentTypes['OutpatientQuestionnaireEntry']> };
  OrganizationNotificationPage: Omit<OrganizationNotificationPage, 'nodes'> & { nodes: Array<ResolversParentTypes['OrganizationNotification']> };
  OrganizationNotificationSetting: Omit<OrganizationNotificationSetting, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  OrganizationPage: Omit<OrganizationPage, 'nodes'> & { nodes: Array<ResolversParentTypes['Organization']> };
  OutpatientQuestionnaire: OutpatientQuestionnaire;
  OutpatientQuestionnaireEntry: Omit<OutpatientQuestionnaireEntry, 'address' | 'directVisitor' | 'organization' | 'unreadOrganizationNotifications'> & { address: ResolversParentTypes['Address'], directVisitor: ResolversParentTypes['DirectVisitor'], organization: ResolversParentTypes['Organization'], unreadOrganizationNotifications: Array<ResolversParentTypes['OrganizationNotification']> };
  OutpatientQuestionnaireOrganization: OutpatientQuestionnaireOrganization;
  OutpatientQuestionnaireQuestion: OutpatientQuestionnaireQuestion;
  OutpatientQuestionnaireQuestionInput: OutpatientQuestionnaireQuestionInput;
  OutpatientQuestionnaireSetting: OutpatientQuestionnaireSetting;
  OutpatientQuestionnaireSettingQuestionnaire: OutpatientQuestionnaireSettingQuestionnaire;
  OutpatientQuestionnaireSheetAnswer: OutpatientQuestionnaireSheetAnswer;
  PageInfo: PageInfo;
  Patient: Omit<Patient, 'appointments' | 'bookmark' | 'draftAppointments' | 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'questionnaireSheet' | 'questionnaires' | 'tracingReportDrafts' | 'tracingReports'> & { appointments: ResolversParentTypes['AppointmentPage'], bookmark?: Maybe<ResolversParentTypes['Bookmark']>, draftAppointments: ResolversParentTypes['DraftAppointmentPage'], medicationFollowupDraftMessages: ResolversParentTypes['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: ResolversParentTypes['MedicationFollowupMessagePage'], medixsPatient?: Maybe<ResolversParentTypes['MedixsPatient']>, messageDeliverResults: ResolversParentTypes['MessageDeliverResultPage'], questionnaireSheet?: Maybe<ResolversParentTypes['QuestionnaireSheet']>, questionnaires?: Maybe<Array<ResolversParentTypes['QuestionnaireSheetAnswer']>>, tracingReportDrafts: ResolversParentTypes['TracingReportDraftPage'], tracingReports: ResolversParentTypes['TracingReportPage'] };
  PatientAttachment: PatientAttachment;
  PatientAttachmentPage: PatientAttachmentPage;
  PatientConnection: Omit<PatientConnection, 'edges' | 'nodes'> & { edges?: Maybe<Array<Maybe<ResolversParentTypes['PatientEdge']>>>, nodes?: Maybe<Array<Maybe<ResolversParentTypes['Patient']>>> };
  PatientEdge: Omit<PatientEdge, 'node'> & { node?: Maybe<ResolversParentTypes['Patient']> };
  PatientMedicationFollowupComment: Omit<PatientMedicationFollowupComment, 'practitioner'> & { practitioner: ResolversParentTypes['Practitioner'] };
  PatientMedicationFollowupCommentPage: PatientMedicationFollowupCommentPage;
  PatientPage: Omit<PatientPage, 'nodes'> & { nodes: Array<ResolversParentTypes['Patient']> };
  Payout: Omit<Payout, 'company' | 'payoutOrganizations'> & { company?: Maybe<ResolversParentTypes['Company']>, payoutOrganizations: ResolversParentTypes['PayoutOrganizationPage'] };
  PayoutBankAccount: Omit<PayoutBankAccount, 'payoutOrganization'> & { payoutOrganization?: Maybe<ResolversParentTypes['PayoutOrganization']> };
  PayoutOrganization: Omit<PayoutOrganization, 'organization' | 'payout' | 'payoutBankAccount' | 'payoutSubjects'> & { organization?: Maybe<ResolversParentTypes['Organization']>, payout?: Maybe<ResolversParentTypes['Payout']>, payoutBankAccount?: Maybe<ResolversParentTypes['PayoutBankAccount']>, payoutSubjects: Array<ResolversParentTypes['PayoutSubject']> };
  PayoutOrganizationPage: Omit<PayoutOrganizationPage, 'nodes'> & { nodes: Array<ResolversParentTypes['PayoutOrganization']> };
  PayoutPage: Omit<PayoutPage, 'nodes'> & { nodes: Array<ResolversParentTypes['Payout']> };
  PayoutSubject: Omit<PayoutSubject, 'payoutOrganization'> & { payoutOrganization?: Maybe<ResolversParentTypes['PayoutOrganization']> };
  PfAddress: PfAddress;
  PfAttachment: PfAttachment;
  PfContactPoint: PfContactPoint;
  PfDispensingRequest: PfDispensingRequest;
  PfDispensingRequestMedicalInstitution: PfDispensingRequestMedicalInstitution;
  PfDispensingRequestMedicalInstitutionConsultation: PfDispensingRequestMedicalInstitutionConsultation;
  PfDispensingRequestMedicalInstitutionMedicalInstitution: PfDispensingRequestMedicalInstitutionMedicalInstitution;
  PfDispensingRequestMedicalInstitutionPhysician: PfDispensingRequestMedicalInstitutionPhysician;
  PfDispensingRequestMedicalInstitutionPrescription: PfDispensingRequestMedicalInstitutionPrescription;
  PfDispensingRequestPharmacy: PfDispensingRequestPharmacy;
  PfDispensingRequestPharmacyDispensing: PfDispensingRequestPharmacyDispensing;
  PfDispensingRequestPharmacyPharmacist: PfDispensingRequestPharmacyPharmacist;
  PfDispensingRequestPharmacyPharmacy: PfDispensingRequestPharmacyPharmacy;
  PfInsuranceCard: PfInsuranceCard;
  PfInsuranceCards: PfInsuranceCards;
  PfPatient: PfPatient;
  PfPrescriptionImage: PfPrescriptionImage;
  Plan: Omit<Plan, 'extensions'> & { extensions: Array<ResolversParentTypes['Extension']> };
  PlanFeature: PlanFeature;
  PostalCode: PostalCode;
  PostalCodePage: PostalCodePage;
  Practitioner: Omit<Practitioner, 'authentication' | 'organization' | 'signinHistory'> & { authentication: ResolversParentTypes['PractitionerAuthentication'], organization: ResolversParentTypes['Organization'], signinHistory?: Maybe<ResolversParentTypes['PractitionerSigninHistory']> };
  PractitionerAuthentication: PractitionerAuthentication;
  PractitionerOtpSecret: PractitionerOtpSecret;
  PractitionerPage: Omit<PractitionerPage, 'nodes'> & { nodes: Array<ResolversParentTypes['Practitioner']> };
  PractitionerSigninHistory: Omit<PractitionerSigninHistory, 'practitioner'> & { practitioner: ResolversParentTypes['Practitioner'] };
  PrintPrescriptionSetting: PrintPrescriptionSetting;
  PrivilegeOrganization: PrivilegeOrganization;
  PrivilegeOrganizationPractitioner: PrivilegeOrganizationPractitioner;
  PublicAddress: PublicAddress;
  PublicAppointment: PublicAppointment;
  PublicCheckinEntry: Omit<PublicCheckinEntry, 'checkinOrganization'> & { checkinOrganization: ResolversParentTypes['CheckinOrganization'] };
  PublicMedicationFollowupMessage: PublicMedicationFollowupMessage;
  PublicMedicationFollowupQuestionnaireRevision: PublicMedicationFollowupQuestionnaireRevision;
  PublicMedicationFollowupQuestionnaireSheet: PublicMedicationFollowupQuestionnaireSheet;
  PublicOrganization: PublicOrganization;
  PublicOrganizationAddress: PublicOrganizationAddress;
  PublicOrganizationPage: PublicOrganizationPage;
  PublicOutpatientQuestionnaireEntry: PublicOutpatientQuestionnaireEntry;
  PublicSignupPfPatientInformation: PublicSignupPfPatientInformation;
  PublicSignupPfPatientInformationOrganization: PublicSignupPfPatientInformationOrganization;
  PublicSlot: PublicSlot;
  PublicWebBookingsSetting: PublicWebBookingsSetting;
  QualifiedInvoice: QualifiedInvoice;
  Query: {};
  QuestionnaireSheet: Omit<QuestionnaireSheet, 'answers'> & { answers: Array<ResolversParentTypes['QuestionnaireSheetAnswer']> };
  QuestionnaireSheetAnswer: QuestionnaireSheetAnswer;
  QuestionnaireSheetAnswerInput: QuestionnaireSheetAnswerInput;
  Quote: Quote;
  Reception: ResolversUnionTypes<ResolversParentTypes>['Reception'];
  ReceptionPage: Omit<ReceptionPage, 'nodes'> & { nodes: Array<ResolversParentTypes['Reception']> };
  ReceptionUsage: Omit<ReceptionUsage, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  ReceptionUsagePage: Omit<ReceptionUsagePage, 'nodes'> & { nodes: Array<ResolversParentTypes['ReceptionUsage']> };
  RechargeWithAppInput: RechargeWithAppInput;
  RechargeWithAppPayload: Omit<RechargeWithAppPayload, 'charge'> & { charge: ResolversParentTypes['Charge'] };
  RechargeWithCashInput: RechargeWithCashInput;
  RechargeWithCashPayload: Omit<RechargeWithCashPayload, 'charge'> & { charge: ResolversParentTypes['Charge'] };
  RecreateTracingReportInput: RecreateTracingReportInput;
  RecreateTracingReportPayload: Omit<RecreateTracingReportPayload, 'tracingReport'> & { tracingReport: ResolversParentTypes['TracingReport'] };
  RefundHistory: Omit<RefundHistory, 'afterChargeHistory' | 'beforeChargeHistory' | 'patient' | 'refundedChargeHistory'> & { afterChargeHistory: ResolversParentTypes['ChargeHistory'], beforeChargeHistory: ResolversParentTypes['ChargeHistory'], patient: ResolversParentTypes['Patient'], refundedChargeHistory: ResolversParentTypes['ChargeHistory'] };
  RemandUberSignatureInput: RemandUberSignatureInput;
  RemandUberSignaturePayload: Omit<RemandUberSignaturePayload, 'uberSignature'> & { uberSignature: ResolversParentTypes['UberSignature'] };
  RemoveCompanyAddressInput: RemoveCompanyAddressInput;
  RemoveCompanyAddressPayload: Omit<RemoveCompanyAddressPayload, 'companyAddress'> & { companyAddress: ResolversParentTypes['CompanyAddress'] };
  RemoveCompanyContactPointInput: RemoveCompanyContactPointInput;
  RemoveCompanyContactPointPayload: Omit<RemoveCompanyContactPointPayload, 'companyContactPoint'> & { companyContactPoint: ResolversParentTypes['CompanyContactPoint'] };
  RemoveCompanySetupDocumentInput: RemoveCompanySetupDocumentInput;
  RemoveCompanySetupDocumentPayload: RemoveCompanySetupDocumentPayload;
  RemoveMedicalInstitutionSettingInput: RemoveMedicalInstitutionSettingInput;
  RemoveMedicalInstitutionSettingPayload: Omit<RemoveMedicalInstitutionSettingPayload, 'medicalInstitutionSetting'> & { medicalInstitutionSetting: ResolversParentTypes['MedicalInstitutionSetting'] };
  RemoveOrganizationContactPointInput: RemoveOrganizationContactPointInput;
  RemoveOrganizationContactPointPayload: Omit<RemoveOrganizationContactPointPayload, 'organizationContactPoint'> & { organizationContactPoint: ResolversParentTypes['OrganizationContactPoint'] };
  RemoveWebBookingsExceptionBusinessHourInput: RemoveWebBookingsExceptionBusinessHourInput;
  RemoveWebBookingsExceptionBusinessHourPayload: RemoveWebBookingsExceptionBusinessHourPayload;
  RequestAppointmentInput: RequestAppointmentInput;
  RequestAppointmentPayload: Omit<RequestAppointmentPayload, 'draftAppointment'> & { draftAppointment: ResolversParentTypes['DraftAppointment'] };
  ResendAuthenticationCodeInput: ResendAuthenticationCodeInput;
  ResendAuthenticationCodePayload: ResendAuthenticationCodePayload;
  RestartAgentInput: RestartAgentInput;
  RestartAgentPayload: RestartAgentPayload;
  ResumeWebBookingsInput: ResumeWebBookingsInput;
  ResumeWebBookingsPayload: ResumeWebBookingsPayload;
  RevokeClientCertInput: RevokeClientCertInput;
  RevokeClientCertPayload: Omit<RevokeClientCertPayload, 'clientCert'> & { clientCert: ResolversParentTypes['ClientCert'] };
  SendAuthenticationCodeAndRegisterPatientEmailInput: SendAuthenticationCodeAndRegisterPatientEmailInput;
  SendAuthenticationCodeAndRegisterPatientEmailPayload: SendAuthenticationCodeAndRegisterPatientEmailPayload;
  SendCallNotificationInput: SendCallNotificationInput;
  SendCallNotificationPayload: Omit<SendCallNotificationPayload, 'encounter'> & { encounter: ResolversParentTypes['Encounter'] };
  SendClientCertMailInput: SendClientCertMailInput;
  SendClientCertMailPayload: Omit<SendClientCertMailPayload, 'clientCert'> & { clientCert: ResolversParentTypes['ClientCert'] };
  SendCongestionNotificationForWebVisitorInput: SendCongestionNotificationForWebVisitorInput;
  SendCongestionNotificationForWebVisitorPayload: Omit<SendCongestionNotificationForWebVisitorPayload, 'messageDeliver'> & { messageDeliver: ResolversParentTypes['MessageDeliver'] };
  SendCongestionNotificationInput: SendCongestionNotificationInput;
  SendCongestionNotificationPayload: Omit<SendCongestionNotificationPayload, 'appointment'> & { appointment: ResolversParentTypes['Appointment'] };
  SendDispensingPreparedNotificationInput: SendDispensingPreparedNotificationInput;
  SendDispensingPreparedNotificationPayload: Omit<SendDispensingPreparedNotificationPayload, 'appointment'> & { appointment: ResolversParentTypes['Appointment'] };
  SendInvitationSmsInput: SendInvitationSmsInput;
  SendInvitationSmsPayload: SendInvitationSmsPayload;
  SendPractitionerCodeMailInput: SendPractitionerCodeMailInput;
  SendPractitionerCodeMailPayload: Omit<SendPractitionerCodeMailPayload, 'practitioner'> & { practitioner: ResolversParentTypes['Practitioner'] };
  SendTracingReportInput: SendTracingReportInput;
  SendTracingReportPayload: Omit<SendTracingReportPayload, 'faximoSendFax'> & { faximoSendFax: ResolversParentTypes['FaximoSendFax'] };
  SendgridEventActivity: SendgridEventActivity;
  SetPractitionerRoleInput: SetPractitionerRoleInput;
  SetPractitionerRolePayload: Omit<SetPractitionerRolePayload, 'practitioner'> & { practitioner: ResolversParentTypes['Practitioner'] };
  SigninHistory: SigninHistory;
  SignupCompanyInput: SignupCompanyInput;
  SignupCompanyPayload: Omit<SignupCompanyPayload, 'company' | 'organization' | 'practitioner'> & { company: ResolversParentTypes['Company'], organization: ResolversParentTypes['Organization'], practitioner: ResolversParentTypes['Practitioner'] };
  SignupPfPatientFromCheckinEntryInput: SignupPfPatientFromCheckinEntryInput;
  SignupPfPatientFromCheckinEntryPayload: SignupPfPatientFromCheckinEntryPayload;
  SignupPfPatientFromOutpatientQuestionnaireEntryAddressInput: SignupPfPatientFromOutpatientQuestionnaireEntryAddressInput;
  SignupPfPatientFromOutpatientQuestionnaireEntryInput: SignupPfPatientFromOutpatientQuestionnaireEntryInput;
  SignupPfPatientFromOutpatientQuestionnaireEntryPayload: SignupPfPatientFromOutpatientQuestionnaireEntryPayload;
  SkipEncounterInput: SkipEncounterInput;
  SkipEncounterPayload: Omit<SkipEncounterPayload, 'appointment'> & { appointment: ResolversParentTypes['Appointment'] };
  String: Scalars['String']['output'];
  SubjectTotalAmount: SubjectTotalAmount;
  SubscribeChannelInput: SubscribeChannelInput;
  SubscribeChannelPayload: SubscribeChannelPayload;
  SuspendWebBookingsInput: SuspendWebBookingsInput;
  SuspendWebBookingsPayload: SuspendWebBookingsPayload;
  TracingReport: Omit<TracingReport, 'data' | 'latestSentFax' | 'latestSentFaxByEvent' | 'organization'> & { data: ResolversParentTypes['TracingReportData'], latestSentFax?: Maybe<ResolversParentTypes['FaximoSendFax']>, latestSentFaxByEvent?: Maybe<ResolversParentTypes['FaximoSendFax']>, organization: ResolversParentTypes['Organization'] };
  TracingReportData: Omit<TracingReportData, 'medicalInstitutionSetting'> & { medicalInstitutionSetting?: Maybe<ResolversParentTypes['MedicalInstitutionSetting']> };
  TracingReportDraft: Omit<TracingReportDraft, 'guestPatient' | 'patient'> & { guestPatient?: Maybe<ResolversParentTypes['GuestPatient']>, patient?: Maybe<ResolversParentTypes['Patient']> };
  TracingReportDraftData: TracingReportDraftData;
  TracingReportDraftDataInput: TracingReportDraftDataInput;
  TracingReportDraftPage: Omit<TracingReportDraftPage, 'nodes'> & { nodes: Array<ResolversParentTypes['TracingReportDraft']> };
  TracingReportDraftPrescriptionDrug: TracingReportDraftPrescriptionDrug;
  TracingReportDraftPrescriptionDrugInput: TracingReportDraftPrescriptionDrugInput;
  TracingReportPage: Omit<TracingReportPage, 'nodes'> & { nodes: Array<ResolversParentTypes['TracingReport']> };
  TracingReportUsage: Omit<TracingReportUsage, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  TracingReportUsagePage: Omit<TracingReportUsagePage, 'nodes'> & { nodes: Array<ResolversParentTypes['TracingReportUsage']> };
  UberCourier: UberCourier;
  UberDelivery: Omit<UberDelivery, 'appointment' | 'practitioner'> & { appointment: ResolversParentTypes['Appointment'], practitioner: ResolversParentTypes['Practitioner'] };
  UberDeliveryInvoiceFee: UberDeliveryInvoiceFee;
  UberDeliveryInvoiceFeePage: UberDeliveryInvoiceFeePage;
  UberInvoice: UberInvoice;
  UberOrganization: UberOrganization;
  UberOrganizationImportJobInformation: UberOrganizationImportJobInformation;
  UberOrganizationSetting: UberOrganizationSetting;
  UberOrganizationSettingJobInformation: UberOrganizationSettingJobInformation;
  UberQuote: UberQuote;
  UberSignature: Omit<UberSignature, 'company'> & { company: ResolversParentTypes['Company'] };
  UberSignatureData: UberSignatureData;
  UberSignatureDataInput: UberSignatureDataInput;
  UberSignatureDraft: Omit<UberSignatureDraft, 'company'> & { company: ResolversParentTypes['Company'] };
  UberSignatureDraftData: UberSignatureDraftData;
  UberSignatureDraftDataInput: UberSignatureDraftDataInput;
  UnidentifyMedixsPatientInput: UnidentifyMedixsPatientInput;
  UnidentifyMedixsPatientPayload: Omit<UnidentifyMedixsPatientPayload, 'medixsPatient'> & { medixsPatient: ResolversParentTypes['MedixsPatient'] };
  UnidentifyMedixsReceptionInput: UnidentifyMedixsReceptionInput;
  UnidentifyMedixsReceptionPayload: Omit<UnidentifyMedixsReceptionPayload, 'medixsReception'> & { medixsReception: ResolversParentTypes['MedixsReception'] };
  UnpublishOrganizationInput: UnpublishOrganizationInput;
  UnpublishOrganizationPayload: Omit<UnpublishOrganizationPayload, 'organization'> & { organization: ResolversParentTypes['Organization'] };
  UnsubscribeChannelInput: UnsubscribeChannelInput;
  UnsubscribeChannelPayload: UnsubscribeChannelPayload;
  UpdateAdminPractitionerInput: UpdateAdminPractitionerInput;
  UpdateAgentDescriptionInput: UpdateAgentDescriptionInput;
  UpdateAgentDescriptionPayload: UpdateAgentDescriptionPayload;
  UpdateAnnouncementInput: UpdateAnnouncementInput;
  UpdateAnnouncementPayload: UpdateAnnouncementPayload;
  UpdateAppointmentDeliveryMethodInput: UpdateAppointmentDeliveryMethodInput;
  UpdateAppointmentDeliveryMethodPayload: Omit<UpdateAppointmentDeliveryMethodPayload, 'appointment'> & { appointment: ResolversParentTypes['Appointment'] };
  UpdateAppointmentDescriptionInput: UpdateAppointmentDescriptionInput;
  UpdateAppointmentDescriptionPayload: Omit<UpdateAppointmentDescriptionPayload, 'appointment'> & { appointment: ResolversParentTypes['Appointment'] };
  UpdateB2cloudSettingDataInput: UpdateB2cloudSettingDataInput;
  UpdateB2cloudSettingInput: UpdateB2cloudSettingInput;
  UpdateB2cloudSettingPayload: Omit<UpdateB2cloudSettingPayload, 'b2cloudSetting'> & { b2cloudSetting: ResolversParentTypes['B2cloudSetting'] };
  UpdateB2cloudSettingSenderDataInput: UpdateB2cloudSettingSenderDataInput;
  UpdateBankAccountInput: UpdateBankAccountInput;
  UpdateBankAccountPayload: Omit<UpdateBankAccountPayload, 'bankAccount'> & { bankAccount: ResolversParentTypes['BankAccount'] };
  UpdateCheckinDescriptionInput: UpdateCheckinDescriptionInput;
  UpdateCheckinDescriptionPayload: Omit<UpdateCheckinDescriptionPayload, 'checkinEntry'> & { checkinEntry: ResolversParentTypes['CheckinEntry'] };
  UpdateCheckinSettingInput: UpdateCheckinSettingInput;
  UpdateCheckinSettingPayload: Omit<UpdateCheckinSettingPayload, 'checkinSetting'> & { checkinSetting: ResolversParentTypes['CheckinSetting'] };
  UpdateCompanyAddressAddressInput: UpdateCompanyAddressAddressInput;
  UpdateCompanyAddressInput: UpdateCompanyAddressInput;
  UpdateCompanyAddressPayload: Omit<UpdateCompanyAddressPayload, 'companyAddress'> & { companyAddress: ResolversParentTypes['CompanyAddress'] };
  UpdateCompanyAgentSettingInput: UpdateCompanyAgentSettingInput;
  UpdateCompanyAgentSettingPayload: UpdateCompanyAgentSettingPayload;
  UpdateCompanyContactPointContactPointInput: UpdateCompanyContactPointContactPointInput;
  UpdateCompanyContactPointInput: UpdateCompanyContactPointInput;
  UpdateCompanyContactPointPayload: Omit<UpdateCompanyContactPointPayload, 'companyContactPoint'> & { companyContactPoint: ResolversParentTypes['CompanyContactPoint'] };
  UpdateCompanyFeeSettingInput: UpdateCompanyFeeSettingInput;
  UpdateCompanyFeeSettingPayload: Omit<UpdateCompanyFeeSettingPayload, 'companyFeeSetting'> & { companyFeeSetting: ResolversParentTypes['CompanyFeeSetting'] };
  UpdateCompanyInput: UpdateCompanyInput;
  UpdateCompanyPayload: Omit<UpdateCompanyPayload, 'company'> & { company: ResolversParentTypes['Company'] };
  UpdateCompanyPractitionerInput: UpdateCompanyPractitionerInput;
  UpdateCompanyPractitionerPayload: Omit<UpdateCompanyPractitionerPayload, 'companyPractitioner' | 'companyPractitionerConfirmation'> & { companyPractitioner: ResolversParentTypes['CompanyPractitioner'], companyPractitionerConfirmation?: Maybe<ResolversParentTypes['CompanyPractitionerConfirmation']> };
  UpdateCompanySessionSettingInput: UpdateCompanySessionSettingInput;
  UpdateCompanySessionSettingPayload: UpdateCompanySessionSettingPayload;
  UpdateContractInput: UpdateContractInput;
  UpdateContractPayload: Omit<UpdateContractPayload, 'contract'> & { contract: ResolversParentTypes['Contract'] };
  UpdateContractPlanInput: UpdateContractPlanInput;
  UpdateContractPlanPayload: Omit<UpdateContractPlanPayload, 'contractPlan'> & { contractPlan: ResolversParentTypes['ContractPlan'] };
  UpdateDraftAppointmentDescriptionInput: UpdateDraftAppointmentDescriptionInput;
  UpdateDraftAppointmentDescriptionPayload: Omit<UpdateDraftAppointmentDescriptionPayload, 'draftAppointment'> & { draftAppointment: ResolversParentTypes['DraftAppointment'] };
  UpdateFeatureInput: UpdateFeatureInput;
  UpdateFeaturePayload: UpdateFeaturePayload;
  UpdateFeatureTargetGroupInput: UpdateFeatureTargetGroupInput;
  UpdateFeatureTargetGroupPayload: UpdateFeatureTargetGroupPayload;
  UpdateGendaApiKeyInput: UpdateGendaApiKeyInput;
  UpdateGendaApiKeyPayload: UpdateGendaApiKeyPayload;
  UpdateGendaSettingInput: UpdateGendaSettingInput;
  UpdateGendaSettingPayload: Omit<UpdateGendaSettingPayload, 'gendaSetting'> & { gendaSetting: ResolversParentTypes['GendaSetting'] };
  UpdateGuestPatientFollowupCommentInput: UpdateGuestPatientFollowupCommentInput;
  UpdateGuestPatientFollowupCommentPayload: UpdateGuestPatientFollowupCommentPayload;
  UpdateMedicalInstitutionSettingInput: UpdateMedicalInstitutionSettingInput;
  UpdateMedicalInstitutionSettingPayload: Omit<UpdateMedicalInstitutionSettingPayload, 'medicalInstitutionSetting'> & { medicalInstitutionSetting: ResolversParentTypes['MedicalInstitutionSetting'] };
  UpdateMedicationFollowupMessage2Input: UpdateMedicationFollowupMessage2Input;
  UpdateMedicationFollowupMessage2Payload: Omit<UpdateMedicationFollowupMessage2Payload, 'medicationFollowupMessage'> & { medicationFollowupMessage: ResolversParentTypes['MedicationFollowupMessage'] };
  UpdateMedicationFollowupMessageTemplateInput: UpdateMedicationFollowupMessageTemplateInput;
  UpdateMedicationFollowupMessageTemplatePayload: Omit<UpdateMedicationFollowupMessageTemplatePayload, 'medicationFollowupMessageTemplate'> & { medicationFollowupMessageTemplate: ResolversParentTypes['MedicationFollowupMessageTemplate'] };
  UpdateMedicationFollowupQuestionnaireInput: UpdateMedicationFollowupQuestionnaireInput;
  UpdateMedicationFollowupQuestionnairePayload: Omit<UpdateMedicationFollowupQuestionnairePayload, 'medicationFollowupQuestionnaire'> & { medicationFollowupQuestionnaire: ResolversParentTypes['MedicationFollowupQuestionnaire'] };
  UpdateMedicationFollowupQuestionnairePositionInput: UpdateMedicationFollowupQuestionnairePositionInput;
  UpdateMedicationFollowupQuestionnairePositionPayload: Omit<UpdateMedicationFollowupQuestionnairePositionPayload, 'medicationFollowupQuestionnaire'> & { medicationFollowupQuestionnaire: ResolversParentTypes['MedicationFollowupQuestionnaire'] };
  UpdateMedixsSettingInput: UpdateMedixsSettingInput;
  UpdateMedixsSettingPayload: Omit<UpdateMedixsSettingPayload, 'medixsSetting'> & { medixsSetting: ResolversParentTypes['MedixsSetting'] };
  UpdateNotificationSettingDataInput: UpdateNotificationSettingDataInput;
  UpdateNotificationSettingInput: UpdateNotificationSettingInput;
  UpdateNotificationSettingPayload: Omit<UpdateNotificationSettingPayload, 'organizationNotificationSetting'> & { organizationNotificationSetting: ResolversParentTypes['OrganizationNotificationSetting'] };
  UpdateNotificationSettingSoundInput: UpdateNotificationSettingSoundInput;
  UpdateNotificationSettingTelInput: UpdateNotificationSettingTelInput;
  UpdateOperatorRoleInput: UpdateOperatorRoleInput;
  UpdateOperatorRolePayload: UpdateOperatorRolePayload;
  UpdateOrganizationAddressAddressInput: UpdateOrganizationAddressAddressInput;
  UpdateOrganizationAddressInput: UpdateOrganizationAddressInput;
  UpdateOrganizationAddressPayload: Omit<UpdateOrganizationAddressPayload, 'organizationAddress'> & { organizationAddress: ResolversParentTypes['OrganizationAddress'] };
  UpdateOrganizationCompanyFeeSettingInput: UpdateOrganizationCompanyFeeSettingInput;
  UpdateOrganizationCompanyFeeSettingPayload: UpdateOrganizationCompanyFeeSettingPayload;
  UpdateOrganizationContactPointContactPointInput: UpdateOrganizationContactPointContactPointInput;
  UpdateOrganizationContactPointInput: UpdateOrganizationContactPointInput;
  UpdateOrganizationContactPointPayload: Omit<UpdateOrganizationContactPointPayload, 'organizationContactPoint'> & { organizationContactPoint: ResolversParentTypes['OrganizationContactPoint'] };
  UpdateOrganizationFeeSettingInput: UpdateOrganizationFeeSettingInput;
  UpdateOrganizationFeeSettingPayload: Omit<UpdateOrganizationFeeSettingPayload, 'organizationFeeSetting'> & { organizationFeeSetting: ResolversParentTypes['OrganizationFeeSetting'] };
  UpdateOrganizationInput: UpdateOrganizationInput;
  UpdateOrganizationPayload: Omit<UpdateOrganizationPayload, 'adminPractitioner' | 'organization'> & { adminPractitioner?: Maybe<ResolversParentTypes['Practitioner']>, organization: ResolversParentTypes['Organization'] };
  UpdateOutpatientQuestionnaireDescriptionInput: UpdateOutpatientQuestionnaireDescriptionInput;
  UpdateOutpatientQuestionnaireDescriptionPayload: Omit<UpdateOutpatientQuestionnaireDescriptionPayload, 'outpatientQuestionnaireEntry'> & { outpatientQuestionnaireEntry: ResolversParentTypes['OutpatientQuestionnaireEntry'] };
  UpdateOutpatientQuestionnaireSettingInput: UpdateOutpatientQuestionnaireSettingInput;
  UpdateOutpatientQuestionnaireSettingPayload: UpdateOutpatientQuestionnaireSettingPayload;
  UpdateOutpatientQuestionnaireSettingQuestionnaireInput: UpdateOutpatientQuestionnaireSettingQuestionnaireInput;
  UpdateOutpatientQuestionnaireSettingQuestionnairePayload: UpdateOutpatientQuestionnaireSettingQuestionnairePayload;
  UpdatePatientFollowupCommentInput: UpdatePatientFollowupCommentInput;
  UpdatePatientFollowupCommentPayload: UpdatePatientFollowupCommentPayload;
  UpdatePlanInput: UpdatePlanInput;
  UpdatePlanPayload: Omit<UpdatePlanPayload, 'plan'> & { plan: ResolversParentTypes['Plan'] };
  UpdatePractitionerAuthenticationInput: UpdatePractitionerAuthenticationInput;
  UpdatePractitionerAuthenticationPayload: Omit<UpdatePractitionerAuthenticationPayload, 'authentication'> & { authentication: ResolversParentTypes['PractitionerAuthentication'] };
  UpdatePractitionerCodeForCompanyPractitionerInput: UpdatePractitionerCodeForCompanyPractitionerInput;
  UpdatePractitionerCodeForCompanyPractitionerPayload: Omit<UpdatePractitionerCodeForCompanyPractitionerPayload, 'companyPractitioner'> & { companyPractitioner: ResolversParentTypes['CompanyPractitioner'] };
  UpdatePractitionerCodeInput: UpdatePractitionerCodeInput;
  UpdatePractitionerCodePayload: Omit<UpdatePractitionerCodePayload, 'practitioner'> & { practitioner: ResolversParentTypes['Practitioner'] };
  UpdatePractitionerInput: UpdatePractitionerInput;
  UpdatePractitionerPayload: Omit<UpdatePractitionerPayload, 'practitioner'> & { practitioner: ResolversParentTypes['Practitioner'] };
  UpdatePrintPrescriptionSettingInput: UpdatePrintPrescriptionSettingInput;
  UpdatePrintPrescriptionSettingPayload: UpdatePrintPrescriptionSettingPayload;
  UpdateUberSignatureInputDataInput: UpdateUberSignatureInputDataInput;
  UpdateUberSignatureInputDataPayload: Omit<UpdateUberSignatureInputDataPayload, 'uberSignature'> & { uberSignature: ResolversParentTypes['UberSignature'] };
  UpdateWebBookingsBusinessHour2Input: UpdateWebBookingsBusinessHour2Input;
  UpdateWebBookingsBusinessHour2Payload: UpdateWebBookingsBusinessHour2Payload;
  UpdateWebBookingsExceptionBusinessHourInput: UpdateWebBookingsExceptionBusinessHourInput;
  UpdateWebBookingsExceptionBusinessHourPayload: UpdateWebBookingsExceptionBusinessHourPayload;
  UpdateWebBookingsHolidayBusinessHourInput: UpdateWebBookingsHolidayBusinessHourInput;
  UpdateWebBookingsHolidayBusinessHourPayload: UpdateWebBookingsHolidayBusinessHourPayload;
  UpdateWebBookingsSettingInput: UpdateWebBookingsSettingInput;
  UpdateWebBookingsSettingPayload: UpdateWebBookingsSettingPayload;
  UpsertAgreementExtensionInput: UpsertAgreementExtensionInput;
  UpsertAgreementExtensionPayload: Omit<UpsertAgreementExtensionPayload, 'agreementExtension'> & { agreementExtension: ResolversParentTypes['AgreementExtension'] };
  UpsertClientAuthenticationInput: UpsertClientAuthenticationInput;
  UpsertClientAuthenticationPayload: Omit<UpsertClientAuthenticationPayload, 'clientAuthentication'> & { clientAuthentication: ResolversParentTypes['ClientAuthentication'] };
  UpsertCompanyWebBookingsLimitSettingInput: UpsertCompanyWebBookingsLimitSettingInput;
  UpsertCompanyWebBookingsLimitSettingPayload: Omit<UpsertCompanyWebBookingsLimitSettingPayload, 'companyWebBookingsLimitSetting'> & { companyWebBookingsLimitSetting: ResolversParentTypes['CompanyWebBookingsLimitSetting'] };
  UpsertGuestPatientMedicationFollowupStatusInput: UpsertGuestPatientMedicationFollowupStatusInput;
  UpsertGuestPatientMedicationFollowupStatusPayload: UpsertGuestPatientMedicationFollowupStatusPayload;
  UpsertMedicationFollowupDraftMessageInput: UpsertMedicationFollowupDraftMessageInput;
  UpsertMedicationFollowupDraftMessagePayload: Omit<UpsertMedicationFollowupDraftMessagePayload, 'medicationFollowupDraftMessage'> & { medicationFollowupDraftMessage: ResolversParentTypes['MedicationFollowupDraftMessage'] };
  UpsertMedicationFollowupStatusSettingInput: UpsertMedicationFollowupStatusSettingInput;
  UpsertMedicationFollowupStatusSettingPayload: Omit<UpsertMedicationFollowupStatusSettingPayload, 'medicationFollowupSetting'> & { medicationFollowupSetting: ResolversParentTypes['MedicationFollowupSetting'] };
  UpsertOrganizationAddressInput: UpsertOrganizationAddressInput;
  UpsertOrganizationAdminPractitionerInput: UpsertOrganizationAdminPractitionerInput;
  UpsertOrganizationBankAccountInput: UpsertOrganizationBankAccountInput;
  UpsertOrganizationInput: UpsertOrganizationInput;
  UpsertOrganizationPayload: Omit<UpsertOrganizationPayload, 'adminPractitioner' | 'clientCert' | 'organization'> & { adminPractitioner?: Maybe<ResolversParentTypes['Practitioner']>, clientCert?: Maybe<ResolversParentTypes['ClientCert']>, organization: ResolversParentTypes['Organization'] };
  UpsertOrganizationWebBookingsBusinessHourInput: UpsertOrganizationWebBookingsBusinessHourInput;
  UpsertOrganizationWebBookingsSettingInput: UpsertOrganizationWebBookingsSettingInput;
  UpsertOrganizationsInput: UpsertOrganizationsInput;
  UpsertOrganizationsPayload: Omit<UpsertOrganizationsPayload, 'organizationImportJobInformation'> & { organizationImportJobInformation: ResolversParentTypes['OrganizationImportJobInformation'] };
  UpsertPatientMedicationFollowupStatusInput: UpsertPatientMedicationFollowupStatusInput;
  UpsertPatientMedicationFollowupStatusPayload: UpsertPatientMedicationFollowupStatusPayload;
  UpsertTracingReportDraftInput: UpsertTracingReportDraftInput;
  UpsertTracingReportDraftPayload: Omit<UpsertTracingReportDraftPayload, 'tracingReportDraft'> & { tracingReportDraft: ResolversParentTypes['TracingReportDraft'] };
  UpsertUberOrganizationSettingInput: UpsertUberOrganizationSettingInput;
  UpsertUberOrganizationSettingPayload: UpsertUberOrganizationSettingPayload;
  UpsertUberOrganizationSettingsInput: UpsertUberOrganizationSettingsInput;
  UpsertUberOrganizationSettingsPayload: UpsertUberOrganizationSettingsPayload;
  UpsertUberSignatureDraftInput: UpsertUberSignatureDraftInput;
  UpsertUberSignatureDraftPayload: Omit<UpsertUberSignatureDraftPayload, 'uberSignatureDraft'> & { uberSignatureDraft: ResolversParentTypes['UberSignatureDraft'] };
  UpsertWebBookingsAllDayLimitInput: UpsertWebBookingsAllDayLimitInput;
  UpsertWebBookingsAllDayLimitPayload: UpsertWebBookingsAllDayLimitPayload;
  UpsertWebBookingsLimitInput: UpsertWebBookingsLimitInput;
  UpsertWebBookingsLimitLimitInput: UpsertWebBookingsLimitLimitInput;
  UpsertWebBookingsLimitPayload: UpsertWebBookingsLimitPayload;
  ViewedMedicationFollowupQuestionnaireSheetInput: ViewedMedicationFollowupQuestionnaireSheetInput;
  ViewedMedicationFollowupQuestionnaireSheetPayload: Omit<ViewedMedicationFollowupQuestionnaireSheetPayload, 'medicationFollowupQuestionnaireSheet' | 'medicationFollowupQuestionnaireSheets'> & { medicationFollowupQuestionnaireSheet?: Maybe<ResolversParentTypes['MedicationFollowupQuestionnaireSheet']>, medicationFollowupQuestionnaireSheets?: Maybe<Array<ResolversParentTypes['MedicationFollowupQuestionnaireSheet']>> };
  WebBookingsBusinessHour: WebBookingsBusinessHour;
  WebBookingsExceptionBusinessHour: WebBookingsExceptionBusinessHour;
  WebBookingsExceptionDate: WebBookingsExceptionDate;
  WebBookingsHolidayBusinessHour: WebBookingsHolidayBusinessHour;
  WebBookingsLimit: WebBookingsLimit;
  WebBookingsLimitLimit: WebBookingsLimitLimit;
  WebBookingsSetting: WebBookingsSetting;
  WebBookingsSuspend: WebBookingsSuspend;
  WebVisitor: Omit<WebVisitor, 'appointment' | 'medicationFollowupDraftMessages' | 'medicationFollowupMessages' | 'medixsPatient' | 'messageDeliverResults' | 'questionnaireSheet' | 'samePatient' | 'tracingReportDrafts' | 'tracingReports'> & { appointment: ResolversParentTypes['Appointment'], medicationFollowupDraftMessages: ResolversParentTypes['MedicationFollowupDraftMessagePage'], medicationFollowupMessages: ResolversParentTypes['MedicationFollowupMessagePage'], medixsPatient?: Maybe<ResolversParentTypes['MedixsPatient']>, messageDeliverResults: ResolversParentTypes['MessageDeliverResultPage'], questionnaireSheet: ResolversParentTypes['QuestionnaireSheet'], samePatient?: Maybe<ResolversParentTypes['Patient']>, tracingReportDrafts: ResolversParentTypes['TracingReportDraftPage'], tracingReports: ResolversParentTypes['TracingReportPage'] };
}>;

export type AccreteMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccreteMessage'] = ResolversParentTypes['AccreteMessage']> = ResolversObject<{
  accreteMessageResults?: Resolver<Array<ResolversTypes['AccreteMessageResult']>, ParentType, ContextType>;
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  link?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  practitioner?: Resolver<Maybe<ResolversTypes['Practitioner']>, ParentType, ContextType>;
  registerTime?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  resultCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userRef?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccreteMessagePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccreteMessagePage'] = ResolversParentTypes['AccreteMessagePage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['AccreteMessage']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AccreteMessageResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccreteMessageResult'] = ResolversParentTypes['AccreteMessageResult']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalmsgnum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ActivateAnnouncementPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivateAnnouncementPayload'] = ResolversParentTypes['ActivateAnnouncementPayload']> = ResolversObject<{
  announcement?: Resolver<ResolversTypes['Announcement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ActivateOtpSecretPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivateOtpSecretPayload'] = ResolversParentTypes['ActivateOtpSecretPayload']> = ResolversObject<{
  practitionerOtpSecret?: Resolver<ResolversTypes['PractitionerOtpSecret'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddCompanyAddressPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddCompanyAddressPayload'] = ResolversParentTypes['AddCompanyAddressPayload']> = ResolversObject<{
  companyAddress?: Resolver<ResolversTypes['CompanyAddress'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddCompanyContactPointPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddCompanyContactPointPayload'] = ResolversParentTypes['AddCompanyContactPointPayload']> = ResolversObject<{
  companyContactPoint?: Resolver<ResolversTypes['CompanyContactPoint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddCompanyPractitionerPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddCompanyPractitionerPayload'] = ResolversParentTypes['AddCompanyPractitionerPayload']> = ResolversObject<{
  companyPractitionerConfirmation?: Resolver<ResolversTypes['CompanyPractitionerConfirmation'], ParentType, ContextType>;
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddContractPlanPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddContractPlanPayload'] = ResolversParentTypes['AddContractPlanPayload']> = ResolversObject<{
  contractPlan?: Resolver<ResolversTypes['ContractPlan'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddIncentiveTargetCompanyPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddIncentiveTargetCompanyPayload'] = ResolversParentTypes['AddIncentiveTargetCompanyPayload']> = ResolversObject<{
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddInvitationCodePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddInvitationCodePayload'] = ResolversParentTypes['AddInvitationCodePayload']> = ResolversObject<{
  invitationCode?: Resolver<ResolversTypes['InvitationCode'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddOrganizationAddressPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddOrganizationAddressPayload'] = ResolversParentTypes['AddOrganizationAddressPayload']> = ResolversObject<{
  organizationAddress?: Resolver<ResolversTypes['OrganizationAddress'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddOrganizationContactPointPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddOrganizationContactPointPayload'] = ResolversParentTypes['AddOrganizationContactPointPayload']> = ResolversObject<{
  organizationContactPoint?: Resolver<ResolversTypes['OrganizationContactPoint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddPatientAttachmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddPatientAttachmentPayload'] = ResolversParentTypes['AddPatientAttachmentPayload']> = ResolversObject<{
  patientAttachment?: Resolver<ResolversTypes['PatientAttachment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddUberSignatureDraftExtraTextPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddUberSignatureDraftExtraTextPayload'] = ResolversParentTypes['AddUberSignatureDraftExtraTextPayload']> = ResolversObject<{
  uberSignatureDraft?: Resolver<ResolversTypes['UberSignatureDraft'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = ResolversObject<{
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  line?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prefecture?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AddressType'], ParentType, ContextType>;
  use?: Resolver<ResolversTypes['AddressUse'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Agent'] = ResolversParentTypes['Agent']> = ResolversObject<{
  artifact?: Resolver<Maybe<ResolversTypes['Blob']>, ParentType, ContextType>;
  connected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasSetUp?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  setting?: Resolver<ResolversTypes['AgentSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgentSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgentSetting'] = ResolversParentTypes['AgentSetting']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  printPrescription?: Resolver<ResolversTypes['PrintPrescriptionSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgreementExtensionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementExtension'] = ResolversParentTypes['AgreementExtension']> = ResolversObject<{
  activatePractitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deactivatePractitioner?: Resolver<Maybe<ResolversTypes['Practitioner']>, ParentType, ContextType>;
  endAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  extension?: Resolver<ResolversTypes['Extension'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  startAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  uberSignatures?: Resolver<Maybe<Array<ResolversTypes['UberSignature']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AgreementExtensionPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementExtensionPage'] = ResolversParentTypes['AgreementExtensionPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['AgreementExtension']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AllPatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['AllPatient'] = ResolversParentTypes['AllPatient']> = ResolversObject<{
  __resolveType: TypeResolveFn<'CheckinEntry' | 'DirectVisitor' | 'Patient' | 'WebVisitor', ParentType, ContextType>;
}>;

export type AllPatientPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AllPatientPage'] = ResolversParentTypes['AllPatientPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['AllPatient']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AllowListResolvers<ContextType = any, ParentType extends ResolversParentTypes['AllowList'] = ResolversParentTypes['AllowList']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AllowOperatorAccessPermissionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AllowOperatorAccessPermissionPayload'] = ResolversParentTypes['AllowOperatorAccessPermissionPayload']> = ResolversObject<{
  operatorAccessPermission?: Resolver<ResolversTypes['OperatorAccessPermission'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AnnouncementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Announcement'] = ResolversParentTypes['Announcement']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  deactivatedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  emergency?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AnnouncementType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AnnouncementConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnnouncementConnection'] = ResolversParentTypes['AnnouncementConnection']> = ResolversObject<{
  edges?: Resolver<Maybe<Array<Maybe<ResolversTypes['AnnouncementEdge']>>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Announcement']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AnnouncementEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnnouncementEdge'] = ResolversParentTypes['AnnouncementEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Announcement']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AnnouncementPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnnouncementPage'] = ResolversParentTypes['AnnouncementPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Announcement']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AppendIdToFeatureTargetGroupPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppendIdToFeatureTargetGroupPayload'] = ResolversParentTypes['AppendIdToFeatureTargetGroupPayload']> = ResolversObject<{
  featureTargetGroup?: Resolver<ResolversTypes['FeatureTargetGroup'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AppendToFeatureTargetGroupPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppendToFeatureTargetGroupPayload'] = ResolversParentTypes['AppendToFeatureTargetGroupPayload']> = ResolversObject<{
  featureTargetGroup?: Resolver<ResolversTypes['FeatureTargetGroup'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AppointmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Appointment'] = ResolversParentTypes['Appointment']> = ResolversObject<{
  appPayment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  bookedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  cancellationReason?: Resolver<Maybe<ResolversTypes['AppointmentCancellationReason']>, ParentType, ContextType>;
  charge?: Resolver<Maybe<ResolversTypes['Charge']>, ParentType, ContextType>;
  congestionNotificationSentAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  deliveryMethod?: Resolver<ResolversTypes['AppointmentDeliveryMethod'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  draftAppointment?: Resolver<Maybe<ResolversTypes['DraftAppointment']>, ParentType, ContextType>;
  encounter?: Resolver<Maybe<ResolversTypes['Encounter']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  finishedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  hiccupAppointmentPermission?: Resolver<Maybe<ResolversTypes['HiccupAppointmentPermission']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  immediate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  medixsReception?: Resolver<Maybe<ResolversTypes['MedixsReception']>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  patientInstruction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pfDispensingRequestAcceptFailed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pfDispensingRequestCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pfDispensingRequestUploadType?: Resolver<Maybe<ResolversTypes['AppointmentPfDispensingRequestUploadType']>, ParentType, ContextType>;
  pfDispensingRequests?: Resolver<Array<Maybe<ResolversTypes['PfDispensingRequest']>>, ParentType, ContextType>;
  prescriptions?: Resolver<Maybe<Array<ResolversTypes['Blob']>>, ParentType, ContextType>;
  qualificationConfirmationMethod?: Resolver<ResolversTypes['AppointmentQualificationConfirmationMethod'], ParentType, ContextType>;
  questionnaires?: Resolver<Array<ResolversTypes['QuestionnaireSheetAnswer']>, ParentType, ContextType>;
  quote?: Resolver<ResolversTypes['Quote'], ParentType, ContextType>;
  requiredUberDeliveryFee?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AppointmentStatus'], ParentType, ContextType>;
  telemedicine?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uberDelivery?: Resolver<Maybe<ResolversTypes['UberDelivery']>, ParentType, ContextType>;
  uberQuote?: Resolver<Maybe<ResolversTypes['UberQuote']>, ParentType, ContextType>;
  unreadOrganizationNotifications?: Resolver<Array<ResolversTypes['OrganizationNotification']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  waitingForChargeAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  webVisitor?: Resolver<Maybe<ResolversTypes['WebVisitor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AppointmentConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppointmentConnection'] = ResolversParentTypes['AppointmentConnection']> = ResolversObject<{
  edges?: Resolver<Maybe<Array<Maybe<ResolversTypes['AppointmentEdge']>>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Appointment']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AppointmentEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppointmentEdge'] = ResolversParentTypes['AppointmentEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Appointment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AppointmentPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppointmentPage'] = ResolversParentTypes['AppointmentPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Appointment']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApproveUberSignaturePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApproveUberSignaturePayload'] = ResolversParentTypes['ApproveUberSignaturePayload']> = ResolversObject<{
  uberSignature?: Resolver<ResolversTypes['UberSignature'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuthTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthToken'] = ResolversParentTypes['AuthToken']> = ResolversObject<{
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type B2cloudSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2cloudSetting'] = ResolversParentTypes['B2cloudSetting']> = ResolversObject<{
  data?: Resolver<ResolversTypes['B2cloudSettingData'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type B2cloudSettingDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2cloudSettingData'] = ResolversParentTypes['B2cloudSettingData']> = ResolversObject<{
  customerCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  defaultInvoiceType?: Resolver<ResolversTypes['B2cloudInvoiceType'], ParentType, ContextType>;
  enable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  goodsName1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sender?: Resolver<ResolversTypes['B2cloudSettingSenderData'], ParentType, ContextType>;
  shippingFeeCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type B2cloudSettingSenderDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['B2cloudSettingSenderData'] = ResolversParentTypes['B2cloudSettingSenderData']> = ResolversObject<{
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  building?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  line?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneBranchNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prefecture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BankResolvers<ContextType = any, ParentType extends ResolversParentTypes['Bank'] = ResolversParentTypes['Bank']> = ResolversObject<{
  branchCodes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  branchFirstHira?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  branchFirstRoma?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  branches?: Resolver<ResolversTypes['BranchPage'], ParentType, ContextType, RequireFields<BankBranchesArgs, 'query'>>;
  code?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  hira?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  kana?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roma?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BankAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccount'] = ResolversParentTypes['BankAccount']> = ResolversObject<{
  accountHolderName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['BankAccountAccount'], ParentType, ContextType>;
  bankCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bankName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  branchCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  branchName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BankBranchResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankBranch'] = ResolversParentTypes['BankBranch']> = ResolversObject<{
  bank?: Resolver<ResolversTypes['Bank'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  hira?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  kana?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roma?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BankPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankPage'] = ResolversParentTypes['BankPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Bank']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BlobResolvers<ContextType = any, ParentType extends ResolversParentTypes['Blob'] = ResolversParentTypes['Blob']> = ResolversObject<{
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signedId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BookAppointmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookAppointmentPayload'] = ResolversParentTypes['BookAppointmentPayload']> = ResolversObject<{
  encounter?: Resolver<ResolversTypes['Encounter'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BookmarkResolvers<ContextType = any, ParentType extends ResolversParentTypes['Bookmark'] = ResolversParentTypes['Bookmark']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  deactivatedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BookmarkedPatientCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookmarkedPatientCount'] = ResolversParentTypes['BookmarkedPatientCount']> = ResolversObject<{
  appointmentCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  monthlyPatientsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  totalPatientsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BookmarkedPatientCountPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['BookmarkedPatientCountPage'] = ResolversParentTypes['BookmarkedPatientCountPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['BookmarkedPatientCount']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BranchResolvers<ContextType = any, ParentType extends ResolversParentTypes['Branch'] = ResolversParentTypes['Branch']> = ResolversObject<{
  bank?: Resolver<ResolversTypes['Bank'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  hira?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  kana?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roma?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BranchPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['BranchPage'] = ResolversParentTypes['BranchPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Branch']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BulkDuplicateMedicationFollowupMessageTemplatesPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkDuplicateMedicationFollowupMessageTemplatesPayload'] = ResolversParentTypes['BulkDuplicateMedicationFollowupMessageTemplatesPayload']> = ResolversObject<{
  messageTemplateJobInformation?: Resolver<ResolversTypes['MedicationFollowupMessageTemplateJobInformation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessHourTimeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessHourTime'] = ResolversParentTypes['BusinessHourTime']> = ResolversObject<{
  end?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  start?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CancelAppointmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelAppointmentPayload'] = ResolversParentTypes['CancelAppointmentPayload']> = ResolversObject<{
  appointment?: Resolver<ResolversTypes['Appointment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CancelAppointmentViaWebPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelAppointmentViaWebPayload'] = ResolversParentTypes['CancelAppointmentViaWebPayload']> = ResolversObject<{
  appointment?: Resolver<ResolversTypes['PublicAppointment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CancelAppointmentWithWebVisitorPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelAppointmentWithWebVisitorPayload'] = ResolversParentTypes['CancelAppointmentWithWebVisitorPayload']> = ResolversObject<{
  appointment?: Resolver<ResolversTypes['Appointment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CancelDraftAppointmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelDraftAppointmentPayload'] = ResolversParentTypes['CancelDraftAppointmentPayload']> = ResolversObject<{
  draftAppointment?: Resolver<ResolversTypes['DraftAppointment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CancelOperatorAccessPermissionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelOperatorAccessPermissionPayload'] = ResolversParentTypes['CancelOperatorAccessPermissionPayload']> = ResolversObject<{
  operatorAccessPermission?: Resolver<Maybe<ResolversTypes['OperatorAccessPermission']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChangeDeliveryMethodPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangeDeliveryMethodPayload'] = ResolversParentTypes['ChangeDeliveryMethodPayload']> = ResolversObject<{
  appointment?: Resolver<ResolversTypes['Appointment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChangeOutpatientQuestionnaireSettingQuestionnaireInUsePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChangeOutpatientQuestionnaireSettingQuestionnaireInUsePayload'] = ResolversParentTypes['ChangeOutpatientQuestionnaireSettingQuestionnaireInUsePayload']> = ResolversObject<{
  outpatientQuestionnaireSettingQuestionnaire?: Resolver<ResolversTypes['OutpatientQuestionnaireSettingQuestionnaire'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChargeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Charge'] = ResolversParentTypes['Charge']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  appointment?: Resolver<ResolversTypes['Appointment'], ParentType, ContextType>;
  chargeHistories?: Resolver<ResolversTypes['ChargeHistoryPage'], ParentType, ContextType, Partial<ChargeChargeHistoriesArgs>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  paymentMethod?: Resolver<ResolversTypes['PaymentMethod'], ParentType, ContextType>;
  pfPaymentHistoryId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pfPaymentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  refundable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  refunded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChargeHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargeHistory'] = ResolversParentTypes['ChargeHistory']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  amountDetails?: Resolver<Maybe<Array<ResolversTypes['ChargeHistoryAmountDetail']>>, ParentType, ContextType>;
  charge?: Resolver<ResolversTypes['Charge'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  fee?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  feeWithTax?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  invoice?: Resolver<Maybe<ResolversTypes['Invoice']>, ParentType, ContextType>;
  net?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  refunded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  statement?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChargeHistoryAmountDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargeHistoryAmountDetail'] = ResolversParentTypes['ChargeHistoryAmountDetail']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['LineItemCode'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChargeHistoryPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargeHistoryPage'] = ResolversParentTypes['ChargeHistoryPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ChargeHistory']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChargeWithApp2PayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargeWithApp2Payload'] = ResolversParentTypes['ChargeWithApp2Payload']> = ResolversObject<{
  charge?: Resolver<ResolversTypes['Charge'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChargeWithAppPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargeWithAppPayload'] = ResolversParentTypes['ChargeWithAppPayload']> = ResolversObject<{
  charge?: Resolver<ResolversTypes['Charge'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChargeWithCash2PayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargeWithCash2Payload'] = ResolversParentTypes['ChargeWithCash2Payload']> = ResolversObject<{
  charge?: Resolver<ResolversTypes['Charge'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChargeWithCashPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChargeWithCashPayload'] = ResolversParentTypes['ChargeWithCashPayload']> = ResolversObject<{
  charge?: Resolver<ResolversTypes['Charge'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CheckinEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckinEntry'] = ResolversParentTypes['CheckinEntry']> = ResolversObject<{
  checkinOrganization?: Resolver<ResolversTypes['CheckinOrganization'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  enteredAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  familyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  givenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  notificationsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  notifiedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneticFamilyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneticGivenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CheckinEntryStatus'], ParentType, ContextType>;
  unreadOrganizationNotifications?: Resolver<Array<ResolversTypes['OrganizationNotification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CheckinEntryPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckinEntryPage'] = ResolversParentTypes['CheckinEntryPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CheckinEntry']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CheckinOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckinOrganization'] = ResolversParentTypes['CheckinOrganization']> = ResolversObject<{
  active?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  appDownloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CheckinSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckinSetting'] = ResolversParentTypes['CheckinSetting']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  checkinOrganization?: Resolver<ResolversTypes['CheckinOrganization'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CityResolvers<ContextType = any, ParentType extends ResolversParentTypes['City'] = ResolversParentTypes['City']> = ResolversObject<{
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jisCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ClientAuthenticationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientAuthentication'] = ResolversParentTypes['ClientAuthentication']> = ResolversObject<{
  available?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  enable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  startAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ClientCertResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientCert'] = ResolversParentTypes['ClientCert']> = ResolversObject<{
  certId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  downloadStatus?: Resolver<ResolversTypes['ClientCertDownloadStatus'], ParentType, ContextType>;
  downloadUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  issuerRdn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notAfter?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  notBefore?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  operator?: Resolver<Maybe<ResolversTypes['Operator']>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  practitioner?: Resolver<Maybe<ResolversTypes['PrivilegeOrganizationPractitioner']>, ParentType, ContextType>;
  renewable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  revokedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  serialNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ClientCertStatus'], ParentType, ContextType>;
  used?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ClientCertJobInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientCertJobInformation'] = ResolversParentTypes['ClientCertJobInformation']> = ResolversObject<{
  errorMessages?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobInformationStatus'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ClientCertPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientCertPage'] = ResolversParentTypes['ClientCertPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ClientCert']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ClientCertSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientCertSummary'] = ResolversParentTypes['ClientCertSummary']> = ResolversObject<{
  downloadedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  renewCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  revokedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  validCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  waitingCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ClientCertSummaryPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientCertSummaryPage'] = ResolversParentTypes['ClientCertSummaryPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ClientCertSummary']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ClientCertVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientCertVerification'] = ResolversParentTypes['ClientCertVerification']> = ResolversObject<{
  clientCert?: Resolver<Maybe<ResolversTypes['ClientCert']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ClientCertVerificationStatus'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Company'] = ResolversParentTypes['Company']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  activeExtensionCodes?: Resolver<Array<ResolversTypes['ExtensionCode']>, ParentType, ContextType>;
  affectedOrganizationsByDeactivation?: Resolver<Maybe<ResolversTypes['OrganizationPage']>, ParentType, ContextType, Partial<CompanyAffectedOrganizationsByDeactivationArgs>>;
  agentSetting?: Resolver<Maybe<ResolversTypes['CompanyAgentSetting']>, ParentType, ContextType>;
  agreementExtensions?: Resolver<ResolversTypes['AgreementExtensionPage'], ParentType, ContextType, RequireFields<CompanyAgreementExtensionsArgs, 'extensionCode'>>;
  bookmarkedPatientCounts?: Resolver<ResolversTypes['BookmarkedPatientCountPage'], ParentType, ContextType, Partial<CompanyBookmarkedPatientCountsArgs>>;
  candidateCompanyPractitioners?: Resolver<Maybe<Array<ResolversTypes['Practitioner']>>, ParentType, ContextType>;
  checkinEntries?: Resolver<ResolversTypes['CheckinEntryPage'], ParentType, ContextType, RequireFields<CompanyCheckinEntriesArgs, 'order' | 'statuses'>>;
  clientAuthentication?: Resolver<Maybe<ResolversTypes['ClientAuthentication']>, ParentType, ContextType>;
  clientCertSummaries?: Resolver<ResolversTypes['ClientCertSummaryPage'], ParentType, ContextType, Partial<CompanyClientCertSummariesArgs>>;
  companyAddresses?: Resolver<Array<ResolversTypes['CompanyAddress']>, ParentType, ContextType>;
  companyContactPoints?: Resolver<Array<ResolversTypes['CompanyContactPoint']>, ParentType, ContextType>;
  companyPractitioner?: Resolver<Maybe<ResolversTypes['CompanyPractitioner']>, ParentType, ContextType>;
  companyPractitionerConfirmation?: Resolver<Maybe<ResolversTypes['CompanyPractitionerConfirmation']>, ParentType, ContextType>;
  contract?: Resolver<Maybe<ResolversTypes['Contract']>, ParentType, ContextType>;
  contractLightPlan?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  existPlanFeature?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<CompanyExistPlanFeatureArgs, 'featureCode'>>;
  facetofaceOrganizationCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  featureNames?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  featureUsages?: Resolver<ResolversTypes['FeatureUsagePage'], ParentType, ContextType, Partial<CompanyFeatureUsagesArgs>>;
  feeSettings?: Resolver<ResolversTypes['CompanyFeeSettingPage'], ParentType, ContextType, Partial<CompanyFeeSettingsArgs>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  latestSucceededTemplateJobInformation?: Resolver<Maybe<ResolversTypes['MedicationFollowupMessageTemplateJobInformation']>, ParentType, ContextType>;
  latestUberSignature?: Resolver<Maybe<ResolversTypes['UberSignature']>, ParentType, ContextType>;
  medicationFollowupUsages?: Resolver<ResolversTypes['MedicationFollowupUsagePage'], ParentType, ContextType, Partial<CompanyMedicationFollowupUsagesArgs>>;
  monthlySales?: Resolver<Maybe<ResolversTypes['CompanyMonthlySales']>, ParentType, ContextType, RequireFields<CompanyMonthlySalesArgs, 'month' | 'year'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationImportJobInformations?: Resolver<ResolversTypes['OrganizationImportJobInformationConnection'], ParentType, ContextType, Partial<CompanyOrganizationImportJobInformationsArgs>>;
  organizations?: Resolver<ResolversTypes['OrganizationPage'], ParentType, ContextType, Partial<CompanyOrganizationsArgs>>;
  payoutYears?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  payouts?: Resolver<ResolversTypes['PayoutPage'], ParentType, ContextType, Partial<CompanyPayoutsArgs>>;
  practitioners?: Resolver<ResolversTypes['PractitionerPage'], ParentType, ContextType, RequireFields<CompanyPractitionersArgs, 'order'>>;
  privilegeOrganization?: Resolver<ResolversTypes['PrivilegeOrganization'], ParentType, ContextType>;
  publishedOrganizationCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  receptionUsages?: Resolver<ResolversTypes['ReceptionUsagePage'], ParentType, ContextType, Partial<CompanyReceptionUsagesArgs>>;
  receptions?: Resolver<Maybe<ResolversTypes['ReceptionPage']>, ParentType, ContextType, RequireFields<CompanyReceptionsArgs, 'order'>>;
  salesMonths?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<CompanySalesMonthsArgs, 'year'>>;
  salesYears?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  sessionSetting?: Resolver<Maybe<ResolversTypes['CompanySessionSetting']>, ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  telemedicineOrganizationCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tracingReportUsages?: Resolver<ResolversTypes['TracingReportUsagePage'], ParentType, ContextType, Partial<CompanyTracingReportUsagesArgs>>;
  uberSignatureDraft?: Resolver<Maybe<ResolversTypes['UberSignatureDraft']>, ParentType, ContextType>;
  uberSignatures?: Resolver<Maybe<Array<ResolversTypes['UberSignature']>>, ParentType, ContextType>;
  webBookingsLimitSettings?: Resolver<Array<ResolversTypes['CompanyWebBookingsLimitSetting']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyAddress'] = ResolversParentTypes['CompanyAddress']> = ResolversObject<{
  address?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyAgentSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyAgentSetting'] = ResolversParentTypes['CompanyAgentSetting']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  proxyHost?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  proxyPort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyCommonSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyCommonSetting'] = ResolversParentTypes['CompanyCommonSetting']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  fee?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  webBookingsLimit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyContactPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyContactPoint'] = ResolversParentTypes['CompanyContactPoint']> = ResolversObject<{
  contactPoint?: Resolver<ResolversTypes['ContactPoint'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyFeeSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyFeeSetting'] = ResolversParentTypes['CompanyFeeSetting']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['LineItemCode'], ParentType, ContextType>;
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  defaultAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  defaultField?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fixed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyFeeSettingPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyFeeSettingPage'] = ResolversParentTypes['CompanyFeeSettingPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CompanyFeeSetting']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyMonthlySalesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyMonthlySales'] = ResolversParentTypes['CompanyMonthlySales']> = ResolversObject<{
  organizationDailySales?: Resolver<ResolversTypes['OrganizationDailySalesPage'], ParentType, ContextType, Partial<CompanyMonthlySalesOrganizationDailySalesArgs>>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyPractitionerResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPractitioner'] = ResolversParentTypes['CompanyPractitioner']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  companyPractitionerContactPoints?: Resolver<Array<ResolversTypes['CompanyPractitionerContactPoint']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  sendgridEventActivities?: Resolver<Maybe<Array<ResolversTypes['SendgridEventActivity']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyPractitionerConfirmationResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPractitionerConfirmation'] = ResolversParentTypes['CompanyPractitionerConfirmation']> = ResolversObject<{
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  confirmationType?: Resolver<ResolversTypes['CompanyPractitionerConfirmationType'], ParentType, ContextType>;
  confirmed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['CompanyPractitionerConfirmationData'], ParentType, ContextType>;
  expired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  sendgridEventActivities?: Resolver<Maybe<Array<ResolversTypes['SendgridEventActivity']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyPractitionerConfirmationDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPractitionerConfirmationData'] = ResolversParentTypes['CompanyPractitionerConfirmationData']> = ResolversObject<{
  practitionerEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  practitionerTel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyPractitionerContactPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyPractitionerContactPoint'] = ResolversParentTypes['CompanyPractitionerContactPoint']> = ResolversObject<{
  contactPoint?: Resolver<ResolversTypes['ContactPoint'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanySessionSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanySessionSetting'] = ResolversParentTypes['CompanySessionSetting']> = ResolversObject<{
  duration?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanySetupDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanySetupDocument'] = ResolversParentTypes['CompanySetupDocument']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sendgridEventActivities?: Resolver<Maybe<Array<ResolversTypes['SendgridEventActivity']>>, ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyWebBookingsLimitSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyWebBookingsLimitSetting'] = ResolversParentTypes['CompanyWebBookingsLimitSetting']> = ResolversObject<{
  code?: Resolver<ResolversTypes['WebBookingsLimitCode'], ParentType, ContextType>;
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContactPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactPoint'] = ResolversParentTypes['ContactPoint']> = ResolversObject<{
  formattedValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  system?: Resolver<ResolversTypes['ContactPointSystem'], ParentType, ContextType>;
  use?: Resolver<ResolversTypes['ContactPointUse'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContractResolvers<ContextType = any, ParentType extends ResolversParentTypes['Contract'] = ResolversParentTypes['Contract']> = ResolversObject<{
  contractCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  contractPlans?: Resolver<Array<ResolversTypes['ContractPlan']>, ParentType, ContextType, Partial<ContractContractPlansArgs>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ContractPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContractPlan'] = ResolversParentTypes['ContractPlan']> = ResolversObject<{
  contract?: Resolver<ResolversTypes['Contract'], ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  plan?: Resolver<ResolversTypes['Plan'], ParentType, ContextType>;
  start?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateAllowListPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateAllowListPayload'] = ResolversParentTypes['CreateAllowListPayload']> = ResolversObject<{
  allowList?: Resolver<ResolversTypes['AllowList'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateAnnouncementPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateAnnouncementPayload'] = ResolversParentTypes['CreateAnnouncementPayload']> = ResolversObject<{
  announcement?: Resolver<ResolversTypes['Announcement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateAppointmentViaWebPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateAppointmentViaWebPayload'] = ResolversParentTypes['CreateAppointmentViaWebPayload']> = ResolversObject<{
  appointment?: Resolver<ResolversTypes['PublicAppointment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateAuthTokenByProxyPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateAuthTokenByProxyPayload'] = ResolversParentTypes['CreateAuthTokenByProxyPayload']> = ResolversObject<{
  authToken?: Resolver<ResolversTypes['AuthToken'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateCheckinEntryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateCheckinEntryPayload'] = ResolversParentTypes['CreateCheckinEntryPayload']> = ResolversObject<{
  publicCheckinEntry?: Resolver<ResolversTypes['PublicCheckinEntry'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateClientCertPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateClientCertPayload'] = ResolversParentTypes['CreateClientCertPayload']> = ResolversObject<{
  clientCert?: Resolver<ResolversTypes['ClientCert'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateCompanyFeeSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateCompanyFeeSettingPayload'] = ResolversParentTypes['CreateCompanyFeeSettingPayload']> = ResolversObject<{
  companyFeeSetting?: Resolver<ResolversTypes['CompanyFeeSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateCompanySetupDocumentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateCompanySetupDocumentPayload'] = ResolversParentTypes['CreateCompanySetupDocumentPayload']> = ResolversObject<{
  companySetupDocument?: Resolver<ResolversTypes['CompanySetupDocument'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateDirectVisitorPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDirectVisitorPayload'] = ResolversParentTypes['CreateDirectVisitorPayload']> = ResolversObject<{
  directVisitor?: Resolver<ResolversTypes['DirectVisitor'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateFeaturePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFeaturePayload'] = ResolversParentTypes['CreateFeaturePayload']> = ResolversObject<{
  feature?: Resolver<ResolversTypes['Feature'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateFeatureTargetGroupFromTargetPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFeatureTargetGroupFromTargetPayload'] = ResolversParentTypes['CreateFeatureTargetGroupFromTargetPayload']> = ResolversObject<{
  featureTargetGroup?: Resolver<ResolversTypes['FeatureTargetGroup'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateFeatureTargetGroupPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFeatureTargetGroupPayload'] = ResolversParentTypes['CreateFeatureTargetGroupPayload']> = ResolversObject<{
  featureTargetGroup?: Resolver<ResolversTypes['FeatureTargetGroup'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateGendaSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateGendaSettingPayload'] = ResolversParentTypes['CreateGendaSettingPayload']> = ResolversObject<{
  gendaSetting?: Resolver<ResolversTypes['GendaSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateGuestPatientFollowupCommentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateGuestPatientFollowupCommentPayload'] = ResolversParentTypes['CreateGuestPatientFollowupCommentPayload']> = ResolversObject<{
  guestPatientMedicationFollowupComment?: Resolver<ResolversTypes['GuestPatientMedicationFollowupComment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateMedicalInstitutionSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateMedicalInstitutionSettingPayload'] = ResolversParentTypes['CreateMedicalInstitutionSettingPayload']> = ResolversObject<{
  medicalInstitutionSetting?: Resolver<ResolversTypes['MedicalInstitutionSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateMedicationFollowupMessage2PayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateMedicationFollowupMessage2Payload'] = ResolversParentTypes['CreateMedicationFollowupMessage2Payload']> = ResolversObject<{
  medicationFollowupMessage?: Resolver<ResolversTypes['MedicationFollowupMessage'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateMedicationFollowupMessageTemplatePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateMedicationFollowupMessageTemplatePayload'] = ResolversParentTypes['CreateMedicationFollowupMessageTemplatePayload']> = ResolversObject<{
  medicationFollowupMessageTemplate?: Resolver<ResolversTypes['MedicationFollowupMessageTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateMedicationFollowupQuestionnairePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateMedicationFollowupQuestionnairePayload'] = ResolversParentTypes['CreateMedicationFollowupQuestionnairePayload']> = ResolversObject<{
  medicationFollowupQuestionnaire?: Resolver<ResolversTypes['MedicationFollowupQuestionnaire'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateMedicationFollowupQuestionnaireSheetPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateMedicationFollowupQuestionnaireSheetPayload'] = ResolversParentTypes['CreateMedicationFollowupQuestionnaireSheetPayload']> = ResolversObject<{
  publicMedicationFollowupMessage?: Resolver<ResolversTypes['PublicMedicationFollowupMessage'], ParentType, ContextType>;
  publicMedicationFollowupQuestionnaireSheet?: Resolver<ResolversTypes['PublicMedicationFollowupQuestionnaireSheet'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateMedixsSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateMedixsSettingPayload'] = ResolversParentTypes['CreateMedixsSettingPayload']> = ResolversObject<{
  medixsSetting?: Resolver<ResolversTypes['MedixsSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateMessageForWebVisitorPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateMessageForWebVisitorPayload'] = ResolversParentTypes['CreateMessageForWebVisitorPayload']> = ResolversObject<{
  messageDeliver?: Resolver<ResolversTypes['MessageDeliver'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateOperatorAuthorityPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOperatorAuthorityPayload'] = ResolversParentTypes['CreateOperatorAuthorityPayload']> = ResolversObject<{
  operator?: Resolver<ResolversTypes['Operator'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateOperatorRolePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOperatorRolePayload'] = ResolversParentTypes['CreateOperatorRolePayload']> = ResolversObject<{
  operatorRole?: Resolver<ResolversTypes['OperatorRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateOrganizationCompanyFeeSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOrganizationCompanyFeeSettingPayload'] = ResolversParentTypes['CreateOrganizationCompanyFeeSettingPayload']> = ResolversObject<{
  organizationCompanyFeeSetting?: Resolver<ResolversTypes['OrganizationCompanyFeeSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateOrganizationFeeSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOrganizationFeeSettingPayload'] = ResolversParentTypes['CreateOrganizationFeeSettingPayload']> = ResolversObject<{
  organizationFeeSetting?: Resolver<ResolversTypes['OrganizationFeeSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateOrganizationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOrganizationPayload'] = ResolversParentTypes['CreateOrganizationPayload']> = ResolversObject<{
  adminPractitioner?: Resolver<Maybe<ResolversTypes['Practitioner']>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  practitionerCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateOtpSecretPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOtpSecretPayload'] = ResolversParentTypes['CreateOtpSecretPayload']> = ResolversObject<{
  practitionerOtpSecret?: Resolver<ResolversTypes['PractitionerOtpSecret'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateOutpatientQuestionnaireEntryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOutpatientQuestionnaireEntryPayload'] = ResolversParentTypes['CreateOutpatientQuestionnaireEntryPayload']> = ResolversObject<{
  outpatientQuestionnaireEntry?: Resolver<ResolversTypes['PublicOutpatientQuestionnaireEntry'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateOutpatientQuestionnaireSettingQuestionnairePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOutpatientQuestionnaireSettingQuestionnairePayload'] = ResolversParentTypes['CreateOutpatientQuestionnaireSettingQuestionnairePayload']> = ResolversObject<{
  outpatientQuestionnaireSettingQuestionnaire?: Resolver<ResolversTypes['OutpatientQuestionnaireSettingQuestionnaire'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreatePatientFollowupCommentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatePatientFollowupCommentPayload'] = ResolversParentTypes['CreatePatientFollowupCommentPayload']> = ResolversObject<{
  patientMedicationFollowupComment?: Resolver<ResolversTypes['PatientMedicationFollowupComment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreatePlanPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatePlanPayload'] = ResolversParentTypes['CreatePlanPayload']> = ResolversObject<{
  plan?: Resolver<ResolversTypes['Plan'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreatePractitionerPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatePractitionerPayload'] = ResolversParentTypes['CreatePractitionerPayload']> = ResolversObject<{
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  practitionerCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateTracingReportPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateTracingReportPayload'] = ResolversParentTypes['CreateTracingReportPayload']> = ResolversObject<{
  tracingReport?: Resolver<ResolversTypes['TracingReport'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateUberAgreementExtensionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUberAgreementExtensionPayload'] = ResolversParentTypes['CreateUberAgreementExtensionPayload']> = ResolversObject<{
  agreementExtension?: Resolver<ResolversTypes['AgreementExtension'], ParentType, ContextType>;
  uberSignature?: Resolver<ResolversTypes['UberSignature'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CreateUberDeliveryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUberDeliveryPayload'] = ResolversParentTypes['CreateUberDeliveryPayload']> = ResolversObject<{
  uberDelivery?: Resolver<ResolversTypes['UberDelivery'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CsCityResolvers<ContextType = any, ParentType extends ResolversParentTypes['CsCity'] = ResolversParentTypes['CsCity']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CsClinicResolvers<ContextType = any, ParentType extends ResolversParentTypes['CsClinic'] = ResolversParentTypes['CsClinic']> = ResolversObject<{
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logoImageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subCategories?: Resolver<Array<ResolversTypes['CsClinicSubCategory']>, ParentType, ContextType>;
  tel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CsClinicCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CsClinicCategory'] = ResolversParentTypes['CsClinicCategory']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CsClinicPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['CsClinicPage'] = ResolversParentTypes['CsClinicPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['CsClinic']>, ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CsClinicSubCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['CsClinicSubCategory'] = ResolversParentTypes['CsClinicSubCategory']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeactivateAnnouncementPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateAnnouncementPayload'] = ResolversParentTypes['DeactivateAnnouncementPayload']> = ResolversObject<{
  announcement?: Resolver<ResolversTypes['Announcement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeactivateCompanyFeeSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateCompanyFeeSettingPayload'] = ResolversParentTypes['DeactivateCompanyFeeSettingPayload']> = ResolversObject<{
  companyFeeSetting?: Resolver<ResolversTypes['CompanyFeeSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeactivateCompanyPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateCompanyPayload'] = ResolversParentTypes['DeactivateCompanyPayload']> = ResolversObject<{
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeactivateMedicationFollowupMessagePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateMedicationFollowupMessagePayload'] = ResolversParentTypes['DeactivateMedicationFollowupMessagePayload']> = ResolversObject<{
  medicationFollowupMessage?: Resolver<ResolversTypes['MedicationFollowupMessage'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeactivateMedicationFollowupMessageTemplatePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateMedicationFollowupMessageTemplatePayload'] = ResolversParentTypes['DeactivateMedicationFollowupMessageTemplatePayload']> = ResolversObject<{
  medicationFollowupMessageTemplate?: Resolver<ResolversTypes['MedicationFollowupMessageTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeactivateMedicationFollowupQuestionnairePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateMedicationFollowupQuestionnairePayload'] = ResolversParentTypes['DeactivateMedicationFollowupQuestionnairePayload']> = ResolversObject<{
  medicationFollowupQuestionnaire?: Resolver<ResolversTypes['MedicationFollowupQuestionnaire'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeactivateOperatorPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateOperatorPayload'] = ResolversParentTypes['DeactivateOperatorPayload']> = ResolversObject<{
  operator?: Resolver<ResolversTypes['Operator'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeactivateOrganizationFeeSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateOrganizationFeeSettingPayload'] = ResolversParentTypes['DeactivateOrganizationFeeSettingPayload']> = ResolversObject<{
  organizationFeeSetting?: Resolver<ResolversTypes['OrganizationFeeSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeactivateOtpSecretsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivateOtpSecretsPayload'] = ResolversParentTypes['DeactivateOtpSecretsPayload']> = ResolversObject<{
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeactivatePractitionerPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeactivatePractitionerPayload'] = ResolversParentTypes['DeactivatePractitionerPayload']> = ResolversObject<{
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeleteAllowListPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteAllowListPayload'] = ResolversParentTypes['DeleteAllowListPayload']> = ResolversObject<{
  allowList?: Resolver<ResolversTypes['AllowList'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeleteFeaturePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteFeaturePayload'] = ResolversParentTypes['DeleteFeaturePayload']> = ResolversObject<{
  feature?: Resolver<ResolversTypes['Feature'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeleteFeatureTargetGroupPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteFeatureTargetGroupPayload'] = ResolversParentTypes['DeleteFeatureTargetGroupPayload']> = ResolversObject<{
  featureTargetGroup?: Resolver<ResolversTypes['FeatureTargetGroup'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeleteFromFeatureTargetGroupPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteFromFeatureTargetGroupPayload'] = ResolversParentTypes['DeleteFromFeatureTargetGroupPayload']> = ResolversObject<{
  featureTargetGroup?: Resolver<ResolversTypes['FeatureTargetGroup'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeleteGuestPatientMedicationFollowupCommentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteGuestPatientMedicationFollowupCommentPayload'] = ResolversParentTypes['DeleteGuestPatientMedicationFollowupCommentPayload']> = ResolversObject<{
  guestPatientMedicationFollowupComment?: Resolver<ResolversTypes['GuestPatientMedicationFollowupComment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeleteIdFromFeatureTargetGroupPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteIdFromFeatureTargetGroupPayload'] = ResolversParentTypes['DeleteIdFromFeatureTargetGroupPayload']> = ResolversObject<{
  featureTargetGroup?: Resolver<ResolversTypes['FeatureTargetGroup'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeleteMedicationFollowupDraftMessagePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteMedicationFollowupDraftMessagePayload'] = ResolversParentTypes['DeleteMedicationFollowupDraftMessagePayload']> = ResolversObject<{
  medicationFollowupDraftMessage?: Resolver<Maybe<ResolversTypes['MedicationFollowupDraftMessage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeleteOperatorAuthorityPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteOperatorAuthorityPayload'] = ResolversParentTypes['DeleteOperatorAuthorityPayload']> = ResolversObject<{
  operator?: Resolver<ResolversTypes['Operator'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeleteOperatorRolePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteOperatorRolePayload'] = ResolversParentTypes['DeleteOperatorRolePayload']> = ResolversObject<{
  operatorRole?: Resolver<ResolversTypes['OperatorRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeleteOrganizationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteOrganizationPayload'] = ResolversParentTypes['DeleteOrganizationPayload']> = ResolversObject<{
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeleteOutpatientQuestionnaireSettingQuestionnairePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteOutpatientQuestionnaireSettingQuestionnairePayload'] = ResolversParentTypes['DeleteOutpatientQuestionnaireSettingQuestionnairePayload']> = ResolversObject<{
  outpatientQuestionnaireSettingQuestionnaire?: Resolver<ResolversTypes['OutpatientQuestionnaireSettingQuestionnaire'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeletePatientAttachmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeletePatientAttachmentPayload'] = ResolversParentTypes['DeletePatientAttachmentPayload']> = ResolversObject<{
  patientAttachment?: Resolver<ResolversTypes['PatientAttachment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeletePatientMedicationFollowupCommentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeletePatientMedicationFollowupCommentPayload'] = ResolversParentTypes['DeletePatientMedicationFollowupCommentPayload']> = ResolversObject<{
  patientMedicationFollowupComment?: Resolver<ResolversTypes['PatientMedicationFollowupComment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DeleteTracingReportDraftPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteTracingReportDraftPayload'] = ResolversParentTypes['DeleteTracingReportDraftPayload']> = ResolversObject<{
  tracingReportDraft?: Resolver<Maybe<ResolversTypes['TracingReportDraft']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DescriptionCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DescriptionCode'] = ResolversParentTypes['DescriptionCode']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DirectVisitorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectVisitor'] = ResolversParentTypes['DirectVisitor']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  birthDate?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  familyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  givenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  medicationFollowupComments?: Resolver<ResolversTypes['GuestPatientMedicationFollowupCommentPage'], ParentType, ContextType, Partial<DirectVisitorMedicationFollowupCommentsArgs>>;
  medicationFollowupDraftMessages?: Resolver<ResolversTypes['MedicationFollowupDraftMessagePage'], ParentType, ContextType, Partial<DirectVisitorMedicationFollowupDraftMessagesArgs>>;
  medicationFollowupMessages?: Resolver<ResolversTypes['MedicationFollowupMessagePage'], ParentType, ContextType, Partial<DirectVisitorMedicationFollowupMessagesArgs>>;
  medicationFollowupStatus?: Resolver<Maybe<ResolversTypes['PatientMedicationFollowupStatus']>, ParentType, ContextType>;
  medixsPatient?: Resolver<Maybe<ResolversTypes['MedixsPatient']>, ParentType, ContextType>;
  messageDeliverResults?: Resolver<ResolversTypes['MessageDeliverResultPage'], ParentType, ContextType, Partial<DirectVisitorMessageDeliverResultsArgs>>;
  mobilePhone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outpatientQuestionnaireEntry?: Resolver<Maybe<ResolversTypes['OutpatientQuestionnaireEntry']>, ParentType, ContextType>;
  phoneticFamilyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneticGivenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  samePatient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  sex?: Resolver<ResolversTypes['Sex'], ParentType, ContextType>;
  tracingReportDrafts?: Resolver<ResolversTypes['TracingReportDraftPage'], ParentType, ContextType, Partial<DirectVisitorTracingReportDraftsArgs>>;
  tracingReports?: Resolver<ResolversTypes['TracingReportPage'], ParentType, ContextType, Partial<DirectVisitorTracingReportsArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DirectVisitorCandidateResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectVisitorCandidate'] = ResolversParentTypes['DirectVisitorCandidate']> = ResolversObject<{
  __resolveType: TypeResolveFn<'CheckinEntry' | 'DirectVisitor', ParentType, ContextType>;
}>;

export type DirectVisitorCandidatePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectVisitorCandidatePage'] = ResolversParentTypes['DirectVisitorCandidatePage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['DirectVisitorCandidate']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DirectVisitorPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectVisitorPage'] = ResolversParentTypes['DirectVisitorPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['DirectVisitor']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DisclosedMedicineNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisclosedMedicineNote'] = ResolversParentTypes['DisclosedMedicineNote']> = ResolversObject<{
  __resolveType: TypeResolveFn<'HiccupOnetimeApiCache' | 'HiccupTemporaryPermission', ParentType, ContextType>;
}>;

export type DisclosedMedicineNotePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisclosedMedicineNotePage'] = ResolversParentTypes['DisclosedMedicineNotePage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['DisclosedMedicineNote']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DownloadClientCertPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DownloadClientCertPayload'] = ResolversParentTypes['DownloadClientCertPayload']> = ResolversObject<{
  certData?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DraftAppointmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['DraftAppointment'] = ResolversParentTypes['DraftAppointment']> = ResolversObject<{
  appointment?: Resolver<Maybe<ResolversTypes['Appointment']>, ParentType, ContextType>;
  cancellationReason?: Resolver<Maybe<ResolversTypes['DraftAppointmentCancellationReason']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  deliveryMethod?: Resolver<ResolversTypes['DraftAppointmentDeliveryMethod'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  patient?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  pfDispensingRequest?: Resolver<Maybe<ResolversTypes['PfDispensingRequest']>, ParentType, ContextType>;
  previousStatus?: Resolver<Maybe<ResolversTypes['DraftAppointmentStatus']>, ParentType, ContextType>;
  questionnaires?: Resolver<Array<ResolversTypes['QuestionnaireSheetAnswer']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DraftAppointmentStatus'], ParentType, ContextType>;
  telemedicine?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  unreadOrganizationNotifications?: Resolver<Array<ResolversTypes['OrganizationNotification']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DraftAppointmentPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['DraftAppointmentPage'] = ResolversParentTypes['DraftAppointmentPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['DraftAppointment']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DumpOrganizationsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DumpOrganizationsPayload'] = ResolversParentTypes['DumpOrganizationsPayload']> = ResolversObject<{
  organizationImportJobInformation?: Resolver<ResolversTypes['OrganizationImportJobInformation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EditDirectVisitorPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['EditDirectVisitorPayload'] = ResolversParentTypes['EditDirectVisitorPayload']> = ResolversObject<{
  directVisitor?: Resolver<ResolversTypes['DirectVisitor'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EncounterResolvers<ContextType = any, ParentType extends ResolversParentTypes['Encounter'] = ResolversParentTypes['Encounter']> = ResolversObject<{
  appointment?: Resolver<ResolversTypes['Appointment'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  notifiedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  rawId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['EncounterStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EventResolvers<ContextType = any, ParentType extends ResolversParentTypes['Event'] = ResolversParentTypes['Event']> = ResolversObject<{
  __resolveType: TypeResolveFn<'GuestPatientMedicationFollowupComment' | 'MedicationFollowupMessage' | 'MedicationFollowupQuestionnaireSheet' | 'PatientMedicationFollowupComment' | 'TracingReport', ParentType, ContextType>;
}>;

export type EventPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventPage'] = ResolversParentTypes['EventPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Event']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ExtendCompanySetupDocumentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExtendCompanySetupDocumentPayload'] = ResolversParentTypes['ExtendCompanySetupDocumentPayload']> = ResolversObject<{
  companySetupDocument?: Resolver<ResolversTypes['CompanySetupDocument'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ExtensionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Extension'] = ResolversParentTypes['Extension']> = ResolversObject<{
  code?: Resolver<ResolversTypes['ExtensionCode'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FaximoSendFaxResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaximoSendFax'] = ResolversParentTypes['FaximoSendFax']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  faxNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  file?: Resolver<Maybe<ResolversTypes['Blob']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['FaximoSendFaxStatus'], ParentType, ContextType>;
  tracingReport?: Resolver<Maybe<ResolversTypes['TracingReport']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FaximoSendFaxPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['FaximoSendFaxPage'] = ResolversParentTypes['FaximoSendFaxPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['FaximoSendFax']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['Feature'] = ResolversParentTypes['Feature']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  targetGroups?: Resolver<Array<ResolversTypes['FeatureTargetGroup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeatureTargetResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureTarget'] = ResolversParentTypes['FeatureTarget']> = ResolversObject<{
  __resolveType: TypeResolveFn<'Company' | 'Organization' | 'Patient' | 'Practitioner', ParentType, ContextType>;
}>;

export type FeatureTargetGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureTargetGroup'] = ResolversParentTypes['FeatureTargetGroup']> = ResolversObject<{
  end?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  feature?: Resolver<ResolversTypes['Feature'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ids?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['FeatureTargetGroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeatureUsageResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureUsage'] = ResolversParentTypes['FeatureUsage']> = ResolversObject<{
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  featureCode?: Resolver<ResolversTypes['PlanFeatureCode'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  kind?: Resolver<ResolversTypes['FeatureUsageKind'], ParentType, ContextType>;
  month?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeatureUsagePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeatureUsagePage'] = ResolversParentTypes['FeatureUsagePage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['FeatureUsage']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FeeSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeSetting'] = ResolversParentTypes['FeeSetting']> = ResolversObject<{
  __resolveType: TypeResolveFn<'CompanyFeeSetting' | 'OrganizationCompanyFeeSetting' | 'OrganizationFeeSetting', ParentType, ContextType>;
}>;

export type FeeSettingPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeSettingPage'] = ResolversParentTypes['FeeSettingPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['FeeSetting']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FetchMedixsReceptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FetchMedixsReceptionPayload'] = ResolversParentTypes['FetchMedixsReceptionPayload']> = ResolversObject<{
  medixsReceptions?: Resolver<Array<ResolversTypes['MedixsReception']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FinalizeDeliveryOutputPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinalizeDeliveryOutputPayload'] = ResolversParentTypes['FinalizeDeliveryOutputPayload']> = ResolversObject<{
  appointments?: Resolver<Array<ResolversTypes['Appointment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FinishAppointmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinishAppointmentPayload'] = ResolversParentTypes['FinishAppointmentPayload']> = ResolversObject<{
  appointment?: Resolver<ResolversTypes['Appointment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FinishCheckinEntryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinishCheckinEntryPayload'] = ResolversParentTypes['FinishCheckinEntryPayload']> = ResolversObject<{
  checkinEntries?: Resolver<Maybe<Array<ResolversTypes['CheckinEntry']>>, ParentType, ContextType>;
  checkinEntry?: Resolver<Maybe<ResolversTypes['CheckinEntry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FinishDraftAppointmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinishDraftAppointmentPayload'] = ResolversParentTypes['FinishDraftAppointmentPayload']> = ResolversObject<{
  draftAppointment?: Resolver<ResolversTypes['DraftAppointment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FinishEncounterPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinishEncounterPayload'] = ResolversParentTypes['FinishEncounterPayload']> = ResolversObject<{
  encounter?: Resolver<ResolversTypes['Encounter'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FinishOutpatientQuestionnaireEntryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinishOutpatientQuestionnaireEntryPayload'] = ResolversParentTypes['FinishOutpatientQuestionnaireEntryPayload']> = ResolversObject<{
  outpatientQuestionnaireEntry?: Resolver<ResolversTypes['OutpatientQuestionnaireEntry'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FulfillAppointmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['FulfillAppointmentPayload'] = ResolversParentTypes['FulfillAppointmentPayload']> = ResolversObject<{
  encounter?: Resolver<ResolversTypes['Encounter'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GendaApiKeyResolvers<ContextType = any, ParentType extends ResolversParentTypes['GendaApiKey'] = ResolversParentTypes['GendaApiKey']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['GendaApiKeyData'], ParentType, ContextType>;
  gendaSettings?: Resolver<ResolversTypes['GendaSettingPage'], ParentType, ContextType, Partial<GendaApiKeyGendaSettingsArgs>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GendaApiKeyDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['GendaApiKeyData'] = ResolversParentTypes['GendaApiKeyData']> = ResolversObject<{
  partnerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GendaSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['GendaSetting'] = ResolversParentTypes['GendaSetting']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  gendaApiKey?: Resolver<ResolversTypes['GendaApiKey'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GendaSettingPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['GendaSettingPage'] = ResolversParentTypes['GendaSettingPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GendaSetting']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateAgentArtifactPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateAgentArtifactPayload'] = ResolversParentTypes['GenerateAgentArtifactPayload']> = ResolversObject<{
  agent?: Resolver<ResolversTypes['Agent'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateBookmarkedPatientsCountCsvPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateBookmarkedPatientsCountCsvPayload'] = ResolversParentTypes['GenerateBookmarkedPatientsCountCsvPayload']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateClientCertCsvPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateClientCertCsvPayload'] = ResolversParentTypes['GenerateClientCertCsvPayload']> = ResolversObject<{
  clientCertJobInformation?: Resolver<ResolversTypes['ClientCertJobInformation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateCompanyMedicationFollowupMessageUsagesCsvPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateCompanyMedicationFollowupMessageUsagesCsvPayload'] = ResolversParentTypes['GenerateCompanyMedicationFollowupMessageUsagesCsvPayload']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateCompanyOrganizationsAppDownloadUrlsCsvPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateCompanyOrganizationsAppDownloadUrlsCsvPayload'] = ResolversParentTypes['GenerateCompanyOrganizationsAppDownloadUrlsCsvPayload']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateCompanyReceptionUsagesCsvPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateCompanyReceptionUsagesCsvPayload'] = ResolversParentTypes['GenerateCompanyReceptionUsagesCsvPayload']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateCompanyReceptionsCsvPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateCompanyReceptionsCsvPayload'] = ResolversParentTypes['GenerateCompanyReceptionsCsvPayload']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateCompanySalesDetailsCsvPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateCompanySalesDetailsCsvPayload'] = ResolversParentTypes['GenerateCompanySalesDetailsCsvPayload']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateCompanyTracingReportUsagesCsvPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateCompanyTracingReportUsagesCsvPayload'] = ResolversParentTypes['GenerateCompanyTracingReportUsagesCsvPayload']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateCsvForClientCertsImportPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateCsvForClientCertsImportPayload'] = ResolversParentTypes['GenerateCsvForClientCertsImportPayload']> = ResolversObject<{
  clientCertJobInformation?: Resolver<ResolversTypes['ClientCertJobInformation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateCsvForMessageTemplatesBulkDuplicatePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateCsvForMessageTemplatesBulkDuplicatePayload'] = ResolversParentTypes['GenerateCsvForMessageTemplatesBulkDuplicatePayload']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateCsvForUberOrganizationSettingsUpsertPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateCsvForUberOrganizationSettingsUpsertPayload'] = ResolversParentTypes['GenerateCsvForUberOrganizationSettingsUpsertPayload']> = ResolversObject<{
  uberOrganizationSettingJobInformation?: Resolver<ResolversTypes['UberOrganizationSettingJobInformation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateDeliveryCsvPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateDeliveryCsvPayload'] = ResolversParentTypes['GenerateDeliveryCsvPayload']> = ResolversObject<{
  appointments?: Resolver<Array<ResolversTypes['Appointment']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateIncentivePayoutNotificationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateIncentivePayoutNotificationPayload'] = ResolversParentTypes['GenerateIncentivePayoutNotificationPayload']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateOrganizationAuditEventCsvPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateOrganizationAuditEventCsvPayload'] = ResolversParentTypes['GenerateOrganizationAuditEventCsvPayload']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GeneratePayoutOrganizationsWithBankAccountCsvPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeneratePayoutOrganizationsWithBankAccountCsvPayload'] = ResolversParentTypes['GeneratePayoutOrganizationsWithBankAccountCsvPayload']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateUberSignaturePreviewFormDataPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateUberSignaturePreviewFormDataPayload'] = ResolversParentTypes['GenerateUberSignaturePreviewFormDataPayload']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateUberSignaturePreviewOnlyExtraTextPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateUberSignaturePreviewOnlyExtraTextPayload'] = ResolversParentTypes['GenerateUberSignaturePreviewOnlyExtraTextPayload']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GenerateUberSignaturePreviewPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenerateUberSignaturePreviewPayload'] = ResolversParentTypes['GenerateUberSignaturePreviewPayload']> = ResolversObject<{
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GuestPatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuestPatient'] = ResolversParentTypes['GuestPatient']> = ResolversObject<{
  __resolveType: TypeResolveFn<'DirectVisitor' | 'WebVisitor', ParentType, ContextType>;
}>;

export type GuestPatientMedicationFollowupCommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuestPatientMedicationFollowupComment'] = ResolversParentTypes['GuestPatientMedicationFollowupComment']> = ResolversObject<{
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GuestPatientMedicationFollowupCommentPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['GuestPatientMedicationFollowupCommentPage'] = ResolversParentTypes['GuestPatientMedicationFollowupCommentPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['GuestPatientMedicationFollowupComment']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HiccupAppointmentPermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['HiccupAppointmentPermission'] = ResolversParentTypes['HiccupAppointmentPermission']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  appointment?: Resolver<ResolversTypes['Appointment'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HiccupOnetimeApiCacheResolvers<ContextType = any, ParentType extends ResolversParentTypes['HiccupOnetimeApiCache'] = ResolversParentTypes['HiccupOnetimeApiCache']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  onetimeCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  patientProfile?: Resolver<ResolversTypes['HiccupOnetimeApiCachePatientProfile'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HiccupOnetimeApiCachePatientProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['HiccupOnetimeApiCachePatientProfile'] = ResolversParentTypes['HiccupOnetimeApiCachePatientProfile']> = ResolversObject<{
  kana?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HiccupTemporaryPermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['HiccupTemporaryPermission'] = ResolversParentTypes['HiccupTemporaryPermission']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HiccupTemporaryPermissionPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['HiccupTemporaryPermissionPage'] = ResolversParentTypes['HiccupTemporaryPermissionPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['HiccupTemporaryPermission']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HolidayResolvers<ContextType = any, ParentType extends ResolversParentTypes['Holiday'] = ResolversParentTypes['Holiday']> = ResolversObject<{
  date?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface Iso8601DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ISO8601Date'], any> {
  name: 'ISO8601Date';
}

export interface Iso8601DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ISO8601DateTime'], any> {
  name: 'ISO8601DateTime';
}

export type IdentifyMedixsPatientPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentifyMedixsPatientPayload'] = ResolversParentTypes['IdentifyMedixsPatientPayload']> = ResolversObject<{
  medixsPatient?: Resolver<ResolversTypes['MedixsPatient'], ParentType, ContextType>;
  medixsReception?: Resolver<ResolversTypes['MedixsReception'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IdentifyMedixsReceptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['IdentifyMedixsReceptionPayload'] = ResolversParentTypes['IdentifyMedixsReceptionPayload']> = ResolversObject<{
  medixsReception?: Resolver<ResolversTypes['MedixsReception'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ImportClientCertsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportClientCertsPayload'] = ResolversParentTypes['ImportClientCertsPayload']> = ResolversObject<{
  clientCertJobInformation?: Resolver<ResolversTypes['ClientCertJobInformation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ImportOrganizationsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportOrganizationsPayload'] = ResolversParentTypes['ImportOrganizationsPayload']> = ResolversObject<{
  organizationImportJobInformation?: Resolver<ResolversTypes['OrganizationImportJobInformation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ImportUberOrganizationsCsvPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportUberOrganizationsCsvPayload'] = ResolversParentTypes['ImportUberOrganizationsCsvPayload']> = ResolversObject<{
  uberOrganizationImportJobInformation?: Resolver<ResolversTypes['UberOrganizationImportJobInformation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvitationCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvitationCode'] = ResolversParentTypes['InvitationCode']> = ResolversObject<{
  accreteMessage?: Resolver<Maybe<ResolversTypes['AccreteMessage']>, ParentType, ContextType>;
  appointment?: Resolver<Maybe<ResolversTypes['Appointment']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  memo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvitationCodePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvitationCodePage'] = ResolversParentTypes['InvitationCodePage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['InvitationCode']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Invoice'] = ResolversParentTypes['Invoice']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lineItems?: Resolver<Array<ResolversTypes['LineItem']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['InvoiceStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IssueGendaApiKeyPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['IssueGendaApiKeyPayload'] = ResolversParentTypes['IssueGendaApiKeyPayload']> = ResolversObject<{
  gendaApiKey?: Resolver<ResolversTypes['GendaApiKey'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type LineItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LineItem'] = ResolversParentTypes['LineItem']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  chargeItems?: Resolver<Array<ResolversTypes['LineItemType']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['LineItemCode'], ParentType, ContextType>;
  sequence?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LineItemTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LineItemType'] = ResolversParentTypes['LineItemType']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['LineItemCode'], ParentType, ContextType>;
  sequence?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LoginUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginUser'] = ResolversParentTypes['LoginUser']> = ResolversObject<{
  __resolveType: TypeResolveFn<'Operator' | 'Practitioner', ParentType, ContextType>;
}>;

export type MarkAnnouncementPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarkAnnouncementPayload'] = ResolversParentTypes['MarkAnnouncementPayload']> = ResolversObject<{
  announcement?: Resolver<ResolversTypes['Announcement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarkHiccupTemporaryPermissionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarkHiccupTemporaryPermissionPayload'] = ResolversParentTypes['MarkHiccupTemporaryPermissionPayload']> = ResolversObject<{
  hiccupTemporaryPermission?: Resolver<ResolversTypes['HiccupTemporaryPermission'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarkOrganizationNotificationByAppointmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarkOrganizationNotificationByAppointmentPayload'] = ResolversParentTypes['MarkOrganizationNotificationByAppointmentPayload']> = ResolversObject<{
  organizationNotifications?: Resolver<Array<ResolversTypes['OrganizationNotification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MarkOrganizationNotificationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['MarkOrganizationNotificationPayload'] = ResolversParentTypes['MarkOrganizationNotificationPayload']> = ResolversObject<{
  organizationNotification?: Resolver<ResolversTypes['OrganizationNotification'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicalInstitutionSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicalInstitutionSetting'] = ResolversParentTypes['MedicalInstitutionSetting']> = ResolversObject<{
  attendingPhysicians?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  clinicalDepartments?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  contactPoint?: Resolver<Maybe<ResolversTypes['ContactPoint']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  medicalInstitutionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicalInstitutionSettingPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicalInstitutionSettingPage'] = ResolversParentTypes['MedicalInstitutionSettingPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MedicalInstitutionSetting']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupAutoReplySettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupAutoReplySetting'] = ResolversParentTypes['MedicationFollowupAutoReplySetting']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  questionnaireRevision?: Resolver<Maybe<ResolversTypes['MedicationFollowupQuestionnaireRevision']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupAutoReplySettingTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupAutoReplySettingTemplate'] = ResolversParentTypes['MedicationFollowupAutoReplySettingTemplate']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  questionnaireRevision?: Resolver<Maybe<ResolversTypes['MedicationFollowupQuestionnaireRevision']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupCommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupComment'] = ResolversParentTypes['MedicationFollowupComment']> = ResolversObject<{
  __resolveType: TypeResolveFn<'GuestPatientMedicationFollowupComment' | 'PatientMedicationFollowupComment', ParentType, ContextType>;
}>;

export type MedicationFollowupCommentPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupCommentPage'] = ResolversParentTypes['MedicationFollowupCommentPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MedicationFollowupComment']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupDraftMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupDraftMessage'] = ResolversParentTypes['MedicationFollowupDraftMessage']> = ResolversObject<{
  data?: Resolver<ResolversTypes['MedicationFollowupDraftMessageData'], ParentType, ContextType>;
  guestPatient?: Resolver<Maybe<ResolversTypes['GuestPatient']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupDraftMessageDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupDraftMessageData'] = ResolversParentTypes['MedicationFollowupDraftMessageData']> = ResolversObject<{
  autoReplySettingMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkboxAutoReplySetting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  checkboxAutoReplySettingQuestionnaire?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  checkboxRecommendation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  csClinic?: Resolver<Maybe<ResolversTypes['CsClinic']>, ParentType, ContextType>;
  fixedDate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  medicationFollowupQuestionnaire?: Resolver<Maybe<ResolversTypes['MedicationFollowupQuestionnaire']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sendDate?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  sendTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupDraftMessagePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupDraftMessagePage'] = ResolversParentTypes['MedicationFollowupDraftMessagePage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MedicationFollowupDraftMessage']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupMessage'] = ResolversParentTypes['MedicationFollowupMessage']> = ResolversObject<{
  appointment?: Resolver<Maybe<ResolversTypes['Appointment']>, ParentType, ContextType>;
  autoReplySetting?: Resolver<Maybe<ResolversTypes['MedicationFollowupAutoReplySetting']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  csClinic?: Resolver<Maybe<ResolversTypes['CsClinic']>, ParentType, ContextType>;
  directVisitor?: Resolver<Maybe<ResolversTypes['DirectVisitor']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAutoReplyMessage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  medicationFollowupQuestionnaireRevision?: Resolver<Maybe<ResolversTypes['MedicationFollowupQuestionnaireRevision']>, ParentType, ContextType>;
  medicationFollowupQuestionnaireSheet?: Resolver<Maybe<ResolversTypes['MedicationFollowupQuestionnaireSheet']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  messageDeliverResult?: Resolver<Maybe<ResolversTypes['MessageDeliverResult']>, ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  sendAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MedicationFollowupMessageStatus'], ParentType, ContextType>;
  webVisitor?: Resolver<Maybe<ResolversTypes['WebVisitor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupMessagePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupMessagePage'] = ResolversParentTypes['MedicationFollowupMessagePage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MedicationFollowupMessage']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupMessageTemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupMessageTemplate'] = ResolversParentTypes['MedicationFollowupMessageTemplate']> = ResolversObject<{
  active?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  autoReplySettingTemplate?: Resolver<Maybe<ResolversTypes['MedicationFollowupAutoReplySettingTemplate']>, ParentType, ContextType>;
  csClinic?: Resolver<Maybe<ResolversTypes['CsClinic']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  medicationFollowupQuestionnaire?: Resolver<Maybe<ResolversTypes['MedicationFollowupQuestionnaire']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sendTime?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  sendTiming?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  withRecommendation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupMessageTemplateJobInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupMessageTemplateJobInformation'] = ResolversParentTypes['MedicationFollowupMessageTemplateJobInformation']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  errorMessages?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sourceOrganization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobInformationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupMessageTemplatePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupMessageTemplatePage'] = ResolversParentTypes['MedicationFollowupMessageTemplatePage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MedicationFollowupMessageTemplate']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupQuestionnaireResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupQuestionnaire'] = ResolversParentTypes['MedicationFollowupQuestionnaire']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  default?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['MedicationFollowupQuestionnaireRevision'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupQuestionnaireChoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupQuestionnaireChoice'] = ResolversParentTypes['MedicationFollowupQuestionnaireChoice']> = ResolversObject<{
  goto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  group?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupQuestionnaireConditionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupQuestionnaireCondition'] = ResolversParentTypes['MedicationFollowupQuestionnaireCondition']> = ResolversObject<{
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupQuestionnaireFormDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupQuestionnaireFormData'] = ResolversParentTypes['MedicationFollowupQuestionnaireFormData']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sections?: Resolver<Array<ResolversTypes['MedicationFollowupQuestionnaireSection']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupQuestionnairePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupQuestionnairePage'] = ResolversParentTypes['MedicationFollowupQuestionnairePage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MedicationFollowupQuestionnaire']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupQuestionnaireQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupQuestionnaireQuestion'] = ResolversParentTypes['MedicationFollowupQuestionnaireQuestion']> = ResolversObject<{
  choices?: Resolver<Maybe<Array<ResolversTypes['MedicationFollowupQuestionnaireChoice']>>, ParentType, ContextType>;
  conditions?: Resolver<Maybe<Array<ResolversTypes['MedicationFollowupQuestionnaireCondition']>>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  other?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  otherGoto?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  placeholder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  questionType?: Resolver<ResolversTypes['MedicationFollowupQuestionnaireQuestionType'], ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupQuestionnaireRevisionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupQuestionnaireRevision'] = ResolversParentTypes['MedicationFollowupQuestionnaireRevision']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  formData?: Resolver<ResolversTypes['MedicationFollowupQuestionnaireFormData'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  medicationFollowupQuestionnaire?: Resolver<ResolversTypes['MedicationFollowupQuestionnaire'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupQuestionnaireSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupQuestionnaireSection'] = ResolversParentTypes['MedicationFollowupQuestionnaireSection']> = ResolversObject<{
  goto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  questions?: Resolver<Array<ResolversTypes['MedicationFollowupQuestionnaireQuestion']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupQuestionnaireSheetResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupQuestionnaireSheet'] = ResolversParentTypes['MedicationFollowupQuestionnaireSheet']> = ResolversObject<{
  answers?: Resolver<Array<ResolversTypes['QuestionnaireSheetAnswer']>, ParentType, ContextType>;
  appointment?: Resolver<Maybe<ResolversTypes['Appointment']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  medicationFollowupMessage?: Resolver<ResolversTypes['MedicationFollowupMessage'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupQuestionnaireSheetPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupQuestionnaireSheetPage'] = ResolversParentTypes['MedicationFollowupQuestionnaireSheetPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MedicationFollowupQuestionnaireSheet']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupSetting'] = ResolversParentTypes['MedicationFollowupSetting']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  statusManagement?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupUsageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupUsage'] = ResolversParentTypes['MedicationFollowupUsage']> = ResolversObject<{
  answerCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  appMessageCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  messageCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  questionnaireSheetCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  smsMessageCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unreadCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicationFollowupUsagePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicationFollowupUsagePage'] = ResolversParentTypes['MedicationFollowupUsagePage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MedicationFollowupUsage']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineResolvers<ContextType = any, ParentType extends ResolversParentTypes['Medicine'] = ResolversParentTypes['Medicine']> = ResolversObject<{
  productName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  yjCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNote'] = ResolversParentTypes['MedicineNote']> = ResolversObject<{
  notebookMemo?: Resolver<Maybe<ResolversTypes['MedicineNoteNotebookMemo']>, ParentType, ContextType>;
  otcDrugDosage?: Resolver<Maybe<ResolversTypes['MedicineNoteOtcDrugDosage']>, ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['MedicineNotePatient']>, ParentType, ContextType>;
  prescriptions?: Resolver<Maybe<Array<ResolversTypes['MedicineNotePrescription']>>, ParentType, ContextType>;
  primaryPharmacist?: Resolver<Maybe<ResolversTypes['MedicineNotePrimaryPharmacist']>, ParentType, ContextType>;
  splitControl?: Resolver<Maybe<ResolversTypes['MedicineNoteSplitControl']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['MedicineNoteVersion']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteClinicResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteClinic'] = ResolversParentTypes['MedicineNoteClinic']> = ResolversObject<{
  clinicRecord?: Resolver<Maybe<ResolversTypes['MedicineNoteClinicRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteClinicRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteClinicRecord'] = ResolversParentTypes['MedicineNoteClinicRecord']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prefecture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tensu?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteDispensingDateRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteDispensingDateRecord'] = ResolversParentTypes['MedicineNoteDispensingDateRecord']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteDispensingPharmacyResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteDispensingPharmacy'] = ResolversParentTypes['MedicineNoteDispensingPharmacy']> = ResolversObject<{
  dispensingDateRecord?: Resolver<Maybe<ResolversTypes['MedicineNoteDispensingDateRecord']>, ParentType, ContextType>;
  pharmacistRecord?: Resolver<Maybe<ResolversTypes['MedicineNotePharmacistRecord']>, ParentType, ContextType>;
  pharmacyRecord?: Resolver<Maybe<ResolversTypes['MedicineNotePharmacyRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteDoctorResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteDoctor'] = ResolversParentTypes['MedicineNoteDoctor']> = ResolversObject<{
  doctorRecord?: Resolver<Maybe<ResolversTypes['MedicineNoteDoctorRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteDoctorRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteDoctorRecord'] = ResolversParentTypes['MedicineNoteDoctorRecord']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  departmentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteDosageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteDosage'] = ResolversParentTypes['MedicineNoteDosage']> = ResolversObject<{
  dosagePlusRecords?: Resolver<Maybe<Array<ResolversTypes['MedicineNoteDosagePlusRecord']>>, ParentType, ContextType>;
  dosageRecord?: Resolver<Maybe<ResolversTypes['MedicineNoteDosageRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteDosageCautionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteDosageCaution'] = ResolversParentTypes['MedicineNoteDosageCaution']> = ResolversObject<{
  dosageCautionRecords?: Resolver<Maybe<Array<ResolversTypes['MedicineNoteDosageCautionRecord']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteDosageCautionRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteDosageCautionRecord'] = ResolversParentTypes['MedicineNoteDosageCautionRecord']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rpNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteDosagePlusRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteDosagePlusRecord'] = ResolversParentTypes['MedicineNoteDosagePlusRecord']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rpNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteDosageRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteDosageRecord'] = ResolversParentTypes['MedicineNoteDosageRecord']> = ResolversObject<{
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  formCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rpNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usageCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  usageCodeType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteMedicineResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteMedicine'] = ResolversParentTypes['MedicineNoteMedicine']> = ResolversObject<{
  medicineCautionRecords?: Resolver<Maybe<Array<ResolversTypes['MedicineNoteMedicineCautionRecord']>>, ParentType, ContextType>;
  medicinePlusRecords?: Resolver<Maybe<Array<ResolversTypes['MedicineNoteMedicinePlusRecord']>>, ParentType, ContextType>;
  medicineRecord?: Resolver<Maybe<ResolversTypes['MedicineNoteMedicineRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteMedicineCautionRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteMedicineCautionRecord'] = ResolversParentTypes['MedicineNoteMedicineCautionRecord']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rpNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteMedicinePlusRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteMedicinePlusRecord'] = ResolversParentTypes['MedicineNoteMedicinePlusRecord']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rpNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteMedicineRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteMedicineRecord'] = ResolversParentTypes['MedicineNoteMedicineRecord']> = ResolversObject<{
  amount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  genericCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  genericCodeType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  genericName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rpNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  unitName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteNotebookMemoResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteNotebookMemo'] = ResolversParentTypes['MedicineNoteNotebookMemo']> = ResolversObject<{
  notebookMemoRecords?: Resolver<Maybe<Array<ResolversTypes['MedicineNoteNotebookMemoRecord']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteNotebookMemoRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteNotebookMemoRecord'] = ResolversParentTypes['MedicineNoteNotebookMemoRecord']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  enteredAt?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteOtcDrugDosageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteOtcDrugDosage'] = ResolversParentTypes['MedicineNoteOtcDrugDosage']> = ResolversObject<{
  otcDrugDosagesRecords?: Resolver<Maybe<Array<ResolversTypes['MedicineNoteOtcDrugDosageRecord']>>, ParentType, ContextType>;
  otcDrugIngredientRecords?: Resolver<Maybe<Array<ResolversTypes['MedicineNoteOtcDrugIngredientRecord']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteOtcDrugDosageRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteOtcDrugDosageRecord'] = ResolversParentTypes['MedicineNoteOtcDrugDosageRecord']> = ResolversObject<{
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dosageRecordNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  janCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteOtcDrugIngredientRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteOtcDrugIngredientRecord'] = ResolversParentTypes['MedicineNoteOtcDrugIngredientRecord']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dosageRecordNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotePatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotePatient'] = ResolversParentTypes['MedicineNotePatient']> = ResolversObject<{
  patientRecord?: Resolver<Maybe<ResolversTypes['MedicineNotePatientRecord']>, ParentType, ContextType>;
  patientReportRecords?: Resolver<Maybe<Array<ResolversTypes['MedicineNotePatientReportRecord']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotePatientProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotePatientProfile'] = ResolversParentTypes['MedicineNotePatientProfile']> = ResolversObject<{
  notebookMemoRecords?: Resolver<Array<ResolversTypes['MedicineNoteNotebookMemoRecord']>, ParentType, ContextType>;
  patientReportRecords?: Resolver<Array<ResolversTypes['MedicineNotePatientReportRecord']>, ParentType, ContextType>;
  pfPatient?: Resolver<Maybe<ResolversTypes['PfPatient']>, ParentType, ContextType>;
  primaryPharmacistRecords?: Resolver<Array<ResolversTypes['MedicineNotePrimaryPharmacistRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotePatientRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotePatientRecord'] = ResolversParentTypes['MedicineNotePatientRecord']> = ResolversObject<{
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  birthDate?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  bloodType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emergency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kana?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sex?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotePatientReportRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotePatientReportRecord'] = ResolversParentTypes['MedicineNotePatientReportRecord']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotePharmacistRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotePharmacistRecord'] = ResolversParentTypes['MedicineNotePharmacistRecord']> = ResolversObject<{
  contact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotePharmacyRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotePharmacyRecord'] = ResolversParentTypes['MedicineNotePharmacyRecord']> = ResolversObject<{
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prefecture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tensu?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotePrecautionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotePrecaution'] = ResolversParentTypes['MedicineNotePrecaution']> = ResolversObject<{
  precautionRecords?: Resolver<Maybe<Array<ResolversTypes['MedicineNotePrecautionRecord']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotePrecautionRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotePrecautionRecord'] = ResolversParentTypes['MedicineNotePrecautionRecord']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotePrescriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotePrescription'] = ResolversParentTypes['MedicineNotePrescription']> = ResolversObject<{
  clinic?: Resolver<Maybe<ResolversTypes['MedicineNoteClinic']>, ParentType, ContextType>;
  dispensingPharmacy?: Resolver<Maybe<ResolversTypes['MedicineNoteDispensingPharmacy']>, ParentType, ContextType>;
  precaution?: Resolver<Maybe<ResolversTypes['MedicineNotePrecaution']>, ParentType, ContextType>;
  prescriptionMemo?: Resolver<Maybe<ResolversTypes['MedicineNotePrescriptionMemo']>, ParentType, ContextType>;
  prescriptionRecipes?: Resolver<Maybe<Array<ResolversTypes['MedicineNotePrescriptionRecipe']>>, ParentType, ContextType>;
  remaining?: Resolver<Maybe<ResolversTypes['MedicineNoteRemaining']>, ParentType, ContextType>;
  remark?: Resolver<Maybe<ResolversTypes['MedicineNoteRemark']>, ParentType, ContextType>;
  warning?: Resolver<Maybe<ResolversTypes['MedicineNoteWarning']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotePrescriptionMemoResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotePrescriptionMemo'] = ResolversParentTypes['MedicineNotePrescriptionMemo']> = ResolversObject<{
  prescriptionMemoRecords?: Resolver<Maybe<Array<ResolversTypes['MedicineNotePrescriptionMemoRecord']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotePrescriptionMemoRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotePrescriptionMemoRecord'] = ResolversParentTypes['MedicineNotePrescriptionMemoRecord']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enteredAt?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotePrescriptionRecipeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotePrescriptionRecipe'] = ResolversParentTypes['MedicineNotePrescriptionRecipe']> = ResolversObject<{
  doctor?: Resolver<Maybe<ResolversTypes['MedicineNoteDoctor']>, ParentType, ContextType>;
  recipeInformation?: Resolver<Maybe<Array<ResolversTypes['MedicineNoteRecipeInformation']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotePrimaryPharmacistResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotePrimaryPharmacist'] = ResolversParentTypes['MedicineNotePrimaryPharmacist']> = ResolversObject<{
  primaryPharmacistRecords?: Resolver<Maybe<Array<ResolversTypes['MedicineNotePrimaryPharmacistRecord']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotePrimaryPharmacistRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotePrimaryPharmacistRecord'] = ResolversParentTypes['MedicineNotePrimaryPharmacistRecord']> = ResolversObject<{
  contact?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  end?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pharmacyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteRecipeInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteRecipeInformation'] = ResolversParentTypes['MedicineNoteRecipeInformation']> = ResolversObject<{
  dosage?: Resolver<Maybe<ResolversTypes['MedicineNoteDosage']>, ParentType, ContextType>;
  dosageCaution?: Resolver<Maybe<ResolversTypes['MedicineNoteDosageCaution']>, ParentType, ContextType>;
  medicines?: Resolver<Maybe<Array<ResolversTypes['MedicineNoteMedicine']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteRemainingResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteRemaining'] = ResolversParentTypes['MedicineNoteRemaining']> = ResolversObject<{
  remainingRecords?: Resolver<Maybe<Array<ResolversTypes['MedicineNoteRemainingRecord']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteRemainingRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteRemainingRecord'] = ResolversParentTypes['MedicineNoteRemainingRecord']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteRemarkResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteRemark'] = ResolversParentTypes['MedicineNoteRemark']> = ResolversObject<{
  remarkRecords?: Resolver<Maybe<Array<ResolversTypes['MedicineNoteRemarkRecord']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteRemarkRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteRemarkRecord'] = ResolversParentTypes['MedicineNoteRemarkRecord']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteSplitControlResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteSplitControl'] = ResolversParentTypes['MedicineNoteSplitControl']> = ResolversObject<{
  splitControlRecord?: Resolver<Maybe<ResolversTypes['MedicineNoteSplitControlRecord']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteSplitControlRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteSplitControlRecord'] = ResolversParentTypes['MedicineNoteSplitControlRecord']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sequence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteVersionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteVersion'] = ResolversParentTypes['MedicineNoteVersion']> = ResolversObject<{
  versionRecord?: Resolver<ResolversTypes['MedicineNoteVersionRecord'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteVersionRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteVersionRecord'] = ResolversParentTypes['MedicineNoteVersionRecord']> = ResolversObject<{
  destinationType?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteWarningResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteWarning'] = ResolversParentTypes['MedicineNoteWarning']> = ResolversObject<{
  warningRecords?: Resolver<Maybe<Array<ResolversTypes['MedicineNoteWarningRecord']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNoteWarningRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNoteWarningRecord'] = ResolversParentTypes['MedicineNoteWarningRecord']> = ResolversObject<{
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creator?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotesByOnetimeCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotesByOnetimeCode'] = ResolversParentTypes['MedicineNotesByOnetimeCode']> = ResolversObject<{
  expiresAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  medicineNotes?: Resolver<Maybe<Array<ResolversTypes['MedicineNote']>>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resultCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicineNotesByPatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicineNotesByPatient'] = ResolversParentTypes['MedicineNotesByPatient']> = ResolversObject<{
  expiresAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  medicineNotes?: Resolver<Maybe<Array<ResolversTypes['MedicineNote']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedicinePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedicinePage'] = ResolversParentTypes['MedicinePage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Medicine']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedixsDispensingRecordResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedixsDispensingRecord'] = ResolversParentTypes['MedixsDispensingRecord']> = ResolversObject<{
  additionSum?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  basicAddition?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  claimAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  containerAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  contributionsAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  dispensingBasic?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  dispensingSum?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  history?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  insuranceScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lastUnpaidAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  managementSum?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  medicalMaterialsSum?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  medicineSum?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  otherAddition?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  otherAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  otherGuidance?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paymentAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scoreSumAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  unpaidAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedixsEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedixsEvent'] = ResolversParentTypes['MedixsEvent']> = ResolversObject<{
  eventDt?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  eventId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  eventTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedixsEventPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedixsEventPage'] = ResolversParentTypes['MedixsEventPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MedixsEvent']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedixsPatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedixsPatient'] = ResolversParentTypes['MedixsPatient']> = ResolversObject<{
  birthDate?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  events?: Resolver<ResolversTypes['EventPage'], ParentType, ContextType, Partial<MedixsPatientEventsArgs>>;
  gender?: Resolver<ResolversTypes['Sex'], ParentType, ContextType>;
  guestPatients?: Resolver<Array<ResolversTypes['GuestPatient']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  latestAppointment?: Resolver<Maybe<ResolversTypes['Appointment']>, ParentType, ContextType>;
  latestQuestionnaireSheet?: Resolver<Maybe<ResolversTypes['MedixsPatientQuestionnaireSheet']>, ParentType, ContextType>;
  medicationFollowupComments?: Resolver<ResolversTypes['MedicationFollowupCommentPage'], ParentType, ContextType, Partial<MedixsPatientMedicationFollowupCommentsArgs>>;
  medicationFollowupDraftMessage?: Resolver<Maybe<ResolversTypes['MedicationFollowupDraftMessage']>, ParentType, ContextType>;
  medicationFollowupStatus?: Resolver<Maybe<ResolversTypes['PatientMedicationFollowupStatus']>, ParentType, ContextType>;
  medixsEvents?: Resolver<ResolversTypes['MedixsEventPage'], ParentType, ContextType, Partial<MedixsPatientMedixsEventsArgs>>;
  mobilePhone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  patientCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  patientName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  patientNameKana?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pharmacyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tracingReportDraft?: Resolver<Maybe<ResolversTypes['TracingReportDraft']>, ParentType, ContextType>;
  visitedDate?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedixsPatientPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedixsPatientPage'] = ResolversParentTypes['MedixsPatientPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MedixsPatient']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedixsPatientQuestionnaireSheetResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedixsPatientQuestionnaireSheet'] = ResolversParentTypes['MedixsPatientQuestionnaireSheet']> = ResolversObject<{
  __resolveType: TypeResolveFn<'OutpatientQuestionnaireEntry' | 'QuestionnaireSheet', ParentType, ContextType>;
}>;

export type MedixsReceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedixsReception'] = ResolversParentTypes['MedixsReception']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  importTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  medicineNote?: Resolver<Maybe<ResolversTypes['MedicineNote']>, ParentType, ContextType>;
  medixsDispensingRecord?: Resolver<Maybe<ResolversTypes['MedixsDispensingRecord']>, ParentType, ContextType>;
  medixsPatient?: Resolver<ResolversTypes['MedixsPatient'], ParentType, ContextType>;
  patientCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pharmacyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prescriptions?: Resolver<Array<ResolversTypes['MedixsReceptionPrescription']>, ParentType, ContextType>;
  receptionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sendTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedixsReceptionPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedixsReceptionPage'] = ResolversParentTypes['MedixsReceptionPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MedixsReception']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedixsReceptionPrescriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedixsReceptionPrescription'] = ResolversParentTypes['MedixsReceptionPrescription']> = ResolversObject<{
  doctorName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  grantDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hospitalDepartmentName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hospitalName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  receptionNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MedixsSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['MedixsSetting'] = ResolversParentTypes['MedixsSetting']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  medixsPatients?: Resolver<ResolversTypes['MedixsPatientPage'], ParentType, ContextType, Partial<MedixsSettingMedixsPatientsArgs>>;
  medixsReceptions?: Resolver<ResolversTypes['MedixsReceptionPage'], ParentType, ContextType, RequireFields<MedixsSettingMedixsReceptionsArgs, 'patientId'>>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  pharmacyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MessageDeliverResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageDeliver'] = ResolversParentTypes['MessageDeliver']> = ResolversObject<{
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  patient?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MessageDeliverResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageDeliverResult'] = ResolversParentTypes['MessageDeliverResult']> = ResolversObject<{
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  guestPatient?: Resolver<Maybe<ResolversTypes['GuestPatient']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MessageDeliverResultStatus'], ParentType, ContextType>;
  system?: Resolver<ResolversTypes['MessageDeliverSystem'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MessageDeliverResultPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageDeliverResultPage'] = ResolversParentTypes['MessageDeliverResultPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MessageDeliverResult']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MonthlyPayoutStatementResolvers<ContextType = any, ParentType extends ResolversParentTypes['MonthlyPayoutStatement'] = ResolversParentTypes['MonthlyPayoutStatement']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  feeWithTax?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  month?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uberDeliveryFee?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uberDeliveryInvoiceFees?: Resolver<ResolversTypes['UberDeliveryInvoiceFeePage'], ParentType, ContextType, Partial<MonthlyPayoutStatementUberDeliveryInvoiceFeesArgs>>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MonthlyPayoutStatementPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['MonthlyPayoutStatementPage'] = ResolversParentTypes['MonthlyPayoutStatementPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['MonthlyPayoutStatement']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = ResolversObject<{
  activateAnnouncement?: Resolver<Maybe<ResolversTypes['ActivateAnnouncementPayload']>, ParentType, ContextType, RequireFields<MutationActivateAnnouncementArgs, 'input'>>;
  activateOtpSecret?: Resolver<Maybe<ResolversTypes['ActivateOtpSecretPayload']>, ParentType, ContextType, RequireFields<MutationActivateOtpSecretArgs, 'input'>>;
  addCompanyAddress?: Resolver<Maybe<ResolversTypes['AddCompanyAddressPayload']>, ParentType, ContextType, RequireFields<MutationAddCompanyAddressArgs, 'input'>>;
  addCompanyContactPoint?: Resolver<Maybe<ResolversTypes['AddCompanyContactPointPayload']>, ParentType, ContextType, RequireFields<MutationAddCompanyContactPointArgs, 'input'>>;
  addCompanyPractitioner?: Resolver<Maybe<ResolversTypes['AddCompanyPractitionerPayload']>, ParentType, ContextType, RequireFields<MutationAddCompanyPractitionerArgs, 'input'>>;
  addContractPlan?: Resolver<Maybe<ResolversTypes['AddContractPlanPayload']>, ParentType, ContextType, RequireFields<MutationAddContractPlanArgs, 'input'>>;
  addIncentiveTargetCompany?: Resolver<Maybe<ResolversTypes['AddIncentiveTargetCompanyPayload']>, ParentType, ContextType, RequireFields<MutationAddIncentiveTargetCompanyArgs, 'input'>>;
  addInvitationCode?: Resolver<Maybe<ResolversTypes['AddInvitationCodePayload']>, ParentType, ContextType, RequireFields<MutationAddInvitationCodeArgs, 'input'>>;
  addOrganizationAddress?: Resolver<Maybe<ResolversTypes['AddOrganizationAddressPayload']>, ParentType, ContextType, RequireFields<MutationAddOrganizationAddressArgs, 'input'>>;
  addOrganizationContactPoint?: Resolver<Maybe<ResolversTypes['AddOrganizationContactPointPayload']>, ParentType, ContextType, RequireFields<MutationAddOrganizationContactPointArgs, 'input'>>;
  addPatientAttachment?: Resolver<Maybe<ResolversTypes['AddPatientAttachmentPayload']>, ParentType, ContextType, RequireFields<MutationAddPatientAttachmentArgs, 'input'>>;
  addUberSignatureDraftExtraText?: Resolver<Maybe<ResolversTypes['AddUberSignatureDraftExtraTextPayload']>, ParentType, ContextType, RequireFields<MutationAddUberSignatureDraftExtraTextArgs, 'input'>>;
  allowOperatorAccessPermission?: Resolver<Maybe<ResolversTypes['AllowOperatorAccessPermissionPayload']>, ParentType, ContextType, RequireFields<MutationAllowOperatorAccessPermissionArgs, 'input'>>;
  appendIdToFeatureTargetGroup?: Resolver<Maybe<ResolversTypes['AppendIdToFeatureTargetGroupPayload']>, ParentType, ContextType, RequireFields<MutationAppendIdToFeatureTargetGroupArgs, 'input'>>;
  appendToFeatureTargetGroup?: Resolver<Maybe<ResolversTypes['AppendToFeatureTargetGroupPayload']>, ParentType, ContextType, RequireFields<MutationAppendToFeatureTargetGroupArgs, 'input'>>;
  approveUberSignature?: Resolver<Maybe<ResolversTypes['ApproveUberSignaturePayload']>, ParentType, ContextType, RequireFields<MutationApproveUberSignatureArgs, 'input'>>;
  bookAppointment?: Resolver<Maybe<ResolversTypes['BookAppointmentPayload']>, ParentType, ContextType, RequireFields<MutationBookAppointmentArgs, 'input'>>;
  bulkDuplicateMedicationFollowupMessageTemplates?: Resolver<Maybe<ResolversTypes['BulkDuplicateMedicationFollowupMessageTemplatesPayload']>, ParentType, ContextType, RequireFields<MutationBulkDuplicateMedicationFollowupMessageTemplatesArgs, 'input'>>;
  cancelAppointment?: Resolver<Maybe<ResolversTypes['CancelAppointmentPayload']>, ParentType, ContextType, RequireFields<MutationCancelAppointmentArgs, 'input'>>;
  cancelAppointmentViaWeb?: Resolver<Maybe<ResolversTypes['CancelAppointmentViaWebPayload']>, ParentType, ContextType, RequireFields<MutationCancelAppointmentViaWebArgs, 'input'>>;
  cancelAppointmentWithWebVisitor?: Resolver<Maybe<ResolversTypes['CancelAppointmentWithWebVisitorPayload']>, ParentType, ContextType, RequireFields<MutationCancelAppointmentWithWebVisitorArgs, 'input'>>;
  cancelDraftAppointment?: Resolver<Maybe<ResolversTypes['CancelDraftAppointmentPayload']>, ParentType, ContextType, RequireFields<MutationCancelDraftAppointmentArgs, 'input'>>;
  cancelOperatorAccessPermission?: Resolver<Maybe<ResolversTypes['CancelOperatorAccessPermissionPayload']>, ParentType, ContextType, RequireFields<MutationCancelOperatorAccessPermissionArgs, 'input'>>;
  changeDeliveryMethod?: Resolver<Maybe<ResolversTypes['ChangeDeliveryMethodPayload']>, ParentType, ContextType, RequireFields<MutationChangeDeliveryMethodArgs, 'input'>>;
  changeOutpatientQuestionnaireSettingQuestionnaireInUse?: Resolver<Maybe<ResolversTypes['ChangeOutpatientQuestionnaireSettingQuestionnaireInUsePayload']>, ParentType, ContextType, RequireFields<MutationChangeOutpatientQuestionnaireSettingQuestionnaireInUseArgs, 'input'>>;
  chargeWithApp?: Resolver<Maybe<ResolversTypes['ChargeWithAppPayload']>, ParentType, ContextType, RequireFields<MutationChargeWithAppArgs, 'input'>>;
  chargeWithApp2?: Resolver<Maybe<ResolversTypes['ChargeWithApp2Payload']>, ParentType, ContextType, RequireFields<MutationChargeWithApp2Args, 'input'>>;
  chargeWithCash?: Resolver<Maybe<ResolversTypes['ChargeWithCashPayload']>, ParentType, ContextType, RequireFields<MutationChargeWithCashArgs, 'input'>>;
  chargeWithCash2?: Resolver<Maybe<ResolversTypes['ChargeWithCash2Payload']>, ParentType, ContextType, RequireFields<MutationChargeWithCash2Args, 'input'>>;
  createAllowList?: Resolver<Maybe<ResolversTypes['CreateAllowListPayload']>, ParentType, ContextType, RequireFields<MutationCreateAllowListArgs, 'input'>>;
  createAnnouncement?: Resolver<Maybe<ResolversTypes['CreateAnnouncementPayload']>, ParentType, ContextType, RequireFields<MutationCreateAnnouncementArgs, 'input'>>;
  createAppointmentViaWeb?: Resolver<Maybe<ResolversTypes['CreateAppointmentViaWebPayload']>, ParentType, ContextType, RequireFields<MutationCreateAppointmentViaWebArgs, 'input'>>;
  createAuthTokenByProxy?: Resolver<Maybe<ResolversTypes['CreateAuthTokenByProxyPayload']>, ParentType, ContextType, RequireFields<MutationCreateAuthTokenByProxyArgs, 'input'>>;
  createCheckinEntry?: Resolver<Maybe<ResolversTypes['CreateCheckinEntryPayload']>, ParentType, ContextType, RequireFields<MutationCreateCheckinEntryArgs, 'input'>>;
  createClientCert?: Resolver<Maybe<ResolversTypes['CreateClientCertPayload']>, ParentType, ContextType, RequireFields<MutationCreateClientCertArgs, 'input'>>;
  createCompanyFeeSetting?: Resolver<Maybe<ResolversTypes['CreateCompanyFeeSettingPayload']>, ParentType, ContextType, RequireFields<MutationCreateCompanyFeeSettingArgs, 'input'>>;
  createCompanySetupDocument?: Resolver<Maybe<ResolversTypes['CreateCompanySetupDocumentPayload']>, ParentType, ContextType, RequireFields<MutationCreateCompanySetupDocumentArgs, 'input'>>;
  createDirectVisitor?: Resolver<Maybe<ResolversTypes['CreateDirectVisitorPayload']>, ParentType, ContextType, RequireFields<MutationCreateDirectVisitorArgs, 'input'>>;
  createFeature?: Resolver<Maybe<ResolversTypes['CreateFeaturePayload']>, ParentType, ContextType, RequireFields<MutationCreateFeatureArgs, 'input'>>;
  createFeatureTargetGroup?: Resolver<Maybe<ResolversTypes['CreateFeatureTargetGroupPayload']>, ParentType, ContextType, RequireFields<MutationCreateFeatureTargetGroupArgs, 'input'>>;
  createFeatureTargetGroupFromTarget?: Resolver<Maybe<ResolversTypes['CreateFeatureTargetGroupFromTargetPayload']>, ParentType, ContextType, RequireFields<MutationCreateFeatureTargetGroupFromTargetArgs, 'input'>>;
  createGendaSetting?: Resolver<Maybe<ResolversTypes['CreateGendaSettingPayload']>, ParentType, ContextType, RequireFields<MutationCreateGendaSettingArgs, 'input'>>;
  createGuestPatientFollowupComment?: Resolver<Maybe<ResolversTypes['CreateGuestPatientFollowupCommentPayload']>, ParentType, ContextType, RequireFields<MutationCreateGuestPatientFollowupCommentArgs, 'input'>>;
  createMedicalInstitutionSetting?: Resolver<Maybe<ResolversTypes['CreateMedicalInstitutionSettingPayload']>, ParentType, ContextType, RequireFields<MutationCreateMedicalInstitutionSettingArgs, 'input'>>;
  createMedicationFollowupMessage2?: Resolver<Maybe<ResolversTypes['CreateMedicationFollowupMessage2Payload']>, ParentType, ContextType, RequireFields<MutationCreateMedicationFollowupMessage2Args, 'input'>>;
  createMedicationFollowupMessageTemplate?: Resolver<Maybe<ResolversTypes['CreateMedicationFollowupMessageTemplatePayload']>, ParentType, ContextType, RequireFields<MutationCreateMedicationFollowupMessageTemplateArgs, 'input'>>;
  createMedicationFollowupQuestionnaire?: Resolver<Maybe<ResolversTypes['CreateMedicationFollowupQuestionnairePayload']>, ParentType, ContextType, RequireFields<MutationCreateMedicationFollowupQuestionnaireArgs, 'input'>>;
  createMedicationFollowupQuestionnaireSheet?: Resolver<Maybe<ResolversTypes['CreateMedicationFollowupQuestionnaireSheetPayload']>, ParentType, ContextType, RequireFields<MutationCreateMedicationFollowupQuestionnaireSheetArgs, 'input'>>;
  createMedixsSetting?: Resolver<Maybe<ResolversTypes['CreateMedixsSettingPayload']>, ParentType, ContextType, RequireFields<MutationCreateMedixsSettingArgs, 'input'>>;
  createMessageForWebVisitor?: Resolver<Maybe<ResolversTypes['CreateMessageForWebVisitorPayload']>, ParentType, ContextType, RequireFields<MutationCreateMessageForWebVisitorArgs, 'input'>>;
  createOperatorAuthority?: Resolver<Maybe<ResolversTypes['CreateOperatorAuthorityPayload']>, ParentType, ContextType, RequireFields<MutationCreateOperatorAuthorityArgs, 'input'>>;
  createOperatorRole?: Resolver<Maybe<ResolversTypes['CreateOperatorRolePayload']>, ParentType, ContextType, RequireFields<MutationCreateOperatorRoleArgs, 'input'>>;
  createOrganization?: Resolver<Maybe<ResolversTypes['CreateOrganizationPayload']>, ParentType, ContextType, RequireFields<MutationCreateOrganizationArgs, 'input'>>;
  createOrganizationCompanyFeeSetting?: Resolver<Maybe<ResolversTypes['CreateOrganizationCompanyFeeSettingPayload']>, ParentType, ContextType, RequireFields<MutationCreateOrganizationCompanyFeeSettingArgs, 'input'>>;
  createOrganizationFeeSetting?: Resolver<Maybe<ResolversTypes['CreateOrganizationFeeSettingPayload']>, ParentType, ContextType, RequireFields<MutationCreateOrganizationFeeSettingArgs, 'input'>>;
  createOtpSecret?: Resolver<Maybe<ResolversTypes['CreateOtpSecretPayload']>, ParentType, ContextType, RequireFields<MutationCreateOtpSecretArgs, 'input'>>;
  createOutpatientQuestionnaireEntry?: Resolver<Maybe<ResolversTypes['CreateOutpatientQuestionnaireEntryPayload']>, ParentType, ContextType, RequireFields<MutationCreateOutpatientQuestionnaireEntryArgs, 'input'>>;
  createOutpatientQuestionnaireSettingQuestionnaire?: Resolver<Maybe<ResolversTypes['CreateOutpatientQuestionnaireSettingQuestionnairePayload']>, ParentType, ContextType, RequireFields<MutationCreateOutpatientQuestionnaireSettingQuestionnaireArgs, 'input'>>;
  createPatientFollowupComment?: Resolver<Maybe<ResolversTypes['CreatePatientFollowupCommentPayload']>, ParentType, ContextType, RequireFields<MutationCreatePatientFollowupCommentArgs, 'input'>>;
  createPlan?: Resolver<Maybe<ResolversTypes['CreatePlanPayload']>, ParentType, ContextType, RequireFields<MutationCreatePlanArgs, 'input'>>;
  createPractitioner?: Resolver<Maybe<ResolversTypes['CreatePractitionerPayload']>, ParentType, ContextType, RequireFields<MutationCreatePractitionerArgs, 'input'>>;
  createTracingReport?: Resolver<Maybe<ResolversTypes['CreateTracingReportPayload']>, ParentType, ContextType, RequireFields<MutationCreateTracingReportArgs, 'input'>>;
  createUberAgreementExtension?: Resolver<Maybe<ResolversTypes['CreateUberAgreementExtensionPayload']>, ParentType, ContextType, RequireFields<MutationCreateUberAgreementExtensionArgs, 'input'>>;
  createUberDelivery?: Resolver<Maybe<ResolversTypes['CreateUberDeliveryPayload']>, ParentType, ContextType, RequireFields<MutationCreateUberDeliveryArgs, 'input'>>;
  deactivateAnnouncement?: Resolver<Maybe<ResolversTypes['DeactivateAnnouncementPayload']>, ParentType, ContextType, RequireFields<MutationDeactivateAnnouncementArgs, 'input'>>;
  deactivateCompany?: Resolver<Maybe<ResolversTypes['DeactivateCompanyPayload']>, ParentType, ContextType, RequireFields<MutationDeactivateCompanyArgs, 'input'>>;
  deactivateCompanyFeeSetting?: Resolver<Maybe<ResolversTypes['DeactivateCompanyFeeSettingPayload']>, ParentType, ContextType, RequireFields<MutationDeactivateCompanyFeeSettingArgs, 'input'>>;
  deactivateMedicationFollowupMessage?: Resolver<Maybe<ResolversTypes['DeactivateMedicationFollowupMessagePayload']>, ParentType, ContextType, RequireFields<MutationDeactivateMedicationFollowupMessageArgs, 'input'>>;
  deactivateMedicationFollowupMessageTemplate?: Resolver<Maybe<ResolversTypes['DeactivateMedicationFollowupMessageTemplatePayload']>, ParentType, ContextType, RequireFields<MutationDeactivateMedicationFollowupMessageTemplateArgs, 'input'>>;
  deactivateMedicationFollowupQuestionnaire?: Resolver<Maybe<ResolversTypes['DeactivateMedicationFollowupQuestionnairePayload']>, ParentType, ContextType, RequireFields<MutationDeactivateMedicationFollowupQuestionnaireArgs, 'input'>>;
  deactivateOperator?: Resolver<Maybe<ResolversTypes['DeactivateOperatorPayload']>, ParentType, ContextType, RequireFields<MutationDeactivateOperatorArgs, 'input'>>;
  deactivateOrganizationFeeSetting?: Resolver<Maybe<ResolversTypes['DeactivateOrganizationFeeSettingPayload']>, ParentType, ContextType, RequireFields<MutationDeactivateOrganizationFeeSettingArgs, 'input'>>;
  deactivateOtpSecrets?: Resolver<Maybe<ResolversTypes['DeactivateOtpSecretsPayload']>, ParentType, ContextType, RequireFields<MutationDeactivateOtpSecretsArgs, 'input'>>;
  deactivatePractitioner?: Resolver<Maybe<ResolversTypes['DeactivatePractitionerPayload']>, ParentType, ContextType, RequireFields<MutationDeactivatePractitionerArgs, 'input'>>;
  deleteAllowList?: Resolver<Maybe<ResolversTypes['DeleteAllowListPayload']>, ParentType, ContextType, RequireFields<MutationDeleteAllowListArgs, 'input'>>;
  deleteFeature?: Resolver<Maybe<ResolversTypes['DeleteFeaturePayload']>, ParentType, ContextType, RequireFields<MutationDeleteFeatureArgs, 'input'>>;
  deleteFeatureTargetGroup?: Resolver<Maybe<ResolversTypes['DeleteFeatureTargetGroupPayload']>, ParentType, ContextType, RequireFields<MutationDeleteFeatureTargetGroupArgs, 'input'>>;
  deleteFromFeatureTargetGroup?: Resolver<Maybe<ResolversTypes['DeleteFromFeatureTargetGroupPayload']>, ParentType, ContextType, RequireFields<MutationDeleteFromFeatureTargetGroupArgs, 'input'>>;
  deleteGuestPatientMedicationFollowupComment?: Resolver<Maybe<ResolversTypes['DeleteGuestPatientMedicationFollowupCommentPayload']>, ParentType, ContextType, RequireFields<MutationDeleteGuestPatientMedicationFollowupCommentArgs, 'input'>>;
  deleteIdFromFeatureTargetGroup?: Resolver<Maybe<ResolversTypes['DeleteIdFromFeatureTargetGroupPayload']>, ParentType, ContextType, RequireFields<MutationDeleteIdFromFeatureTargetGroupArgs, 'input'>>;
  deleteMedicationFollowupDraftMessage?: Resolver<Maybe<ResolversTypes['DeleteMedicationFollowupDraftMessagePayload']>, ParentType, ContextType, RequireFields<MutationDeleteMedicationFollowupDraftMessageArgs, 'input'>>;
  deleteOperatorAuthority?: Resolver<Maybe<ResolversTypes['DeleteOperatorAuthorityPayload']>, ParentType, ContextType, RequireFields<MutationDeleteOperatorAuthorityArgs, 'input'>>;
  deleteOperatorRole?: Resolver<Maybe<ResolversTypes['DeleteOperatorRolePayload']>, ParentType, ContextType, RequireFields<MutationDeleteOperatorRoleArgs, 'input'>>;
  deleteOrganization?: Resolver<Maybe<ResolversTypes['DeleteOrganizationPayload']>, ParentType, ContextType, RequireFields<MutationDeleteOrganizationArgs, 'input'>>;
  deleteOutpatientQuestionnaireSettingQuestionnaire?: Resolver<Maybe<ResolversTypes['DeleteOutpatientQuestionnaireSettingQuestionnairePayload']>, ParentType, ContextType, RequireFields<MutationDeleteOutpatientQuestionnaireSettingQuestionnaireArgs, 'input'>>;
  deletePatientAttachment?: Resolver<Maybe<ResolversTypes['DeletePatientAttachmentPayload']>, ParentType, ContextType, RequireFields<MutationDeletePatientAttachmentArgs, 'input'>>;
  deletePatientMedicationFollowupComment?: Resolver<Maybe<ResolversTypes['DeletePatientMedicationFollowupCommentPayload']>, ParentType, ContextType, RequireFields<MutationDeletePatientMedicationFollowupCommentArgs, 'input'>>;
  deleteTracingReportDraft?: Resolver<Maybe<ResolversTypes['DeleteTracingReportDraftPayload']>, ParentType, ContextType, RequireFields<MutationDeleteTracingReportDraftArgs, 'input'>>;
  downloadClientCert?: Resolver<Maybe<ResolversTypes['DownloadClientCertPayload']>, ParentType, ContextType, RequireFields<MutationDownloadClientCertArgs, 'input'>>;
  dumpOrganizations?: Resolver<Maybe<ResolversTypes['DumpOrganizationsPayload']>, ParentType, ContextType, RequireFields<MutationDumpOrganizationsArgs, 'input'>>;
  editDirectVisitor?: Resolver<Maybe<ResolversTypes['EditDirectVisitorPayload']>, ParentType, ContextType, RequireFields<MutationEditDirectVisitorArgs, 'input'>>;
  extendCompanySetupDocument?: Resolver<Maybe<ResolversTypes['ExtendCompanySetupDocumentPayload']>, ParentType, ContextType, RequireFields<MutationExtendCompanySetupDocumentArgs, 'input'>>;
  fetchMedixsReception?: Resolver<Maybe<ResolversTypes['FetchMedixsReceptionPayload']>, ParentType, ContextType, RequireFields<MutationFetchMedixsReceptionArgs, 'input'>>;
  finalizeDeliveryOutput?: Resolver<Maybe<ResolversTypes['FinalizeDeliveryOutputPayload']>, ParentType, ContextType, RequireFields<MutationFinalizeDeliveryOutputArgs, 'input'>>;
  finishAppointment?: Resolver<Maybe<ResolversTypes['FinishAppointmentPayload']>, ParentType, ContextType, RequireFields<MutationFinishAppointmentArgs, 'input'>>;
  finishCheckinEntry?: Resolver<Maybe<ResolversTypes['FinishCheckinEntryPayload']>, ParentType, ContextType, RequireFields<MutationFinishCheckinEntryArgs, 'input'>>;
  finishDraftAppointment?: Resolver<Maybe<ResolversTypes['FinishDraftAppointmentPayload']>, ParentType, ContextType, RequireFields<MutationFinishDraftAppointmentArgs, 'input'>>;
  finishEncounter?: Resolver<Maybe<ResolversTypes['FinishEncounterPayload']>, ParentType, ContextType, RequireFields<MutationFinishEncounterArgs, 'input'>>;
  finishOutpatientQuestionnaireEntry?: Resolver<Maybe<ResolversTypes['FinishOutpatientQuestionnaireEntryPayload']>, ParentType, ContextType, RequireFields<MutationFinishOutpatientQuestionnaireEntryArgs, 'input'>>;
  fulfillAppointment?: Resolver<Maybe<ResolversTypes['FulfillAppointmentPayload']>, ParentType, ContextType, RequireFields<MutationFulfillAppointmentArgs, 'input'>>;
  generateAgentArtifact?: Resolver<Maybe<ResolversTypes['GenerateAgentArtifactPayload']>, ParentType, ContextType, RequireFields<MutationGenerateAgentArtifactArgs, 'input'>>;
  generateBookmarkedPatientsCountCsv?: Resolver<Maybe<ResolversTypes['GenerateBookmarkedPatientsCountCsvPayload']>, ParentType, ContextType, RequireFields<MutationGenerateBookmarkedPatientsCountCsvArgs, 'input'>>;
  generateClientCertCsv?: Resolver<Maybe<ResolversTypes['GenerateClientCertCsvPayload']>, ParentType, ContextType, RequireFields<MutationGenerateClientCertCsvArgs, 'input'>>;
  generateCompanyMedicationFollowupMessageUsagesCsv?: Resolver<Maybe<ResolversTypes['GenerateCompanyMedicationFollowupMessageUsagesCsvPayload']>, ParentType, ContextType, RequireFields<MutationGenerateCompanyMedicationFollowupMessageUsagesCsvArgs, 'input'>>;
  generateCompanyOrganizationsAppDownloadUrlsCsv?: Resolver<Maybe<ResolversTypes['GenerateCompanyOrganizationsAppDownloadUrlsCsvPayload']>, ParentType, ContextType, RequireFields<MutationGenerateCompanyOrganizationsAppDownloadUrlsCsvArgs, 'input'>>;
  generateCompanyReceptionUsagesCsv?: Resolver<Maybe<ResolversTypes['GenerateCompanyReceptionUsagesCsvPayload']>, ParentType, ContextType, RequireFields<MutationGenerateCompanyReceptionUsagesCsvArgs, 'input'>>;
  generateCompanyReceptionsCsv?: Resolver<Maybe<ResolversTypes['GenerateCompanyReceptionsCsvPayload']>, ParentType, ContextType, RequireFields<MutationGenerateCompanyReceptionsCsvArgs, 'input'>>;
  generateCompanySalesDetailsCsv?: Resolver<Maybe<ResolversTypes['GenerateCompanySalesDetailsCsvPayload']>, ParentType, ContextType, RequireFields<MutationGenerateCompanySalesDetailsCsvArgs, 'input'>>;
  generateCompanyTracingReportUsagesCsv?: Resolver<Maybe<ResolversTypes['GenerateCompanyTracingReportUsagesCsvPayload']>, ParentType, ContextType, RequireFields<MutationGenerateCompanyTracingReportUsagesCsvArgs, 'input'>>;
  generateCsvForClientCertsImport?: Resolver<Maybe<ResolversTypes['GenerateCsvForClientCertsImportPayload']>, ParentType, ContextType, RequireFields<MutationGenerateCsvForClientCertsImportArgs, 'input'>>;
  generateCsvForMessageTemplatesBulkDuplicate?: Resolver<Maybe<ResolversTypes['GenerateCsvForMessageTemplatesBulkDuplicatePayload']>, ParentType, ContextType, RequireFields<MutationGenerateCsvForMessageTemplatesBulkDuplicateArgs, 'input'>>;
  generateCsvForUberOrganizationSettingsUpsert?: Resolver<Maybe<ResolversTypes['GenerateCsvForUberOrganizationSettingsUpsertPayload']>, ParentType, ContextType, RequireFields<MutationGenerateCsvForUberOrganizationSettingsUpsertArgs, 'input'>>;
  generateDeliveryCsv?: Resolver<Maybe<ResolversTypes['GenerateDeliveryCsvPayload']>, ParentType, ContextType, RequireFields<MutationGenerateDeliveryCsvArgs, 'input'>>;
  generateIncentivePayoutNotification?: Resolver<Maybe<ResolversTypes['GenerateIncentivePayoutNotificationPayload']>, ParentType, ContextType, RequireFields<MutationGenerateIncentivePayoutNotificationArgs, 'input'>>;
  generateOrganizationAuditEventCsv?: Resolver<Maybe<ResolversTypes['GenerateOrganizationAuditEventCsvPayload']>, ParentType, ContextType, RequireFields<MutationGenerateOrganizationAuditEventCsvArgs, 'input'>>;
  generatePayoutOrganizationsWithBankAccountCsv?: Resolver<Maybe<ResolversTypes['GeneratePayoutOrganizationsWithBankAccountCsvPayload']>, ParentType, ContextType, RequireFields<MutationGeneratePayoutOrganizationsWithBankAccountCsvArgs, 'input'>>;
  generateUberSignaturePreview?: Resolver<Maybe<ResolversTypes['GenerateUberSignaturePreviewPayload']>, ParentType, ContextType, RequireFields<MutationGenerateUberSignaturePreviewArgs, 'input'>>;
  generateUberSignaturePreviewFormData?: Resolver<Maybe<ResolversTypes['GenerateUberSignaturePreviewFormDataPayload']>, ParentType, ContextType, RequireFields<MutationGenerateUberSignaturePreviewFormDataArgs, 'input'>>;
  generateUberSignaturePreviewOnlyExtraText?: Resolver<Maybe<ResolversTypes['GenerateUberSignaturePreviewOnlyExtraTextPayload']>, ParentType, ContextType, RequireFields<MutationGenerateUberSignaturePreviewOnlyExtraTextArgs, 'input'>>;
  identifyMedixsPatient?: Resolver<Maybe<ResolversTypes['IdentifyMedixsPatientPayload']>, ParentType, ContextType, RequireFields<MutationIdentifyMedixsPatientArgs, 'input'>>;
  identifyMedixsReception?: Resolver<Maybe<ResolversTypes['IdentifyMedixsReceptionPayload']>, ParentType, ContextType, RequireFields<MutationIdentifyMedixsReceptionArgs, 'input'>>;
  importClientCerts?: Resolver<Maybe<ResolversTypes['ImportClientCertsPayload']>, ParentType, ContextType, RequireFields<MutationImportClientCertsArgs, 'input'>>;
  importOrganizations?: Resolver<Maybe<ResolversTypes['ImportOrganizationsPayload']>, ParentType, ContextType, RequireFields<MutationImportOrganizationsArgs, 'input'>>;
  importUberOrganizationsCsv?: Resolver<Maybe<ResolversTypes['ImportUberOrganizationsCsvPayload']>, ParentType, ContextType, RequireFields<MutationImportUberOrganizationsCsvArgs, 'input'>>;
  issueGendaApiKey?: Resolver<Maybe<ResolversTypes['IssueGendaApiKeyPayload']>, ParentType, ContextType, RequireFields<MutationIssueGendaApiKeyArgs, 'input'>>;
  markAnnouncement?: Resolver<Maybe<ResolversTypes['MarkAnnouncementPayload']>, ParentType, ContextType, RequireFields<MutationMarkAnnouncementArgs, 'input'>>;
  markHiccupTemporaryPermission?: Resolver<Maybe<ResolversTypes['MarkHiccupTemporaryPermissionPayload']>, ParentType, ContextType, RequireFields<MutationMarkHiccupTemporaryPermissionArgs, 'input'>>;
  markOrganizationNotification?: Resolver<Maybe<ResolversTypes['MarkOrganizationNotificationPayload']>, ParentType, ContextType, RequireFields<MutationMarkOrganizationNotificationArgs, 'input'>>;
  markOrganizationNotificationByAppointment?: Resolver<Maybe<ResolversTypes['MarkOrganizationNotificationByAppointmentPayload']>, ParentType, ContextType, RequireFields<MutationMarkOrganizationNotificationByAppointmentArgs, 'input'>>;
  notifyCheckinEntry?: Resolver<Maybe<ResolversTypes['NotifyCheckinEntryPayload']>, ParentType, ContextType, RequireFields<MutationNotifyCheckinEntryArgs, 'input'>>;
  notifyOutpatientQuestionnaireEntry?: Resolver<Maybe<ResolversTypes['NotifyOutpatientQuestionnaireEntryPayload']>, ParentType, ContextType, RequireFields<MutationNotifyOutpatientQuestionnaireEntryArgs, 'input'>>;
  rechargeWithApp?: Resolver<Maybe<ResolversTypes['RechargeWithAppPayload']>, ParentType, ContextType, RequireFields<MutationRechargeWithAppArgs, 'input'>>;
  rechargeWithCash?: Resolver<Maybe<ResolversTypes['RechargeWithCashPayload']>, ParentType, ContextType, RequireFields<MutationRechargeWithCashArgs, 'input'>>;
  recreateTracingReport?: Resolver<Maybe<ResolversTypes['RecreateTracingReportPayload']>, ParentType, ContextType, RequireFields<MutationRecreateTracingReportArgs, 'input'>>;
  remandUberSignature?: Resolver<Maybe<ResolversTypes['RemandUberSignaturePayload']>, ParentType, ContextType, RequireFields<MutationRemandUberSignatureArgs, 'input'>>;
  removeCompanyAddress?: Resolver<Maybe<ResolversTypes['RemoveCompanyAddressPayload']>, ParentType, ContextType, RequireFields<MutationRemoveCompanyAddressArgs, 'input'>>;
  removeCompanyContactPoint?: Resolver<Maybe<ResolversTypes['RemoveCompanyContactPointPayload']>, ParentType, ContextType, RequireFields<MutationRemoveCompanyContactPointArgs, 'input'>>;
  removeCompanySetupDocument?: Resolver<Maybe<ResolversTypes['RemoveCompanySetupDocumentPayload']>, ParentType, ContextType, RequireFields<MutationRemoveCompanySetupDocumentArgs, 'input'>>;
  removeMedicalInstitutionSetting?: Resolver<Maybe<ResolversTypes['RemoveMedicalInstitutionSettingPayload']>, ParentType, ContextType, RequireFields<MutationRemoveMedicalInstitutionSettingArgs, 'input'>>;
  removeOrganizationContactPoint?: Resolver<Maybe<ResolversTypes['RemoveOrganizationContactPointPayload']>, ParentType, ContextType, RequireFields<MutationRemoveOrganizationContactPointArgs, 'input'>>;
  removeWebBookingsExceptionBusinessHour?: Resolver<Maybe<ResolversTypes['RemoveWebBookingsExceptionBusinessHourPayload']>, ParentType, ContextType, RequireFields<MutationRemoveWebBookingsExceptionBusinessHourArgs, 'input'>>;
  requestAppointment?: Resolver<Maybe<ResolversTypes['RequestAppointmentPayload']>, ParentType, ContextType, RequireFields<MutationRequestAppointmentArgs, 'input'>>;
  resendAuthenticationCode?: Resolver<Maybe<ResolversTypes['ResendAuthenticationCodePayload']>, ParentType, ContextType, RequireFields<MutationResendAuthenticationCodeArgs, 'input'>>;
  restartAgent?: Resolver<Maybe<ResolversTypes['RestartAgentPayload']>, ParentType, ContextType, RequireFields<MutationRestartAgentArgs, 'input'>>;
  resumeWebBookings?: Resolver<Maybe<ResolversTypes['ResumeWebBookingsPayload']>, ParentType, ContextType, RequireFields<MutationResumeWebBookingsArgs, 'input'>>;
  revokeClientCert?: Resolver<Maybe<ResolversTypes['RevokeClientCertPayload']>, ParentType, ContextType, RequireFields<MutationRevokeClientCertArgs, 'input'>>;
  sendAuthenticationCodeAndRegisterPatientEmail?: Resolver<Maybe<ResolversTypes['SendAuthenticationCodeAndRegisterPatientEmailPayload']>, ParentType, ContextType, RequireFields<MutationSendAuthenticationCodeAndRegisterPatientEmailArgs, 'input'>>;
  sendCallNotification?: Resolver<Maybe<ResolversTypes['SendCallNotificationPayload']>, ParentType, ContextType, RequireFields<MutationSendCallNotificationArgs, 'input'>>;
  sendClientCertMail?: Resolver<Maybe<ResolversTypes['SendClientCertMailPayload']>, ParentType, ContextType, RequireFields<MutationSendClientCertMailArgs, 'input'>>;
  sendCongestionNotification?: Resolver<Maybe<ResolversTypes['SendCongestionNotificationPayload']>, ParentType, ContextType, RequireFields<MutationSendCongestionNotificationArgs, 'input'>>;
  sendCongestionNotificationForWebVisitor?: Resolver<Maybe<ResolversTypes['SendCongestionNotificationForWebVisitorPayload']>, ParentType, ContextType, RequireFields<MutationSendCongestionNotificationForWebVisitorArgs, 'input'>>;
  sendDispensingPreparedNotification?: Resolver<Maybe<ResolversTypes['SendDispensingPreparedNotificationPayload']>, ParentType, ContextType, RequireFields<MutationSendDispensingPreparedNotificationArgs, 'input'>>;
  sendInvitationSms?: Resolver<Maybe<ResolversTypes['SendInvitationSmsPayload']>, ParentType, ContextType, RequireFields<MutationSendInvitationSmsArgs, 'input'>>;
  sendPractitionerCodeMail?: Resolver<Maybe<ResolversTypes['SendPractitionerCodeMailPayload']>, ParentType, ContextType, RequireFields<MutationSendPractitionerCodeMailArgs, 'input'>>;
  sendTracingReport?: Resolver<Maybe<ResolversTypes['SendTracingReportPayload']>, ParentType, ContextType, RequireFields<MutationSendTracingReportArgs, 'input'>>;
  setPractitionerRole?: Resolver<Maybe<ResolversTypes['SetPractitionerRolePayload']>, ParentType, ContextType, RequireFields<MutationSetPractitionerRoleArgs, 'input'>>;
  signupCompany?: Resolver<Maybe<ResolversTypes['SignupCompanyPayload']>, ParentType, ContextType, RequireFields<MutationSignupCompanyArgs, 'input'>>;
  signupPfPatientFromCheckinEntry?: Resolver<Maybe<ResolversTypes['SignupPfPatientFromCheckinEntryPayload']>, ParentType, ContextType, RequireFields<MutationSignupPfPatientFromCheckinEntryArgs, 'input'>>;
  signupPfPatientFromOutpatientQuestionnaireEntry?: Resolver<Maybe<ResolversTypes['SignupPfPatientFromOutpatientQuestionnaireEntryPayload']>, ParentType, ContextType, RequireFields<MutationSignupPfPatientFromOutpatientQuestionnaireEntryArgs, 'input'>>;
  skipEncounter?: Resolver<Maybe<ResolversTypes['SkipEncounterPayload']>, ParentType, ContextType, RequireFields<MutationSkipEncounterArgs, 'input'>>;
  subscribeChannel?: Resolver<Maybe<ResolversTypes['SubscribeChannelPayload']>, ParentType, ContextType, RequireFields<MutationSubscribeChannelArgs, 'input'>>;
  suspendWebBookings?: Resolver<Maybe<ResolversTypes['SuspendWebBookingsPayload']>, ParentType, ContextType, RequireFields<MutationSuspendWebBookingsArgs, 'input'>>;
  unidentifyMedixsPatient?: Resolver<Maybe<ResolversTypes['UnidentifyMedixsPatientPayload']>, ParentType, ContextType, RequireFields<MutationUnidentifyMedixsPatientArgs, 'input'>>;
  unidentifyMedixsReception?: Resolver<Maybe<ResolversTypes['UnidentifyMedixsReceptionPayload']>, ParentType, ContextType, RequireFields<MutationUnidentifyMedixsReceptionArgs, 'input'>>;
  unpublishOrganization?: Resolver<Maybe<ResolversTypes['UnpublishOrganizationPayload']>, ParentType, ContextType, RequireFields<MutationUnpublishOrganizationArgs, 'input'>>;
  unsubscribeChannel?: Resolver<Maybe<ResolversTypes['UnsubscribeChannelPayload']>, ParentType, ContextType, RequireFields<MutationUnsubscribeChannelArgs, 'input'>>;
  updateAgentDescription?: Resolver<Maybe<ResolversTypes['UpdateAgentDescriptionPayload']>, ParentType, ContextType, RequireFields<MutationUpdateAgentDescriptionArgs, 'input'>>;
  updateAgentPrintPrescriptionSetting?: Resolver<Maybe<ResolversTypes['UpdatePrintPrescriptionSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpdateAgentPrintPrescriptionSettingArgs, 'input'>>;
  updateAnnouncement?: Resolver<Maybe<ResolversTypes['UpdateAnnouncementPayload']>, ParentType, ContextType, RequireFields<MutationUpdateAnnouncementArgs, 'input'>>;
  updateAppointmentDeliveryMethod?: Resolver<Maybe<ResolversTypes['UpdateAppointmentDeliveryMethodPayload']>, ParentType, ContextType, RequireFields<MutationUpdateAppointmentDeliveryMethodArgs, 'input'>>;
  updateAppointmentDescription?: Resolver<Maybe<ResolversTypes['UpdateAppointmentDescriptionPayload']>, ParentType, ContextType, RequireFields<MutationUpdateAppointmentDescriptionArgs, 'input'>>;
  updateB2cloudSetting?: Resolver<Maybe<ResolversTypes['UpdateB2cloudSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpdateB2cloudSettingArgs, 'input'>>;
  updateBankAccount?: Resolver<Maybe<ResolversTypes['UpdateBankAccountPayload']>, ParentType, ContextType, RequireFields<MutationUpdateBankAccountArgs, 'input'>>;
  updateCheckinDescription?: Resolver<Maybe<ResolversTypes['UpdateCheckinDescriptionPayload']>, ParentType, ContextType, RequireFields<MutationUpdateCheckinDescriptionArgs, 'input'>>;
  updateCheckinSetting?: Resolver<Maybe<ResolversTypes['UpdateCheckinSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpdateCheckinSettingArgs, 'input'>>;
  updateCompany?: Resolver<Maybe<ResolversTypes['UpdateCompanyPayload']>, ParentType, ContextType, RequireFields<MutationUpdateCompanyArgs, 'input'>>;
  updateCompanyAddress?: Resolver<Maybe<ResolversTypes['UpdateCompanyAddressPayload']>, ParentType, ContextType, RequireFields<MutationUpdateCompanyAddressArgs, 'input'>>;
  updateCompanyAgentSetting?: Resolver<Maybe<ResolversTypes['UpdateCompanyAgentSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpdateCompanyAgentSettingArgs, 'input'>>;
  updateCompanyContactPoint?: Resolver<Maybe<ResolversTypes['UpdateCompanyContactPointPayload']>, ParentType, ContextType, RequireFields<MutationUpdateCompanyContactPointArgs, 'input'>>;
  updateCompanyFeeSetting?: Resolver<Maybe<ResolversTypes['UpdateCompanyFeeSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpdateCompanyFeeSettingArgs, 'input'>>;
  updateCompanyPractitioner?: Resolver<Maybe<ResolversTypes['UpdateCompanyPractitionerPayload']>, ParentType, ContextType, RequireFields<MutationUpdateCompanyPractitionerArgs, 'input'>>;
  updateCompanySessionSetting?: Resolver<Maybe<ResolversTypes['UpdateCompanySessionSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpdateCompanySessionSettingArgs, 'input'>>;
  updateContract?: Resolver<Maybe<ResolversTypes['UpdateContractPayload']>, ParentType, ContextType, RequireFields<MutationUpdateContractArgs, 'input'>>;
  updateContractPlan?: Resolver<Maybe<ResolversTypes['UpdateContractPlanPayload']>, ParentType, ContextType, RequireFields<MutationUpdateContractPlanArgs, 'input'>>;
  updateDraftAppointmentDescription?: Resolver<Maybe<ResolversTypes['UpdateDraftAppointmentDescriptionPayload']>, ParentType, ContextType, RequireFields<MutationUpdateDraftAppointmentDescriptionArgs, 'input'>>;
  updateFeature?: Resolver<Maybe<ResolversTypes['UpdateFeaturePayload']>, ParentType, ContextType, RequireFields<MutationUpdateFeatureArgs, 'input'>>;
  updateFeatureTargetGroup?: Resolver<Maybe<ResolversTypes['UpdateFeatureTargetGroupPayload']>, ParentType, ContextType, RequireFields<MutationUpdateFeatureTargetGroupArgs, 'input'>>;
  updateGendaApiKey?: Resolver<Maybe<ResolversTypes['UpdateGendaApiKeyPayload']>, ParentType, ContextType, RequireFields<MutationUpdateGendaApiKeyArgs, 'input'>>;
  updateGendaSetting?: Resolver<Maybe<ResolversTypes['UpdateGendaSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpdateGendaSettingArgs, 'input'>>;
  updateGuestPatientFollowupComment?: Resolver<Maybe<ResolversTypes['UpdateGuestPatientFollowupCommentPayload']>, ParentType, ContextType, RequireFields<MutationUpdateGuestPatientFollowupCommentArgs, 'input'>>;
  updateMedicalInstitutionSetting?: Resolver<Maybe<ResolversTypes['UpdateMedicalInstitutionSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpdateMedicalInstitutionSettingArgs, 'input'>>;
  updateMedicationFollowupMessage2?: Resolver<Maybe<ResolversTypes['UpdateMedicationFollowupMessage2Payload']>, ParentType, ContextType, RequireFields<MutationUpdateMedicationFollowupMessage2Args, 'input'>>;
  updateMedicationFollowupMessageTemplate?: Resolver<Maybe<ResolversTypes['UpdateMedicationFollowupMessageTemplatePayload']>, ParentType, ContextType, RequireFields<MutationUpdateMedicationFollowupMessageTemplateArgs, 'input'>>;
  updateMedicationFollowupQuestionnaire?: Resolver<Maybe<ResolversTypes['UpdateMedicationFollowupQuestionnairePayload']>, ParentType, ContextType, RequireFields<MutationUpdateMedicationFollowupQuestionnaireArgs, 'input'>>;
  updateMedicationFollowupQuestionnairePosition?: Resolver<Maybe<ResolversTypes['UpdateMedicationFollowupQuestionnairePositionPayload']>, ParentType, ContextType, RequireFields<MutationUpdateMedicationFollowupQuestionnairePositionArgs, 'input'>>;
  updateMedixsSetting?: Resolver<Maybe<ResolversTypes['UpdateMedixsSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpdateMedixsSettingArgs, 'input'>>;
  updateNotificationSetting?: Resolver<Maybe<ResolversTypes['UpdateNotificationSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpdateNotificationSettingArgs, 'input'>>;
  updateOperatorRole?: Resolver<Maybe<ResolversTypes['UpdateOperatorRolePayload']>, ParentType, ContextType, RequireFields<MutationUpdateOperatorRoleArgs, 'input'>>;
  updateOrganization?: Resolver<Maybe<ResolversTypes['UpdateOrganizationPayload']>, ParentType, ContextType, RequireFields<MutationUpdateOrganizationArgs, 'input'>>;
  updateOrganizationAddress?: Resolver<Maybe<ResolversTypes['UpdateOrganizationAddressPayload']>, ParentType, ContextType, RequireFields<MutationUpdateOrganizationAddressArgs, 'input'>>;
  updateOrganizationCompanyFeeSetting?: Resolver<Maybe<ResolversTypes['UpdateOrganizationCompanyFeeSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpdateOrganizationCompanyFeeSettingArgs, 'input'>>;
  updateOrganizationContactPoint?: Resolver<Maybe<ResolversTypes['UpdateOrganizationContactPointPayload']>, ParentType, ContextType, RequireFields<MutationUpdateOrganizationContactPointArgs, 'input'>>;
  updateOrganizationFeeSetting?: Resolver<Maybe<ResolversTypes['UpdateOrganizationFeeSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpdateOrganizationFeeSettingArgs, 'input'>>;
  updateOutpatientQuestionnaireDescription?: Resolver<Maybe<ResolversTypes['UpdateOutpatientQuestionnaireDescriptionPayload']>, ParentType, ContextType, RequireFields<MutationUpdateOutpatientQuestionnaireDescriptionArgs, 'input'>>;
  updateOutpatientQuestionnaireSetting?: Resolver<Maybe<ResolversTypes['UpdateOutpatientQuestionnaireSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpdateOutpatientQuestionnaireSettingArgs, 'input'>>;
  updateOutpatientQuestionnaireSettingQuestionnaire?: Resolver<Maybe<ResolversTypes['UpdateOutpatientQuestionnaireSettingQuestionnairePayload']>, ParentType, ContextType, RequireFields<MutationUpdateOutpatientQuestionnaireSettingQuestionnaireArgs, 'input'>>;
  updatePatientFollowupComment?: Resolver<Maybe<ResolversTypes['UpdatePatientFollowupCommentPayload']>, ParentType, ContextType, RequireFields<MutationUpdatePatientFollowupCommentArgs, 'input'>>;
  updatePlan?: Resolver<Maybe<ResolversTypes['UpdatePlanPayload']>, ParentType, ContextType, RequireFields<MutationUpdatePlanArgs, 'input'>>;
  updatePractitioner?: Resolver<Maybe<ResolversTypes['UpdatePractitionerPayload']>, ParentType, ContextType, RequireFields<MutationUpdatePractitionerArgs, 'input'>>;
  updatePractitionerAuthentication?: Resolver<Maybe<ResolversTypes['UpdatePractitionerAuthenticationPayload']>, ParentType, ContextType, RequireFields<MutationUpdatePractitionerAuthenticationArgs, 'input'>>;
  updatePractitionerCode?: Resolver<Maybe<ResolversTypes['UpdatePractitionerCodePayload']>, ParentType, ContextType, RequireFields<MutationUpdatePractitionerCodeArgs, 'input'>>;
  updatePractitionerCodeForCompanyPractitioner?: Resolver<Maybe<ResolversTypes['UpdatePractitionerCodeForCompanyPractitionerPayload']>, ParentType, ContextType, RequireFields<MutationUpdatePractitionerCodeForCompanyPractitionerArgs, 'input'>>;
  updateUberSignatureInputData?: Resolver<Maybe<ResolversTypes['UpdateUberSignatureInputDataPayload']>, ParentType, ContextType, RequireFields<MutationUpdateUberSignatureInputDataArgs, 'input'>>;
  updateWebBookingsBusinessHour2?: Resolver<Maybe<ResolversTypes['UpdateWebBookingsBusinessHour2Payload']>, ParentType, ContextType, RequireFields<MutationUpdateWebBookingsBusinessHour2Args, 'input'>>;
  updateWebBookingsExceptionBusinessHour?: Resolver<Maybe<ResolversTypes['UpdateWebBookingsExceptionBusinessHourPayload']>, ParentType, ContextType, RequireFields<MutationUpdateWebBookingsExceptionBusinessHourArgs, 'input'>>;
  updateWebBookingsHolidayBusinessHour?: Resolver<Maybe<ResolversTypes['UpdateWebBookingsHolidayBusinessHourPayload']>, ParentType, ContextType, RequireFields<MutationUpdateWebBookingsHolidayBusinessHourArgs, 'input'>>;
  updateWebBookingsSetting?: Resolver<Maybe<ResolversTypes['UpdateWebBookingsSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpdateWebBookingsSettingArgs, 'input'>>;
  upsertAgreementExtension?: Resolver<Maybe<ResolversTypes['UpsertAgreementExtensionPayload']>, ParentType, ContextType, RequireFields<MutationUpsertAgreementExtensionArgs, 'input'>>;
  upsertClientAuthentication?: Resolver<Maybe<ResolversTypes['UpsertClientAuthenticationPayload']>, ParentType, ContextType, RequireFields<MutationUpsertClientAuthenticationArgs, 'input'>>;
  upsertCompanyWebBookingsLimitSetting?: Resolver<Maybe<ResolversTypes['UpsertCompanyWebBookingsLimitSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpsertCompanyWebBookingsLimitSettingArgs, 'input'>>;
  upsertGuestPatientMedicationFollowupStatus?: Resolver<Maybe<ResolversTypes['UpsertGuestPatientMedicationFollowupStatusPayload']>, ParentType, ContextType, RequireFields<MutationUpsertGuestPatientMedicationFollowupStatusArgs, 'input'>>;
  upsertMedicationFollowupDraftMessage?: Resolver<Maybe<ResolversTypes['UpsertMedicationFollowupDraftMessagePayload']>, ParentType, ContextType, RequireFields<MutationUpsertMedicationFollowupDraftMessageArgs, 'input'>>;
  upsertMedicationFollowupStatusSetting?: Resolver<Maybe<ResolversTypes['UpsertMedicationFollowupStatusSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpsertMedicationFollowupStatusSettingArgs, 'input'>>;
  upsertOrganization?: Resolver<Maybe<ResolversTypes['UpsertOrganizationPayload']>, ParentType, ContextType, RequireFields<MutationUpsertOrganizationArgs, 'input'>>;
  upsertOrganizations?: Resolver<Maybe<ResolversTypes['UpsertOrganizationsPayload']>, ParentType, ContextType, RequireFields<MutationUpsertOrganizationsArgs, 'input'>>;
  upsertPatientMedicationFollowupStatus?: Resolver<Maybe<ResolversTypes['UpsertPatientMedicationFollowupStatusPayload']>, ParentType, ContextType, RequireFields<MutationUpsertPatientMedicationFollowupStatusArgs, 'input'>>;
  upsertTracingReportDraft?: Resolver<Maybe<ResolversTypes['UpsertTracingReportDraftPayload']>, ParentType, ContextType, RequireFields<MutationUpsertTracingReportDraftArgs, 'input'>>;
  upsertUberOrganizationSetting?: Resolver<Maybe<ResolversTypes['UpsertUberOrganizationSettingPayload']>, ParentType, ContextType, RequireFields<MutationUpsertUberOrganizationSettingArgs, 'input'>>;
  upsertUberOrganizationSettings?: Resolver<Maybe<ResolversTypes['UpsertUberOrganizationSettingsPayload']>, ParentType, ContextType, RequireFields<MutationUpsertUberOrganizationSettingsArgs, 'input'>>;
  upsertUberSignatureDraft?: Resolver<Maybe<ResolversTypes['UpsertUberSignatureDraftPayload']>, ParentType, ContextType, RequireFields<MutationUpsertUberSignatureDraftArgs, 'input'>>;
  upsertWebBookingsAllDayLimit?: Resolver<Maybe<ResolversTypes['UpsertWebBookingsAllDayLimitPayload']>, ParentType, ContextType, RequireFields<MutationUpsertWebBookingsAllDayLimitArgs, 'input'>>;
  upsertWebBookingsLimit?: Resolver<Maybe<ResolversTypes['UpsertWebBookingsLimitPayload']>, ParentType, ContextType, RequireFields<MutationUpsertWebBookingsLimitArgs, 'input'>>;
  viewedMedicationFollowupQuestionnaireSheet?: Resolver<Maybe<ResolversTypes['ViewedMedicationFollowupQuestionnaireSheetPayload']>, ParentType, ContextType, RequireFields<MutationViewedMedicationFollowupQuestionnaireSheetArgs, 'input'>>;
}>;

export type NodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Node'] = ResolversParentTypes['Node']> = ResolversObject<{
  __resolveType: TypeResolveFn<'Address' | 'Agent' | 'AgreementExtension' | 'AllowList' | 'Announcement' | 'Appointment' | 'B2cloudSetting' | 'BankAccount' | 'Bookmark' | 'Charge' | 'ChargeHistory' | 'CheckinEntry' | 'CheckinOrganization' | 'ClientAuthentication' | 'ClientCert' | 'ClientCertJobInformation' | 'Company' | 'CompanyAddress' | 'CompanyCommonSetting' | 'CompanyContactPoint' | 'CompanyFeeSetting' | 'CompanyPractitioner' | 'CompanyPractitionerConfirmation' | 'CompanyPractitionerContactPoint' | 'CompanySessionSetting' | 'CompanySetupDocument' | 'CompanyWebBookingsLimitSetting' | 'ContactPoint' | 'Contract' | 'ContractPlan' | 'DirectVisitor' | 'DraftAppointment' | 'Encounter' | 'Extension' | 'FaximoSendFax' | 'Feature' | 'FeatureTargetGroup' | 'FeatureUsage' | 'GendaApiKey' | 'GendaSetting' | 'GuestPatientMedicationFollowupComment' | 'HiccupAppointmentPermission' | 'HiccupOnetimeApiCache' | 'HiccupTemporaryPermission' | 'InvitationCode' | 'Invoice' | 'MedicalInstitutionSetting' | 'MedicationFollowupAutoReplySetting' | 'MedicationFollowupAutoReplySettingTemplate' | 'MedicationFollowupDraftMessage' | 'MedicationFollowupMessage' | 'MedicationFollowupMessageTemplate' | 'MedicationFollowupMessageTemplateJobInformation' | 'MedicationFollowupQuestionnaire' | 'MedicationFollowupQuestionnaireRevision' | 'MedicationFollowupQuestionnaireSheet' | 'MedicationFollowupSetting' | 'MedixsPatient' | 'MedixsReception' | 'MedixsSetting' | 'MessageDeliver' | 'MessageDeliverResult' | 'Operator' | 'OperatorAccessPermission' | 'OperatorRole' | 'Organization' | 'OrganizationAddress' | 'OrganizationCompanyFeeSetting' | 'OrganizationContactPoint' | 'OrganizationFeeSetting' | 'OrganizationImportJobInformation' | 'OrganizationNotification' | 'OrganizationNotificationSetting' | 'OutpatientQuestionnaire' | 'OutpatientQuestionnaireEntry' | 'OutpatientQuestionnaireOrganization' | 'OutpatientQuestionnaireQuestion' | 'OutpatientQuestionnaireSetting' | 'OutpatientQuestionnaireSettingQuestionnaire' | 'Patient' | 'PatientAttachment' | 'PatientMedicationFollowupComment' | 'Payout' | 'PayoutBankAccount' | 'PayoutOrganization' | 'PayoutSubject' | 'PfDispensingRequest' | 'PfPatient' | 'PfPrescriptionImage' | 'Plan' | 'PlanFeature' | 'Practitioner' | 'PractitionerOtpSecret' | 'PractitionerSigninHistory' | 'PrivilegeOrganization' | 'PrivilegeOrganizationPractitioner' | 'PublicAddress' | 'PublicAppointment' | 'PublicCheckinEntry' | 'PublicMedicationFollowupMessage' | 'PublicMedicationFollowupQuestionnaireRevision' | 'PublicMedicationFollowupQuestionnaireSheet' | 'PublicOrganization' | 'PublicOrganizationAddress' | 'PublicOutpatientQuestionnaireEntry' | 'PublicSignupPfPatientInformation' | 'PublicSignupPfPatientInformationOrganization' | 'PublicSlot' | 'PublicWebBookingsSetting' | 'RefundHistory' | 'SendgridEventActivity' | 'TracingReport' | 'TracingReportDraft' | 'UberDelivery' | 'UberOrganization' | 'UberOrganizationImportJobInformation' | 'UberOrganizationSetting' | 'UberOrganizationSettingJobInformation' | 'UberSignature' | 'UberSignatureDraft' | 'WebBookingsBusinessHour' | 'WebBookingsExceptionBusinessHour' | 'WebBookingsExceptionDate' | 'WebBookingsHolidayBusinessHour' | 'WebBookingsLimit' | 'WebBookingsSetting' | 'WebBookingsSuspend' | 'WebVisitor', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
}>;

export type NotificationSettingDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationSettingData'] = ResolversParentTypes['NotificationSettingData']> = ResolversObject<{
  medicationFollowupEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  onlineEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sound?: Resolver<ResolversTypes['NotificationSettingSound'], ParentType, ContextType>;
  tel?: Resolver<ResolversTypes['NotificationSettingTel'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NotificationSettingSoundResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationSettingSound'] = ResolversParentTypes['NotificationSettingSound']> = ResolversObject<{
  enable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  interval?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NotificationSettingTelResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotificationSettingTel'] = ResolversParentTypes['NotificationSettingTel']> = ResolversObject<{
  delay?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  enable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  formattedPhoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NotifyCheckinEntryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotifyCheckinEntryPayload'] = ResolversParentTypes['NotifyCheckinEntryPayload']> = ResolversObject<{
  checkinEntry?: Resolver<ResolversTypes['CheckinEntry'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type NotifyOutpatientQuestionnaireEntryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotifyOutpatientQuestionnaireEntryPayload'] = ResolversParentTypes['NotifyOutpatientQuestionnaireEntryPayload']> = ResolversObject<{
  outpatientQuestionnaireEntry?: Resolver<ResolversTypes['OutpatientQuestionnaireEntry'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OperatorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Operator'] = ResolversParentTypes['Operator']> = ResolversObject<{
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  operatorRoles?: Resolver<Array<ResolversTypes['OperatorRole']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OperatorAccessPermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OperatorAccessPermission'] = ResolversParentTypes['OperatorAccessPermission']> = ResolversObject<{
  expiresAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OperatorRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['OperatorRole'] = ResolversParentTypes['OperatorRole']> = ResolversObject<{
  abilities?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  operators?: Resolver<Array<ResolversTypes['Operator']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  adminPractitioners?: Resolver<Array<ResolversTypes['Practitioner']>, ParentType, ContextType>;
  agent?: Resolver<Maybe<ResolversTypes['Agent']>, ParentType, ContextType>;
  allPatients?: Resolver<ResolversTypes['AllPatientPage'], ParentType, ContextType, Partial<OrganizationAllPatientsArgs>>;
  appDownloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  appPromotionDownloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  appointmentCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<OrganizationAppointmentCountArgs, 'statuses'>>;
  appointments?: Resolver<ResolversTypes['AppointmentPage'], ParentType, ContextType, Partial<OrganizationAppointmentsArgs>>;
  b2cloudSetting?: Resolver<Maybe<ResolversTypes['B2cloudSetting']>, ParentType, ContextType>;
  bankAccount?: Resolver<Maybe<ResolversTypes['BankAccount']>, ParentType, ContextType>;
  bookmarkedPatients?: Resolver<ResolversTypes['PatientPage'], ParentType, ContextType, Partial<OrganizationBookmarkedPatientsArgs>>;
  bookmarkedPfPatientsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<OrganizationBookmarkedPfPatientsCountArgs>>;
  cancellationAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<OrganizationCancellationAmountArgs>>;
  chargeAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<OrganizationChargeAmountArgs>>;
  chargeHistories?: Resolver<ResolversTypes['ChargeHistoryPage'], ParentType, ContextType, RequireFields<OrganizationChargeHistoriesArgs, 'order'>>;
  chargeTotals?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<OrganizationChargeTotalsArgs>>;
  checkinEntries?: Resolver<ResolversTypes['CheckinEntryPage'], ParentType, ContextType, RequireFields<OrganizationCheckinEntriesArgs, 'statuses'>>;
  checkinSetting?: Resolver<Maybe<ResolversTypes['CheckinSetting']>, ParentType, ContextType>;
  clientCerts?: Resolver<ResolversTypes['ClientCertPage'], ParentType, ContextType, Partial<OrganizationClientCertsArgs>>;
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  companyCommonSetting?: Resolver<Maybe<ResolversTypes['CompanyCommonSetting']>, ParentType, ContextType>;
  dailySalesDetail?: Resolver<ResolversTypes['OrganizationDailySalesDetail'], ParentType, ContextType, RequireFields<OrganizationDailySalesDetailArgs, 'day' | 'month' | 'year'>>;
  descriptionCodes?: Resolver<Array<ResolversTypes['DescriptionCode']>, ParentType, ContextType>;
  directVisitorCandidates?: Resolver<ResolversTypes['DirectVisitorCandidatePage'], ParentType, ContextType, Partial<OrganizationDirectVisitorCandidatesArgs>>;
  directVisitors?: Resolver<ResolversTypes['DirectVisitorPage'], ParentType, ContextType, Partial<OrganizationDirectVisitorsArgs>>;
  disclosedMedicineNotes?: Resolver<ResolversTypes['DisclosedMedicineNotePage'], ParentType, ContextType, RequireFields<OrganizationDisclosedMedicineNotesArgs, 'date' | 'onlyUnread'>>;
  existCompanyOrganizationFeeSetting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  existWebBookingsLimit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  faximoSendFaxes?: Resolver<ResolversTypes['FaximoSendFaxPage'], ParentType, ContextType, Partial<OrganizationFaximoSendFaxesArgs>>;
  featureUsages?: Resolver<ResolversTypes['FeatureUsagePage'], ParentType, ContextType, Partial<OrganizationFeatureUsagesArgs>>;
  feeSettings?: Resolver<ResolversTypes['FeeSettingPage'], ParentType, ContextType, Partial<OrganizationFeeSettingsArgs>>;
  hiccupTemporaryPermissions?: Resolver<ResolversTypes['HiccupTemporaryPermissionPage'], ParentType, ContextType, RequireFields<OrganizationHiccupTemporaryPermissionsArgs, 'date' | 'onlyUnread'>>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inDeliveryAppointmentCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  incompleteAppointmentCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  incompleteCheckinEntryCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  incompleteDraftAppointmentCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  incompleteMedicationFollowupMessageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  invitationCodes?: Resolver<ResolversTypes['InvitationCodePage'], ParentType, ContextType, RequireFields<OrganizationInvitationCodesArgs, 'notApplied' | 'sendFailed'>>;
  medicalInstitutionSetting?: Resolver<Maybe<ResolversTypes['MedicalInstitutionSetting']>, ParentType, ContextType, RequireFields<OrganizationMedicalInstitutionSettingArgs, 'medicalInstitutionName'>>;
  medicalInstitutionSettings?: Resolver<ResolversTypes['MedicalInstitutionSettingPage'], ParentType, ContextType, Partial<OrganizationMedicalInstitutionSettingsArgs>>;
  medicationFollowupMessageTemplates?: Resolver<ResolversTypes['MedicationFollowupMessageTemplatePage'], ParentType, ContextType, Partial<OrganizationMedicationFollowupMessageTemplatesArgs>>;
  medicationFollowupMessages?: Resolver<ResolversTypes['MedicationFollowupMessagePage'], ParentType, ContextType, RequireFields<OrganizationMedicationFollowupMessagesArgs, 'date'>>;
  medicationFollowupQuestionnaireSheets?: Resolver<ResolversTypes['MedicationFollowupQuestionnaireSheetPage'], ParentType, ContextType, RequireFields<OrganizationMedicationFollowupQuestionnaireSheetsArgs, 'from' | 'onlyUnread' | 'to'>>;
  medicationFollowupQuestionnaires?: Resolver<ResolversTypes['MedicationFollowupQuestionnairePage'], ParentType, ContextType, Partial<OrganizationMedicationFollowupQuestionnairesArgs>>;
  medicationFollowupSetting?: Resolver<Maybe<ResolversTypes['MedicationFollowupSetting']>, ParentType, ContextType>;
  medixsSetting?: Resolver<Maybe<ResolversTypes['MedixsSetting']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notificationSetting?: Resolver<Maybe<ResolversTypes['OrganizationNotificationSetting']>, ParentType, ContextType>;
  organizationAddresses?: Resolver<Array<ResolversTypes['OrganizationAddress']>, ParentType, ContextType>;
  organizationContactPoints?: Resolver<Array<ResolversTypes['OrganizationContactPoint']>, ParentType, ContextType>;
  organizationNotifications?: Resolver<ResolversTypes['OrganizationNotificationPage'], ParentType, ContextType, Partial<OrganizationOrganizationNotificationsArgs>>;
  outpatientQuestionnaireSetting?: Resolver<Maybe<ResolversTypes['OutpatientQuestionnaireSetting']>, ParentType, ContextType>;
  outpatientQuestionnaireSettingQuestionnaires?: Resolver<Array<ResolversTypes['OutpatientQuestionnaireSettingQuestionnaire']>, ParentType, ContextType>;
  patients?: Resolver<ResolversTypes['PatientConnection'], ParentType, ContextType, Partial<OrganizationPatientsArgs>>;
  payoutOrganizations?: Resolver<ResolversTypes['PayoutOrganizationPage'], ParentType, ContextType, Partial<OrganizationPayoutOrganizationsArgs>>;
  pharmacistPractitioners?: Resolver<Array<ResolversTypes['Practitioner']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  practitionerAuthentications?: Resolver<Array<ResolversTypes['PractitionerAuthentication']>, ParentType, ContextType>;
  practitioners?: Resolver<ResolversTypes['PractitionerPage'], ParentType, ContextType, Partial<OrganizationPractitionersArgs>>;
  privilege?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  receptions?: Resolver<ResolversTypes['ReceptionPage'], ParentType, ContextType, Partial<OrganizationReceptionsArgs>>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uberOrganization?: Resolver<Maybe<ResolversTypes['UberOrganization']>, ParentType, ContextType>;
  uberOrganizationSetting?: Resolver<Maybe<ResolversTypes['UberOrganizationSetting']>, ParentType, ContextType>;
  unreadOrganizationNotifications?: Resolver<ResolversTypes['OrganizationNotificationPage'], ParentType, ContextType, Partial<OrganizationUnreadOrganizationNotificationsArgs>>;
  webBookingsSetting?: Resolver<Maybe<ResolversTypes['WebBookingsSetting']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationAddress'] = ResolversParentTypes['OrganizationAddress']> = ResolversObject<{
  address?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationCompanyFeeSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationCompanyFeeSetting'] = ResolversParentTypes['OrganizationCompanyFeeSetting']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['LineItemCode'], ParentType, ContextType>;
  defaultAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  defaultField?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fixed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationContactPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationContactPoint'] = ResolversParentTypes['OrganizationContactPoint']> = ResolversObject<{
  contactPoint?: Resolver<ResolversTypes['ContactPoint'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationDailySalesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationDailySales'] = ResolversParentTypes['OrganizationDailySales']> = ResolversObject<{
  isRefunded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  orderedAt?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAppAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalCashAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalFeeWithTax?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPayout?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalUberAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationDailySalesDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationDailySalesDetail'] = ResolversParentTypes['OrganizationDailySalesDetail']> = ResolversObject<{
  appBillingAmountDetail?: Resolver<Array<ResolversTypes['SubjectTotalAmount']>, ParentType, ContextType>;
  appShippingFeeDetail?: Resolver<Array<ResolversTypes['SubjectTotalAmount']>, ParentType, ContextType>;
  appUberDeliveryFeeDetail?: Resolver<Array<ResolversTypes['SubjectTotalAmount']>, ParentType, ContextType>;
  cashBillingAmountDetail?: Resolver<Array<ResolversTypes['SubjectTotalAmount']>, ParentType, ContextType>;
  cashShippingFeeDetail?: Resolver<Array<ResolversTypes['SubjectTotalAmount']>, ParentType, ContextType>;
  organizationDailySales?: Resolver<ResolversTypes['OrganizationDailySales'], ParentType, ContextType>;
  refundHistories?: Resolver<Maybe<Array<ResolversTypes['RefundHistory']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationDailySalesPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationDailySalesPage'] = ResolversParentTypes['OrganizationDailySalesPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['OrganizationDailySales']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationFeeSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationFeeSetting'] = ResolversParentTypes['OrganizationFeeSetting']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['LineItemCode'], ParentType, ContextType>;
  defaultAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  defaultField?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fixed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationImportJobInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationImportJobInformation'] = ResolversParentTypes['OrganizationImportJobInformation']> = ResolversObject<{
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  file?: Resolver<Maybe<ResolversTypes['Blob']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  practitioner?: Resolver<Maybe<ResolversTypes['Practitioner']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OrganizationImportJobInformationStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OrganizationImportJobInformationType'], ParentType, ContextType>;
  workerProgress?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationImportJobInformationConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationImportJobInformationConnection'] = ResolversParentTypes['OrganizationImportJobInformationConnection']> = ResolversObject<{
  edges?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganizationImportJobInformationEdge']>>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['OrganizationImportJobInformation']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationImportJobInformationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationImportJobInformationEdge'] = ResolversParentTypes['OrganizationImportJobInformationEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['OrganizationImportJobInformation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationNotificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationNotification'] = ResolversParentTypes['OrganizationNotification']> = ResolversObject<{
  appointment?: Resolver<Maybe<ResolversTypes['Appointment']>, ParentType, ContextType>;
  checkinEntry?: Resolver<Maybe<ResolversTypes['CheckinEntry']>, ParentType, ContextType>;
  content?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  draftAppointment?: Resolver<Maybe<ResolversTypes['DraftAppointment']>, ParentType, ContextType>;
  faximoSendFax?: Resolver<Maybe<ResolversTypes['FaximoSendFax']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRead?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  medicationFollowupMessage?: Resolver<Maybe<ResolversTypes['MedicationFollowupMessage']>, ParentType, ContextType>;
  meta?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  outpatientQuestionnaireEntry?: Resolver<Maybe<ResolversTypes['OutpatientQuestionnaireEntry']>, ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OrganizationNotificationType'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationNotificationPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationNotificationPage'] = ResolversParentTypes['OrganizationNotificationPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['OrganizationNotification']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationNotificationSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationNotificationSetting'] = ResolversParentTypes['OrganizationNotificationSetting']> = ResolversObject<{
  data?: Resolver<ResolversTypes['NotificationSettingData'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrganizationPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationPage'] = ResolversParentTypes['OrganizationPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Organization']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OutpatientQuestionnaireResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutpatientQuestionnaire'] = ResolversParentTypes['OutpatientQuestionnaire']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  questions?: Resolver<Array<ResolversTypes['OutpatientQuestionnaireQuestion']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OutpatientQuestionnaireEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutpatientQuestionnaireEntry'] = ResolversParentTypes['OutpatientQuestionnaireEntry']> = ResolversObject<{
  address?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  directVisitor?: Resolver<ResolversTypes['DirectVisitor'], ParentType, ContextType>;
  enableNotification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  enteredAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  questionnaires?: Resolver<Array<ResolversTypes['OutpatientQuestionnaireSheetAnswer']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OutpatientQuestionnaireEntryStatus'], ParentType, ContextType>;
  unreadOrganizationNotifications?: Resolver<Array<ResolversTypes['OrganizationNotification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OutpatientQuestionnaireOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutpatientQuestionnaireOrganization'] = ResolversParentTypes['OutpatientQuestionnaireOrganization']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  appDownloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  outpatientQuestionnaire?: Resolver<ResolversTypes['OutpatientQuestionnaire'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OutpatientQuestionnaireQuestionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutpatientQuestionnaireQuestion'] = ResolversParentTypes['OutpatientQuestionnaireQuestion']> = ResolversObject<{
  choices?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  descriptionCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  questionType?: Resolver<ResolversTypes['OutpatientQuestionnaireQuestionType'], ParentType, ContextType>;
  required?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OutpatientQuestionnaireSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutpatientQuestionnaireSetting'] = ResolversParentTypes['OutpatientQuestionnaireSetting']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  outpatientQuestionnaireOrganization?: Resolver<ResolversTypes['OutpatientQuestionnaireOrganization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OutpatientQuestionnaireSettingQuestionnaireResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutpatientQuestionnaireSettingQuestionnaire'] = ResolversParentTypes['OutpatientQuestionnaireSettingQuestionnaire']> = ResolversObject<{
  default?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  outpatientQuestionnaire?: Resolver<ResolversTypes['OutpatientQuestionnaire'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  use?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OutpatientQuestionnaireSheetAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutpatientQuestionnaireSheetAnswer'] = ResolversParentTypes['OutpatientQuestionnaireSheetAnswer']> = ResolversObject<{
  answers?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = ResolversObject<{
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['Patient'] = ResolversParentTypes['Patient']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  appointments?: Resolver<ResolversTypes['AppointmentPage'], ParentType, ContextType, Partial<PatientAppointmentsArgs>>;
  birthDate?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  bookmark?: Resolver<Maybe<ResolversTypes['Bookmark']>, ParentType, ContextType>;
  draftAppointments?: Resolver<ResolversTypes['DraftAppointmentPage'], ParentType, ContextType, Partial<PatientDraftAppointmentsArgs>>;
  familyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  givenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  medicationFollowupComments?: Resolver<ResolversTypes['PatientMedicationFollowupCommentPage'], ParentType, ContextType, Partial<PatientMedicationFollowupCommentsArgs>>;
  medicationFollowupDraftMessages?: Resolver<ResolversTypes['MedicationFollowupDraftMessagePage'], ParentType, ContextType, Partial<PatientMedicationFollowupDraftMessagesArgs>>;
  medicationFollowupMessages?: Resolver<ResolversTypes['MedicationFollowupMessagePage'], ParentType, ContextType, Partial<PatientMedicationFollowupMessagesArgs>>;
  medicationFollowupStatus?: Resolver<Maybe<ResolversTypes['PatientMedicationFollowupStatus']>, ParentType, ContextType>;
  medicineNotes?: Resolver<Maybe<Array<ResolversTypes['MedicineNote']>>, ParentType, ContextType, RequireFields<PatientMedicineNotesArgs, 'from' | 'to'>>;
  medixsPatient?: Resolver<Maybe<ResolversTypes['MedixsPatient']>, ParentType, ContextType>;
  messageDeliverResults?: Resolver<ResolversTypes['MessageDeliverResultPage'], ParentType, ContextType, Partial<PatientMessageDeliverResultsArgs>>;
  patientAttachments?: Resolver<ResolversTypes['PatientAttachmentPage'], ParentType, ContextType, Partial<PatientPatientAttachmentsArgs>>;
  pfFirebaseUid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pfPatient?: Resolver<Maybe<ResolversTypes['PfPatient']>, ParentType, ContextType>;
  phoneticFamilyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneticGivenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  questionnaireSheet?: Resolver<Maybe<ResolversTypes['QuestionnaireSheet']>, ParentType, ContextType>;
  questionnaires?: Resolver<Maybe<Array<ResolversTypes['QuestionnaireSheetAnswer']>>, ParentType, ContextType>;
  sex?: Resolver<ResolversTypes['Sex'], ParentType, ContextType>;
  tracingReportDrafts?: Resolver<ResolversTypes['TracingReportDraftPage'], ParentType, ContextType, Partial<PatientTracingReportDraftsArgs>>;
  tracingReports?: Resolver<ResolversTypes['TracingReportPage'], ParentType, ContextType, Partial<PatientTracingReportsArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PatientAttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientAttachment'] = ResolversParentTypes['PatientAttachment']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  file?: Resolver<ResolversTypes['Blob'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  patientFrom?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PatientAttachmentPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientAttachmentPage'] = ResolversParentTypes['PatientAttachmentPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['PatientAttachment']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PatientConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientConnection'] = ResolversParentTypes['PatientConnection']> = ResolversObject<{
  edges?: Resolver<Maybe<Array<Maybe<ResolversTypes['PatientEdge']>>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Patient']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PatientEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientEdge'] = ResolversParentTypes['PatientEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PatientMedicationFollowupCommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientMedicationFollowupComment'] = ResolversParentTypes['PatientMedicationFollowupComment']> = ResolversObject<{
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PatientMedicationFollowupCommentPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientMedicationFollowupCommentPage'] = ResolversParentTypes['PatientMedicationFollowupCommentPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['PatientMedicationFollowupComment']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PatientPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PatientPage'] = ResolversParentTypes['PatientPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Patient']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['Payout'] = ResolversParentTypes['Payout']> = ResolversObject<{
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  month?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  payoutOrganizations?: Resolver<ResolversTypes['PayoutOrganizationPage'], ParentType, ContextType, Partial<PayoutPayoutOrganizationsArgs>>;
  qualifiedInvoice?: Resolver<Maybe<ResolversTypes['QualifiedInvoice']>, ParentType, ContextType>;
  totalPayment?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uberInvoice?: Resolver<Maybe<ResolversTypes['UberInvoice']>, ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PayoutBankAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutBankAccount'] = ResolversParentTypes['PayoutBankAccount']> = ResolversObject<{
  accountHolderName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountType?: Resolver<ResolversTypes['PayoutBankAccountAccount'], ParentType, ContextType>;
  bankCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bankName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  branchCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  branchName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payoutOrganization?: Resolver<Maybe<ResolversTypes['PayoutOrganization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PayoutOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutOrganization'] = ResolversParentTypes['PayoutOrganization']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<Maybe<ResolversTypes['Organization']>, ParentType, ContextType>;
  organizationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payout?: Resolver<Maybe<ResolversTypes['Payout']>, ParentType, ContextType>;
  payoutBankAccount?: Resolver<Maybe<ResolversTypes['PayoutBankAccount']>, ParentType, ContextType>;
  payoutSubjects?: Resolver<Array<ResolversTypes['PayoutSubject']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PayoutOrganizationPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutOrganizationPage'] = ResolversParentTypes['PayoutOrganizationPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['PayoutOrganization']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PayoutPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutPage'] = ResolversParentTypes['PayoutPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Payout']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PayoutSubjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutSubject'] = ResolversParentTypes['PayoutSubject']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['PayoutSubjectCode'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  payoutOrganization?: Resolver<Maybe<ResolversTypes['PayoutOrganization']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfAddress'] = ResolversParentTypes['PfAddress']> = ResolversObject<{
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  line?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prefecture?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sequence?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PfAddressType'], ParentType, ContextType>;
  use?: Resolver<ResolversTypes['PfAddressUse'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfAttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfAttachment'] = ResolversParentTypes['PfAttachment']> = ResolversObject<{
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfContactPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfContactPoint'] = ResolversParentTypes['PfContactPoint']> = ResolversObject<{
  formattedValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rank?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  system?: Resolver<ResolversTypes['PfContactPointSystem'], ParentType, ContextType>;
  use?: Resolver<ResolversTypes['PfContactPointUse'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfDispensingRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfDispensingRequest'] = ResolversParentTypes['PfDispensingRequest']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  medicalInstitution?: Resolver<Maybe<ResolversTypes['PfDispensingRequestMedicalInstitution']>, ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pharmacies?: Resolver<Array<ResolversTypes['PfDispensingRequestPharmacy']>, ParentType, ContextType>;
  prescriptionImages?: Resolver<Array<Maybe<ResolversTypes['PfPrescriptionImage']>>, ParentType, ContextType>;
  prescriptionImagesUpdatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requester?: Resolver<ResolversTypes['PfServiceAccount'], ParentType, ContextType>;
  sendMethod?: Resolver<ResolversTypes['PfDispensingRequestSendMethod'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PfDispensingRequestStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfDispensingRequestMedicalInstitutionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfDispensingRequestMedicalInstitution'] = ResolversParentTypes['PfDispensingRequestMedicalInstitution']> = ResolversObject<{
  consultation?: Resolver<ResolversTypes['PfDispensingRequestMedicalInstitutionConsultation'], ParentType, ContextType>;
  medicalInstitution?: Resolver<ResolversTypes['PfDispensingRequestMedicalInstitutionMedicalInstitution'], ParentType, ContextType>;
  physician?: Resolver<ResolversTypes['PfDispensingRequestMedicalInstitutionPhysician'], ParentType, ContextType>;
  prescription?: Resolver<ResolversTypes['PfDispensingRequestMedicalInstitutionPrescription'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfDispensingRequestMedicalInstitutionConsultationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfDispensingRequestMedicalInstitutionConsultation'] = ResolversParentTypes['PfDispensingRequestMedicalInstitutionConsultation']> = ResolversObject<{
  consultedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  departmentName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfDispensingRequestMedicalInstitutionMedicalInstitutionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfDispensingRequestMedicalInstitutionMedicalInstitution'] = ResolversParentTypes['PfDispensingRequestMedicalInstitutionMedicalInstitution']> = ResolversObject<{
  addresses?: Resolver<Array<ResolversTypes['PfAddress']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  telecoms?: Resolver<Array<ResolversTypes['PfContactPoint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfDispensingRequestMedicalInstitutionPhysicianResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfDispensingRequestMedicalInstitutionPhysician'] = ResolversParentTypes['PfDispensingRequestMedicalInstitutionPhysician']> = ResolversObject<{
  familyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  givenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  phoneticFamilyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneticGivenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfDispensingRequestMedicalInstitutionPrescriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfDispensingRequestMedicalInstitutionPrescription'] = ResolversParentTypes['PfDispensingRequestMedicalInstitutionPrescription']> = ResolversObject<{
  issuedDate?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  overrideExpirationDate?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfDispensingRequestPharmacyResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfDispensingRequestPharmacy'] = ResolversParentTypes['PfDispensingRequestPharmacy']> = ResolversObject<{
  dispensing?: Resolver<Maybe<ResolversTypes['PfDispensingRequestPharmacyDispensing']>, ParentType, ContextType>;
  pharmacist?: Resolver<Maybe<ResolversTypes['PfDispensingRequestPharmacyPharmacist']>, ParentType, ContextType>;
  pharmacy?: Resolver<ResolversTypes['PfDispensingRequestPharmacyPharmacy'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfDispensingRequestPharmacyDispensingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfDispensingRequestPharmacyDispensing'] = ResolversParentTypes['PfDispensingRequestPharmacyDispensing']> = ResolversObject<{
  dispensedDate?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfDispensingRequestPharmacyPharmacistResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfDispensingRequestPharmacyPharmacist'] = ResolversParentTypes['PfDispensingRequestPharmacyPharmacist']> = ResolversObject<{
  familyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  givenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  phoneticFamilyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneticGivenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfDispensingRequestPharmacyPharmacyResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfDispensingRequestPharmacyPharmacy'] = ResolversParentTypes['PfDispensingRequestPharmacyPharmacy']> = ResolversObject<{
  addresses?: Resolver<Array<ResolversTypes['PfAddress']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  telecoms?: Resolver<Array<ResolversTypes['PfContactPoint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfInsuranceCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfInsuranceCard'] = ResolversParentTypes['PfInsuranceCard']> = ResolversObject<{
  attachment?: Resolver<ResolversTypes['PfAttachment'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  uploadedAt?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfInsuranceCardsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfInsuranceCards'] = ResolversParentTypes['PfInsuranceCards']> = ResolversObject<{
  insuranceCards?: Resolver<Array<ResolversTypes['PfInsuranceCard']>, ParentType, ContextType>;
  nextPageToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfPatientResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfPatient'] = ResolversParentTypes['PfPatient']> = ResolversObject<{
  addresses?: Resolver<Array<ResolversTypes['PfAddress']>, ParentType, ContextType>;
  birthDate?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  children?: Resolver<Array<ResolversTypes['PfPatient']>, ParentType, ContextType>;
  family?: Resolver<Array<ResolversTypes['PfPatient']>, ParentType, ContextType>;
  familyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  givenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  insuranceCards?: Resolver<Maybe<ResolversTypes['PfInsuranceCards']>, ParentType, ContextType, RequireFields<PfPatientInsuranceCardsArgs, 'pageSize'>>;
  parent?: Resolver<Maybe<ResolversTypes['PfPatient']>, ParentType, ContextType>;
  parentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  phoneticFamilyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneticGivenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sex?: Resolver<ResolversTypes['PfSex'], ParentType, ContextType>;
  telecoms?: Resolver<Array<ResolversTypes['PfContactPoint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PfPrescriptionImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PfPrescriptionImage'] = ResolversParentTypes['PfPrescriptionImage']> = ResolversObject<{
  attachment?: Resolver<ResolversTypes['PfAttachment'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  patientId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  uploadedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['Plan'] = ResolversParentTypes['Plan']> = ResolversObject<{
  extensions?: Resolver<Array<ResolversTypes['Extension']>, ParentType, ContextType>;
  features?: Resolver<Array<ResolversTypes['PlanFeature']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PlanFeatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlanFeature'] = ResolversParentTypes['PlanFeature']> = ResolversObject<{
  billingMethod?: Resolver<ResolversTypes['PlanFeatureBillingMethod'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['PlanFeatureCode'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PostalCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostalCode'] = ResolversParentTypes['PostalCode']> = ResolversObject<{
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  line?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prefecture?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  town?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PostalCodePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostalCodePage'] = ResolversParentTypes['PostalCodePage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['PostalCode']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PractitionerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Practitioner'] = ResolversParentTypes['Practitioner']> = ResolversObject<{
  accreteMessages?: Resolver<ResolversTypes['AccreteMessagePage'], ParentType, ContextType, Partial<PractitionerAccreteMessagesArgs>>;
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  authentication?: Resolver<ResolversTypes['PractitionerAuthentication'], ParentType, ContextType>;
  customToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  familyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  featureNames?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  givenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  intercomUserHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isProxy?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  operatorAccessPermission?: Resolver<Maybe<ResolversTypes['OperatorAccessPermission']>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  otpSecret?: Resolver<Maybe<ResolversTypes['PractitionerOtpSecret']>, ParentType, ContextType>;
  phoneticFamilyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneticGivenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  planFeatureCodes?: Resolver<Array<ResolversTypes['PlanFeatureCode']>, ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rawId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['PractitionerRole']>, ParentType, ContextType>;
  signinHistory?: Resolver<Maybe<ResolversTypes['PractitionerSigninHistory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PractitionerAuthenticationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PractitionerAuthentication'] = ResolversParentTypes['PractitionerAuthentication']> = ResolversObject<{
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PractitionerOtpSecretResolvers<ContextType = any, ParentType extends ResolversParentTypes['PractitionerOtpSecret'] = ResolversParentTypes['PractitionerOtpSecret']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  provisioningUri?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PractitionerPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PractitionerPage'] = ResolversParentTypes['PractitionerPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Practitioner']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PractitionerSigninHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PractitionerSigninHistory'] = ResolversParentTypes['PractitionerSigninHistory']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  signinHistories?: Resolver<Array<ResolversTypes['SigninHistory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PrintPrescriptionSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrintPrescriptionSetting'] = ResolversParentTypes['PrintPrescriptionSetting']> = ResolversObject<{
  enable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  printCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PrivilegeOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrivilegeOrganization'] = ResolversParentTypes['PrivilegeOrganization']> = ResolversObject<{
  companyAdminPractitioners?: Resolver<Array<ResolversTypes['PrivilegeOrganizationPractitioner']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PrivilegeOrganizationPractitionerResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrivilegeOrganizationPractitioner'] = ResolversParentTypes['PrivilegeOrganizationPractitioner']> = ResolversObject<{
  familyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  givenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PublicAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicAddress'] = ResolversParentTypes['PublicAddress']> = ResolversObject<{
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  line?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prefecture?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AddressType'], ParentType, ContextType>;
  use?: Resolver<ResolversTypes['AddressUse'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PublicAppointmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicAppointment'] = ResolversParentTypes['PublicAppointment']> = ResolversObject<{
  cancellationReason?: Resolver<Maybe<ResolversTypes['AppointmentCancellationReason']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['PublicOrganization'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AppointmentStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PublicCheckinEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicCheckinEntry'] = ResolversParentTypes['PublicCheckinEntry']> = ResolversObject<{
  checkinOrganization?: Resolver<ResolversTypes['CheckinOrganization'], ParentType, ContextType>;
  enteredAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  familyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  givenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  notifiedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneticFamilyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneticGivenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CheckinEntryStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PublicMedicationFollowupMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicMedicationFollowupMessage'] = ResolversParentTypes['PublicMedicationFollowupMessage']> = ResolversObject<{
  answerable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  appDownloadUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  medicationFollowupQuestionnaireRevision?: Resolver<Maybe<ResolversTypes['PublicMedicationFollowupQuestionnaireRevision']>, ParentType, ContextType>;
  medicationFollowupQuestionnaireSheet?: Resolver<Maybe<ResolversTypes['PublicMedicationFollowupQuestionnaireSheet']>, ParentType, ContextType>;
  organizationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PublicMedicationFollowupQuestionnaireRevisionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicMedicationFollowupQuestionnaireRevision'] = ResolversParentTypes['PublicMedicationFollowupQuestionnaireRevision']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  formData?: Resolver<ResolversTypes['MedicationFollowupQuestionnaireFormData'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PublicMedicationFollowupQuestionnaireSheetResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicMedicationFollowupQuestionnaireSheet'] = ResolversParentTypes['PublicMedicationFollowupQuestionnaireSheet']> = ResolversObject<{
  createdAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PublicOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicOrganization'] = ResolversParentTypes['PublicOrganization']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationAddresses?: Resolver<Array<ResolversTypes['PublicOrganizationAddress']>, ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rawId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  webBookingsSetting?: Resolver<ResolversTypes['PublicWebBookingsSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PublicOrganizationAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicOrganizationAddress'] = ResolversParentTypes['PublicOrganizationAddress']> = ResolversObject<{
  address?: Resolver<ResolversTypes['PublicAddress'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PublicOrganizationPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicOrganizationPage'] = ResolversParentTypes['PublicOrganizationPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['PublicOrganization']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PublicOutpatientQuestionnaireEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicOutpatientQuestionnaireEntry'] = ResolversParentTypes['PublicOutpatientQuestionnaireEntry']> = ResolversObject<{
  enableNotification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['OutpatientQuestionnaireOrganization'], ParentType, ContextType>;
  signupPfPatientInformation?: Resolver<Maybe<ResolversTypes['PublicSignupPfPatientInformation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PublicSignupPfPatientInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicSignupPfPatientInformation'] = ResolversParentTypes['PublicSignupPfPatientInformation']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  outpatientQuestionnaireEntry?: Resolver<Maybe<ResolversTypes['PublicOutpatientQuestionnaireEntry']>, ParentType, ContextType>;
  signupPfPatientInformationOrganization?: Resolver<ResolversTypes['PublicSignupPfPatientInformationOrganization'], ParentType, ContextType>;
  tel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PublicSignupPfPatientInformationOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicSignupPfPatientInformationOrganization'] = ResolversParentTypes['PublicSignupPfPatientInformationOrganization']> = ResolversObject<{
  appDeeplink?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PublicSlotResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicSlot'] = ResolversParentTypes['PublicSlot']> = ResolversObject<{
  date?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  endAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  startAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PublicWebBookingsSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublicWebBookingsSetting'] = ResolversParentTypes['PublicWebBookingsSetting']> = ResolversObject<{
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  electronicPrescription?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  facetoface?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['Blob']>, ParentType, ContextType>;
  published?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  slots?: Resolver<Array<ResolversTypes['PublicSlot']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QualifiedInvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['QualifiedInvoice'] = ResolversParentTypes['QualifiedInvoice']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  monthlyPayoutStatements?: Resolver<ResolversTypes['MonthlyPayoutStatementPage'], ParentType, ContextType, Partial<QualifiedInvoiceMonthlyPayoutStatementsArgs>>;
  tax?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  transferFee?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  announcements?: Resolver<ResolversTypes['AnnouncementPage'], ParentType, ContextType, Partial<QueryAnnouncementsArgs>>;
  appointments?: Resolver<ResolversTypes['AppointmentConnection'], ParentType, ContextType, Partial<QueryAppointmentsArgs>>;
  bankBranch?: Resolver<Maybe<ResolversTypes['BankBranch']>, ParentType, ContextType, RequireFields<QueryBankBranchArgs, 'branchCode' | 'code'>>;
  banks?: Resolver<ResolversTypes['BankPage'], ParentType, ContextType, RequireFields<QueryBanksArgs, 'code' | 'query'>>;
  cities?: Resolver<Array<ResolversTypes['City']>, ParentType, ContextType, RequireFields<QueryCitiesArgs, 'prefectureCode'>>;
  clientCertVerification?: Resolver<Maybe<ResolversTypes['ClientCertVerification']>, ParentType, ContextType>;
  companySetupDocument?: Resolver<Maybe<ResolversTypes['CompanySetupDocument']>, ParentType, ContextType, RequireFields<QueryCompanySetupDocumentArgs, 'token'>>;
  csCities?: Resolver<Array<ResolversTypes['CsCity']>, ParentType, ContextType, RequireFields<QueryCsCitiesArgs, 'prefectureCode'>>;
  csClinicCategories?: Resolver<Array<ResolversTypes['CsClinicCategory']>, ParentType, ContextType>;
  csClinics?: Resolver<ResolversTypes['CsClinicPage'], ParentType, ContextType, RequireFields<QueryCsClinicsArgs, 'categoryKey' | 'cityCode' | 'page' | 'perPage' | 'prefectureCode' | 'query'>>;
  events?: Resolver<Maybe<ResolversTypes['EventPage']>, ParentType, ContextType, Partial<QueryEventsArgs>>;
  holidays?: Resolver<Array<ResolversTypes['Holiday']>, ParentType, ContextType, RequireFields<QueryHolidaysArgs, 'from' | 'to'>>;
  latestUberOrganizationImportJobInformation?: Resolver<Maybe<ResolversTypes['UberOrganizationImportJobInformation']>, ParentType, ContextType>;
  me?: Resolver<Maybe<ResolversTypes['LoginUser']>, ParentType, ContextType>;
  medicineNotePatientProfile?: Resolver<Maybe<ResolversTypes['MedicineNotePatientProfile']>, ParentType, ContextType, RequireFields<QueryMedicineNotePatientProfileArgs, 'patientId'>>;
  medicineNotesByOnetimeCode?: Resolver<Maybe<ResolversTypes['MedicineNotesByOnetimeCode']>, ParentType, ContextType, RequireFields<QueryMedicineNotesByOnetimeCodeArgs, 'from' | 'onetimeCode' | 'to'>>;
  medicineNotesByPatient?: Resolver<Maybe<ResolversTypes['MedicineNotesByPatient']>, ParentType, ContextType, RequireFields<QueryMedicineNotesByPatientArgs, 'from' | 'patientId' | 'to'>>;
  medicines?: Resolver<ResolversTypes['MedicinePage'], ParentType, ContextType, RequireFields<QueryMedicinesArgs, 'query'>>;
  node?: Resolver<Maybe<ResolversTypes['Node']>, ParentType, ContextType, RequireFields<QueryNodeArgs, 'id'>>;
  organizations?: Resolver<ResolversTypes['OrganizationPage'], ParentType, ContextType, Partial<QueryOrganizationsArgs>>;
  patients?: Resolver<ResolversTypes['PatientConnection'], ParentType, ContextType, RequireFields<QueryPatientsArgs, 'organizationId'>>;
  postalCodes?: Resolver<ResolversTypes['PostalCodePage'], ParentType, ContextType, RequireFields<QueryPostalCodesArgs, 'postalCode'>>;
  practitioners?: Resolver<ResolversTypes['PractitionerPage'], ParentType, ContextType, RequireFields<QueryPractitionersArgs, 'organizationId'>>;
  publicOrganizations?: Resolver<ResolversTypes['PublicOrganizationPage'], ParentType, ContextType, RequireFields<QueryPublicOrganizationsArgs, 'cityCode' | 'latitude' | 'longitude' | 'q' | 'radius'>>;
  unreadAnnouncements?: Resolver<ResolversTypes['AnnouncementConnection'], ParentType, ContextType, Partial<QueryUnreadAnnouncementsArgs>>;
}>;

export type QuestionnaireSheetResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestionnaireSheet'] = ResolversParentTypes['QuestionnaireSheet']> = ResolversObject<{
  answers?: Resolver<Array<ResolversTypes['QuestionnaireSheetAnswer']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QuestionnaireSheetAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestionnaireSheetAnswer'] = ResolversParentTypes['QuestionnaireSheetAnswer']> = ResolversObject<{
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QuoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['Quote'] = ResolversParentTypes['Quote']> = ResolversObject<{
  availableSameDayDelivery?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fee?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReceptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Reception'] = ResolversParentTypes['Reception']> = ResolversObject<{
  __resolveType: TypeResolveFn<'Appointment' | 'CheckinEntry' | 'DraftAppointment' | 'OutpatientQuestionnaireEntry', ParentType, ContextType>;
}>;

export type ReceptionPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReceptionPage'] = ResolversParentTypes['ReceptionPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Reception']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReceptionUsageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReceptionUsage'] = ResolversParentTypes['ReceptionUsage']> = ResolversObject<{
  allReceptionCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  cancelledAppointmentCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  facetofaceAppointmentCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  telemedicineAppointmentCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReceptionUsagePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReceptionUsagePage'] = ResolversParentTypes['ReceptionUsagePage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ReceptionUsage']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RechargeWithAppPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RechargeWithAppPayload'] = ResolversParentTypes['RechargeWithAppPayload']> = ResolversObject<{
  charge?: Resolver<ResolversTypes['Charge'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RechargeWithCashPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RechargeWithCashPayload'] = ResolversParentTypes['RechargeWithCashPayload']> = ResolversObject<{
  charge?: Resolver<ResolversTypes['Charge'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RecreateTracingReportPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecreateTracingReportPayload'] = ResolversParentTypes['RecreateTracingReportPayload']> = ResolversObject<{
  tracingReport?: Resolver<ResolversTypes['TracingReport'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RefundHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundHistory'] = ResolversParentTypes['RefundHistory']> = ResolversObject<{
  afterChargeHistory?: Resolver<ResolversTypes['ChargeHistory'], ParentType, ContextType>;
  beforeChargeHistory?: Resolver<ResolversTypes['ChargeHistory'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  patient?: Resolver<ResolversTypes['Patient'], ParentType, ContextType>;
  refundedChargeHistory?: Resolver<ResolversTypes['ChargeHistory'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RemandUberSignaturePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemandUberSignaturePayload'] = ResolversParentTypes['RemandUberSignaturePayload']> = ResolversObject<{
  uberSignature?: Resolver<ResolversTypes['UberSignature'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RemoveCompanyAddressPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveCompanyAddressPayload'] = ResolversParentTypes['RemoveCompanyAddressPayload']> = ResolversObject<{
  companyAddress?: Resolver<ResolversTypes['CompanyAddress'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RemoveCompanyContactPointPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveCompanyContactPointPayload'] = ResolversParentTypes['RemoveCompanyContactPointPayload']> = ResolversObject<{
  companyContactPoint?: Resolver<ResolversTypes['CompanyContactPoint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RemoveCompanySetupDocumentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveCompanySetupDocumentPayload'] = ResolversParentTypes['RemoveCompanySetupDocumentPayload']> = ResolversObject<{
  companySetupDocument?: Resolver<ResolversTypes['CompanySetupDocument'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RemoveMedicalInstitutionSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveMedicalInstitutionSettingPayload'] = ResolversParentTypes['RemoveMedicalInstitutionSettingPayload']> = ResolversObject<{
  medicalInstitutionSetting?: Resolver<ResolversTypes['MedicalInstitutionSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RemoveOrganizationContactPointPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveOrganizationContactPointPayload'] = ResolversParentTypes['RemoveOrganizationContactPointPayload']> = ResolversObject<{
  organizationContactPoint?: Resolver<ResolversTypes['OrganizationContactPoint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RemoveWebBookingsExceptionBusinessHourPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveWebBookingsExceptionBusinessHourPayload'] = ResolversParentTypes['RemoveWebBookingsExceptionBusinessHourPayload']> = ResolversObject<{
  webBookingsSetting?: Resolver<ResolversTypes['WebBookingsSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RequestAppointmentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RequestAppointmentPayload'] = ResolversParentTypes['RequestAppointmentPayload']> = ResolversObject<{
  draftAppointment?: Resolver<ResolversTypes['DraftAppointment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ResendAuthenticationCodePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResendAuthenticationCodePayload'] = ResolversParentTypes['ResendAuthenticationCodePayload']> = ResolversObject<{
  publicSignupPfPatientInformation?: Resolver<ResolversTypes['PublicSignupPfPatientInformation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RestartAgentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RestartAgentPayload'] = ResolversParentTypes['RestartAgentPayload']> = ResolversObject<{
  agent?: Resolver<ResolversTypes['Agent'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ResumeWebBookingsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResumeWebBookingsPayload'] = ResolversParentTypes['ResumeWebBookingsPayload']> = ResolversObject<{
  webBookingsSuspend?: Resolver<ResolversTypes['WebBookingsSuspend'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RevokeClientCertPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RevokeClientCertPayload'] = ResolversParentTypes['RevokeClientCertPayload']> = ResolversObject<{
  clientCert?: Resolver<ResolversTypes['ClientCert'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendAuthenticationCodeAndRegisterPatientEmailPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendAuthenticationCodeAndRegisterPatientEmailPayload'] = ResolversParentTypes['SendAuthenticationCodeAndRegisterPatientEmailPayload']> = ResolversObject<{
  publicSignupPfPatientInformation?: Resolver<ResolversTypes['PublicSignupPfPatientInformation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendCallNotificationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendCallNotificationPayload'] = ResolversParentTypes['SendCallNotificationPayload']> = ResolversObject<{
  encounter?: Resolver<ResolversTypes['Encounter'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendClientCertMailPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendClientCertMailPayload'] = ResolversParentTypes['SendClientCertMailPayload']> = ResolversObject<{
  clientCert?: Resolver<ResolversTypes['ClientCert'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendCongestionNotificationForWebVisitorPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendCongestionNotificationForWebVisitorPayload'] = ResolversParentTypes['SendCongestionNotificationForWebVisitorPayload']> = ResolversObject<{
  messageDeliver?: Resolver<ResolversTypes['MessageDeliver'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendCongestionNotificationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendCongestionNotificationPayload'] = ResolversParentTypes['SendCongestionNotificationPayload']> = ResolversObject<{
  appointment?: Resolver<ResolversTypes['Appointment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendDispensingPreparedNotificationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendDispensingPreparedNotificationPayload'] = ResolversParentTypes['SendDispensingPreparedNotificationPayload']> = ResolversObject<{
  appointment?: Resolver<ResolversTypes['Appointment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendInvitationSmsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendInvitationSmsPayload'] = ResolversParentTypes['SendInvitationSmsPayload']> = ResolversObject<{
  accreteMessage?: Resolver<ResolversTypes['AccreteMessage'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendPractitionerCodeMailPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendPractitionerCodeMailPayload'] = ResolversParentTypes['SendPractitionerCodeMailPayload']> = ResolversObject<{
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendTracingReportPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendTracingReportPayload'] = ResolversParentTypes['SendTracingReportPayload']> = ResolversObject<{
  faximoSendFax?: Resolver<ResolversTypes['FaximoSendFax'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SendgridEventActivityResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendgridEventActivity'] = ResolversParentTypes['SendgridEventActivity']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mailKind?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SendgridEventActivityStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SetPractitionerRolePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetPractitionerRolePayload'] = ResolversParentTypes['SetPractitionerRolePayload']> = ResolversObject<{
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SigninHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SigninHistory'] = ResolversParentTypes['SigninHistory']> = ResolversObject<{
  ipAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signinAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  userAgent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SignupCompanyPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignupCompanyPayload'] = ResolversParentTypes['SignupCompanyPayload']> = ResolversObject<{
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SignupPfPatientFromCheckinEntryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignupPfPatientFromCheckinEntryPayload'] = ResolversParentTypes['SignupPfPatientFromCheckinEntryPayload']> = ResolversObject<{
  publicSignupPfPatientInformation?: Resolver<ResolversTypes['PublicSignupPfPatientInformation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SignupPfPatientFromOutpatientQuestionnaireEntryPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignupPfPatientFromOutpatientQuestionnaireEntryPayload'] = ResolversParentTypes['SignupPfPatientFromOutpatientQuestionnaireEntryPayload']> = ResolversObject<{
  publicSignupPfPatientInformation?: Resolver<ResolversTypes['PublicSignupPfPatientInformation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SkipEncounterPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SkipEncounterPayload'] = ResolversParentTypes['SkipEncounterPayload']> = ResolversObject<{
  appointment?: Resolver<ResolversTypes['Appointment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubjectTotalAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubjectTotalAmount'] = ResolversParentTypes['SubjectTotalAmount']> = ResolversObject<{
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscribeChannelPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscribeChannelPayload'] = ResolversParentTypes['SubscribeChannelPayload']> = ResolversObject<{
  channelId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SuspendWebBookingsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SuspendWebBookingsPayload'] = ResolversParentTypes['SuspendWebBookingsPayload']> = ResolversObject<{
  webBookingsSuspend?: Resolver<ResolversTypes['WebBookingsSuspend'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TracingReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['TracingReport'] = ResolversParentTypes['TracingReport']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['TracingReportData'], ParentType, ContextType>;
  file?: Resolver<Maybe<ResolversTypes['Blob']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  latestSentFax?: Resolver<Maybe<ResolversTypes['FaximoSendFax']>, ParentType, ContextType>;
  latestSentFaxByEvent?: Resolver<Maybe<ResolversTypes['FaximoSendFax']>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['JobInformationStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TracingReportDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['TracingReportData'] = ResolversParentTypes['TracingReportData']> = ResolversObject<{
  clinicName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  medicalInstitutionSetting?: Resolver<Maybe<ResolversTypes['MedicalInstitutionSetting']>, ParentType, ContextType>;
  patientFamilyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  patientGivenName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pharmacistName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TracingReportDraftResolvers<ContextType = any, ParentType extends ResolversParentTypes['TracingReportDraft'] = ResolversParentTypes['TracingReportDraft']> = ResolversObject<{
  data?: Resolver<ResolversTypes['TracingReportDraftData'], ParentType, ContextType>;
  guestPatient?: Resolver<Maybe<ResolversTypes['GuestPatient']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  patient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TracingReportDraftDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['TracingReportDraftData'] = ResolversParentTypes['TracingReportDraftData']> = ResolversObject<{
  clinicName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clinicalDepartment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dispensingDate?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  doctorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pharmacistName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prescriptionDrugs?: Resolver<Maybe<Array<ResolversTypes['TracingReportDraftPrescriptionDrug']>>, ParentType, ContextType>;
  prescriptionIssueDate?: Resolver<Maybe<ResolversTypes['ISO8601Date']>, ParentType, ContextType>;
  report?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  suggestion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TracingReportDraftPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['TracingReportDraftPage'] = ResolversParentTypes['TracingReportDraftPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TracingReportDraft']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TracingReportDraftPrescriptionDrugResolvers<ContextType = any, ParentType extends ResolversParentTypes['TracingReportDraftPrescriptionDrug'] = ResolversParentTypes['TracingReportDraftPrescriptionDrug']> = ResolversObject<{
  drugName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TracingReportPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['TracingReportPage'] = ResolversParentTypes['TracingReportPage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TracingReport']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TracingReportUsageResolvers<ContextType = any, ParentType extends ResolversParentTypes['TracingReportUsage'] = ResolversParentTypes['TracingReportUsage']> = ResolversObject<{
  createdCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  sendCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TracingReportUsagePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['TracingReportUsagePage'] = ResolversParentTypes['TracingReportUsagePage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['TracingReportUsage']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UberCourierResolvers<ContextType = any, ParentType extends ResolversParentTypes['UberCourier'] = ResolversParentTypes['UberCourier']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pickupScheduledAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UberDeliveryResolvers<ContextType = any, ParentType extends ResolversParentTypes['UberDelivery'] = ResolversParentTypes['UberDelivery']> = ResolversObject<{
  appointment?: Resolver<ResolversTypes['Appointment'], ParentType, ContextType>;
  courier?: Resolver<Maybe<ResolversTypes['UberCourier']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  deliveredAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  deliveryId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fee?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isFreePromotion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isTimeElapsedNotification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isValidFee?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  orderNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UberDeliveryStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UberDeliveryInvoiceFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UberDeliveryInvoiceFee'] = ResolversParentTypes['UberDeliveryInvoiceFee']> = ResolversObject<{
  deliveredMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  deliveredYear?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalUberDeliveryFee?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UberDeliveryInvoiceFeePageResolvers<ContextType = any, ParentType extends ResolversParentTypes['UberDeliveryInvoiceFeePage'] = ResolversParentTypes['UberDeliveryInvoiceFeePage']> = ResolversObject<{
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['UberDeliveryInvoiceFee']>, ParentType, ContextType>;
  nodesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pagesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UberInvoiceResolvers<ContextType = any, ParentType extends ResolversParentTypes['UberInvoice'] = ResolversParentTypes['UberInvoice']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  tax?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UberOrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UberOrganization'] = ResolversParentTypes['UberOrganization']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  uberAreaStatus?: Resolver<ResolversTypes['UberAreaStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UberOrganizationImportJobInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UberOrganizationImportJobInformation'] = ResolversParentTypes['UberOrganizationImportJobInformation']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UberOrganizationImportJobInformationStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UberOrganizationSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['UberOrganizationSetting'] = ResolversParentTypes['UberOrganizationSetting']> = ResolversObject<{
  enable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UberOrganizationSettingJobInformationResolvers<ContextType = any, ParentType extends ResolversParentTypes['UberOrganizationSettingJobInformation'] = ResolversParentTypes['UberOrganizationSettingJobInformation']> = ResolversObject<{
  file?: Resolver<Maybe<ResolversTypes['Blob']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UberOrganizationSettingJobInformationStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UberQuoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['UberQuote'] = ResolversParentTypes['UberQuote']> = ResolversObject<{
  errorCode?: Resolver<Maybe<ResolversTypes['UberQuoteErrorCode']>, ParentType, ContextType>;
  fee?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  quoteId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UberSignatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['UberSignature'] = ResolversParentTypes['UberSignature']> = ResolversObject<{
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  extraText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputData?: Resolver<ResolversTypes['UberSignatureData'], ParentType, ContextType>;
  pdf?: Resolver<ResolversTypes['Blob'], ParentType, ContextType>;
  signedAt?: Resolver<Maybe<ResolversTypes['ISO8601DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UberSignatureStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UberSignatureDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['UberSignatureData'] = ResolversParentTypes['UberSignatureData']> = ResolversObject<{
  companyAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyPhoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  corporateNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isSelfEmployed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  primaryContactEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  primaryContactFamilyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  primaryContactGivenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  primaryContactPhone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  responsiblePersonEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  responsiblePersonFamilyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  responsiblePersonGivenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  responsiblePersonPhone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  responsiblePersonTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signature?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signatureFamilyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signatureGivenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signatureTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UberSignatureDraftResolvers<ContextType = any, ParentType extends ResolversParentTypes['UberSignatureDraft'] = ResolversParentTypes['UberSignatureDraft']> = ResolversObject<{
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  extraText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputData?: Resolver<Maybe<ResolversTypes['UberSignatureDraftData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UberSignatureDraftDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['UberSignatureDraftData'] = ResolversParentTypes['UberSignatureDraftData']> = ResolversObject<{
  companyAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyPhoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  corporateNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSelfEmployed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  primaryContactEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryContactFamilyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryContactGivenName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  primaryContactPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responsiblePersonEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responsiblePersonFamilyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responsiblePersonGivenName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responsiblePersonPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responsiblePersonTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signatureFamilyName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signatureGivenName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signatureTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UnidentifyMedixsPatientPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnidentifyMedixsPatientPayload'] = ResolversParentTypes['UnidentifyMedixsPatientPayload']> = ResolversObject<{
  medixsPatient?: Resolver<ResolversTypes['MedixsPatient'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UnidentifyMedixsReceptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnidentifyMedixsReceptionPayload'] = ResolversParentTypes['UnidentifyMedixsReceptionPayload']> = ResolversObject<{
  medixsReception?: Resolver<ResolversTypes['MedixsReception'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UnpublishOrganizationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnpublishOrganizationPayload'] = ResolversParentTypes['UnpublishOrganizationPayload']> = ResolversObject<{
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UnsubscribeChannelPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnsubscribeChannelPayload'] = ResolversParentTypes['UnsubscribeChannelPayload']> = ResolversObject<{
  channelId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateAgentDescriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAgentDescriptionPayload'] = ResolversParentTypes['UpdateAgentDescriptionPayload']> = ResolversObject<{
  agent?: Resolver<ResolversTypes['Agent'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateAnnouncementPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAnnouncementPayload'] = ResolversParentTypes['UpdateAnnouncementPayload']> = ResolversObject<{
  announcement?: Resolver<ResolversTypes['Announcement'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateAppointmentDeliveryMethodPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAppointmentDeliveryMethodPayload'] = ResolversParentTypes['UpdateAppointmentDeliveryMethodPayload']> = ResolversObject<{
  appointment?: Resolver<ResolversTypes['Appointment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateAppointmentDescriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateAppointmentDescriptionPayload'] = ResolversParentTypes['UpdateAppointmentDescriptionPayload']> = ResolversObject<{
  appointment?: Resolver<ResolversTypes['Appointment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateB2cloudSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateB2cloudSettingPayload'] = ResolversParentTypes['UpdateB2cloudSettingPayload']> = ResolversObject<{
  b2cloudSetting?: Resolver<ResolversTypes['B2cloudSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateBankAccountPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateBankAccountPayload'] = ResolversParentTypes['UpdateBankAccountPayload']> = ResolversObject<{
  bankAccount?: Resolver<ResolversTypes['BankAccount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateCheckinDescriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCheckinDescriptionPayload'] = ResolversParentTypes['UpdateCheckinDescriptionPayload']> = ResolversObject<{
  checkinEntry?: Resolver<ResolversTypes['CheckinEntry'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateCheckinSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCheckinSettingPayload'] = ResolversParentTypes['UpdateCheckinSettingPayload']> = ResolversObject<{
  checkinSetting?: Resolver<ResolversTypes['CheckinSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateCompanyAddressPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCompanyAddressPayload'] = ResolversParentTypes['UpdateCompanyAddressPayload']> = ResolversObject<{
  companyAddress?: Resolver<ResolversTypes['CompanyAddress'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateCompanyAgentSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCompanyAgentSettingPayload'] = ResolversParentTypes['UpdateCompanyAgentSettingPayload']> = ResolversObject<{
  agentSetting?: Resolver<ResolversTypes['CompanyAgentSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateCompanyContactPointPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCompanyContactPointPayload'] = ResolversParentTypes['UpdateCompanyContactPointPayload']> = ResolversObject<{
  companyContactPoint?: Resolver<ResolversTypes['CompanyContactPoint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateCompanyFeeSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCompanyFeeSettingPayload'] = ResolversParentTypes['UpdateCompanyFeeSettingPayload']> = ResolversObject<{
  companyFeeSetting?: Resolver<ResolversTypes['CompanyFeeSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateCompanyPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCompanyPayload'] = ResolversParentTypes['UpdateCompanyPayload']> = ResolversObject<{
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateCompanyPractitionerPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCompanyPractitionerPayload'] = ResolversParentTypes['UpdateCompanyPractitionerPayload']> = ResolversObject<{
  companyPractitioner?: Resolver<ResolversTypes['CompanyPractitioner'], ParentType, ContextType>;
  companyPractitionerConfirmation?: Resolver<Maybe<ResolversTypes['CompanyPractitionerConfirmation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateCompanySessionSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCompanySessionSettingPayload'] = ResolversParentTypes['UpdateCompanySessionSettingPayload']> = ResolversObject<{
  companySessionSetting?: Resolver<ResolversTypes['CompanySessionSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateContractPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateContractPayload'] = ResolversParentTypes['UpdateContractPayload']> = ResolversObject<{
  contract?: Resolver<ResolversTypes['Contract'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateContractPlanPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateContractPlanPayload'] = ResolversParentTypes['UpdateContractPlanPayload']> = ResolversObject<{
  contractPlan?: Resolver<ResolversTypes['ContractPlan'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateDraftAppointmentDescriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateDraftAppointmentDescriptionPayload'] = ResolversParentTypes['UpdateDraftAppointmentDescriptionPayload']> = ResolversObject<{
  draftAppointment?: Resolver<ResolversTypes['DraftAppointment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateFeaturePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateFeaturePayload'] = ResolversParentTypes['UpdateFeaturePayload']> = ResolversObject<{
  feature?: Resolver<ResolversTypes['Feature'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateFeatureTargetGroupPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateFeatureTargetGroupPayload'] = ResolversParentTypes['UpdateFeatureTargetGroupPayload']> = ResolversObject<{
  featureTargetGroup?: Resolver<ResolversTypes['FeatureTargetGroup'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateGendaApiKeyPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateGendaApiKeyPayload'] = ResolversParentTypes['UpdateGendaApiKeyPayload']> = ResolversObject<{
  gendaApiKey?: Resolver<ResolversTypes['GendaApiKey'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateGendaSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateGendaSettingPayload'] = ResolversParentTypes['UpdateGendaSettingPayload']> = ResolversObject<{
  gendaSetting?: Resolver<ResolversTypes['GendaSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateGuestPatientFollowupCommentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateGuestPatientFollowupCommentPayload'] = ResolversParentTypes['UpdateGuestPatientFollowupCommentPayload']> = ResolversObject<{
  guestPatientMedicationFollowupComment?: Resolver<ResolversTypes['GuestPatientMedicationFollowupComment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateMedicalInstitutionSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMedicalInstitutionSettingPayload'] = ResolversParentTypes['UpdateMedicalInstitutionSettingPayload']> = ResolversObject<{
  medicalInstitutionSetting?: Resolver<ResolversTypes['MedicalInstitutionSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateMedicationFollowupMessage2PayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMedicationFollowupMessage2Payload'] = ResolversParentTypes['UpdateMedicationFollowupMessage2Payload']> = ResolversObject<{
  medicationFollowupMessage?: Resolver<ResolversTypes['MedicationFollowupMessage'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateMedicationFollowupMessageTemplatePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMedicationFollowupMessageTemplatePayload'] = ResolversParentTypes['UpdateMedicationFollowupMessageTemplatePayload']> = ResolversObject<{
  medicationFollowupMessageTemplate?: Resolver<ResolversTypes['MedicationFollowupMessageTemplate'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateMedicationFollowupQuestionnairePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMedicationFollowupQuestionnairePayload'] = ResolversParentTypes['UpdateMedicationFollowupQuestionnairePayload']> = ResolversObject<{
  medicationFollowupQuestionnaire?: Resolver<ResolversTypes['MedicationFollowupQuestionnaire'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateMedicationFollowupQuestionnairePositionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMedicationFollowupQuestionnairePositionPayload'] = ResolversParentTypes['UpdateMedicationFollowupQuestionnairePositionPayload']> = ResolversObject<{
  medicationFollowupQuestionnaire?: Resolver<ResolversTypes['MedicationFollowupQuestionnaire'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateMedixsSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateMedixsSettingPayload'] = ResolversParentTypes['UpdateMedixsSettingPayload']> = ResolversObject<{
  medixsSetting?: Resolver<ResolversTypes['MedixsSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateNotificationSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateNotificationSettingPayload'] = ResolversParentTypes['UpdateNotificationSettingPayload']> = ResolversObject<{
  organizationNotificationSetting?: Resolver<ResolversTypes['OrganizationNotificationSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateOperatorRolePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateOperatorRolePayload'] = ResolversParentTypes['UpdateOperatorRolePayload']> = ResolversObject<{
  operatorRole?: Resolver<ResolversTypes['OperatorRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateOrganizationAddressPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateOrganizationAddressPayload'] = ResolversParentTypes['UpdateOrganizationAddressPayload']> = ResolversObject<{
  organizationAddress?: Resolver<ResolversTypes['OrganizationAddress'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateOrganizationCompanyFeeSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateOrganizationCompanyFeeSettingPayload'] = ResolversParentTypes['UpdateOrganizationCompanyFeeSettingPayload']> = ResolversObject<{
  organizationCompanyFeeSetting?: Resolver<ResolversTypes['OrganizationCompanyFeeSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateOrganizationContactPointPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateOrganizationContactPointPayload'] = ResolversParentTypes['UpdateOrganizationContactPointPayload']> = ResolversObject<{
  organizationContactPoint?: Resolver<ResolversTypes['OrganizationContactPoint'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateOrganizationFeeSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateOrganizationFeeSettingPayload'] = ResolversParentTypes['UpdateOrganizationFeeSettingPayload']> = ResolversObject<{
  organizationFeeSetting?: Resolver<ResolversTypes['OrganizationFeeSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateOrganizationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateOrganizationPayload'] = ResolversParentTypes['UpdateOrganizationPayload']> = ResolversObject<{
  adminPractitioner?: Resolver<Maybe<ResolversTypes['Practitioner']>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  practitionerCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateOutpatientQuestionnaireDescriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateOutpatientQuestionnaireDescriptionPayload'] = ResolversParentTypes['UpdateOutpatientQuestionnaireDescriptionPayload']> = ResolversObject<{
  outpatientQuestionnaireEntry?: Resolver<ResolversTypes['OutpatientQuestionnaireEntry'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateOutpatientQuestionnaireSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateOutpatientQuestionnaireSettingPayload'] = ResolversParentTypes['UpdateOutpatientQuestionnaireSettingPayload']> = ResolversObject<{
  outpatientQuestionnaireSetting?: Resolver<ResolversTypes['OutpatientQuestionnaireSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateOutpatientQuestionnaireSettingQuestionnairePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateOutpatientQuestionnaireSettingQuestionnairePayload'] = ResolversParentTypes['UpdateOutpatientQuestionnaireSettingQuestionnairePayload']> = ResolversObject<{
  outpatientQuestionnaireSettingQuestionnaire?: Resolver<ResolversTypes['OutpatientQuestionnaireSettingQuestionnaire'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdatePatientFollowupCommentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePatientFollowupCommentPayload'] = ResolversParentTypes['UpdatePatientFollowupCommentPayload']> = ResolversObject<{
  patientMedicationFollowupComment?: Resolver<ResolversTypes['PatientMedicationFollowupComment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdatePlanPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePlanPayload'] = ResolversParentTypes['UpdatePlanPayload']> = ResolversObject<{
  plan?: Resolver<ResolversTypes['Plan'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdatePractitionerAuthenticationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePractitionerAuthenticationPayload'] = ResolversParentTypes['UpdatePractitionerAuthenticationPayload']> = ResolversObject<{
  authentication?: Resolver<ResolversTypes['PractitionerAuthentication'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdatePractitionerCodeForCompanyPractitionerPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePractitionerCodeForCompanyPractitionerPayload'] = ResolversParentTypes['UpdatePractitionerCodeForCompanyPractitionerPayload']> = ResolversObject<{
  companyPractitioner?: Resolver<ResolversTypes['CompanyPractitioner'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdatePractitionerCodePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePractitionerCodePayload'] = ResolversParentTypes['UpdatePractitionerCodePayload']> = ResolversObject<{
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  practitionerCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdatePractitionerPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePractitionerPayload'] = ResolversParentTypes['UpdatePractitionerPayload']> = ResolversObject<{
  practitioner?: Resolver<ResolversTypes['Practitioner'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdatePrintPrescriptionSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePrintPrescriptionSettingPayload'] = ResolversParentTypes['UpdatePrintPrescriptionSettingPayload']> = ResolversObject<{
  agent?: Resolver<ResolversTypes['Agent'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateUberSignatureInputDataPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUberSignatureInputDataPayload'] = ResolversParentTypes['UpdateUberSignatureInputDataPayload']> = ResolversObject<{
  uberSignature?: Resolver<ResolversTypes['UberSignature'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateWebBookingsBusinessHour2PayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateWebBookingsBusinessHour2Payload'] = ResolversParentTypes['UpdateWebBookingsBusinessHour2Payload']> = ResolversObject<{
  webBookingsSetting?: Resolver<ResolversTypes['WebBookingsSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateWebBookingsExceptionBusinessHourPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateWebBookingsExceptionBusinessHourPayload'] = ResolversParentTypes['UpdateWebBookingsExceptionBusinessHourPayload']> = ResolversObject<{
  webBookingsSetting?: Resolver<ResolversTypes['WebBookingsSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateWebBookingsHolidayBusinessHourPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateWebBookingsHolidayBusinessHourPayload'] = ResolversParentTypes['UpdateWebBookingsHolidayBusinessHourPayload']> = ResolversObject<{
  webBookingsSetting?: Resolver<ResolversTypes['WebBookingsSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpdateWebBookingsSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateWebBookingsSettingPayload'] = ResolversParentTypes['UpdateWebBookingsSettingPayload']> = ResolversObject<{
  webBookingsSetting?: Resolver<ResolversTypes['WebBookingsSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsertAgreementExtensionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertAgreementExtensionPayload'] = ResolversParentTypes['UpsertAgreementExtensionPayload']> = ResolversObject<{
  agreementExtension?: Resolver<ResolversTypes['AgreementExtension'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsertClientAuthenticationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertClientAuthenticationPayload'] = ResolversParentTypes['UpsertClientAuthenticationPayload']> = ResolversObject<{
  clientAuthentication?: Resolver<ResolversTypes['ClientAuthentication'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsertCompanyWebBookingsLimitSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertCompanyWebBookingsLimitSettingPayload'] = ResolversParentTypes['UpsertCompanyWebBookingsLimitSettingPayload']> = ResolversObject<{
  companyWebBookingsLimitSetting?: Resolver<ResolversTypes['CompanyWebBookingsLimitSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsertGuestPatientMedicationFollowupStatusPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertGuestPatientMedicationFollowupStatusPayload'] = ResolversParentTypes['UpsertGuestPatientMedicationFollowupStatusPayload']> = ResolversObject<{
  guestPatientMedicationFollowupStatus?: Resolver<ResolversTypes['PatientMedicationFollowupStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsertMedicationFollowupDraftMessagePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertMedicationFollowupDraftMessagePayload'] = ResolversParentTypes['UpsertMedicationFollowupDraftMessagePayload']> = ResolversObject<{
  medicationFollowupDraftMessage?: Resolver<ResolversTypes['MedicationFollowupDraftMessage'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsertMedicationFollowupStatusSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertMedicationFollowupStatusSettingPayload'] = ResolversParentTypes['UpsertMedicationFollowupStatusSettingPayload']> = ResolversObject<{
  medicationFollowupSetting?: Resolver<ResolversTypes['MedicationFollowupSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsertOrganizationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertOrganizationPayload'] = ResolversParentTypes['UpsertOrganizationPayload']> = ResolversObject<{
  adminPractitioner?: Resolver<Maybe<ResolversTypes['Practitioner']>, ParentType, ContextType>;
  clientCert?: Resolver<Maybe<ResolversTypes['ClientCert']>, ParentType, ContextType>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  practitionerCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsertOrganizationsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertOrganizationsPayload'] = ResolversParentTypes['UpsertOrganizationsPayload']> = ResolversObject<{
  organizationImportJobInformation?: Resolver<ResolversTypes['OrganizationImportJobInformation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsertPatientMedicationFollowupStatusPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertPatientMedicationFollowupStatusPayload'] = ResolversParentTypes['UpsertPatientMedicationFollowupStatusPayload']> = ResolversObject<{
  patientMedicationFollowupStatus?: Resolver<ResolversTypes['PatientMedicationFollowupStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsertTracingReportDraftPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertTracingReportDraftPayload'] = ResolversParentTypes['UpsertTracingReportDraftPayload']> = ResolversObject<{
  tracingReportDraft?: Resolver<ResolversTypes['TracingReportDraft'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsertUberOrganizationSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertUberOrganizationSettingPayload'] = ResolversParentTypes['UpsertUberOrganizationSettingPayload']> = ResolversObject<{
  uberOrganizationSetting?: Resolver<ResolversTypes['UberOrganizationSetting'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsertUberOrganizationSettingsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertUberOrganizationSettingsPayload'] = ResolversParentTypes['UpsertUberOrganizationSettingsPayload']> = ResolversObject<{
  uberOrganizationSettingJobInformation?: Resolver<ResolversTypes['UberOrganizationSettingJobInformation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsertUberSignatureDraftPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertUberSignatureDraftPayload'] = ResolversParentTypes['UpsertUberSignatureDraftPayload']> = ResolversObject<{
  uberSignatureDraft?: Resolver<ResolversTypes['UberSignatureDraft'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsertWebBookingsAllDayLimitPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertWebBookingsAllDayLimitPayload'] = ResolversParentTypes['UpsertWebBookingsAllDayLimitPayload']> = ResolversObject<{
  webBookingsLimit?: Resolver<ResolversTypes['WebBookingsLimit'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UpsertWebBookingsLimitPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertWebBookingsLimitPayload'] = ResolversParentTypes['UpsertWebBookingsLimitPayload']> = ResolversObject<{
  webBookingsLimit?: Resolver<ResolversTypes['WebBookingsLimit'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ViewedMedicationFollowupQuestionnaireSheetPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewedMedicationFollowupQuestionnaireSheetPayload'] = ResolversParentTypes['ViewedMedicationFollowupQuestionnaireSheetPayload']> = ResolversObject<{
  medicationFollowupQuestionnaireSheet?: Resolver<Maybe<ResolversTypes['MedicationFollowupQuestionnaireSheet']>, ParentType, ContextType>;
  medicationFollowupQuestionnaireSheets?: Resolver<Maybe<Array<ResolversTypes['MedicationFollowupQuestionnaireSheet']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WebBookingsBusinessHourResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebBookingsBusinessHour'] = ResolversParentTypes['WebBookingsBusinessHour']> = ResolversObject<{
  dow?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  times?: Resolver<Array<ResolversTypes['BusinessHourTime']>, ParentType, ContextType>;
  webBookingsLimit?: Resolver<Maybe<ResolversTypes['WebBookingsLimit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WebBookingsExceptionBusinessHourResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebBookingsExceptionBusinessHour'] = ResolversParentTypes['WebBookingsExceptionBusinessHour']> = ResolversObject<{
  exceptionDate?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  times?: Resolver<Array<ResolversTypes['BusinessHourTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WebBookingsExceptionDateResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebBookingsExceptionDate'] = ResolversParentTypes['WebBookingsExceptionDate']> = ResolversObject<{
  exceptionDate?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WebBookingsHolidayBusinessHourResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebBookingsHolidayBusinessHour'] = ResolversParentTypes['WebBookingsHolidayBusinessHour']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  times?: Resolver<Array<ResolversTypes['BusinessHourTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WebBookingsLimitResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebBookingsLimit'] = ResolversParentTypes['WebBookingsLimit']> = ResolversObject<{
  allDayFacetofaceLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  allDayTelemedicineLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  limits?: Resolver<Array<ResolversTypes['WebBookingsLimitLimit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WebBookingsLimitLimitResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebBookingsLimitLimit'] = ResolversParentTypes['WebBookingsLimitLimit']> = ResolversObject<{
  endAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  facetofaceLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  telemedicineLimit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WebBookingsSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebBookingsSetting'] = ResolversParentTypes['WebBookingsSetting']> = ResolversObject<{
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  electronicPrescription?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  facetoface?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['Blob']>, ParentType, ContextType>;
  maxAppointmentCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  onlineQualificationConfirmation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  onlineQualificationConfirmationUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  openingHours?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  published?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  telemedicine?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  useHoliday?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  webBookingsBusinessHours?: Resolver<Array<ResolversTypes['WebBookingsBusinessHour']>, ParentType, ContextType>;
  webBookingsExceptionBusinessHours?: Resolver<Array<ResolversTypes['WebBookingsExceptionBusinessHour']>, ParentType, ContextType, Partial<WebBookingsSettingWebBookingsExceptionBusinessHoursArgs>>;
  webBookingsExceptionDates?: Resolver<Array<ResolversTypes['WebBookingsExceptionDate']>, ParentType, ContextType, Partial<WebBookingsSettingWebBookingsExceptionDatesArgs>>;
  webBookingsHolidayBusinessHour?: Resolver<Maybe<ResolversTypes['WebBookingsHolidayBusinessHour']>, ParentType, ContextType>;
  webBookingsSuspend?: Resolver<Maybe<ResolversTypes['WebBookingsSuspend']>, ParentType, ContextType>;
  website?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WebBookingsSuspendResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebBookingsSuspend'] = ResolversParentTypes['WebBookingsSuspend']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  untilAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WebVisitorResolvers<ContextType = any, ParentType extends ResolversParentTypes['WebVisitor'] = ResolversParentTypes['WebVisitor']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  appointment?: Resolver<ResolversTypes['Appointment'], ParentType, ContextType>;
  birthDate?: Resolver<ResolversTypes['ISO8601Date'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['ISO8601DateTime'], ParentType, ContextType>;
  familyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  givenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  medicationFollowupComments?: Resolver<ResolversTypes['GuestPatientMedicationFollowupCommentPage'], ParentType, ContextType, Partial<WebVisitorMedicationFollowupCommentsArgs>>;
  medicationFollowupDraftMessages?: Resolver<ResolversTypes['MedicationFollowupDraftMessagePage'], ParentType, ContextType, Partial<WebVisitorMedicationFollowupDraftMessagesArgs>>;
  medicationFollowupMessages?: Resolver<ResolversTypes['MedicationFollowupMessagePage'], ParentType, ContextType, Partial<WebVisitorMedicationFollowupMessagesArgs>>;
  medicationFollowupStatus?: Resolver<Maybe<ResolversTypes['PatientMedicationFollowupStatus']>, ParentType, ContextType>;
  medixsPatient?: Resolver<Maybe<ResolversTypes['MedixsPatient']>, ParentType, ContextType>;
  messageDeliverResults?: Resolver<ResolversTypes['MessageDeliverResultPage'], ParentType, ContextType, Partial<WebVisitorMessageDeliverResultsArgs>>;
  mobilePhone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneticFamilyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneticGivenName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  questionnaireSheet?: Resolver<ResolversTypes['QuestionnaireSheet'], ParentType, ContextType>;
  samePatient?: Resolver<Maybe<ResolversTypes['Patient']>, ParentType, ContextType>;
  sex?: Resolver<ResolversTypes['Sex'], ParentType, ContextType>;
  tracingReportDrafts?: Resolver<ResolversTypes['TracingReportDraftPage'], ParentType, ContextType, Partial<WebVisitorTracingReportDraftsArgs>>;
  tracingReports?: Resolver<ResolversTypes['TracingReportPage'], ParentType, ContextType, Partial<WebVisitorTracingReportsArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = any> = ResolversObject<{
  AccreteMessage?: AccreteMessageResolvers<ContextType>;
  AccreteMessagePage?: AccreteMessagePageResolvers<ContextType>;
  AccreteMessageResult?: AccreteMessageResultResolvers<ContextType>;
  ActivateAnnouncementPayload?: ActivateAnnouncementPayloadResolvers<ContextType>;
  ActivateOtpSecretPayload?: ActivateOtpSecretPayloadResolvers<ContextType>;
  AddCompanyAddressPayload?: AddCompanyAddressPayloadResolvers<ContextType>;
  AddCompanyContactPointPayload?: AddCompanyContactPointPayloadResolvers<ContextType>;
  AddCompanyPractitionerPayload?: AddCompanyPractitionerPayloadResolvers<ContextType>;
  AddContractPlanPayload?: AddContractPlanPayloadResolvers<ContextType>;
  AddIncentiveTargetCompanyPayload?: AddIncentiveTargetCompanyPayloadResolvers<ContextType>;
  AddInvitationCodePayload?: AddInvitationCodePayloadResolvers<ContextType>;
  AddOrganizationAddressPayload?: AddOrganizationAddressPayloadResolvers<ContextType>;
  AddOrganizationContactPointPayload?: AddOrganizationContactPointPayloadResolvers<ContextType>;
  AddPatientAttachmentPayload?: AddPatientAttachmentPayloadResolvers<ContextType>;
  AddUberSignatureDraftExtraTextPayload?: AddUberSignatureDraftExtraTextPayloadResolvers<ContextType>;
  Address?: AddressResolvers<ContextType>;
  Agent?: AgentResolvers<ContextType>;
  AgentSetting?: AgentSettingResolvers<ContextType>;
  AgreementExtension?: AgreementExtensionResolvers<ContextType>;
  AgreementExtensionPage?: AgreementExtensionPageResolvers<ContextType>;
  AllPatient?: AllPatientResolvers<ContextType>;
  AllPatientPage?: AllPatientPageResolvers<ContextType>;
  AllowList?: AllowListResolvers<ContextType>;
  AllowOperatorAccessPermissionPayload?: AllowOperatorAccessPermissionPayloadResolvers<ContextType>;
  Announcement?: AnnouncementResolvers<ContextType>;
  AnnouncementConnection?: AnnouncementConnectionResolvers<ContextType>;
  AnnouncementEdge?: AnnouncementEdgeResolvers<ContextType>;
  AnnouncementPage?: AnnouncementPageResolvers<ContextType>;
  AppendIdToFeatureTargetGroupPayload?: AppendIdToFeatureTargetGroupPayloadResolvers<ContextType>;
  AppendToFeatureTargetGroupPayload?: AppendToFeatureTargetGroupPayloadResolvers<ContextType>;
  Appointment?: AppointmentResolvers<ContextType>;
  AppointmentConnection?: AppointmentConnectionResolvers<ContextType>;
  AppointmentEdge?: AppointmentEdgeResolvers<ContextType>;
  AppointmentPage?: AppointmentPageResolvers<ContextType>;
  ApproveUberSignaturePayload?: ApproveUberSignaturePayloadResolvers<ContextType>;
  AuthToken?: AuthTokenResolvers<ContextType>;
  B2cloudSetting?: B2cloudSettingResolvers<ContextType>;
  B2cloudSettingData?: B2cloudSettingDataResolvers<ContextType>;
  B2cloudSettingSenderData?: B2cloudSettingSenderDataResolvers<ContextType>;
  Bank?: BankResolvers<ContextType>;
  BankAccount?: BankAccountResolvers<ContextType>;
  BankBranch?: BankBranchResolvers<ContextType>;
  BankPage?: BankPageResolvers<ContextType>;
  Blob?: BlobResolvers<ContextType>;
  BookAppointmentPayload?: BookAppointmentPayloadResolvers<ContextType>;
  Bookmark?: BookmarkResolvers<ContextType>;
  BookmarkedPatientCount?: BookmarkedPatientCountResolvers<ContextType>;
  BookmarkedPatientCountPage?: BookmarkedPatientCountPageResolvers<ContextType>;
  Branch?: BranchResolvers<ContextType>;
  BranchPage?: BranchPageResolvers<ContextType>;
  BulkDuplicateMedicationFollowupMessageTemplatesPayload?: BulkDuplicateMedicationFollowupMessageTemplatesPayloadResolvers<ContextType>;
  BusinessHourTime?: BusinessHourTimeResolvers<ContextType>;
  CancelAppointmentPayload?: CancelAppointmentPayloadResolvers<ContextType>;
  CancelAppointmentViaWebPayload?: CancelAppointmentViaWebPayloadResolvers<ContextType>;
  CancelAppointmentWithWebVisitorPayload?: CancelAppointmentWithWebVisitorPayloadResolvers<ContextType>;
  CancelDraftAppointmentPayload?: CancelDraftAppointmentPayloadResolvers<ContextType>;
  CancelOperatorAccessPermissionPayload?: CancelOperatorAccessPermissionPayloadResolvers<ContextType>;
  ChangeDeliveryMethodPayload?: ChangeDeliveryMethodPayloadResolvers<ContextType>;
  ChangeOutpatientQuestionnaireSettingQuestionnaireInUsePayload?: ChangeOutpatientQuestionnaireSettingQuestionnaireInUsePayloadResolvers<ContextType>;
  Charge?: ChargeResolvers<ContextType>;
  ChargeHistory?: ChargeHistoryResolvers<ContextType>;
  ChargeHistoryAmountDetail?: ChargeHistoryAmountDetailResolvers<ContextType>;
  ChargeHistoryPage?: ChargeHistoryPageResolvers<ContextType>;
  ChargeWithApp2Payload?: ChargeWithApp2PayloadResolvers<ContextType>;
  ChargeWithAppPayload?: ChargeWithAppPayloadResolvers<ContextType>;
  ChargeWithCash2Payload?: ChargeWithCash2PayloadResolvers<ContextType>;
  ChargeWithCashPayload?: ChargeWithCashPayloadResolvers<ContextType>;
  CheckinEntry?: CheckinEntryResolvers<ContextType>;
  CheckinEntryPage?: CheckinEntryPageResolvers<ContextType>;
  CheckinOrganization?: CheckinOrganizationResolvers<ContextType>;
  CheckinSetting?: CheckinSettingResolvers<ContextType>;
  City?: CityResolvers<ContextType>;
  ClientAuthentication?: ClientAuthenticationResolvers<ContextType>;
  ClientCert?: ClientCertResolvers<ContextType>;
  ClientCertJobInformation?: ClientCertJobInformationResolvers<ContextType>;
  ClientCertPage?: ClientCertPageResolvers<ContextType>;
  ClientCertSummary?: ClientCertSummaryResolvers<ContextType>;
  ClientCertSummaryPage?: ClientCertSummaryPageResolvers<ContextType>;
  ClientCertVerification?: ClientCertVerificationResolvers<ContextType>;
  Company?: CompanyResolvers<ContextType>;
  CompanyAddress?: CompanyAddressResolvers<ContextType>;
  CompanyAgentSetting?: CompanyAgentSettingResolvers<ContextType>;
  CompanyCommonSetting?: CompanyCommonSettingResolvers<ContextType>;
  CompanyContactPoint?: CompanyContactPointResolvers<ContextType>;
  CompanyFeeSetting?: CompanyFeeSettingResolvers<ContextType>;
  CompanyFeeSettingPage?: CompanyFeeSettingPageResolvers<ContextType>;
  CompanyMonthlySales?: CompanyMonthlySalesResolvers<ContextType>;
  CompanyPractitioner?: CompanyPractitionerResolvers<ContextType>;
  CompanyPractitionerConfirmation?: CompanyPractitionerConfirmationResolvers<ContextType>;
  CompanyPractitionerConfirmationData?: CompanyPractitionerConfirmationDataResolvers<ContextType>;
  CompanyPractitionerContactPoint?: CompanyPractitionerContactPointResolvers<ContextType>;
  CompanySessionSetting?: CompanySessionSettingResolvers<ContextType>;
  CompanySetupDocument?: CompanySetupDocumentResolvers<ContextType>;
  CompanyWebBookingsLimitSetting?: CompanyWebBookingsLimitSettingResolvers<ContextType>;
  ContactPoint?: ContactPointResolvers<ContextType>;
  Contract?: ContractResolvers<ContextType>;
  ContractPlan?: ContractPlanResolvers<ContextType>;
  CreateAllowListPayload?: CreateAllowListPayloadResolvers<ContextType>;
  CreateAnnouncementPayload?: CreateAnnouncementPayloadResolvers<ContextType>;
  CreateAppointmentViaWebPayload?: CreateAppointmentViaWebPayloadResolvers<ContextType>;
  CreateAuthTokenByProxyPayload?: CreateAuthTokenByProxyPayloadResolvers<ContextType>;
  CreateCheckinEntryPayload?: CreateCheckinEntryPayloadResolvers<ContextType>;
  CreateClientCertPayload?: CreateClientCertPayloadResolvers<ContextType>;
  CreateCompanyFeeSettingPayload?: CreateCompanyFeeSettingPayloadResolvers<ContextType>;
  CreateCompanySetupDocumentPayload?: CreateCompanySetupDocumentPayloadResolvers<ContextType>;
  CreateDirectVisitorPayload?: CreateDirectVisitorPayloadResolvers<ContextType>;
  CreateFeaturePayload?: CreateFeaturePayloadResolvers<ContextType>;
  CreateFeatureTargetGroupFromTargetPayload?: CreateFeatureTargetGroupFromTargetPayloadResolvers<ContextType>;
  CreateFeatureTargetGroupPayload?: CreateFeatureTargetGroupPayloadResolvers<ContextType>;
  CreateGendaSettingPayload?: CreateGendaSettingPayloadResolvers<ContextType>;
  CreateGuestPatientFollowupCommentPayload?: CreateGuestPatientFollowupCommentPayloadResolvers<ContextType>;
  CreateMedicalInstitutionSettingPayload?: CreateMedicalInstitutionSettingPayloadResolvers<ContextType>;
  CreateMedicationFollowupMessage2Payload?: CreateMedicationFollowupMessage2PayloadResolvers<ContextType>;
  CreateMedicationFollowupMessageTemplatePayload?: CreateMedicationFollowupMessageTemplatePayloadResolvers<ContextType>;
  CreateMedicationFollowupQuestionnairePayload?: CreateMedicationFollowupQuestionnairePayloadResolvers<ContextType>;
  CreateMedicationFollowupQuestionnaireSheetPayload?: CreateMedicationFollowupQuestionnaireSheetPayloadResolvers<ContextType>;
  CreateMedixsSettingPayload?: CreateMedixsSettingPayloadResolvers<ContextType>;
  CreateMessageForWebVisitorPayload?: CreateMessageForWebVisitorPayloadResolvers<ContextType>;
  CreateOperatorAuthorityPayload?: CreateOperatorAuthorityPayloadResolvers<ContextType>;
  CreateOperatorRolePayload?: CreateOperatorRolePayloadResolvers<ContextType>;
  CreateOrganizationCompanyFeeSettingPayload?: CreateOrganizationCompanyFeeSettingPayloadResolvers<ContextType>;
  CreateOrganizationFeeSettingPayload?: CreateOrganizationFeeSettingPayloadResolvers<ContextType>;
  CreateOrganizationPayload?: CreateOrganizationPayloadResolvers<ContextType>;
  CreateOtpSecretPayload?: CreateOtpSecretPayloadResolvers<ContextType>;
  CreateOutpatientQuestionnaireEntryPayload?: CreateOutpatientQuestionnaireEntryPayloadResolvers<ContextType>;
  CreateOutpatientQuestionnaireSettingQuestionnairePayload?: CreateOutpatientQuestionnaireSettingQuestionnairePayloadResolvers<ContextType>;
  CreatePatientFollowupCommentPayload?: CreatePatientFollowupCommentPayloadResolvers<ContextType>;
  CreatePlanPayload?: CreatePlanPayloadResolvers<ContextType>;
  CreatePractitionerPayload?: CreatePractitionerPayloadResolvers<ContextType>;
  CreateTracingReportPayload?: CreateTracingReportPayloadResolvers<ContextType>;
  CreateUberAgreementExtensionPayload?: CreateUberAgreementExtensionPayloadResolvers<ContextType>;
  CreateUberDeliveryPayload?: CreateUberDeliveryPayloadResolvers<ContextType>;
  CsCity?: CsCityResolvers<ContextType>;
  CsClinic?: CsClinicResolvers<ContextType>;
  CsClinicCategory?: CsClinicCategoryResolvers<ContextType>;
  CsClinicPage?: CsClinicPageResolvers<ContextType>;
  CsClinicSubCategory?: CsClinicSubCategoryResolvers<ContextType>;
  DeactivateAnnouncementPayload?: DeactivateAnnouncementPayloadResolvers<ContextType>;
  DeactivateCompanyFeeSettingPayload?: DeactivateCompanyFeeSettingPayloadResolvers<ContextType>;
  DeactivateCompanyPayload?: DeactivateCompanyPayloadResolvers<ContextType>;
  DeactivateMedicationFollowupMessagePayload?: DeactivateMedicationFollowupMessagePayloadResolvers<ContextType>;
  DeactivateMedicationFollowupMessageTemplatePayload?: DeactivateMedicationFollowupMessageTemplatePayloadResolvers<ContextType>;
  DeactivateMedicationFollowupQuestionnairePayload?: DeactivateMedicationFollowupQuestionnairePayloadResolvers<ContextType>;
  DeactivateOperatorPayload?: DeactivateOperatorPayloadResolvers<ContextType>;
  DeactivateOrganizationFeeSettingPayload?: DeactivateOrganizationFeeSettingPayloadResolvers<ContextType>;
  DeactivateOtpSecretsPayload?: DeactivateOtpSecretsPayloadResolvers<ContextType>;
  DeactivatePractitionerPayload?: DeactivatePractitionerPayloadResolvers<ContextType>;
  DeleteAllowListPayload?: DeleteAllowListPayloadResolvers<ContextType>;
  DeleteFeaturePayload?: DeleteFeaturePayloadResolvers<ContextType>;
  DeleteFeatureTargetGroupPayload?: DeleteFeatureTargetGroupPayloadResolvers<ContextType>;
  DeleteFromFeatureTargetGroupPayload?: DeleteFromFeatureTargetGroupPayloadResolvers<ContextType>;
  DeleteGuestPatientMedicationFollowupCommentPayload?: DeleteGuestPatientMedicationFollowupCommentPayloadResolvers<ContextType>;
  DeleteIdFromFeatureTargetGroupPayload?: DeleteIdFromFeatureTargetGroupPayloadResolvers<ContextType>;
  DeleteMedicationFollowupDraftMessagePayload?: DeleteMedicationFollowupDraftMessagePayloadResolvers<ContextType>;
  DeleteOperatorAuthorityPayload?: DeleteOperatorAuthorityPayloadResolvers<ContextType>;
  DeleteOperatorRolePayload?: DeleteOperatorRolePayloadResolvers<ContextType>;
  DeleteOrganizationPayload?: DeleteOrganizationPayloadResolvers<ContextType>;
  DeleteOutpatientQuestionnaireSettingQuestionnairePayload?: DeleteOutpatientQuestionnaireSettingQuestionnairePayloadResolvers<ContextType>;
  DeletePatientAttachmentPayload?: DeletePatientAttachmentPayloadResolvers<ContextType>;
  DeletePatientMedicationFollowupCommentPayload?: DeletePatientMedicationFollowupCommentPayloadResolvers<ContextType>;
  DeleteTracingReportDraftPayload?: DeleteTracingReportDraftPayloadResolvers<ContextType>;
  DescriptionCode?: DescriptionCodeResolvers<ContextType>;
  DirectVisitor?: DirectVisitorResolvers<ContextType>;
  DirectVisitorCandidate?: DirectVisitorCandidateResolvers<ContextType>;
  DirectVisitorCandidatePage?: DirectVisitorCandidatePageResolvers<ContextType>;
  DirectVisitorPage?: DirectVisitorPageResolvers<ContextType>;
  DisclosedMedicineNote?: DisclosedMedicineNoteResolvers<ContextType>;
  DisclosedMedicineNotePage?: DisclosedMedicineNotePageResolvers<ContextType>;
  DownloadClientCertPayload?: DownloadClientCertPayloadResolvers<ContextType>;
  DraftAppointment?: DraftAppointmentResolvers<ContextType>;
  DraftAppointmentPage?: DraftAppointmentPageResolvers<ContextType>;
  DumpOrganizationsPayload?: DumpOrganizationsPayloadResolvers<ContextType>;
  EditDirectVisitorPayload?: EditDirectVisitorPayloadResolvers<ContextType>;
  Encounter?: EncounterResolvers<ContextType>;
  Event?: EventResolvers<ContextType>;
  EventPage?: EventPageResolvers<ContextType>;
  ExtendCompanySetupDocumentPayload?: ExtendCompanySetupDocumentPayloadResolvers<ContextType>;
  Extension?: ExtensionResolvers<ContextType>;
  FaximoSendFax?: FaximoSendFaxResolvers<ContextType>;
  FaximoSendFaxPage?: FaximoSendFaxPageResolvers<ContextType>;
  Feature?: FeatureResolvers<ContextType>;
  FeatureTarget?: FeatureTargetResolvers<ContextType>;
  FeatureTargetGroup?: FeatureTargetGroupResolvers<ContextType>;
  FeatureUsage?: FeatureUsageResolvers<ContextType>;
  FeatureUsagePage?: FeatureUsagePageResolvers<ContextType>;
  FeeSetting?: FeeSettingResolvers<ContextType>;
  FeeSettingPage?: FeeSettingPageResolvers<ContextType>;
  FetchMedixsReceptionPayload?: FetchMedixsReceptionPayloadResolvers<ContextType>;
  FinalizeDeliveryOutputPayload?: FinalizeDeliveryOutputPayloadResolvers<ContextType>;
  FinishAppointmentPayload?: FinishAppointmentPayloadResolvers<ContextType>;
  FinishCheckinEntryPayload?: FinishCheckinEntryPayloadResolvers<ContextType>;
  FinishDraftAppointmentPayload?: FinishDraftAppointmentPayloadResolvers<ContextType>;
  FinishEncounterPayload?: FinishEncounterPayloadResolvers<ContextType>;
  FinishOutpatientQuestionnaireEntryPayload?: FinishOutpatientQuestionnaireEntryPayloadResolvers<ContextType>;
  FulfillAppointmentPayload?: FulfillAppointmentPayloadResolvers<ContextType>;
  GendaApiKey?: GendaApiKeyResolvers<ContextType>;
  GendaApiKeyData?: GendaApiKeyDataResolvers<ContextType>;
  GendaSetting?: GendaSettingResolvers<ContextType>;
  GendaSettingPage?: GendaSettingPageResolvers<ContextType>;
  GenerateAgentArtifactPayload?: GenerateAgentArtifactPayloadResolvers<ContextType>;
  GenerateBookmarkedPatientsCountCsvPayload?: GenerateBookmarkedPatientsCountCsvPayloadResolvers<ContextType>;
  GenerateClientCertCsvPayload?: GenerateClientCertCsvPayloadResolvers<ContextType>;
  GenerateCompanyMedicationFollowupMessageUsagesCsvPayload?: GenerateCompanyMedicationFollowupMessageUsagesCsvPayloadResolvers<ContextType>;
  GenerateCompanyOrganizationsAppDownloadUrlsCsvPayload?: GenerateCompanyOrganizationsAppDownloadUrlsCsvPayloadResolvers<ContextType>;
  GenerateCompanyReceptionUsagesCsvPayload?: GenerateCompanyReceptionUsagesCsvPayloadResolvers<ContextType>;
  GenerateCompanyReceptionsCsvPayload?: GenerateCompanyReceptionsCsvPayloadResolvers<ContextType>;
  GenerateCompanySalesDetailsCsvPayload?: GenerateCompanySalesDetailsCsvPayloadResolvers<ContextType>;
  GenerateCompanyTracingReportUsagesCsvPayload?: GenerateCompanyTracingReportUsagesCsvPayloadResolvers<ContextType>;
  GenerateCsvForClientCertsImportPayload?: GenerateCsvForClientCertsImportPayloadResolvers<ContextType>;
  GenerateCsvForMessageTemplatesBulkDuplicatePayload?: GenerateCsvForMessageTemplatesBulkDuplicatePayloadResolvers<ContextType>;
  GenerateCsvForUberOrganizationSettingsUpsertPayload?: GenerateCsvForUberOrganizationSettingsUpsertPayloadResolvers<ContextType>;
  GenerateDeliveryCsvPayload?: GenerateDeliveryCsvPayloadResolvers<ContextType>;
  GenerateIncentivePayoutNotificationPayload?: GenerateIncentivePayoutNotificationPayloadResolvers<ContextType>;
  GenerateOrganizationAuditEventCsvPayload?: GenerateOrganizationAuditEventCsvPayloadResolvers<ContextType>;
  GeneratePayoutOrganizationsWithBankAccountCsvPayload?: GeneratePayoutOrganizationsWithBankAccountCsvPayloadResolvers<ContextType>;
  GenerateUberSignaturePreviewFormDataPayload?: GenerateUberSignaturePreviewFormDataPayloadResolvers<ContextType>;
  GenerateUberSignaturePreviewOnlyExtraTextPayload?: GenerateUberSignaturePreviewOnlyExtraTextPayloadResolvers<ContextType>;
  GenerateUberSignaturePreviewPayload?: GenerateUberSignaturePreviewPayloadResolvers<ContextType>;
  GuestPatient?: GuestPatientResolvers<ContextType>;
  GuestPatientMedicationFollowupComment?: GuestPatientMedicationFollowupCommentResolvers<ContextType>;
  GuestPatientMedicationFollowupCommentPage?: GuestPatientMedicationFollowupCommentPageResolvers<ContextType>;
  HiccupAppointmentPermission?: HiccupAppointmentPermissionResolvers<ContextType>;
  HiccupOnetimeApiCache?: HiccupOnetimeApiCacheResolvers<ContextType>;
  HiccupOnetimeApiCachePatientProfile?: HiccupOnetimeApiCachePatientProfileResolvers<ContextType>;
  HiccupTemporaryPermission?: HiccupTemporaryPermissionResolvers<ContextType>;
  HiccupTemporaryPermissionPage?: HiccupTemporaryPermissionPageResolvers<ContextType>;
  Holiday?: HolidayResolvers<ContextType>;
  ISO8601Date?: GraphQLScalarType;
  ISO8601DateTime?: GraphQLScalarType;
  IdentifyMedixsPatientPayload?: IdentifyMedixsPatientPayloadResolvers<ContextType>;
  IdentifyMedixsReceptionPayload?: IdentifyMedixsReceptionPayloadResolvers<ContextType>;
  ImportClientCertsPayload?: ImportClientCertsPayloadResolvers<ContextType>;
  ImportOrganizationsPayload?: ImportOrganizationsPayloadResolvers<ContextType>;
  ImportUberOrganizationsCsvPayload?: ImportUberOrganizationsCsvPayloadResolvers<ContextType>;
  InvitationCode?: InvitationCodeResolvers<ContextType>;
  InvitationCodePage?: InvitationCodePageResolvers<ContextType>;
  Invoice?: InvoiceResolvers<ContextType>;
  IssueGendaApiKeyPayload?: IssueGendaApiKeyPayloadResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  LineItem?: LineItemResolvers<ContextType>;
  LineItemType?: LineItemTypeResolvers<ContextType>;
  LoginUser?: LoginUserResolvers<ContextType>;
  MarkAnnouncementPayload?: MarkAnnouncementPayloadResolvers<ContextType>;
  MarkHiccupTemporaryPermissionPayload?: MarkHiccupTemporaryPermissionPayloadResolvers<ContextType>;
  MarkOrganizationNotificationByAppointmentPayload?: MarkOrganizationNotificationByAppointmentPayloadResolvers<ContextType>;
  MarkOrganizationNotificationPayload?: MarkOrganizationNotificationPayloadResolvers<ContextType>;
  MedicalInstitutionSetting?: MedicalInstitutionSettingResolvers<ContextType>;
  MedicalInstitutionSettingPage?: MedicalInstitutionSettingPageResolvers<ContextType>;
  MedicationFollowupAutoReplySetting?: MedicationFollowupAutoReplySettingResolvers<ContextType>;
  MedicationFollowupAutoReplySettingTemplate?: MedicationFollowupAutoReplySettingTemplateResolvers<ContextType>;
  MedicationFollowupComment?: MedicationFollowupCommentResolvers<ContextType>;
  MedicationFollowupCommentPage?: MedicationFollowupCommentPageResolvers<ContextType>;
  MedicationFollowupDraftMessage?: MedicationFollowupDraftMessageResolvers<ContextType>;
  MedicationFollowupDraftMessageData?: MedicationFollowupDraftMessageDataResolvers<ContextType>;
  MedicationFollowupDraftMessagePage?: MedicationFollowupDraftMessagePageResolvers<ContextType>;
  MedicationFollowupMessage?: MedicationFollowupMessageResolvers<ContextType>;
  MedicationFollowupMessagePage?: MedicationFollowupMessagePageResolvers<ContextType>;
  MedicationFollowupMessageTemplate?: MedicationFollowupMessageTemplateResolvers<ContextType>;
  MedicationFollowupMessageTemplateJobInformation?: MedicationFollowupMessageTemplateJobInformationResolvers<ContextType>;
  MedicationFollowupMessageTemplatePage?: MedicationFollowupMessageTemplatePageResolvers<ContextType>;
  MedicationFollowupQuestionnaire?: MedicationFollowupQuestionnaireResolvers<ContextType>;
  MedicationFollowupQuestionnaireChoice?: MedicationFollowupQuestionnaireChoiceResolvers<ContextType>;
  MedicationFollowupQuestionnaireCondition?: MedicationFollowupQuestionnaireConditionResolvers<ContextType>;
  MedicationFollowupQuestionnaireFormData?: MedicationFollowupQuestionnaireFormDataResolvers<ContextType>;
  MedicationFollowupQuestionnairePage?: MedicationFollowupQuestionnairePageResolvers<ContextType>;
  MedicationFollowupQuestionnaireQuestion?: MedicationFollowupQuestionnaireQuestionResolvers<ContextType>;
  MedicationFollowupQuestionnaireRevision?: MedicationFollowupQuestionnaireRevisionResolvers<ContextType>;
  MedicationFollowupQuestionnaireSection?: MedicationFollowupQuestionnaireSectionResolvers<ContextType>;
  MedicationFollowupQuestionnaireSheet?: MedicationFollowupQuestionnaireSheetResolvers<ContextType>;
  MedicationFollowupQuestionnaireSheetPage?: MedicationFollowupQuestionnaireSheetPageResolvers<ContextType>;
  MedicationFollowupSetting?: MedicationFollowupSettingResolvers<ContextType>;
  MedicationFollowupUsage?: MedicationFollowupUsageResolvers<ContextType>;
  MedicationFollowupUsagePage?: MedicationFollowupUsagePageResolvers<ContextType>;
  Medicine?: MedicineResolvers<ContextType>;
  MedicineNote?: MedicineNoteResolvers<ContextType>;
  MedicineNoteClinic?: MedicineNoteClinicResolvers<ContextType>;
  MedicineNoteClinicRecord?: MedicineNoteClinicRecordResolvers<ContextType>;
  MedicineNoteDispensingDateRecord?: MedicineNoteDispensingDateRecordResolvers<ContextType>;
  MedicineNoteDispensingPharmacy?: MedicineNoteDispensingPharmacyResolvers<ContextType>;
  MedicineNoteDoctor?: MedicineNoteDoctorResolvers<ContextType>;
  MedicineNoteDoctorRecord?: MedicineNoteDoctorRecordResolvers<ContextType>;
  MedicineNoteDosage?: MedicineNoteDosageResolvers<ContextType>;
  MedicineNoteDosageCaution?: MedicineNoteDosageCautionResolvers<ContextType>;
  MedicineNoteDosageCautionRecord?: MedicineNoteDosageCautionRecordResolvers<ContextType>;
  MedicineNoteDosagePlusRecord?: MedicineNoteDosagePlusRecordResolvers<ContextType>;
  MedicineNoteDosageRecord?: MedicineNoteDosageRecordResolvers<ContextType>;
  MedicineNoteMedicine?: MedicineNoteMedicineResolvers<ContextType>;
  MedicineNoteMedicineCautionRecord?: MedicineNoteMedicineCautionRecordResolvers<ContextType>;
  MedicineNoteMedicinePlusRecord?: MedicineNoteMedicinePlusRecordResolvers<ContextType>;
  MedicineNoteMedicineRecord?: MedicineNoteMedicineRecordResolvers<ContextType>;
  MedicineNoteNotebookMemo?: MedicineNoteNotebookMemoResolvers<ContextType>;
  MedicineNoteNotebookMemoRecord?: MedicineNoteNotebookMemoRecordResolvers<ContextType>;
  MedicineNoteOtcDrugDosage?: MedicineNoteOtcDrugDosageResolvers<ContextType>;
  MedicineNoteOtcDrugDosageRecord?: MedicineNoteOtcDrugDosageRecordResolvers<ContextType>;
  MedicineNoteOtcDrugIngredientRecord?: MedicineNoteOtcDrugIngredientRecordResolvers<ContextType>;
  MedicineNotePatient?: MedicineNotePatientResolvers<ContextType>;
  MedicineNotePatientProfile?: MedicineNotePatientProfileResolvers<ContextType>;
  MedicineNotePatientRecord?: MedicineNotePatientRecordResolvers<ContextType>;
  MedicineNotePatientReportRecord?: MedicineNotePatientReportRecordResolvers<ContextType>;
  MedicineNotePharmacistRecord?: MedicineNotePharmacistRecordResolvers<ContextType>;
  MedicineNotePharmacyRecord?: MedicineNotePharmacyRecordResolvers<ContextType>;
  MedicineNotePrecaution?: MedicineNotePrecautionResolvers<ContextType>;
  MedicineNotePrecautionRecord?: MedicineNotePrecautionRecordResolvers<ContextType>;
  MedicineNotePrescription?: MedicineNotePrescriptionResolvers<ContextType>;
  MedicineNotePrescriptionMemo?: MedicineNotePrescriptionMemoResolvers<ContextType>;
  MedicineNotePrescriptionMemoRecord?: MedicineNotePrescriptionMemoRecordResolvers<ContextType>;
  MedicineNotePrescriptionRecipe?: MedicineNotePrescriptionRecipeResolvers<ContextType>;
  MedicineNotePrimaryPharmacist?: MedicineNotePrimaryPharmacistResolvers<ContextType>;
  MedicineNotePrimaryPharmacistRecord?: MedicineNotePrimaryPharmacistRecordResolvers<ContextType>;
  MedicineNoteRecipeInformation?: MedicineNoteRecipeInformationResolvers<ContextType>;
  MedicineNoteRemaining?: MedicineNoteRemainingResolvers<ContextType>;
  MedicineNoteRemainingRecord?: MedicineNoteRemainingRecordResolvers<ContextType>;
  MedicineNoteRemark?: MedicineNoteRemarkResolvers<ContextType>;
  MedicineNoteRemarkRecord?: MedicineNoteRemarkRecordResolvers<ContextType>;
  MedicineNoteSplitControl?: MedicineNoteSplitControlResolvers<ContextType>;
  MedicineNoteSplitControlRecord?: MedicineNoteSplitControlRecordResolvers<ContextType>;
  MedicineNoteVersion?: MedicineNoteVersionResolvers<ContextType>;
  MedicineNoteVersionRecord?: MedicineNoteVersionRecordResolvers<ContextType>;
  MedicineNoteWarning?: MedicineNoteWarningResolvers<ContextType>;
  MedicineNoteWarningRecord?: MedicineNoteWarningRecordResolvers<ContextType>;
  MedicineNotesByOnetimeCode?: MedicineNotesByOnetimeCodeResolvers<ContextType>;
  MedicineNotesByPatient?: MedicineNotesByPatientResolvers<ContextType>;
  MedicinePage?: MedicinePageResolvers<ContextType>;
  MedixsDispensingRecord?: MedixsDispensingRecordResolvers<ContextType>;
  MedixsEvent?: MedixsEventResolvers<ContextType>;
  MedixsEventPage?: MedixsEventPageResolvers<ContextType>;
  MedixsPatient?: MedixsPatientResolvers<ContextType>;
  MedixsPatientPage?: MedixsPatientPageResolvers<ContextType>;
  MedixsPatientQuestionnaireSheet?: MedixsPatientQuestionnaireSheetResolvers<ContextType>;
  MedixsReception?: MedixsReceptionResolvers<ContextType>;
  MedixsReceptionPage?: MedixsReceptionPageResolvers<ContextType>;
  MedixsReceptionPrescription?: MedixsReceptionPrescriptionResolvers<ContextType>;
  MedixsSetting?: MedixsSettingResolvers<ContextType>;
  MessageDeliver?: MessageDeliverResolvers<ContextType>;
  MessageDeliverResult?: MessageDeliverResultResolvers<ContextType>;
  MessageDeliverResultPage?: MessageDeliverResultPageResolvers<ContextType>;
  MonthlyPayoutStatement?: MonthlyPayoutStatementResolvers<ContextType>;
  MonthlyPayoutStatementPage?: MonthlyPayoutStatementPageResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Node?: NodeResolvers<ContextType>;
  NotificationSettingData?: NotificationSettingDataResolvers<ContextType>;
  NotificationSettingSound?: NotificationSettingSoundResolvers<ContextType>;
  NotificationSettingTel?: NotificationSettingTelResolvers<ContextType>;
  NotifyCheckinEntryPayload?: NotifyCheckinEntryPayloadResolvers<ContextType>;
  NotifyOutpatientQuestionnaireEntryPayload?: NotifyOutpatientQuestionnaireEntryPayloadResolvers<ContextType>;
  Operator?: OperatorResolvers<ContextType>;
  OperatorAccessPermission?: OperatorAccessPermissionResolvers<ContextType>;
  OperatorRole?: OperatorRoleResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  OrganizationAddress?: OrganizationAddressResolvers<ContextType>;
  OrganizationCompanyFeeSetting?: OrganizationCompanyFeeSettingResolvers<ContextType>;
  OrganizationContactPoint?: OrganizationContactPointResolvers<ContextType>;
  OrganizationDailySales?: OrganizationDailySalesResolvers<ContextType>;
  OrganizationDailySalesDetail?: OrganizationDailySalesDetailResolvers<ContextType>;
  OrganizationDailySalesPage?: OrganizationDailySalesPageResolvers<ContextType>;
  OrganizationFeeSetting?: OrganizationFeeSettingResolvers<ContextType>;
  OrganizationImportJobInformation?: OrganizationImportJobInformationResolvers<ContextType>;
  OrganizationImportJobInformationConnection?: OrganizationImportJobInformationConnectionResolvers<ContextType>;
  OrganizationImportJobInformationEdge?: OrganizationImportJobInformationEdgeResolvers<ContextType>;
  OrganizationNotification?: OrganizationNotificationResolvers<ContextType>;
  OrganizationNotificationPage?: OrganizationNotificationPageResolvers<ContextType>;
  OrganizationNotificationSetting?: OrganizationNotificationSettingResolvers<ContextType>;
  OrganizationPage?: OrganizationPageResolvers<ContextType>;
  OutpatientQuestionnaire?: OutpatientQuestionnaireResolvers<ContextType>;
  OutpatientQuestionnaireEntry?: OutpatientQuestionnaireEntryResolvers<ContextType>;
  OutpatientQuestionnaireOrganization?: OutpatientQuestionnaireOrganizationResolvers<ContextType>;
  OutpatientQuestionnaireQuestion?: OutpatientQuestionnaireQuestionResolvers<ContextType>;
  OutpatientQuestionnaireSetting?: OutpatientQuestionnaireSettingResolvers<ContextType>;
  OutpatientQuestionnaireSettingQuestionnaire?: OutpatientQuestionnaireSettingQuestionnaireResolvers<ContextType>;
  OutpatientQuestionnaireSheetAnswer?: OutpatientQuestionnaireSheetAnswerResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Patient?: PatientResolvers<ContextType>;
  PatientAttachment?: PatientAttachmentResolvers<ContextType>;
  PatientAttachmentPage?: PatientAttachmentPageResolvers<ContextType>;
  PatientConnection?: PatientConnectionResolvers<ContextType>;
  PatientEdge?: PatientEdgeResolvers<ContextType>;
  PatientMedicationFollowupComment?: PatientMedicationFollowupCommentResolvers<ContextType>;
  PatientMedicationFollowupCommentPage?: PatientMedicationFollowupCommentPageResolvers<ContextType>;
  PatientPage?: PatientPageResolvers<ContextType>;
  Payout?: PayoutResolvers<ContextType>;
  PayoutBankAccount?: PayoutBankAccountResolvers<ContextType>;
  PayoutOrganization?: PayoutOrganizationResolvers<ContextType>;
  PayoutOrganizationPage?: PayoutOrganizationPageResolvers<ContextType>;
  PayoutPage?: PayoutPageResolvers<ContextType>;
  PayoutSubject?: PayoutSubjectResolvers<ContextType>;
  PfAddress?: PfAddressResolvers<ContextType>;
  PfAttachment?: PfAttachmentResolvers<ContextType>;
  PfContactPoint?: PfContactPointResolvers<ContextType>;
  PfDispensingRequest?: PfDispensingRequestResolvers<ContextType>;
  PfDispensingRequestMedicalInstitution?: PfDispensingRequestMedicalInstitutionResolvers<ContextType>;
  PfDispensingRequestMedicalInstitutionConsultation?: PfDispensingRequestMedicalInstitutionConsultationResolvers<ContextType>;
  PfDispensingRequestMedicalInstitutionMedicalInstitution?: PfDispensingRequestMedicalInstitutionMedicalInstitutionResolvers<ContextType>;
  PfDispensingRequestMedicalInstitutionPhysician?: PfDispensingRequestMedicalInstitutionPhysicianResolvers<ContextType>;
  PfDispensingRequestMedicalInstitutionPrescription?: PfDispensingRequestMedicalInstitutionPrescriptionResolvers<ContextType>;
  PfDispensingRequestPharmacy?: PfDispensingRequestPharmacyResolvers<ContextType>;
  PfDispensingRequestPharmacyDispensing?: PfDispensingRequestPharmacyDispensingResolvers<ContextType>;
  PfDispensingRequestPharmacyPharmacist?: PfDispensingRequestPharmacyPharmacistResolvers<ContextType>;
  PfDispensingRequestPharmacyPharmacy?: PfDispensingRequestPharmacyPharmacyResolvers<ContextType>;
  PfInsuranceCard?: PfInsuranceCardResolvers<ContextType>;
  PfInsuranceCards?: PfInsuranceCardsResolvers<ContextType>;
  PfPatient?: PfPatientResolvers<ContextType>;
  PfPrescriptionImage?: PfPrescriptionImageResolvers<ContextType>;
  Plan?: PlanResolvers<ContextType>;
  PlanFeature?: PlanFeatureResolvers<ContextType>;
  PostalCode?: PostalCodeResolvers<ContextType>;
  PostalCodePage?: PostalCodePageResolvers<ContextType>;
  Practitioner?: PractitionerResolvers<ContextType>;
  PractitionerAuthentication?: PractitionerAuthenticationResolvers<ContextType>;
  PractitionerOtpSecret?: PractitionerOtpSecretResolvers<ContextType>;
  PractitionerPage?: PractitionerPageResolvers<ContextType>;
  PractitionerSigninHistory?: PractitionerSigninHistoryResolvers<ContextType>;
  PrintPrescriptionSetting?: PrintPrescriptionSettingResolvers<ContextType>;
  PrivilegeOrganization?: PrivilegeOrganizationResolvers<ContextType>;
  PrivilegeOrganizationPractitioner?: PrivilegeOrganizationPractitionerResolvers<ContextType>;
  PublicAddress?: PublicAddressResolvers<ContextType>;
  PublicAppointment?: PublicAppointmentResolvers<ContextType>;
  PublicCheckinEntry?: PublicCheckinEntryResolvers<ContextType>;
  PublicMedicationFollowupMessage?: PublicMedicationFollowupMessageResolvers<ContextType>;
  PublicMedicationFollowupQuestionnaireRevision?: PublicMedicationFollowupQuestionnaireRevisionResolvers<ContextType>;
  PublicMedicationFollowupQuestionnaireSheet?: PublicMedicationFollowupQuestionnaireSheetResolvers<ContextType>;
  PublicOrganization?: PublicOrganizationResolvers<ContextType>;
  PublicOrganizationAddress?: PublicOrganizationAddressResolvers<ContextType>;
  PublicOrganizationPage?: PublicOrganizationPageResolvers<ContextType>;
  PublicOutpatientQuestionnaireEntry?: PublicOutpatientQuestionnaireEntryResolvers<ContextType>;
  PublicSignupPfPatientInformation?: PublicSignupPfPatientInformationResolvers<ContextType>;
  PublicSignupPfPatientInformationOrganization?: PublicSignupPfPatientInformationOrganizationResolvers<ContextType>;
  PublicSlot?: PublicSlotResolvers<ContextType>;
  PublicWebBookingsSetting?: PublicWebBookingsSettingResolvers<ContextType>;
  QualifiedInvoice?: QualifiedInvoiceResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  QuestionnaireSheet?: QuestionnaireSheetResolvers<ContextType>;
  QuestionnaireSheetAnswer?: QuestionnaireSheetAnswerResolvers<ContextType>;
  Quote?: QuoteResolvers<ContextType>;
  Reception?: ReceptionResolvers<ContextType>;
  ReceptionPage?: ReceptionPageResolvers<ContextType>;
  ReceptionUsage?: ReceptionUsageResolvers<ContextType>;
  ReceptionUsagePage?: ReceptionUsagePageResolvers<ContextType>;
  RechargeWithAppPayload?: RechargeWithAppPayloadResolvers<ContextType>;
  RechargeWithCashPayload?: RechargeWithCashPayloadResolvers<ContextType>;
  RecreateTracingReportPayload?: RecreateTracingReportPayloadResolvers<ContextType>;
  RefundHistory?: RefundHistoryResolvers<ContextType>;
  RemandUberSignaturePayload?: RemandUberSignaturePayloadResolvers<ContextType>;
  RemoveCompanyAddressPayload?: RemoveCompanyAddressPayloadResolvers<ContextType>;
  RemoveCompanyContactPointPayload?: RemoveCompanyContactPointPayloadResolvers<ContextType>;
  RemoveCompanySetupDocumentPayload?: RemoveCompanySetupDocumentPayloadResolvers<ContextType>;
  RemoveMedicalInstitutionSettingPayload?: RemoveMedicalInstitutionSettingPayloadResolvers<ContextType>;
  RemoveOrganizationContactPointPayload?: RemoveOrganizationContactPointPayloadResolvers<ContextType>;
  RemoveWebBookingsExceptionBusinessHourPayload?: RemoveWebBookingsExceptionBusinessHourPayloadResolvers<ContextType>;
  RequestAppointmentPayload?: RequestAppointmentPayloadResolvers<ContextType>;
  ResendAuthenticationCodePayload?: ResendAuthenticationCodePayloadResolvers<ContextType>;
  RestartAgentPayload?: RestartAgentPayloadResolvers<ContextType>;
  ResumeWebBookingsPayload?: ResumeWebBookingsPayloadResolvers<ContextType>;
  RevokeClientCertPayload?: RevokeClientCertPayloadResolvers<ContextType>;
  SendAuthenticationCodeAndRegisterPatientEmailPayload?: SendAuthenticationCodeAndRegisterPatientEmailPayloadResolvers<ContextType>;
  SendCallNotificationPayload?: SendCallNotificationPayloadResolvers<ContextType>;
  SendClientCertMailPayload?: SendClientCertMailPayloadResolvers<ContextType>;
  SendCongestionNotificationForWebVisitorPayload?: SendCongestionNotificationForWebVisitorPayloadResolvers<ContextType>;
  SendCongestionNotificationPayload?: SendCongestionNotificationPayloadResolvers<ContextType>;
  SendDispensingPreparedNotificationPayload?: SendDispensingPreparedNotificationPayloadResolvers<ContextType>;
  SendInvitationSmsPayload?: SendInvitationSmsPayloadResolvers<ContextType>;
  SendPractitionerCodeMailPayload?: SendPractitionerCodeMailPayloadResolvers<ContextType>;
  SendTracingReportPayload?: SendTracingReportPayloadResolvers<ContextType>;
  SendgridEventActivity?: SendgridEventActivityResolvers<ContextType>;
  SetPractitionerRolePayload?: SetPractitionerRolePayloadResolvers<ContextType>;
  SigninHistory?: SigninHistoryResolvers<ContextType>;
  SignupCompanyPayload?: SignupCompanyPayloadResolvers<ContextType>;
  SignupPfPatientFromCheckinEntryPayload?: SignupPfPatientFromCheckinEntryPayloadResolvers<ContextType>;
  SignupPfPatientFromOutpatientQuestionnaireEntryPayload?: SignupPfPatientFromOutpatientQuestionnaireEntryPayloadResolvers<ContextType>;
  SkipEncounterPayload?: SkipEncounterPayloadResolvers<ContextType>;
  SubjectTotalAmount?: SubjectTotalAmountResolvers<ContextType>;
  SubscribeChannelPayload?: SubscribeChannelPayloadResolvers<ContextType>;
  SuspendWebBookingsPayload?: SuspendWebBookingsPayloadResolvers<ContextType>;
  TracingReport?: TracingReportResolvers<ContextType>;
  TracingReportData?: TracingReportDataResolvers<ContextType>;
  TracingReportDraft?: TracingReportDraftResolvers<ContextType>;
  TracingReportDraftData?: TracingReportDraftDataResolvers<ContextType>;
  TracingReportDraftPage?: TracingReportDraftPageResolvers<ContextType>;
  TracingReportDraftPrescriptionDrug?: TracingReportDraftPrescriptionDrugResolvers<ContextType>;
  TracingReportPage?: TracingReportPageResolvers<ContextType>;
  TracingReportUsage?: TracingReportUsageResolvers<ContextType>;
  TracingReportUsagePage?: TracingReportUsagePageResolvers<ContextType>;
  UberCourier?: UberCourierResolvers<ContextType>;
  UberDelivery?: UberDeliveryResolvers<ContextType>;
  UberDeliveryInvoiceFee?: UberDeliveryInvoiceFeeResolvers<ContextType>;
  UberDeliveryInvoiceFeePage?: UberDeliveryInvoiceFeePageResolvers<ContextType>;
  UberInvoice?: UberInvoiceResolvers<ContextType>;
  UberOrganization?: UberOrganizationResolvers<ContextType>;
  UberOrganizationImportJobInformation?: UberOrganizationImportJobInformationResolvers<ContextType>;
  UberOrganizationSetting?: UberOrganizationSettingResolvers<ContextType>;
  UberOrganizationSettingJobInformation?: UberOrganizationSettingJobInformationResolvers<ContextType>;
  UberQuote?: UberQuoteResolvers<ContextType>;
  UberSignature?: UberSignatureResolvers<ContextType>;
  UberSignatureData?: UberSignatureDataResolvers<ContextType>;
  UberSignatureDraft?: UberSignatureDraftResolvers<ContextType>;
  UberSignatureDraftData?: UberSignatureDraftDataResolvers<ContextType>;
  UnidentifyMedixsPatientPayload?: UnidentifyMedixsPatientPayloadResolvers<ContextType>;
  UnidentifyMedixsReceptionPayload?: UnidentifyMedixsReceptionPayloadResolvers<ContextType>;
  UnpublishOrganizationPayload?: UnpublishOrganizationPayloadResolvers<ContextType>;
  UnsubscribeChannelPayload?: UnsubscribeChannelPayloadResolvers<ContextType>;
  UpdateAgentDescriptionPayload?: UpdateAgentDescriptionPayloadResolvers<ContextType>;
  UpdateAnnouncementPayload?: UpdateAnnouncementPayloadResolvers<ContextType>;
  UpdateAppointmentDeliveryMethodPayload?: UpdateAppointmentDeliveryMethodPayloadResolvers<ContextType>;
  UpdateAppointmentDescriptionPayload?: UpdateAppointmentDescriptionPayloadResolvers<ContextType>;
  UpdateB2cloudSettingPayload?: UpdateB2cloudSettingPayloadResolvers<ContextType>;
  UpdateBankAccountPayload?: UpdateBankAccountPayloadResolvers<ContextType>;
  UpdateCheckinDescriptionPayload?: UpdateCheckinDescriptionPayloadResolvers<ContextType>;
  UpdateCheckinSettingPayload?: UpdateCheckinSettingPayloadResolvers<ContextType>;
  UpdateCompanyAddressPayload?: UpdateCompanyAddressPayloadResolvers<ContextType>;
  UpdateCompanyAgentSettingPayload?: UpdateCompanyAgentSettingPayloadResolvers<ContextType>;
  UpdateCompanyContactPointPayload?: UpdateCompanyContactPointPayloadResolvers<ContextType>;
  UpdateCompanyFeeSettingPayload?: UpdateCompanyFeeSettingPayloadResolvers<ContextType>;
  UpdateCompanyPayload?: UpdateCompanyPayloadResolvers<ContextType>;
  UpdateCompanyPractitionerPayload?: UpdateCompanyPractitionerPayloadResolvers<ContextType>;
  UpdateCompanySessionSettingPayload?: UpdateCompanySessionSettingPayloadResolvers<ContextType>;
  UpdateContractPayload?: UpdateContractPayloadResolvers<ContextType>;
  UpdateContractPlanPayload?: UpdateContractPlanPayloadResolvers<ContextType>;
  UpdateDraftAppointmentDescriptionPayload?: UpdateDraftAppointmentDescriptionPayloadResolvers<ContextType>;
  UpdateFeaturePayload?: UpdateFeaturePayloadResolvers<ContextType>;
  UpdateFeatureTargetGroupPayload?: UpdateFeatureTargetGroupPayloadResolvers<ContextType>;
  UpdateGendaApiKeyPayload?: UpdateGendaApiKeyPayloadResolvers<ContextType>;
  UpdateGendaSettingPayload?: UpdateGendaSettingPayloadResolvers<ContextType>;
  UpdateGuestPatientFollowupCommentPayload?: UpdateGuestPatientFollowupCommentPayloadResolvers<ContextType>;
  UpdateMedicalInstitutionSettingPayload?: UpdateMedicalInstitutionSettingPayloadResolvers<ContextType>;
  UpdateMedicationFollowupMessage2Payload?: UpdateMedicationFollowupMessage2PayloadResolvers<ContextType>;
  UpdateMedicationFollowupMessageTemplatePayload?: UpdateMedicationFollowupMessageTemplatePayloadResolvers<ContextType>;
  UpdateMedicationFollowupQuestionnairePayload?: UpdateMedicationFollowupQuestionnairePayloadResolvers<ContextType>;
  UpdateMedicationFollowupQuestionnairePositionPayload?: UpdateMedicationFollowupQuestionnairePositionPayloadResolvers<ContextType>;
  UpdateMedixsSettingPayload?: UpdateMedixsSettingPayloadResolvers<ContextType>;
  UpdateNotificationSettingPayload?: UpdateNotificationSettingPayloadResolvers<ContextType>;
  UpdateOperatorRolePayload?: UpdateOperatorRolePayloadResolvers<ContextType>;
  UpdateOrganizationAddressPayload?: UpdateOrganizationAddressPayloadResolvers<ContextType>;
  UpdateOrganizationCompanyFeeSettingPayload?: UpdateOrganizationCompanyFeeSettingPayloadResolvers<ContextType>;
  UpdateOrganizationContactPointPayload?: UpdateOrganizationContactPointPayloadResolvers<ContextType>;
  UpdateOrganizationFeeSettingPayload?: UpdateOrganizationFeeSettingPayloadResolvers<ContextType>;
  UpdateOrganizationPayload?: UpdateOrganizationPayloadResolvers<ContextType>;
  UpdateOutpatientQuestionnaireDescriptionPayload?: UpdateOutpatientQuestionnaireDescriptionPayloadResolvers<ContextType>;
  UpdateOutpatientQuestionnaireSettingPayload?: UpdateOutpatientQuestionnaireSettingPayloadResolvers<ContextType>;
  UpdateOutpatientQuestionnaireSettingQuestionnairePayload?: UpdateOutpatientQuestionnaireSettingQuestionnairePayloadResolvers<ContextType>;
  UpdatePatientFollowupCommentPayload?: UpdatePatientFollowupCommentPayloadResolvers<ContextType>;
  UpdatePlanPayload?: UpdatePlanPayloadResolvers<ContextType>;
  UpdatePractitionerAuthenticationPayload?: UpdatePractitionerAuthenticationPayloadResolvers<ContextType>;
  UpdatePractitionerCodeForCompanyPractitionerPayload?: UpdatePractitionerCodeForCompanyPractitionerPayloadResolvers<ContextType>;
  UpdatePractitionerCodePayload?: UpdatePractitionerCodePayloadResolvers<ContextType>;
  UpdatePractitionerPayload?: UpdatePractitionerPayloadResolvers<ContextType>;
  UpdatePrintPrescriptionSettingPayload?: UpdatePrintPrescriptionSettingPayloadResolvers<ContextType>;
  UpdateUberSignatureInputDataPayload?: UpdateUberSignatureInputDataPayloadResolvers<ContextType>;
  UpdateWebBookingsBusinessHour2Payload?: UpdateWebBookingsBusinessHour2PayloadResolvers<ContextType>;
  UpdateWebBookingsExceptionBusinessHourPayload?: UpdateWebBookingsExceptionBusinessHourPayloadResolvers<ContextType>;
  UpdateWebBookingsHolidayBusinessHourPayload?: UpdateWebBookingsHolidayBusinessHourPayloadResolvers<ContextType>;
  UpdateWebBookingsSettingPayload?: UpdateWebBookingsSettingPayloadResolvers<ContextType>;
  UpsertAgreementExtensionPayload?: UpsertAgreementExtensionPayloadResolvers<ContextType>;
  UpsertClientAuthenticationPayload?: UpsertClientAuthenticationPayloadResolvers<ContextType>;
  UpsertCompanyWebBookingsLimitSettingPayload?: UpsertCompanyWebBookingsLimitSettingPayloadResolvers<ContextType>;
  UpsertGuestPatientMedicationFollowupStatusPayload?: UpsertGuestPatientMedicationFollowupStatusPayloadResolvers<ContextType>;
  UpsertMedicationFollowupDraftMessagePayload?: UpsertMedicationFollowupDraftMessagePayloadResolvers<ContextType>;
  UpsertMedicationFollowupStatusSettingPayload?: UpsertMedicationFollowupStatusSettingPayloadResolvers<ContextType>;
  UpsertOrganizationPayload?: UpsertOrganizationPayloadResolvers<ContextType>;
  UpsertOrganizationsPayload?: UpsertOrganizationsPayloadResolvers<ContextType>;
  UpsertPatientMedicationFollowupStatusPayload?: UpsertPatientMedicationFollowupStatusPayloadResolvers<ContextType>;
  UpsertTracingReportDraftPayload?: UpsertTracingReportDraftPayloadResolvers<ContextType>;
  UpsertUberOrganizationSettingPayload?: UpsertUberOrganizationSettingPayloadResolvers<ContextType>;
  UpsertUberOrganizationSettingsPayload?: UpsertUberOrganizationSettingsPayloadResolvers<ContextType>;
  UpsertUberSignatureDraftPayload?: UpsertUberSignatureDraftPayloadResolvers<ContextType>;
  UpsertWebBookingsAllDayLimitPayload?: UpsertWebBookingsAllDayLimitPayloadResolvers<ContextType>;
  UpsertWebBookingsLimitPayload?: UpsertWebBookingsLimitPayloadResolvers<ContextType>;
  ViewedMedicationFollowupQuestionnaireSheetPayload?: ViewedMedicationFollowupQuestionnaireSheetPayloadResolvers<ContextType>;
  WebBookingsBusinessHour?: WebBookingsBusinessHourResolvers<ContextType>;
  WebBookingsExceptionBusinessHour?: WebBookingsExceptionBusinessHourResolvers<ContextType>;
  WebBookingsExceptionDate?: WebBookingsExceptionDateResolvers<ContextType>;
  WebBookingsHolidayBusinessHour?: WebBookingsHolidayBusinessHourResolvers<ContextType>;
  WebBookingsLimit?: WebBookingsLimitResolvers<ContextType>;
  WebBookingsLimitLimit?: WebBookingsLimitLimitResolvers<ContextType>;
  WebBookingsSetting?: WebBookingsSettingResolvers<ContextType>;
  WebBookingsSuspend?: WebBookingsSuspendResolvers<ContextType>;
  WebVisitor?: WebVisitorResolvers<ContextType>;
}>;


export const SlotFragmentDoc = gql`
    fragment Slot on PublicSlot {
  id
  date
  startAt
  endAt
}
    `;
export const PharmacyProfileFragmentDoc = gql`
    fragment PharmacyProfile on PublicOrganization {
  id
  name
  phoneNumber
  organizationAddresses {
    id
    address {
      id
      city
      line
      postalCode
      prefecture
      type
      use
    }
  }
  webBookingsSetting {
    id
    logo {
      signedId
      url
    }
    electronicPrescription
  }
}
    `;
export const GetCitiesDocument = gql`
    query getCities($prefectureCode: String!) {
  cities(prefectureCode: $prefectureCode) {
    city
    jisCode
  }
}
    `;

/**
 * __useGetCitiesQuery__
 *
 * To run a query within a React component, call `useGetCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesQuery({
 *   variables: {
 *      prefectureCode: // value for 'prefectureCode'
 *   },
 * });
 */
export function useGetCitiesQuery(baseOptions: Apollo.QueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables> & ({ variables: GetCitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
      }
export function useGetCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
        }
export function useGetCitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
        }
export type GetCitiesQueryHookResult = ReturnType<typeof useGetCitiesQuery>;
export type GetCitiesLazyQueryHookResult = ReturnType<typeof useGetCitiesLazyQuery>;
export type GetCitiesSuspenseQueryHookResult = ReturnType<typeof useGetCitiesSuspenseQuery>;
export type GetCitiesQueryResult = Apollo.QueryResult<GetCitiesQuery, GetCitiesQueryVariables>;
export const GetPublicOrganizationsDocument = gql`
    query getPublicOrganizations($q: String, $cityCode: String, $latitude: Float, $longitude: Float, $radius: Float, $page: Int!, $perPage: Int!) {
  publicOrganizations(
    q: $q
    cityCode: $cityCode
    latitude: $latitude
    longitude: $longitude
    radius: $radius
    page: $page
    perPage: $perPage
  ) {
    nodes {
      ...PharmacyProfile
    }
    hasNextPage
    hasPreviousPage
    nodesCount
    pagesCount
  }
}
    ${PharmacyProfileFragmentDoc}`;

/**
 * __useGetPublicOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetPublicOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicOrganizationsQuery({
 *   variables: {
 *      q: // value for 'q'
 *      cityCode: // value for 'cityCode'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      radius: // value for 'radius'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetPublicOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<GetPublicOrganizationsQuery, GetPublicOrganizationsQueryVariables> & ({ variables: GetPublicOrganizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicOrganizationsQuery, GetPublicOrganizationsQueryVariables>(GetPublicOrganizationsDocument, options);
      }
export function useGetPublicOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicOrganizationsQuery, GetPublicOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicOrganizationsQuery, GetPublicOrganizationsQueryVariables>(GetPublicOrganizationsDocument, options);
        }
export function useGetPublicOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicOrganizationsQuery, GetPublicOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicOrganizationsQuery, GetPublicOrganizationsQueryVariables>(GetPublicOrganizationsDocument, options);
        }
export type GetPublicOrganizationsQueryHookResult = ReturnType<typeof useGetPublicOrganizationsQuery>;
export type GetPublicOrganizationsLazyQueryHookResult = ReturnType<typeof useGetPublicOrganizationsLazyQuery>;
export type GetPublicOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetPublicOrganizationsSuspenseQuery>;
export type GetPublicOrganizationsQueryResult = Apollo.QueryResult<GetPublicOrganizationsQuery, GetPublicOrganizationsQueryVariables>;
export const GetPharmacyDocument = gql`
    query getPharmacy($id: ID!) {
  node(id: $id) {
    ...PharmacyProfile
    ... on PublicOrganization {
      id
      rawId
      active
      webBookingsSetting {
        id
        description
        electronicPrescription
        slots {
          ...Slot
        }
        published
        facetoface
      }
      organizationAddresses {
        id
        address {
          id
          longitude
          latitude
        }
      }
    }
  }
}
    ${PharmacyProfileFragmentDoc}
${SlotFragmentDoc}`;

/**
 * __useGetPharmacyQuery__
 *
 * To run a query within a React component, call `useGetPharmacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPharmacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPharmacyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPharmacyQuery(baseOptions: Apollo.QueryHookOptions<GetPharmacyQuery, GetPharmacyQueryVariables> & ({ variables: GetPharmacyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPharmacyQuery, GetPharmacyQueryVariables>(GetPharmacyDocument, options);
      }
export function useGetPharmacyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPharmacyQuery, GetPharmacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPharmacyQuery, GetPharmacyQueryVariables>(GetPharmacyDocument, options);
        }
export function useGetPharmacySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPharmacyQuery, GetPharmacyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPharmacyQuery, GetPharmacyQueryVariables>(GetPharmacyDocument, options);
        }
export type GetPharmacyQueryHookResult = ReturnType<typeof useGetPharmacyQuery>;
export type GetPharmacyLazyQueryHookResult = ReturnType<typeof useGetPharmacyLazyQuery>;
export type GetPharmacySuspenseQueryHookResult = ReturnType<typeof useGetPharmacySuspenseQuery>;
export type GetPharmacyQueryResult = Apollo.QueryResult<GetPharmacyQuery, GetPharmacyQueryVariables>;
export const CreateAppointmentViaWebDocument = gql`
    mutation createAppointmentViaWeb($input: CreateAppointmentViaWebInput!) {
  createAppointmentViaWeb(input: $input) {
    appointment {
      id
      organization {
        id
      }
    }
  }
}
    `;
export type CreateAppointmentViaWebMutationFn = Apollo.MutationFunction<CreateAppointmentViaWebMutation, CreateAppointmentViaWebMutationVariables>;

/**
 * __useCreateAppointmentViaWebMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentViaWebMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentViaWebMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentViaWebMutation, { data, loading, error }] = useCreateAppointmentViaWebMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppointmentViaWebMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentViaWebMutation, CreateAppointmentViaWebMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentViaWebMutation, CreateAppointmentViaWebMutationVariables>(CreateAppointmentViaWebDocument, options);
      }
export type CreateAppointmentViaWebMutationHookResult = ReturnType<typeof useCreateAppointmentViaWebMutation>;
export type CreateAppointmentViaWebMutationResult = Apollo.MutationResult<CreateAppointmentViaWebMutation>;
export type CreateAppointmentViaWebMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentViaWebMutation, CreateAppointmentViaWebMutationVariables>;
export const GetCancelledAppointmentDocument = gql`
    query getCancelledAppointment($id: ID!) {
  node(id: $id) {
    ... on PublicAppointment {
      id
      cancellationReason
      status
      organization {
        ...PharmacyProfile
      }
    }
  }
}
    ${PharmacyProfileFragmentDoc}`;

/**
 * __useGetCancelledAppointmentQuery__
 *
 * To run a query within a React component, call `useGetCancelledAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancelledAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCancelledAppointmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCancelledAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetCancelledAppointmentQuery, GetCancelledAppointmentQueryVariables> & ({ variables: GetCancelledAppointmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCancelledAppointmentQuery, GetCancelledAppointmentQueryVariables>(GetCancelledAppointmentDocument, options);
      }
export function useGetCancelledAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCancelledAppointmentQuery, GetCancelledAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCancelledAppointmentQuery, GetCancelledAppointmentQueryVariables>(GetCancelledAppointmentDocument, options);
        }
export function useGetCancelledAppointmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCancelledAppointmentQuery, GetCancelledAppointmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCancelledAppointmentQuery, GetCancelledAppointmentQueryVariables>(GetCancelledAppointmentDocument, options);
        }
export type GetCancelledAppointmentQueryHookResult = ReturnType<typeof useGetCancelledAppointmentQuery>;
export type GetCancelledAppointmentLazyQueryHookResult = ReturnType<typeof useGetCancelledAppointmentLazyQuery>;
export type GetCancelledAppointmentSuspenseQueryHookResult = ReturnType<typeof useGetCancelledAppointmentSuspenseQuery>;
export type GetCancelledAppointmentQueryResult = Apollo.QueryResult<GetCancelledAppointmentQuery, GetCancelledAppointmentQueryVariables>;
export const GetAppointmentDocument = gql`
    query getAppointment($id: ID!) {
  node(id: $id) {
    ... on PublicAppointment {
      id
      status
      organization {
        ...PharmacyProfile
      }
    }
  }
}
    ${PharmacyProfileFragmentDoc}`;

/**
 * __useGetAppointmentQuery__
 *
 * To run a query within a React component, call `useGetAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAppointmentQuery(baseOptions: Apollo.QueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables> & ({ variables: GetAppointmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
      }
export function useGetAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
        }
export function useGetAppointmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppointmentQuery, GetAppointmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppointmentQuery, GetAppointmentQueryVariables>(GetAppointmentDocument, options);
        }
export type GetAppointmentQueryHookResult = ReturnType<typeof useGetAppointmentQuery>;
export type GetAppointmentLazyQueryHookResult = ReturnType<typeof useGetAppointmentLazyQuery>;
export type GetAppointmentSuspenseQueryHookResult = ReturnType<typeof useGetAppointmentSuspenseQuery>;
export type GetAppointmentQueryResult = Apollo.QueryResult<GetAppointmentQuery, GetAppointmentQueryVariables>;
export const CancelAppointmentDocument = gql`
    mutation cancelAppointment($input: CancelAppointmentViaWebInput!) {
  cancelAppointmentViaWeb(input: $input) {
    appointment {
      id
      organization {
        ...PharmacyProfile
      }
    }
  }
}
    ${PharmacyProfileFragmentDoc}`;
export type CancelAppointmentMutationFn = Apollo.MutationFunction<CancelAppointmentMutation, CancelAppointmentMutationVariables>;

/**
 * __useCancelAppointmentMutation__
 *
 * To run a mutation, you first call `useCancelAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAppointmentMutation, { data, loading, error }] = useCancelAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAppointmentMutation, CancelAppointmentMutationVariables>(CancelAppointmentDocument, options);
      }
export type CancelAppointmentMutationHookResult = ReturnType<typeof useCancelAppointmentMutation>;
export type CancelAppointmentMutationResult = Apollo.MutationResult<CancelAppointmentMutation>;
export type CancelAppointmentMutationOptions = Apollo.BaseMutationOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>;